const Long = require('long');
const __builtIn = {
  'Number': Number,
  'Array': Array,
  'Object': Object,
  'Buffer': Buffer
};
const $root = {};
$root.__options = {
  'stringEnums': true,
  'stringLongs': false,
  'stdCase': false,
  'generatorVersion': '2.0.1027',
  'contentHash': 'ad8f3f2e26492cbc871ae6910e30acba3c2275cb'
};
$root.__lookup = function (pbjs) {
  const root = pbjs.Root.fromJSON({
    'nested': {
      'wix': {
        'nested': {
          'common': {
            'options': {
              'java_multiple_files': true,
              'java_package': 'com.wix.common',
              'java_outer_classname': 'WixLinkProto'
            },
            'nested': {
              'Address': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'formatted_address',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'country',
                      'subdivision',
                      'city',
                      'postal_code',
                      'address_line',
                      'address_line_2',
                      'formatted_address'
                    ]
                  }
                },
                'oneofs': {
                  'street': {
                    'oneof': [
                      'streetAddress',
                      'addressLine'
                    ],
                    'comment': null
                  }
                },
                'fields': {
                  'country': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1,
                    'options': { '(.wix.api.format)': 'COUNTRY' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.format)': 'COUNTRY',
                        '__comment': null
                      }]
                  },
                  'subdivision': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'city': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'postalCode': {
                    'type': 'google.protobuf.StringValue',
                    'id': 4,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'streetAddress': {
                    'type': 'StreetAddress',
                    'id': 5,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'addressLine': {
                    'type': 'google.protobuf.StringValue',
                    'id': 6,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'addressLine_2': {
                    'type': 'google.protobuf.StringValue',
                    'id': 7,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'formattedAddress': {
                    'type': 'google.protobuf.StringValue',
                    'id': 8,
                    'options': { '(.wix.api.field_exposure)': 'PRIVATE' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.field_exposure)': 'PRIVATE',
                        '__comment': null
                      }]
                  },
                  'hint': {
                    'type': 'google.protobuf.StringValue',
                    'id': 9,
                    'options': { '(.wix.api.field_exposure)': 'PRIVATE' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.field_exposure)': 'PRIVATE',
                        '__comment': null
                      }]
                  },
                  'geocode': {
                    'type': 'AddressLocation',
                    'id': 10,
                    'options': { '(.wix.api.field_exposure)': 'PRIVATE' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.field_exposure)': 'PRIVATE',
                        '__comment': null
                      }]
                  },
                  'countryFullname': {
                    'type': 'google.protobuf.StringValue',
                    'id': 11,
                    'options': { '(.wix.api.field_exposure)': 'PRIVATE' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.field_exposure)': 'PRIVATE',
                        '__comment': null
                      }]
                  },
                  'subdivisionFullname': {
                    'type': 'google.protobuf.StringValue',
                    'id': 13,
                    'options': { '(.wix.api.field_exposure)': 'PRIVATE' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.field_exposure)': 'PRIVATE',
                        '__comment': null
                      }]
                  },
                  'subdivisions': {
                    'rule': 'repeated',
                    'type': 'Subdivision',
                    'id': 12,
                    'options': { '(.wix.api.field_exposure)': 'PRIVATE' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.field_exposure)': 'PRIVATE',
                        '__comment': null
                      }]
                  }
                },
                'comment': null
              },
              'Subdivision': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'code',
                  '(.wix.api.decomposition_minimum_fields)': { 'field': 'code' }
                },
                'fields': {
                  'code': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'name': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'type': {
                    'type': 'SubdivisionType',
                    'id': 3,
                    'options': { '(.wix.api.field_exposure)': 'PRIVATE' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.field_exposure)': 'PRIVATE',
                        '__comment': null
                      }]
                  },
                  'typeInfo': {
                    'type': 'google.protobuf.StringValue',
                    'id': 4,
                    'options': { '(.wix.api.field_exposure)': 'PRIVATE' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.field_exposure)': 'PRIVATE',
                        '__comment': null
                      }]
                  }
                },
                'nested': {
                  'SubdivisionType': {
                    'values': {
                      'UNKNOWN_SUBDIVISION_TYPE': 0,
                      'ADMINISTRATIVE_AREA_LEVEL_1': 1,
                      'ADMINISTRATIVE_AREA_LEVEL_2': 2,
                      'ADMINISTRATIVE_AREA_LEVEL_3': 3,
                      'ADMINISTRATIVE_AREA_LEVEL_4': 4,
                      'ADMINISTRATIVE_AREA_LEVEL_5': 5,
                      'COUNTRY': 6
                    },
                    'comment': null,
                    'comments': {
                      'UNKNOWN_SUBDIVISION_TYPE': null,
                      'ADMINISTRATIVE_AREA_LEVEL_1': null,
                      'ADMINISTRATIVE_AREA_LEVEL_2': null,
                      'ADMINISTRATIVE_AREA_LEVEL_3': null,
                      'ADMINISTRATIVE_AREA_LEVEL_4': null,
                      'ADMINISTRATIVE_AREA_LEVEL_5': null,
                      'COUNTRY': null
                    }
                  }
                },
                'comment': null
              },
              'StreetAddress': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'name',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'number',
                      'name'
                    ]
                  }
                },
                'fields': {
                  'number': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'name': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'apt': {
                    'type': 'string',
                    'id': 3,
                    'options': { '(.wix.api.field_exposure)': 'PRIVATE' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.field_exposure)': 'PRIVATE',
                        '__comment': null
                      }]
                  }
                },
                'comment': null
              },
              'AddressContactDetails': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'full_name',
                  '(.wix.api.decomposition_minimum_fields)': { 'field': 'full_name' }
                },
                'fields': {
                  'fullName': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'phone': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2,
                    'options': { '(.wix.api.format)': 'PHONE' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.format)': 'PHONE',
                        '__comment': null
                      }]
                  },
                  'company': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'email': {
                    'type': 'google.protobuf.StringValue',
                    'id': 4,
                    'options': { '(.wix.api.format)': 'EMAIL' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.format)': 'EMAIL',
                        '__comment': null
                      }]
                  }
                },
                'comment': null
              },
              'FullAddressContactDetails': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'full_name',
                  '(.wix.api.decomposition_minimum_fields)': { 'field': 'full_name' }
                },
                'fields': {
                  'firstName': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'lastName': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'fullName': {
                    'type': 'google.protobuf.StringValue',
                    'id': 8,
                    'options': { '(.wix.api.field_exposure)': 'PRIVATE' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.field_exposure)': 'PRIVATE',
                        '__comment': null
                      }]
                  },
                  'phone': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3,
                    'options': { '(.wix.api.format)': 'PHONE' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.format)': 'PHONE',
                        '__comment': null
                      }]
                  },
                  'company': {
                    'type': 'google.protobuf.StringValue',
                    'id': 4,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'email': {
                    'type': 'google.protobuf.StringValue',
                    'id': 5,
                    'options': { '(.wix.api.format)': 'EMAIL' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.format)': 'EMAIL',
                        '__comment': null
                      }]
                  },
                  'vatId': {
                    'type': 'VatId',
                    'id': 7,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'VatId': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'type',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'id',
                      'type'
                    ]
                  }
                },
                'fields': {
                  'id': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'type': {
                    'type': 'VatType',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'VatType': {
                'values': {
                  'UNSPECIFIED': 0,
                  'CPF': 1,
                  'CNPJ': 2
                },
                'comment': null,
                'comments': {
                  'UNSPECIFIED': null,
                  'CPF': null,
                  'CNPJ': null
                }
              },
              'AddressLocation': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'longitude',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'latitude',
                      'longitude'
                    ]
                  }
                },
                'fields': {
                  'latitude': {
                    'type': 'google.protobuf.DoubleValue',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'longitude': {
                    'type': 'google.protobuf.DoubleValue',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'BulkActionMetadata': {
                'fields': {
                  'totalSuccesses': {
                    'type': 'uint32',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'totalFailures': {
                    'type': 'uint32',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'undetailedFailures': {
                    'type': 'uint32',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'ItemMetadata': {
                'fields': {
                  'id': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'originalIndex': {
                    'type': 'uint32',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'success': {
                    'type': 'bool',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'error': {
                    'type': '.wix.api.ApplicationError',
                    'id': 4,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'BulkActionType': {
                'values': {
                  'UNKNOWN_ACTION_TYPE': 0,
                  'INSERT': 1,
                  'UPDATE': 2,
                  'DELETE': 3
                },
                'comment': null,
                'comments': {
                  'UNKNOWN_ACTION_TYPE': null,
                  'INSERT': null,
                  'UPDATE': null,
                  'DELETE': null
                }
              },
              'IdentificationData': {
                'oneofs': {
                  'id': {
                    'oneof': [
                      'anonymousVisitorId',
                      'memberId',
                      'wixUserId',
                      'appId'
                    ],
                    'comment': null
                  }
                },
                'fields': {
                  'contactId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1,
                    'options': {
                      '(.wix.api.format)': 'GUID',
                      '(.wix.api.referenced_entity)': 'wix.contacts.v4.contact',
                      '(.wix.api.readOnly)': true
                    },
                    'comment': null,
                    'parsedOptions': [
                      {
                        '(.wix.api.format)': 'GUID',
                        '__comment': null
                      },
                      {
                        '(.wix.api.referenced_entity)': 'wix.contacts.v4.contact',
                        '__comment': null
                      },
                      {
                        '(.wix.api.readOnly)': true,
                        '__comment': null
                      }
                    ]
                  },
                  'anonymousVisitorId': {
                    'type': 'string',
                    'id': 2,
                    'options': { '(.wix.api.format)': 'GUID' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.format)': 'GUID',
                        '__comment': null
                      }]
                  },
                  'memberId': {
                    'type': 'string',
                    'id': 3,
                    'options': {
                      '(.wix.api.format)': 'GUID',
                      '(.wix.api.referenced_entity)': 'wix.members.v1.member'
                    },
                    'comment': null,
                    'parsedOptions': [
                      {
                        '(.wix.api.format)': 'GUID',
                        '__comment': null
                      },
                      {
                        '(.wix.api.referenced_entity)': 'wix.members.v1.member',
                        '__comment': null
                      }
                    ]
                  },
                  'wixUserId': {
                    'type': 'string',
                    'id': 4,
                    'options': { '(.wix.api.format)': 'GUID' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.format)': 'GUID',
                        '__comment': null
                      }]
                  },
                  'appId': {
                    'type': 'string',
                    'id': 5,
                    'options': { '(.wix.api.format)': 'GUID' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.format)': 'GUID',
                        '__comment': null
                      }]
                  }
                },
                'comment': null
              },
              'Image': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'width',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'id',
                      'height',
                      'width'
                    ]
                  }
                },
                'fields': {
                  'id': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'url': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'height': {
                    'type': 'int32',
                    'id': 3,
                    'options': { '(.wix.api.readOnly)': true },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.readOnly)': true,
                        '__comment': null
                      }]
                  },
                  'width': {
                    'type': 'int32',
                    'id': 4,
                    'options': { '(.wix.api.readOnly)': true },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.readOnly)': true,
                        '__comment': null
                      }]
                  },
                  'altText': {
                    'type': 'google.protobuf.StringValue',
                    'id': 5,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'urlExpirationDate': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 6,
                    'options': { '(.wix.api.field_exposure)': 'PRIVATE' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.field_exposure)': 'PRIVATE',
                        '__comment': null
                      }]
                  },
                  'filename': {
                    'type': 'google.protobuf.StringValue',
                    'id': 7,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'Video': {
                'options': {
                  'deprecated': true,
                  '(.wix.api.decomposition_minimum_fields).field': 'width',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'id',
                      'url',
                      'height',
                      'width'
                    ]
                  }
                },
                'fields': {
                  'id': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'url': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'height': {
                    'type': 'int32',
                    'id': 3,
                    'options': { '(.wix.api.readOnly)': true },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.readOnly)': true,
                        '__comment': null
                      }]
                  },
                  'width': {
                    'type': 'int32',
                    'id': 4,
                    'options': { '(.wix.api.readOnly)': true },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.readOnly)': true,
                        '__comment': null
                      }]
                  },
                  'thumbnail': {
                    'type': 'Image',
                    'id': 5,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'VideoV2': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'resolutions',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'id',
                      'resolutions'
                    ]
                  }
                },
                'fields': {
                  'id': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'resolutions': {
                    'rule': 'repeated',
                    'type': 'VideoResolution',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'VideoResolution': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'format',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'url',
                      'height',
                      'width',
                      'poster',
                      'format'
                    ]
                  }
                },
                'fields': {
                  'url': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'height': {
                    'type': 'int32',
                    'id': 3,
                    'options': { '(.wix.api.readOnly)': true },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.readOnly)': true,
                        '__comment': null
                      }]
                  },
                  'width': {
                    'type': 'int32',
                    'id': 4,
                    'options': { '(.wix.api.readOnly)': true },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.readOnly)': true,
                        '__comment': null
                      }]
                  },
                  'poster': {
                    'type': 'Image',
                    'id': 5,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'format': {
                    'type': 'string',
                    'id': 6,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'urlExpirationDate': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 7,
                    'options': { '(.wix.api.field_exposure)': 'PRIVATE' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.field_exposure)': 'PRIVATE',
                        '__comment': null
                      }]
                  }
                },
                'comment': null
              },
              'Audio': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'url',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'id',
                      'url'
                    ]
                  }
                },
                'fields': {
                  'id': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'url': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'urlExpirationDate': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 3,
                    'options': { '(.wix.api.field_exposure)': 'PRIVATE' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.field_exposure)': 'PRIVATE',
                        '__comment': null
                      }]
                  }
                },
                'comment': null
              },
              'Document': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'url',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'id',
                      'url'
                    ]
                  }
                },
                'fields': {
                  'id': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'url': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'urlExpirationDate': {
                    'type': 'google.protobuf.Timestamp',
                    'id': 3,
                    'options': { '(.wix.api.field_exposure)': 'PRIVATE' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.field_exposure)': 'PRIVATE',
                        '__comment': null
                      }]
                  }
                },
                'comment': null
              },
              'MediaItem': {
                'options': {
                  'deprecated': true,
                  '(.wix.api.decomposition_minimum_fields).field': 'document',
                  '(.wix.api.decomposition_minimum_fields)': { 'field': 'document' }
                },
                'oneofs': {
                  'media': {
                    'oneof': [
                      'image',
                      'video',
                      'document'
                    ],
                    'comment': null
                  }
                },
                'fields': {
                  'image': {
                    'type': 'Image',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'video': {
                    'type': 'Video',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'document': {
                    'type': 'Document',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'Money': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'currency',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'value',
                      'currency'
                    ]
                  }
                },
                'fields': {
                  'value': {
                    'type': 'string',
                    'id': 1,
                    'options': { '(.wix.api.format)': 'DECIMAL_VALUE' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.format)': 'DECIMAL_VALUE',
                        '__comment': null
                      }]
                  },
                  'currency': {
                    'type': 'string',
                    'id': 2,
                    'options': { '(.wix.api.format)': 'CURRENCY' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.format)': 'CURRENCY',
                        '__comment': null
                      }]
                  }
                },
                'comment': null
              },
              'PageUrl': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'path',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'base',
                      'path'
                    ]
                  }
                },
                'fields': {
                  'base': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'path': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'PageUrlV2': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'url',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'relative_path',
                      'url'
                    ]
                  }
                },
                'fields': {
                  'relativePath': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'url': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'Paging': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'offset',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'limit',
                      'offset'
                    ]
                  }
                },
                'fields': {
                  'limit': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 1,
                    'options': { '(.wix.api.min)': 0 },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.min)': 0,
                        '__comment': null
                      }]
                  },
                  'offset': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 2,
                    'options': { '(.wix.api.min)': 0 },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.min)': 0,
                        '__comment': null
                      }]
                  }
                },
                'comment': null
              },
              'CursorPaging': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'cursor',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'limit',
                      'cursor'
                    ]
                  }
                },
                'fields': {
                  'limit': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 1,
                    'options': {
                      '(.wix.api.min)': 0,
                      '(.wix.api.max)': 100
                    },
                    'comment': null,
                    'parsedOptions': [
                      {
                        '(.wix.api.min)': 0,
                        '__comment': null
                      },
                      {
                        '(.wix.api.max)': 100,
                        '__comment': null
                      }
                    ]
                  },
                  'cursor': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'PagingMetadata': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'offset',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'count',
                      'offset'
                    ]
                  }
                },
                'fields': {
                  'count': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'offset': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'total': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'tooManyToCount': {
                    'type': 'google.protobuf.BoolValue',
                    'id': 4,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'PagingMetadataV2': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'cursors',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'count',
                      'offset',
                      'cursors'
                    ]
                  }
                },
                'fields': {
                  'count': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'offset': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'total': {
                    'type': 'google.protobuf.Int32Value',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'tooManyToCount': {
                    'type': 'google.protobuf.BoolValue',
                    'id': 4,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'cursors': {
                    'type': 'Cursors',
                    'id': 5,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'Cursors': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'prev',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'next',
                      'prev'
                    ]
                  }
                },
                'fields': {
                  'next': {
                    'type': 'google.protobuf.StringValue',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'prev': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'Sorting': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'order',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'fieldName',
                      'order'
                    ]
                  }
                },
                'fields': {
                  'fieldName': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'order': {
                    'type': 'SortOrder',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'SortOrder': {
                'values': {
                  'ASC': 0,
                  'DESC': 1
                },
                'comment': null,
                'comments': {
                  'ASC': null,
                  'DESC': null
                }
              },
              'WixLink': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'whats_app',
                  '(.wix.api.decomposition_minimum_fields)': { 'field': 'whats_app' }
                },
                'oneofs': {
                  'Link': {
                    'oneof': [
                      'external',
                      'page',
                      'anchor',
                      'dynamicPage',
                      'document',
                      'email',
                      'phone',
                      'address',
                      'whatsApp'
                    ],
                    'comment': null
                  }
                },
                'fields': {
                  'external': {
                    'type': 'ExternalLink',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'page': {
                    'type': 'PageLink',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'anchor': {
                    'type': 'AnchorLink',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'dynamicPage': {
                    'type': 'DynamicPageLink',
                    'id': 4,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'document': {
                    'type': 'DocumentLink',
                    'id': 5,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'email': {
                    'type': 'EmailLink',
                    'id': 6,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'phone': {
                    'type': 'PhoneLink',
                    'id': 7,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'address': {
                    'type': 'AddressLink',
                    'id': 8,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'whatsApp': {
                    'type': 'WhatsAppLink',
                    'id': 9,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'ExternalLink': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'url',
                  '(.wix.api.decomposition_minimum_fields)': { 'field': 'url' }
                },
                'fields': {
                  'url': {
                    'type': 'string',
                    'id': 1,
                    'options': { '(.wix.api.format)': 'URI' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.format)': 'URI',
                        '__comment': null
                      }]
                  },
                  'target': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'PageLink': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'page_id',
                  '(.wix.api.decomposition_minimum_fields)': { 'field': 'page_id' }
                },
                'fields': {
                  'pageId': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'target': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'AnchorLink': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'page_id',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'anchor_name',
                      'anchor_data_id',
                      'page_id'
                    ]
                  }
                },
                'fields': {
                  'anchorName': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'anchorDataId': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'pageId': {
                    'type': 'string',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'DynamicPageLink': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'anchor_data_id',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'router_id',
                      'inner_route',
                      'anchor_data_id'
                    ]
                  }
                },
                'fields': {
                  'routerId': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'innerRoute': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'anchorDataId': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'DocumentLink': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'name',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'doc_id',
                      'name'
                    ]
                  }
                },
                'fields': {
                  'docId': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'name': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'indexable': {
                    'type': 'bool',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'EmailLink': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'body',
                  '(.wix.api.decomposition_minimum_fields)': {
                    'field': [
                      'recipient',
                      'subject',
                      'body'
                    ]
                  }
                },
                'fields': {
                  'recipient': {
                    'type': 'string',
                    'id': 1,
                    'options': { '(.wix.api.format)': 'EMAIL' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.format)': 'EMAIL',
                        '__comment': null
                      }]
                  },
                  'subject': {
                    'type': 'google.protobuf.StringValue',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'body': {
                    'type': 'google.protobuf.StringValue',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'PhoneLink': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'phone_number',
                  '(.wix.api.decomposition_minimum_fields)': { 'field': 'phone_number' }
                },
                'fields': {
                  'phoneNumber': {
                    'type': 'string',
                    'id': 1,
                    'options': {
                      '(.wix.api.format)': 'PHONE',
                      '(.wix.api.maxLength)': 100
                    },
                    'comment': null,
                    'parsedOptions': [
                      {
                        '(.wix.api.format)': 'PHONE',
                        '__comment': null
                      },
                      {
                        '(.wix.api.maxLength)': 100,
                        '__comment': null
                      }
                    ]
                  }
                },
                'comment': null
              },
              'AddressLink': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'address',
                  '(.wix.api.decomposition_minimum_fields)': { 'field': 'address' }
                },
                'fields': {
                  'address': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'WhatsAppLink': {
                'options': {
                  '(.wix.api.decomposition_minimum_fields).field': 'phone_number',
                  '(.wix.api.decomposition_minimum_fields)': { 'field': 'phone_number' }
                },
                'fields': {
                  'phoneNumber': {
                    'type': 'string',
                    'id': 1,
                    'options': { '(.wix.api.format)': 'PHONE' },
                    'comment': null,
                    'parsedOptions': [{
                        '(.wix.api.format)': 'PHONE',
                        '__comment': null
                      }]
                  }
                },
                'comment': null
              }
            }
          },
          'api': {
            'options': {
              'java_multiple_files': true,
              'java_outer_classname': 'CallbackProto',
              'java_package': 'com.wix.api'
            },
            'nested': {
              'serviceMaturity': {
                'type': 'Maturity',
                'id': 50104,
                'extend': 'google.protobuf.ServiceOptions',
                'comment': null,
                'parsedOptions': null
              },
              'serviceExposure': {
                'type': 'Exposure',
                'id': 50105,
                'extend': 'google.protobuf.ServiceOptions',
                'comment': null,
                'parsedOptions': null
              },
              'serviceDeprecated': {
                'type': 'Deprecated',
                'id': 50140,
                'extend': 'google.protobuf.ServiceOptions',
                'comment': null,
                'parsedOptions': null
              },
              'appendixFiles': {
                'rule': 'repeated',
                'type': 'ServiceAppendix',
                'id': 50150,
                'extend': 'google.protobuf.ServiceOptions',
                'options': {},
                'comment': null,
                'parsedOptions': null
              },
              'exposure': {
                'type': 'Exposure',
                'id': 50101,
                'extend': 'google.protobuf.MethodOptions',
                'comment': null,
                'parsedOptions': null
              },
              'maturity': {
                'type': 'Maturity',
                'id': 50102,
                'extend': 'google.protobuf.MethodOptions',
                'comment': null,
                'parsedOptions': null
              },
              'cacheable': {
                'type': 'CacheSettings',
                'id': 50103,
                'extend': 'google.protobuf.MethodOptions',
                'comment': null,
                'parsedOptions': null
              },
              'deprecated': {
                'type': 'Deprecated',
                'id': 50141,
                'extend': 'google.protobuf.MethodOptions',
                'comment': null,
                'parsedOptions': null
              },
              'crud': {
                'type': 'Crud',
                'id': 50146,
                'extend': 'google.protobuf.MethodOptions',
                'comment': null,
                'parsedOptions': null
              },
              'decompositeOf': {
                'type': 'string',
                'id': 50120,
                'extend': 'google.protobuf.MessageOptions',
                'comment': null,
                'parsedOptions': null
              },
              'decompositionMinimumFields': {
                'rule': 'repeated',
                'type': 'FieldSet',
                'id': 50121,
                'extend': 'google.protobuf.MessageOptions',
                'options': {},
                'comment': null,
                'parsedOptions': null
              },
              'unwrapArrayValue': {
                'type': 'bool',
                'id': 50122,
                'extend': 'google.protobuf.MessageOptions',
                'comment': null,
                'parsedOptions': null
              },
              'messageDeprecated': {
                'type': 'Deprecated',
                'id': 50142,
                'extend': 'google.protobuf.MessageOptions',
                'comment': null,
                'parsedOptions': null
              },
              'unique': {
                'rule': 'repeated',
                'type': 'Unique',
                'id': 50145,
                'extend': 'google.protobuf.MessageOptions',
                'options': {},
                'comment': null,
                'parsedOptions': null
              },
              'fieldExposure': {
                'type': 'Exposure',
                'id': 50106,
                'extend': 'google.protobuf.FieldOptions',
                'comment': null,
                'parsedOptions': null
              },
              'fieldMaturity': {
                'type': 'Maturity',
                'id': 50107,
                'extend': 'google.protobuf.FieldOptions',
                'comment': null,
                'parsedOptions': null
              },
              'pii': {
                'type': 'bool',
                'id': 50110,
                'extend': 'google.protobuf.FieldOptions',
                'comment': null,
                'parsedOptions': null
              },
              'referencedEntity': {
                'type': 'string',
                'id': 50111,
                'extend': 'google.protobuf.FieldOptions',
                'comment': null,
                'parsedOptions': null
              },
              'fieldDeprecated': {
                'type': 'Deprecated',
                'id': 50143,
                'extend': 'google.protobuf.FieldOptions',
                'comment': null,
                'parsedOptions': null
              },
              'translatable': {
                'type': 'Translatable',
                'id': 50144,
                'extend': 'google.protobuf.FieldOptions',
                'comment': null,
                'parsedOptions': null
              },
              'enumMaturity': {
                'type': 'Maturity',
                'id': 50130,
                'extend': 'google.protobuf.EnumValueOptions',
                'comment': null,
                'parsedOptions': null
              },
              'enumExposure': {
                'type': 'Exposure',
                'id': 50131,
                'extend': 'google.protobuf.EnumValueOptions',
                'comment': null,
                'parsedOptions': null
              },
              'CacheSettings': {
                'fields': {
                  'maxAgeSeconds': {
                    'type': 'int32',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'FieldSet': {
                'fields': {
                  'field': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'Deprecated': {
                'fields': {
                  'replacedBy': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'targetRemovalDate': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'Unique': {
                'fields': {
                  'field': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'Crud': {
                'oneofs': {
                  'methodOptions': {
                    'oneof': [
                      'createOptions',
                      'getOptions',
                      'updateOptions',
                      'deleteOptions',
                      'listOptions',
                      'queryOptions',
                      'bulkCreateOptions',
                      'bulkUpdateOptions',
                      'bulkUpdateByFilterOptions',
                      'bulkDeleteOptions',
                      'bulkDeleteByFilterOptions',
                      'upsertOptions',
                      'bulkUpsertOptions'
                    ],
                    'comment': null
                  }
                },
                'fields': {
                  'method': {
                    'rule': 'required',
                    'type': 'Method',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'createOptions': {
                    'type': 'CreateMethodOptions',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'getOptions': {
                    'type': 'GetItemMethodOptions',
                    'id': 4,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'updateOptions': {
                    'type': 'UpdateMethodOptions',
                    'id': 5,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'deleteOptions': {
                    'type': 'DeleteMethodOptions',
                    'id': 6,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'listOptions': {
                    'type': 'ListMethodOptions',
                    'id': 7,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'queryOptions': {
                    'type': 'QueryMethodOptions',
                    'id': 8,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'bulkCreateOptions': {
                    'type': 'BulkCreateMethodOptions',
                    'id': 9,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'bulkUpdateOptions': {
                    'type': 'BulkUpdateMethodOptions',
                    'id': 10,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'bulkUpdateByFilterOptions': {
                    'type': 'BulkUpdateByFilterMethodOptions',
                    'id': 11,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'bulkDeleteOptions': {
                    'type': 'BulkDeleteMethodOptions',
                    'id': 12,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'bulkDeleteByFilterOptions': {
                    'type': 'BulkDeleteByFilterMethodOptions',
                    'id': 13,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'upsertOptions': {
                    'type': 'UpsertMethodOptions',
                    'id': 14,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'bulkUpsertOptions': {
                    'type': 'BulkUpsertMethodOptions',
                    'id': 15,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'nested': {
                  'Method': {
                    'values': {
                      'UNKNOWN_METHOD': 0,
                      'CREATE': 1,
                      'GET_ITEM': 2,
                      'UPDATE': 3,
                      'DELETE': 4,
                      'UPSERT': 12,
                      'LIST': 5,
                      'QUERY': 6,
                      'BULK_CREATE': 7,
                      'BULK_UPDATE': 8,
                      'BULK_UPDATE_BY_FILTER': 9,
                      'BULK_DELETE': 10,
                      'BULK_DELETE_BY_FILTER': 11,
                      'BULK_UPSERT': 13
                    },
                    'comment': null,
                    'comments': {
                      'UNKNOWN_METHOD': null,
                      'CREATE': null,
                      'GET_ITEM': null,
                      'UPDATE': null,
                      'DELETE': null,
                      'UPSERT': null,
                      'LIST': null,
                      'QUERY': null,
                      'BULK_CREATE': null,
                      'BULK_UPDATE': null,
                      'BULK_UPDATE_BY_FILTER': null,
                      'BULK_DELETE': null,
                      'BULK_DELETE_BY_FILTER': null,
                      'BULK_UPSERT': null
                    }
                  }
                },
                'comment': null
              },
              'Paging': {
                'fields': {
                  'type': {
                    'rule': 'required',
                    'type': 'Type',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'pagingField': {
                    'rule': 'required',
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'totalsField': {
                    'type': 'string',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'nested': {
                  'Type': {
                    'values': {
                      'UNKNOWN_TYPE': 0,
                      'OFFSET': 1,
                      'CURSOR': 2
                    },
                    'comment': null,
                    'comments': {
                      'UNKNOWN_TYPE': null,
                      'OFFSET': null,
                      'CURSOR': null
                    }
                  }
                },
                'comment': null
              },
              'CreateMethodOptions': {
                'fields': {
                  'itemField': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'fieldmaskField': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'GetItemMethodOptions': {
                'fields': {
                  'idField': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'UpdateMethodOptions': {
                'fields': {
                  'itemField': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'fieldmaskField': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'UpsertMethodOptions': {
                'fields': {
                  'itemField': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'fieldmaskField': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'DeleteMethodOptions': {
                'fields': {
                  'idField': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'ListMethodOptions': {
                'fields': {
                  'idsField': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'itemsField': {
                    'type': 'string',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'paging': {
                    'type': 'Paging',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'QueryMethodOptions': {
                'fields': {
                  'queryField': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'itemsField': {
                    'type': 'string',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'paging': {
                    'type': 'Paging',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'BulkCreateMethodOptions': {
                'fields': {
                  'itemField': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'fieldmaskField': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'BulkUpdateMethodOptions': {
                'fields': {
                  'itemField': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'fieldmaskField': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'BulkUpdateByFilterMethodOptions': {
                'fields': {
                  'itemField': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'fieldmaskField': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'filterField': {
                    'type': 'string',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'BulkUpsertMethodOptions': {
                'fields': {
                  'itemField': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'fieldmaskField': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'BulkDeleteMethodOptions': {
                'fields': {
                  'idsField': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'BulkDeleteByFilterMethodOptions': {
                'fields': {
                  'filterField': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'Translatable': {
                'fields': {
                  'name': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'hidden': {
                    'type': 'bool',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'grouping': {
                    'rule': 'required',
                    'type': 'string',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'type': {
                    'rule': 'required',
                    'type': 'Type',
                    'id': 4,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'nested': {
                  'Type': {
                    'values': {
                      'UNDEFINED_TYPE': 0,
                      'SHORT_TEXT': 1,
                      'LONG_TEXT': 2,
                      'RICH_TEXT': 3,
                      'RICH_CONTENT_EDITOR': 4,
                      'SELECTION': 5,
                      'MULTI_SELECTION': 6,
                      'DOCUMENT': 7,
                      'IMAGE': 8,
                      'VIDEO': 9
                    },
                    'comment': null,
                    'comments': {
                      'UNDEFINED_TYPE': null,
                      'SHORT_TEXT': null,
                      'LONG_TEXT': null,
                      'RICH_TEXT': null,
                      'RICH_CONTENT_EDITOR': null,
                      'SELECTION': null,
                      'MULTI_SELECTION': null,
                      'DOCUMENT': null,
                      'IMAGE': null,
                      'VIDEO': null
                    }
                  }
                },
                'comment': null
              },
              'ServiceAppendix': {
                'fields': {
                  'type': {
                    'rule': 'required',
                    'type': 'Type',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'path': {
                    'rule': 'required',
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'nested': {
                  'Type': {
                    'values': {
                      'UNKNOWN_APPENDIX_TYPE': 0,
                      'NILE': 1,
                      'MESSAGE_BUS': 2
                    },
                    'comment': null,
                    'comments': {
                      'UNKNOWN_APPENDIX_TYPE': null,
                      'NILE': null,
                      'MESSAGE_BUS': null
                    }
                  }
                },
                'comment': null
              },
              'Exposure': {
                'values': {
                  'PRIVATE': 0,
                  'INTERNAL': 1,
                  'PUBLIC': 2
                },
                'comment': null,
                'comments': {
                  'PRIVATE': null,
                  'INTERNAL': null,
                  'PUBLIC': null
                }
              },
              'Maturity': {
                'values': {
                  'ALPHA': 0,
                  'BETA': 1,
                  'IA': 2,
                  'GA': 3,
                  'NOT_IMPLEMENTED': 4
                },
                'comment': null,
                'comments': {
                  'ALPHA': null,
                  'BETA': null,
                  'IA': null,
                  'GA': null,
                  'NOT_IMPLEMENTED': null
                }
              },
              'max': {
                'type': 'double',
                'id': 50201,
                'extend': 'google.protobuf.FieldOptions',
                'comment': null,
                'parsedOptions': null
              },
              'min': {
                'type': 'double',
                'id': 50202,
                'extend': 'google.protobuf.FieldOptions',
                'comment': null,
                'parsedOptions': null
              },
              'maxLength': {
                'type': 'int32',
                'id': 50203,
                'extend': 'google.protobuf.FieldOptions',
                'comment': null,
                'parsedOptions': null
              },
              'minLength': {
                'type': 'int32',
                'id': 50204,
                'extend': 'google.protobuf.FieldOptions',
                'comment': null,
                'parsedOptions': null
              },
              'maxSize': {
                'type': 'int32',
                'id': 50209,
                'extend': 'google.protobuf.FieldOptions',
                'comment': null,
                'parsedOptions': null
              },
              'minSize': {
                'type': 'int32',
                'id': 50210,
                'extend': 'google.protobuf.FieldOptions',
                'comment': null,
                'parsedOptions': null
              },
              'format': {
                'type': 'Format',
                'id': 50205,
                'extend': 'google.protobuf.FieldOptions',
                'comment': null,
                'parsedOptions': null
              },
              'readOnly': {
                'type': 'bool',
                'id': 50208,
                'extend': 'google.protobuf.FieldOptions',
                'comment': null,
                'parsedOptions': null
              },
              'immutable': {
                'type': 'bool',
                'id': 50212,
                'extend': 'google.protobuf.FieldOptions',
                'comment': null,
                'parsedOptions': null
              },
              'decimalValue': {
                'type': 'DecimalValueOptions',
                'id': 50211,
                'extend': 'google.protobuf.FieldOptions',
                'comment': null,
                'parsedOptions': null
              },
              'DecimalValueOptions': {
                'fields': {
                  'lte': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'gte': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'lt': {
                    'type': 'string',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'gt': {
                    'type': 'string',
                    'id': 4,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'maxScale': {
                    'type': 'int32',
                    'id': 5,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': 'Decimal value validation rules.\nBased on java.math.BigDecimal, implies (wix.api.format) = DECIMAL_VALUE'
              },
              'required': {
                'rule': 'repeated',
                'type': 'string',
                'id': 50200,
                'extend': 'google.protobuf.MethodOptions',
                'comment': null,
                'parsedOptions': null
              },
              'Format': {
                'values': {
                  'EMAIL': 0,
                  'HOSTNAME': 1,
                  'IPV4': 2,
                  'IPV6': 3,
                  'URI': 4,
                  'WEB_URL': 5,
                  'PHONE': 7,
                  'CREDIT_CARD': 8,
                  'GUID': 9,
                  'COUNTRY': 10,
                  'LANGUAGE': 11,
                  'DECIMAL_VALUE': 12,
                  'CURRENCY': 13,
                  'LANGUAGE_TAG': 14,
                  'COLOR_HEX': 15,
                  'LOCAL_DATE': 16,
                  'LOCAL_TIME': 17,
                  'LOCAL_DATE_TIME': 18
                },
                'comment': null,
                'comments': {
                  'EMAIL': null,
                  'HOSTNAME': null,
                  'IPV4': null,
                  'IPV6': null,
                  'URI': null,
                  'WEB_URL': null,
                  'PHONE': null,
                  'CREDIT_CARD': null,
                  'GUID': null,
                  'COUNTRY': null,
                  'LANGUAGE': null,
                  'DECIMAL_VALUE': null,
                  'CURRENCY': null,
                  'LANGUAGE_TAG': null,
                  'COLOR_HEX': null,
                  'LOCAL_DATE': null,
                  'LOCAL_TIME': null,
                  'LOCAL_DATE_TIME': null
                }
              },
              'Details': {
                'oneofs': {
                  'kind': {
                    'oneof': [
                      'applicationError',
                      'validationError'
                    ],
                    'comment': null
                  }
                },
                'fields': {
                  'applicationError': {
                    'type': 'ApplicationError',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'validationError': {
                    'type': 'ValidationError',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'tracing': {
                    'keyType': 'string',
                    'type': 'string',
                    'id': 3,
                    'options': { 'deprecated': true },
                    'comment': null
                  }
                },
                'comment': null
              },
              'ApplicationError': {
                'fields': {
                  'code': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'description': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'data': {
                    'type': 'google.protobuf.Struct',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'ValidationError': {
                'fields': {
                  'fieldViolations': {
                    'rule': 'repeated',
                    'type': 'FieldViolation',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'nested': {
                  'RuleType': {
                    'values': {
                      'VALIDATION': 0,
                      'OTHER': 1,
                      'MAX': 2,
                      'MIN': 3,
                      'MAX_LENGTH': 4,
                      'MIN_LENGTH': 5,
                      'MAX_SIZE': 6,
                      'MIN_SIZE': 7,
                      'FORMAT': 8,
                      'DECIMAL_LTE': 9,
                      'DECIMAL_GTE': 10,
                      'DECIMAL_LT': 11,
                      'DECIMAL_GT': 12,
                      'DECIMAL_MAX_SCALE': 13,
                      'INVALID_ENUM_VALUE': 14,
                      'REQUIRED_FIELD': 15
                    },
                    'comment': null,
                    'comments': {
                      'VALIDATION': null,
                      'OTHER': null,
                      'MAX': null,
                      'MIN': null,
                      'MAX_LENGTH': null,
                      'MIN_LENGTH': null,
                      'MAX_SIZE': null,
                      'MIN_SIZE': null,
                      'FORMAT': null,
                      'DECIMAL_LTE': null,
                      'DECIMAL_GTE': null,
                      'DECIMAL_LT': null,
                      'DECIMAL_GT': null,
                      'DECIMAL_MAX_SCALE': null,
                      'INVALID_ENUM_VALUE': null,
                      'REQUIRED_FIELD': null
                    }
                  },
                  'FieldViolation': {
                    'fields': {
                      'field': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'description': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'violatedRule': {
                        'type': 'RuleType',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'ruleName': {
                        'type': 'google.protobuf.StringValue',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'data': {
                        'type': 'google.protobuf.Struct',
                        'id': 5,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  }
                },
                'comment': 'example result:\n{\n"fieldViolations": [\n{\n"field": "fieldA",\n"description": "invalid music note. supported notes: [do,re,mi,fa,sol,la,ti]",\n"violatedRule": "OTHER",\n"ruleName": "INVALID_NOTE",\n"data": {\n"value": "FI"\n}\n},\n{\n"field": "fieldB",\n"description": "field value out of range. supported range: [0-20]",\n"violatedRule": "MAX",\n"data": {\n"threshold": 20\n}\n},\n{\n"field": "fieldC",\n"description": "invalid phone number. provide a valid phone number of size: [7-12], supported characters: [0-9, +, -, (, )]",\n"violatedRule": "FORMAT",\n"data": {\n"type": "PHONE"\n}\n}\n]\n}'
              },
              'LimitRuleInt32DataPayload': {
                'fields': {
                  'threshold': {
                    'type': 'int32',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'LimitRuleDoubleDataPayload': {
                'fields': {
                  'threshold': {
                    'type': 'double',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'LimitRuleStringDataPayload': {
                'fields': {
                  'threshold': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'FormatRuleDataPayload': {
                'fields': {
                  'type': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'EnumRuleDataPayload': {
                'fields': {
                  'supported': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'serviceEntity': {
                'type': 'ServiceEntity',
                'id': 50500,
                'extend': 'google.protobuf.ServiceOptions',
                'comment': null,
                'parsedOptions': null
              },
              'ServiceEntity': {
                'fields': {
                  'message': {
                    'rule': 'required',
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'namespace': {
                    'type': 'string',
                    'id': 50501,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'entity': {
                'type': 'Entity',
                'id': 50500,
                'extend': 'google.protobuf.MessageOptions',
                'comment': null,
                'parsedOptions': null
              },
              'Entity': {
                'fields': {
                  'fqdn': {
                    'rule': 'required',
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'exposure': {
                    'type': 'Exposure',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'appendixFiles': {
                    'rule': 'repeated',
                    'type': 'MessageAppendix',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'oldFqdnForBackwardsCompatibility': {
                    'type': 'string',
                    'id': 4,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'segment': {
                    'type': 'Segment.Segment',
                    'id': 5,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'implements': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 6,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'MessageAppendix': {
                'fields': {
                  'type': {
                    'rule': 'required',
                    'type': 'Type',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'path': {
                    'rule': 'required',
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'nested': {
                  'Type': {
                    'values': {
                      'UNKNOWN_APPENDIX_TYPE': 0,
                      'AUTO_VELO': 1,
                      'DOCS_CONF': 2,
                      'MULTILINGUAL': 3
                    },
                    'comment': null,
                    'comments': {
                      'UNKNOWN_APPENDIX_TYPE': null,
                      'AUTO_VELO': null,
                      'DOCS_CONF': null,
                      'MULTILINGUAL': null
                    }
                  }
                },
                'comment': null
              },
              'callback': {
                'rule': 'repeated',
                'type': 'Callback',
                'id': 50000,
                'extend': 'google.protobuf.MethodOptions',
                'comment': null,
                'parsedOptions': null
              },
              'event': {
                'rule': 'repeated',
                'type': 'Callback',
                'id': 50000,
                'extend': 'google.protobuf.ServiceOptions',
                'options': { 'packed': false },
                'comment': null,
                'parsedOptions': null
              },
              'eventDeprecated': {
                'rule': 'repeated',
                'type': 'CallbackDeprecation',
                'id': 50001,
                'extend': 'google.protobuf.ServiceOptions',
                'options': { 'packed': false },
                'comment': null,
                'parsedOptions': null
              },
              'Callback': {
                'fields': {
                  'topic': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'segment': {
                    'type': 'Segment.Segment',
                    'id': 8,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'payload': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'permission': {
                    'type': 'string',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'eventType': {
                    'type': 'EventType',
                    'id': 4,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'exposure': {
                    'type': 'Exposure',
                    'id': 6,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'maturity': {
                    'type': 'Maturity',
                    'id': 7,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'nested': {
                  'EventType': {
                    'values': {
                      'UNKNOWN': 0,
                      'CREATED': 1,
                      'UPDATED': 2,
                      'DELETED': 3,
                      'ACTION': 4
                    },
                    'comment': null,
                    'comments': {
                      'UNKNOWN': null,
                      'CREATED': null,
                      'UPDATED': null,
                      'DELETED': null,
                      'ACTION': null
                    }
                  }
                },
                'comment': null
              },
              'CallbackDeprecation': {
                'fields': {
                  'replacedBy': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'targetRemovalDate': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'eventType': {
                    'type': 'Callback.EventType',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'customSlug': {
                    'type': 'string',
                    'id': 4,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'payload': {
                    'type': 'string',
                    'id': 5,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'Segment': {
                'fields': {},
                'nested': {
                  'Segment': {
                    'values': {
                      'UNSPECIFIED': 0,
                      'USERS': 1,
                      'PUBLIC': 2,
                      'OTHERS': 3
                    },
                    'comment': null,
                    'comments': {
                      'UNSPECIFIED': null,
                      'USERS': null,
                      'PUBLIC': null,
                      'OTHERS': null
                    }
                  }
                },
                'comment': null
              }
            }
          }
        }
      },
      'com': {
        'nested': {
          'wixpress': {
            'nested': {
              'wixdocs': {
                'nested': {
                  'BackstageService': {
                    'options': { '(wix.api.service_exposure)': 'PRIVATE' },
                    'methods': {
                      'getUserData': {
                        'requestType': 'google.protobuf.Empty',
                        'responseType': 'GetUserDataResponse',
                        'options': { '(google.api.http).get': '/v1/user-data' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'get': '/v1/user-data' },
                            '__comment': { 'get': null }
                          }]
                      },
                      'HasAccess': {
                        'requestType': 'HasAccessRequest',
                        'responseType': 'HasAccessResponse',
                        'options': { '(google.api.http).get': '/v1/user-data/has-access' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'get': '/v1/user-data/has-access' },
                            '__comment': { 'get': null }
                          }]
                      }
                    },
                    'comment': null
                  },
                  'UserData': {
                    'fields': {
                      'project': {
                        'type': 'Project',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'viewers': {
                        'rule': 'repeated',
                        'type': 'Viewer',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'GetUserDataResponse': {
                    'fields': {
                      'data': {
                        'rule': 'repeated',
                        'type': 'UserData',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'HasAccessRequest': {
                    'fields': {
                      'projectId': {
                        'type': 'google.protobuf.StringValue',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'viewerId': {
                        'type': 'google.protobuf.StringValue',
                        'id': 2,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'HasAccessResponse': {
                    'fields': {
                      'hasAccess': {
                        'type': 'bool',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'SectionTypes': {
                    'values': {
                      'NO_TYPE': 0,
                      'OPERATIONS': 1,
                      'SUBCATEGORIES': 2,
                      'PROPERTIES': 3,
                      'EVENTS': 4,
                      'MESSAGES': 5,
                      'GUIDES': 6
                    },
                    'comment': null,
                    'comments': {
                      'NO_TYPE': null,
                      'OPERATIONS': null,
                      'SUBCATEGORIES': null,
                      'PROPERTIES': null,
                      'EVENTS': null,
                      'MESSAGES': null,
                      'GUIDES': null
                    }
                  },
                  'ViewerConfig': {
                    'fields': {
                      'layoutType': {
                        'type': 'LayoutType',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'relatedSites': {
                        'rule': 'repeated',
                        'type': 'RelatedSite',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'seoConfig': {
                        'type': 'SeoConfig',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'displayOptions': {
                        'type': 'DisplayOptions',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'embeddedScripts': {
                        'rule': 'repeated',
                        'type': 'EmbeddedScript',
                        'id': 5,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'githubSourceUrl': {
                        'type': 'string',
                        'id': 6,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'customLabelsTemplates': {
                        'keyType': 'string',
                        'type': 'CustomLabel',
                        'id': 7,
                        'comment': null
                      },
                      'resolvingNameConflicts': {
                        'keyType': 'string',
                        'type': 'NameConflictResolution',
                        'id': 8,
                        'comment': null
                      },
                      'urlPath': {
                        'type': 'google.protobuf.StringValue',
                        'id': 9,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'host': {
                        'type': 'google.protobuf.StringValue',
                        'id': 10,
                        'options': { 'deprecated': true },
                        'comment': null,
                        'parsedOptions': [{
                            'deprecated': true,
                            '__comment': null
                          }]
                      },
                      'basename': {
                        'type': 'google.protobuf.StringValue',
                        'id': 11,
                        'options': { 'deprecated': true },
                        'comment': null,
                        'parsedOptions': [{
                            'deprecated': true,
                            '__comment': null
                          }]
                      }
                    },
                    'nested': {
                      'LayoutType': {
                        'values': {
                          'REST': 0,
                          'JS': 1,
                          'RPC': 2,
                          'RPC_REST': 3
                        },
                        'comment': null,
                        'comments': {
                          'REST': null,
                          'JS': null,
                          'RPC': null,
                          'RPC_REST': null
                        }
                      },
                      'NameConflictResolution': {
                        'fields': {
                          'additionalText': {
                            'type': 'string',
                            'id': 1,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'textPlacement': {
                            'type': 'TextPlacement',
                            'id': 2,
                            'comment': null,
                            'parsedOptions': null
                          }
                        },
                        'nested': {
                          'TextPlacement': {
                            'values': {
                              'NO_PLACEMENT': 0,
                              'SUFFIX': 1,
                              'PREFIX': 2
                            },
                            'comment': null,
                            'comments': {
                              'NO_PLACEMENT': null,
                              'SUFFIX': null,
                              'PREFIX': null
                            }
                          }
                        },
                        'comment': null
                      },
                      'CustomLabel': {
                        'fields': {
                          'name': {
                            'type': 'string',
                            'id': 1,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'color': {
                            'type': 'string',
                            'id': 2,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'description': {
                            'type': 'string',
                            'id': 3,
                            'comment': null,
                            'parsedOptions': null
                          }
                        },
                        'comment': null
                      },
                      'EmbeddedScript': {
                        'fields': {
                          'location': {
                            'type': 'EmbeddedScriptLocation',
                            'id': 1,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'script': {
                            'type': 'string',
                            'id': 2,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'name': {
                            'type': 'string',
                            'id': 3,
                            'comment': null,
                            'parsedOptions': null
                          }
                        },
                        'nested': {
                          'EmbeddedScriptLocation': {
                            'values': {
                              'HEAD': 0,
                              'BODY_START': 1,
                              'BODY_END': 2
                            },
                            'comment': null,
                            'comments': {
                              'HEAD': null,
                              'BODY_START': null,
                              'BODY_END': null
                            }
                          }
                        },
                        'comment': null
                      },
                      'RelatedSite': {
                        'fields': {
                          'name': {
                            'type': 'string',
                            'id': 1,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'url': {
                            'type': 'string',
                            'id': 2,
                            'options': { '(wix.api.format)': 'WEB_URL' },
                            'comment': null,
                            'parsedOptions': [{
                                '(wix.api.format)': 'WEB_URL',
                                '__comment': null
                              }]
                          },
                          'viewerId': {
                            'type': 'google.protobuf.StringValue',
                            'id': 3,
                            'options': { '(wix.api.format)': 'GUID' },
                            'comment': null,
                            'parsedOptions': [{
                                '(wix.api.format)': 'GUID',
                                '__comment': null
                              }]
                          }
                        },
                        'comment': null
                      },
                      'SeoConfig': {
                        'fields': {
                          'homePageTitle': {
                            'type': 'google.protobuf.StringValue',
                            'id': 1,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'homePageDescription': {
                            'type': 'google.protobuf.StringValue',
                            'id': 2,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'pageTitleSuffix': {
                            'type': 'google.protobuf.StringValue',
                            'id': 3,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'hideFromSearchEngines': {
                            'type': 'google.protobuf.BoolValue',
                            'id': 4,
                            'comment': null,
                            'parsedOptions': null
                          }
                        },
                        'comment': null
                      },
                      'DisplayOptions': {
                        'fields': {
                          'showComplexTypesInTable': {
                            'type': 'google.protobuf.BoolValue',
                            'id': 1,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'openAllExamplesOnStart': {
                            'type': 'google.protobuf.BoolValue',
                            'id': 2,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'hideRestPlayground': {
                            'type': 'google.protobuf.BoolValue',
                            'id': 3,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'showTokenBar': {
                            'type': 'google.protobuf.BoolValue',
                            'id': 4,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'favicon': {
                            'type': 'google.protobuf.StringValue',
                            'id': 5,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'showSourceLink': {
                            'type': 'google.protobuf.BoolValue',
                            'id': 6,
                            'comment': null,
                            'parsedOptions': null
                          }
                        },
                        'comment': null
                      }
                    },
                    'comment': null
                  },
                  'MenuConfig': {
                    'fields': {
                      'categories': {
                        'rule': 'repeated',
                        'type': 'MenuConfigCategory',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'nested': {
                      'MenuConfigCategory': {
                        'fields': {
                          'name': {
                            'type': 'string',
                            'id': 1,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'path': {
                            'type': 'string',
                            'id': 2,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'visible': {
                            'type': 'bool',
                            'id': 3,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'type': {
                            'type': 'string',
                            'id': 4,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'sortOrder': {
                            'type': 'google.protobuf.UInt32Value',
                            'id': 5,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'touched': {
                            'type': 'google.protobuf.BoolValue',
                            'id': 6,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'members': {
                            'rule': 'repeated',
                            'type': 'Member',
                            'id': 7,
                            'comment': null,
                            'parsedOptions': null
                          }
                        },
                        'nested': {
                          'Member': {
                            'fields': {
                              'name': {
                                'type': 'string',
                                'id': 1,
                                'comment': null,
                                'parsedOptions': null
                              },
                              'path': {
                                'type': 'string',
                                'id': 2,
                                'comment': null,
                                'parsedOptions': null
                              },
                              'visible': {
                                'type': 'bool',
                                'id': 3,
                                'comment': null,
                                'parsedOptions': null
                              },
                              'type': {
                                'type': 'string',
                                'id': 4,
                                'comment': null,
                                'parsedOptions': null
                              },
                              'sortOrder': {
                                'type': 'google.protobuf.UInt32Value',
                                'id': 5,
                                'comment': null,
                                'parsedOptions': null
                              },
                              'movedFrom': {
                                'type': 'google.protobuf.StringValue',
                                'id': 6,
                                'comment': null,
                                'parsedOptions': null
                              },
                              'touched': {
                                'type': 'google.protobuf.BoolValue',
                                'id': 7,
                                'comment': null,
                                'parsedOptions': null
                              }
                            },
                            'comment': null
                          }
                        },
                        'comment': null
                      }
                    },
                    'comment': null
                  },
                  'Viewer': {
                    'options': {
                      '(wix.api.entity).fqdn': 'wix.apis.docs.v1.viewer',
                      '(wix.api.entity).old_fqdn_for_backwards_compatibility': 'com.wixpress.wixdocs.viewer',
                      '(wix.api.entity)': {
                        'fqdn': 'wix.apis.docs.v1.viewer',
                        'old_fqdn_for_backwards_compatibility': 'com.wixpress.wixdocs.viewer'
                      }
                    },
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': {
                          '(wix.api.readOnly)': true,
                          '(wix.api.format)': 'GUID'
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(wix.api.readOnly)': true,
                            '__comment': null
                          },
                          {
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }
                        ]
                      },
                      'name': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'artifactId': {
                        'type': 'string',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'viewerConfig': {
                        'type': 'ViewerConfig',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'menuConfig': {
                        'type': 'MenuConfig',
                        'id': 5,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'currentVersion': {
                        'type': 'string',
                        'id': 6,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'availableVersions': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 7,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'contentStatus': {
                        'type': 'ContentStatus',
                        'id': 8,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'autoPublish': {
                        'type': 'bool',
                        'id': 9,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'order': {
                        'type': 'int32',
                        'id': 10,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'visibleSite': {
                        'type': 'bool',
                        'id': 11,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'latestVersion': {
                        'type': 'string',
                        'id': 12,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'projectId': {
                        'type': 'string',
                        'id': 13,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'emailList': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 14,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'category': {
                        'type': 'string',
                        'id': 15,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'serviceJsonFormat': {
                        'type': 'ServiceJsonFormat',
                        'id': 16,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'nested': {
                      'ContentStatus': {
                        'values': {
                          'PUBLISHED': 0,
                          'PENDING': 1
                        },
                        'comment': null,
                        'comments': {
                          'PUBLISHED': null,
                          'PENDING': null
                        }
                      },
                      'ServiceJsonFormat': {
                        'values': {
                          'NONE': 0,
                          'PASCAL_CASE': 1,
                          'KABAB_CASE': 2
                        },
                        'comment': null,
                        'comments': {
                          'NONE': null,
                          'PASCAL_CASE': null,
                          'KABAB_CASE': null
                        }
                      }
                    },
                    'comment': null
                  },
                  'ViewerFilter': {
                    'fields': {
                      'name': {
                        'type': 'google.protobuf.StringValue',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'artifactId': {
                        'type': 'google.protobuf.StringValue',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'currentVersion': {
                        'type': 'google.protobuf.StringValue',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'autoPublish': {
                        'type': 'google.protobuf.BoolValue',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'visibleSite': {
                        'type': 'google.protobuf.BoolValue',
                        'id': 5,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'category': {
                        'type': 'google.protobuf.StringValue',
                        'id': 6,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'ViewerUpdater': {
                    'fields': {
                      'name': {
                        'type': 'google.protobuf.StringValue',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'artifactId': {
                        'type': 'google.protobuf.StringValue',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'currentVersion': {
                        'type': 'google.protobuf.StringValue',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'autoPublish': {
                        'type': 'google.protobuf.BoolValue',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'visibleSite': {
                        'type': 'google.protobuf.BoolValue',
                        'id': 5,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'category': {
                        'type': 'google.protobuf.StringValue',
                        'id': 6,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'Version': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': {
                          '(wix.api.readOnly)': true,
                          '(wix.api.format)': 'GUID'
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(wix.api.readOnly)': true,
                            '__comment': null
                          },
                          {
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }
                        ]
                      },
                      'viewerId': {
                        'type': 'string',
                        'id': 2,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'publishedBy': {
                        'type': 'string',
                        'id': 3,
                        'options': { '(wix.api.minLength)': 1 },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.minLength)': 1,
                            '__comment': null
                          }]
                      },
                      'version': {
                        'type': 'string',
                        'id': 4,
                        'options': { '(wix.api.minLength)': 1 },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.minLength)': 1,
                            '__comment': null
                          }]
                      },
                      'releaseNote': {
                        'type': 'string',
                        'id': 5,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'branches': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 6,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'publishedDate': {
                        'type': 'google.protobuf.Timestamp',
                        'id': 7,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'buildInfo': {
                        'type': 'BuildInfo',
                        'id': 8,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'updatedDate': {
                        'type': 'google.protobuf.Timestamp',
                        'id': 9,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'nested': {
                      'BuildInfo': {
                        'fields': {
                          'status': {
                            'type': 'Status',
                            'id': 1,
                            'comment': null,
                            'parsedOptions': null
                          },
                          'errorMsg': {
                            'type': 'google.protobuf.StringValue',
                            'id': 2,
                            'comment': null,
                            'parsedOptions': null
                          }
                        },
                        'nested': {
                          'Status': {
                            'values': {
                              'STARTED': 0,
                              'COMPLETED': 1,
                              'FAILED': 2
                            },
                            'comment': null,
                            'comments': {
                              'STARTED': null,
                              'COMPLETED': null,
                              'FAILED': null
                            }
                          }
                        },
                        'comment': null
                      },
                      'BumpType': {
                        'values': {
                          'patch': 0,
                          'minor': 1,
                          'major': 2
                        },
                        'comment': null,
                        'comments': {
                          'patch': null,
                          'minor': null,
                          'major': null
                        }
                      }
                    },
                    'comment': null
                  },
                  'Project': {
                    'options': {
                      '(wix.api.entity).fqdn': 'wix.apis.docs.v1.project',
                      '(wix.api.entity).old_fqdn_for_backwards_compatibility': 'com.wixpress.wixdocs.project',
                      '(wix.api.entity)': {
                        'fqdn': 'wix.apis.docs.v1.project',
                        'old_fqdn_for_backwards_compatibility': 'com.wixpress.wixdocs.project'
                      }
                    },
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': {
                          '(wix.api.readOnly)': true,
                          '(wix.api.format)': 'GUID'
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(wix.api.readOnly)': true,
                            '__comment': null
                          },
                          {
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }
                        ]
                      },
                      'name': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'viewerIds': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 3,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'domainSettings': {
                        'type': 'DomainSettings',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'DomainSettings': {
                    'fields': {
                      'baseDomain': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'externalDomain': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'viewerId': {
                        'type': 'string',
                        'id': 3,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'ViewerConfigUpdated': {
                    'fields': {
                      'config': {
                        'type': 'ViewerConfig',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'viewerId': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'ViewerConfigPublished': {
                    'fields': {
                      'config': {
                        'type': 'ViewerConfig',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'viewerId': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'MenuConfigUpdated': {
                    'fields': {
                      'config': {
                        'type': 'MenuConfig',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'viewerId': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'MenuConfigPublished': {
                    'fields': {
                      'config': {
                        'type': 'MenuConfig',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'viewerId': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'ViewerVersionDataUploaded': {
                    'fields': {
                      'currentVersion': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'viewerId': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'ProjectDomainSettingsUpdated': {
                    'fields': {
                      'domainSettings': {
                        'type': 'DomainSettings',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'projectId': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'ProjectsService': {
                    'options': {
                      '(wix.api.service_entity).message': 'com.wixpress.wixdocs.Project',
                      '(wix.api.service_exposure)': 'PRIVATE'
                    },
                    'methods': {
                      'ListProjects': {
                        'requestType': 'google.protobuf.Empty',
                        'responseType': 'ListProjectsResponse',
                        'options': { '(google.api.http).get': '/v1/projects' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'get': '/v1/projects' },
                            '__comment': { 'get': null }
                          }]
                      },
                      'CreateProject': {
                        'requestType': 'CreateProjectRequest',
                        'responseType': 'CreateProjectResponse',
                        'options': {
                          '(wix.api.required)': 'CreateProjectRequest.name',
                          '(google.api.http).post': '/v1/projects'
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(wix.api.required)': 'CreateProjectRequest.name',
                            '__comment': null
                          },
                          {
                            '(google.api.http)': { 'post': '/v1/projects' },
                            '__comment': { 'post': null }
                          }
                        ]
                      },
                      'GetProject': {
                        'requestType': 'GetProjectRequest',
                        'responseType': 'GetProjectResponse',
                        'options': { '(google.api.http).get': '/v1/projects/{id}' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'get': '/v1/projects/{id}' },
                            '__comment': { 'get': null }
                          }]
                      },
                      'DeleteProject': {
                        'requestType': 'DeleteProjectRequest',
                        'responseType': 'DeleteProjectResponse',
                        'options': { '(google.api.http).delete': '/v1/projects/{id}' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'delete': '/v1/projects/{id}' },
                            '__comment': { 'delete': null }
                          }]
                      },
                      'UpdateProjectName': {
                        'requestType': 'UpdateProjectNameRequest',
                        'responseType': 'UpdateProjectNameResponse',
                        'options': {
                          '(wix.api.required)': 'UpdateProjectNameRequest.name',
                          '(google.api.http).patch': '/v1/projects/{id}'
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(wix.api.required)': 'UpdateProjectNameRequest.name',
                            '__comment': null
                          },
                          {
                            '(google.api.http)': { 'patch': '/v1/projects/{id}' },
                            '__comment': { 'patch': null }
                          }
                        ]
                      },
                      'UpdateViewersProjectId': {
                        'requestType': 'UpdateViewersProjectIdRequest',
                        'responseType': 'UpdateViewersProjectIdResponse',
                        'options': {
                          '(wix.api.required)': 'UpdateViewersProjectIdRequest.id',
                          '(google.api.http).patch': '/v1/projects'
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(wix.api.required)': 'UpdateViewersProjectIdRequest.id',
                            '__comment': null
                          },
                          {
                            '(google.api.http)': { 'patch': '/v1/projects' },
                            '__comment': { 'patch': null }
                          }
                        ]
                      },
                      'UpdateProjectDomainSettings': {
                        'requestType': 'UpdateProjectDomainSettingsRequest',
                        'responseType': 'UpdateProjectDomainSettingsResponse',
                        'options': {
                          '(google.api.http).patch': '/v1/projects/{id}/domain-settings',
                          '(wix.api.callback).event_type': 'ACTION',
                          '(wix.api.callback).payload': 'ProjectDomainSettingsUpdated',
                          '(wix.api.callback)': {
                            'event_type': 'ACTION',
                            'payload': 'ProjectDomainSettingsUpdated'
                          }
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(google.api.http)': { 'patch': '/v1/projects/{id}/domain-settings' },
                            '__comment': { 'patch': null }
                          },
                          {
                            '(wix.api.callback)': {
                              'event_type': 'ACTION',
                              'payload': 'ProjectDomainSettingsUpdated'
                            },
                            '__comment': null
                          }
                        ]
                      }
                    },
                    'comment': null
                  },
                  'ListProjectsResponse': {
                    'fields': {
                      'projects': {
                        'rule': 'repeated',
                        'type': 'Project',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'CreateProjectRequest': {
                    'fields': {
                      'name': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.minLength)': 1 },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.minLength)': 1,
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'CreateProjectResponse': {
                    'fields': {
                      'project': {
                        'type': 'Project',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'GetProjectRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'GetProjectResponse': {
                    'fields': {
                      'project': {
                        'type': 'Project',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'DeleteProjectRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'DeleteProjectResponse': {
                    'fields': {},
                    'comment': null
                  },
                  'UpdateProjectNameRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'name': {
                        'type': 'string',
                        'id': 2,
                        'options': { '(wix.api.minLength)': 1 },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.minLength)': 1,
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'UpdateProjectNameResponse': {
                    'fields': {
                      'project': {
                        'type': 'Project',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'UpdateViewersProjectIdRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'UpdateViewersProjectIdResponse': {
                    'fields': {
                      'viewers': {
                        'rule': 'repeated',
                        'type': 'Viewer',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'UpdateProjectDomainSettingsRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'baseDomain': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'externalDomain': {
                        'type': 'string',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'viewerId': {
                        'type': 'string',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'UpdateProjectDomainSettingsResponse': {
                    'fields': {},
                    'comment': null
                  },
                  'SearchService': {
                    'options': {
                      '(wix.api.service_exposure)': 'PRIVATE',
                      '(wix.api.service_maturity)': 'ALPHA'
                    },
                    'methods': {
                      'GetDocs': {
                        'requestType': 'GetDocsRequest',
                        'responseType': 'GetDocsResponse',
                        'options': { '(google.api.http).get': '/v1/search/{viewer_id}/{search_terms}' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'get': '/v1/search/{viewer_id}/{search_terms}' },
                            '__comment': { 'get': null }
                          }]
                      },
                      'GetFullSearchData': {
                        'requestType': 'GetFullSearchDataRequest',
                        'responseType': 'GetFullSearchDataResponse',
                        'options': { '(google.api.http).get': '/v1/search/{viewer_id}' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'get': '/v1/search/{viewer_id}' },
                            '__comment': { 'get': null }
                          }]
                      }
                    },
                    'comment': null
                  },
                  'GetDocsRequest': {
                    'fields': {
                      'viewerId': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'searchTerms': {
                        'type': 'string',
                        'id': 2,
                        'options': { '(wix.api.minLength)': 2 },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.minLength)': 2,
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'WixDocsResults': {
                    'fields': {
                      'type': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.minLength)': 1 },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.minLength)': 1,
                            '__comment': null
                          }]
                      },
                      'name': {
                        'type': 'string',
                        'id': 2,
                        'options': { '(wix.api.minLength)': 1 },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.minLength)': 1,
                            '__comment': null
                          }]
                      },
                      'description': {
                        'type': 'string',
                        'id': 3,
                        'options': { '(wix.api.minLength)': 1 },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.minLength)': 1,
                            '__comment': null
                          }]
                      },
                      'summary': {
                        'type': 'string',
                        'id': 4,
                        'options': { '(wix.api.minLength)': 1 },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.minLength)': 1,
                            '__comment': null
                          }]
                      },
                      'siteName': {
                        'type': 'string',
                        'id': 5,
                        'options': { '(wix.api.minLength)': 1 },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.minLength)': 1,
                            '__comment': null
                          }]
                      },
                      'link': {
                        'type': 'string',
                        'id': 6,
                        'options': { '(wix.api.format)': 'WEB_URL' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'WEB_URL',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'GetDocsResponse': {
                    'fields': {
                      'results': {
                        'rule': 'repeated',
                        'type': 'WixDocsResults',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'GetFullSearchDataRequest': {
                    'fields': {
                      'viewerId': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'GetFullSearchDataResponse': {
                    'fields': {
                      'results': {
                        'rule': 'repeated',
                        'type': 'WixDocsResults',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'StoreService': {
                    'options': {
                      '(wix.api.service_exposure)': 'PRIVATE',
                      '(wix.api.service_maturity)': 'ALPHA'
                    },
                    'methods': {
                      'UpdateStoreContent': {
                        'requestType': 'UpdateStoreContentRequest',
                        'responseType': 'UpdateStoreContentResponse',
                        'options': { '(google.api.http).post': '/v1/update-store/{viewer_id}' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'post': '/v1/update-store/{viewer_id}' },
                            '__comment': { 'post': null }
                          }]
                      },
                      'PublishStoreContent': {
                        'requestType': 'PublishStoreContentRequest',
                        'responseType': 'PublishStoreContentResponse',
                        'options': { '(google.api.http).post': '/v1/publish-store/{viewer_id}' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'post': '/v1/publish-store/{viewer_id}' },
                            '__comment': { 'post': null }
                          }]
                      }
                    },
                    'comment': null
                  },
                  'UpdateStoreContentRequest': {
                    'fields': {
                      'viewerId': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'UpdateStoreContentResponse': {
                    'fields': {},
                    'comment': null
                  },
                  'PublishStoreContentRequest': {
                    'fields': {
                      'viewerId': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'version': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'PublishStoreContentResponse': {
                    'fields': {},
                    'comment': null
                  },
                  'ViewersService': {
                    'options': {
                      '(wix.api.service_entity).message': 'com.wixpress.wixdocs.Viewer',
                      '(wix.api.service_exposure)': 'PRIVATE',
                      '(wix.api.service_maturity)': 'ALPHA'
                    },
                    'methods': {
                      'ListViewersByProjectId': {
                        'requestType': 'ListViewersByProjectIdRequest',
                        'responseType': 'ListViewersByProjectIdResponse',
                        'options': { '(google.api.http).get': '/v1/projects/{project_id}/viewers' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'get': '/v1/projects/{project_id}/viewers' },
                            '__comment': { 'get': null }
                          }]
                      },
                      'GetViewersByProjectId': {
                        'requestType': 'GetViewersByProjectIdRequest',
                        'responseType': 'GetViewersByProjectIdResponse',
                        'options': { '(google.api.http).get': '/v1/projects/{project_id}/viewers-list' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'get': '/v1/projects/{project_id}/viewers-list' },
                            '__comment': { 'get': null }
                          }]
                      },
                      'GetViewer': {
                        'requestType': 'GetViewerRequest',
                        'responseType': 'GetViewerResponse',
                        'options': { '(google.api.http).get': '/v1/projects/{project_id}/viewers/{id}' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'get': '/v1/projects/{project_id}/viewers/{id}' },
                            '__comment': { 'get': null }
                          }]
                      },
                      'CreateViewer': {
                        'requestType': 'CreateViewerRequest',
                        'responseType': 'CreateViewerResponse',
                        'options': {
                          '(wix.api.required)': 'CreateViewerRequest.project_id',
                          '(google.api.http).post': '/v1/projects/{project_id}/viewers'
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(wix.api.required)': 'CreateViewerRequest.name',
                            '__comment': null
                          },
                          {
                            '(wix.api.required)': 'CreateViewerRequest.artifact_id',
                            '__comment': null
                          },
                          {
                            '(wix.api.required)': 'CreateViewerRequest.project_id',
                            '__comment': null
                          },
                          {
                            '(google.api.http)': { 'post': '/v1/projects/{project_id}/viewers' },
                            '__comment': { 'post': null }
                          }
                        ]
                      },
                      'DeleteViewer': {
                        'requestType': 'DeleteViewerRequest',
                        'responseType': 'DeleteViewerResponse',
                        'options': { '(google.api.http).delete': '/v1/projects/{project_id}/viewers/{id}' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'delete': '/v1/projects/{project_id}/viewers/{id}' },
                            '__comment': { 'delete': null }
                          }]
                      },
                      'UpdateViewerName': {
                        'requestType': 'UpdateViewerNameRequest',
                        'responseType': 'UpdateViewerNameResponse',
                        'options': {
                          '(wix.api.required)': 'UpdateViewerNameRequest.name',
                          '(google.api.http).patch': '/v1/projects/{project_id}/viewers/{id}'
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(wix.api.required)': 'UpdateViewerNameRequest.name',
                            '__comment': null
                          },
                          {
                            '(google.api.http)': { 'patch': '/v1/projects/{project_id}/viewers/{id}' },
                            '__comment': { 'patch': null }
                          }
                        ]
                      },
                      'UpdateViewerArtifactId': {
                        'requestType': 'UpdateViewerArtifactIdRequest',
                        'responseType': 'UpdateViewerArtifactIdResponse',
                        'options': {
                          '(wix.api.required)': 'UpdateViewerArtifactIdRequest.artifact_id',
                          '(google.api.http).patch': '/v1/projects/{project_id}/viewers/{id}/artifact-id'
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(wix.api.required)': 'UpdateViewerArtifactIdRequest.artifact_id',
                            '__comment': null
                          },
                          {
                            '(google.api.http)': { 'patch': '/v1/projects/{project_id}/viewers/{id}/artifact-id' },
                            '__comment': { 'patch': null }
                          }
                        ]
                      },
                      'UpdateViewerConfig': {
                        'requestType': 'UpdateViewerConfigRequest',
                        'responseType': 'UpdateViewerConfigResponse',
                        'options': {
                          '(google.api.http).patch': '/v1/projects/{project_id}/viewers/{id}/viewer-config',
                          '(wix.api.callback).event_type': 'ACTION',
                          '(wix.api.callback).payload': 'ViewerConfigUpdated',
                          '(wix.api.callback)': {
                            'event_type': 'ACTION',
                            'payload': 'ViewerConfigUpdated'
                          }
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(google.api.http)': { 'patch': '/v1/projects/{project_id}/viewers/{id}/viewer-config' },
                            '__comment': { 'patch': null }
                          },
                          {
                            '(wix.api.callback)': {
                              'event_type': 'ACTION',
                              'payload': 'ViewerConfigUpdated'
                            },
                            '__comment': null
                          }
                        ]
                      },
                      'PublishViewerConfig': {
                        'requestType': 'PublishViewerConfigRequest',
                        'responseType': 'PublishViewerConfigResponse',
                        'options': {
                          '(google.api.http).post': '/v1/projects/{project_id}/viewers/{id}/viewer-config/publish',
                          '(wix.api.callback).event_type': 'ACTION',
                          '(wix.api.callback).payload': 'ViewerConfigPublished',
                          '(wix.api.callback)': {
                            'event_type': 'ACTION',
                            'payload': 'ViewerConfigPublished'
                          }
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(google.api.http)': { 'post': '/v1/projects/{project_id}/viewers/{id}/viewer-config/publish' },
                            '__comment': { 'post': null }
                          },
                          {
                            '(wix.api.callback)': {
                              'event_type': 'ACTION',
                              'payload': 'ViewerConfigPublished'
                            },
                            '__comment': null
                          }
                        ]
                      },
                      'UpdateMenuConfig': {
                        'requestType': 'UpdateMenuConfigRequest',
                        'responseType': 'UpdateMenuConfigResponse',
                        'options': {
                          '(google.api.http).patch': '/v1/projects/{project_id}/viewers/{id}/menu-config',
                          '(wix.api.callback).event_type': 'ACTION',
                          '(wix.api.callback).payload': 'MenuConfigUpdated',
                          '(wix.api.callback)': {
                            'event_type': 'ACTION',
                            'payload': 'MenuConfigUpdated'
                          }
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(google.api.http)': { 'patch': '/v1/projects/{project_id}/viewers/{id}/menu-config' },
                            '__comment': { 'patch': null }
                          },
                          {
                            '(wix.api.callback)': {
                              'event_type': 'ACTION',
                              'payload': 'MenuConfigUpdated'
                            },
                            '__comment': null
                          }
                        ]
                      },
                      'PublishMenuConfig': {
                        'requestType': 'PublishMenuConfigRequest',
                        'responseType': 'PublishMenuConfigResponse',
                        'options': {
                          '(google.api.http).post': '/v1/projects/{project_id}/viewers/{id}/menu-config/publish',
                          '(wix.api.callback).event_type': 'ACTION',
                          '(wix.api.callback).payload': 'MenuConfigPublished',
                          '(wix.api.callback)': {
                            'event_type': 'ACTION',
                            'payload': 'MenuConfigPublished'
                          }
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(google.api.http)': { 'post': '/v1/projects/{project_id}/viewers/{id}/menu-config/publish' },
                            '__comment': { 'post': null }
                          },
                          {
                            '(wix.api.callback)': {
                              'event_type': 'ACTION',
                              'payload': 'MenuConfigPublished'
                            },
                            '__comment': null
                          }
                        ]
                      },
                      'BumpVersion': {
                        'requestType': 'BumpVersionRequest',
                        'responseType': 'BumpVersionResponse',
                        'options': { '(google.api.http).patch': '/v1/projects/{project_id}/viewers/{id}/version/bump' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'patch': '/v1/projects/{project_id}/viewers/{id}/version/bump' },
                            '__comment': { 'patch': null }
                          }]
                      },
                      'PurgeVersions': {
                        'requestType': 'PurgeVersionsRequest',
                        'responseType': 'PurgeVersionsResponse',
                        'options': { '(google.api.http).patch': '/v1/projects/viewers/{id}/versions/purge' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'patch': '/v1/projects/viewers/{id}/versions/purge' },
                            '__comment': { 'patch': null }
                          }]
                      },
                      'UpdateVersion': {
                        'requestType': 'UpdateVersionRequest',
                        'responseType': 'UpdateVersionResponse',
                        'options': { '(google.api.http).patch': '/v1/projects/{project_id}/viewers/{id}/version/update' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'patch': '/v1/projects/{project_id}/viewers/{id}/version/update' },
                            '__comment': { 'patch': null }
                          }]
                      },
                      'GetVersions': {
                        'requestType': 'GetVersionsRequest',
                        'responseType': 'GetVersionsResponse',
                        'options': { '(google.api.http).get': '/v1/viewers/{id}/versions' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'get': '/v1/viewers/{id}/versions' },
                            '__comment': { 'get': null }
                          }]
                      },
                      'UpdateContentStatus': {
                        'requestType': 'UpdateContentStatusRequest',
                        'responseType': 'UpdateContentStatusResponse',
                        'options': { '(google.api.http).patch': '/v1/viewers/update-content-status' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'patch': '/v1/viewers/update-content-status' },
                            '__comment': { 'patch': null }
                          }]
                      },
                      'QueryViewersByContent': {
                        'requestType': 'QueryViewersByContentRequest',
                        'responseType': 'QueryViewersByContentResponse',
                        'options': { '(google.api.http).post': '/v1/viewers/query' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'post': '/v1/viewers/query' },
                            '__comment': { 'post': null }
                          }]
                      },
                      'UpdateAutoPublish': {
                        'requestType': 'UpdateAutoPublishRequest',
                        'responseType': 'UpdateAutoPublishResponse',
                        'options': { '(google.api.http).patch': '/v1/viewers/{id}/auto-publish' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'patch': '/v1/viewers/{id}/auto-publish' },
                            '__comment': { 'patch': null }
                          }]
                      },
                      'UpdateViewersOrder': {
                        'requestType': 'UpdateViewersOrderRequest',
                        'responseType': 'UpdateViewersOrderResponse',
                        'options': { '(google.api.http).patch': '/v1/viewers/update-order' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'patch': '/v1/viewers/update-order' },
                            '__comment': { 'patch': null }
                          }]
                      },
                      'UpdateViewerVisibility': {
                        'requestType': 'UpdateViewerVisibilityRequest',
                        'responseType': 'UpdateViewerVisibilityResponse',
                        'options': { '(google.api.http).patch': '/v1/viewers/update-visibility' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'patch': '/v1/viewers/update-visibility' },
                            '__comment': { 'patch': null }
                          }]
                      },
                      'AddToEmailList': {
                        'requestType': 'AddToEmailListRequest',
                        'responseType': 'AddToEmailListResponse',
                        'options': {
                          '(wix.api.required)': 'AddToEmailListRequest.email_list',
                          '(google.api.http).patch': '/v1/update-email-list/{id}'
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(wix.api.required)': 'AddToEmailListRequest.id',
                            '__comment': null
                          },
                          {
                            '(wix.api.required)': 'AddToEmailListRequest.email_list',
                            '__comment': null
                          },
                          {
                            '(google.api.http)': { 'patch': '/v1/update-email-list/{id}' },
                            '__comment': { 'patch': null }
                          }
                        ]
                      },
                      'RemoveEmailsFromList': {
                        'requestType': 'RemoveEmailsFromListRequest',
                        'responseType': 'RemoveEmailsFromListResponse',
                        'options': {
                          '(wix.api.required)': 'RemoveEmailsFromListRequest.email_list',
                          '(google.api.http).delete': '/v1/remove-email-list/{id}'
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(wix.api.required)': 'RemoveEmailsFromListRequest.id',
                            '__comment': null
                          },
                          {
                            '(wix.api.required)': 'RemoveEmailsFromListRequest.email_list',
                            '__comment': null
                          },
                          {
                            '(google.api.http)': { 'delete': '/v1/remove-email-list/{id}' },
                            '__comment': { 'delete': null }
                          }
                        ]
                      },
                      'DeployContent': {
                        'requestType': 'DeployContentRequest',
                        'responseType': 'DeployContentResponse',
                        'options': {
                          '(wix.api.required)': 'DeployContentRequest.release_note',
                          '(google.api.http).post': '/v1/viewers/{viewer_id}/deploy-content'
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(wix.api.required)': 'DeployContentRequest.viewer_id',
                            '__comment': null
                          },
                          {
                            '(wix.api.required)': 'DeployContentRequest.release_note',
                            '__comment': null
                          },
                          {
                            '(google.api.http)': { 'post': '/v1/viewers/{viewer_id}/deploy-content' },
                            '__comment': { 'post': null }
                          }
                        ]
                      },
                      'QueryViewer': {
                        'requestType': 'QueryViewerRequest',
                        'responseType': 'QueryViewerResponse',
                        'options': {
                          '(wix.api.required)': 'QueryViewerRequest.viewer_filter',
                          '(google.api.http).post': '/v1/viewers'
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(wix.api.required)': 'QueryViewerRequest.viewer_filter',
                            '__comment': null
                          },
                          {
                            '(google.api.http)': { 'post': '/v1/viewers' },
                            '__comment': { 'post': null }
                          }
                        ]
                      },
                      'UpdateViewer': {
                        'requestType': 'UpdateViewerRequest',
                        'responseType': 'UpdateViewerResponse',
                        'options': {
                          '(wix.api.exposure)': 'PRIVATE',
                          '(wix.api.required)': 'UpdateViewerRequest.viewer_updater',
                          '(google.api.http).patch': '/v1/viewers/{id}'
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(wix.api.exposure)': 'PRIVATE',
                            '__comment': null
                          },
                          {
                            '(wix.api.required)': 'UpdateViewerRequest.id',
                            '__comment': null
                          },
                          {
                            '(wix.api.required)': 'UpdateViewerRequest.viewer_updater',
                            '__comment': null
                          },
                          {
                            '(google.api.http)': { 'patch': '/v1/viewers/{id}' },
                            '__comment': { 'patch': null }
                          }
                        ]
                      },
                      'UpdateServiceJsonFormat': {
                        'requestType': 'UpdateServiceJsonFormatRequest',
                        'responseType': 'UpdateServiceJsonFormatResponse',
                        'options': { '(google.api.http).patch': '/v1/viewers/update-service-json-format' },
                        'comment': null,
                        'parsedOptions': [{
                            '(google.api.http)': { 'patch': '/v1/viewers/update-service-json-format' },
                            '__comment': { 'patch': null }
                          }]
                      }
                    },
                    'comment': null
                  },
                  'ListViewersByProjectIdRequest': {
                    'fields': {
                      'projectId': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'ListViewersByProjectIdResponse': {
                    'fields': {
                      'viewers': {
                        'rule': 'repeated',
                        'type': 'Viewer',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'GetViewersByProjectIdRequest': {
                    'fields': {
                      'projectId': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'GetViewersByProjectIdResponse': {
                    'fields': {
                      'viewers': {
                        'rule': 'repeated',
                        'type': 'Viewer',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'GetViewerRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'projectId': {
                        'type': 'string',
                        'id': 2,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'GetViewerResponse': {
                    'fields': {
                      'viewer': {
                        'type': 'Viewer',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'CreateViewerRequest': {
                    'fields': {
                      'projectId': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'name': {
                        'type': 'string',
                        'id': 2,
                        'options': { '(wix.api.minLength)': 1 },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.minLength)': 1,
                            '__comment': null
                          }]
                      },
                      'artifactId': {
                        'type': 'string',
                        'id': 3,
                        'options': { '(wix.api.minLength)': 1 },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.minLength)': 1,
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'CreateViewerResponse': {
                    'fields': {
                      'viewer': {
                        'type': 'Viewer',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'DeleteViewerRequest': {
                    'fields': {
                      'projectId': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'id': {
                        'type': 'string',
                        'id': 2,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'DeleteViewerResponse': {
                    'fields': {},
                    'comment': null
                  },
                  'UpdateViewerNameRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'name': {
                        'type': 'string',
                        'id': 2,
                        'options': { '(wix.api.minLength)': 1 },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.minLength)': 1,
                            '__comment': null
                          }]
                      },
                      'projectId': {
                        'type': 'string',
                        'id': 3,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'UpdateViewerNameResponse': {
                    'fields': {
                      'viewer': {
                        'type': 'Viewer',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'UpdateViewerArtifactIdRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'artifactId': {
                        'type': 'string',
                        'id': 2,
                        'options': { '(wix.api.minLength)': 1 },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.minLength)': 1,
                            '__comment': null
                          }]
                      },
                      'projectId': {
                        'type': 'string',
                        'id': 3,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'UpdateViewerArtifactIdResponse': {
                    'fields': {
                      'viewer': {
                        'type': 'Viewer',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'UpdateViewerConfigRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'config': {
                        'type': 'ViewerConfig',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'shouldPublish': {
                        'type': 'bool',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'projectId': {
                        'type': 'string',
                        'id': 4,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'UpdateViewerConfigResponse': {
                    'fields': {
                      'config': {
                        'type': 'ViewerConfig',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'PublishViewerConfigRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'projectId': {
                        'type': 'string',
                        'id': 2,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'PublishViewerConfigResponse': {
                    'fields': {},
                    'comment': null
                  },
                  'UpdateMenuConfigRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'config': {
                        'type': 'MenuConfig',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'shouldPublish': {
                        'type': 'bool',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'projectId': {
                        'type': 'string',
                        'id': 4,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'UpdateMenuConfigResponse': {
                    'fields': {
                      'config': {
                        'type': 'MenuConfig',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'PublishMenuConfigRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'projectId': {
                        'type': 'string',
                        'id': 2,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'PublishMenuConfigResponse': {
                    'fields': {},
                    'comment': null
                  },
                  'BumpVersionRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'projectId': {
                        'type': 'string',
                        'id': 2,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'BumpVersionResponse': {
                    'fields': {
                      'version': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'PurgeVersionsRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'PurgeVersionsResponse': {
                    'fields': {},
                    'comment': null
                  },
                  'UpdateVersionRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'projectId': {
                        'type': 'string',
                        'id': 2,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'viewerVersion': {
                        'type': 'string',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'UpdateVersionResponse': {
                    'fields': {
                      'version': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'GetVersionsRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'GetVersionsResponse': {
                    'fields': {
                      'versions': {
                        'rule': 'repeated',
                        'type': 'Version',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'UpdateContentStatusRequest': {
                    'oneofs': {
                      'contentUpdateParams': {
                        'oneof': [
                          'id',
                          'category'
                        ],
                        'comment': null
                      }
                    },
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'category': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'contentStatus': {
                        'type': 'Viewer.ContentStatus',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'UpdateContentStatusResponse': {
                    'fields': {
                      'contentStatus': {
                        'type': 'Viewer.ContentStatus',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'QueryViewersByContentRequest': {
                    'fields': {
                      'contentStatus': {
                        'type': 'Viewer.ContentStatus',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'QueryViewersByContentResponse': {
                    'fields': {
                      'viewers': {
                        'rule': 'repeated',
                        'type': 'Viewer',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'UpdateAutoPublishRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'autoPublish': {
                        'type': 'bool',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'UpdateAutoPublishResponse': {
                    'fields': {},
                    'comment': null
                  },
                  'UpdateViewersOrderRequest': {
                    'fields': {
                      'viewersOrder': {
                        'rule': 'repeated',
                        'type': 'ViewerOrder',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'nested': {
                      'ViewerOrder': {
                        'fields': {
                          'id': {
                            'type': 'string',
                            'id': 1,
                            'options': { '(wix.api.format)': 'GUID' },
                            'comment': null,
                            'parsedOptions': [{
                                '(wix.api.format)': 'GUID',
                                '__comment': null
                              }]
                          },
                          'order': {
                            'type': 'int32',
                            'id': 2,
                            'comment': null,
                            'parsedOptions': null
                          }
                        },
                        'comment': null
                      }
                    },
                    'comment': null
                  },
                  'UpdateViewersOrderResponse': {
                    'fields': {},
                    'comment': null
                  },
                  'UpdateViewerVisibilityRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'visibility': {
                        'type': 'bool',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'UpdateViewerVisibilityResponse': {
                    'fields': {},
                    'comment': null
                  },
                  'AddToEmailListRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'emailList': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'shouldOverride': {
                        'type': 'bool',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'AddToEmailListResponse': {
                    'fields': {
                      'emailList': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'RemoveEmailsFromListRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'emailList': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'RemoveEmailsFromListResponse': {
                    'fields': {
                      'emailList': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'DeployContentRequest': {
                    'fields': {
                      'viewerId': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'releaseNote': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'branch': {
                        'type': 'google.protobuf.StringValue',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'bumpType': {
                        'type': 'Version.BumpType',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'DeployContentResponse': {
                    'fields': {
                      'version': {
                        'type': 'Version',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'QueryViewerRequest': {
                    'fields': {
                      'viewerFilter': {
                        'type': 'ViewerFilter',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'QueryViewerResponse': {
                    'fields': {
                      'viewer': {
                        'type': 'Viewer',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'UpdateViewerRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'viewerUpdater': {
                        'type': 'ViewerUpdater',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'UpdateViewerResponse': {
                    'fields': {
                      'viewer': {
                        'type': 'Viewer',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'UpdateServiceJsonFormatRequest': {
                    'fields': {
                      'id': {
                        'type': 'string',
                        'id': 1,
                        'options': { '(wix.api.format)': 'GUID' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'GUID',
                            '__comment': null
                          }]
                      },
                      'serviceJsonFormat': {
                        'type': 'Viewer.ServiceJsonFormat',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'UpdateServiceJsonFormatResponse': {
                    'fields': {
                      'serviceJsonFormat': {
                        'type': 'Viewer.ServiceJsonFormat',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'Service': {
                    'options': {
                      '(wix.api.entity).fqdn': 'wix.docs.v1.service',
                      '(wix.api.entity)': { 'fqdn': 'wix.docs.v1.service' }
                    },
                    'fields': {
                      'name': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'memberOf': {
                        'type': 'google.protobuf.StringValue',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'mixes': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'labels': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 4,
                        'options': { 'deprecated': true },
                        'comment': null,
                        'parsedOptions': [{
                            'deprecated': true,
                            '__comment': null
                          }]
                      },
                      'location': {
                        'type': 'CodeLocation',
                        'id': 5,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'docs': {
                        'type': 'Docs',
                        'id': 6,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'properties': {
                        'rule': 'repeated',
                        'type': 'Property',
                        'id': 7,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'operations': {
                        'rule': 'repeated',
                        'type': 'Operation',
                        'id': 8,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'clientEvents': {
                        'rule': 'repeated',
                        'type': 'Operation',
                        'id': 9,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'callbacks': {
                        'rule': 'repeated',
                        'type': 'Operation',
                        'id': 10,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'messages': {
                        'rule': 'repeated',
                        'type': 'Message',
                        'id': 11,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'relatedContent': {
                        'rule': 'repeated',
                        'type': 'RelatedContent',
                        'id': 12,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'FAQs': {
                        'rule': 'repeated',
                        'type': 'FAQ',
                        'id': 13,
                        'options': { 'deprecated': true },
                        'comment': null,
                        'parsedOptions': [{
                            'deprecated': true,
                            '__comment': null
                          }]
                      },
                      'tags': {
                        'rule': 'repeated',
                        'type': 'Tag',
                        'id': 14,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'relatedGuides': {
                        'rule': 'repeated',
                        'type': 'RelatedGuide',
                        'id': 15,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'events': {
                        'rule': 'repeated',
                        'type': 'Event',
                        'id': 16,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'extra': {
                        'type': 'google.protobuf.Struct',
                        'id': 17,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'clientId': {
                        'type': 'google.protobuf.StringValue',
                        'id': 18,
                        'comment': 'A unique id for this description file - once you set it DON\'T CHANGE IT\nThis helps prevent renaming or moving this file creating new / duplicate documentation\nSuggested format:\n${RuntimeArea}-${DescriptiveType}\nRuntimeArea - where this is used in runtime (we\'ve provided some options below)\nDescriptiveType - a short clear description of what this is, examples: FooComponent, FooAPI, FooEvent\nExample:\nbusiness-manager-single-invoice-component-api',
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'Extra': {
                    'fields': {
                      'eventType': {
                        'type': 'google.protobuf.StringValue',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'queryable': {
                        'type': 'google.protobuf.BoolValue',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'CodeLocation': {
                    'fields': {
                      'filename': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'lineno': {
                        'type': 'google.protobuf.Int32Value',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'Docs': {
                    'fields': {
                      'summary': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'description': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'links': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'examples': {
                        'rule': 'repeated',
                        'type': 'Example',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'extra': {
                        'type': 'Extra',
                        'id': 5,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'request': {
                        'type': 'HTTP_VERB',
                        'id': 6,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'url': {
                        'type': 'google.protobuf.StringValue',
                        'id': 7,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'nested': {
                      'HTTP_VERB': {
                        'values': {
                          'NA': 0,
                          'GET': 1,
                          'POST': 2,
                          'PUT': 3,
                          'DELETE': 4,
                          'PATCH': 5,
                          'OPTIONS': 6
                        },
                        'comment': null,
                        'comments': {
                          'NA': null,
                          'GET': null,
                          'POST': null,
                          'PUT': null,
                          'DELETE': null,
                          'PATCH': null,
                          'OPTIONS': null
                        }
                      }
                    },
                    'comment': null
                  },
                  'Property': {
                    'fields': {
                      'name': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'labels': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'get': {
                        'type': 'google.protobuf.BoolValue',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'set': {
                        'type': 'google.protobuf.BoolValue',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'type': {
                        'rule': 'repeated',
                        'type': 'Type',
                        'id': 5,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'defaultValue': {
                        'type': 'google.protobuf.Value',
                        'id': 6,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'locations': {
                        'rule': 'repeated',
                        'type': 'CodeLocation',
                        'id': 7,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'docs': {
                        'type': 'Docs',
                        'id': 8,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'extra': {
                        'type': 'Extra',
                        'id': 9,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'customLabels': {
                        'rule': 'repeated',
                        'type': 'CustomLabel',
                        'id': 10,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'dynamicCustomLabels': {
                        'rule': 'repeated',
                        'type': 'DynamicCustomLabel',
                        'id': 11,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'Example': {
                    'fields': {
                      'title': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'body': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'response': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'extra': {
                        'type': 'Extra',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'Operation': {
                    'fields': {
                      'name': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'labels': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'nameParams': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 3,
                        'options': { 'deprecated': true },
                        'comment': null,
                        'parsedOptions': [{
                            'deprecated': true,
                            '__comment': null
                          }]
                      },
                      'params': {
                        'rule': 'repeated',
                        'type': 'Parameter',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'ret': {
                        'type': 'ReturnValue',
                        'id': 5,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'locations': {
                        'rule': 'repeated',
                        'type': 'CodeLocation',
                        'id': 6,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'docs': {
                        'type': 'Docs',
                        'id': 7,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'tag': {
                        'type': 'google.protobuf.StringValue',
                        'id': 8,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'methodName': {
                        'type': 'google.protobuf.StringValue',
                        'id': 9,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'serviceName': {
                        'type': 'google.protobuf.StringValue',
                        'id': 10,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'permissions': {
                        'rule': 'repeated',
                        'type': 'Permission',
                        'id': 11,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'extra': {
                        'type': 'OperationsExtra',
                        'id': 12,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'customLabels': {
                        'rule': 'repeated',
                        'type': 'CustomLabel',
                        'id': 13,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'dynamicCustomLabels': {
                        'rule': 'repeated',
                        'type': 'DynamicCustomLabel',
                        'id': 14,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'requiredFields': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 15,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'Parameter': {
                    'fields': {
                      'name': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'type': {
                        'rule': 'repeated',
                        'type': 'Type',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'doc': {
                        'type': 'string',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'spread': {
                        'type': 'google.protobuf.BoolValue',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'optional': {
                        'type': 'google.protobuf.BoolValue',
                        'id': 5,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'in': {
                        'type': 'PARAM_URL_LOCATION',
                        'id': 6,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'required': {
                        'type': 'google.protobuf.BoolValue',
                        'id': 7,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'readOnly': {
                        'type': 'google.protobuf.BoolValue',
                        'id': 8,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'nested': {
                      'PARAM_URL_LOCATION': {
                        'values': {
                          'NA': 0,
                          'BODY': 1,
                          'PATH': 2,
                          'QUERY': 3
                        },
                        'comment': null,
                        'comments': {
                          'NA': null,
                          'BODY': null,
                          'PATH': null,
                          'QUERY': null
                        }
                      }
                    },
                    'comment': null
                  },
                  'ReturnValue': {
                    'fields': {
                      'type': {
                        'rule': 'repeated',
                        'type': 'Type',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'doc': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'statusCode': {
                        'type': 'google.protobuf.StringValue',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'UnionType': {
                    'fields': {
                      'type': {
                        'rule': 'repeated',
                        'type': 'Type',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'ComplexType': {
                    'oneofs': {
                      'type': {
                        'oneof': [
                          'nativeType',
                          'referenceType'
                        ],
                        'comment': null
                      }
                    },
                    'fields': {
                      'nativeType': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'referenceType': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'typeParams': {
                        'rule': 'repeated',
                        'type': 'TypeParameter',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'displayName': {
                        'type': 'google.protobuf.StringValue',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'TypeParameter': {
                    'oneofs': {
                      'type': {
                        'oneof': [
                          'nativeType',
                          'referenceType',
                          'complexType',
                          'unionType'
                        ],
                        'comment': null
                      }
                    },
                    'fields': {
                      'nativeType': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'referenceType': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'complexType': {
                        'type': 'ComplexType',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'unionType': {
                        'type': 'UnionType',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'key': {
                        'type': 'google.protobuf.BoolValue',
                        'id': 5,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'displayName': {
                        'type': 'google.protobuf.StringValue',
                        'id': 6,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'Type': {
                    'oneofs': {
                      'type': {
                        'oneof': [
                          'nativeType',
                          'referenceType',
                          'complexType'
                        ],
                        'comment': null
                      }
                    },
                    'fields': {
                      'nativeType': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'referenceType': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'complexType': {
                        'type': 'ComplexType',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'displayName': {
                        'type': 'google.protobuf.StringValue',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'CustomLabel': {
                    'fields': {
                      'id': {
                        'type': 'google.protobuf.StringValue',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'values': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'DynamicCustomLabel': {
                    'fields': {
                      'color': {
                        'type': 'google.protobuf.StringValue',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'name': {
                        'type': 'google.protobuf.StringValue',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'description': {
                        'type': 'google.protobuf.StringValue',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'Message': {
                    'fields': {
                      'name': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'locations': {
                        'rule': 'repeated',
                        'type': 'CodeLocation',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'docs': {
                        'type': 'Docs',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'members': {
                        'rule': 'repeated',
                        'type': 'Parameter',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'labels': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 5,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'extra': {
                        'type': 'Extra',
                        'id': 6,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'enum': {
                        'rule': 'repeated',
                        'type': 'google.protobuf.StringValue',
                        'id': 7,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'customLabels': {
                        'rule': 'repeated',
                        'type': 'CustomLabel',
                        'id': 8,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'dynamicCustomLabels': {
                        'rule': 'repeated',
                        'type': 'DynamicCustomLabel',
                        'id': 9,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'RelatedContent': {
                    'fields': {
                      'icon': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'text': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'url': {
                        'type': 'string',
                        'id': 3,
                        'options': { '(wix.api.format)': 'URI' },
                        'comment': null,
                        'parsedOptions': [{
                            '(wix.api.format)': 'URI',
                            '__comment': null
                          }]
                      }
                    },
                    'comment': null
                  },
                  'RelatedGuide': {
                    'fields': {
                      'path': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'name': {
                        'type': 'google.protobuf.StringValue',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'tag': {
                        'type': 'google.protobuf.StringValue',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'src': {
                        'type': 'google.protobuf.StringValue',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'FAQ': {
                    'fields': {
                      'title': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'markdown': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'Tag': {
                    'fields': {
                      'name': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'entity': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'OperationsExtra': {
                    'fields': {
                      'hasRest': {
                        'type': 'bool',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'rpcRequestName': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'rpcResponseName': {
                        'type': 'string',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'Permission': {
                    'fields': {
                      'name': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'description': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'Event': {
                    'fields': {
                      'type': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'name': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'docs': {
                        'type': 'Docs',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'topic': {
                        'type': 'string',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'tag': {
                        'type': 'string',
                        'id': 5,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'permissions': {
                        'rule': 'repeated',
                        'type': 'Permission',
                        'id': 6,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'customLabels': {
                        'rule': 'repeated',
                        'type': 'CustomLabel',
                        'id': 7,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'dynamicCustomLabels': {
                        'rule': 'repeated',
                        'type': 'DynamicCustomLabel',
                        'id': 8,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'Entity': {
                    'options': { 'deprecated': true },
                    'fields': {
                      'name': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'type': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'WixDocsService': {
                    'options': { '(wix.api.service_entity).message': 'com.wixpress.wixdocs.Service' },
                    'methods': {
                      'CreateDocs': {
                        'requestType': 'CreateDocsRequest',
                        'responseType': 'CreateDocsResponse',
                        'options': {
                          '(google.api.http).post': '/v1/docs',
                          '(.wix.api.maturity)': 'ALPHA',
                          '(wix.api.required)': 'CreateDocsRequest.service'
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(google.api.http)': { 'post': '/v1/docs' },
                            '__comment': { 'post': null }
                          },
                          {
                            '(.wix.api.maturity)': 'ALPHA',
                            '__comment': null
                          },
                          {
                            '(wix.api.required)': 'CreateDocsRequest.service',
                            '__comment': null
                          }
                        ]
                      },
                      'PartialUpdateDocs': {
                        'requestType': 'PartialUpdateDocsRequest',
                        'responseType': 'PartialUpdateDocsResponse',
                        'options': {
                          '(google.api.http).patch': '/v1/docs/{service.name}',
                          '(.wix.api.maturity)': 'ALPHA',
                          '(wix.api.required)': 'PartialUpdateDocsRequest.service'
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(google.api.http)': { 'patch': '/v1/docs/{service.name}' },
                            '__comment': { 'patch': null }
                          },
                          {
                            '(.wix.api.maturity)': 'ALPHA',
                            '__comment': null
                          },
                          {
                            '(wix.api.required)': 'PartialUpdateDocsRequest.service',
                            '__comment': null
                          }
                        ]
                      },
                      'JsonPreview': {
                        'requestType': 'JsonPreviewRequest',
                        'responseType': 'JsonPreviewResponse',
                        'options': {
                          '(google.api.http).post': '/v1/jsonPreview',
                          '(.wix.api.maturity)': 'ALPHA',
                          '(wix.api.exposure)': 'PRIVATE'
                        },
                        'comment': null,
                        'parsedOptions': [
                          {
                            '(google.api.http)': { 'post': '/v1/jsonPreview' },
                            '__comment': { 'post': null }
                          },
                          {
                            '(.wix.api.maturity)': 'ALPHA',
                            '__comment': null
                          },
                          {
                            '(wix.api.exposure)': 'PRIVATE',
                            '__comment': null
                          }
                        ]
                      }
                    },
                    'comment': null
                  },
                  'CreateDocsRequest': {
                    'fields': {
                      'service': {
                        'type': 'Service',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'wixDocsPortal': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'branchName': {
                        'type': 'string',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'CreateDocsResponse': {
                    'fields': {
                      'previewUrl': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'service': {
                        'type': 'Service',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'PartialUpdateDocsRequest': {
                    'fields': {
                      'service': {
                        'type': 'Service',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'wixDocsPortal': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'branchName': {
                        'type': 'string',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'PartialUpdateDocsResponse': {
                    'fields': {
                      'previewUrl': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'service': {
                        'type': 'Service',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'JsonPreviewRequest': {
                    'fields': {
                      'jsonAsString': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'JsonPreviewResponse': {
                    'fields': {
                      'previewUrl': {
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  }
                }
              }
            }
          }
        }
      },
      'google': {
        'nested': {
          'protobuf': {
            'options': {
              'go_package': 'google.golang.org/protobuf/types/descriptorpb',
              'java_package': 'com.google.protobuf',
              'java_outer_classname': 'DescriptorProtos',
              'csharp_namespace': 'Google.Protobuf.Reflection',
              'objc_class_prefix': 'GPB',
              'cc_enable_arenas': true,
              'optimize_for': 'SPEED'
            },
            'nested': {
              'DoubleValue': {
                'fields': {
                  'value': {
                    'type': 'double',
                    'id': 1
                  }
                },
                'comment': null
              },
              'FloatValue': {
                'fields': {
                  'value': {
                    'type': 'float',
                    'id': 1
                  }
                },
                'comment': null
              },
              'Int64Value': {
                'fields': {
                  'value': {
                    'type': 'int64',
                    'id': 1
                  }
                },
                'comment': null
              },
              'UInt64Value': {
                'fields': {
                  'value': {
                    'type': 'uint64',
                    'id': 1
                  }
                },
                'comment': null
              },
              'Int32Value': {
                'fields': {
                  'value': {
                    'type': 'int32',
                    'id': 1
                  }
                },
                'comment': null
              },
              'UInt32Value': {
                'fields': {
                  'value': {
                    'type': 'uint32',
                    'id': 1
                  }
                },
                'comment': null
              },
              'BoolValue': {
                'fields': {
                  'value': {
                    'type': 'bool',
                    'id': 1
                  }
                },
                'comment': null
              },
              'StringValue': {
                'fields': {
                  'value': {
                    'type': 'string',
                    'id': 1
                  }
                },
                'comment': null
              },
              'BytesValue': {
                'fields': {
                  'value': {
                    'type': 'bytes',
                    'id': 1
                  }
                },
                'comment': null
              },
              'FileDescriptorSet': {
                'fields': {
                  'file': {
                    'rule': 'repeated',
                    'type': 'FileDescriptorProto',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'FileDescriptorProto': {
                'fields': {
                  'name': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'package': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'dependency': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'publicDependency': {
                    'rule': 'repeated',
                    'type': 'int32',
                    'id': 10,
                    'options': { 'packed': false },
                    'comment': null,
                    'parsedOptions': null
                  },
                  'weakDependency': {
                    'rule': 'repeated',
                    'type': 'int32',
                    'id': 11,
                    'options': { 'packed': false },
                    'comment': null,
                    'parsedOptions': null
                  },
                  'messageType': {
                    'rule': 'repeated',
                    'type': 'DescriptorProto',
                    'id': 4,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'enumType': {
                    'rule': 'repeated',
                    'type': 'EnumDescriptorProto',
                    'id': 5,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'service': {
                    'rule': 'repeated',
                    'type': 'ServiceDescriptorProto',
                    'id': 6,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'extension': {
                    'rule': 'repeated',
                    'type': 'FieldDescriptorProto',
                    'id': 7,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'options': {
                    'type': 'FileOptions',
                    'id': 8,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'sourceCodeInfo': {
                    'type': 'SourceCodeInfo',
                    'id': 9,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'syntax': {
                    'type': 'string',
                    'id': 12,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'DescriptorProto': {
                'fields': {
                  'name': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'field': {
                    'rule': 'repeated',
                    'type': 'FieldDescriptorProto',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'extension': {
                    'rule': 'repeated',
                    'type': 'FieldDescriptorProto',
                    'id': 6,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'nestedType': {
                    'rule': 'repeated',
                    'type': 'DescriptorProto',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'enumType': {
                    'rule': 'repeated',
                    'type': 'EnumDescriptorProto',
                    'id': 4,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'extensionRange': {
                    'rule': 'repeated',
                    'type': 'ExtensionRange',
                    'id': 5,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'oneofDecl': {
                    'rule': 'repeated',
                    'type': 'OneofDescriptorProto',
                    'id': 8,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'options': {
                    'type': 'MessageOptions',
                    'id': 7,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'reservedRange': {
                    'rule': 'repeated',
                    'type': 'ReservedRange',
                    'id': 9,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'reservedName': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 10,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'nested': {
                  'ExtensionRange': {
                    'fields': {
                      'start': {
                        'type': 'int32',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'end': {
                        'type': 'int32',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'options': {
                        'type': 'ExtensionRangeOptions',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  },
                  'ReservedRange': {
                    'fields': {
                      'start': {
                        'type': 'int32',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'end': {
                        'type': 'int32',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  }
                },
                'comment': null
              },
              'ExtensionRangeOptions': {
                'fields': {
                  'uninterpretedOption': {
                    'rule': 'repeated',
                    'type': 'UninterpretedOption',
                    'id': 999,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'extensions': [[
                    1000,
                    536870911
                  ]],
                'comment': null
              },
              'FieldDescriptorProto': {
                'fields': {
                  'name': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'number': {
                    'type': 'int32',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'label': {
                    'type': 'Label',
                    'id': 4,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'type': {
                    'type': 'Type',
                    'id': 5,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'typeName': {
                    'type': 'string',
                    'id': 6,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'extendee': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'defaultValue': {
                    'type': 'string',
                    'id': 7,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'oneofIndex': {
                    'type': 'int32',
                    'id': 9,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'jsonName': {
                    'type': 'string',
                    'id': 10,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'options': {
                    'type': 'FieldOptions',
                    'id': 8,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'proto3Optional': {
                    'type': 'bool',
                    'id': 17,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'nested': {
                  'Type': {
                    'values': {
                      'TYPE_DOUBLE': 1,
                      'TYPE_FLOAT': 2,
                      'TYPE_INT64': 3,
                      'TYPE_UINT64': 4,
                      'TYPE_INT32': 5,
                      'TYPE_FIXED64': 6,
                      'TYPE_FIXED32': 7,
                      'TYPE_BOOL': 8,
                      'TYPE_STRING': 9,
                      'TYPE_GROUP': 10,
                      'TYPE_MESSAGE': 11,
                      'TYPE_BYTES': 12,
                      'TYPE_UINT32': 13,
                      'TYPE_ENUM': 14,
                      'TYPE_SFIXED32': 15,
                      'TYPE_SFIXED64': 16,
                      'TYPE_SINT32': 17,
                      'TYPE_SINT64': 18
                    },
                    'comment': null,
                    'comments': {
                      'TYPE_DOUBLE': null,
                      'TYPE_FLOAT': null,
                      'TYPE_INT64': null,
                      'TYPE_UINT64': null,
                      'TYPE_INT32': null,
                      'TYPE_FIXED64': null,
                      'TYPE_FIXED32': null,
                      'TYPE_BOOL': null,
                      'TYPE_STRING': null,
                      'TYPE_GROUP': null,
                      'TYPE_MESSAGE': null,
                      'TYPE_BYTES': null,
                      'TYPE_UINT32': null,
                      'TYPE_ENUM': null,
                      'TYPE_SFIXED32': null,
                      'TYPE_SFIXED64': null,
                      'TYPE_SINT32': null,
                      'TYPE_SINT64': null
                    }
                  },
                  'Label': {
                    'values': {
                      'LABEL_OPTIONAL': 1,
                      'LABEL_REQUIRED': 2,
                      'LABEL_REPEATED': 3
                    },
                    'comment': null,
                    'comments': {
                      'LABEL_OPTIONAL': null,
                      'LABEL_REQUIRED': null,
                      'LABEL_REPEATED': null
                    }
                  }
                },
                'comment': null
              },
              'OneofDescriptorProto': {
                'fields': {
                  'name': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'options': {
                    'type': 'OneofOptions',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'EnumDescriptorProto': {
                'fields': {
                  'name': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'value': {
                    'rule': 'repeated',
                    'type': 'EnumValueDescriptorProto',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'options': {
                    'type': 'EnumOptions',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'reservedRange': {
                    'rule': 'repeated',
                    'type': 'EnumReservedRange',
                    'id': 4,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'reservedName': {
                    'rule': 'repeated',
                    'type': 'string',
                    'id': 5,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'nested': {
                  'EnumReservedRange': {
                    'fields': {
                      'start': {
                        'type': 'int32',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'end': {
                        'type': 'int32',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  }
                },
                'comment': null
              },
              'EnumValueDescriptorProto': {
                'fields': {
                  'name': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'number': {
                    'type': 'int32',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'options': {
                    'type': 'EnumValueOptions',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'ServiceDescriptorProto': {
                'fields': {
                  'name': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'method': {
                    'rule': 'repeated',
                    'type': 'MethodDescriptorProto',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'options': {
                    'type': 'ServiceOptions',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'MethodDescriptorProto': {
                'fields': {
                  'name': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'inputType': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'outputType': {
                    'type': 'string',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'options': {
                    'type': 'MethodOptions',
                    'id': 4,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'clientStreaming': {
                    'type': 'bool',
                    'id': 5,
                    'options': { 'default': false },
                    'comment': null,
                    'parsedOptions': [{
                        'default': false,
                        '__comment': null
                      }]
                  },
                  'serverStreaming': {
                    'type': 'bool',
                    'id': 6,
                    'options': { 'default': false },
                    'comment': null,
                    'parsedOptions': [{
                        'default': false,
                        '__comment': null
                      }]
                  }
                },
                'comment': null
              },
              'FileOptions': {
                'fields': {
                  'javaPackage': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'javaOuterClassname': {
                    'type': 'string',
                    'id': 8,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'javaMultipleFiles': {
                    'type': 'bool',
                    'id': 10,
                    'options': { 'default': false },
                    'comment': null,
                    'parsedOptions': [{
                        'default': false,
                        '__comment': null
                      }]
                  },
                  'javaGenerateEqualsAndHash': {
                    'type': 'bool',
                    'id': 20,
                    'options': { 'deprecated': true },
                    'comment': null,
                    'parsedOptions': [{
                        'deprecated': true,
                        '__comment': null
                      }]
                  },
                  'javaStringCheckUtf8': {
                    'type': 'bool',
                    'id': 27,
                    'options': { 'default': false },
                    'comment': null,
                    'parsedOptions': [{
                        'default': false,
                        '__comment': null
                      }]
                  },
                  'optimizeFor': {
                    'type': 'OptimizeMode',
                    'id': 9,
                    'options': { 'default': 'SPEED' },
                    'comment': null,
                    'parsedOptions': [{
                        'default': 'SPEED',
                        '__comment': null
                      }]
                  },
                  'goPackage': {
                    'type': 'string',
                    'id': 11,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'ccGenericServices': {
                    'type': 'bool',
                    'id': 16,
                    'options': { 'default': false },
                    'comment': null,
                    'parsedOptions': [{
                        'default': false,
                        '__comment': null
                      }]
                  },
                  'javaGenericServices': {
                    'type': 'bool',
                    'id': 17,
                    'options': { 'default': false },
                    'comment': null,
                    'parsedOptions': [{
                        'default': false,
                        '__comment': null
                      }]
                  },
                  'pyGenericServices': {
                    'type': 'bool',
                    'id': 18,
                    'options': { 'default': false },
                    'comment': null,
                    'parsedOptions': [{
                        'default': false,
                        '__comment': null
                      }]
                  },
                  'phpGenericServices': {
                    'type': 'bool',
                    'id': 42,
                    'options': { 'default': false },
                    'comment': null,
                    'parsedOptions': [{
                        'default': false,
                        '__comment': null
                      }]
                  },
                  'deprecated': {
                    'type': 'bool',
                    'id': 23,
                    'options': { 'default': false },
                    'comment': null,
                    'parsedOptions': [{
                        'default': false,
                        '__comment': null
                      }]
                  },
                  'ccEnableArenas': {
                    'type': 'bool',
                    'id': 31,
                    'options': { 'default': true },
                    'comment': null,
                    'parsedOptions': [{
                        'default': true,
                        '__comment': null
                      }]
                  },
                  'objcClassPrefix': {
                    'type': 'string',
                    'id': 36,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'csharpNamespace': {
                    'type': 'string',
                    'id': 37,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'swiftPrefix': {
                    'type': 'string',
                    'id': 39,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'phpClassPrefix': {
                    'type': 'string',
                    'id': 40,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'phpNamespace': {
                    'type': 'string',
                    'id': 41,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'phpMetadataNamespace': {
                    'type': 'string',
                    'id': 44,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'rubyPackage': {
                    'type': 'string',
                    'id': 45,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'uninterpretedOption': {
                    'rule': 'repeated',
                    'type': 'UninterpretedOption',
                    'id': 999,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'extensions': [[
                    1000,
                    536870911
                  ]],
                'reserved': [[
                    38,
                    38
                  ]],
                'nested': {
                  'OptimizeMode': {
                    'values': {
                      'SPEED': 1,
                      'CODE_SIZE': 2,
                      'LITE_RUNTIME': 3
                    },
                    'comment': null,
                    'comments': {
                      'SPEED': null,
                      'CODE_SIZE': null,
                      'LITE_RUNTIME': null
                    }
                  }
                },
                'comment': null
              },
              'MessageOptions': {
                'fields': {
                  'messageSetWireFormat': {
                    'type': 'bool',
                    'id': 1,
                    'options': { 'default': false },
                    'comment': null,
                    'parsedOptions': [{
                        'default': false,
                        '__comment': null
                      }]
                  },
                  'noStandardDescriptorAccessor': {
                    'type': 'bool',
                    'id': 2,
                    'options': { 'default': false },
                    'comment': null,
                    'parsedOptions': [{
                        'default': false,
                        '__comment': null
                      }]
                  },
                  'deprecated': {
                    'type': 'bool',
                    'id': 3,
                    'options': { 'default': false },
                    'comment': null,
                    'parsedOptions': [{
                        'default': false,
                        '__comment': null
                      }]
                  },
                  'mapEntry': {
                    'type': 'bool',
                    'id': 7,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'uninterpretedOption': {
                    'rule': 'repeated',
                    'type': 'UninterpretedOption',
                    'id': 999,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'extensions': [[
                    1000,
                    536870911
                  ]],
                'reserved': [
                  [
                    4,
                    4
                  ],
                  [
                    5,
                    5
                  ],
                  [
                    6,
                    6
                  ],
                  [
                    8,
                    8
                  ],
                  [
                    9,
                    9
                  ]
                ],
                'comment': null
              },
              'FieldOptions': {
                'fields': {
                  'ctype': {
                    'type': 'CType',
                    'id': 1,
                    'options': { 'default': 'STRING' },
                    'comment': null,
                    'parsedOptions': [{
                        'default': 'STRING',
                        '__comment': null
                      }]
                  },
                  'packed': {
                    'type': 'bool',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'jstype': {
                    'type': 'JSType',
                    'id': 6,
                    'options': { 'default': 'JS_NORMAL' },
                    'comment': null,
                    'parsedOptions': [{
                        'default': 'JS_NORMAL',
                        '__comment': null
                      }]
                  },
                  'lazy': {
                    'type': 'bool',
                    'id': 5,
                    'options': { 'default': false },
                    'comment': null,
                    'parsedOptions': [{
                        'default': false,
                        '__comment': null
                      }]
                  },
                  'deprecated': {
                    'type': 'bool',
                    'id': 3,
                    'options': { 'default': false },
                    'comment': null,
                    'parsedOptions': [{
                        'default': false,
                        '__comment': null
                      }]
                  },
                  'weak': {
                    'type': 'bool',
                    'id': 10,
                    'options': { 'default': false },
                    'comment': null,
                    'parsedOptions': [{
                        'default': false,
                        '__comment': null
                      }]
                  },
                  'uninterpretedOption': {
                    'rule': 'repeated',
                    'type': 'UninterpretedOption',
                    'id': 999,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'extensions': [[
                    1000,
                    536870911
                  ]],
                'reserved': [[
                    4,
                    4
                  ]],
                'nested': {
                  'CType': {
                    'values': {
                      'STRING': 0,
                      'CORD': 1,
                      'STRING_PIECE': 2
                    },
                    'comment': null,
                    'comments': {
                      'STRING': null,
                      'CORD': null,
                      'STRING_PIECE': null
                    }
                  },
                  'JSType': {
                    'values': {
                      'JS_NORMAL': 0,
                      'JS_STRING': 1,
                      'JS_NUMBER': 2
                    },
                    'comment': null,
                    'comments': {
                      'JS_NORMAL': null,
                      'JS_STRING': null,
                      'JS_NUMBER': null
                    }
                  }
                },
                'comment': null
              },
              'OneofOptions': {
                'fields': {
                  'uninterpretedOption': {
                    'rule': 'repeated',
                    'type': 'UninterpretedOption',
                    'id': 999,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'extensions': [[
                    1000,
                    536870911
                  ]],
                'comment': null
              },
              'EnumOptions': {
                'fields': {
                  'allowAlias': {
                    'type': 'bool',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'deprecated': {
                    'type': 'bool',
                    'id': 3,
                    'options': { 'default': false },
                    'comment': null,
                    'parsedOptions': [{
                        'default': false,
                        '__comment': null
                      }]
                  },
                  'uninterpretedOption': {
                    'rule': 'repeated',
                    'type': 'UninterpretedOption',
                    'id': 999,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'extensions': [[
                    1000,
                    536870911
                  ]],
                'reserved': [[
                    5,
                    5
                  ]],
                'comment': null
              },
              'EnumValueOptions': {
                'fields': {
                  'deprecated': {
                    'type': 'bool',
                    'id': 1,
                    'options': { 'default': false },
                    'comment': null,
                    'parsedOptions': [{
                        'default': false,
                        '__comment': null
                      }]
                  },
                  'uninterpretedOption': {
                    'rule': 'repeated',
                    'type': 'UninterpretedOption',
                    'id': 999,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'extensions': [[
                    1000,
                    536870911
                  ]],
                'comment': null
              },
              'ServiceOptions': {
                'fields': {
                  'deprecated': {
                    'type': 'bool',
                    'id': 33,
                    'options': { 'default': false },
                    'comment': null,
                    'parsedOptions': [{
                        'default': false,
                        '__comment': null
                      }]
                  },
                  'uninterpretedOption': {
                    'rule': 'repeated',
                    'type': 'UninterpretedOption',
                    'id': 999,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'extensions': [[
                    1000,
                    536870911
                  ]],
                'comment': null
              },
              'MethodOptions': {
                'fields': {
                  'deprecated': {
                    'type': 'bool',
                    'id': 33,
                    'options': { 'default': false },
                    'comment': null,
                    'parsedOptions': [{
                        'default': false,
                        '__comment': null
                      }]
                  },
                  'idempotencyLevel': {
                    'type': 'IdempotencyLevel',
                    'id': 34,
                    'options': { 'default': 'IDEMPOTENCY_UNKNOWN' },
                    'comment': null,
                    'parsedOptions': [{
                        'default': 'IDEMPOTENCY_UNKNOWN',
                        '__comment': null
                      }]
                  },
                  'uninterpretedOption': {
                    'rule': 'repeated',
                    'type': 'UninterpretedOption',
                    'id': 999,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'extensions': [[
                    1000,
                    536870911
                  ]],
                'nested': {
                  'IdempotencyLevel': {
                    'values': {
                      'IDEMPOTENCY_UNKNOWN': 0,
                      'NO_SIDE_EFFECTS': 1,
                      'IDEMPOTENT': 2
                    },
                    'comment': null,
                    'comments': {
                      'IDEMPOTENCY_UNKNOWN': null,
                      'NO_SIDE_EFFECTS': null,
                      'IDEMPOTENT': null
                    }
                  }
                },
                'comment': null
              },
              'UninterpretedOption': {
                'fields': {
                  'name': {
                    'rule': 'repeated',
                    'type': 'NamePart',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'identifierValue': {
                    'type': 'string',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'positiveIntValue': {
                    'type': 'uint64',
                    'id': 4,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'negativeIntValue': {
                    'type': 'int64',
                    'id': 5,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'doubleValue': {
                    'type': 'double',
                    'id': 6,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'stringValue': {
                    'type': 'bytes',
                    'id': 7,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'aggregateValue': {
                    'type': 'string',
                    'id': 8,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'nested': {
                  'NamePart': {
                    'fields': {
                      'namePart': {
                        'rule': 'required',
                        'type': 'string',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'isExtension': {
                        'rule': 'required',
                        'type': 'bool',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  }
                },
                'comment': null
              },
              'SourceCodeInfo': {
                'fields': {
                  'location': {
                    'rule': 'repeated',
                    'type': 'Location',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'nested': {
                  'Location': {
                    'fields': {
                      'path': {
                        'rule': 'repeated',
                        'type': 'int32',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': [{
                            'packed': true,
                            '__comment': null
                          }]
                      },
                      'span': {
                        'rule': 'repeated',
                        'type': 'int32',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': [{
                            'packed': true,
                            '__comment': null
                          }]
                      },
                      'leadingComments': {
                        'type': 'string',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'trailingComments': {
                        'type': 'string',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'leadingDetachedComments': {
                        'rule': 'repeated',
                        'type': 'string',
                        'id': 6,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  }
                },
                'comment': null
              },
              'GeneratedCodeInfo': {
                'fields': {
                  'annotation': {
                    'rule': 'repeated',
                    'type': 'Annotation',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'nested': {
                  'Annotation': {
                    'fields': {
                      'path': {
                        'rule': 'repeated',
                        'type': 'int32',
                        'id': 1,
                        'comment': null,
                        'parsedOptions': [{
                            'packed': true,
                            '__comment': null
                          }]
                      },
                      'sourceFile': {
                        'type': 'string',
                        'id': 2,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'begin': {
                        'type': 'int32',
                        'id': 3,
                        'comment': null,
                        'parsedOptions': null
                      },
                      'end': {
                        'type': 'int32',
                        'id': 4,
                        'comment': null,
                        'parsedOptions': null
                      }
                    },
                    'comment': null
                  }
                },
                'comment': null
              },
              'Struct': {
                'fields': {
                  'fields': {
                    'keyType': 'string',
                    'type': 'Value',
                    'id': 1
                  }
                },
                'comment': null
              },
              'Value': {
                'oneofs': {
                  'kind': {
                    'oneof': [
                      'nullValue',
                      'numberValue',
                      'stringValue',
                      'boolValue',
                      'structValue',
                      'listValue'
                    ]
                  }
                },
                'fields': {
                  'nullValue': {
                    'type': 'NullValue',
                    'id': 1
                  },
                  'numberValue': {
                    'type': 'double',
                    'id': 2
                  },
                  'stringValue': {
                    'type': 'string',
                    'id': 3
                  },
                  'boolValue': {
                    'type': 'bool',
                    'id': 4
                  },
                  'structValue': {
                    'type': 'Struct',
                    'id': 5
                  },
                  'listValue': {
                    'type': 'ListValue',
                    'id': 6
                  }
                },
                'comment': null
              },
              'NullValue': {
                'values': { 'NULL_VALUE': 0 },
                'comments': {}
              },
              'ListValue': {
                'fields': {
                  'values': {
                    'rule': 'repeated',
                    'type': 'Value',
                    'id': 1
                  }
                },
                'comment': null
              },
              'Timestamp': {
                'fields': {
                  'seconds': {
                    'type': 'int64',
                    'id': 1
                  },
                  'nanos': {
                    'type': 'int32',
                    'id': 2
                  }
                },
                'comment': null
              },
              'Empty': {
                'fields': {},
                'comment': null
              }
            }
          },
          'api': {
            'options': {
              'go_package': 'google.golang.org/genproto/googleapis/api/annotations;annotations',
              'java_multiple_files': true,
              'java_outer_classname': 'HttpProto',
              'java_package': 'com.google.api',
              'objc_class_prefix': 'GAPI',
              'cc_enable_arenas': true
            },
            'nested': {
              'http': {
                'type': 'HttpRule',
                'id': 72295728,
                'extend': 'google.protobuf.MethodOptions',
                'comment': null,
                'parsedOptions': null
              },
              'Http': {
                'fields': {
                  'rules': {
                    'rule': 'repeated',
                    'type': 'HttpRule',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'HttpRule': {
                'oneofs': {
                  'pattern': {
                    'oneof': [
                      'get',
                      'put',
                      'post',
                      'delete',
                      'patch',
                      'custom'
                    ],
                    'comment': null
                  }
                },
                'fields': {
                  'selector': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'get': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'put': {
                    'type': 'string',
                    'id': 3,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'post': {
                    'type': 'string',
                    'id': 4,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'delete': {
                    'type': 'string',
                    'id': 5,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'patch': {
                    'type': 'string',
                    'id': 6,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'custom': {
                    'type': 'CustomHttpPattern',
                    'id': 8,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'body': {
                    'type': 'string',
                    'id': 7,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'additionalBindings': {
                    'rule': 'repeated',
                    'type': 'HttpRule',
                    'id': 11,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              },
              'CustomHttpPattern': {
                'fields': {
                  'kind': {
                    'type': 'string',
                    'id': 1,
                    'comment': null,
                    'parsedOptions': null
                  },
                  'path': {
                    'type': 'string',
                    'id': 2,
                    'comment': null,
                    'parsedOptions': null
                  }
                },
                'comment': null
              }
            }
          }
        }
      }
    }
  });
  $root.__lookup = function () {
    return path => {
      return root.lookup(path);
    };
  };
  return $root.__lookup();
};
$root.wix = (function () {
  const _wix = {};
  _wix.common = (function () {
    const _common = {};
    _common.Address = (function () {
      class Address {
        constructor(props) {
          this.country = props && props.country;
          this.subdivision = props && props.subdivision;
          this.city = props && props.city;
          this.postalCode = props && props.postalCode;
          this.streetAddress = props && props.streetAddress;
          this.addressLine = props && props.addressLine;
          this.addressLine_2 = props && props.addressLine_2;
          this.formattedAddress = props && props.formattedAddress;
          this.hint = props && props.hint;
          this.geocode = props && props.geocode;
          this.countryFullname = props && props.countryFullname;
          this.subdivisionFullname = props && props.subdivisionFullname;
          this.subdivisions = props && props.subdivisions;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['country'] != null) {
              json['country'] = $root.google.protobuf.StringValue.toJSON(obj['country'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['country'];
            }
            if (obj['subdivision'] != null) {
              json['subdivision'] = $root.google.protobuf.StringValue.toJSON(obj['subdivision'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['subdivision'];
            }
            if (obj['city'] != null) {
              json['city'] = $root.google.protobuf.StringValue.toJSON(obj['city'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['city'];
            }
            if (obj['postalCode'] != null) {
              json['postalCode'] = $root.google.protobuf.StringValue.toJSON(obj['postalCode'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['postalCode'];
            }
            if (obj['streetAddress'] != null) {
              json['streetAddress'] = $root.wix.common.StreetAddress.toJSON(obj['streetAddress'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['streetAddress'];
            }
            if (obj['addressLine'] != null) {
              json['addressLine'] = $root.google.protobuf.StringValue.toJSON(obj['addressLine'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['addressLine'];
            }
            if (obj['addressLine_2'] != null) {
              json['addressLine_2'] = $root.google.protobuf.StringValue.toJSON(obj['addressLine_2'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['addressLine_2'];
            }
            if (obj['formattedAddress'] != null) {
              json['formattedAddress'] = $root.google.protobuf.StringValue.toJSON(obj['formattedAddress'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['formattedAddress'];
            }
            if (obj['hint'] != null) {
              json['hint'] = $root.google.protobuf.StringValue.toJSON(obj['hint'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['hint'];
            }
            if (obj['geocode'] != null) {
              json['geocode'] = $root.wix.common.AddressLocation.toJSON(obj['geocode'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['geocode'];
            }
            if (obj['countryFullname'] != null) {
              json['countryFullname'] = $root.google.protobuf.StringValue.toJSON(obj['countryFullname'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['countryFullname'];
            }
            if (obj['subdivisionFullname'] != null) {
              json['subdivisionFullname'] = $root.google.protobuf.StringValue.toJSON(obj['subdivisionFullname'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['subdivisionFullname'];
            }
            if (obj['subdivisions'] != null) {
              json['subdivisions'] = obj['subdivisions'].map(e => {
                return $root.wix.common.Subdivision.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['subdivisions'] = [];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.Address();
            if (json['country'] != null) {
              result['country'] = $root.google.protobuf.StringValue.fromJSON(json['country'], helper);
            } else if (withDefaults !== false) {
              delete result['country'];
            } else {
              delete result['country'];
            }
            if (json['subdivision'] != null) {
              result['subdivision'] = $root.google.protobuf.StringValue.fromJSON(json['subdivision'], helper);
            } else if (withDefaults !== false) {
              delete result['subdivision'];
            } else {
              delete result['subdivision'];
            }
            if (json['city'] != null) {
              result['city'] = $root.google.protobuf.StringValue.fromJSON(json['city'], helper);
            } else if (withDefaults !== false) {
              delete result['city'];
            } else {
              delete result['city'];
            }
            if (json['postalCode'] != null) {
              result['postalCode'] = $root.google.protobuf.StringValue.fromJSON(json['postalCode'], helper);
            } else if (withDefaults !== false) {
              delete result['postalCode'];
            } else {
              delete result['postalCode'];
            }
            if (json['streetAddress'] != null) {
              result['streetAddress'] = $root.wix.common.StreetAddress.fromJSON(json['streetAddress'], helper);
            } else if (withDefaults !== false) {
              delete result['streetAddress'];
            } else {
              delete result['streetAddress'];
            }
            if (json['addressLine'] != null) {
              result['addressLine'] = $root.google.protobuf.StringValue.fromJSON(json['addressLine'], helper);
            } else if (withDefaults !== false) {
              delete result['addressLine'];
            } else {
              delete result['addressLine'];
            }
            if (json['addressLine_2'] != null) {
              result['addressLine_2'] = $root.google.protobuf.StringValue.fromJSON(json['addressLine_2'], helper);
            } else if (withDefaults !== false) {
              delete result['addressLine_2'];
            } else {
              delete result['addressLine_2'];
            }
            if (json['formattedAddress'] != null) {
              result['formattedAddress'] = $root.google.protobuf.StringValue.fromJSON(json['formattedAddress'], helper);
            } else if (withDefaults !== false) {
              delete result['formattedAddress'];
            } else {
              delete result['formattedAddress'];
            }
            if (json['hint'] != null) {
              result['hint'] = $root.google.protobuf.StringValue.fromJSON(json['hint'], helper);
            } else if (withDefaults !== false) {
              delete result['hint'];
            } else {
              delete result['hint'];
            }
            if (json['geocode'] != null) {
              result['geocode'] = $root.wix.common.AddressLocation.fromJSON(json['geocode'], helper);
            } else if (withDefaults !== false) {
              delete result['geocode'];
            } else {
              delete result['geocode'];
            }
            if (json['countryFullname'] != null) {
              result['countryFullname'] = $root.google.protobuf.StringValue.fromJSON(json['countryFullname'], helper);
            } else if (withDefaults !== false) {
              delete result['countryFullname'];
            } else {
              delete result['countryFullname'];
            }
            if (json['subdivisionFullname'] != null) {
              result['subdivisionFullname'] = $root.google.protobuf.StringValue.fromJSON(json['subdivisionFullname'], helper);
            } else if (withDefaults !== false) {
              delete result['subdivisionFullname'];
            } else {
              delete result['subdivisionFullname'];
            }
            if (json['subdivisions'] != null) {
              result['subdivisions'] = Array.isArray(json['subdivisions']) ? json['subdivisions'].map(e => {
                return $root.wix.common.Subdivision.fromJSON(e, helper);
              }) : json['subdivisions'];
            } else if (withDefaults !== false) {
              result['subdivisions'] = [];
            } else {
              delete result['subdivisions'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['country'] != null) {
              grpc['country'] = $root.google.protobuf.StringValue.toGRPC(obj['country'], helper);
            }
            if (obj['subdivision'] != null) {
              grpc['subdivision'] = $root.google.protobuf.StringValue.toGRPC(obj['subdivision'], helper);
            }
            if (obj['city'] != null) {
              grpc['city'] = $root.google.protobuf.StringValue.toGRPC(obj['city'], helper);
            }
            if (obj['postalCode'] != null) {
              grpc['postalCode'] = $root.google.protobuf.StringValue.toGRPC(obj['postalCode'], helper);
            }
            if (obj['streetAddress'] != null) {
              grpc['streetAddress'] = $root.wix.common.StreetAddress.toGRPC(obj['streetAddress'], helper);
            }
            if (obj['addressLine'] != null) {
              grpc['addressLine'] = $root.google.protobuf.StringValue.toGRPC(obj['addressLine'], helper);
            }
            if (obj['addressLine_2'] != null) {
              grpc['addressLine_2'] = $root.google.protobuf.StringValue.toGRPC(obj['addressLine_2'], helper);
            }
            if (obj['formattedAddress'] != null) {
              grpc['formattedAddress'] = $root.google.protobuf.StringValue.toGRPC(obj['formattedAddress'], helper);
            }
            if (obj['hint'] != null) {
              grpc['hint'] = $root.google.protobuf.StringValue.toGRPC(obj['hint'], helper);
            }
            if (obj['geocode'] != null) {
              grpc['geocode'] = $root.wix.common.AddressLocation.toGRPC(obj['geocode'], helper);
            }
            if (obj['countryFullname'] != null) {
              grpc['countryFullname'] = $root.google.protobuf.StringValue.toGRPC(obj['countryFullname'], helper);
            }
            if (obj['subdivisionFullname'] != null) {
              grpc['subdivisionFullname'] = $root.google.protobuf.StringValue.toGRPC(obj['subdivisionFullname'], helper);
            }
            if (obj['subdivisions'] != null) {
              grpc['subdivisions'] = obj['subdivisions'].map(e => {
                return $root.wix.common.Subdivision.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.Address();
            if (grpc['country'] != null) {
              result['country'] = $root.google.protobuf.StringValue.fromGRPC(grpc['country'], helper);
            } else {
              delete result['country'];
            }
            if (grpc['subdivision'] != null) {
              result['subdivision'] = $root.google.protobuf.StringValue.fromGRPC(grpc['subdivision'], helper);
            } else {
              delete result['subdivision'];
            }
            if (grpc['city'] != null) {
              result['city'] = $root.google.protobuf.StringValue.fromGRPC(grpc['city'], helper);
            } else {
              delete result['city'];
            }
            if (grpc['postalCode'] != null) {
              result['postalCode'] = $root.google.protobuf.StringValue.fromGRPC(grpc['postalCode'], helper);
            } else {
              delete result['postalCode'];
            }
            if (grpc['streetAddress'] != null) {
              result['streetAddress'] = $root.wix.common.StreetAddress.fromGRPC(grpc['streetAddress'], helper);
            } else {
              delete result['streetAddress'];
            }
            if (grpc['addressLine'] != null) {
              result['addressLine'] = $root.google.protobuf.StringValue.fromGRPC(grpc['addressLine'], helper);
            } else {
              delete result['addressLine'];
            }
            if (grpc['addressLine_2'] != null) {
              result['addressLine_2'] = $root.google.protobuf.StringValue.fromGRPC(grpc['addressLine_2'], helper);
            } else {
              delete result['addressLine_2'];
            }
            if (grpc['formattedAddress'] != null) {
              result['formattedAddress'] = $root.google.protobuf.StringValue.fromGRPC(grpc['formattedAddress'], helper);
            } else {
              delete result['formattedAddress'];
            }
            if (grpc['hint'] != null) {
              result['hint'] = $root.google.protobuf.StringValue.fromGRPC(grpc['hint'], helper);
            } else {
              delete result['hint'];
            }
            if (grpc['geocode'] != null) {
              result['geocode'] = $root.wix.common.AddressLocation.fromGRPC(grpc['geocode'], helper);
            } else {
              delete result['geocode'];
            }
            if (grpc['countryFullname'] != null) {
              result['countryFullname'] = $root.google.protobuf.StringValue.fromGRPC(grpc['countryFullname'], helper);
            } else {
              delete result['countryFullname'];
            }
            if (grpc['subdivisionFullname'] != null) {
              result['subdivisionFullname'] = $root.google.protobuf.StringValue.fromGRPC(grpc['subdivisionFullname'], helper);
            } else {
              delete result['subdivisionFullname'];
            }
            if (grpc['subdivisions'] != null) {
              result['subdivisions'] = grpc['subdivisions'].map(e => {
                return $root.wix.common.Subdivision.fromGRPC(e, helper);
              });
            } else {
              result['subdivisions'] = [];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(Address.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.Address');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Address.prototype, '__fqn__', {
        value: 'wix.common.Address',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Address.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Address.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Address;
    }());;
    _common.Subdivision = (function () {
      class Subdivision {
        constructor(props) {
          this.code = props && props.code;
          this.name = props && props.name;
          this.type = props && props.type;
          this.typeInfo = props && props.typeInfo;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['code'] != null) {
              json['code'] = obj['code'];
            } else if (withDefaults) {
              json['code'] = '';
            }
            if (obj['name'] != null) {
              json['name'] = obj['name'];
            } else if (withDefaults) {
              json['name'] = '';
            }
            if (obj['type'] != null) {
              json['type'] = $root.wix.common.Subdivision.SubdivisionType[obj['type']];
            } else if (withDefaults) {
              json['type'] = 'UNKNOWN_SUBDIVISION_TYPE';
            }
            if (obj['typeInfo'] != null) {
              json['typeInfo'] = $root.google.protobuf.StringValue.toJSON(obj['typeInfo'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['typeInfo'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.Subdivision();
            if (json['code'] != null) {
              result['code'] = json['code'];
            } else if (withDefaults !== false) {
              result['code'] = '';
            } else {
              delete result['code'];
            }
            if (json['name'] != null) {
              result['name'] = json['name'];
            } else if (withDefaults !== false) {
              result['name'] = '';
            } else {
              delete result['name'];
            }
            if (json['type'] != null) {
              result['type'] = typeof json['type'] === 'string' ? json['type'] : $root.wix.common.Subdivision.SubdivisionType[json['type']];
            } else if (withDefaults !== false) {
              result['type'] = 'UNKNOWN_SUBDIVISION_TYPE';
            } else {
              delete result['type'];
            }
            if (json['typeInfo'] != null) {
              result['typeInfo'] = $root.google.protobuf.StringValue.fromJSON(json['typeInfo'], helper);
            } else if (withDefaults !== false) {
              delete result['typeInfo'];
            } else {
              delete result['typeInfo'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['code'] != null) {
              grpc['code'] = obj['code'];
            }
            if (obj['name'] != null) {
              grpc['name'] = obj['name'];
            }
            if (obj['type'] != null) {
              grpc['type'] = obj['type'];
            }
            if (obj['typeInfo'] != null) {
              grpc['typeInfo'] = $root.google.protobuf.StringValue.toGRPC(obj['typeInfo'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.Subdivision();
            if (grpc['code'] != null) {
              result['code'] = grpc['code'];
            } else {
              result['code'] = '';
            }
            if (grpc['name'] != null) {
              result['name'] = grpc['name'];
            } else {
              result['name'] = '';
            }
            if (grpc['type'] != null) {
              result['type'] = grpc['type'];
            } else {
              result['type'] = 'UNKNOWN_SUBDIVISION_TYPE';
            }
            if (grpc['typeInfo'] != null) {
              result['typeInfo'] = $root.google.protobuf.StringValue.fromGRPC(grpc['typeInfo'], helper);
            } else {
              delete result['typeInfo'];
            }
            return result;
          }
        }
      }
      Subdivision.SubdivisionType = {
        'UNKNOWN_SUBDIVISION_TYPE': 'UNKNOWN_SUBDIVISION_TYPE',
        0: 'UNKNOWN_SUBDIVISION_TYPE',
        'ADMINISTRATIVE_AREA_LEVEL_1': 'ADMINISTRATIVE_AREA_LEVEL_1',
        1: 'ADMINISTRATIVE_AREA_LEVEL_1',
        'ADMINISTRATIVE_AREA_LEVEL_2': 'ADMINISTRATIVE_AREA_LEVEL_2',
        2: 'ADMINISTRATIVE_AREA_LEVEL_2',
        'ADMINISTRATIVE_AREA_LEVEL_3': 'ADMINISTRATIVE_AREA_LEVEL_3',
        3: 'ADMINISTRATIVE_AREA_LEVEL_3',
        'ADMINISTRATIVE_AREA_LEVEL_4': 'ADMINISTRATIVE_AREA_LEVEL_4',
        4: 'ADMINISTRATIVE_AREA_LEVEL_4',
        'ADMINISTRATIVE_AREA_LEVEL_5': 'ADMINISTRATIVE_AREA_LEVEL_5',
        5: 'ADMINISTRATIVE_AREA_LEVEL_5',
        'COUNTRY': 'COUNTRY',
        6: 'COUNTRY'
      };
      Subdivision.SubdivisionType = {
        'UNKNOWN_SUBDIVISION_TYPE': 'UNKNOWN_SUBDIVISION_TYPE',
        0: 'UNKNOWN_SUBDIVISION_TYPE',
        'ADMINISTRATIVE_AREA_LEVEL_1': 'ADMINISTRATIVE_AREA_LEVEL_1',
        1: 'ADMINISTRATIVE_AREA_LEVEL_1',
        'ADMINISTRATIVE_AREA_LEVEL_2': 'ADMINISTRATIVE_AREA_LEVEL_2',
        2: 'ADMINISTRATIVE_AREA_LEVEL_2',
        'ADMINISTRATIVE_AREA_LEVEL_3': 'ADMINISTRATIVE_AREA_LEVEL_3',
        3: 'ADMINISTRATIVE_AREA_LEVEL_3',
        'ADMINISTRATIVE_AREA_LEVEL_4': 'ADMINISTRATIVE_AREA_LEVEL_4',
        4: 'ADMINISTRATIVE_AREA_LEVEL_4',
        'ADMINISTRATIVE_AREA_LEVEL_5': 'ADMINISTRATIVE_AREA_LEVEL_5',
        5: 'ADMINISTRATIVE_AREA_LEVEL_5',
        'COUNTRY': 'COUNTRY',
        6: 'COUNTRY'
      };
      __builtIn.Object.defineProperty(Subdivision.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.Subdivision');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Subdivision.prototype, '__fqn__', {
        value: 'wix.common.Subdivision',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Subdivision.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Subdivision.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Subdivision;
    }());;
    _common.StreetAddress = (function () {
      class StreetAddress {
        constructor(props) {
          this.number = props && props.number;
          this.name = props && props.name;
          this.apt = props && props.apt;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['number'] != null) {
              json['number'] = obj['number'];
            } else if (withDefaults) {
              json['number'] = '';
            }
            if (obj['name'] != null) {
              json['name'] = obj['name'];
            } else if (withDefaults) {
              json['name'] = '';
            }
            if (obj['apt'] != null) {
              json['apt'] = obj['apt'];
            } else if (withDefaults) {
              json['apt'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.StreetAddress();
            if (json['number'] != null) {
              result['number'] = json['number'];
            } else if (withDefaults !== false) {
              result['number'] = '';
            } else {
              delete result['number'];
            }
            if (json['name'] != null) {
              result['name'] = json['name'];
            } else if (withDefaults !== false) {
              result['name'] = '';
            } else {
              delete result['name'];
            }
            if (json['apt'] != null) {
              result['apt'] = json['apt'];
            } else if (withDefaults !== false) {
              result['apt'] = '';
            } else {
              delete result['apt'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['number'] != null) {
              grpc['number'] = obj['number'];
            }
            if (obj['name'] != null) {
              grpc['name'] = obj['name'];
            }
            if (obj['apt'] != null) {
              grpc['apt'] = obj['apt'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.StreetAddress();
            if (grpc['number'] != null) {
              result['number'] = grpc['number'];
            } else {
              result['number'] = '';
            }
            if (grpc['name'] != null) {
              result['name'] = grpc['name'];
            } else {
              result['name'] = '';
            }
            if (grpc['apt'] != null) {
              result['apt'] = grpc['apt'];
            } else {
              result['apt'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(StreetAddress.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.StreetAddress');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(StreetAddress.prototype, '__fqn__', {
        value: 'wix.common.StreetAddress',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(StreetAddress.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(StreetAddress.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return StreetAddress;
    }());;
    _common.AddressContactDetails = (function () {
      class AddressContactDetails {
        constructor(props) {
          this.fullName = props && props.fullName;
          this.phone = props && props.phone;
          this.company = props && props.company;
          this.email = props && props.email;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['fullName'] != null) {
              json['fullName'] = $root.google.protobuf.StringValue.toJSON(obj['fullName'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['fullName'];
            }
            if (obj['phone'] != null) {
              json['phone'] = $root.google.protobuf.StringValue.toJSON(obj['phone'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['phone'];
            }
            if (obj['company'] != null) {
              json['company'] = $root.google.protobuf.StringValue.toJSON(obj['company'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['company'];
            }
            if (obj['email'] != null) {
              json['email'] = $root.google.protobuf.StringValue.toJSON(obj['email'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['email'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.AddressContactDetails();
            if (json['fullName'] != null) {
              result['fullName'] = $root.google.protobuf.StringValue.fromJSON(json['fullName'], helper);
            } else if (withDefaults !== false) {
              delete result['fullName'];
            } else {
              delete result['fullName'];
            }
            if (json['phone'] != null) {
              result['phone'] = $root.google.protobuf.StringValue.fromJSON(json['phone'], helper);
            } else if (withDefaults !== false) {
              delete result['phone'];
            } else {
              delete result['phone'];
            }
            if (json['company'] != null) {
              result['company'] = $root.google.protobuf.StringValue.fromJSON(json['company'], helper);
            } else if (withDefaults !== false) {
              delete result['company'];
            } else {
              delete result['company'];
            }
            if (json['email'] != null) {
              result['email'] = $root.google.protobuf.StringValue.fromJSON(json['email'], helper);
            } else if (withDefaults !== false) {
              delete result['email'];
            } else {
              delete result['email'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['fullName'] != null) {
              grpc['fullName'] = $root.google.protobuf.StringValue.toGRPC(obj['fullName'], helper);
            }
            if (obj['phone'] != null) {
              grpc['phone'] = $root.google.protobuf.StringValue.toGRPC(obj['phone'], helper);
            }
            if (obj['company'] != null) {
              grpc['company'] = $root.google.protobuf.StringValue.toGRPC(obj['company'], helper);
            }
            if (obj['email'] != null) {
              grpc['email'] = $root.google.protobuf.StringValue.toGRPC(obj['email'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.AddressContactDetails();
            if (grpc['fullName'] != null) {
              result['fullName'] = $root.google.protobuf.StringValue.fromGRPC(grpc['fullName'], helper);
            } else {
              delete result['fullName'];
            }
            if (grpc['phone'] != null) {
              result['phone'] = $root.google.protobuf.StringValue.fromGRPC(grpc['phone'], helper);
            } else {
              delete result['phone'];
            }
            if (grpc['company'] != null) {
              result['company'] = $root.google.protobuf.StringValue.fromGRPC(grpc['company'], helper);
            } else {
              delete result['company'];
            }
            if (grpc['email'] != null) {
              result['email'] = $root.google.protobuf.StringValue.fromGRPC(grpc['email'], helper);
            } else {
              delete result['email'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(AddressContactDetails.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.AddressContactDetails');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(AddressContactDetails.prototype, '__fqn__', {
        value: 'wix.common.AddressContactDetails',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(AddressContactDetails.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(AddressContactDetails.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return AddressContactDetails;
    }());;
    _common.FullAddressContactDetails = (function () {
      class FullAddressContactDetails {
        constructor(props) {
          this.firstName = props && props.firstName;
          this.lastName = props && props.lastName;
          this.fullName = props && props.fullName;
          this.phone = props && props.phone;
          this.company = props && props.company;
          this.email = props && props.email;
          this.vatId = props && props.vatId;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['firstName'] != null) {
              json['firstName'] = $root.google.protobuf.StringValue.toJSON(obj['firstName'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['firstName'];
            }
            if (obj['lastName'] != null) {
              json['lastName'] = $root.google.protobuf.StringValue.toJSON(obj['lastName'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['lastName'];
            }
            if (obj['fullName'] != null) {
              json['fullName'] = $root.google.protobuf.StringValue.toJSON(obj['fullName'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['fullName'];
            }
            if (obj['phone'] != null) {
              json['phone'] = $root.google.protobuf.StringValue.toJSON(obj['phone'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['phone'];
            }
            if (obj['company'] != null) {
              json['company'] = $root.google.protobuf.StringValue.toJSON(obj['company'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['company'];
            }
            if (obj['email'] != null) {
              json['email'] = $root.google.protobuf.StringValue.toJSON(obj['email'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['email'];
            }
            if (obj['vatId'] != null) {
              json['vatId'] = $root.wix.common.VatId.toJSON(obj['vatId'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['vatId'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.FullAddressContactDetails();
            if (json['firstName'] != null) {
              result['firstName'] = $root.google.protobuf.StringValue.fromJSON(json['firstName'], helper);
            } else if (withDefaults !== false) {
              delete result['firstName'];
            } else {
              delete result['firstName'];
            }
            if (json['lastName'] != null) {
              result['lastName'] = $root.google.protobuf.StringValue.fromJSON(json['lastName'], helper);
            } else if (withDefaults !== false) {
              delete result['lastName'];
            } else {
              delete result['lastName'];
            }
            if (json['fullName'] != null) {
              result['fullName'] = $root.google.protobuf.StringValue.fromJSON(json['fullName'], helper);
            } else if (withDefaults !== false) {
              delete result['fullName'];
            } else {
              delete result['fullName'];
            }
            if (json['phone'] != null) {
              result['phone'] = $root.google.protobuf.StringValue.fromJSON(json['phone'], helper);
            } else if (withDefaults !== false) {
              delete result['phone'];
            } else {
              delete result['phone'];
            }
            if (json['company'] != null) {
              result['company'] = $root.google.protobuf.StringValue.fromJSON(json['company'], helper);
            } else if (withDefaults !== false) {
              delete result['company'];
            } else {
              delete result['company'];
            }
            if (json['email'] != null) {
              result['email'] = $root.google.protobuf.StringValue.fromJSON(json['email'], helper);
            } else if (withDefaults !== false) {
              delete result['email'];
            } else {
              delete result['email'];
            }
            if (json['vatId'] != null) {
              result['vatId'] = $root.wix.common.VatId.fromJSON(json['vatId'], helper);
            } else if (withDefaults !== false) {
              delete result['vatId'];
            } else {
              delete result['vatId'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['firstName'] != null) {
              grpc['firstName'] = $root.google.protobuf.StringValue.toGRPC(obj['firstName'], helper);
            }
            if (obj['lastName'] != null) {
              grpc['lastName'] = $root.google.protobuf.StringValue.toGRPC(obj['lastName'], helper);
            }
            if (obj['fullName'] != null) {
              grpc['fullName'] = $root.google.protobuf.StringValue.toGRPC(obj['fullName'], helper);
            }
            if (obj['phone'] != null) {
              grpc['phone'] = $root.google.protobuf.StringValue.toGRPC(obj['phone'], helper);
            }
            if (obj['company'] != null) {
              grpc['company'] = $root.google.protobuf.StringValue.toGRPC(obj['company'], helper);
            }
            if (obj['email'] != null) {
              grpc['email'] = $root.google.protobuf.StringValue.toGRPC(obj['email'], helper);
            }
            if (obj['vatId'] != null) {
              grpc['vatId'] = $root.wix.common.VatId.toGRPC(obj['vatId'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.FullAddressContactDetails();
            if (grpc['firstName'] != null) {
              result['firstName'] = $root.google.protobuf.StringValue.fromGRPC(grpc['firstName'], helper);
            } else {
              delete result['firstName'];
            }
            if (grpc['lastName'] != null) {
              result['lastName'] = $root.google.protobuf.StringValue.fromGRPC(grpc['lastName'], helper);
            } else {
              delete result['lastName'];
            }
            if (grpc['fullName'] != null) {
              result['fullName'] = $root.google.protobuf.StringValue.fromGRPC(grpc['fullName'], helper);
            } else {
              delete result['fullName'];
            }
            if (grpc['phone'] != null) {
              result['phone'] = $root.google.protobuf.StringValue.fromGRPC(grpc['phone'], helper);
            } else {
              delete result['phone'];
            }
            if (grpc['company'] != null) {
              result['company'] = $root.google.protobuf.StringValue.fromGRPC(grpc['company'], helper);
            } else {
              delete result['company'];
            }
            if (grpc['email'] != null) {
              result['email'] = $root.google.protobuf.StringValue.fromGRPC(grpc['email'], helper);
            } else {
              delete result['email'];
            }
            if (grpc['vatId'] != null) {
              result['vatId'] = $root.wix.common.VatId.fromGRPC(grpc['vatId'], helper);
            } else {
              delete result['vatId'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(FullAddressContactDetails.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.FullAddressContactDetails');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FullAddressContactDetails.prototype, '__fqn__', {
        value: 'wix.common.FullAddressContactDetails',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FullAddressContactDetails.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FullAddressContactDetails.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return FullAddressContactDetails;
    }());;
    _common.VatId = (function () {
      class VatId {
        constructor(props) {
          this.id = props && props.id;
          this.type = props && props.type;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['id'] != null) {
              json['id'] = obj['id'];
            } else if (withDefaults) {
              json['id'] = '';
            }
            if (obj['type'] != null) {
              json['type'] = $root.wix.common.VatType[obj['type']];
            } else if (withDefaults) {
              json['type'] = 'UNSPECIFIED';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.VatId();
            if (json['id'] != null) {
              result['id'] = json['id'];
            } else if (withDefaults !== false) {
              result['id'] = '';
            } else {
              delete result['id'];
            }
            if (json['type'] != null) {
              result['type'] = typeof json['type'] === 'string' ? json['type'] : $root.wix.common.VatType[json['type']];
            } else if (withDefaults !== false) {
              result['type'] = 'UNSPECIFIED';
            } else {
              delete result['type'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['id'] != null) {
              grpc['id'] = obj['id'];
            }
            if (obj['type'] != null) {
              grpc['type'] = obj['type'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.VatId();
            if (grpc['id'] != null) {
              result['id'] = grpc['id'];
            } else {
              result['id'] = '';
            }
            if (grpc['type'] != null) {
              result['type'] = grpc['type'];
            } else {
              result['type'] = 'UNSPECIFIED';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(VatId.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.VatId');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(VatId.prototype, '__fqn__', {
        value: 'wix.common.VatId',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(VatId.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(VatId.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return VatId;
    }());;
    _common.VatType = {
      'UNSPECIFIED': 'UNSPECIFIED',
      0: 'UNSPECIFIED',
      'CPF': 'CPF',
      1: 'CPF',
      'CNPJ': 'CNPJ',
      2: 'CNPJ'
    };
    _common.AddressLocation = (function () {
      class AddressLocation {
        constructor(props) {
          this.latitude = props && props.latitude;
          this.longitude = props && props.longitude;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['latitude'] != null) {
              json['latitude'] = $root.google.protobuf.DoubleValue.toJSON(obj['latitude'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['latitude'];
            }
            if (obj['longitude'] != null) {
              json['longitude'] = $root.google.protobuf.DoubleValue.toJSON(obj['longitude'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['longitude'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.AddressLocation();
            if (json['latitude'] != null) {
              result['latitude'] = $root.google.protobuf.DoubleValue.fromJSON(json['latitude'], helper);
            } else if (withDefaults !== false) {
              delete result['latitude'];
            } else {
              delete result['latitude'];
            }
            if (json['longitude'] != null) {
              result['longitude'] = $root.google.protobuf.DoubleValue.fromJSON(json['longitude'], helper);
            } else if (withDefaults !== false) {
              delete result['longitude'];
            } else {
              delete result['longitude'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['latitude'] != null) {
              grpc['latitude'] = $root.google.protobuf.DoubleValue.toGRPC(obj['latitude'], helper);
            }
            if (obj['longitude'] != null) {
              grpc['longitude'] = $root.google.protobuf.DoubleValue.toGRPC(obj['longitude'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.AddressLocation();
            if (grpc['latitude'] != null) {
              result['latitude'] = $root.google.protobuf.DoubleValue.fromGRPC(grpc['latitude'], helper);
            } else {
              delete result['latitude'];
            }
            if (grpc['longitude'] != null) {
              result['longitude'] = $root.google.protobuf.DoubleValue.fromGRPC(grpc['longitude'], helper);
            } else {
              delete result['longitude'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(AddressLocation.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.AddressLocation');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(AddressLocation.prototype, '__fqn__', {
        value: 'wix.common.AddressLocation',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(AddressLocation.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(AddressLocation.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return AddressLocation;
    }());;
    _common.BulkActionMetadata = (function () {
      class BulkActionMetadata {
        constructor(props) {
          this.totalSuccesses = props && props.totalSuccesses;
          this.totalFailures = props && props.totalFailures;
          this.undetailedFailures = props && props.undetailedFailures;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['totalSuccesses'] != null) {
              json['totalSuccesses'] = obj['totalSuccesses'];
            } else if (withDefaults) {
              json['totalSuccesses'] = 0;
            }
            if (obj['totalFailures'] != null) {
              json['totalFailures'] = obj['totalFailures'];
            } else if (withDefaults) {
              json['totalFailures'] = 0;
            }
            if (obj['undetailedFailures'] != null) {
              json['undetailedFailures'] = obj['undetailedFailures'];
            } else if (withDefaults) {
              json['undetailedFailures'] = 0;
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.BulkActionMetadata();
            if (json['totalSuccesses'] != null) {
              result['totalSuccesses'] = json['totalSuccesses'];
            } else if (withDefaults !== false) {
              result['totalSuccesses'] = 0;
            } else {
              delete result['totalSuccesses'];
            }
            if (json['totalFailures'] != null) {
              result['totalFailures'] = json['totalFailures'];
            } else if (withDefaults !== false) {
              result['totalFailures'] = 0;
            } else {
              delete result['totalFailures'];
            }
            if (json['undetailedFailures'] != null) {
              result['undetailedFailures'] = json['undetailedFailures'];
            } else if (withDefaults !== false) {
              result['undetailedFailures'] = 0;
            } else {
              delete result['undetailedFailures'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['totalSuccesses'] != null) {
              grpc['totalSuccesses'] = obj['totalSuccesses'];
            }
            if (obj['totalFailures'] != null) {
              grpc['totalFailures'] = obj['totalFailures'];
            }
            if (obj['undetailedFailures'] != null) {
              grpc['undetailedFailures'] = obj['undetailedFailures'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.BulkActionMetadata();
            if (grpc['totalSuccesses'] != null) {
              result['totalSuccesses'] = grpc['totalSuccesses'];
            } else {
              result['totalSuccesses'] = 0;
            }
            if (grpc['totalFailures'] != null) {
              result['totalFailures'] = grpc['totalFailures'];
            } else {
              result['totalFailures'] = 0;
            }
            if (grpc['undetailedFailures'] != null) {
              result['undetailedFailures'] = grpc['undetailedFailures'];
            } else {
              result['undetailedFailures'] = 0;
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(BulkActionMetadata.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.BulkActionMetadata');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkActionMetadata.prototype, '__fqn__', {
        value: 'wix.common.BulkActionMetadata',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkActionMetadata.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkActionMetadata.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return BulkActionMetadata;
    }());;
    _common.ItemMetadata = (function () {
      class ItemMetadata {
        constructor(props) {
          this.id = props && props.id;
          this.originalIndex = props && props.originalIndex;
          this.success = props && props.success;
          this.error = props && props.error;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['id'] != null) {
              json['id'] = $root.google.protobuf.StringValue.toJSON(obj['id'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['id'];
            }
            if (obj['originalIndex'] != null) {
              json['originalIndex'] = obj['originalIndex'];
            } else if (withDefaults) {
              json['originalIndex'] = 0;
            }
            if (obj['success'] != null) {
              json['success'] = obj['success'];
            } else if (withDefaults) {
              json['success'] = false;
            }
            if (obj['error'] != null) {
              json['error'] = $root.wix.api.ApplicationError.toJSON(obj['error'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['error'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.ItemMetadata();
            if (json['id'] != null) {
              result['id'] = $root.google.protobuf.StringValue.fromJSON(json['id'], helper);
            } else if (withDefaults !== false) {
              delete result['id'];
            } else {
              delete result['id'];
            }
            if (json['originalIndex'] != null) {
              result['originalIndex'] = json['originalIndex'];
            } else if (withDefaults !== false) {
              result['originalIndex'] = 0;
            } else {
              delete result['originalIndex'];
            }
            if (json['success'] != null) {
              result['success'] = json['success'];
            } else if (withDefaults !== false) {
              result['success'] = false;
            } else {
              delete result['success'];
            }
            if (json['error'] != null) {
              result['error'] = $root.wix.api.ApplicationError.fromJSON(json['error'], helper);
            } else if (withDefaults !== false) {
              delete result['error'];
            } else {
              delete result['error'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['id'] != null) {
              grpc['id'] = $root.google.protobuf.StringValue.toGRPC(obj['id'], helper);
            }
            if (obj['originalIndex'] != null) {
              grpc['originalIndex'] = obj['originalIndex'];
            }
            if (obj['success'] != null) {
              grpc['success'] = obj['success'];
            }
            if (obj['error'] != null) {
              grpc['error'] = $root.wix.api.ApplicationError.toGRPC(obj['error'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.ItemMetadata();
            if (grpc['id'] != null) {
              result['id'] = $root.google.protobuf.StringValue.fromGRPC(grpc['id'], helper);
            } else {
              delete result['id'];
            }
            if (grpc['originalIndex'] != null) {
              result['originalIndex'] = grpc['originalIndex'];
            } else {
              result['originalIndex'] = 0;
            }
            if (grpc['success'] != null) {
              result['success'] = grpc['success'];
            } else {
              result['success'] = false;
            }
            if (grpc['error'] != null) {
              result['error'] = $root.wix.api.ApplicationError.fromGRPC(grpc['error'], helper);
            } else {
              delete result['error'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(ItemMetadata.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.ItemMetadata');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ItemMetadata.prototype, '__fqn__', {
        value: 'wix.common.ItemMetadata',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ItemMetadata.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ItemMetadata.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return ItemMetadata;
    }());;
    _common.BulkActionType = {
      'UNKNOWN_ACTION_TYPE': 'UNKNOWN_ACTION_TYPE',
      0: 'UNKNOWN_ACTION_TYPE',
      'INSERT': 'INSERT',
      1: 'INSERT',
      'UPDATE': 'UPDATE',
      2: 'UPDATE',
      'DELETE': 'DELETE',
      3: 'DELETE'
    };
    _common.IdentificationData = (function () {
      class IdentificationData {
        constructor(props) {
          this.contactId = props && props.contactId;
          this.anonymousVisitorId = props && props.anonymousVisitorId;
          this.memberId = props && props.memberId;
          this.wixUserId = props && props.wixUserId;
          this.appId = props && props.appId;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['contactId'] != null) {
              json['contactId'] = $root.google.protobuf.StringValue.toJSON(obj['contactId'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['contactId'];
            }
            if (obj['anonymousVisitorId'] != null) {
              json['anonymousVisitorId'] = obj['anonymousVisitorId'];
            } else if (withDefaults) {
              delete json['anonymousVisitorId'];
            }
            if (obj['memberId'] != null) {
              json['memberId'] = obj['memberId'];
            } else if (withDefaults) {
              delete json['memberId'];
            }
            if (obj['wixUserId'] != null) {
              json['wixUserId'] = obj['wixUserId'];
            } else if (withDefaults) {
              delete json['wixUserId'];
            }
            if (obj['appId'] != null) {
              json['appId'] = obj['appId'];
            } else if (withDefaults) {
              delete json['appId'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.IdentificationData();
            if (json['contactId'] != null) {
              result['contactId'] = $root.google.protobuf.StringValue.fromJSON(json['contactId'], helper);
            } else if (withDefaults !== false) {
              delete result['contactId'];
            } else {
              delete result['contactId'];
            }
            if (json['anonymousVisitorId'] != null) {
              result['anonymousVisitorId'] = json['anonymousVisitorId'];
            } else if (withDefaults !== false) {
              delete result['anonymousVisitorId'];
            } else {
              delete result['anonymousVisitorId'];
            }
            if (json['memberId'] != null) {
              result['memberId'] = json['memberId'];
            } else if (withDefaults !== false) {
              delete result['memberId'];
            } else {
              delete result['memberId'];
            }
            if (json['wixUserId'] != null) {
              result['wixUserId'] = json['wixUserId'];
            } else if (withDefaults !== false) {
              delete result['wixUserId'];
            } else {
              delete result['wixUserId'];
            }
            if (json['appId'] != null) {
              result['appId'] = json['appId'];
            } else if (withDefaults !== false) {
              delete result['appId'];
            } else {
              delete result['appId'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['contactId'] != null) {
              grpc['contactId'] = $root.google.protobuf.StringValue.toGRPC(obj['contactId'], helper);
            }
            if (obj['anonymousVisitorId'] != null) {
              grpc['anonymousVisitorId'] = obj['anonymousVisitorId'];
            }
            if (obj['memberId'] != null) {
              grpc['memberId'] = obj['memberId'];
            }
            if (obj['wixUserId'] != null) {
              grpc['wixUserId'] = obj['wixUserId'];
            }
            if (obj['appId'] != null) {
              grpc['appId'] = obj['appId'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.IdentificationData();
            if (grpc['contactId'] != null) {
              result['contactId'] = $root.google.protobuf.StringValue.fromGRPC(grpc['contactId'], helper);
            } else {
              delete result['contactId'];
            }
            if (grpc['anonymousVisitorId'] != null) {
              result['anonymousVisitorId'] = grpc['anonymousVisitorId'];
            } else {
              delete result['anonymousVisitorId'];
            }
            if (grpc['memberId'] != null) {
              result['memberId'] = grpc['memberId'];
            } else {
              delete result['memberId'];
            }
            if (grpc['wixUserId'] != null) {
              result['wixUserId'] = grpc['wixUserId'];
            } else {
              delete result['wixUserId'];
            }
            if (grpc['appId'] != null) {
              result['appId'] = grpc['appId'];
            } else {
              delete result['appId'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(IdentificationData.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.IdentificationData');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(IdentificationData.prototype, '__fqn__', {
        value: 'wix.common.IdentificationData',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(IdentificationData.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(IdentificationData.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return IdentificationData;
    }());;
    _common.Image = (function () {
      class Image {
        constructor(props) {
          this.id = props && props.id;
          this.url = props && props.url;
          this.height = props && props.height;
          this.width = props && props.width;
          this.altText = props && props.altText;
          this.urlExpirationDate = props && props.urlExpirationDate;
          this.filename = props && props.filename;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['id'] != null) {
              json['id'] = obj['id'];
            } else if (withDefaults) {
              json['id'] = '';
            }
            if (obj['url'] != null) {
              json['url'] = obj['url'];
            } else if (withDefaults) {
              json['url'] = '';
            }
            if (obj['height'] != null) {
              json['height'] = obj['height'];
            } else if (withDefaults) {
              json['height'] = 0;
            }
            if (obj['width'] != null) {
              json['width'] = obj['width'];
            } else if (withDefaults) {
              json['width'] = 0;
            }
            if (obj['altText'] != null) {
              json['altText'] = $root.google.protobuf.StringValue.toJSON(obj['altText'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['altText'];
            }
            if (obj['urlExpirationDate'] != null) {
              json['urlExpirationDate'] = $root.google.protobuf.Timestamp.toJSON(obj['urlExpirationDate'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['urlExpirationDate'];
            }
            if (obj['filename'] != null) {
              json['filename'] = $root.google.protobuf.StringValue.toJSON(obj['filename'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['filename'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.Image();
            if (json['id'] != null) {
              result['id'] = json['id'];
            } else if (withDefaults !== false) {
              result['id'] = '';
            } else {
              delete result['id'];
            }
            if (json['url'] != null) {
              result['url'] = json['url'];
            } else if (withDefaults !== false) {
              result['url'] = '';
            } else {
              delete result['url'];
            }
            if (json['height'] != null) {
              result['height'] = json['height'];
            } else if (withDefaults !== false) {
              result['height'] = 0;
            } else {
              delete result['height'];
            }
            if (json['width'] != null) {
              result['width'] = json['width'];
            } else if (withDefaults !== false) {
              result['width'] = 0;
            } else {
              delete result['width'];
            }
            if (json['altText'] != null) {
              result['altText'] = $root.google.protobuf.StringValue.fromJSON(json['altText'], helper);
            } else if (withDefaults !== false) {
              delete result['altText'];
            } else {
              delete result['altText'];
            }
            if (json['urlExpirationDate'] != null) {
              result['urlExpirationDate'] = $root.google.protobuf.Timestamp.fromJSON(json['urlExpirationDate'], helper);
            } else if (withDefaults !== false) {
              delete result['urlExpirationDate'];
            } else {
              delete result['urlExpirationDate'];
            }
            if (json['filename'] != null) {
              result['filename'] = $root.google.protobuf.StringValue.fromJSON(json['filename'], helper);
            } else if (withDefaults !== false) {
              delete result['filename'];
            } else {
              delete result['filename'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['id'] != null) {
              grpc['id'] = obj['id'];
            }
            if (obj['url'] != null) {
              grpc['url'] = obj['url'];
            }
            if (obj['height'] != null) {
              grpc['height'] = obj['height'];
            }
            if (obj['width'] != null) {
              grpc['width'] = obj['width'];
            }
            if (obj['altText'] != null) {
              grpc['altText'] = $root.google.protobuf.StringValue.toGRPC(obj['altText'], helper);
            }
            if (obj['urlExpirationDate'] != null) {
              grpc['urlExpirationDate'] = $root.google.protobuf.Timestamp.toGRPC(obj['urlExpirationDate'], helper);
            }
            if (obj['filename'] != null) {
              grpc['filename'] = $root.google.protobuf.StringValue.toGRPC(obj['filename'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.Image();
            if (grpc['id'] != null) {
              result['id'] = grpc['id'];
            } else {
              result['id'] = '';
            }
            if (grpc['url'] != null) {
              result['url'] = grpc['url'];
            } else {
              result['url'] = '';
            }
            if (grpc['height'] != null) {
              result['height'] = grpc['height'];
            } else {
              result['height'] = 0;
            }
            if (grpc['width'] != null) {
              result['width'] = grpc['width'];
            } else {
              result['width'] = 0;
            }
            if (grpc['altText'] != null) {
              result['altText'] = $root.google.protobuf.StringValue.fromGRPC(grpc['altText'], helper);
            } else {
              delete result['altText'];
            }
            if (grpc['urlExpirationDate'] != null) {
              result['urlExpirationDate'] = $root.google.protobuf.Timestamp.fromGRPC(grpc['urlExpirationDate'], helper);
            } else {
              delete result['urlExpirationDate'];
            }
            if (grpc['filename'] != null) {
              result['filename'] = $root.google.protobuf.StringValue.fromGRPC(grpc['filename'], helper);
            } else {
              delete result['filename'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(Image.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.Image');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Image.prototype, '__fqn__', {
        value: 'wix.common.Image',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Image.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Image.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Image;
    }());;
    _common.Video = (function () {
      class Video {
        constructor(props) {
          this.id = props && props.id;
          this.url = props && props.url;
          this.height = props && props.height;
          this.width = props && props.width;
          this.thumbnail = props && props.thumbnail;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['id'] != null) {
              json['id'] = obj['id'];
            } else if (withDefaults) {
              json['id'] = '';
            }
            if (obj['url'] != null) {
              json['url'] = obj['url'];
            } else if (withDefaults) {
              json['url'] = '';
            }
            if (obj['height'] != null) {
              json['height'] = obj['height'];
            } else if (withDefaults) {
              json['height'] = 0;
            }
            if (obj['width'] != null) {
              json['width'] = obj['width'];
            } else if (withDefaults) {
              json['width'] = 0;
            }
            if (obj['thumbnail'] != null) {
              json['thumbnail'] = $root.wix.common.Image.toJSON(obj['thumbnail'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['thumbnail'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.Video();
            if (json['id'] != null) {
              result['id'] = json['id'];
            } else if (withDefaults !== false) {
              result['id'] = '';
            } else {
              delete result['id'];
            }
            if (json['url'] != null) {
              result['url'] = json['url'];
            } else if (withDefaults !== false) {
              result['url'] = '';
            } else {
              delete result['url'];
            }
            if (json['height'] != null) {
              result['height'] = json['height'];
            } else if (withDefaults !== false) {
              result['height'] = 0;
            } else {
              delete result['height'];
            }
            if (json['width'] != null) {
              result['width'] = json['width'];
            } else if (withDefaults !== false) {
              result['width'] = 0;
            } else {
              delete result['width'];
            }
            if (json['thumbnail'] != null) {
              result['thumbnail'] = $root.wix.common.Image.fromJSON(json['thumbnail'], helper);
            } else if (withDefaults !== false) {
              delete result['thumbnail'];
            } else {
              delete result['thumbnail'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['id'] != null) {
              grpc['id'] = obj['id'];
            }
            if (obj['url'] != null) {
              grpc['url'] = obj['url'];
            }
            if (obj['height'] != null) {
              grpc['height'] = obj['height'];
            }
            if (obj['width'] != null) {
              grpc['width'] = obj['width'];
            }
            if (obj['thumbnail'] != null) {
              grpc['thumbnail'] = $root.wix.common.Image.toGRPC(obj['thumbnail'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.Video();
            if (grpc['id'] != null) {
              result['id'] = grpc['id'];
            } else {
              result['id'] = '';
            }
            if (grpc['url'] != null) {
              result['url'] = grpc['url'];
            } else {
              result['url'] = '';
            }
            if (grpc['height'] != null) {
              result['height'] = grpc['height'];
            } else {
              result['height'] = 0;
            }
            if (grpc['width'] != null) {
              result['width'] = grpc['width'];
            } else {
              result['width'] = 0;
            }
            if (grpc['thumbnail'] != null) {
              result['thumbnail'] = $root.wix.common.Image.fromGRPC(grpc['thumbnail'], helper);
            } else {
              delete result['thumbnail'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(Video.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.Video');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Video.prototype, '__fqn__', {
        value: 'wix.common.Video',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Video.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Video.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Video;
    }());;
    _common.VideoV2 = (function () {
      class VideoV2 {
        constructor(props) {
          this.id = props && props.id;
          this.resolutions = props && props.resolutions;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['id'] != null) {
              json['id'] = obj['id'];
            } else if (withDefaults) {
              json['id'] = '';
            }
            if (obj['resolutions'] != null) {
              json['resolutions'] = obj['resolutions'].map(e => {
                return $root.wix.common.VideoResolution.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['resolutions'] = [];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.VideoV2();
            if (json['id'] != null) {
              result['id'] = json['id'];
            } else if (withDefaults !== false) {
              result['id'] = '';
            } else {
              delete result['id'];
            }
            if (json['resolutions'] != null) {
              result['resolutions'] = Array.isArray(json['resolutions']) ? json['resolutions'].map(e => {
                return $root.wix.common.VideoResolution.fromJSON(e, helper);
              }) : json['resolutions'];
            } else if (withDefaults !== false) {
              result['resolutions'] = [];
            } else {
              delete result['resolutions'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['id'] != null) {
              grpc['id'] = obj['id'];
            }
            if (obj['resolutions'] != null) {
              grpc['resolutions'] = obj['resolutions'].map(e => {
                return $root.wix.common.VideoResolution.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.VideoV2();
            if (grpc['id'] != null) {
              result['id'] = grpc['id'];
            } else {
              result['id'] = '';
            }
            if (grpc['resolutions'] != null) {
              result['resolutions'] = grpc['resolutions'].map(e => {
                return $root.wix.common.VideoResolution.fromGRPC(e, helper);
              });
            } else {
              result['resolutions'] = [];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(VideoV2.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.VideoV2');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(VideoV2.prototype, '__fqn__', {
        value: 'wix.common.VideoV2',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(VideoV2.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(VideoV2.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return VideoV2;
    }());;
    _common.VideoResolution = (function () {
      class VideoResolution {
        constructor(props) {
          this.url = props && props.url;
          this.height = props && props.height;
          this.width = props && props.width;
          this.poster = props && props.poster;
          this.format = props && props.format;
          this.urlExpirationDate = props && props.urlExpirationDate;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['url'] != null) {
              json['url'] = obj['url'];
            } else if (withDefaults) {
              json['url'] = '';
            }
            if (obj['height'] != null) {
              json['height'] = obj['height'];
            } else if (withDefaults) {
              json['height'] = 0;
            }
            if (obj['width'] != null) {
              json['width'] = obj['width'];
            } else if (withDefaults) {
              json['width'] = 0;
            }
            if (obj['poster'] != null) {
              json['poster'] = $root.wix.common.Image.toJSON(obj['poster'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['poster'];
            }
            if (obj['format'] != null) {
              json['format'] = obj['format'];
            } else if (withDefaults) {
              json['format'] = '';
            }
            if (obj['urlExpirationDate'] != null) {
              json['urlExpirationDate'] = $root.google.protobuf.Timestamp.toJSON(obj['urlExpirationDate'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['urlExpirationDate'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.VideoResolution();
            if (json['url'] != null) {
              result['url'] = json['url'];
            } else if (withDefaults !== false) {
              result['url'] = '';
            } else {
              delete result['url'];
            }
            if (json['height'] != null) {
              result['height'] = json['height'];
            } else if (withDefaults !== false) {
              result['height'] = 0;
            } else {
              delete result['height'];
            }
            if (json['width'] != null) {
              result['width'] = json['width'];
            } else if (withDefaults !== false) {
              result['width'] = 0;
            } else {
              delete result['width'];
            }
            if (json['poster'] != null) {
              result['poster'] = $root.wix.common.Image.fromJSON(json['poster'], helper);
            } else if (withDefaults !== false) {
              delete result['poster'];
            } else {
              delete result['poster'];
            }
            if (json['format'] != null) {
              result['format'] = json['format'];
            } else if (withDefaults !== false) {
              result['format'] = '';
            } else {
              delete result['format'];
            }
            if (json['urlExpirationDate'] != null) {
              result['urlExpirationDate'] = $root.google.protobuf.Timestamp.fromJSON(json['urlExpirationDate'], helper);
            } else if (withDefaults !== false) {
              delete result['urlExpirationDate'];
            } else {
              delete result['urlExpirationDate'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['url'] != null) {
              grpc['url'] = obj['url'];
            }
            if (obj['height'] != null) {
              grpc['height'] = obj['height'];
            }
            if (obj['width'] != null) {
              grpc['width'] = obj['width'];
            }
            if (obj['poster'] != null) {
              grpc['poster'] = $root.wix.common.Image.toGRPC(obj['poster'], helper);
            }
            if (obj['format'] != null) {
              grpc['format'] = obj['format'];
            }
            if (obj['urlExpirationDate'] != null) {
              grpc['urlExpirationDate'] = $root.google.protobuf.Timestamp.toGRPC(obj['urlExpirationDate'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.VideoResolution();
            if (grpc['url'] != null) {
              result['url'] = grpc['url'];
            } else {
              result['url'] = '';
            }
            if (grpc['height'] != null) {
              result['height'] = grpc['height'];
            } else {
              result['height'] = 0;
            }
            if (grpc['width'] != null) {
              result['width'] = grpc['width'];
            } else {
              result['width'] = 0;
            }
            if (grpc['poster'] != null) {
              result['poster'] = $root.wix.common.Image.fromGRPC(grpc['poster'], helper);
            } else {
              delete result['poster'];
            }
            if (grpc['format'] != null) {
              result['format'] = grpc['format'];
            } else {
              result['format'] = '';
            }
            if (grpc['urlExpirationDate'] != null) {
              result['urlExpirationDate'] = $root.google.protobuf.Timestamp.fromGRPC(grpc['urlExpirationDate'], helper);
            } else {
              delete result['urlExpirationDate'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(VideoResolution.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.VideoResolution');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(VideoResolution.prototype, '__fqn__', {
        value: 'wix.common.VideoResolution',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(VideoResolution.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(VideoResolution.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return VideoResolution;
    }());;
    _common.Audio = (function () {
      class Audio {
        constructor(props) {
          this.id = props && props.id;
          this.url = props && props.url;
          this.urlExpirationDate = props && props.urlExpirationDate;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['id'] != null) {
              json['id'] = obj['id'];
            } else if (withDefaults) {
              json['id'] = '';
            }
            if (obj['url'] != null) {
              json['url'] = obj['url'];
            } else if (withDefaults) {
              json['url'] = '';
            }
            if (obj['urlExpirationDate'] != null) {
              json['urlExpirationDate'] = $root.google.protobuf.Timestamp.toJSON(obj['urlExpirationDate'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['urlExpirationDate'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.Audio();
            if (json['id'] != null) {
              result['id'] = json['id'];
            } else if (withDefaults !== false) {
              result['id'] = '';
            } else {
              delete result['id'];
            }
            if (json['url'] != null) {
              result['url'] = json['url'];
            } else if (withDefaults !== false) {
              result['url'] = '';
            } else {
              delete result['url'];
            }
            if (json['urlExpirationDate'] != null) {
              result['urlExpirationDate'] = $root.google.protobuf.Timestamp.fromJSON(json['urlExpirationDate'], helper);
            } else if (withDefaults !== false) {
              delete result['urlExpirationDate'];
            } else {
              delete result['urlExpirationDate'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['id'] != null) {
              grpc['id'] = obj['id'];
            }
            if (obj['url'] != null) {
              grpc['url'] = obj['url'];
            }
            if (obj['urlExpirationDate'] != null) {
              grpc['urlExpirationDate'] = $root.google.protobuf.Timestamp.toGRPC(obj['urlExpirationDate'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.Audio();
            if (grpc['id'] != null) {
              result['id'] = grpc['id'];
            } else {
              result['id'] = '';
            }
            if (grpc['url'] != null) {
              result['url'] = grpc['url'];
            } else {
              result['url'] = '';
            }
            if (grpc['urlExpirationDate'] != null) {
              result['urlExpirationDate'] = $root.google.protobuf.Timestamp.fromGRPC(grpc['urlExpirationDate'], helper);
            } else {
              delete result['urlExpirationDate'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(Audio.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.Audio');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Audio.prototype, '__fqn__', {
        value: 'wix.common.Audio',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Audio.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Audio.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Audio;
    }());;
    _common.Document = (function () {
      class Document {
        constructor(props) {
          this.id = props && props.id;
          this.url = props && props.url;
          this.urlExpirationDate = props && props.urlExpirationDate;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['id'] != null) {
              json['id'] = obj['id'];
            } else if (withDefaults) {
              json['id'] = '';
            }
            if (obj['url'] != null) {
              json['url'] = obj['url'];
            } else if (withDefaults) {
              json['url'] = '';
            }
            if (obj['urlExpirationDate'] != null) {
              json['urlExpirationDate'] = $root.google.protobuf.Timestamp.toJSON(obj['urlExpirationDate'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['urlExpirationDate'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.Document();
            if (json['id'] != null) {
              result['id'] = json['id'];
            } else if (withDefaults !== false) {
              result['id'] = '';
            } else {
              delete result['id'];
            }
            if (json['url'] != null) {
              result['url'] = json['url'];
            } else if (withDefaults !== false) {
              result['url'] = '';
            } else {
              delete result['url'];
            }
            if (json['urlExpirationDate'] != null) {
              result['urlExpirationDate'] = $root.google.protobuf.Timestamp.fromJSON(json['urlExpirationDate'], helper);
            } else if (withDefaults !== false) {
              delete result['urlExpirationDate'];
            } else {
              delete result['urlExpirationDate'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['id'] != null) {
              grpc['id'] = obj['id'];
            }
            if (obj['url'] != null) {
              grpc['url'] = obj['url'];
            }
            if (obj['urlExpirationDate'] != null) {
              grpc['urlExpirationDate'] = $root.google.protobuf.Timestamp.toGRPC(obj['urlExpirationDate'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.Document();
            if (grpc['id'] != null) {
              result['id'] = grpc['id'];
            } else {
              result['id'] = '';
            }
            if (grpc['url'] != null) {
              result['url'] = grpc['url'];
            } else {
              result['url'] = '';
            }
            if (grpc['urlExpirationDate'] != null) {
              result['urlExpirationDate'] = $root.google.protobuf.Timestamp.fromGRPC(grpc['urlExpirationDate'], helper);
            } else {
              delete result['urlExpirationDate'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(Document.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.Document');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Document.prototype, '__fqn__', {
        value: 'wix.common.Document',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Document.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Document.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Document;
    }());;
    _common.MediaItem = (function () {
      class MediaItem {
        constructor(props) {
          this.image = props && props.image;
          this.video = props && props.video;
          this.document = props && props.document;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['image'] != null) {
              json['image'] = $root.wix.common.Image.toJSON(obj['image'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['image'];
            }
            if (obj['video'] != null) {
              json['video'] = $root.wix.common.Video.toJSON(obj['video'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['video'];
            }
            if (obj['document'] != null) {
              json['document'] = $root.wix.common.Document.toJSON(obj['document'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['document'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.MediaItem();
            if (json['image'] != null) {
              result['image'] = $root.wix.common.Image.fromJSON(json['image'], helper);
            } else if (withDefaults !== false) {
              delete result['image'];
            } else {
              delete result['image'];
            }
            if (json['video'] != null) {
              result['video'] = $root.wix.common.Video.fromJSON(json['video'], helper);
            } else if (withDefaults !== false) {
              delete result['video'];
            } else {
              delete result['video'];
            }
            if (json['document'] != null) {
              result['document'] = $root.wix.common.Document.fromJSON(json['document'], helper);
            } else if (withDefaults !== false) {
              delete result['document'];
            } else {
              delete result['document'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['image'] != null) {
              grpc['image'] = $root.wix.common.Image.toGRPC(obj['image'], helper);
            }
            if (obj['video'] != null) {
              grpc['video'] = $root.wix.common.Video.toGRPC(obj['video'], helper);
            }
            if (obj['document'] != null) {
              grpc['document'] = $root.wix.common.Document.toGRPC(obj['document'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.MediaItem();
            if (grpc['image'] != null) {
              result['image'] = $root.wix.common.Image.fromGRPC(grpc['image'], helper);
            } else {
              delete result['image'];
            }
            if (grpc['video'] != null) {
              result['video'] = $root.wix.common.Video.fromGRPC(grpc['video'], helper);
            } else {
              delete result['video'];
            }
            if (grpc['document'] != null) {
              result['document'] = $root.wix.common.Document.fromGRPC(grpc['document'], helper);
            } else {
              delete result['document'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(MediaItem.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.MediaItem');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(MediaItem.prototype, '__fqn__', {
        value: 'wix.common.MediaItem',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(MediaItem.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(MediaItem.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return MediaItem;
    }());;
    _common.Money = (function () {
      class Money {
        constructor(props) {
          this.value = props && props.value;
          this.currency = props && props.currency;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['value'] != null) {
              json['value'] = obj['value'];
            } else if (withDefaults) {
              json['value'] = '';
            }
            if (obj['currency'] != null) {
              json['currency'] = obj['currency'];
            } else if (withDefaults) {
              json['currency'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.Money();
            if (json['value'] != null) {
              result['value'] = json['value'];
            } else if (withDefaults !== false) {
              result['value'] = '';
            } else {
              delete result['value'];
            }
            if (json['currency'] != null) {
              result['currency'] = json['currency'];
            } else if (withDefaults !== false) {
              result['currency'] = '';
            } else {
              delete result['currency'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['value'] != null) {
              grpc['value'] = obj['value'];
            }
            if (obj['currency'] != null) {
              grpc['currency'] = obj['currency'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.Money();
            if (grpc['value'] != null) {
              result['value'] = grpc['value'];
            } else {
              result['value'] = '';
            }
            if (grpc['currency'] != null) {
              result['currency'] = grpc['currency'];
            } else {
              result['currency'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(Money.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.Money');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Money.prototype, '__fqn__', {
        value: 'wix.common.Money',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Money.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Money.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Money;
    }());;
    _common.PageUrl = (function () {
      class PageUrl {
        constructor(props) {
          this.base = props && props.base;
          this.path = props && props.path;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['base'] != null) {
              json['base'] = obj['base'];
            } else if (withDefaults) {
              json['base'] = '';
            }
            if (obj['path'] != null) {
              json['path'] = obj['path'];
            } else if (withDefaults) {
              json['path'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.PageUrl();
            if (json['base'] != null) {
              result['base'] = json['base'];
            } else if (withDefaults !== false) {
              result['base'] = '';
            } else {
              delete result['base'];
            }
            if (json['path'] != null) {
              result['path'] = json['path'];
            } else if (withDefaults !== false) {
              result['path'] = '';
            } else {
              delete result['path'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['base'] != null) {
              grpc['base'] = obj['base'];
            }
            if (obj['path'] != null) {
              grpc['path'] = obj['path'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.PageUrl();
            if (grpc['base'] != null) {
              result['base'] = grpc['base'];
            } else {
              result['base'] = '';
            }
            if (grpc['path'] != null) {
              result['path'] = grpc['path'];
            } else {
              result['path'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(PageUrl.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.PageUrl');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(PageUrl.prototype, '__fqn__', {
        value: 'wix.common.PageUrl',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(PageUrl.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(PageUrl.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return PageUrl;
    }());;
    _common.PageUrlV2 = (function () {
      class PageUrlV2 {
        constructor(props) {
          this.relativePath = props && props.relativePath;
          this.url = props && props.url;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['relativePath'] != null) {
              json['relativePath'] = obj['relativePath'];
            } else if (withDefaults) {
              json['relativePath'] = '';
            }
            if (obj['url'] != null) {
              json['url'] = $root.google.protobuf.StringValue.toJSON(obj['url'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['url'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.PageUrlV2();
            if (json['relativePath'] != null) {
              result['relativePath'] = json['relativePath'];
            } else if (withDefaults !== false) {
              result['relativePath'] = '';
            } else {
              delete result['relativePath'];
            }
            if (json['url'] != null) {
              result['url'] = $root.google.protobuf.StringValue.fromJSON(json['url'], helper);
            } else if (withDefaults !== false) {
              delete result['url'];
            } else {
              delete result['url'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['relativePath'] != null) {
              grpc['relativePath'] = obj['relativePath'];
            }
            if (obj['url'] != null) {
              grpc['url'] = $root.google.protobuf.StringValue.toGRPC(obj['url'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.PageUrlV2();
            if (grpc['relativePath'] != null) {
              result['relativePath'] = grpc['relativePath'];
            } else {
              result['relativePath'] = '';
            }
            if (grpc['url'] != null) {
              result['url'] = $root.google.protobuf.StringValue.fromGRPC(grpc['url'], helper);
            } else {
              delete result['url'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(PageUrlV2.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.PageUrlV2');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(PageUrlV2.prototype, '__fqn__', {
        value: 'wix.common.PageUrlV2',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(PageUrlV2.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(PageUrlV2.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return PageUrlV2;
    }());;
    _common.Paging = (function () {
      class Paging {
        constructor(props) {
          this.limit = props && props.limit;
          this.offset = props && props.offset;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['limit'] != null) {
              json['limit'] = $root.google.protobuf.Int32Value.toJSON(obj['limit'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['limit'];
            }
            if (obj['offset'] != null) {
              json['offset'] = $root.google.protobuf.Int32Value.toJSON(obj['offset'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['offset'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.Paging();
            if (json['limit'] != null) {
              result['limit'] = $root.google.protobuf.Int32Value.fromJSON(json['limit'], helper);
            } else if (withDefaults !== false) {
              delete result['limit'];
            } else {
              delete result['limit'];
            }
            if (json['offset'] != null) {
              result['offset'] = $root.google.protobuf.Int32Value.fromJSON(json['offset'], helper);
            } else if (withDefaults !== false) {
              delete result['offset'];
            } else {
              delete result['offset'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['limit'] != null) {
              grpc['limit'] = $root.google.protobuf.Int32Value.toGRPC(obj['limit'], helper);
            }
            if (obj['offset'] != null) {
              grpc['offset'] = $root.google.protobuf.Int32Value.toGRPC(obj['offset'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.Paging();
            if (grpc['limit'] != null) {
              result['limit'] = $root.google.protobuf.Int32Value.fromGRPC(grpc['limit'], helper);
            } else {
              delete result['limit'];
            }
            if (grpc['offset'] != null) {
              result['offset'] = $root.google.protobuf.Int32Value.fromGRPC(grpc['offset'], helper);
            } else {
              delete result['offset'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(Paging.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.Paging');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Paging.prototype, '__fqn__', {
        value: 'wix.common.Paging',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Paging.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Paging.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Paging;
    }());;
    _common.CursorPaging = (function () {
      class CursorPaging {
        constructor(props) {
          this.limit = props && props.limit;
          this.cursor = props && props.cursor;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['limit'] != null) {
              json['limit'] = $root.google.protobuf.Int32Value.toJSON(obj['limit'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['limit'];
            }
            if (obj['cursor'] != null) {
              json['cursor'] = $root.google.protobuf.StringValue.toJSON(obj['cursor'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['cursor'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.CursorPaging();
            if (json['limit'] != null) {
              result['limit'] = $root.google.protobuf.Int32Value.fromJSON(json['limit'], helper);
            } else if (withDefaults !== false) {
              delete result['limit'];
            } else {
              delete result['limit'];
            }
            if (json['cursor'] != null) {
              result['cursor'] = $root.google.protobuf.StringValue.fromJSON(json['cursor'], helper);
            } else if (withDefaults !== false) {
              delete result['cursor'];
            } else {
              delete result['cursor'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['limit'] != null) {
              grpc['limit'] = $root.google.protobuf.Int32Value.toGRPC(obj['limit'], helper);
            }
            if (obj['cursor'] != null) {
              grpc['cursor'] = $root.google.protobuf.StringValue.toGRPC(obj['cursor'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.CursorPaging();
            if (grpc['limit'] != null) {
              result['limit'] = $root.google.protobuf.Int32Value.fromGRPC(grpc['limit'], helper);
            } else {
              delete result['limit'];
            }
            if (grpc['cursor'] != null) {
              result['cursor'] = $root.google.protobuf.StringValue.fromGRPC(grpc['cursor'], helper);
            } else {
              delete result['cursor'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(CursorPaging.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.CursorPaging');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(CursorPaging.prototype, '__fqn__', {
        value: 'wix.common.CursorPaging',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(CursorPaging.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(CursorPaging.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return CursorPaging;
    }());;
    _common.PagingMetadata = (function () {
      class PagingMetadata {
        constructor(props) {
          this.count = props && props.count;
          this.offset = props && props.offset;
          this.total = props && props.total;
          this.tooManyToCount = props && props.tooManyToCount;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['count'] != null) {
              json['count'] = $root.google.protobuf.Int32Value.toJSON(obj['count'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['count'];
            }
            if (obj['offset'] != null) {
              json['offset'] = $root.google.protobuf.Int32Value.toJSON(obj['offset'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['offset'];
            }
            if (obj['total'] != null) {
              json['total'] = $root.google.protobuf.Int32Value.toJSON(obj['total'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['total'];
            }
            if (obj['tooManyToCount'] != null) {
              json['tooManyToCount'] = $root.google.protobuf.BoolValue.toJSON(obj['tooManyToCount'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['tooManyToCount'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.PagingMetadata();
            if (json['count'] != null) {
              result['count'] = $root.google.protobuf.Int32Value.fromJSON(json['count'], helper);
            } else if (withDefaults !== false) {
              delete result['count'];
            } else {
              delete result['count'];
            }
            if (json['offset'] != null) {
              result['offset'] = $root.google.protobuf.Int32Value.fromJSON(json['offset'], helper);
            } else if (withDefaults !== false) {
              delete result['offset'];
            } else {
              delete result['offset'];
            }
            if (json['total'] != null) {
              result['total'] = $root.google.protobuf.Int32Value.fromJSON(json['total'], helper);
            } else if (withDefaults !== false) {
              delete result['total'];
            } else {
              delete result['total'];
            }
            if (json['tooManyToCount'] != null) {
              result['tooManyToCount'] = $root.google.protobuf.BoolValue.fromJSON(json['tooManyToCount'], helper);
            } else if (withDefaults !== false) {
              delete result['tooManyToCount'];
            } else {
              delete result['tooManyToCount'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['count'] != null) {
              grpc['count'] = $root.google.protobuf.Int32Value.toGRPC(obj['count'], helper);
            }
            if (obj['offset'] != null) {
              grpc['offset'] = $root.google.protobuf.Int32Value.toGRPC(obj['offset'], helper);
            }
            if (obj['total'] != null) {
              grpc['total'] = $root.google.protobuf.Int32Value.toGRPC(obj['total'], helper);
            }
            if (obj['tooManyToCount'] != null) {
              grpc['tooManyToCount'] = $root.google.protobuf.BoolValue.toGRPC(obj['tooManyToCount'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.PagingMetadata();
            if (grpc['count'] != null) {
              result['count'] = $root.google.protobuf.Int32Value.fromGRPC(grpc['count'], helper);
            } else {
              delete result['count'];
            }
            if (grpc['offset'] != null) {
              result['offset'] = $root.google.protobuf.Int32Value.fromGRPC(grpc['offset'], helper);
            } else {
              delete result['offset'];
            }
            if (grpc['total'] != null) {
              result['total'] = $root.google.protobuf.Int32Value.fromGRPC(grpc['total'], helper);
            } else {
              delete result['total'];
            }
            if (grpc['tooManyToCount'] != null) {
              result['tooManyToCount'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['tooManyToCount'], helper);
            } else {
              delete result['tooManyToCount'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(PagingMetadata.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.PagingMetadata');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(PagingMetadata.prototype, '__fqn__', {
        value: 'wix.common.PagingMetadata',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(PagingMetadata.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(PagingMetadata.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return PagingMetadata;
    }());;
    _common.PagingMetadataV2 = (function () {
      class PagingMetadataV2 {
        constructor(props) {
          this.count = props && props.count;
          this.offset = props && props.offset;
          this.total = props && props.total;
          this.tooManyToCount = props && props.tooManyToCount;
          this.cursors = props && props.cursors;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['count'] != null) {
              json['count'] = $root.google.protobuf.Int32Value.toJSON(obj['count'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['count'];
            }
            if (obj['offset'] != null) {
              json['offset'] = $root.google.protobuf.Int32Value.toJSON(obj['offset'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['offset'];
            }
            if (obj['total'] != null) {
              json['total'] = $root.google.protobuf.Int32Value.toJSON(obj['total'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['total'];
            }
            if (obj['tooManyToCount'] != null) {
              json['tooManyToCount'] = $root.google.protobuf.BoolValue.toJSON(obj['tooManyToCount'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['tooManyToCount'];
            }
            if (obj['cursors'] != null) {
              json['cursors'] = $root.wix.common.Cursors.toJSON(obj['cursors'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['cursors'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.PagingMetadataV2();
            if (json['count'] != null) {
              result['count'] = $root.google.protobuf.Int32Value.fromJSON(json['count'], helper);
            } else if (withDefaults !== false) {
              delete result['count'];
            } else {
              delete result['count'];
            }
            if (json['offset'] != null) {
              result['offset'] = $root.google.protobuf.Int32Value.fromJSON(json['offset'], helper);
            } else if (withDefaults !== false) {
              delete result['offset'];
            } else {
              delete result['offset'];
            }
            if (json['total'] != null) {
              result['total'] = $root.google.protobuf.Int32Value.fromJSON(json['total'], helper);
            } else if (withDefaults !== false) {
              delete result['total'];
            } else {
              delete result['total'];
            }
            if (json['tooManyToCount'] != null) {
              result['tooManyToCount'] = $root.google.protobuf.BoolValue.fromJSON(json['tooManyToCount'], helper);
            } else if (withDefaults !== false) {
              delete result['tooManyToCount'];
            } else {
              delete result['tooManyToCount'];
            }
            if (json['cursors'] != null) {
              result['cursors'] = $root.wix.common.Cursors.fromJSON(json['cursors'], helper);
            } else if (withDefaults !== false) {
              delete result['cursors'];
            } else {
              delete result['cursors'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['count'] != null) {
              grpc['count'] = $root.google.protobuf.Int32Value.toGRPC(obj['count'], helper);
            }
            if (obj['offset'] != null) {
              grpc['offset'] = $root.google.protobuf.Int32Value.toGRPC(obj['offset'], helper);
            }
            if (obj['total'] != null) {
              grpc['total'] = $root.google.protobuf.Int32Value.toGRPC(obj['total'], helper);
            }
            if (obj['tooManyToCount'] != null) {
              grpc['tooManyToCount'] = $root.google.protobuf.BoolValue.toGRPC(obj['tooManyToCount'], helper);
            }
            if (obj['cursors'] != null) {
              grpc['cursors'] = $root.wix.common.Cursors.toGRPC(obj['cursors'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.PagingMetadataV2();
            if (grpc['count'] != null) {
              result['count'] = $root.google.protobuf.Int32Value.fromGRPC(grpc['count'], helper);
            } else {
              delete result['count'];
            }
            if (grpc['offset'] != null) {
              result['offset'] = $root.google.protobuf.Int32Value.fromGRPC(grpc['offset'], helper);
            } else {
              delete result['offset'];
            }
            if (grpc['total'] != null) {
              result['total'] = $root.google.protobuf.Int32Value.fromGRPC(grpc['total'], helper);
            } else {
              delete result['total'];
            }
            if (grpc['tooManyToCount'] != null) {
              result['tooManyToCount'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['tooManyToCount'], helper);
            } else {
              delete result['tooManyToCount'];
            }
            if (grpc['cursors'] != null) {
              result['cursors'] = $root.wix.common.Cursors.fromGRPC(grpc['cursors'], helper);
            } else {
              delete result['cursors'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(PagingMetadataV2.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.PagingMetadataV2');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(PagingMetadataV2.prototype, '__fqn__', {
        value: 'wix.common.PagingMetadataV2',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(PagingMetadataV2.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(PagingMetadataV2.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return PagingMetadataV2;
    }());;
    _common.Cursors = (function () {
      class Cursors {
        constructor(props) {
          this.next = props && props.next;
          this.prev = props && props.prev;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['next'] != null) {
              json['next'] = $root.google.protobuf.StringValue.toJSON(obj['next'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['next'];
            }
            if (obj['prev'] != null) {
              json['prev'] = $root.google.protobuf.StringValue.toJSON(obj['prev'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['prev'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.Cursors();
            if (json['next'] != null) {
              result['next'] = $root.google.protobuf.StringValue.fromJSON(json['next'], helper);
            } else if (withDefaults !== false) {
              delete result['next'];
            } else {
              delete result['next'];
            }
            if (json['prev'] != null) {
              result['prev'] = $root.google.protobuf.StringValue.fromJSON(json['prev'], helper);
            } else if (withDefaults !== false) {
              delete result['prev'];
            } else {
              delete result['prev'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['next'] != null) {
              grpc['next'] = $root.google.protobuf.StringValue.toGRPC(obj['next'], helper);
            }
            if (obj['prev'] != null) {
              grpc['prev'] = $root.google.protobuf.StringValue.toGRPC(obj['prev'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.Cursors();
            if (grpc['next'] != null) {
              result['next'] = $root.google.protobuf.StringValue.fromGRPC(grpc['next'], helper);
            } else {
              delete result['next'];
            }
            if (grpc['prev'] != null) {
              result['prev'] = $root.google.protobuf.StringValue.fromGRPC(grpc['prev'], helper);
            } else {
              delete result['prev'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(Cursors.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.Cursors');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Cursors.prototype, '__fqn__', {
        value: 'wix.common.Cursors',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Cursors.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Cursors.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Cursors;
    }());;
    _common.Sorting = (function () {
      class Sorting {
        constructor(props) {
          this.fieldName = props && props.fieldName;
          this.order = props && props.order;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['fieldName'] != null) {
              json['fieldName'] = obj['fieldName'];
            } else if (withDefaults) {
              json['fieldName'] = '';
            }
            if (obj['order'] != null) {
              json['order'] = $root.wix.common.SortOrder[obj['order']];
            } else if (withDefaults) {
              json['order'] = 'ASC';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.Sorting();
            if (json['fieldName'] != null) {
              result['fieldName'] = json['fieldName'];
            } else if (withDefaults !== false) {
              result['fieldName'] = '';
            } else {
              delete result['fieldName'];
            }
            if (json['order'] != null) {
              result['order'] = typeof json['order'] === 'string' ? json['order'] : $root.wix.common.SortOrder[json['order']];
            } else if (withDefaults !== false) {
              result['order'] = 'ASC';
            } else {
              delete result['order'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['fieldName'] != null) {
              grpc['fieldName'] = obj['fieldName'];
            }
            if (obj['order'] != null) {
              grpc['order'] = obj['order'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.Sorting();
            if (grpc['fieldName'] != null) {
              result['fieldName'] = grpc['fieldName'];
            } else {
              result['fieldName'] = '';
            }
            if (grpc['order'] != null) {
              result['order'] = grpc['order'];
            } else {
              result['order'] = 'ASC';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(Sorting.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.Sorting');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Sorting.prototype, '__fqn__', {
        value: 'wix.common.Sorting',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Sorting.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Sorting.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Sorting;
    }());;
    _common.SortOrder = {
      'ASC': 'ASC',
      0: 'ASC',
      'DESC': 'DESC',
      1: 'DESC'
    };
    _common.WixLink = (function () {
      class WixLink {
        constructor(props) {
          this.external = props && props.external;
          this.page = props && props.page;
          this.anchor = props && props.anchor;
          this.dynamicPage = props && props.dynamicPage;
          this.document = props && props.document;
          this.email = props && props.email;
          this.phone = props && props.phone;
          this.address = props && props.address;
          this.whatsApp = props && props.whatsApp;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['external'] != null) {
              json['external'] = $root.wix.common.ExternalLink.toJSON(obj['external'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['external'];
            }
            if (obj['page'] != null) {
              json['page'] = $root.wix.common.PageLink.toJSON(obj['page'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['page'];
            }
            if (obj['anchor'] != null) {
              json['anchor'] = $root.wix.common.AnchorLink.toJSON(obj['anchor'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['anchor'];
            }
            if (obj['dynamicPage'] != null) {
              json['dynamicPage'] = $root.wix.common.DynamicPageLink.toJSON(obj['dynamicPage'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['dynamicPage'];
            }
            if (obj['document'] != null) {
              json['document'] = $root.wix.common.DocumentLink.toJSON(obj['document'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['document'];
            }
            if (obj['email'] != null) {
              json['email'] = $root.wix.common.EmailLink.toJSON(obj['email'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['email'];
            }
            if (obj['phone'] != null) {
              json['phone'] = $root.wix.common.PhoneLink.toJSON(obj['phone'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['phone'];
            }
            if (obj['address'] != null) {
              json['address'] = $root.wix.common.AddressLink.toJSON(obj['address'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['address'];
            }
            if (obj['whatsApp'] != null) {
              json['whatsApp'] = $root.wix.common.WhatsAppLink.toJSON(obj['whatsApp'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['whatsApp'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.WixLink();
            if (json['external'] != null) {
              result['external'] = $root.wix.common.ExternalLink.fromJSON(json['external'], helper);
            } else if (withDefaults !== false) {
              delete result['external'];
            } else {
              delete result['external'];
            }
            if (json['page'] != null) {
              result['page'] = $root.wix.common.PageLink.fromJSON(json['page'], helper);
            } else if (withDefaults !== false) {
              delete result['page'];
            } else {
              delete result['page'];
            }
            if (json['anchor'] != null) {
              result['anchor'] = $root.wix.common.AnchorLink.fromJSON(json['anchor'], helper);
            } else if (withDefaults !== false) {
              delete result['anchor'];
            } else {
              delete result['anchor'];
            }
            if (json['dynamicPage'] != null) {
              result['dynamicPage'] = $root.wix.common.DynamicPageLink.fromJSON(json['dynamicPage'], helper);
            } else if (withDefaults !== false) {
              delete result['dynamicPage'];
            } else {
              delete result['dynamicPage'];
            }
            if (json['document'] != null) {
              result['document'] = $root.wix.common.DocumentLink.fromJSON(json['document'], helper);
            } else if (withDefaults !== false) {
              delete result['document'];
            } else {
              delete result['document'];
            }
            if (json['email'] != null) {
              result['email'] = $root.wix.common.EmailLink.fromJSON(json['email'], helper);
            } else if (withDefaults !== false) {
              delete result['email'];
            } else {
              delete result['email'];
            }
            if (json['phone'] != null) {
              result['phone'] = $root.wix.common.PhoneLink.fromJSON(json['phone'], helper);
            } else if (withDefaults !== false) {
              delete result['phone'];
            } else {
              delete result['phone'];
            }
            if (json['address'] != null) {
              result['address'] = $root.wix.common.AddressLink.fromJSON(json['address'], helper);
            } else if (withDefaults !== false) {
              delete result['address'];
            } else {
              delete result['address'];
            }
            if (json['whatsApp'] != null) {
              result['whatsApp'] = $root.wix.common.WhatsAppLink.fromJSON(json['whatsApp'], helper);
            } else if (withDefaults !== false) {
              delete result['whatsApp'];
            } else {
              delete result['whatsApp'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['external'] != null) {
              grpc['external'] = $root.wix.common.ExternalLink.toGRPC(obj['external'], helper);
            }
            if (obj['page'] != null) {
              grpc['page'] = $root.wix.common.PageLink.toGRPC(obj['page'], helper);
            }
            if (obj['anchor'] != null) {
              grpc['anchor'] = $root.wix.common.AnchorLink.toGRPC(obj['anchor'], helper);
            }
            if (obj['dynamicPage'] != null) {
              grpc['dynamicPage'] = $root.wix.common.DynamicPageLink.toGRPC(obj['dynamicPage'], helper);
            }
            if (obj['document'] != null) {
              grpc['document'] = $root.wix.common.DocumentLink.toGRPC(obj['document'], helper);
            }
            if (obj['email'] != null) {
              grpc['email'] = $root.wix.common.EmailLink.toGRPC(obj['email'], helper);
            }
            if (obj['phone'] != null) {
              grpc['phone'] = $root.wix.common.PhoneLink.toGRPC(obj['phone'], helper);
            }
            if (obj['address'] != null) {
              grpc['address'] = $root.wix.common.AddressLink.toGRPC(obj['address'], helper);
            }
            if (obj['whatsApp'] != null) {
              grpc['whatsApp'] = $root.wix.common.WhatsAppLink.toGRPC(obj['whatsApp'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.WixLink();
            if (grpc['external'] != null) {
              result['external'] = $root.wix.common.ExternalLink.fromGRPC(grpc['external'], helper);
            } else {
              delete result['external'];
            }
            if (grpc['page'] != null) {
              result['page'] = $root.wix.common.PageLink.fromGRPC(grpc['page'], helper);
            } else {
              delete result['page'];
            }
            if (grpc['anchor'] != null) {
              result['anchor'] = $root.wix.common.AnchorLink.fromGRPC(grpc['anchor'], helper);
            } else {
              delete result['anchor'];
            }
            if (grpc['dynamicPage'] != null) {
              result['dynamicPage'] = $root.wix.common.DynamicPageLink.fromGRPC(grpc['dynamicPage'], helper);
            } else {
              delete result['dynamicPage'];
            }
            if (grpc['document'] != null) {
              result['document'] = $root.wix.common.DocumentLink.fromGRPC(grpc['document'], helper);
            } else {
              delete result['document'];
            }
            if (grpc['email'] != null) {
              result['email'] = $root.wix.common.EmailLink.fromGRPC(grpc['email'], helper);
            } else {
              delete result['email'];
            }
            if (grpc['phone'] != null) {
              result['phone'] = $root.wix.common.PhoneLink.fromGRPC(grpc['phone'], helper);
            } else {
              delete result['phone'];
            }
            if (grpc['address'] != null) {
              result['address'] = $root.wix.common.AddressLink.fromGRPC(grpc['address'], helper);
            } else {
              delete result['address'];
            }
            if (grpc['whatsApp'] != null) {
              result['whatsApp'] = $root.wix.common.WhatsAppLink.fromGRPC(grpc['whatsApp'], helper);
            } else {
              delete result['whatsApp'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(WixLink.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.WixLink');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(WixLink.prototype, '__fqn__', {
        value: 'wix.common.WixLink',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(WixLink.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(WixLink.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return WixLink;
    }());;
    _common.ExternalLink = (function () {
      class ExternalLink {
        constructor(props) {
          this.url = props && props.url;
          this.target = props && props.target;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['url'] != null) {
              json['url'] = obj['url'];
            } else if (withDefaults) {
              json['url'] = '';
            }
            if (obj['target'] != null) {
              json['target'] = $root.google.protobuf.StringValue.toJSON(obj['target'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['target'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.ExternalLink();
            if (json['url'] != null) {
              result['url'] = json['url'];
            } else if (withDefaults !== false) {
              result['url'] = '';
            } else {
              delete result['url'];
            }
            if (json['target'] != null) {
              result['target'] = $root.google.protobuf.StringValue.fromJSON(json['target'], helper);
            } else if (withDefaults !== false) {
              delete result['target'];
            } else {
              delete result['target'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['url'] != null) {
              grpc['url'] = obj['url'];
            }
            if (obj['target'] != null) {
              grpc['target'] = $root.google.protobuf.StringValue.toGRPC(obj['target'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.ExternalLink();
            if (grpc['url'] != null) {
              result['url'] = grpc['url'];
            } else {
              result['url'] = '';
            }
            if (grpc['target'] != null) {
              result['target'] = $root.google.protobuf.StringValue.fromGRPC(grpc['target'], helper);
            } else {
              delete result['target'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(ExternalLink.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.ExternalLink');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ExternalLink.prototype, '__fqn__', {
        value: 'wix.common.ExternalLink',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ExternalLink.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ExternalLink.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return ExternalLink;
    }());;
    _common.PageLink = (function () {
      class PageLink {
        constructor(props) {
          this.pageId = props && props.pageId;
          this.target = props && props.target;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['pageId'] != null) {
              json['pageId'] = obj['pageId'];
            } else if (withDefaults) {
              json['pageId'] = '';
            }
            if (obj['target'] != null) {
              json['target'] = $root.google.protobuf.StringValue.toJSON(obj['target'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['target'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.PageLink();
            if (json['pageId'] != null) {
              result['pageId'] = json['pageId'];
            } else if (withDefaults !== false) {
              result['pageId'] = '';
            } else {
              delete result['pageId'];
            }
            if (json['target'] != null) {
              result['target'] = $root.google.protobuf.StringValue.fromJSON(json['target'], helper);
            } else if (withDefaults !== false) {
              delete result['target'];
            } else {
              delete result['target'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['pageId'] != null) {
              grpc['pageId'] = obj['pageId'];
            }
            if (obj['target'] != null) {
              grpc['target'] = $root.google.protobuf.StringValue.toGRPC(obj['target'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.PageLink();
            if (grpc['pageId'] != null) {
              result['pageId'] = grpc['pageId'];
            } else {
              result['pageId'] = '';
            }
            if (grpc['target'] != null) {
              result['target'] = $root.google.protobuf.StringValue.fromGRPC(grpc['target'], helper);
            } else {
              delete result['target'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(PageLink.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.PageLink');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(PageLink.prototype, '__fqn__', {
        value: 'wix.common.PageLink',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(PageLink.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(PageLink.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return PageLink;
    }());;
    _common.AnchorLink = (function () {
      class AnchorLink {
        constructor(props) {
          this.anchorName = props && props.anchorName;
          this.anchorDataId = props && props.anchorDataId;
          this.pageId = props && props.pageId;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['anchorName'] != null) {
              json['anchorName'] = obj['anchorName'];
            } else if (withDefaults) {
              json['anchorName'] = '';
            }
            if (obj['anchorDataId'] != null) {
              json['anchorDataId'] = obj['anchorDataId'];
            } else if (withDefaults) {
              json['anchorDataId'] = '';
            }
            if (obj['pageId'] != null) {
              json['pageId'] = obj['pageId'];
            } else if (withDefaults) {
              json['pageId'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.AnchorLink();
            if (json['anchorName'] != null) {
              result['anchorName'] = json['anchorName'];
            } else if (withDefaults !== false) {
              result['anchorName'] = '';
            } else {
              delete result['anchorName'];
            }
            if (json['anchorDataId'] != null) {
              result['anchorDataId'] = json['anchorDataId'];
            } else if (withDefaults !== false) {
              result['anchorDataId'] = '';
            } else {
              delete result['anchorDataId'];
            }
            if (json['pageId'] != null) {
              result['pageId'] = json['pageId'];
            } else if (withDefaults !== false) {
              result['pageId'] = '';
            } else {
              delete result['pageId'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['anchorName'] != null) {
              grpc['anchorName'] = obj['anchorName'];
            }
            if (obj['anchorDataId'] != null) {
              grpc['anchorDataId'] = obj['anchorDataId'];
            }
            if (obj['pageId'] != null) {
              grpc['pageId'] = obj['pageId'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.AnchorLink();
            if (grpc['anchorName'] != null) {
              result['anchorName'] = grpc['anchorName'];
            } else {
              result['anchorName'] = '';
            }
            if (grpc['anchorDataId'] != null) {
              result['anchorDataId'] = grpc['anchorDataId'];
            } else {
              result['anchorDataId'] = '';
            }
            if (grpc['pageId'] != null) {
              result['pageId'] = grpc['pageId'];
            } else {
              result['pageId'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(AnchorLink.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.AnchorLink');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(AnchorLink.prototype, '__fqn__', {
        value: 'wix.common.AnchorLink',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(AnchorLink.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(AnchorLink.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return AnchorLink;
    }());;
    _common.DynamicPageLink = (function () {
      class DynamicPageLink {
        constructor(props) {
          this.routerId = props && props.routerId;
          this.innerRoute = props && props.innerRoute;
          this.anchorDataId = props && props.anchorDataId;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['routerId'] != null) {
              json['routerId'] = obj['routerId'];
            } else if (withDefaults) {
              json['routerId'] = '';
            }
            if (obj['innerRoute'] != null) {
              json['innerRoute'] = obj['innerRoute'];
            } else if (withDefaults) {
              json['innerRoute'] = '';
            }
            if (obj['anchorDataId'] != null) {
              json['anchorDataId'] = $root.google.protobuf.StringValue.toJSON(obj['anchorDataId'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['anchorDataId'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.DynamicPageLink();
            if (json['routerId'] != null) {
              result['routerId'] = json['routerId'];
            } else if (withDefaults !== false) {
              result['routerId'] = '';
            } else {
              delete result['routerId'];
            }
            if (json['innerRoute'] != null) {
              result['innerRoute'] = json['innerRoute'];
            } else if (withDefaults !== false) {
              result['innerRoute'] = '';
            } else {
              delete result['innerRoute'];
            }
            if (json['anchorDataId'] != null) {
              result['anchorDataId'] = $root.google.protobuf.StringValue.fromJSON(json['anchorDataId'], helper);
            } else if (withDefaults !== false) {
              delete result['anchorDataId'];
            } else {
              delete result['anchorDataId'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['routerId'] != null) {
              grpc['routerId'] = obj['routerId'];
            }
            if (obj['innerRoute'] != null) {
              grpc['innerRoute'] = obj['innerRoute'];
            }
            if (obj['anchorDataId'] != null) {
              grpc['anchorDataId'] = $root.google.protobuf.StringValue.toGRPC(obj['anchorDataId'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.DynamicPageLink();
            if (grpc['routerId'] != null) {
              result['routerId'] = grpc['routerId'];
            } else {
              result['routerId'] = '';
            }
            if (grpc['innerRoute'] != null) {
              result['innerRoute'] = grpc['innerRoute'];
            } else {
              result['innerRoute'] = '';
            }
            if (grpc['anchorDataId'] != null) {
              result['anchorDataId'] = $root.google.protobuf.StringValue.fromGRPC(grpc['anchorDataId'], helper);
            } else {
              delete result['anchorDataId'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(DynamicPageLink.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.DynamicPageLink');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(DynamicPageLink.prototype, '__fqn__', {
        value: 'wix.common.DynamicPageLink',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(DynamicPageLink.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(DynamicPageLink.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return DynamicPageLink;
    }());;
    _common.DocumentLink = (function () {
      class DocumentLink {
        constructor(props) {
          this.docId = props && props.docId;
          this.name = props && props.name;
          this.indexable = props && props.indexable;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['docId'] != null) {
              json['docId'] = obj['docId'];
            } else if (withDefaults) {
              json['docId'] = '';
            }
            if (obj['name'] != null) {
              json['name'] = $root.google.protobuf.StringValue.toJSON(obj['name'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['name'];
            }
            if (obj['indexable'] != null) {
              json['indexable'] = obj['indexable'];
            } else if (withDefaults) {
              json['indexable'] = false;
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.DocumentLink();
            if (json['docId'] != null) {
              result['docId'] = json['docId'];
            } else if (withDefaults !== false) {
              result['docId'] = '';
            } else {
              delete result['docId'];
            }
            if (json['name'] != null) {
              result['name'] = $root.google.protobuf.StringValue.fromJSON(json['name'], helper);
            } else if (withDefaults !== false) {
              delete result['name'];
            } else {
              delete result['name'];
            }
            if (json['indexable'] != null) {
              result['indexable'] = json['indexable'];
            } else if (withDefaults !== false) {
              result['indexable'] = false;
            } else {
              delete result['indexable'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['docId'] != null) {
              grpc['docId'] = obj['docId'];
            }
            if (obj['name'] != null) {
              grpc['name'] = $root.google.protobuf.StringValue.toGRPC(obj['name'], helper);
            }
            if (obj['indexable'] != null) {
              grpc['indexable'] = obj['indexable'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.DocumentLink();
            if (grpc['docId'] != null) {
              result['docId'] = grpc['docId'];
            } else {
              result['docId'] = '';
            }
            if (grpc['name'] != null) {
              result['name'] = $root.google.protobuf.StringValue.fromGRPC(grpc['name'], helper);
            } else {
              delete result['name'];
            }
            if (grpc['indexable'] != null) {
              result['indexable'] = grpc['indexable'];
            } else {
              result['indexable'] = false;
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(DocumentLink.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.DocumentLink');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(DocumentLink.prototype, '__fqn__', {
        value: 'wix.common.DocumentLink',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(DocumentLink.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(DocumentLink.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return DocumentLink;
    }());;
    _common.EmailLink = (function () {
      class EmailLink {
        constructor(props) {
          this.recipient = props && props.recipient;
          this.subject = props && props.subject;
          this.body = props && props.body;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['recipient'] != null) {
              json['recipient'] = obj['recipient'];
            } else if (withDefaults) {
              json['recipient'] = '';
            }
            if (obj['subject'] != null) {
              json['subject'] = $root.google.protobuf.StringValue.toJSON(obj['subject'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['subject'];
            }
            if (obj['body'] != null) {
              json['body'] = $root.google.protobuf.StringValue.toJSON(obj['body'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['body'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.EmailLink();
            if (json['recipient'] != null) {
              result['recipient'] = json['recipient'];
            } else if (withDefaults !== false) {
              result['recipient'] = '';
            } else {
              delete result['recipient'];
            }
            if (json['subject'] != null) {
              result['subject'] = $root.google.protobuf.StringValue.fromJSON(json['subject'], helper);
            } else if (withDefaults !== false) {
              delete result['subject'];
            } else {
              delete result['subject'];
            }
            if (json['body'] != null) {
              result['body'] = $root.google.protobuf.StringValue.fromJSON(json['body'], helper);
            } else if (withDefaults !== false) {
              delete result['body'];
            } else {
              delete result['body'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['recipient'] != null) {
              grpc['recipient'] = obj['recipient'];
            }
            if (obj['subject'] != null) {
              grpc['subject'] = $root.google.protobuf.StringValue.toGRPC(obj['subject'], helper);
            }
            if (obj['body'] != null) {
              grpc['body'] = $root.google.protobuf.StringValue.toGRPC(obj['body'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.EmailLink();
            if (grpc['recipient'] != null) {
              result['recipient'] = grpc['recipient'];
            } else {
              result['recipient'] = '';
            }
            if (grpc['subject'] != null) {
              result['subject'] = $root.google.protobuf.StringValue.fromGRPC(grpc['subject'], helper);
            } else {
              delete result['subject'];
            }
            if (grpc['body'] != null) {
              result['body'] = $root.google.protobuf.StringValue.fromGRPC(grpc['body'], helper);
            } else {
              delete result['body'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(EmailLink.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.EmailLink');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(EmailLink.prototype, '__fqn__', {
        value: 'wix.common.EmailLink',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(EmailLink.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(EmailLink.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return EmailLink;
    }());;
    _common.PhoneLink = (function () {
      class PhoneLink {
        constructor(props) {
          this.phoneNumber = props && props.phoneNumber;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['phoneNumber'] != null) {
              json['phoneNumber'] = obj['phoneNumber'];
            } else if (withDefaults) {
              json['phoneNumber'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.PhoneLink();
            if (json['phoneNumber'] != null) {
              result['phoneNumber'] = json['phoneNumber'];
            } else if (withDefaults !== false) {
              result['phoneNumber'] = '';
            } else {
              delete result['phoneNumber'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['phoneNumber'] != null) {
              grpc['phoneNumber'] = obj['phoneNumber'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.PhoneLink();
            if (grpc['phoneNumber'] != null) {
              result['phoneNumber'] = grpc['phoneNumber'];
            } else {
              result['phoneNumber'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(PhoneLink.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.PhoneLink');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(PhoneLink.prototype, '__fqn__', {
        value: 'wix.common.PhoneLink',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(PhoneLink.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(PhoneLink.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return PhoneLink;
    }());;
    _common.AddressLink = (function () {
      class AddressLink {
        constructor(props) {
          this.address = props && props.address;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['address'] != null) {
              json['address'] = obj['address'];
            } else if (withDefaults) {
              json['address'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.AddressLink();
            if (json['address'] != null) {
              result['address'] = json['address'];
            } else if (withDefaults !== false) {
              result['address'] = '';
            } else {
              delete result['address'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['address'] != null) {
              grpc['address'] = obj['address'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.AddressLink();
            if (grpc['address'] != null) {
              result['address'] = grpc['address'];
            } else {
              result['address'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(AddressLink.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.AddressLink');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(AddressLink.prototype, '__fqn__', {
        value: 'wix.common.AddressLink',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(AddressLink.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(AddressLink.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return AddressLink;
    }());;
    _common.WhatsAppLink = (function () {
      class WhatsAppLink {
        constructor(props) {
          this.phoneNumber = props && props.phoneNumber;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['phoneNumber'] != null) {
              json['phoneNumber'] = obj['phoneNumber'];
            } else if (withDefaults) {
              json['phoneNumber'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.common.WhatsAppLink();
            if (json['phoneNumber'] != null) {
              result['phoneNumber'] = json['phoneNumber'];
            } else if (withDefaults !== false) {
              result['phoneNumber'] = '';
            } else {
              delete result['phoneNumber'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['phoneNumber'] != null) {
              grpc['phoneNumber'] = obj['phoneNumber'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.common.WhatsAppLink();
            if (grpc['phoneNumber'] != null) {
              result['phoneNumber'] = grpc['phoneNumber'];
            } else {
              result['phoneNumber'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(WhatsAppLink.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.common.WhatsAppLink');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(WhatsAppLink.prototype, '__fqn__', {
        value: 'wix.common.WhatsAppLink',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(WhatsAppLink.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(WhatsAppLink.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return WhatsAppLink;
    }());;
    return _common;
  }());;
  _wix.api = (function () {
    const _api = {};
    _api.CacheSettings = (function () {
      class CacheSettings {
        constructor(props) {
          this.maxAgeSeconds = props && props.maxAgeSeconds;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['maxAgeSeconds'] != null) {
              json['maxAgeSeconds'] = obj['maxAgeSeconds'];
            } else if (withDefaults) {
              json['maxAgeSeconds'] = 0;
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.CacheSettings();
            if (json['maxAgeSeconds'] != null) {
              result['maxAgeSeconds'] = json['maxAgeSeconds'];
            } else if (withDefaults !== false) {
              result['maxAgeSeconds'] = 0;
            } else {
              delete result['maxAgeSeconds'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['maxAgeSeconds'] != null) {
              grpc['maxAgeSeconds'] = obj['maxAgeSeconds'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.CacheSettings();
            if (grpc['maxAgeSeconds'] != null) {
              result['maxAgeSeconds'] = grpc['maxAgeSeconds'];
            } else {
              result['maxAgeSeconds'] = 0;
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(CacheSettings.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.CacheSettings');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(CacheSettings.prototype, '__fqn__', {
        value: 'wix.api.CacheSettings',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(CacheSettings.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(CacheSettings.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return CacheSettings;
    }());;
    _api.FieldSet = (function () {
      class FieldSet {
        constructor(props) {
          this.field = props && props.field;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['field'] != null) {
              json['field'] = obj['field'].map(e => {
                return e;
              });
            } else if (withDefaults) {
              json['field'] = [];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.FieldSet();
            if (json['field'] != null) {
              result['field'] = Array.isArray(json['field']) ? json['field'].map(e => {
                return e;
              }) : json['field'];
            } else if (withDefaults !== false) {
              result['field'] = [];
            } else {
              delete result['field'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['field'] != null) {
              grpc['field'] = obj['field'].map(e => {
                return e;
              });
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.FieldSet();
            if (grpc['field'] != null) {
              result['field'] = grpc['field'].map(e => {
                return e;
              });
            } else {
              result['field'] = [];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(FieldSet.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.FieldSet');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FieldSet.prototype, '__fqn__', {
        value: 'wix.api.FieldSet',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FieldSet.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FieldSet.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return FieldSet;
    }());;
    _api.Deprecated = (function () {
      class Deprecated {
        constructor(props) {
          this.replacedBy = props && props.replacedBy;
          this.targetRemovalDate = props && props.targetRemovalDate;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['replacedBy'] != null) {
              json['replacedBy'] = obj['replacedBy'];
            } else if (withDefaults) {
              json['replacedBy'] = '';
            }
            if (obj['targetRemovalDate'] != null) {
              json['targetRemovalDate'] = obj['targetRemovalDate'];
            } else if (withDefaults) {
              json['targetRemovalDate'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.Deprecated();
            if (json['replacedBy'] != null) {
              result['replacedBy'] = json['replacedBy'];
            } else if (withDefaults !== false) {
              result['replacedBy'] = '';
            } else {
              delete result['replacedBy'];
            }
            if (json['targetRemovalDate'] != null) {
              result['targetRemovalDate'] = json['targetRemovalDate'];
            } else if (withDefaults !== false) {
              result['targetRemovalDate'] = '';
            } else {
              delete result['targetRemovalDate'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['replacedBy'] != null) {
              grpc['replacedBy'] = obj['replacedBy'];
            }
            if (obj['targetRemovalDate'] != null) {
              grpc['targetRemovalDate'] = obj['targetRemovalDate'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.Deprecated();
            if (grpc['replacedBy'] != null) {
              result['replacedBy'] = grpc['replacedBy'];
            } else {
              result['replacedBy'] = '';
            }
            if (grpc['targetRemovalDate'] != null) {
              result['targetRemovalDate'] = grpc['targetRemovalDate'];
            } else {
              result['targetRemovalDate'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(Deprecated.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.Deprecated');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Deprecated.prototype, '__fqn__', {
        value: 'wix.api.Deprecated',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Deprecated.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Deprecated.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Deprecated;
    }());;
    _api.Unique = (function () {
      class Unique {
        constructor(props) {
          this.field = props && props.field;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['field'] != null) {
              json['field'] = obj['field'].map(e => {
                return e;
              });
            } else if (withDefaults) {
              json['field'] = [];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.Unique();
            if (json['field'] != null) {
              result['field'] = Array.isArray(json['field']) ? json['field'].map(e => {
                return e;
              }) : json['field'];
            } else if (withDefaults !== false) {
              result['field'] = [];
            } else {
              delete result['field'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['field'] != null) {
              grpc['field'] = obj['field'].map(e => {
                return e;
              });
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.Unique();
            if (grpc['field'] != null) {
              result['field'] = grpc['field'].map(e => {
                return e;
              });
            } else {
              result['field'] = [];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(Unique.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.Unique');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Unique.prototype, '__fqn__', {
        value: 'wix.api.Unique',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Unique.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Unique.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Unique;
    }());;
    _api.Crud = (function () {
      class Crud {
        constructor(props) {
          this.method = props && props.method;
          this.createOptions = props && props.createOptions;
          this.getOptions = props && props.getOptions;
          this.updateOptions = props && props.updateOptions;
          this.deleteOptions = props && props.deleteOptions;
          this.listOptions = props && props.listOptions;
          this.queryOptions = props && props.queryOptions;
          this.bulkCreateOptions = props && props.bulkCreateOptions;
          this.bulkUpdateOptions = props && props.bulkUpdateOptions;
          this.bulkUpdateByFilterOptions = props && props.bulkUpdateByFilterOptions;
          this.bulkDeleteOptions = props && props.bulkDeleteOptions;
          this.bulkDeleteByFilterOptions = props && props.bulkDeleteByFilterOptions;
          this.upsertOptions = props && props.upsertOptions;
          this.bulkUpsertOptions = props && props.bulkUpsertOptions;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['method'] != null) {
              json['method'] = $root.wix.api.Crud.Method[obj['method']];
            } else if (withDefaults) {
              json['method'] = 'UNKNOWN_METHOD';
            }
            if (obj['createOptions'] != null) {
              json['createOptions'] = $root.wix.api.CreateMethodOptions.toJSON(obj['createOptions'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['createOptions'];
            }
            if (obj['getOptions'] != null) {
              json['getOptions'] = $root.wix.api.GetItemMethodOptions.toJSON(obj['getOptions'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['getOptions'];
            }
            if (obj['updateOptions'] != null) {
              json['updateOptions'] = $root.wix.api.UpdateMethodOptions.toJSON(obj['updateOptions'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['updateOptions'];
            }
            if (obj['deleteOptions'] != null) {
              json['deleteOptions'] = $root.wix.api.DeleteMethodOptions.toJSON(obj['deleteOptions'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['deleteOptions'];
            }
            if (obj['listOptions'] != null) {
              json['listOptions'] = $root.wix.api.ListMethodOptions.toJSON(obj['listOptions'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['listOptions'];
            }
            if (obj['queryOptions'] != null) {
              json['queryOptions'] = $root.wix.api.QueryMethodOptions.toJSON(obj['queryOptions'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['queryOptions'];
            }
            if (obj['bulkCreateOptions'] != null) {
              json['bulkCreateOptions'] = $root.wix.api.BulkCreateMethodOptions.toJSON(obj['bulkCreateOptions'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['bulkCreateOptions'];
            }
            if (obj['bulkUpdateOptions'] != null) {
              json['bulkUpdateOptions'] = $root.wix.api.BulkUpdateMethodOptions.toJSON(obj['bulkUpdateOptions'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['bulkUpdateOptions'];
            }
            if (obj['bulkUpdateByFilterOptions'] != null) {
              json['bulkUpdateByFilterOptions'] = $root.wix.api.BulkUpdateByFilterMethodOptions.toJSON(obj['bulkUpdateByFilterOptions'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['bulkUpdateByFilterOptions'];
            }
            if (obj['bulkDeleteOptions'] != null) {
              json['bulkDeleteOptions'] = $root.wix.api.BulkDeleteMethodOptions.toJSON(obj['bulkDeleteOptions'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['bulkDeleteOptions'];
            }
            if (obj['bulkDeleteByFilterOptions'] != null) {
              json['bulkDeleteByFilterOptions'] = $root.wix.api.BulkDeleteByFilterMethodOptions.toJSON(obj['bulkDeleteByFilterOptions'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['bulkDeleteByFilterOptions'];
            }
            if (obj['upsertOptions'] != null) {
              json['upsertOptions'] = $root.wix.api.UpsertMethodOptions.toJSON(obj['upsertOptions'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['upsertOptions'];
            }
            if (obj['bulkUpsertOptions'] != null) {
              json['bulkUpsertOptions'] = $root.wix.api.BulkUpsertMethodOptions.toJSON(obj['bulkUpsertOptions'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['bulkUpsertOptions'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.Crud();
            if (json['method'] != null) {
              result['method'] = typeof json['method'] === 'string' ? json['method'] : $root.wix.api.Crud.Method[json['method']];
            } else if (withDefaults !== false) {
              result['method'] = 'UNKNOWN_METHOD';
            } else {
              delete result['method'];
            }
            if (json['createOptions'] != null) {
              result['createOptions'] = $root.wix.api.CreateMethodOptions.fromJSON(json['createOptions'], helper);
            } else if (withDefaults !== false) {
              delete result['createOptions'];
            } else {
              delete result['createOptions'];
            }
            if (json['getOptions'] != null) {
              result['getOptions'] = $root.wix.api.GetItemMethodOptions.fromJSON(json['getOptions'], helper);
            } else if (withDefaults !== false) {
              delete result['getOptions'];
            } else {
              delete result['getOptions'];
            }
            if (json['updateOptions'] != null) {
              result['updateOptions'] = $root.wix.api.UpdateMethodOptions.fromJSON(json['updateOptions'], helper);
            } else if (withDefaults !== false) {
              delete result['updateOptions'];
            } else {
              delete result['updateOptions'];
            }
            if (json['deleteOptions'] != null) {
              result['deleteOptions'] = $root.wix.api.DeleteMethodOptions.fromJSON(json['deleteOptions'], helper);
            } else if (withDefaults !== false) {
              delete result['deleteOptions'];
            } else {
              delete result['deleteOptions'];
            }
            if (json['listOptions'] != null) {
              result['listOptions'] = $root.wix.api.ListMethodOptions.fromJSON(json['listOptions'], helper);
            } else if (withDefaults !== false) {
              delete result['listOptions'];
            } else {
              delete result['listOptions'];
            }
            if (json['queryOptions'] != null) {
              result['queryOptions'] = $root.wix.api.QueryMethodOptions.fromJSON(json['queryOptions'], helper);
            } else if (withDefaults !== false) {
              delete result['queryOptions'];
            } else {
              delete result['queryOptions'];
            }
            if (json['bulkCreateOptions'] != null) {
              result['bulkCreateOptions'] = $root.wix.api.BulkCreateMethodOptions.fromJSON(json['bulkCreateOptions'], helper);
            } else if (withDefaults !== false) {
              delete result['bulkCreateOptions'];
            } else {
              delete result['bulkCreateOptions'];
            }
            if (json['bulkUpdateOptions'] != null) {
              result['bulkUpdateOptions'] = $root.wix.api.BulkUpdateMethodOptions.fromJSON(json['bulkUpdateOptions'], helper);
            } else if (withDefaults !== false) {
              delete result['bulkUpdateOptions'];
            } else {
              delete result['bulkUpdateOptions'];
            }
            if (json['bulkUpdateByFilterOptions'] != null) {
              result['bulkUpdateByFilterOptions'] = $root.wix.api.BulkUpdateByFilterMethodOptions.fromJSON(json['bulkUpdateByFilterOptions'], helper);
            } else if (withDefaults !== false) {
              delete result['bulkUpdateByFilterOptions'];
            } else {
              delete result['bulkUpdateByFilterOptions'];
            }
            if (json['bulkDeleteOptions'] != null) {
              result['bulkDeleteOptions'] = $root.wix.api.BulkDeleteMethodOptions.fromJSON(json['bulkDeleteOptions'], helper);
            } else if (withDefaults !== false) {
              delete result['bulkDeleteOptions'];
            } else {
              delete result['bulkDeleteOptions'];
            }
            if (json['bulkDeleteByFilterOptions'] != null) {
              result['bulkDeleteByFilterOptions'] = $root.wix.api.BulkDeleteByFilterMethodOptions.fromJSON(json['bulkDeleteByFilterOptions'], helper);
            } else if (withDefaults !== false) {
              delete result['bulkDeleteByFilterOptions'];
            } else {
              delete result['bulkDeleteByFilterOptions'];
            }
            if (json['upsertOptions'] != null) {
              result['upsertOptions'] = $root.wix.api.UpsertMethodOptions.fromJSON(json['upsertOptions'], helper);
            } else if (withDefaults !== false) {
              delete result['upsertOptions'];
            } else {
              delete result['upsertOptions'];
            }
            if (json['bulkUpsertOptions'] != null) {
              result['bulkUpsertOptions'] = $root.wix.api.BulkUpsertMethodOptions.fromJSON(json['bulkUpsertOptions'], helper);
            } else if (withDefaults !== false) {
              delete result['bulkUpsertOptions'];
            } else {
              delete result['bulkUpsertOptions'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['method'] != null) {
              grpc['method'] = obj['method'];
            }
            if (obj['createOptions'] != null) {
              grpc['createOptions'] = $root.wix.api.CreateMethodOptions.toGRPC(obj['createOptions'], helper);
            }
            if (obj['getOptions'] != null) {
              grpc['getOptions'] = $root.wix.api.GetItemMethodOptions.toGRPC(obj['getOptions'], helper);
            }
            if (obj['updateOptions'] != null) {
              grpc['updateOptions'] = $root.wix.api.UpdateMethodOptions.toGRPC(obj['updateOptions'], helper);
            }
            if (obj['deleteOptions'] != null) {
              grpc['deleteOptions'] = $root.wix.api.DeleteMethodOptions.toGRPC(obj['deleteOptions'], helper);
            }
            if (obj['listOptions'] != null) {
              grpc['listOptions'] = $root.wix.api.ListMethodOptions.toGRPC(obj['listOptions'], helper);
            }
            if (obj['queryOptions'] != null) {
              grpc['queryOptions'] = $root.wix.api.QueryMethodOptions.toGRPC(obj['queryOptions'], helper);
            }
            if (obj['bulkCreateOptions'] != null) {
              grpc['bulkCreateOptions'] = $root.wix.api.BulkCreateMethodOptions.toGRPC(obj['bulkCreateOptions'], helper);
            }
            if (obj['bulkUpdateOptions'] != null) {
              grpc['bulkUpdateOptions'] = $root.wix.api.BulkUpdateMethodOptions.toGRPC(obj['bulkUpdateOptions'], helper);
            }
            if (obj['bulkUpdateByFilterOptions'] != null) {
              grpc['bulkUpdateByFilterOptions'] = $root.wix.api.BulkUpdateByFilterMethodOptions.toGRPC(obj['bulkUpdateByFilterOptions'], helper);
            }
            if (obj['bulkDeleteOptions'] != null) {
              grpc['bulkDeleteOptions'] = $root.wix.api.BulkDeleteMethodOptions.toGRPC(obj['bulkDeleteOptions'], helper);
            }
            if (obj['bulkDeleteByFilterOptions'] != null) {
              grpc['bulkDeleteByFilterOptions'] = $root.wix.api.BulkDeleteByFilterMethodOptions.toGRPC(obj['bulkDeleteByFilterOptions'], helper);
            }
            if (obj['upsertOptions'] != null) {
              grpc['upsertOptions'] = $root.wix.api.UpsertMethodOptions.toGRPC(obj['upsertOptions'], helper);
            }
            if (obj['bulkUpsertOptions'] != null) {
              grpc['bulkUpsertOptions'] = $root.wix.api.BulkUpsertMethodOptions.toGRPC(obj['bulkUpsertOptions'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.Crud();
            if (grpc['method'] != null) {
              result['method'] = grpc['method'];
            } else {
              result['method'] = 'UNKNOWN_METHOD';
            }
            if (grpc['createOptions'] != null) {
              result['createOptions'] = $root.wix.api.CreateMethodOptions.fromGRPC(grpc['createOptions'], helper);
            } else {
              delete result['createOptions'];
            }
            if (grpc['getOptions'] != null) {
              result['getOptions'] = $root.wix.api.GetItemMethodOptions.fromGRPC(grpc['getOptions'], helper);
            } else {
              delete result['getOptions'];
            }
            if (grpc['updateOptions'] != null) {
              result['updateOptions'] = $root.wix.api.UpdateMethodOptions.fromGRPC(grpc['updateOptions'], helper);
            } else {
              delete result['updateOptions'];
            }
            if (grpc['deleteOptions'] != null) {
              result['deleteOptions'] = $root.wix.api.DeleteMethodOptions.fromGRPC(grpc['deleteOptions'], helper);
            } else {
              delete result['deleteOptions'];
            }
            if (grpc['listOptions'] != null) {
              result['listOptions'] = $root.wix.api.ListMethodOptions.fromGRPC(grpc['listOptions'], helper);
            } else {
              delete result['listOptions'];
            }
            if (grpc['queryOptions'] != null) {
              result['queryOptions'] = $root.wix.api.QueryMethodOptions.fromGRPC(grpc['queryOptions'], helper);
            } else {
              delete result['queryOptions'];
            }
            if (grpc['bulkCreateOptions'] != null) {
              result['bulkCreateOptions'] = $root.wix.api.BulkCreateMethodOptions.fromGRPC(grpc['bulkCreateOptions'], helper);
            } else {
              delete result['bulkCreateOptions'];
            }
            if (grpc['bulkUpdateOptions'] != null) {
              result['bulkUpdateOptions'] = $root.wix.api.BulkUpdateMethodOptions.fromGRPC(grpc['bulkUpdateOptions'], helper);
            } else {
              delete result['bulkUpdateOptions'];
            }
            if (grpc['bulkUpdateByFilterOptions'] != null) {
              result['bulkUpdateByFilterOptions'] = $root.wix.api.BulkUpdateByFilterMethodOptions.fromGRPC(grpc['bulkUpdateByFilterOptions'], helper);
            } else {
              delete result['bulkUpdateByFilterOptions'];
            }
            if (grpc['bulkDeleteOptions'] != null) {
              result['bulkDeleteOptions'] = $root.wix.api.BulkDeleteMethodOptions.fromGRPC(grpc['bulkDeleteOptions'], helper);
            } else {
              delete result['bulkDeleteOptions'];
            }
            if (grpc['bulkDeleteByFilterOptions'] != null) {
              result['bulkDeleteByFilterOptions'] = $root.wix.api.BulkDeleteByFilterMethodOptions.fromGRPC(grpc['bulkDeleteByFilterOptions'], helper);
            } else {
              delete result['bulkDeleteByFilterOptions'];
            }
            if (grpc['upsertOptions'] != null) {
              result['upsertOptions'] = $root.wix.api.UpsertMethodOptions.fromGRPC(grpc['upsertOptions'], helper);
            } else {
              delete result['upsertOptions'];
            }
            if (grpc['bulkUpsertOptions'] != null) {
              result['bulkUpsertOptions'] = $root.wix.api.BulkUpsertMethodOptions.fromGRPC(grpc['bulkUpsertOptions'], helper);
            } else {
              delete result['bulkUpsertOptions'];
            }
            return result;
          }
        }
      }
      Crud.Method = {
        'UNKNOWN_METHOD': 'UNKNOWN_METHOD',
        0: 'UNKNOWN_METHOD',
        'CREATE': 'CREATE',
        1: 'CREATE',
        'GET_ITEM': 'GET_ITEM',
        2: 'GET_ITEM',
        'UPDATE': 'UPDATE',
        3: 'UPDATE',
        'DELETE': 'DELETE',
        4: 'DELETE',
        'UPSERT': 'UPSERT',
        12: 'UPSERT',
        'LIST': 'LIST',
        5: 'LIST',
        'QUERY': 'QUERY',
        6: 'QUERY',
        'BULK_CREATE': 'BULK_CREATE',
        7: 'BULK_CREATE',
        'BULK_UPDATE': 'BULK_UPDATE',
        8: 'BULK_UPDATE',
        'BULK_UPDATE_BY_FILTER': 'BULK_UPDATE_BY_FILTER',
        9: 'BULK_UPDATE_BY_FILTER',
        'BULK_DELETE': 'BULK_DELETE',
        10: 'BULK_DELETE',
        'BULK_DELETE_BY_FILTER': 'BULK_DELETE_BY_FILTER',
        11: 'BULK_DELETE_BY_FILTER',
        'BULK_UPSERT': 'BULK_UPSERT',
        13: 'BULK_UPSERT'
      };
      Crud.Method = {
        'UNKNOWN_METHOD': 'UNKNOWN_METHOD',
        0: 'UNKNOWN_METHOD',
        'CREATE': 'CREATE',
        1: 'CREATE',
        'GET_ITEM': 'GET_ITEM',
        2: 'GET_ITEM',
        'UPDATE': 'UPDATE',
        3: 'UPDATE',
        'DELETE': 'DELETE',
        4: 'DELETE',
        'UPSERT': 'UPSERT',
        12: 'UPSERT',
        'LIST': 'LIST',
        5: 'LIST',
        'QUERY': 'QUERY',
        6: 'QUERY',
        'BULK_CREATE': 'BULK_CREATE',
        7: 'BULK_CREATE',
        'BULK_UPDATE': 'BULK_UPDATE',
        8: 'BULK_UPDATE',
        'BULK_UPDATE_BY_FILTER': 'BULK_UPDATE_BY_FILTER',
        9: 'BULK_UPDATE_BY_FILTER',
        'BULK_DELETE': 'BULK_DELETE',
        10: 'BULK_DELETE',
        'BULK_DELETE_BY_FILTER': 'BULK_DELETE_BY_FILTER',
        11: 'BULK_DELETE_BY_FILTER',
        'BULK_UPSERT': 'BULK_UPSERT',
        13: 'BULK_UPSERT'
      };
      __builtIn.Object.defineProperty(Crud.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.Crud');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Crud.prototype, '__fqn__', {
        value: 'wix.api.Crud',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Crud.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Crud.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Crud;
    }());;
    _api.Paging = (function () {
      class Paging {
        constructor(props) {
          this.type = props && props.type;
          this.pagingField = props && props.pagingField;
          this.totalsField = props && props.totalsField;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['type'] != null) {
              json['type'] = $root.wix.api.Paging.Type[obj['type']];
            } else if (withDefaults) {
              json['type'] = 'UNKNOWN_TYPE';
            }
            if (obj['pagingField'] != null) {
              json['pagingField'] = obj['pagingField'];
            } else if (withDefaults) {
              json['pagingField'] = '';
            }
            if (obj['totalsField'] != null) {
              json['totalsField'] = obj['totalsField'];
            } else if (withDefaults) {
              json['totalsField'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.Paging();
            if (json['type'] != null) {
              result['type'] = typeof json['type'] === 'string' ? json['type'] : $root.wix.api.Paging.Type[json['type']];
            } else if (withDefaults !== false) {
              result['type'] = 'UNKNOWN_TYPE';
            } else {
              delete result['type'];
            }
            if (json['pagingField'] != null) {
              result['pagingField'] = json['pagingField'];
            } else if (withDefaults !== false) {
              result['pagingField'] = '';
            } else {
              delete result['pagingField'];
            }
            if (json['totalsField'] != null) {
              result['totalsField'] = json['totalsField'];
            } else if (withDefaults !== false) {
              result['totalsField'] = '';
            } else {
              delete result['totalsField'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['type'] != null) {
              grpc['type'] = obj['type'];
            }
            if (obj['pagingField'] != null) {
              grpc['pagingField'] = obj['pagingField'];
            }
            if (obj['totalsField'] != null) {
              grpc['totalsField'] = obj['totalsField'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.Paging();
            if (grpc['type'] != null) {
              result['type'] = grpc['type'];
            } else {
              result['type'] = 'UNKNOWN_TYPE';
            }
            if (grpc['pagingField'] != null) {
              result['pagingField'] = grpc['pagingField'];
            } else {
              result['pagingField'] = '';
            }
            if (grpc['totalsField'] != null) {
              result['totalsField'] = grpc['totalsField'];
            } else {
              result['totalsField'] = '';
            }
            return result;
          }
        }
      }
      Paging.Type = {
        'UNKNOWN_TYPE': 'UNKNOWN_TYPE',
        0: 'UNKNOWN_TYPE',
        'OFFSET': 'OFFSET',
        1: 'OFFSET',
        'CURSOR': 'CURSOR',
        2: 'CURSOR'
      };
      Paging.Type = {
        'UNKNOWN_TYPE': 'UNKNOWN_TYPE',
        0: 'UNKNOWN_TYPE',
        'OFFSET': 'OFFSET',
        1: 'OFFSET',
        'CURSOR': 'CURSOR',
        2: 'CURSOR'
      };
      __builtIn.Object.defineProperty(Paging.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.Paging');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Paging.prototype, '__fqn__', {
        value: 'wix.api.Paging',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Paging.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Paging.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Paging;
    }());;
    _api.CreateMethodOptions = (function () {
      class CreateMethodOptions {
        constructor(props) {
          this.itemField = props && props.itemField;
          this.fieldmaskField = props && props.fieldmaskField;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['itemField'] != null) {
              json['itemField'] = obj['itemField'];
            } else if (withDefaults) {
              json['itemField'] = '';
            }
            if (obj['fieldmaskField'] != null) {
              json['fieldmaskField'] = obj['fieldmaskField'];
            } else if (withDefaults) {
              json['fieldmaskField'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.CreateMethodOptions();
            if (json['itemField'] != null) {
              result['itemField'] = json['itemField'];
            } else if (withDefaults !== false) {
              result['itemField'] = '';
            } else {
              delete result['itemField'];
            }
            if (json['fieldmaskField'] != null) {
              result['fieldmaskField'] = json['fieldmaskField'];
            } else if (withDefaults !== false) {
              result['fieldmaskField'] = '';
            } else {
              delete result['fieldmaskField'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['itemField'] != null) {
              grpc['itemField'] = obj['itemField'];
            }
            if (obj['fieldmaskField'] != null) {
              grpc['fieldmaskField'] = obj['fieldmaskField'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.CreateMethodOptions();
            if (grpc['itemField'] != null) {
              result['itemField'] = grpc['itemField'];
            } else {
              result['itemField'] = '';
            }
            if (grpc['fieldmaskField'] != null) {
              result['fieldmaskField'] = grpc['fieldmaskField'];
            } else {
              result['fieldmaskField'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(CreateMethodOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.CreateMethodOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(CreateMethodOptions.prototype, '__fqn__', {
        value: 'wix.api.CreateMethodOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(CreateMethodOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(CreateMethodOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return CreateMethodOptions;
    }());;
    _api.GetItemMethodOptions = (function () {
      class GetItemMethodOptions {
        constructor(props) {
          this.idField = props && props.idField;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['idField'] != null) {
              json['idField'] = obj['idField'];
            } else if (withDefaults) {
              json['idField'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.GetItemMethodOptions();
            if (json['idField'] != null) {
              result['idField'] = json['idField'];
            } else if (withDefaults !== false) {
              result['idField'] = '';
            } else {
              delete result['idField'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['idField'] != null) {
              grpc['idField'] = obj['idField'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.GetItemMethodOptions();
            if (grpc['idField'] != null) {
              result['idField'] = grpc['idField'];
            } else {
              result['idField'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(GetItemMethodOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.GetItemMethodOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(GetItemMethodOptions.prototype, '__fqn__', {
        value: 'wix.api.GetItemMethodOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(GetItemMethodOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(GetItemMethodOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return GetItemMethodOptions;
    }());;
    _api.UpdateMethodOptions = (function () {
      class UpdateMethodOptions {
        constructor(props) {
          this.itemField = props && props.itemField;
          this.fieldmaskField = props && props.fieldmaskField;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['itemField'] != null) {
              json['itemField'] = obj['itemField'];
            } else if (withDefaults) {
              json['itemField'] = '';
            }
            if (obj['fieldmaskField'] != null) {
              json['fieldmaskField'] = obj['fieldmaskField'];
            } else if (withDefaults) {
              json['fieldmaskField'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.UpdateMethodOptions();
            if (json['itemField'] != null) {
              result['itemField'] = json['itemField'];
            } else if (withDefaults !== false) {
              result['itemField'] = '';
            } else {
              delete result['itemField'];
            }
            if (json['fieldmaskField'] != null) {
              result['fieldmaskField'] = json['fieldmaskField'];
            } else if (withDefaults !== false) {
              result['fieldmaskField'] = '';
            } else {
              delete result['fieldmaskField'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['itemField'] != null) {
              grpc['itemField'] = obj['itemField'];
            }
            if (obj['fieldmaskField'] != null) {
              grpc['fieldmaskField'] = obj['fieldmaskField'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.UpdateMethodOptions();
            if (grpc['itemField'] != null) {
              result['itemField'] = grpc['itemField'];
            } else {
              result['itemField'] = '';
            }
            if (grpc['fieldmaskField'] != null) {
              result['fieldmaskField'] = grpc['fieldmaskField'];
            } else {
              result['fieldmaskField'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(UpdateMethodOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.UpdateMethodOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(UpdateMethodOptions.prototype, '__fqn__', {
        value: 'wix.api.UpdateMethodOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(UpdateMethodOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(UpdateMethodOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return UpdateMethodOptions;
    }());;
    _api.UpsertMethodOptions = (function () {
      class UpsertMethodOptions {
        constructor(props) {
          this.itemField = props && props.itemField;
          this.fieldmaskField = props && props.fieldmaskField;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['itemField'] != null) {
              json['itemField'] = obj['itemField'];
            } else if (withDefaults) {
              json['itemField'] = '';
            }
            if (obj['fieldmaskField'] != null) {
              json['fieldmaskField'] = obj['fieldmaskField'];
            } else if (withDefaults) {
              json['fieldmaskField'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.UpsertMethodOptions();
            if (json['itemField'] != null) {
              result['itemField'] = json['itemField'];
            } else if (withDefaults !== false) {
              result['itemField'] = '';
            } else {
              delete result['itemField'];
            }
            if (json['fieldmaskField'] != null) {
              result['fieldmaskField'] = json['fieldmaskField'];
            } else if (withDefaults !== false) {
              result['fieldmaskField'] = '';
            } else {
              delete result['fieldmaskField'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['itemField'] != null) {
              grpc['itemField'] = obj['itemField'];
            }
            if (obj['fieldmaskField'] != null) {
              grpc['fieldmaskField'] = obj['fieldmaskField'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.UpsertMethodOptions();
            if (grpc['itemField'] != null) {
              result['itemField'] = grpc['itemField'];
            } else {
              result['itemField'] = '';
            }
            if (grpc['fieldmaskField'] != null) {
              result['fieldmaskField'] = grpc['fieldmaskField'];
            } else {
              result['fieldmaskField'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(UpsertMethodOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.UpsertMethodOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(UpsertMethodOptions.prototype, '__fqn__', {
        value: 'wix.api.UpsertMethodOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(UpsertMethodOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(UpsertMethodOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return UpsertMethodOptions;
    }());;
    _api.DeleteMethodOptions = (function () {
      class DeleteMethodOptions {
        constructor(props) {
          this.idField = props && props.idField;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['idField'] != null) {
              json['idField'] = obj['idField'];
            } else if (withDefaults) {
              json['idField'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.DeleteMethodOptions();
            if (json['idField'] != null) {
              result['idField'] = json['idField'];
            } else if (withDefaults !== false) {
              result['idField'] = '';
            } else {
              delete result['idField'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['idField'] != null) {
              grpc['idField'] = obj['idField'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.DeleteMethodOptions();
            if (grpc['idField'] != null) {
              result['idField'] = grpc['idField'];
            } else {
              result['idField'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(DeleteMethodOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.DeleteMethodOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(DeleteMethodOptions.prototype, '__fqn__', {
        value: 'wix.api.DeleteMethodOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(DeleteMethodOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(DeleteMethodOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return DeleteMethodOptions;
    }());;
    _api.ListMethodOptions = (function () {
      class ListMethodOptions {
        constructor(props) {
          this.idsField = props && props.idsField;
          this.itemsField = props && props.itemsField;
          this.paging = props && props.paging;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['idsField'] != null) {
              json['idsField'] = obj['idsField'];
            } else if (withDefaults) {
              json['idsField'] = '';
            }
            if (obj['itemsField'] != null) {
              json['itemsField'] = obj['itemsField'];
            } else if (withDefaults) {
              json['itemsField'] = '';
            }
            if (obj['paging'] != null) {
              json['paging'] = $root.wix.api.Paging.toJSON(obj['paging'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['paging'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.ListMethodOptions();
            if (json['idsField'] != null) {
              result['idsField'] = json['idsField'];
            } else if (withDefaults !== false) {
              result['idsField'] = '';
            } else {
              delete result['idsField'];
            }
            if (json['itemsField'] != null) {
              result['itemsField'] = json['itemsField'];
            } else if (withDefaults !== false) {
              result['itemsField'] = '';
            } else {
              delete result['itemsField'];
            }
            if (json['paging'] != null) {
              result['paging'] = $root.wix.api.Paging.fromJSON(json['paging'], helper);
            } else if (withDefaults !== false) {
              delete result['paging'];
            } else {
              delete result['paging'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['idsField'] != null) {
              grpc['idsField'] = obj['idsField'];
            }
            if (obj['itemsField'] != null) {
              grpc['itemsField'] = obj['itemsField'];
            }
            if (obj['paging'] != null) {
              grpc['paging'] = $root.wix.api.Paging.toGRPC(obj['paging'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.ListMethodOptions();
            if (grpc['idsField'] != null) {
              result['idsField'] = grpc['idsField'];
            } else {
              result['idsField'] = '';
            }
            if (grpc['itemsField'] != null) {
              result['itemsField'] = grpc['itemsField'];
            } else {
              result['itemsField'] = '';
            }
            if (grpc['paging'] != null) {
              result['paging'] = $root.wix.api.Paging.fromGRPC(grpc['paging'], helper);
            } else {
              delete result['paging'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(ListMethodOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.ListMethodOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ListMethodOptions.prototype, '__fqn__', {
        value: 'wix.api.ListMethodOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ListMethodOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ListMethodOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return ListMethodOptions;
    }());;
    _api.QueryMethodOptions = (function () {
      class QueryMethodOptions {
        constructor(props) {
          this.queryField = props && props.queryField;
          this.itemsField = props && props.itemsField;
          this.paging = props && props.paging;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['queryField'] != null) {
              json['queryField'] = obj['queryField'];
            } else if (withDefaults) {
              json['queryField'] = '';
            }
            if (obj['itemsField'] != null) {
              json['itemsField'] = obj['itemsField'];
            } else if (withDefaults) {
              json['itemsField'] = '';
            }
            if (obj['paging'] != null) {
              json['paging'] = $root.wix.api.Paging.toJSON(obj['paging'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['paging'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.QueryMethodOptions();
            if (json['queryField'] != null) {
              result['queryField'] = json['queryField'];
            } else if (withDefaults !== false) {
              result['queryField'] = '';
            } else {
              delete result['queryField'];
            }
            if (json['itemsField'] != null) {
              result['itemsField'] = json['itemsField'];
            } else if (withDefaults !== false) {
              result['itemsField'] = '';
            } else {
              delete result['itemsField'];
            }
            if (json['paging'] != null) {
              result['paging'] = $root.wix.api.Paging.fromJSON(json['paging'], helper);
            } else if (withDefaults !== false) {
              delete result['paging'];
            } else {
              delete result['paging'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['queryField'] != null) {
              grpc['queryField'] = obj['queryField'];
            }
            if (obj['itemsField'] != null) {
              grpc['itemsField'] = obj['itemsField'];
            }
            if (obj['paging'] != null) {
              grpc['paging'] = $root.wix.api.Paging.toGRPC(obj['paging'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.QueryMethodOptions();
            if (grpc['queryField'] != null) {
              result['queryField'] = grpc['queryField'];
            } else {
              result['queryField'] = '';
            }
            if (grpc['itemsField'] != null) {
              result['itemsField'] = grpc['itemsField'];
            } else {
              result['itemsField'] = '';
            }
            if (grpc['paging'] != null) {
              result['paging'] = $root.wix.api.Paging.fromGRPC(grpc['paging'], helper);
            } else {
              delete result['paging'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(QueryMethodOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.QueryMethodOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(QueryMethodOptions.prototype, '__fqn__', {
        value: 'wix.api.QueryMethodOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(QueryMethodOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(QueryMethodOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return QueryMethodOptions;
    }());;
    _api.BulkCreateMethodOptions = (function () {
      class BulkCreateMethodOptions {
        constructor(props) {
          this.itemField = props && props.itemField;
          this.fieldmaskField = props && props.fieldmaskField;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['itemField'] != null) {
              json['itemField'] = obj['itemField'];
            } else if (withDefaults) {
              json['itemField'] = '';
            }
            if (obj['fieldmaskField'] != null) {
              json['fieldmaskField'] = obj['fieldmaskField'];
            } else if (withDefaults) {
              json['fieldmaskField'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.BulkCreateMethodOptions();
            if (json['itemField'] != null) {
              result['itemField'] = json['itemField'];
            } else if (withDefaults !== false) {
              result['itemField'] = '';
            } else {
              delete result['itemField'];
            }
            if (json['fieldmaskField'] != null) {
              result['fieldmaskField'] = json['fieldmaskField'];
            } else if (withDefaults !== false) {
              result['fieldmaskField'] = '';
            } else {
              delete result['fieldmaskField'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['itemField'] != null) {
              grpc['itemField'] = obj['itemField'];
            }
            if (obj['fieldmaskField'] != null) {
              grpc['fieldmaskField'] = obj['fieldmaskField'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.BulkCreateMethodOptions();
            if (grpc['itemField'] != null) {
              result['itemField'] = grpc['itemField'];
            } else {
              result['itemField'] = '';
            }
            if (grpc['fieldmaskField'] != null) {
              result['fieldmaskField'] = grpc['fieldmaskField'];
            } else {
              result['fieldmaskField'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(BulkCreateMethodOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.BulkCreateMethodOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkCreateMethodOptions.prototype, '__fqn__', {
        value: 'wix.api.BulkCreateMethodOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkCreateMethodOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkCreateMethodOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return BulkCreateMethodOptions;
    }());;
    _api.BulkUpdateMethodOptions = (function () {
      class BulkUpdateMethodOptions {
        constructor(props) {
          this.itemField = props && props.itemField;
          this.fieldmaskField = props && props.fieldmaskField;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['itemField'] != null) {
              json['itemField'] = obj['itemField'];
            } else if (withDefaults) {
              json['itemField'] = '';
            }
            if (obj['fieldmaskField'] != null) {
              json['fieldmaskField'] = obj['fieldmaskField'];
            } else if (withDefaults) {
              json['fieldmaskField'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.BulkUpdateMethodOptions();
            if (json['itemField'] != null) {
              result['itemField'] = json['itemField'];
            } else if (withDefaults !== false) {
              result['itemField'] = '';
            } else {
              delete result['itemField'];
            }
            if (json['fieldmaskField'] != null) {
              result['fieldmaskField'] = json['fieldmaskField'];
            } else if (withDefaults !== false) {
              result['fieldmaskField'] = '';
            } else {
              delete result['fieldmaskField'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['itemField'] != null) {
              grpc['itemField'] = obj['itemField'];
            }
            if (obj['fieldmaskField'] != null) {
              grpc['fieldmaskField'] = obj['fieldmaskField'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.BulkUpdateMethodOptions();
            if (grpc['itemField'] != null) {
              result['itemField'] = grpc['itemField'];
            } else {
              result['itemField'] = '';
            }
            if (grpc['fieldmaskField'] != null) {
              result['fieldmaskField'] = grpc['fieldmaskField'];
            } else {
              result['fieldmaskField'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(BulkUpdateMethodOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.BulkUpdateMethodOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkUpdateMethodOptions.prototype, '__fqn__', {
        value: 'wix.api.BulkUpdateMethodOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkUpdateMethodOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkUpdateMethodOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return BulkUpdateMethodOptions;
    }());;
    _api.BulkUpdateByFilterMethodOptions = (function () {
      class BulkUpdateByFilterMethodOptions {
        constructor(props) {
          this.itemField = props && props.itemField;
          this.fieldmaskField = props && props.fieldmaskField;
          this.filterField = props && props.filterField;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['itemField'] != null) {
              json['itemField'] = obj['itemField'];
            } else if (withDefaults) {
              json['itemField'] = '';
            }
            if (obj['fieldmaskField'] != null) {
              json['fieldmaskField'] = obj['fieldmaskField'];
            } else if (withDefaults) {
              json['fieldmaskField'] = '';
            }
            if (obj['filterField'] != null) {
              json['filterField'] = obj['filterField'];
            } else if (withDefaults) {
              json['filterField'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.BulkUpdateByFilterMethodOptions();
            if (json['itemField'] != null) {
              result['itemField'] = json['itemField'];
            } else if (withDefaults !== false) {
              result['itemField'] = '';
            } else {
              delete result['itemField'];
            }
            if (json['fieldmaskField'] != null) {
              result['fieldmaskField'] = json['fieldmaskField'];
            } else if (withDefaults !== false) {
              result['fieldmaskField'] = '';
            } else {
              delete result['fieldmaskField'];
            }
            if (json['filterField'] != null) {
              result['filterField'] = json['filterField'];
            } else if (withDefaults !== false) {
              result['filterField'] = '';
            } else {
              delete result['filterField'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['itemField'] != null) {
              grpc['itemField'] = obj['itemField'];
            }
            if (obj['fieldmaskField'] != null) {
              grpc['fieldmaskField'] = obj['fieldmaskField'];
            }
            if (obj['filterField'] != null) {
              grpc['filterField'] = obj['filterField'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.BulkUpdateByFilterMethodOptions();
            if (grpc['itemField'] != null) {
              result['itemField'] = grpc['itemField'];
            } else {
              result['itemField'] = '';
            }
            if (grpc['fieldmaskField'] != null) {
              result['fieldmaskField'] = grpc['fieldmaskField'];
            } else {
              result['fieldmaskField'] = '';
            }
            if (grpc['filterField'] != null) {
              result['filterField'] = grpc['filterField'];
            } else {
              result['filterField'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(BulkUpdateByFilterMethodOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.BulkUpdateByFilterMethodOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkUpdateByFilterMethodOptions.prototype, '__fqn__', {
        value: 'wix.api.BulkUpdateByFilterMethodOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkUpdateByFilterMethodOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkUpdateByFilterMethodOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return BulkUpdateByFilterMethodOptions;
    }());;
    _api.BulkUpsertMethodOptions = (function () {
      class BulkUpsertMethodOptions {
        constructor(props) {
          this.itemField = props && props.itemField;
          this.fieldmaskField = props && props.fieldmaskField;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['itemField'] != null) {
              json['itemField'] = obj['itemField'];
            } else if (withDefaults) {
              json['itemField'] = '';
            }
            if (obj['fieldmaskField'] != null) {
              json['fieldmaskField'] = obj['fieldmaskField'];
            } else if (withDefaults) {
              json['fieldmaskField'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.BulkUpsertMethodOptions();
            if (json['itemField'] != null) {
              result['itemField'] = json['itemField'];
            } else if (withDefaults !== false) {
              result['itemField'] = '';
            } else {
              delete result['itemField'];
            }
            if (json['fieldmaskField'] != null) {
              result['fieldmaskField'] = json['fieldmaskField'];
            } else if (withDefaults !== false) {
              result['fieldmaskField'] = '';
            } else {
              delete result['fieldmaskField'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['itemField'] != null) {
              grpc['itemField'] = obj['itemField'];
            }
            if (obj['fieldmaskField'] != null) {
              grpc['fieldmaskField'] = obj['fieldmaskField'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.BulkUpsertMethodOptions();
            if (grpc['itemField'] != null) {
              result['itemField'] = grpc['itemField'];
            } else {
              result['itemField'] = '';
            }
            if (grpc['fieldmaskField'] != null) {
              result['fieldmaskField'] = grpc['fieldmaskField'];
            } else {
              result['fieldmaskField'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(BulkUpsertMethodOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.BulkUpsertMethodOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkUpsertMethodOptions.prototype, '__fqn__', {
        value: 'wix.api.BulkUpsertMethodOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkUpsertMethodOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkUpsertMethodOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return BulkUpsertMethodOptions;
    }());;
    _api.BulkDeleteMethodOptions = (function () {
      class BulkDeleteMethodOptions {
        constructor(props) {
          this.idsField = props && props.idsField;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['idsField'] != null) {
              json['idsField'] = obj['idsField'];
            } else if (withDefaults) {
              json['idsField'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.BulkDeleteMethodOptions();
            if (json['idsField'] != null) {
              result['idsField'] = json['idsField'];
            } else if (withDefaults !== false) {
              result['idsField'] = '';
            } else {
              delete result['idsField'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['idsField'] != null) {
              grpc['idsField'] = obj['idsField'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.BulkDeleteMethodOptions();
            if (grpc['idsField'] != null) {
              result['idsField'] = grpc['idsField'];
            } else {
              result['idsField'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(BulkDeleteMethodOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.BulkDeleteMethodOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkDeleteMethodOptions.prototype, '__fqn__', {
        value: 'wix.api.BulkDeleteMethodOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkDeleteMethodOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkDeleteMethodOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return BulkDeleteMethodOptions;
    }());;
    _api.BulkDeleteByFilterMethodOptions = (function () {
      class BulkDeleteByFilterMethodOptions {
        constructor(props) {
          this.filterField = props && props.filterField;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['filterField'] != null) {
              json['filterField'] = obj['filterField'];
            } else if (withDefaults) {
              json['filterField'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.BulkDeleteByFilterMethodOptions();
            if (json['filterField'] != null) {
              result['filterField'] = json['filterField'];
            } else if (withDefaults !== false) {
              result['filterField'] = '';
            } else {
              delete result['filterField'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['filterField'] != null) {
              grpc['filterField'] = obj['filterField'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.BulkDeleteByFilterMethodOptions();
            if (grpc['filterField'] != null) {
              result['filterField'] = grpc['filterField'];
            } else {
              result['filterField'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(BulkDeleteByFilterMethodOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.BulkDeleteByFilterMethodOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkDeleteByFilterMethodOptions.prototype, '__fqn__', {
        value: 'wix.api.BulkDeleteByFilterMethodOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkDeleteByFilterMethodOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BulkDeleteByFilterMethodOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return BulkDeleteByFilterMethodOptions;
    }());;
    _api.Translatable = (function () {
      class Translatable {
        constructor(props) {
          this.name = props && props.name;
          this.hidden = props && props.hidden;
          this.grouping = props && props.grouping;
          this.type = props && props.type;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['name'] != null) {
              json['name'] = obj['name'];
            } else if (withDefaults) {
              json['name'] = '';
            }
            if (obj['hidden'] != null) {
              json['hidden'] = obj['hidden'];
            } else if (withDefaults) {
              json['hidden'] = false;
            }
            if (obj['grouping'] != null) {
              json['grouping'] = obj['grouping'];
            } else if (withDefaults) {
              json['grouping'] = '';
            }
            if (obj['type'] != null) {
              json['type'] = $root.wix.api.Translatable.Type[obj['type']];
            } else if (withDefaults) {
              json['type'] = 'UNDEFINED_TYPE';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.Translatable();
            if (json['name'] != null) {
              result['name'] = json['name'];
            } else if (withDefaults !== false) {
              result['name'] = '';
            } else {
              delete result['name'];
            }
            if (json['hidden'] != null) {
              result['hidden'] = json['hidden'];
            } else if (withDefaults !== false) {
              result['hidden'] = false;
            } else {
              delete result['hidden'];
            }
            if (json['grouping'] != null) {
              result['grouping'] = json['grouping'];
            } else if (withDefaults !== false) {
              result['grouping'] = '';
            } else {
              delete result['grouping'];
            }
            if (json['type'] != null) {
              result['type'] = typeof json['type'] === 'string' ? json['type'] : $root.wix.api.Translatable.Type[json['type']];
            } else if (withDefaults !== false) {
              result['type'] = 'UNDEFINED_TYPE';
            } else {
              delete result['type'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['name'] != null) {
              grpc['name'] = obj['name'];
            }
            if (obj['hidden'] != null) {
              grpc['hidden'] = obj['hidden'];
            }
            if (obj['grouping'] != null) {
              grpc['grouping'] = obj['grouping'];
            }
            if (obj['type'] != null) {
              grpc['type'] = obj['type'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.Translatable();
            if (grpc['name'] != null) {
              result['name'] = grpc['name'];
            } else {
              result['name'] = '';
            }
            if (grpc['hidden'] != null) {
              result['hidden'] = grpc['hidden'];
            } else {
              result['hidden'] = false;
            }
            if (grpc['grouping'] != null) {
              result['grouping'] = grpc['grouping'];
            } else {
              result['grouping'] = '';
            }
            if (grpc['type'] != null) {
              result['type'] = grpc['type'];
            } else {
              result['type'] = 'UNDEFINED_TYPE';
            }
            return result;
          }
        }
      }
      Translatable.Type = {
        'UNDEFINED_TYPE': 'UNDEFINED_TYPE',
        0: 'UNDEFINED_TYPE',
        'SHORT_TEXT': 'SHORT_TEXT',
        1: 'SHORT_TEXT',
        'LONG_TEXT': 'LONG_TEXT',
        2: 'LONG_TEXT',
        'RICH_TEXT': 'RICH_TEXT',
        3: 'RICH_TEXT',
        'RICH_CONTENT_EDITOR': 'RICH_CONTENT_EDITOR',
        4: 'RICH_CONTENT_EDITOR',
        'SELECTION': 'SELECTION',
        5: 'SELECTION',
        'MULTI_SELECTION': 'MULTI_SELECTION',
        6: 'MULTI_SELECTION',
        'DOCUMENT': 'DOCUMENT',
        7: 'DOCUMENT',
        'IMAGE': 'IMAGE',
        8: 'IMAGE',
        'VIDEO': 'VIDEO',
        9: 'VIDEO'
      };
      Translatable.Type = {
        'UNDEFINED_TYPE': 'UNDEFINED_TYPE',
        0: 'UNDEFINED_TYPE',
        'SHORT_TEXT': 'SHORT_TEXT',
        1: 'SHORT_TEXT',
        'LONG_TEXT': 'LONG_TEXT',
        2: 'LONG_TEXT',
        'RICH_TEXT': 'RICH_TEXT',
        3: 'RICH_TEXT',
        'RICH_CONTENT_EDITOR': 'RICH_CONTENT_EDITOR',
        4: 'RICH_CONTENT_EDITOR',
        'SELECTION': 'SELECTION',
        5: 'SELECTION',
        'MULTI_SELECTION': 'MULTI_SELECTION',
        6: 'MULTI_SELECTION',
        'DOCUMENT': 'DOCUMENT',
        7: 'DOCUMENT',
        'IMAGE': 'IMAGE',
        8: 'IMAGE',
        'VIDEO': 'VIDEO',
        9: 'VIDEO'
      };
      __builtIn.Object.defineProperty(Translatable.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.Translatable');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Translatable.prototype, '__fqn__', {
        value: 'wix.api.Translatable',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Translatable.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Translatable.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Translatable;
    }());;
    _api.ServiceAppendix = (function () {
      class ServiceAppendix {
        constructor(props) {
          this.type = props && props.type;
          this.path = props && props.path;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['type'] != null) {
              json['type'] = $root.wix.api.ServiceAppendix.Type[obj['type']];
            } else if (withDefaults) {
              json['type'] = 'UNKNOWN_APPENDIX_TYPE';
            }
            if (obj['path'] != null) {
              json['path'] = obj['path'];
            } else if (withDefaults) {
              json['path'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.ServiceAppendix();
            if (json['type'] != null) {
              result['type'] = typeof json['type'] === 'string' ? json['type'] : $root.wix.api.ServiceAppendix.Type[json['type']];
            } else if (withDefaults !== false) {
              result['type'] = 'UNKNOWN_APPENDIX_TYPE';
            } else {
              delete result['type'];
            }
            if (json['path'] != null) {
              result['path'] = json['path'];
            } else if (withDefaults !== false) {
              result['path'] = '';
            } else {
              delete result['path'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['type'] != null) {
              grpc['type'] = obj['type'];
            }
            if (obj['path'] != null) {
              grpc['path'] = obj['path'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.ServiceAppendix();
            if (grpc['type'] != null) {
              result['type'] = grpc['type'];
            } else {
              result['type'] = 'UNKNOWN_APPENDIX_TYPE';
            }
            if (grpc['path'] != null) {
              result['path'] = grpc['path'];
            } else {
              result['path'] = '';
            }
            return result;
          }
        }
      }
      ServiceAppendix.Type = {
        'UNKNOWN_APPENDIX_TYPE': 'UNKNOWN_APPENDIX_TYPE',
        0: 'UNKNOWN_APPENDIX_TYPE',
        'NILE': 'NILE',
        1: 'NILE',
        'MESSAGE_BUS': 'MESSAGE_BUS',
        2: 'MESSAGE_BUS'
      };
      ServiceAppendix.Type = {
        'UNKNOWN_APPENDIX_TYPE': 'UNKNOWN_APPENDIX_TYPE',
        0: 'UNKNOWN_APPENDIX_TYPE',
        'NILE': 'NILE',
        1: 'NILE',
        'MESSAGE_BUS': 'MESSAGE_BUS',
        2: 'MESSAGE_BUS'
      };
      __builtIn.Object.defineProperty(ServiceAppendix.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.ServiceAppendix');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ServiceAppendix.prototype, '__fqn__', {
        value: 'wix.api.ServiceAppendix',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ServiceAppendix.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ServiceAppendix.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return ServiceAppendix;
    }());;
    _api.Exposure = {
      'PRIVATE': 'PRIVATE',
      0: 'PRIVATE',
      'INTERNAL': 'INTERNAL',
      1: 'INTERNAL',
      'PUBLIC': 'PUBLIC',
      2: 'PUBLIC'
    };
    _api.Maturity = {
      'ALPHA': 'ALPHA',
      0: 'ALPHA',
      'BETA': 'BETA',
      1: 'BETA',
      'IA': 'IA',
      2: 'IA',
      'GA': 'GA',
      3: 'GA',
      'NOT_IMPLEMENTED': 'NOT_IMPLEMENTED',
      4: 'NOT_IMPLEMENTED'
    };
    _api.DecimalValueOptions = (function () {
      class DecimalValueOptions {
        constructor(props) {
          this.lte = props && props.lte;
          this.gte = props && props.gte;
          this.lt = props && props.lt;
          this.gt = props && props.gt;
          this.maxScale = props && props.maxScale;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['lte'] != null) {
              json['lte'] = obj['lte'];
            } else if (withDefaults) {
              json['lte'] = '';
            }
            if (obj['gte'] != null) {
              json['gte'] = obj['gte'];
            } else if (withDefaults) {
              json['gte'] = '';
            }
            if (obj['lt'] != null) {
              json['lt'] = obj['lt'];
            } else if (withDefaults) {
              json['lt'] = '';
            }
            if (obj['gt'] != null) {
              json['gt'] = obj['gt'];
            } else if (withDefaults) {
              json['gt'] = '';
            }
            if (obj['maxScale'] != null) {
              json['maxScale'] = obj['maxScale'];
            } else if (withDefaults) {
              json['maxScale'] = 0;
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.DecimalValueOptions();
            if (json['lte'] != null) {
              result['lte'] = json['lte'];
            } else if (withDefaults !== false) {
              result['lte'] = '';
            } else {
              delete result['lte'];
            }
            if (json['gte'] != null) {
              result['gte'] = json['gte'];
            } else if (withDefaults !== false) {
              result['gte'] = '';
            } else {
              delete result['gte'];
            }
            if (json['lt'] != null) {
              result['lt'] = json['lt'];
            } else if (withDefaults !== false) {
              result['lt'] = '';
            } else {
              delete result['lt'];
            }
            if (json['gt'] != null) {
              result['gt'] = json['gt'];
            } else if (withDefaults !== false) {
              result['gt'] = '';
            } else {
              delete result['gt'];
            }
            if (json['maxScale'] != null) {
              result['maxScale'] = json['maxScale'];
            } else if (withDefaults !== false) {
              result['maxScale'] = 0;
            } else {
              delete result['maxScale'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['lte'] != null) {
              grpc['lte'] = obj['lte'];
            }
            if (obj['gte'] != null) {
              grpc['gte'] = obj['gte'];
            }
            if (obj['lt'] != null) {
              grpc['lt'] = obj['lt'];
            }
            if (obj['gt'] != null) {
              grpc['gt'] = obj['gt'];
            }
            if (obj['maxScale'] != null) {
              grpc['maxScale'] = obj['maxScale'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.DecimalValueOptions();
            if (grpc['lte'] != null) {
              result['lte'] = grpc['lte'];
            } else {
              result['lte'] = '';
            }
            if (grpc['gte'] != null) {
              result['gte'] = grpc['gte'];
            } else {
              result['gte'] = '';
            }
            if (grpc['lt'] != null) {
              result['lt'] = grpc['lt'];
            } else {
              result['lt'] = '';
            }
            if (grpc['gt'] != null) {
              result['gt'] = grpc['gt'];
            } else {
              result['gt'] = '';
            }
            if (grpc['maxScale'] != null) {
              result['maxScale'] = grpc['maxScale'];
            } else {
              result['maxScale'] = 0;
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(DecimalValueOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.DecimalValueOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(DecimalValueOptions.prototype, '__fqn__', {
        value: 'wix.api.DecimalValueOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(DecimalValueOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(DecimalValueOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return DecimalValueOptions;
    }());;
    _api.Format = {
      'EMAIL': 'EMAIL',
      0: 'EMAIL',
      'HOSTNAME': 'HOSTNAME',
      1: 'HOSTNAME',
      'IPV4': 'IPV4',
      2: 'IPV4',
      'IPV6': 'IPV6',
      3: 'IPV6',
      'URI': 'URI',
      4: 'URI',
      'WEB_URL': 'WEB_URL',
      5: 'WEB_URL',
      'PHONE': 'PHONE',
      7: 'PHONE',
      'CREDIT_CARD': 'CREDIT_CARD',
      8: 'CREDIT_CARD',
      'GUID': 'GUID',
      9: 'GUID',
      'COUNTRY': 'COUNTRY',
      10: 'COUNTRY',
      'LANGUAGE': 'LANGUAGE',
      11: 'LANGUAGE',
      'DECIMAL_VALUE': 'DECIMAL_VALUE',
      12: 'DECIMAL_VALUE',
      'CURRENCY': 'CURRENCY',
      13: 'CURRENCY',
      'LANGUAGE_TAG': 'LANGUAGE_TAG',
      14: 'LANGUAGE_TAG',
      'COLOR_HEX': 'COLOR_HEX',
      15: 'COLOR_HEX',
      'LOCAL_DATE': 'LOCAL_DATE',
      16: 'LOCAL_DATE',
      'LOCAL_TIME': 'LOCAL_TIME',
      17: 'LOCAL_TIME',
      'LOCAL_DATE_TIME': 'LOCAL_DATE_TIME',
      18: 'LOCAL_DATE_TIME'
    };
    _api.Details = (function () {
      class Details {
        constructor(props) {
          this.applicationError = props && props.applicationError;
          this.validationError = props && props.validationError;
          this.tracing = props && props.tracing;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['applicationError'] != null) {
              json['applicationError'] = $root.wix.api.ApplicationError.toJSON(obj['applicationError'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['applicationError'];
            }
            if (obj['validationError'] != null) {
              json['validationError'] = $root.wix.api.ValidationError.toJSON(obj['validationError'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['validationError'];
            }
            if (obj['tracing'] != null) {
              json['tracing'] = Object.entries(obj['tracing']).reduce((acc, [k, v]) => {
                acc[k] = v;
                return acc;
              }, {});
            } else if (withDefaults) {
              delete json['tracing'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.Details();
            if (json['applicationError'] != null) {
              result['applicationError'] = $root.wix.api.ApplicationError.fromJSON(json['applicationError'], helper);
            } else if (withDefaults !== false) {
              delete result['applicationError'];
            } else {
              delete result['applicationError'];
            }
            if (json['validationError'] != null) {
              result['validationError'] = $root.wix.api.ValidationError.fromJSON(json['validationError'], helper);
            } else if (withDefaults !== false) {
              delete result['validationError'];
            } else {
              delete result['validationError'];
            }
            if (json['tracing'] != null) {
              result['tracing'] = Object.entries(json['tracing']).reduce((acc, [k, v]) => {
                acc[k] = v;
                return acc;
              }, {});
            } else if (withDefaults !== false) {
              delete result['tracing'];
            } else {
              delete result['tracing'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['applicationError'] != null) {
              grpc['applicationError'] = $root.wix.api.ApplicationError.toGRPC(obj['applicationError'], helper);
            }
            if (obj['validationError'] != null) {
              grpc['validationError'] = $root.wix.api.ValidationError.toGRPC(obj['validationError'], helper);
            }
            if (obj['tracing'] != null) {
              grpc['tracing'] = Object.entries(obj['tracing']).reduce((acc, [k, v]) => {
                acc[k] = v;
                return acc;
              }, {});
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.Details();
            if (grpc['applicationError'] != null) {
              result['applicationError'] = $root.wix.api.ApplicationError.fromGRPC(grpc['applicationError'], helper);
            } else {
              delete result['applicationError'];
            }
            if (grpc['validationError'] != null) {
              result['validationError'] = $root.wix.api.ValidationError.fromGRPC(grpc['validationError'], helper);
            } else {
              delete result['validationError'];
            }
            if (grpc['tracing'] != null) {
              result['tracing'] = Object.entries(grpc['tracing']).reduce((acc, [k, v]) => {
                acc[k] = v;
                return acc;
              }, {});
            } else {
              delete result['tracing'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(Details.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.Details');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Details.prototype, '__fqn__', {
        value: 'wix.api.Details',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Details.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Details.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Details;
    }());;
    _api.ApplicationError = (function () {
      class ApplicationError {
        constructor(props) {
          this.code = props && props.code;
          this.description = props && props.description;
          this.data = props && props.data;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['code'] != null) {
              json['code'] = obj['code'];
            } else if (withDefaults) {
              json['code'] = '';
            }
            if (obj['description'] != null) {
              json['description'] = obj['description'];
            } else if (withDefaults) {
              json['description'] = '';
            }
            if (obj['data'] != null) {
              json['data'] = $root.google.protobuf.Struct.toJSON(obj['data'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['data'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.ApplicationError();
            if (json['code'] != null) {
              result['code'] = json['code'];
            } else if (withDefaults !== false) {
              result['code'] = '';
            } else {
              delete result['code'];
            }
            if (json['description'] != null) {
              result['description'] = json['description'];
            } else if (withDefaults !== false) {
              result['description'] = '';
            } else {
              delete result['description'];
            }
            if (json['data'] != null) {
              result['data'] = $root.google.protobuf.Struct.fromJSON(json['data'], helper);
            } else if (withDefaults !== false) {
              delete result['data'];
            } else {
              delete result['data'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['code'] != null) {
              grpc['code'] = obj['code'];
            }
            if (obj['description'] != null) {
              grpc['description'] = obj['description'];
            }
            if (obj['data'] != null) {
              grpc['data'] = $root.google.protobuf.Struct.toGRPC(obj['data'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.ApplicationError();
            if (grpc['code'] != null) {
              result['code'] = grpc['code'];
            } else {
              result['code'] = '';
            }
            if (grpc['description'] != null) {
              result['description'] = grpc['description'];
            } else {
              result['description'] = '';
            }
            if (grpc['data'] != null) {
              result['data'] = $root.google.protobuf.Struct.fromGRPC(grpc['data'], helper);
            } else {
              delete result['data'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(ApplicationError.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.ApplicationError');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ApplicationError.prototype, '__fqn__', {
        value: 'wix.api.ApplicationError',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ApplicationError.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ApplicationError.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return ApplicationError;
    }());;
    _api.ValidationError = (function () {
      class ValidationError {
        constructor(props) {
          this.fieldViolations = props && props.fieldViolations;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['fieldViolations'] != null) {
              json['fieldViolations'] = obj['fieldViolations'].map(e => {
                return $root.wix.api.ValidationError.FieldViolation.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['fieldViolations'] = [];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.ValidationError();
            if (json['fieldViolations'] != null) {
              result['fieldViolations'] = Array.isArray(json['fieldViolations']) ? json['fieldViolations'].map(e => {
                return $root.wix.api.ValidationError.FieldViolation.fromJSON(e, helper);
              }) : json['fieldViolations'];
            } else if (withDefaults !== false) {
              result['fieldViolations'] = [];
            } else {
              delete result['fieldViolations'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['fieldViolations'] != null) {
              grpc['fieldViolations'] = obj['fieldViolations'].map(e => {
                return $root.wix.api.ValidationError.FieldViolation.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.ValidationError();
            if (grpc['fieldViolations'] != null) {
              result['fieldViolations'] = grpc['fieldViolations'].map(e => {
                return $root.wix.api.ValidationError.FieldViolation.fromGRPC(e, helper);
              });
            } else {
              result['fieldViolations'] = [];
            }
            return result;
          }
        }
      }
      ValidationError.RuleType = {
        'VALIDATION': 'VALIDATION',
        0: 'VALIDATION',
        'OTHER': 'OTHER',
        1: 'OTHER',
        'MAX': 'MAX',
        2: 'MAX',
        'MIN': 'MIN',
        3: 'MIN',
        'MAX_LENGTH': 'MAX_LENGTH',
        4: 'MAX_LENGTH',
        'MIN_LENGTH': 'MIN_LENGTH',
        5: 'MIN_LENGTH',
        'MAX_SIZE': 'MAX_SIZE',
        6: 'MAX_SIZE',
        'MIN_SIZE': 'MIN_SIZE',
        7: 'MIN_SIZE',
        'FORMAT': 'FORMAT',
        8: 'FORMAT',
        'DECIMAL_LTE': 'DECIMAL_LTE',
        9: 'DECIMAL_LTE',
        'DECIMAL_GTE': 'DECIMAL_GTE',
        10: 'DECIMAL_GTE',
        'DECIMAL_LT': 'DECIMAL_LT',
        11: 'DECIMAL_LT',
        'DECIMAL_GT': 'DECIMAL_GT',
        12: 'DECIMAL_GT',
        'DECIMAL_MAX_SCALE': 'DECIMAL_MAX_SCALE',
        13: 'DECIMAL_MAX_SCALE',
        'INVALID_ENUM_VALUE': 'INVALID_ENUM_VALUE',
        14: 'INVALID_ENUM_VALUE',
        'REQUIRED_FIELD': 'REQUIRED_FIELD',
        15: 'REQUIRED_FIELD'
      };
      ValidationError.FieldViolation = (function () {
        class FieldViolation {
          constructor(props) {
            this.field = props && props.field;
            this.description = props && props.description;
            this.violatedRule = props && props.violatedRule;
            this.ruleName = props && props.ruleName;
            this.data = props && props.data;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['field'] != null) {
                json['field'] = obj['field'];
              } else if (withDefaults) {
                json['field'] = '';
              }
              if (obj['description'] != null) {
                json['description'] = obj['description'];
              } else if (withDefaults) {
                json['description'] = '';
              }
              if (obj['violatedRule'] != null) {
                json['violatedRule'] = $root.wix.api.ValidationError.RuleType[obj['violatedRule']];
              } else if (withDefaults) {
                json['violatedRule'] = 'VALIDATION';
              }
              if (obj['ruleName'] != null) {
                json['ruleName'] = $root.google.protobuf.StringValue.toJSON(obj['ruleName'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['ruleName'];
              }
              if (obj['data'] != null) {
                json['data'] = $root.google.protobuf.Struct.toJSON(obj['data'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['data'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.wix.api.ValidationError.FieldViolation();
              if (json['field'] != null) {
                result['field'] = json['field'];
              } else if (withDefaults !== false) {
                result['field'] = '';
              } else {
                delete result['field'];
              }
              if (json['description'] != null) {
                result['description'] = json['description'];
              } else if (withDefaults !== false) {
                result['description'] = '';
              } else {
                delete result['description'];
              }
              if (json['violatedRule'] != null) {
                result['violatedRule'] = typeof json['violatedRule'] === 'string' ? json['violatedRule'] : $root.wix.api.ValidationError.RuleType[json['violatedRule']];
              } else if (withDefaults !== false) {
                result['violatedRule'] = 'VALIDATION';
              } else {
                delete result['violatedRule'];
              }
              if (json['ruleName'] != null) {
                result['ruleName'] = $root.google.protobuf.StringValue.fromJSON(json['ruleName'], helper);
              } else if (withDefaults !== false) {
                delete result['ruleName'];
              } else {
                delete result['ruleName'];
              }
              if (json['data'] != null) {
                result['data'] = $root.google.protobuf.Struct.fromJSON(json['data'], helper);
              } else if (withDefaults !== false) {
                delete result['data'];
              } else {
                delete result['data'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['field'] != null) {
                grpc['field'] = obj['field'];
              }
              if (obj['description'] != null) {
                grpc['description'] = obj['description'];
              }
              if (obj['violatedRule'] != null) {
                grpc['violatedRule'] = obj['violatedRule'];
              }
              if (obj['ruleName'] != null) {
                grpc['ruleName'] = $root.google.protobuf.StringValue.toGRPC(obj['ruleName'], helper);
              }
              if (obj['data'] != null) {
                grpc['data'] = $root.google.protobuf.Struct.toGRPC(obj['data'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.api.ValidationError.FieldViolation();
              if (grpc['field'] != null) {
                result['field'] = grpc['field'];
              } else {
                result['field'] = '';
              }
              if (grpc['description'] != null) {
                result['description'] = grpc['description'];
              } else {
                result['description'] = '';
              }
              if (grpc['violatedRule'] != null) {
                result['violatedRule'] = grpc['violatedRule'];
              } else {
                result['violatedRule'] = 'VALIDATION';
              }
              if (grpc['ruleName'] != null) {
                result['ruleName'] = $root.google.protobuf.StringValue.fromGRPC(grpc['ruleName'], helper);
              } else {
                delete result['ruleName'];
              }
              if (grpc['data'] != null) {
                result['data'] = $root.google.protobuf.Struct.fromGRPC(grpc['data'], helper);
              } else {
                delete result['data'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(FieldViolation.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.api.ValidationError.FieldViolation');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(FieldViolation.prototype, '__fqn__', {
          value: 'wix.api.ValidationError.FieldViolation',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(FieldViolation.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(FieldViolation.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return FieldViolation;
      }());;
      ValidationError.RuleType = {
        'VALIDATION': 'VALIDATION',
        0: 'VALIDATION',
        'OTHER': 'OTHER',
        1: 'OTHER',
        'MAX': 'MAX',
        2: 'MAX',
        'MIN': 'MIN',
        3: 'MIN',
        'MAX_LENGTH': 'MAX_LENGTH',
        4: 'MAX_LENGTH',
        'MIN_LENGTH': 'MIN_LENGTH',
        5: 'MIN_LENGTH',
        'MAX_SIZE': 'MAX_SIZE',
        6: 'MAX_SIZE',
        'MIN_SIZE': 'MIN_SIZE',
        7: 'MIN_SIZE',
        'FORMAT': 'FORMAT',
        8: 'FORMAT',
        'DECIMAL_LTE': 'DECIMAL_LTE',
        9: 'DECIMAL_LTE',
        'DECIMAL_GTE': 'DECIMAL_GTE',
        10: 'DECIMAL_GTE',
        'DECIMAL_LT': 'DECIMAL_LT',
        11: 'DECIMAL_LT',
        'DECIMAL_GT': 'DECIMAL_GT',
        12: 'DECIMAL_GT',
        'DECIMAL_MAX_SCALE': 'DECIMAL_MAX_SCALE',
        13: 'DECIMAL_MAX_SCALE',
        'INVALID_ENUM_VALUE': 'INVALID_ENUM_VALUE',
        14: 'INVALID_ENUM_VALUE',
        'REQUIRED_FIELD': 'REQUIRED_FIELD',
        15: 'REQUIRED_FIELD'
      };
      ValidationError.FieldViolation = (function () {
        class FieldViolation {
          constructor(props) {
            this.field = props && props.field;
            this.description = props && props.description;
            this.violatedRule = props && props.violatedRule;
            this.ruleName = props && props.ruleName;
            this.data = props && props.data;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['field'] != null) {
                json['field'] = obj['field'];
              } else if (withDefaults) {
                json['field'] = '';
              }
              if (obj['description'] != null) {
                json['description'] = obj['description'];
              } else if (withDefaults) {
                json['description'] = '';
              }
              if (obj['violatedRule'] != null) {
                json['violatedRule'] = $root.wix.api.ValidationError.RuleType[obj['violatedRule']];
              } else if (withDefaults) {
                json['violatedRule'] = 'VALIDATION';
              }
              if (obj['ruleName'] != null) {
                json['ruleName'] = $root.google.protobuf.StringValue.toJSON(obj['ruleName'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['ruleName'];
              }
              if (obj['data'] != null) {
                json['data'] = $root.google.protobuf.Struct.toJSON(obj['data'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['data'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.wix.api.ValidationError.FieldViolation();
              if (json['field'] != null) {
                result['field'] = json['field'];
              } else if (withDefaults !== false) {
                result['field'] = '';
              } else {
                delete result['field'];
              }
              if (json['description'] != null) {
                result['description'] = json['description'];
              } else if (withDefaults !== false) {
                result['description'] = '';
              } else {
                delete result['description'];
              }
              if (json['violatedRule'] != null) {
                result['violatedRule'] = typeof json['violatedRule'] === 'string' ? json['violatedRule'] : $root.wix.api.ValidationError.RuleType[json['violatedRule']];
              } else if (withDefaults !== false) {
                result['violatedRule'] = 'VALIDATION';
              } else {
                delete result['violatedRule'];
              }
              if (json['ruleName'] != null) {
                result['ruleName'] = $root.google.protobuf.StringValue.fromJSON(json['ruleName'], helper);
              } else if (withDefaults !== false) {
                delete result['ruleName'];
              } else {
                delete result['ruleName'];
              }
              if (json['data'] != null) {
                result['data'] = $root.google.protobuf.Struct.fromJSON(json['data'], helper);
              } else if (withDefaults !== false) {
                delete result['data'];
              } else {
                delete result['data'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['field'] != null) {
                grpc['field'] = obj['field'];
              }
              if (obj['description'] != null) {
                grpc['description'] = obj['description'];
              }
              if (obj['violatedRule'] != null) {
                grpc['violatedRule'] = obj['violatedRule'];
              }
              if (obj['ruleName'] != null) {
                grpc['ruleName'] = $root.google.protobuf.StringValue.toGRPC(obj['ruleName'], helper);
              }
              if (obj['data'] != null) {
                grpc['data'] = $root.google.protobuf.Struct.toGRPC(obj['data'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.wix.api.ValidationError.FieldViolation();
              if (grpc['field'] != null) {
                result['field'] = grpc['field'];
              } else {
                result['field'] = '';
              }
              if (grpc['description'] != null) {
                result['description'] = grpc['description'];
              } else {
                result['description'] = '';
              }
              if (grpc['violatedRule'] != null) {
                result['violatedRule'] = grpc['violatedRule'];
              } else {
                result['violatedRule'] = 'VALIDATION';
              }
              if (grpc['ruleName'] != null) {
                result['ruleName'] = $root.google.protobuf.StringValue.fromGRPC(grpc['ruleName'], helper);
              } else {
                delete result['ruleName'];
              }
              if (grpc['data'] != null) {
                result['data'] = $root.google.protobuf.Struct.fromGRPC(grpc['data'], helper);
              } else {
                delete result['data'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(FieldViolation.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('wix.api.ValidationError.FieldViolation');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(FieldViolation.prototype, '__fqn__', {
          value: 'wix.api.ValidationError.FieldViolation',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(FieldViolation.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(FieldViolation.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return FieldViolation;
      }());;
      __builtIn.Object.defineProperty(ValidationError.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.ValidationError');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ValidationError.prototype, '__fqn__', {
        value: 'wix.api.ValidationError',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ValidationError.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ValidationError.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return ValidationError;
    }());;
    _api.LimitRuleInt32DataPayload = (function () {
      class LimitRuleInt32DataPayload {
        constructor(props) {
          this.threshold = props && props.threshold;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['threshold'] != null) {
              json['threshold'] = obj['threshold'];
            } else if (withDefaults) {
              json['threshold'] = 0;
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.LimitRuleInt32DataPayload();
            if (json['threshold'] != null) {
              result['threshold'] = json['threshold'];
            } else if (withDefaults !== false) {
              result['threshold'] = 0;
            } else {
              delete result['threshold'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['threshold'] != null) {
              grpc['threshold'] = obj['threshold'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.LimitRuleInt32DataPayload();
            if (grpc['threshold'] != null) {
              result['threshold'] = grpc['threshold'];
            } else {
              result['threshold'] = 0;
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(LimitRuleInt32DataPayload.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.LimitRuleInt32DataPayload');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(LimitRuleInt32DataPayload.prototype, '__fqn__', {
        value: 'wix.api.LimitRuleInt32DataPayload',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(LimitRuleInt32DataPayload.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(LimitRuleInt32DataPayload.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return LimitRuleInt32DataPayload;
    }());;
    _api.LimitRuleDoubleDataPayload = (function () {
      class LimitRuleDoubleDataPayload {
        constructor(props) {
          this.threshold = props && props.threshold;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['threshold'] != null) {
              json['threshold'] = obj['threshold'] == null ? obj['threshold'] : isNaN(obj['threshold']) ? 'NaN' : isFinite(obj['threshold']) ? obj['threshold'] : obj['threshold'].toString();
            } else if (withDefaults) {
              json['threshold'] = 0;
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.LimitRuleDoubleDataPayload();
            if (json['threshold'] != null) {
              result['threshold'] = json['threshold'] === 'NaN' ? NaN : json['threshold'] === 'Infinity' ? Infinity : json['threshold'] === '-Infinity' ? -Infinity : json['threshold'];
            } else if (withDefaults !== false) {
              result['threshold'] = 0;
            } else {
              delete result['threshold'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['threshold'] != null) {
              grpc['threshold'] = obj['threshold'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.LimitRuleDoubleDataPayload();
            if (grpc['threshold'] != null) {
              result['threshold'] = grpc['threshold'];
            } else {
              result['threshold'] = 0;
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(LimitRuleDoubleDataPayload.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.LimitRuleDoubleDataPayload');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(LimitRuleDoubleDataPayload.prototype, '__fqn__', {
        value: 'wix.api.LimitRuleDoubleDataPayload',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(LimitRuleDoubleDataPayload.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(LimitRuleDoubleDataPayload.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return LimitRuleDoubleDataPayload;
    }());;
    _api.LimitRuleStringDataPayload = (function () {
      class LimitRuleStringDataPayload {
        constructor(props) {
          this.threshold = props && props.threshold;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['threshold'] != null) {
              json['threshold'] = obj['threshold'];
            } else if (withDefaults) {
              json['threshold'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.LimitRuleStringDataPayload();
            if (json['threshold'] != null) {
              result['threshold'] = json['threshold'];
            } else if (withDefaults !== false) {
              result['threshold'] = '';
            } else {
              delete result['threshold'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['threshold'] != null) {
              grpc['threshold'] = obj['threshold'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.LimitRuleStringDataPayload();
            if (grpc['threshold'] != null) {
              result['threshold'] = grpc['threshold'];
            } else {
              result['threshold'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(LimitRuleStringDataPayload.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.LimitRuleStringDataPayload');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(LimitRuleStringDataPayload.prototype, '__fqn__', {
        value: 'wix.api.LimitRuleStringDataPayload',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(LimitRuleStringDataPayload.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(LimitRuleStringDataPayload.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return LimitRuleStringDataPayload;
    }());;
    _api.FormatRuleDataPayload = (function () {
      class FormatRuleDataPayload {
        constructor(props) {
          this.type = props && props.type;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['type'] != null) {
              json['type'] = obj['type'];
            } else if (withDefaults) {
              json['type'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.FormatRuleDataPayload();
            if (json['type'] != null) {
              result['type'] = json['type'];
            } else if (withDefaults !== false) {
              result['type'] = '';
            } else {
              delete result['type'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['type'] != null) {
              grpc['type'] = obj['type'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.FormatRuleDataPayload();
            if (grpc['type'] != null) {
              result['type'] = grpc['type'];
            } else {
              result['type'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(FormatRuleDataPayload.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.FormatRuleDataPayload');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FormatRuleDataPayload.prototype, '__fqn__', {
        value: 'wix.api.FormatRuleDataPayload',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FormatRuleDataPayload.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FormatRuleDataPayload.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return FormatRuleDataPayload;
    }());;
    _api.EnumRuleDataPayload = (function () {
      class EnumRuleDataPayload {
        constructor(props) {
          this.supported = props && props.supported;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['supported'] != null) {
              json['supported'] = obj['supported'].map(e => {
                return e;
              });
            } else if (withDefaults) {
              json['supported'] = [];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.EnumRuleDataPayload();
            if (json['supported'] != null) {
              result['supported'] = Array.isArray(json['supported']) ? json['supported'].map(e => {
                return e;
              }) : json['supported'];
            } else if (withDefaults !== false) {
              result['supported'] = [];
            } else {
              delete result['supported'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['supported'] != null) {
              grpc['supported'] = obj['supported'].map(e => {
                return e;
              });
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.EnumRuleDataPayload();
            if (grpc['supported'] != null) {
              result['supported'] = grpc['supported'].map(e => {
                return e;
              });
            } else {
              result['supported'] = [];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(EnumRuleDataPayload.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.EnumRuleDataPayload');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(EnumRuleDataPayload.prototype, '__fqn__', {
        value: 'wix.api.EnumRuleDataPayload',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(EnumRuleDataPayload.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(EnumRuleDataPayload.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return EnumRuleDataPayload;
    }());;
    _api.ServiceEntity = (function () {
      class ServiceEntity {
        constructor(props) {
          this.message = props && props.message;
          this.namespace = props && props.namespace;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['message'] != null) {
              json['message'] = obj['message'];
            } else if (withDefaults) {
              json['message'] = '';
            }
            if (obj['namespace'] != null) {
              json['namespace'] = obj['namespace'];
            } else if (withDefaults) {
              json['namespace'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.ServiceEntity();
            if (json['message'] != null) {
              result['message'] = json['message'];
            } else if (withDefaults !== false) {
              result['message'] = '';
            } else {
              delete result['message'];
            }
            if (json['namespace'] != null) {
              result['namespace'] = json['namespace'];
            } else if (withDefaults !== false) {
              result['namespace'] = '';
            } else {
              delete result['namespace'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['message'] != null) {
              grpc['message'] = obj['message'];
            }
            if (obj['namespace'] != null) {
              grpc['namespace'] = obj['namespace'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.ServiceEntity();
            if (grpc['message'] != null) {
              result['message'] = grpc['message'];
            } else {
              result['message'] = '';
            }
            if (grpc['namespace'] != null) {
              result['namespace'] = grpc['namespace'];
            } else {
              result['namespace'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(ServiceEntity.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.ServiceEntity');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ServiceEntity.prototype, '__fqn__', {
        value: 'wix.api.ServiceEntity',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ServiceEntity.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ServiceEntity.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return ServiceEntity;
    }());;
    _api.Entity = (function () {
      class Entity {
        constructor(props) {
          this.fqdn = props && props.fqdn;
          this.exposure = props && props.exposure;
          this.appendixFiles = props && props.appendixFiles;
          this.oldFqdnForBackwardsCompatibility = props && props.oldFqdnForBackwardsCompatibility;
          this.segment = props && props.segment;
          this.implements = props && props.implements;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['fqdn'] != null) {
              json['fqdn'] = obj['fqdn'];
            } else if (withDefaults) {
              json['fqdn'] = '';
            }
            if (obj['exposure'] != null) {
              json['exposure'] = $root.wix.api.Exposure[obj['exposure']];
            } else if (withDefaults) {
              json['exposure'] = 'PRIVATE';
            }
            if (obj['appendixFiles'] != null) {
              json['appendixFiles'] = obj['appendixFiles'].map(e => {
                return $root.wix.api.MessageAppendix.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['appendixFiles'] = [];
            }
            if (obj['oldFqdnForBackwardsCompatibility'] != null) {
              json['oldFqdnForBackwardsCompatibility'] = obj['oldFqdnForBackwardsCompatibility'];
            } else if (withDefaults) {
              json['oldFqdnForBackwardsCompatibility'] = '';
            }
            if (obj['segment'] != null) {
              json['segment'] = $root.wix.api.Segment.Segment[obj['segment']];
            } else if (withDefaults) {
              json['segment'] = 'UNSPECIFIED';
            }
            if (obj['implements'] != null) {
              json['implements'] = obj['implements'].map(e => {
                return e;
              });
            } else if (withDefaults) {
              json['implements'] = [];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.Entity();
            if (json['fqdn'] != null) {
              result['fqdn'] = json['fqdn'];
            } else if (withDefaults !== false) {
              result['fqdn'] = '';
            } else {
              delete result['fqdn'];
            }
            if (json['exposure'] != null) {
              result['exposure'] = typeof json['exposure'] === 'string' ? json['exposure'] : $root.wix.api.Exposure[json['exposure']];
            } else if (withDefaults !== false) {
              result['exposure'] = 'PRIVATE';
            } else {
              delete result['exposure'];
            }
            if (json['appendixFiles'] != null) {
              result['appendixFiles'] = Array.isArray(json['appendixFiles']) ? json['appendixFiles'].map(e => {
                return $root.wix.api.MessageAppendix.fromJSON(e, helper);
              }) : json['appendixFiles'];
            } else if (withDefaults !== false) {
              result['appendixFiles'] = [];
            } else {
              delete result['appendixFiles'];
            }
            if (json['oldFqdnForBackwardsCompatibility'] != null) {
              result['oldFqdnForBackwardsCompatibility'] = json['oldFqdnForBackwardsCompatibility'];
            } else if (withDefaults !== false) {
              result['oldFqdnForBackwardsCompatibility'] = '';
            } else {
              delete result['oldFqdnForBackwardsCompatibility'];
            }
            if (json['segment'] != null) {
              result['segment'] = typeof json['segment'] === 'string' ? json['segment'] : $root.wix.api.Segment.Segment[json['segment']];
            } else if (withDefaults !== false) {
              result['segment'] = 'UNSPECIFIED';
            } else {
              delete result['segment'];
            }
            if (json['implements'] != null) {
              result['implements'] = Array.isArray(json['implements']) ? json['implements'].map(e => {
                return e;
              }) : json['implements'];
            } else if (withDefaults !== false) {
              result['implements'] = [];
            } else {
              delete result['implements'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['fqdn'] != null) {
              grpc['fqdn'] = obj['fqdn'];
            }
            if (obj['exposure'] != null) {
              grpc['exposure'] = obj['exposure'];
            }
            if (obj['appendixFiles'] != null) {
              grpc['appendixFiles'] = obj['appendixFiles'].map(e => {
                return $root.wix.api.MessageAppendix.toGRPC(e, helper);
              });
            }
            if (obj['oldFqdnForBackwardsCompatibility'] != null) {
              grpc['oldFqdnForBackwardsCompatibility'] = obj['oldFqdnForBackwardsCompatibility'];
            }
            if (obj['segment'] != null) {
              grpc['segment'] = obj['segment'];
            }
            if (obj['implements'] != null) {
              grpc['implements'] = obj['implements'].map(e => {
                return e;
              });
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.Entity();
            if (grpc['fqdn'] != null) {
              result['fqdn'] = grpc['fqdn'];
            } else {
              result['fqdn'] = '';
            }
            if (grpc['exposure'] != null) {
              result['exposure'] = grpc['exposure'];
            } else {
              result['exposure'] = 'PRIVATE';
            }
            if (grpc['appendixFiles'] != null) {
              result['appendixFiles'] = grpc['appendixFiles'].map(e => {
                return $root.wix.api.MessageAppendix.fromGRPC(e, helper);
              });
            } else {
              result['appendixFiles'] = [];
            }
            if (grpc['oldFqdnForBackwardsCompatibility'] != null) {
              result['oldFqdnForBackwardsCompatibility'] = grpc['oldFqdnForBackwardsCompatibility'];
            } else {
              result['oldFqdnForBackwardsCompatibility'] = '';
            }
            if (grpc['segment'] != null) {
              result['segment'] = grpc['segment'];
            } else {
              result['segment'] = 'UNSPECIFIED';
            }
            if (grpc['implements'] != null) {
              result['implements'] = grpc['implements'].map(e => {
                return e;
              });
            } else {
              result['implements'] = [];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(Entity.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.Entity');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Entity.prototype, '__fqn__', {
        value: 'wix.api.Entity',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Entity.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Entity.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Entity;
    }());;
    _api.MessageAppendix = (function () {
      class MessageAppendix {
        constructor(props) {
          this.type = props && props.type;
          this.path = props && props.path;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['type'] != null) {
              json['type'] = $root.wix.api.MessageAppendix.Type[obj['type']];
            } else if (withDefaults) {
              json['type'] = 'UNKNOWN_APPENDIX_TYPE';
            }
            if (obj['path'] != null) {
              json['path'] = obj['path'];
            } else if (withDefaults) {
              json['path'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.MessageAppendix();
            if (json['type'] != null) {
              result['type'] = typeof json['type'] === 'string' ? json['type'] : $root.wix.api.MessageAppendix.Type[json['type']];
            } else if (withDefaults !== false) {
              result['type'] = 'UNKNOWN_APPENDIX_TYPE';
            } else {
              delete result['type'];
            }
            if (json['path'] != null) {
              result['path'] = json['path'];
            } else if (withDefaults !== false) {
              result['path'] = '';
            } else {
              delete result['path'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['type'] != null) {
              grpc['type'] = obj['type'];
            }
            if (obj['path'] != null) {
              grpc['path'] = obj['path'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.MessageAppendix();
            if (grpc['type'] != null) {
              result['type'] = grpc['type'];
            } else {
              result['type'] = 'UNKNOWN_APPENDIX_TYPE';
            }
            if (grpc['path'] != null) {
              result['path'] = grpc['path'];
            } else {
              result['path'] = '';
            }
            return result;
          }
        }
      }
      MessageAppendix.Type = {
        'UNKNOWN_APPENDIX_TYPE': 'UNKNOWN_APPENDIX_TYPE',
        0: 'UNKNOWN_APPENDIX_TYPE',
        'AUTO_VELO': 'AUTO_VELO',
        1: 'AUTO_VELO',
        'DOCS_CONF': 'DOCS_CONF',
        2: 'DOCS_CONF',
        'MULTILINGUAL': 'MULTILINGUAL',
        3: 'MULTILINGUAL'
      };
      MessageAppendix.Type = {
        'UNKNOWN_APPENDIX_TYPE': 'UNKNOWN_APPENDIX_TYPE',
        0: 'UNKNOWN_APPENDIX_TYPE',
        'AUTO_VELO': 'AUTO_VELO',
        1: 'AUTO_VELO',
        'DOCS_CONF': 'DOCS_CONF',
        2: 'DOCS_CONF',
        'MULTILINGUAL': 'MULTILINGUAL',
        3: 'MULTILINGUAL'
      };
      __builtIn.Object.defineProperty(MessageAppendix.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.MessageAppendix');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(MessageAppendix.prototype, '__fqn__', {
        value: 'wix.api.MessageAppendix',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(MessageAppendix.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(MessageAppendix.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return MessageAppendix;
    }());;
    _api.Callback = (function () {
      class Callback {
        constructor(props) {
          this.topic = props && props.topic;
          this.segment = props && props.segment;
          this.payload = props && props.payload;
          this.permission = props && props.permission;
          this.eventType = props && props.eventType;
          this.exposure = props && props.exposure;
          this.maturity = props && props.maturity;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['topic'] != null) {
              json['topic'] = obj['topic'];
            } else if (withDefaults) {
              json['topic'] = '';
            }
            if (obj['segment'] != null) {
              json['segment'] = $root.wix.api.Segment.Segment[obj['segment']];
            } else if (withDefaults) {
              json['segment'] = 'UNSPECIFIED';
            }
            if (obj['payload'] != null) {
              json['payload'] = obj['payload'];
            } else if (withDefaults) {
              json['payload'] = '';
            }
            if (obj['permission'] != null) {
              json['permission'] = obj['permission'];
            } else if (withDefaults) {
              json['permission'] = '';
            }
            if (obj['eventType'] != null) {
              json['eventType'] = $root.wix.api.Callback.EventType[obj['eventType']];
            } else if (withDefaults) {
              json['eventType'] = 'UNKNOWN';
            }
            if (obj['exposure'] != null) {
              json['exposure'] = $root.wix.api.Exposure[obj['exposure']];
            } else if (withDefaults) {
              json['exposure'] = 'PRIVATE';
            }
            if (obj['maturity'] != null) {
              json['maturity'] = $root.wix.api.Maturity[obj['maturity']];
            } else if (withDefaults) {
              json['maturity'] = 'ALPHA';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.Callback();
            if (json['topic'] != null) {
              result['topic'] = json['topic'];
            } else if (withDefaults !== false) {
              result['topic'] = '';
            } else {
              delete result['topic'];
            }
            if (json['segment'] != null) {
              result['segment'] = typeof json['segment'] === 'string' ? json['segment'] : $root.wix.api.Segment.Segment[json['segment']];
            } else if (withDefaults !== false) {
              result['segment'] = 'UNSPECIFIED';
            } else {
              delete result['segment'];
            }
            if (json['payload'] != null) {
              result['payload'] = json['payload'];
            } else if (withDefaults !== false) {
              result['payload'] = '';
            } else {
              delete result['payload'];
            }
            if (json['permission'] != null) {
              result['permission'] = json['permission'];
            } else if (withDefaults !== false) {
              result['permission'] = '';
            } else {
              delete result['permission'];
            }
            if (json['eventType'] != null) {
              result['eventType'] = typeof json['eventType'] === 'string' ? json['eventType'] : $root.wix.api.Callback.EventType[json['eventType']];
            } else if (withDefaults !== false) {
              result['eventType'] = 'UNKNOWN';
            } else {
              delete result['eventType'];
            }
            if (json['exposure'] != null) {
              result['exposure'] = typeof json['exposure'] === 'string' ? json['exposure'] : $root.wix.api.Exposure[json['exposure']];
            } else if (withDefaults !== false) {
              result['exposure'] = 'PRIVATE';
            } else {
              delete result['exposure'];
            }
            if (json['maturity'] != null) {
              result['maturity'] = typeof json['maturity'] === 'string' ? json['maturity'] : $root.wix.api.Maturity[json['maturity']];
            } else if (withDefaults !== false) {
              result['maturity'] = 'ALPHA';
            } else {
              delete result['maturity'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['topic'] != null) {
              grpc['topic'] = obj['topic'];
            }
            if (obj['segment'] != null) {
              grpc['segment'] = obj['segment'];
            }
            if (obj['payload'] != null) {
              grpc['payload'] = obj['payload'];
            }
            if (obj['permission'] != null) {
              grpc['permission'] = obj['permission'];
            }
            if (obj['eventType'] != null) {
              grpc['eventType'] = obj['eventType'];
            }
            if (obj['exposure'] != null) {
              grpc['exposure'] = obj['exposure'];
            }
            if (obj['maturity'] != null) {
              grpc['maturity'] = obj['maturity'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.Callback();
            if (grpc['topic'] != null) {
              result['topic'] = grpc['topic'];
            } else {
              result['topic'] = '';
            }
            if (grpc['segment'] != null) {
              result['segment'] = grpc['segment'];
            } else {
              result['segment'] = 'UNSPECIFIED';
            }
            if (grpc['payload'] != null) {
              result['payload'] = grpc['payload'];
            } else {
              result['payload'] = '';
            }
            if (grpc['permission'] != null) {
              result['permission'] = grpc['permission'];
            } else {
              result['permission'] = '';
            }
            if (grpc['eventType'] != null) {
              result['eventType'] = grpc['eventType'];
            } else {
              result['eventType'] = 'UNKNOWN';
            }
            if (grpc['exposure'] != null) {
              result['exposure'] = grpc['exposure'];
            } else {
              result['exposure'] = 'PRIVATE';
            }
            if (grpc['maturity'] != null) {
              result['maturity'] = grpc['maturity'];
            } else {
              result['maturity'] = 'ALPHA';
            }
            return result;
          }
        }
      }
      Callback.EventType = {
        'UNKNOWN': 'UNKNOWN',
        0: 'UNKNOWN',
        'CREATED': 'CREATED',
        1: 'CREATED',
        'UPDATED': 'UPDATED',
        2: 'UPDATED',
        'DELETED': 'DELETED',
        3: 'DELETED',
        'ACTION': 'ACTION',
        4: 'ACTION'
      };
      Callback.EventType = {
        'UNKNOWN': 'UNKNOWN',
        0: 'UNKNOWN',
        'CREATED': 'CREATED',
        1: 'CREATED',
        'UPDATED': 'UPDATED',
        2: 'UPDATED',
        'DELETED': 'DELETED',
        3: 'DELETED',
        'ACTION': 'ACTION',
        4: 'ACTION'
      };
      __builtIn.Object.defineProperty(Callback.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.Callback');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Callback.prototype, '__fqn__', {
        value: 'wix.api.Callback',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Callback.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Callback.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Callback;
    }());;
    _api.CallbackDeprecation = (function () {
      class CallbackDeprecation {
        constructor(props) {
          this.replacedBy = props && props.replacedBy;
          this.targetRemovalDate = props && props.targetRemovalDate;
          this.eventType = props && props.eventType;
          this.customSlug = props && props.customSlug;
          this.payload = props && props.payload;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['replacedBy'] != null) {
              json['replacedBy'] = obj['replacedBy'];
            } else if (withDefaults) {
              json['replacedBy'] = '';
            }
            if (obj['targetRemovalDate'] != null) {
              json['targetRemovalDate'] = obj['targetRemovalDate'];
            } else if (withDefaults) {
              json['targetRemovalDate'] = '';
            }
            if (obj['eventType'] != null) {
              json['eventType'] = $root.wix.api.Callback.EventType[obj['eventType']];
            } else if (withDefaults) {
              json['eventType'] = 'UNKNOWN';
            }
            if (obj['customSlug'] != null) {
              json['customSlug'] = obj['customSlug'];
            } else if (withDefaults) {
              json['customSlug'] = '';
            }
            if (obj['payload'] != null) {
              json['payload'] = obj['payload'];
            } else if (withDefaults) {
              json['payload'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.CallbackDeprecation();
            if (json['replacedBy'] != null) {
              result['replacedBy'] = json['replacedBy'];
            } else if (withDefaults !== false) {
              result['replacedBy'] = '';
            } else {
              delete result['replacedBy'];
            }
            if (json['targetRemovalDate'] != null) {
              result['targetRemovalDate'] = json['targetRemovalDate'];
            } else if (withDefaults !== false) {
              result['targetRemovalDate'] = '';
            } else {
              delete result['targetRemovalDate'];
            }
            if (json['eventType'] != null) {
              result['eventType'] = typeof json['eventType'] === 'string' ? json['eventType'] : $root.wix.api.Callback.EventType[json['eventType']];
            } else if (withDefaults !== false) {
              result['eventType'] = 'UNKNOWN';
            } else {
              delete result['eventType'];
            }
            if (json['customSlug'] != null) {
              result['customSlug'] = json['customSlug'];
            } else if (withDefaults !== false) {
              result['customSlug'] = '';
            } else {
              delete result['customSlug'];
            }
            if (json['payload'] != null) {
              result['payload'] = json['payload'];
            } else if (withDefaults !== false) {
              result['payload'] = '';
            } else {
              delete result['payload'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['replacedBy'] != null) {
              grpc['replacedBy'] = obj['replacedBy'];
            }
            if (obj['targetRemovalDate'] != null) {
              grpc['targetRemovalDate'] = obj['targetRemovalDate'];
            }
            if (obj['eventType'] != null) {
              grpc['eventType'] = obj['eventType'];
            }
            if (obj['customSlug'] != null) {
              grpc['customSlug'] = obj['customSlug'];
            }
            if (obj['payload'] != null) {
              grpc['payload'] = obj['payload'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.CallbackDeprecation();
            if (grpc['replacedBy'] != null) {
              result['replacedBy'] = grpc['replacedBy'];
            } else {
              result['replacedBy'] = '';
            }
            if (grpc['targetRemovalDate'] != null) {
              result['targetRemovalDate'] = grpc['targetRemovalDate'];
            } else {
              result['targetRemovalDate'] = '';
            }
            if (grpc['eventType'] != null) {
              result['eventType'] = grpc['eventType'];
            } else {
              result['eventType'] = 'UNKNOWN';
            }
            if (grpc['customSlug'] != null) {
              result['customSlug'] = grpc['customSlug'];
            } else {
              result['customSlug'] = '';
            }
            if (grpc['payload'] != null) {
              result['payload'] = grpc['payload'];
            } else {
              result['payload'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(CallbackDeprecation.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.CallbackDeprecation');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(CallbackDeprecation.prototype, '__fqn__', {
        value: 'wix.api.CallbackDeprecation',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(CallbackDeprecation.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(CallbackDeprecation.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return CallbackDeprecation;
    }());;
    _api.Segment = (function () {
      class Segment {
        constructor(props) {
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.wix.api.Segment();
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.wix.api.Segment();
            return result;
          }
        }
      }
      Segment.Segment = {
        'UNSPECIFIED': 'UNSPECIFIED',
        0: 'UNSPECIFIED',
        'USERS': 'USERS',
        1: 'USERS',
        'PUBLIC': 'PUBLIC',
        2: 'PUBLIC',
        'OTHERS': 'OTHERS',
        3: 'OTHERS'
      };
      Segment.Segment = {
        'UNSPECIFIED': 'UNSPECIFIED',
        0: 'UNSPECIFIED',
        'USERS': 'USERS',
        1: 'USERS',
        'PUBLIC': 'PUBLIC',
        2: 'PUBLIC',
        'OTHERS': 'OTHERS',
        3: 'OTHERS'
      };
      __builtIn.Object.defineProperty(Segment.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('wix.api.Segment');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Segment.prototype, '__fqn__', {
        value: 'wix.api.Segment',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Segment.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Segment.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Segment;
    }());;
    return _api;
  }());;
  return _wix;
}());;
$root.com = (function () {
  const _com = {};
  _com.wixpress = (function () {
    const _wixpress = {};
    _wixpress.wixdocs = (function () {
      const _wixdocs = {};
      _wixdocs.BackstageService = (function () {
        class BackstageService {
          getUserData(aspects, msg) {
            throw new TypeError('method getUserData is abstract');
          }
          hasAccess(aspects, msg) {
            throw new TypeError('method hasAccess is abstract');
          }
        }
        BackstageService.prototype.getUserData._messageTypes = function () {
          return [
            $root.google.protobuf.Empty,
            $root.com.wixpress.wixdocs.GetUserDataResponse
          ];
        };
        BackstageService.prototype.hasAccess._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.HasAccessRequest,
            $root.com.wixpress.wixdocs.HasAccessResponse
          ];
        };
        BackstageService.prototype.getUserData.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.BackstageService.getUserData');
        };
        BackstageService.prototype.hasAccess.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.BackstageService.HasAccess');
        };
        __builtIn.Object.defineProperty(BackstageService.prototype, '__isRpcService__', {
          value: true,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(BackstageService.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.BackstageService',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(BackstageService.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.BackstageService');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(BackstageService.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(BackstageService.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(BackstageService.prototype, '__filename', {
          value: __filename,
          enumerable: false,
          configurable: false
        });
        return BackstageService;
      }());;
      _wixdocs.UserData = (function () {
        class UserData {
          constructor(props) {
            this.project = props && props.project;
            this.viewers = props && props.viewers;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['project'] != null) {
                json['project'] = $root.com.wixpress.wixdocs.Project.toJSON(obj['project'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['project'];
              }
              if (obj['viewers'] != null) {
                json['viewers'] = obj['viewers'].map(e => {
                  return $root.com.wixpress.wixdocs.Viewer.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['viewers'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UserData();
              if (json['project'] != null) {
                result['project'] = $root.com.wixpress.wixdocs.Project.fromJSON(json['project'], helper);
              } else if (withDefaults !== false) {
                delete result['project'];
              } else {
                delete result['project'];
              }
              if (json['viewers'] != null) {
                result['viewers'] = Array.isArray(json['viewers']) ? json['viewers'].map(e => {
                  return $root.com.wixpress.wixdocs.Viewer.fromJSON(e, helper);
                }) : json['viewers'];
              } else if (withDefaults !== false) {
                result['viewers'] = [];
              } else {
                delete result['viewers'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['project'] != null) {
                grpc['project'] = $root.com.wixpress.wixdocs.Project.toGRPC(obj['project'], helper);
              }
              if (obj['viewers'] != null) {
                grpc['viewers'] = obj['viewers'].map(e => {
                  return $root.com.wixpress.wixdocs.Viewer.toGRPC(e, helper);
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UserData();
              if (grpc['project'] != null) {
                result['project'] = $root.com.wixpress.wixdocs.Project.fromGRPC(grpc['project'], helper);
              } else {
                delete result['project'];
              }
              if (grpc['viewers'] != null) {
                result['viewers'] = grpc['viewers'].map(e => {
                  return $root.com.wixpress.wixdocs.Viewer.fromGRPC(e, helper);
                });
              } else {
                result['viewers'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UserData.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UserData');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UserData.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UserData',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UserData.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UserData.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UserData;
      }());;
      _wixdocs.GetUserDataResponse = (function () {
        class GetUserDataResponse {
          constructor(props) {
            this.data = props && props.data;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['data'] != null) {
                json['data'] = obj['data'].map(e => {
                  return $root.com.wixpress.wixdocs.UserData.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['data'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.GetUserDataResponse();
              if (json['data'] != null) {
                result['data'] = Array.isArray(json['data']) ? json['data'].map(e => {
                  return $root.com.wixpress.wixdocs.UserData.fromJSON(e, helper);
                }) : json['data'];
              } else if (withDefaults !== false) {
                result['data'] = [];
              } else {
                delete result['data'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['data'] != null) {
                grpc['data'] = obj['data'].map(e => {
                  return $root.com.wixpress.wixdocs.UserData.toGRPC(e, helper);
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.GetUserDataResponse();
              if (grpc['data'] != null) {
                result['data'] = grpc['data'].map(e => {
                  return $root.com.wixpress.wixdocs.UserData.fromGRPC(e, helper);
                });
              } else {
                result['data'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(GetUserDataResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.GetUserDataResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetUserDataResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.GetUserDataResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetUserDataResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetUserDataResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return GetUserDataResponse;
      }());;
      _wixdocs.HasAccessRequest = (function () {
        class HasAccessRequest {
          constructor(props) {
            this.projectId = props && props.projectId;
            this.viewerId = props && props.viewerId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['projectId'] != null) {
                json['projectId'] = $root.google.protobuf.StringValue.toJSON(obj['projectId'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['projectId'];
              }
              if (obj['viewerId'] != null) {
                json['viewerId'] = $root.google.protobuf.StringValue.toJSON(obj['viewerId'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['viewerId'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.HasAccessRequest();
              if (json['projectId'] != null) {
                result['projectId'] = $root.google.protobuf.StringValue.fromJSON(json['projectId'], helper);
              } else if (withDefaults !== false) {
                delete result['projectId'];
              } else {
                delete result['projectId'];
              }
              if (json['viewerId'] != null) {
                result['viewerId'] = $root.google.protobuf.StringValue.fromJSON(json['viewerId'], helper);
              } else if (withDefaults !== false) {
                delete result['viewerId'];
              } else {
                delete result['viewerId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['projectId'] != null) {
                grpc['projectId'] = $root.google.protobuf.StringValue.toGRPC(obj['projectId'], helper);
              }
              if (obj['viewerId'] != null) {
                grpc['viewerId'] = $root.google.protobuf.StringValue.toGRPC(obj['viewerId'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.HasAccessRequest();
              if (grpc['projectId'] != null) {
                result['projectId'] = $root.google.protobuf.StringValue.fromGRPC(grpc['projectId'], helper);
              } else {
                delete result['projectId'];
              }
              if (grpc['viewerId'] != null) {
                result['viewerId'] = $root.google.protobuf.StringValue.fromGRPC(grpc['viewerId'], helper);
              } else {
                delete result['viewerId'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(HasAccessRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.HasAccessRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(HasAccessRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.HasAccessRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(HasAccessRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(HasAccessRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return HasAccessRequest;
      }());;
      _wixdocs.HasAccessResponse = (function () {
        class HasAccessResponse {
          constructor(props) {
            this.hasAccess = props && props.hasAccess;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['hasAccess'] != null) {
                json['hasAccess'] = obj['hasAccess'];
              } else if (withDefaults) {
                json['hasAccess'] = false;
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.HasAccessResponse();
              if (json['hasAccess'] != null) {
                result['hasAccess'] = json['hasAccess'];
              } else if (withDefaults !== false) {
                result['hasAccess'] = false;
              } else {
                delete result['hasAccess'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['hasAccess'] != null) {
                grpc['hasAccess'] = obj['hasAccess'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.HasAccessResponse();
              if (grpc['hasAccess'] != null) {
                result['hasAccess'] = grpc['hasAccess'];
              } else {
                result['hasAccess'] = false;
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(HasAccessResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.HasAccessResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(HasAccessResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.HasAccessResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(HasAccessResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(HasAccessResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return HasAccessResponse;
      }());;
      _wixdocs.SectionTypes = {
        'NO_TYPE': 'NO_TYPE',
        0: 'NO_TYPE',
        'OPERATIONS': 'OPERATIONS',
        1: 'OPERATIONS',
        'SUBCATEGORIES': 'SUBCATEGORIES',
        2: 'SUBCATEGORIES',
        'PROPERTIES': 'PROPERTIES',
        3: 'PROPERTIES',
        'EVENTS': 'EVENTS',
        4: 'EVENTS',
        'MESSAGES': 'MESSAGES',
        5: 'MESSAGES',
        'GUIDES': 'GUIDES',
        6: 'GUIDES'
      };
      _wixdocs.ViewerConfig = (function () {
        class ViewerConfig {
          constructor(props) {
            this.layoutType = props && props.layoutType;
            this.relatedSites = props && props.relatedSites;
            this.seoConfig = props && props.seoConfig;
            this.displayOptions = props && props.displayOptions;
            this.embeddedScripts = props && props.embeddedScripts;
            this.githubSourceUrl = props && props.githubSourceUrl;
            this.customLabelsTemplates = props && props.customLabelsTemplates;
            this.resolvingNameConflicts = props && props.resolvingNameConflicts;
            this.urlPath = props && props.urlPath;
            this.host = props && props.host;
            this.basename = props && props.basename;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['layoutType'] != null) {
                json['layoutType'] = $root.com.wixpress.wixdocs.ViewerConfig.LayoutType[obj['layoutType']];
              } else if (withDefaults) {
                json['layoutType'] = 'REST';
              }
              if (obj['relatedSites'] != null) {
                json['relatedSites'] = obj['relatedSites'].map(e => {
                  return $root.com.wixpress.wixdocs.ViewerConfig.RelatedSite.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['relatedSites'] = [];
              }
              if (obj['seoConfig'] != null) {
                json['seoConfig'] = $root.com.wixpress.wixdocs.ViewerConfig.SeoConfig.toJSON(obj['seoConfig'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['seoConfig'];
              }
              if (obj['displayOptions'] != null) {
                json['displayOptions'] = $root.com.wixpress.wixdocs.ViewerConfig.DisplayOptions.toJSON(obj['displayOptions'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['displayOptions'];
              }
              if (obj['embeddedScripts'] != null) {
                json['embeddedScripts'] = obj['embeddedScripts'].map(e => {
                  return $root.com.wixpress.wixdocs.ViewerConfig.EmbeddedScript.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['embeddedScripts'] = [];
              }
              if (obj['githubSourceUrl'] != null) {
                json['githubSourceUrl'] = obj['githubSourceUrl'];
              } else if (withDefaults) {
                json['githubSourceUrl'] = '';
              }
              if (obj['customLabelsTemplates'] != null) {
                json['customLabelsTemplates'] = Object.entries(obj['customLabelsTemplates']).reduce((acc, [k, v]) => {
                  acc[k] = $root.com.wixpress.wixdocs.ViewerConfig.CustomLabel.toJSON(v, helper, withDefaults);
                  return acc;
                }, {});
              } else if (withDefaults) {
                delete json['customLabelsTemplates'];
              }
              if (obj['resolvingNameConflicts'] != null) {
                json['resolvingNameConflicts'] = Object.entries(obj['resolvingNameConflicts']).reduce((acc, [k, v]) => {
                  acc[k] = $root.com.wixpress.wixdocs.ViewerConfig.NameConflictResolution.toJSON(v, helper, withDefaults);
                  return acc;
                }, {});
              } else if (withDefaults) {
                delete json['resolvingNameConflicts'];
              }
              if (obj['urlPath'] != null) {
                json['urlPath'] = $root.google.protobuf.StringValue.toJSON(obj['urlPath'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['urlPath'];
              }
              if (obj['host'] != null) {
                json['host'] = $root.google.protobuf.StringValue.toJSON(obj['host'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['host'];
              }
              if (obj['basename'] != null) {
                json['basename'] = $root.google.protobuf.StringValue.toJSON(obj['basename'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['basename'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.ViewerConfig();
              if (json['layoutType'] != null) {
                result['layoutType'] = typeof json['layoutType'] === 'string' ? json['layoutType'] : $root.com.wixpress.wixdocs.ViewerConfig.LayoutType[json['layoutType']];
              } else if (withDefaults !== false) {
                result['layoutType'] = 'REST';
              } else {
                delete result['layoutType'];
              }
              if (json['relatedSites'] != null) {
                result['relatedSites'] = Array.isArray(json['relatedSites']) ? json['relatedSites'].map(e => {
                  return $root.com.wixpress.wixdocs.ViewerConfig.RelatedSite.fromJSON(e, helper);
                }) : json['relatedSites'];
              } else if (withDefaults !== false) {
                result['relatedSites'] = [];
              } else {
                delete result['relatedSites'];
              }
              if (json['seoConfig'] != null) {
                result['seoConfig'] = $root.com.wixpress.wixdocs.ViewerConfig.SeoConfig.fromJSON(json['seoConfig'], helper);
              } else if (withDefaults !== false) {
                delete result['seoConfig'];
              } else {
                delete result['seoConfig'];
              }
              if (json['displayOptions'] != null) {
                result['displayOptions'] = $root.com.wixpress.wixdocs.ViewerConfig.DisplayOptions.fromJSON(json['displayOptions'], helper);
              } else if (withDefaults !== false) {
                delete result['displayOptions'];
              } else {
                delete result['displayOptions'];
              }
              if (json['embeddedScripts'] != null) {
                result['embeddedScripts'] = Array.isArray(json['embeddedScripts']) ? json['embeddedScripts'].map(e => {
                  return $root.com.wixpress.wixdocs.ViewerConfig.EmbeddedScript.fromJSON(e, helper);
                }) : json['embeddedScripts'];
              } else if (withDefaults !== false) {
                result['embeddedScripts'] = [];
              } else {
                delete result['embeddedScripts'];
              }
              if (json['githubSourceUrl'] != null) {
                result['githubSourceUrl'] = json['githubSourceUrl'];
              } else if (withDefaults !== false) {
                result['githubSourceUrl'] = '';
              } else {
                delete result['githubSourceUrl'];
              }
              if (json['customLabelsTemplates'] != null) {
                result['customLabelsTemplates'] = Object.entries(json['customLabelsTemplates']).reduce((acc, [k, v]) => {
                  acc[k] = $root.com.wixpress.wixdocs.ViewerConfig.CustomLabel.fromJSON(v, helper);
                  return acc;
                }, {});
              } else if (withDefaults !== false) {
                delete result['customLabelsTemplates'];
              } else {
                delete result['customLabelsTemplates'];
              }
              if (json['resolvingNameConflicts'] != null) {
                result['resolvingNameConflicts'] = Object.entries(json['resolvingNameConflicts']).reduce((acc, [k, v]) => {
                  acc[k] = $root.com.wixpress.wixdocs.ViewerConfig.NameConflictResolution.fromJSON(v, helper);
                  return acc;
                }, {});
              } else if (withDefaults !== false) {
                delete result['resolvingNameConflicts'];
              } else {
                delete result['resolvingNameConflicts'];
              }
              if (json['urlPath'] != null) {
                result['urlPath'] = $root.google.protobuf.StringValue.fromJSON(json['urlPath'], helper);
              } else if (withDefaults !== false) {
                delete result['urlPath'];
              } else {
                delete result['urlPath'];
              }
              if (json['host'] != null) {
                result['host'] = $root.google.protobuf.StringValue.fromJSON(json['host'], helper);
              } else if (withDefaults !== false) {
                delete result['host'];
              } else {
                delete result['host'];
              }
              if (json['basename'] != null) {
                result['basename'] = $root.google.protobuf.StringValue.fromJSON(json['basename'], helper);
              } else if (withDefaults !== false) {
                delete result['basename'];
              } else {
                delete result['basename'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['layoutType'] != null) {
                grpc['layoutType'] = obj['layoutType'];
              }
              if (obj['relatedSites'] != null) {
                grpc['relatedSites'] = obj['relatedSites'].map(e => {
                  return $root.com.wixpress.wixdocs.ViewerConfig.RelatedSite.toGRPC(e, helper);
                });
              }
              if (obj['seoConfig'] != null) {
                grpc['seoConfig'] = $root.com.wixpress.wixdocs.ViewerConfig.SeoConfig.toGRPC(obj['seoConfig'], helper);
              }
              if (obj['displayOptions'] != null) {
                grpc['displayOptions'] = $root.com.wixpress.wixdocs.ViewerConfig.DisplayOptions.toGRPC(obj['displayOptions'], helper);
              }
              if (obj['embeddedScripts'] != null) {
                grpc['embeddedScripts'] = obj['embeddedScripts'].map(e => {
                  return $root.com.wixpress.wixdocs.ViewerConfig.EmbeddedScript.toGRPC(e, helper);
                });
              }
              if (obj['githubSourceUrl'] != null) {
                grpc['githubSourceUrl'] = obj['githubSourceUrl'];
              }
              if (obj['customLabelsTemplates'] != null) {
                grpc['customLabelsTemplates'] = Object.entries(obj['customLabelsTemplates']).reduce((acc, [k, v]) => {
                  acc[k] = $root.com.wixpress.wixdocs.ViewerConfig.CustomLabel.toGRPC(v, helper);
                  return acc;
                }, {});
              }
              if (obj['resolvingNameConflicts'] != null) {
                grpc['resolvingNameConflicts'] = Object.entries(obj['resolvingNameConflicts']).reduce((acc, [k, v]) => {
                  acc[k] = $root.com.wixpress.wixdocs.ViewerConfig.NameConflictResolution.toGRPC(v, helper);
                  return acc;
                }, {});
              }
              if (obj['urlPath'] != null) {
                grpc['urlPath'] = $root.google.protobuf.StringValue.toGRPC(obj['urlPath'], helper);
              }
              if (obj['host'] != null) {
                grpc['host'] = $root.google.protobuf.StringValue.toGRPC(obj['host'], helper);
              }
              if (obj['basename'] != null) {
                grpc['basename'] = $root.google.protobuf.StringValue.toGRPC(obj['basename'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.ViewerConfig();
              if (grpc['layoutType'] != null) {
                result['layoutType'] = grpc['layoutType'];
              } else {
                result['layoutType'] = 'REST';
              }
              if (grpc['relatedSites'] != null) {
                result['relatedSites'] = grpc['relatedSites'].map(e => {
                  return $root.com.wixpress.wixdocs.ViewerConfig.RelatedSite.fromGRPC(e, helper);
                });
              } else {
                result['relatedSites'] = [];
              }
              if (grpc['seoConfig'] != null) {
                result['seoConfig'] = $root.com.wixpress.wixdocs.ViewerConfig.SeoConfig.fromGRPC(grpc['seoConfig'], helper);
              } else {
                delete result['seoConfig'];
              }
              if (grpc['displayOptions'] != null) {
                result['displayOptions'] = $root.com.wixpress.wixdocs.ViewerConfig.DisplayOptions.fromGRPC(grpc['displayOptions'], helper);
              } else {
                delete result['displayOptions'];
              }
              if (grpc['embeddedScripts'] != null) {
                result['embeddedScripts'] = grpc['embeddedScripts'].map(e => {
                  return $root.com.wixpress.wixdocs.ViewerConfig.EmbeddedScript.fromGRPC(e, helper);
                });
              } else {
                result['embeddedScripts'] = [];
              }
              if (grpc['githubSourceUrl'] != null) {
                result['githubSourceUrl'] = grpc['githubSourceUrl'];
              } else {
                result['githubSourceUrl'] = '';
              }
              if (grpc['customLabelsTemplates'] != null) {
                result['customLabelsTemplates'] = Object.entries(grpc['customLabelsTemplates']).reduce((acc, [k, v]) => {
                  acc[k] = $root.com.wixpress.wixdocs.ViewerConfig.CustomLabel.fromGRPC(v, helper);
                  return acc;
                }, {});
              } else {
                delete result['customLabelsTemplates'];
              }
              if (grpc['resolvingNameConflicts'] != null) {
                result['resolvingNameConflicts'] = Object.entries(grpc['resolvingNameConflicts']).reduce((acc, [k, v]) => {
                  acc[k] = $root.com.wixpress.wixdocs.ViewerConfig.NameConflictResolution.fromGRPC(v, helper);
                  return acc;
                }, {});
              } else {
                delete result['resolvingNameConflicts'];
              }
              if (grpc['urlPath'] != null) {
                result['urlPath'] = $root.google.protobuf.StringValue.fromGRPC(grpc['urlPath'], helper);
              } else {
                delete result['urlPath'];
              }
              if (grpc['host'] != null) {
                result['host'] = $root.google.protobuf.StringValue.fromGRPC(grpc['host'], helper);
              } else {
                delete result['host'];
              }
              if (grpc['basename'] != null) {
                result['basename'] = $root.google.protobuf.StringValue.fromGRPC(grpc['basename'], helper);
              } else {
                delete result['basename'];
              }
              return result;
            }
          }
        }
        ViewerConfig.LayoutType = {
          'REST': 'REST',
          0: 'REST',
          'JS': 'JS',
          1: 'JS',
          'RPC': 'RPC',
          2: 'RPC',
          'RPC_REST': 'RPC_REST',
          3: 'RPC_REST'
        };
        ViewerConfig.NameConflictResolution = (function () {
          class NameConflictResolution {
            constructor(props) {
              this.additionalText = props && props.additionalText;
              this.textPlacement = props && props.textPlacement;
            }
            static toJSON(obj, helper, withDefaults) {
              if (obj == null) {
                return null;
              } else {
                const json = {};
                if (obj['additionalText'] != null) {
                  json['additionalText'] = obj['additionalText'];
                } else if (withDefaults) {
                  json['additionalText'] = '';
                }
                if (obj['textPlacement'] != null) {
                  json['textPlacement'] = $root.com.wixpress.wixdocs.ViewerConfig.NameConflictResolution.TextPlacement[obj['textPlacement']];
                } else if (withDefaults) {
                  json['textPlacement'] = 'NO_PLACEMENT';
                }
                return json;
              }
            }
            static fromJSON(json, helper, withDefaults) {
              if (typeof json === 'object' && !Array.isArray(json)) {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.NameConflictResolution();
                if (json['additionalText'] != null) {
                  result['additionalText'] = json['additionalText'];
                } else if (withDefaults !== false) {
                  result['additionalText'] = '';
                } else {
                  delete result['additionalText'];
                }
                if (json['textPlacement'] != null) {
                  result['textPlacement'] = typeof json['textPlacement'] === 'string' ? json['textPlacement'] : $root.com.wixpress.wixdocs.ViewerConfig.NameConflictResolution.TextPlacement[json['textPlacement']];
                } else if (withDefaults !== false) {
                  result['textPlacement'] = 'NO_PLACEMENT';
                } else {
                  delete result['textPlacement'];
                }
                return result;
              } else
                return json;
            }
            static toGRPC(obj, helper) {
              if (obj == null) {
                return null;
              } else {
                const grpc = {};
                if (obj['additionalText'] != null) {
                  grpc['additionalText'] = obj['additionalText'];
                }
                if (obj['textPlacement'] != null) {
                  grpc['textPlacement'] = obj['textPlacement'];
                }
                return grpc;
              }
            }
            static fromGRPC(grpc, helper) {
              if (grpc == null) {
                return null;
              } else {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.NameConflictResolution();
                if (grpc['additionalText'] != null) {
                  result['additionalText'] = grpc['additionalText'];
                } else {
                  result['additionalText'] = '';
                }
                if (grpc['textPlacement'] != null) {
                  result['textPlacement'] = grpc['textPlacement'];
                } else {
                  result['textPlacement'] = 'NO_PLACEMENT';
                }
                return result;
              }
            }
          }
          NameConflictResolution.TextPlacement = {
            'NO_PLACEMENT': 'NO_PLACEMENT',
            0: 'NO_PLACEMENT',
            'SUFFIX': 'SUFFIX',
            1: 'SUFFIX',
            'PREFIX': 'PREFIX',
            2: 'PREFIX'
          };
          NameConflictResolution.TextPlacement = {
            'NO_PLACEMENT': 'NO_PLACEMENT',
            0: 'NO_PLACEMENT',
            'SUFFIX': 'SUFFIX',
            1: 'SUFFIX',
            'PREFIX': 'PREFIX',
            2: 'PREFIX'
          };
          __builtIn.Object.defineProperty(NameConflictResolution.prototype, '__proto', {
            value: pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewerConfig.NameConflictResolution');
            },
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(NameConflictResolution.prototype, '__fqn__', {
            value: 'com.wixpress.wixdocs.ViewerConfig.NameConflictResolution',
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(NameConflictResolution.prototype, '__options__', {
            value: $root.__options,
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(NameConflictResolution.prototype, '__root__', {
            value: $root,
            enumerable: false,
            configurable: false
          });
          return NameConflictResolution;
        }());;
        ViewerConfig.CustomLabel = (function () {
          class CustomLabel {
            constructor(props) {
              this.name = props && props.name;
              this.color = props && props.color;
              this.description = props && props.description;
            }
            static toJSON(obj, helper, withDefaults) {
              if (obj == null) {
                return null;
              } else {
                const json = {};
                if (obj['name'] != null) {
                  json['name'] = obj['name'];
                } else if (withDefaults) {
                  json['name'] = '';
                }
                if (obj['color'] != null) {
                  json['color'] = obj['color'];
                } else if (withDefaults) {
                  json['color'] = '';
                }
                if (obj['description'] != null) {
                  json['description'] = obj['description'];
                } else if (withDefaults) {
                  json['description'] = '';
                }
                return json;
              }
            }
            static fromJSON(json, helper, withDefaults) {
              if (typeof json === 'object' && !Array.isArray(json)) {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.CustomLabel();
                if (json['name'] != null) {
                  result['name'] = json['name'];
                } else if (withDefaults !== false) {
                  result['name'] = '';
                } else {
                  delete result['name'];
                }
                if (json['color'] != null) {
                  result['color'] = json['color'];
                } else if (withDefaults !== false) {
                  result['color'] = '';
                } else {
                  delete result['color'];
                }
                if (json['description'] != null) {
                  result['description'] = json['description'];
                } else if (withDefaults !== false) {
                  result['description'] = '';
                } else {
                  delete result['description'];
                }
                return result;
              } else
                return json;
            }
            static toGRPC(obj, helper) {
              if (obj == null) {
                return null;
              } else {
                const grpc = {};
                if (obj['name'] != null) {
                  grpc['name'] = obj['name'];
                }
                if (obj['color'] != null) {
                  grpc['color'] = obj['color'];
                }
                if (obj['description'] != null) {
                  grpc['description'] = obj['description'];
                }
                return grpc;
              }
            }
            static fromGRPC(grpc, helper) {
              if (grpc == null) {
                return null;
              } else {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.CustomLabel();
                if (grpc['name'] != null) {
                  result['name'] = grpc['name'];
                } else {
                  result['name'] = '';
                }
                if (grpc['color'] != null) {
                  result['color'] = grpc['color'];
                } else {
                  result['color'] = '';
                }
                if (grpc['description'] != null) {
                  result['description'] = grpc['description'];
                } else {
                  result['description'] = '';
                }
                return result;
              }
            }
          }
          __builtIn.Object.defineProperty(CustomLabel.prototype, '__proto', {
            value: pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewerConfig.CustomLabel');
            },
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(CustomLabel.prototype, '__fqn__', {
            value: 'com.wixpress.wixdocs.ViewerConfig.CustomLabel',
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(CustomLabel.prototype, '__options__', {
            value: $root.__options,
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(CustomLabel.prototype, '__root__', {
            value: $root,
            enumerable: false,
            configurable: false
          });
          return CustomLabel;
        }());;
        ViewerConfig.EmbeddedScript = (function () {
          class EmbeddedScript {
            constructor(props) {
              this.location = props && props.location;
              this.script = props && props.script;
              this.name = props && props.name;
            }
            static toJSON(obj, helper, withDefaults) {
              if (obj == null) {
                return null;
              } else {
                const json = {};
                if (obj['location'] != null) {
                  json['location'] = $root.com.wixpress.wixdocs.ViewerConfig.EmbeddedScript.EmbeddedScriptLocation[obj['location']];
                } else if (withDefaults) {
                  json['location'] = 'HEAD';
                }
                if (obj['script'] != null) {
                  json['script'] = obj['script'];
                } else if (withDefaults) {
                  json['script'] = '';
                }
                if (obj['name'] != null) {
                  json['name'] = obj['name'];
                } else if (withDefaults) {
                  json['name'] = '';
                }
                return json;
              }
            }
            static fromJSON(json, helper, withDefaults) {
              if (typeof json === 'object' && !Array.isArray(json)) {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.EmbeddedScript();
                if (json['location'] != null) {
                  result['location'] = typeof json['location'] === 'string' ? json['location'] : $root.com.wixpress.wixdocs.ViewerConfig.EmbeddedScript.EmbeddedScriptLocation[json['location']];
                } else if (withDefaults !== false) {
                  result['location'] = 'HEAD';
                } else {
                  delete result['location'];
                }
                if (json['script'] != null) {
                  result['script'] = json['script'];
                } else if (withDefaults !== false) {
                  result['script'] = '';
                } else {
                  delete result['script'];
                }
                if (json['name'] != null) {
                  result['name'] = json['name'];
                } else if (withDefaults !== false) {
                  result['name'] = '';
                } else {
                  delete result['name'];
                }
                return result;
              } else
                return json;
            }
            static toGRPC(obj, helper) {
              if (obj == null) {
                return null;
              } else {
                const grpc = {};
                if (obj['location'] != null) {
                  grpc['location'] = obj['location'];
                }
                if (obj['script'] != null) {
                  grpc['script'] = obj['script'];
                }
                if (obj['name'] != null) {
                  grpc['name'] = obj['name'];
                }
                return grpc;
              }
            }
            static fromGRPC(grpc, helper) {
              if (grpc == null) {
                return null;
              } else {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.EmbeddedScript();
                if (grpc['location'] != null) {
                  result['location'] = grpc['location'];
                } else {
                  result['location'] = 'HEAD';
                }
                if (grpc['script'] != null) {
                  result['script'] = grpc['script'];
                } else {
                  result['script'] = '';
                }
                if (grpc['name'] != null) {
                  result['name'] = grpc['name'];
                } else {
                  result['name'] = '';
                }
                return result;
              }
            }
          }
          EmbeddedScript.EmbeddedScriptLocation = {
            'HEAD': 'HEAD',
            0: 'HEAD',
            'BODY_START': 'BODY_START',
            1: 'BODY_START',
            'BODY_END': 'BODY_END',
            2: 'BODY_END'
          };
          EmbeddedScript.EmbeddedScriptLocation = {
            'HEAD': 'HEAD',
            0: 'HEAD',
            'BODY_START': 'BODY_START',
            1: 'BODY_START',
            'BODY_END': 'BODY_END',
            2: 'BODY_END'
          };
          __builtIn.Object.defineProperty(EmbeddedScript.prototype, '__proto', {
            value: pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewerConfig.EmbeddedScript');
            },
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(EmbeddedScript.prototype, '__fqn__', {
            value: 'com.wixpress.wixdocs.ViewerConfig.EmbeddedScript',
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(EmbeddedScript.prototype, '__options__', {
            value: $root.__options,
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(EmbeddedScript.prototype, '__root__', {
            value: $root,
            enumerable: false,
            configurable: false
          });
          return EmbeddedScript;
        }());;
        ViewerConfig.RelatedSite = (function () {
          class RelatedSite {
            constructor(props) {
              this.name = props && props.name;
              this.url = props && props.url;
              this.viewerId = props && props.viewerId;
            }
            static toJSON(obj, helper, withDefaults) {
              if (obj == null) {
                return null;
              } else {
                const json = {};
                if (obj['name'] != null) {
                  json['name'] = obj['name'];
                } else if (withDefaults) {
                  json['name'] = '';
                }
                if (obj['url'] != null) {
                  json['url'] = obj['url'];
                } else if (withDefaults) {
                  json['url'] = '';
                }
                if (obj['viewerId'] != null) {
                  json['viewerId'] = $root.google.protobuf.StringValue.toJSON(obj['viewerId'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['viewerId'];
                }
                return json;
              }
            }
            static fromJSON(json, helper, withDefaults) {
              if (typeof json === 'object' && !Array.isArray(json)) {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.RelatedSite();
                if (json['name'] != null) {
                  result['name'] = json['name'];
                } else if (withDefaults !== false) {
                  result['name'] = '';
                } else {
                  delete result['name'];
                }
                if (json['url'] != null) {
                  result['url'] = json['url'];
                } else if (withDefaults !== false) {
                  result['url'] = '';
                } else {
                  delete result['url'];
                }
                if (json['viewerId'] != null) {
                  result['viewerId'] = $root.google.protobuf.StringValue.fromJSON(json['viewerId'], helper);
                } else if (withDefaults !== false) {
                  delete result['viewerId'];
                } else {
                  delete result['viewerId'];
                }
                return result;
              } else
                return json;
            }
            static toGRPC(obj, helper) {
              if (obj == null) {
                return null;
              } else {
                const grpc = {};
                if (obj['name'] != null) {
                  grpc['name'] = obj['name'];
                }
                if (obj['url'] != null) {
                  grpc['url'] = obj['url'];
                }
                if (obj['viewerId'] != null) {
                  grpc['viewerId'] = $root.google.protobuf.StringValue.toGRPC(obj['viewerId'], helper);
                }
                return grpc;
              }
            }
            static fromGRPC(grpc, helper) {
              if (grpc == null) {
                return null;
              } else {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.RelatedSite();
                if (grpc['name'] != null) {
                  result['name'] = grpc['name'];
                } else {
                  result['name'] = '';
                }
                if (grpc['url'] != null) {
                  result['url'] = grpc['url'];
                } else {
                  result['url'] = '';
                }
                if (grpc['viewerId'] != null) {
                  result['viewerId'] = $root.google.protobuf.StringValue.fromGRPC(grpc['viewerId'], helper);
                } else {
                  delete result['viewerId'];
                }
                return result;
              }
            }
          }
          __builtIn.Object.defineProperty(RelatedSite.prototype, '__proto', {
            value: pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewerConfig.RelatedSite');
            },
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(RelatedSite.prototype, '__fqn__', {
            value: 'com.wixpress.wixdocs.ViewerConfig.RelatedSite',
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(RelatedSite.prototype, '__options__', {
            value: $root.__options,
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(RelatedSite.prototype, '__root__', {
            value: $root,
            enumerable: false,
            configurable: false
          });
          return RelatedSite;
        }());;
        ViewerConfig.SeoConfig = (function () {
          class SeoConfig {
            constructor(props) {
              this.homePageTitle = props && props.homePageTitle;
              this.homePageDescription = props && props.homePageDescription;
              this.pageTitleSuffix = props && props.pageTitleSuffix;
              this.hideFromSearchEngines = props && props.hideFromSearchEngines;
            }
            static toJSON(obj, helper, withDefaults) {
              if (obj == null) {
                return null;
              } else {
                const json = {};
                if (obj['homePageTitle'] != null) {
                  json['homePageTitle'] = $root.google.protobuf.StringValue.toJSON(obj['homePageTitle'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['homePageTitle'];
                }
                if (obj['homePageDescription'] != null) {
                  json['homePageDescription'] = $root.google.protobuf.StringValue.toJSON(obj['homePageDescription'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['homePageDescription'];
                }
                if (obj['pageTitleSuffix'] != null) {
                  json['pageTitleSuffix'] = $root.google.protobuf.StringValue.toJSON(obj['pageTitleSuffix'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['pageTitleSuffix'];
                }
                if (obj['hideFromSearchEngines'] != null) {
                  json['hideFromSearchEngines'] = $root.google.protobuf.BoolValue.toJSON(obj['hideFromSearchEngines'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['hideFromSearchEngines'];
                }
                return json;
              }
            }
            static fromJSON(json, helper, withDefaults) {
              if (typeof json === 'object' && !Array.isArray(json)) {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.SeoConfig();
                if (json['homePageTitle'] != null) {
                  result['homePageTitle'] = $root.google.protobuf.StringValue.fromJSON(json['homePageTitle'], helper);
                } else if (withDefaults !== false) {
                  delete result['homePageTitle'];
                } else {
                  delete result['homePageTitle'];
                }
                if (json['homePageDescription'] != null) {
                  result['homePageDescription'] = $root.google.protobuf.StringValue.fromJSON(json['homePageDescription'], helper);
                } else if (withDefaults !== false) {
                  delete result['homePageDescription'];
                } else {
                  delete result['homePageDescription'];
                }
                if (json['pageTitleSuffix'] != null) {
                  result['pageTitleSuffix'] = $root.google.protobuf.StringValue.fromJSON(json['pageTitleSuffix'], helper);
                } else if (withDefaults !== false) {
                  delete result['pageTitleSuffix'];
                } else {
                  delete result['pageTitleSuffix'];
                }
                if (json['hideFromSearchEngines'] != null) {
                  result['hideFromSearchEngines'] = $root.google.protobuf.BoolValue.fromJSON(json['hideFromSearchEngines'], helper);
                } else if (withDefaults !== false) {
                  delete result['hideFromSearchEngines'];
                } else {
                  delete result['hideFromSearchEngines'];
                }
                return result;
              } else
                return json;
            }
            static toGRPC(obj, helper) {
              if (obj == null) {
                return null;
              } else {
                const grpc = {};
                if (obj['homePageTitle'] != null) {
                  grpc['homePageTitle'] = $root.google.protobuf.StringValue.toGRPC(obj['homePageTitle'], helper);
                }
                if (obj['homePageDescription'] != null) {
                  grpc['homePageDescription'] = $root.google.protobuf.StringValue.toGRPC(obj['homePageDescription'], helper);
                }
                if (obj['pageTitleSuffix'] != null) {
                  grpc['pageTitleSuffix'] = $root.google.protobuf.StringValue.toGRPC(obj['pageTitleSuffix'], helper);
                }
                if (obj['hideFromSearchEngines'] != null) {
                  grpc['hideFromSearchEngines'] = $root.google.protobuf.BoolValue.toGRPC(obj['hideFromSearchEngines'], helper);
                }
                return grpc;
              }
            }
            static fromGRPC(grpc, helper) {
              if (grpc == null) {
                return null;
              } else {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.SeoConfig();
                if (grpc['homePageTitle'] != null) {
                  result['homePageTitle'] = $root.google.protobuf.StringValue.fromGRPC(grpc['homePageTitle'], helper);
                } else {
                  delete result['homePageTitle'];
                }
                if (grpc['homePageDescription'] != null) {
                  result['homePageDescription'] = $root.google.protobuf.StringValue.fromGRPC(grpc['homePageDescription'], helper);
                } else {
                  delete result['homePageDescription'];
                }
                if (grpc['pageTitleSuffix'] != null) {
                  result['pageTitleSuffix'] = $root.google.protobuf.StringValue.fromGRPC(grpc['pageTitleSuffix'], helper);
                } else {
                  delete result['pageTitleSuffix'];
                }
                if (grpc['hideFromSearchEngines'] != null) {
                  result['hideFromSearchEngines'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['hideFromSearchEngines'], helper);
                } else {
                  delete result['hideFromSearchEngines'];
                }
                return result;
              }
            }
          }
          __builtIn.Object.defineProperty(SeoConfig.prototype, '__proto', {
            value: pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewerConfig.SeoConfig');
            },
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(SeoConfig.prototype, '__fqn__', {
            value: 'com.wixpress.wixdocs.ViewerConfig.SeoConfig',
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(SeoConfig.prototype, '__options__', {
            value: $root.__options,
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(SeoConfig.prototype, '__root__', {
            value: $root,
            enumerable: false,
            configurable: false
          });
          return SeoConfig;
        }());;
        ViewerConfig.DisplayOptions = (function () {
          class DisplayOptions {
            constructor(props) {
              this.showComplexTypesInTable = props && props.showComplexTypesInTable;
              this.openAllExamplesOnStart = props && props.openAllExamplesOnStart;
              this.hideRestPlayground = props && props.hideRestPlayground;
              this.showTokenBar = props && props.showTokenBar;
              this.favicon = props && props.favicon;
              this.showSourceLink = props && props.showSourceLink;
            }
            static toJSON(obj, helper, withDefaults) {
              if (obj == null) {
                return null;
              } else {
                const json = {};
                if (obj['showComplexTypesInTable'] != null) {
                  json['showComplexTypesInTable'] = $root.google.protobuf.BoolValue.toJSON(obj['showComplexTypesInTable'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['showComplexTypesInTable'];
                }
                if (obj['openAllExamplesOnStart'] != null) {
                  json['openAllExamplesOnStart'] = $root.google.protobuf.BoolValue.toJSON(obj['openAllExamplesOnStart'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['openAllExamplesOnStart'];
                }
                if (obj['hideRestPlayground'] != null) {
                  json['hideRestPlayground'] = $root.google.protobuf.BoolValue.toJSON(obj['hideRestPlayground'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['hideRestPlayground'];
                }
                if (obj['showTokenBar'] != null) {
                  json['showTokenBar'] = $root.google.protobuf.BoolValue.toJSON(obj['showTokenBar'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['showTokenBar'];
                }
                if (obj['favicon'] != null) {
                  json['favicon'] = $root.google.protobuf.StringValue.toJSON(obj['favicon'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['favicon'];
                }
                if (obj['showSourceLink'] != null) {
                  json['showSourceLink'] = $root.google.protobuf.BoolValue.toJSON(obj['showSourceLink'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['showSourceLink'];
                }
                return json;
              }
            }
            static fromJSON(json, helper, withDefaults) {
              if (typeof json === 'object' && !Array.isArray(json)) {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.DisplayOptions();
                if (json['showComplexTypesInTable'] != null) {
                  result['showComplexTypesInTable'] = $root.google.protobuf.BoolValue.fromJSON(json['showComplexTypesInTable'], helper);
                } else if (withDefaults !== false) {
                  delete result['showComplexTypesInTable'];
                } else {
                  delete result['showComplexTypesInTable'];
                }
                if (json['openAllExamplesOnStart'] != null) {
                  result['openAllExamplesOnStart'] = $root.google.protobuf.BoolValue.fromJSON(json['openAllExamplesOnStart'], helper);
                } else if (withDefaults !== false) {
                  delete result['openAllExamplesOnStart'];
                } else {
                  delete result['openAllExamplesOnStart'];
                }
                if (json['hideRestPlayground'] != null) {
                  result['hideRestPlayground'] = $root.google.protobuf.BoolValue.fromJSON(json['hideRestPlayground'], helper);
                } else if (withDefaults !== false) {
                  delete result['hideRestPlayground'];
                } else {
                  delete result['hideRestPlayground'];
                }
                if (json['showTokenBar'] != null) {
                  result['showTokenBar'] = $root.google.protobuf.BoolValue.fromJSON(json['showTokenBar'], helper);
                } else if (withDefaults !== false) {
                  delete result['showTokenBar'];
                } else {
                  delete result['showTokenBar'];
                }
                if (json['favicon'] != null) {
                  result['favicon'] = $root.google.protobuf.StringValue.fromJSON(json['favicon'], helper);
                } else if (withDefaults !== false) {
                  delete result['favicon'];
                } else {
                  delete result['favicon'];
                }
                if (json['showSourceLink'] != null) {
                  result['showSourceLink'] = $root.google.protobuf.BoolValue.fromJSON(json['showSourceLink'], helper);
                } else if (withDefaults !== false) {
                  delete result['showSourceLink'];
                } else {
                  delete result['showSourceLink'];
                }
                return result;
              } else
                return json;
            }
            static toGRPC(obj, helper) {
              if (obj == null) {
                return null;
              } else {
                const grpc = {};
                if (obj['showComplexTypesInTable'] != null) {
                  grpc['showComplexTypesInTable'] = $root.google.protobuf.BoolValue.toGRPC(obj['showComplexTypesInTable'], helper);
                }
                if (obj['openAllExamplesOnStart'] != null) {
                  grpc['openAllExamplesOnStart'] = $root.google.protobuf.BoolValue.toGRPC(obj['openAllExamplesOnStart'], helper);
                }
                if (obj['hideRestPlayground'] != null) {
                  grpc['hideRestPlayground'] = $root.google.protobuf.BoolValue.toGRPC(obj['hideRestPlayground'], helper);
                }
                if (obj['showTokenBar'] != null) {
                  grpc['showTokenBar'] = $root.google.protobuf.BoolValue.toGRPC(obj['showTokenBar'], helper);
                }
                if (obj['favicon'] != null) {
                  grpc['favicon'] = $root.google.protobuf.StringValue.toGRPC(obj['favicon'], helper);
                }
                if (obj['showSourceLink'] != null) {
                  grpc['showSourceLink'] = $root.google.protobuf.BoolValue.toGRPC(obj['showSourceLink'], helper);
                }
                return grpc;
              }
            }
            static fromGRPC(grpc, helper) {
              if (grpc == null) {
                return null;
              } else {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.DisplayOptions();
                if (grpc['showComplexTypesInTable'] != null) {
                  result['showComplexTypesInTable'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['showComplexTypesInTable'], helper);
                } else {
                  delete result['showComplexTypesInTable'];
                }
                if (grpc['openAllExamplesOnStart'] != null) {
                  result['openAllExamplesOnStart'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['openAllExamplesOnStart'], helper);
                } else {
                  delete result['openAllExamplesOnStart'];
                }
                if (grpc['hideRestPlayground'] != null) {
                  result['hideRestPlayground'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['hideRestPlayground'], helper);
                } else {
                  delete result['hideRestPlayground'];
                }
                if (grpc['showTokenBar'] != null) {
                  result['showTokenBar'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['showTokenBar'], helper);
                } else {
                  delete result['showTokenBar'];
                }
                if (grpc['favicon'] != null) {
                  result['favicon'] = $root.google.protobuf.StringValue.fromGRPC(grpc['favicon'], helper);
                } else {
                  delete result['favicon'];
                }
                if (grpc['showSourceLink'] != null) {
                  result['showSourceLink'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['showSourceLink'], helper);
                } else {
                  delete result['showSourceLink'];
                }
                return result;
              }
            }
          }
          __builtIn.Object.defineProperty(DisplayOptions.prototype, '__proto', {
            value: pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewerConfig.DisplayOptions');
            },
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(DisplayOptions.prototype, '__fqn__', {
            value: 'com.wixpress.wixdocs.ViewerConfig.DisplayOptions',
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(DisplayOptions.prototype, '__options__', {
            value: $root.__options,
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(DisplayOptions.prototype, '__root__', {
            value: $root,
            enumerable: false,
            configurable: false
          });
          return DisplayOptions;
        }());;
        ViewerConfig.LayoutType = {
          'REST': 'REST',
          0: 'REST',
          'JS': 'JS',
          1: 'JS',
          'RPC': 'RPC',
          2: 'RPC',
          'RPC_REST': 'RPC_REST',
          3: 'RPC_REST'
        };
        ViewerConfig.NameConflictResolution = (function () {
          class NameConflictResolution {
            constructor(props) {
              this.additionalText = props && props.additionalText;
              this.textPlacement = props && props.textPlacement;
            }
            static toJSON(obj, helper, withDefaults) {
              if (obj == null) {
                return null;
              } else {
                const json = {};
                if (obj['additionalText'] != null) {
                  json['additionalText'] = obj['additionalText'];
                } else if (withDefaults) {
                  json['additionalText'] = '';
                }
                if (obj['textPlacement'] != null) {
                  json['textPlacement'] = $root.com.wixpress.wixdocs.ViewerConfig.NameConflictResolution.TextPlacement[obj['textPlacement']];
                } else if (withDefaults) {
                  json['textPlacement'] = 'NO_PLACEMENT';
                }
                return json;
              }
            }
            static fromJSON(json, helper, withDefaults) {
              if (typeof json === 'object' && !Array.isArray(json)) {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.NameConflictResolution();
                if (json['additionalText'] != null) {
                  result['additionalText'] = json['additionalText'];
                } else if (withDefaults !== false) {
                  result['additionalText'] = '';
                } else {
                  delete result['additionalText'];
                }
                if (json['textPlacement'] != null) {
                  result['textPlacement'] = typeof json['textPlacement'] === 'string' ? json['textPlacement'] : $root.com.wixpress.wixdocs.ViewerConfig.NameConflictResolution.TextPlacement[json['textPlacement']];
                } else if (withDefaults !== false) {
                  result['textPlacement'] = 'NO_PLACEMENT';
                } else {
                  delete result['textPlacement'];
                }
                return result;
              } else
                return json;
            }
            static toGRPC(obj, helper) {
              if (obj == null) {
                return null;
              } else {
                const grpc = {};
                if (obj['additionalText'] != null) {
                  grpc['additionalText'] = obj['additionalText'];
                }
                if (obj['textPlacement'] != null) {
                  grpc['textPlacement'] = obj['textPlacement'];
                }
                return grpc;
              }
            }
            static fromGRPC(grpc, helper) {
              if (grpc == null) {
                return null;
              } else {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.NameConflictResolution();
                if (grpc['additionalText'] != null) {
                  result['additionalText'] = grpc['additionalText'];
                } else {
                  result['additionalText'] = '';
                }
                if (grpc['textPlacement'] != null) {
                  result['textPlacement'] = grpc['textPlacement'];
                } else {
                  result['textPlacement'] = 'NO_PLACEMENT';
                }
                return result;
              }
            }
          }
          NameConflictResolution.TextPlacement = {
            'NO_PLACEMENT': 'NO_PLACEMENT',
            0: 'NO_PLACEMENT',
            'SUFFIX': 'SUFFIX',
            1: 'SUFFIX',
            'PREFIX': 'PREFIX',
            2: 'PREFIX'
          };
          NameConflictResolution.TextPlacement = {
            'NO_PLACEMENT': 'NO_PLACEMENT',
            0: 'NO_PLACEMENT',
            'SUFFIX': 'SUFFIX',
            1: 'SUFFIX',
            'PREFIX': 'PREFIX',
            2: 'PREFIX'
          };
          __builtIn.Object.defineProperty(NameConflictResolution.prototype, '__proto', {
            value: pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewerConfig.NameConflictResolution');
            },
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(NameConflictResolution.prototype, '__fqn__', {
            value: 'com.wixpress.wixdocs.ViewerConfig.NameConflictResolution',
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(NameConflictResolution.prototype, '__options__', {
            value: $root.__options,
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(NameConflictResolution.prototype, '__root__', {
            value: $root,
            enumerable: false,
            configurable: false
          });
          return NameConflictResolution;
        }());;
        ViewerConfig.CustomLabel = (function () {
          class CustomLabel {
            constructor(props) {
              this.name = props && props.name;
              this.color = props && props.color;
              this.description = props && props.description;
            }
            static toJSON(obj, helper, withDefaults) {
              if (obj == null) {
                return null;
              } else {
                const json = {};
                if (obj['name'] != null) {
                  json['name'] = obj['name'];
                } else if (withDefaults) {
                  json['name'] = '';
                }
                if (obj['color'] != null) {
                  json['color'] = obj['color'];
                } else if (withDefaults) {
                  json['color'] = '';
                }
                if (obj['description'] != null) {
                  json['description'] = obj['description'];
                } else if (withDefaults) {
                  json['description'] = '';
                }
                return json;
              }
            }
            static fromJSON(json, helper, withDefaults) {
              if (typeof json === 'object' && !Array.isArray(json)) {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.CustomLabel();
                if (json['name'] != null) {
                  result['name'] = json['name'];
                } else if (withDefaults !== false) {
                  result['name'] = '';
                } else {
                  delete result['name'];
                }
                if (json['color'] != null) {
                  result['color'] = json['color'];
                } else if (withDefaults !== false) {
                  result['color'] = '';
                } else {
                  delete result['color'];
                }
                if (json['description'] != null) {
                  result['description'] = json['description'];
                } else if (withDefaults !== false) {
                  result['description'] = '';
                } else {
                  delete result['description'];
                }
                return result;
              } else
                return json;
            }
            static toGRPC(obj, helper) {
              if (obj == null) {
                return null;
              } else {
                const grpc = {};
                if (obj['name'] != null) {
                  grpc['name'] = obj['name'];
                }
                if (obj['color'] != null) {
                  grpc['color'] = obj['color'];
                }
                if (obj['description'] != null) {
                  grpc['description'] = obj['description'];
                }
                return grpc;
              }
            }
            static fromGRPC(grpc, helper) {
              if (grpc == null) {
                return null;
              } else {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.CustomLabel();
                if (grpc['name'] != null) {
                  result['name'] = grpc['name'];
                } else {
                  result['name'] = '';
                }
                if (grpc['color'] != null) {
                  result['color'] = grpc['color'];
                } else {
                  result['color'] = '';
                }
                if (grpc['description'] != null) {
                  result['description'] = grpc['description'];
                } else {
                  result['description'] = '';
                }
                return result;
              }
            }
          }
          __builtIn.Object.defineProperty(CustomLabel.prototype, '__proto', {
            value: pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewerConfig.CustomLabel');
            },
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(CustomLabel.prototype, '__fqn__', {
            value: 'com.wixpress.wixdocs.ViewerConfig.CustomLabel',
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(CustomLabel.prototype, '__options__', {
            value: $root.__options,
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(CustomLabel.prototype, '__root__', {
            value: $root,
            enumerable: false,
            configurable: false
          });
          return CustomLabel;
        }());;
        ViewerConfig.EmbeddedScript = (function () {
          class EmbeddedScript {
            constructor(props) {
              this.location = props && props.location;
              this.script = props && props.script;
              this.name = props && props.name;
            }
            static toJSON(obj, helper, withDefaults) {
              if (obj == null) {
                return null;
              } else {
                const json = {};
                if (obj['location'] != null) {
                  json['location'] = $root.com.wixpress.wixdocs.ViewerConfig.EmbeddedScript.EmbeddedScriptLocation[obj['location']];
                } else if (withDefaults) {
                  json['location'] = 'HEAD';
                }
                if (obj['script'] != null) {
                  json['script'] = obj['script'];
                } else if (withDefaults) {
                  json['script'] = '';
                }
                if (obj['name'] != null) {
                  json['name'] = obj['name'];
                } else if (withDefaults) {
                  json['name'] = '';
                }
                return json;
              }
            }
            static fromJSON(json, helper, withDefaults) {
              if (typeof json === 'object' && !Array.isArray(json)) {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.EmbeddedScript();
                if (json['location'] != null) {
                  result['location'] = typeof json['location'] === 'string' ? json['location'] : $root.com.wixpress.wixdocs.ViewerConfig.EmbeddedScript.EmbeddedScriptLocation[json['location']];
                } else if (withDefaults !== false) {
                  result['location'] = 'HEAD';
                } else {
                  delete result['location'];
                }
                if (json['script'] != null) {
                  result['script'] = json['script'];
                } else if (withDefaults !== false) {
                  result['script'] = '';
                } else {
                  delete result['script'];
                }
                if (json['name'] != null) {
                  result['name'] = json['name'];
                } else if (withDefaults !== false) {
                  result['name'] = '';
                } else {
                  delete result['name'];
                }
                return result;
              } else
                return json;
            }
            static toGRPC(obj, helper) {
              if (obj == null) {
                return null;
              } else {
                const grpc = {};
                if (obj['location'] != null) {
                  grpc['location'] = obj['location'];
                }
                if (obj['script'] != null) {
                  grpc['script'] = obj['script'];
                }
                if (obj['name'] != null) {
                  grpc['name'] = obj['name'];
                }
                return grpc;
              }
            }
            static fromGRPC(grpc, helper) {
              if (grpc == null) {
                return null;
              } else {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.EmbeddedScript();
                if (grpc['location'] != null) {
                  result['location'] = grpc['location'];
                } else {
                  result['location'] = 'HEAD';
                }
                if (grpc['script'] != null) {
                  result['script'] = grpc['script'];
                } else {
                  result['script'] = '';
                }
                if (grpc['name'] != null) {
                  result['name'] = grpc['name'];
                } else {
                  result['name'] = '';
                }
                return result;
              }
            }
          }
          EmbeddedScript.EmbeddedScriptLocation = {
            'HEAD': 'HEAD',
            0: 'HEAD',
            'BODY_START': 'BODY_START',
            1: 'BODY_START',
            'BODY_END': 'BODY_END',
            2: 'BODY_END'
          };
          EmbeddedScript.EmbeddedScriptLocation = {
            'HEAD': 'HEAD',
            0: 'HEAD',
            'BODY_START': 'BODY_START',
            1: 'BODY_START',
            'BODY_END': 'BODY_END',
            2: 'BODY_END'
          };
          __builtIn.Object.defineProperty(EmbeddedScript.prototype, '__proto', {
            value: pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewerConfig.EmbeddedScript');
            },
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(EmbeddedScript.prototype, '__fqn__', {
            value: 'com.wixpress.wixdocs.ViewerConfig.EmbeddedScript',
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(EmbeddedScript.prototype, '__options__', {
            value: $root.__options,
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(EmbeddedScript.prototype, '__root__', {
            value: $root,
            enumerable: false,
            configurable: false
          });
          return EmbeddedScript;
        }());;
        ViewerConfig.RelatedSite = (function () {
          class RelatedSite {
            constructor(props) {
              this.name = props && props.name;
              this.url = props && props.url;
              this.viewerId = props && props.viewerId;
            }
            static toJSON(obj, helper, withDefaults) {
              if (obj == null) {
                return null;
              } else {
                const json = {};
                if (obj['name'] != null) {
                  json['name'] = obj['name'];
                } else if (withDefaults) {
                  json['name'] = '';
                }
                if (obj['url'] != null) {
                  json['url'] = obj['url'];
                } else if (withDefaults) {
                  json['url'] = '';
                }
                if (obj['viewerId'] != null) {
                  json['viewerId'] = $root.google.protobuf.StringValue.toJSON(obj['viewerId'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['viewerId'];
                }
                return json;
              }
            }
            static fromJSON(json, helper, withDefaults) {
              if (typeof json === 'object' && !Array.isArray(json)) {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.RelatedSite();
                if (json['name'] != null) {
                  result['name'] = json['name'];
                } else if (withDefaults !== false) {
                  result['name'] = '';
                } else {
                  delete result['name'];
                }
                if (json['url'] != null) {
                  result['url'] = json['url'];
                } else if (withDefaults !== false) {
                  result['url'] = '';
                } else {
                  delete result['url'];
                }
                if (json['viewerId'] != null) {
                  result['viewerId'] = $root.google.protobuf.StringValue.fromJSON(json['viewerId'], helper);
                } else if (withDefaults !== false) {
                  delete result['viewerId'];
                } else {
                  delete result['viewerId'];
                }
                return result;
              } else
                return json;
            }
            static toGRPC(obj, helper) {
              if (obj == null) {
                return null;
              } else {
                const grpc = {};
                if (obj['name'] != null) {
                  grpc['name'] = obj['name'];
                }
                if (obj['url'] != null) {
                  grpc['url'] = obj['url'];
                }
                if (obj['viewerId'] != null) {
                  grpc['viewerId'] = $root.google.protobuf.StringValue.toGRPC(obj['viewerId'], helper);
                }
                return grpc;
              }
            }
            static fromGRPC(grpc, helper) {
              if (grpc == null) {
                return null;
              } else {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.RelatedSite();
                if (grpc['name'] != null) {
                  result['name'] = grpc['name'];
                } else {
                  result['name'] = '';
                }
                if (grpc['url'] != null) {
                  result['url'] = grpc['url'];
                } else {
                  result['url'] = '';
                }
                if (grpc['viewerId'] != null) {
                  result['viewerId'] = $root.google.protobuf.StringValue.fromGRPC(grpc['viewerId'], helper);
                } else {
                  delete result['viewerId'];
                }
                return result;
              }
            }
          }
          __builtIn.Object.defineProperty(RelatedSite.prototype, '__proto', {
            value: pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewerConfig.RelatedSite');
            },
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(RelatedSite.prototype, '__fqn__', {
            value: 'com.wixpress.wixdocs.ViewerConfig.RelatedSite',
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(RelatedSite.prototype, '__options__', {
            value: $root.__options,
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(RelatedSite.prototype, '__root__', {
            value: $root,
            enumerable: false,
            configurable: false
          });
          return RelatedSite;
        }());;
        ViewerConfig.SeoConfig = (function () {
          class SeoConfig {
            constructor(props) {
              this.homePageTitle = props && props.homePageTitle;
              this.homePageDescription = props && props.homePageDescription;
              this.pageTitleSuffix = props && props.pageTitleSuffix;
              this.hideFromSearchEngines = props && props.hideFromSearchEngines;
            }
            static toJSON(obj, helper, withDefaults) {
              if (obj == null) {
                return null;
              } else {
                const json = {};
                if (obj['homePageTitle'] != null) {
                  json['homePageTitle'] = $root.google.protobuf.StringValue.toJSON(obj['homePageTitle'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['homePageTitle'];
                }
                if (obj['homePageDescription'] != null) {
                  json['homePageDescription'] = $root.google.protobuf.StringValue.toJSON(obj['homePageDescription'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['homePageDescription'];
                }
                if (obj['pageTitleSuffix'] != null) {
                  json['pageTitleSuffix'] = $root.google.protobuf.StringValue.toJSON(obj['pageTitleSuffix'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['pageTitleSuffix'];
                }
                if (obj['hideFromSearchEngines'] != null) {
                  json['hideFromSearchEngines'] = $root.google.protobuf.BoolValue.toJSON(obj['hideFromSearchEngines'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['hideFromSearchEngines'];
                }
                return json;
              }
            }
            static fromJSON(json, helper, withDefaults) {
              if (typeof json === 'object' && !Array.isArray(json)) {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.SeoConfig();
                if (json['homePageTitle'] != null) {
                  result['homePageTitle'] = $root.google.protobuf.StringValue.fromJSON(json['homePageTitle'], helper);
                } else if (withDefaults !== false) {
                  delete result['homePageTitle'];
                } else {
                  delete result['homePageTitle'];
                }
                if (json['homePageDescription'] != null) {
                  result['homePageDescription'] = $root.google.protobuf.StringValue.fromJSON(json['homePageDescription'], helper);
                } else if (withDefaults !== false) {
                  delete result['homePageDescription'];
                } else {
                  delete result['homePageDescription'];
                }
                if (json['pageTitleSuffix'] != null) {
                  result['pageTitleSuffix'] = $root.google.protobuf.StringValue.fromJSON(json['pageTitleSuffix'], helper);
                } else if (withDefaults !== false) {
                  delete result['pageTitleSuffix'];
                } else {
                  delete result['pageTitleSuffix'];
                }
                if (json['hideFromSearchEngines'] != null) {
                  result['hideFromSearchEngines'] = $root.google.protobuf.BoolValue.fromJSON(json['hideFromSearchEngines'], helper);
                } else if (withDefaults !== false) {
                  delete result['hideFromSearchEngines'];
                } else {
                  delete result['hideFromSearchEngines'];
                }
                return result;
              } else
                return json;
            }
            static toGRPC(obj, helper) {
              if (obj == null) {
                return null;
              } else {
                const grpc = {};
                if (obj['homePageTitle'] != null) {
                  grpc['homePageTitle'] = $root.google.protobuf.StringValue.toGRPC(obj['homePageTitle'], helper);
                }
                if (obj['homePageDescription'] != null) {
                  grpc['homePageDescription'] = $root.google.protobuf.StringValue.toGRPC(obj['homePageDescription'], helper);
                }
                if (obj['pageTitleSuffix'] != null) {
                  grpc['pageTitleSuffix'] = $root.google.protobuf.StringValue.toGRPC(obj['pageTitleSuffix'], helper);
                }
                if (obj['hideFromSearchEngines'] != null) {
                  grpc['hideFromSearchEngines'] = $root.google.protobuf.BoolValue.toGRPC(obj['hideFromSearchEngines'], helper);
                }
                return grpc;
              }
            }
            static fromGRPC(grpc, helper) {
              if (grpc == null) {
                return null;
              } else {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.SeoConfig();
                if (grpc['homePageTitle'] != null) {
                  result['homePageTitle'] = $root.google.protobuf.StringValue.fromGRPC(grpc['homePageTitle'], helper);
                } else {
                  delete result['homePageTitle'];
                }
                if (grpc['homePageDescription'] != null) {
                  result['homePageDescription'] = $root.google.protobuf.StringValue.fromGRPC(grpc['homePageDescription'], helper);
                } else {
                  delete result['homePageDescription'];
                }
                if (grpc['pageTitleSuffix'] != null) {
                  result['pageTitleSuffix'] = $root.google.protobuf.StringValue.fromGRPC(grpc['pageTitleSuffix'], helper);
                } else {
                  delete result['pageTitleSuffix'];
                }
                if (grpc['hideFromSearchEngines'] != null) {
                  result['hideFromSearchEngines'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['hideFromSearchEngines'], helper);
                } else {
                  delete result['hideFromSearchEngines'];
                }
                return result;
              }
            }
          }
          __builtIn.Object.defineProperty(SeoConfig.prototype, '__proto', {
            value: pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewerConfig.SeoConfig');
            },
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(SeoConfig.prototype, '__fqn__', {
            value: 'com.wixpress.wixdocs.ViewerConfig.SeoConfig',
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(SeoConfig.prototype, '__options__', {
            value: $root.__options,
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(SeoConfig.prototype, '__root__', {
            value: $root,
            enumerable: false,
            configurable: false
          });
          return SeoConfig;
        }());;
        ViewerConfig.DisplayOptions = (function () {
          class DisplayOptions {
            constructor(props) {
              this.showComplexTypesInTable = props && props.showComplexTypesInTable;
              this.openAllExamplesOnStart = props && props.openAllExamplesOnStart;
              this.hideRestPlayground = props && props.hideRestPlayground;
              this.showTokenBar = props && props.showTokenBar;
              this.favicon = props && props.favicon;
              this.showSourceLink = props && props.showSourceLink;
            }
            static toJSON(obj, helper, withDefaults) {
              if (obj == null) {
                return null;
              } else {
                const json = {};
                if (obj['showComplexTypesInTable'] != null) {
                  json['showComplexTypesInTable'] = $root.google.protobuf.BoolValue.toJSON(obj['showComplexTypesInTable'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['showComplexTypesInTable'];
                }
                if (obj['openAllExamplesOnStart'] != null) {
                  json['openAllExamplesOnStart'] = $root.google.protobuf.BoolValue.toJSON(obj['openAllExamplesOnStart'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['openAllExamplesOnStart'];
                }
                if (obj['hideRestPlayground'] != null) {
                  json['hideRestPlayground'] = $root.google.protobuf.BoolValue.toJSON(obj['hideRestPlayground'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['hideRestPlayground'];
                }
                if (obj['showTokenBar'] != null) {
                  json['showTokenBar'] = $root.google.protobuf.BoolValue.toJSON(obj['showTokenBar'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['showTokenBar'];
                }
                if (obj['favicon'] != null) {
                  json['favicon'] = $root.google.protobuf.StringValue.toJSON(obj['favicon'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['favicon'];
                }
                if (obj['showSourceLink'] != null) {
                  json['showSourceLink'] = $root.google.protobuf.BoolValue.toJSON(obj['showSourceLink'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['showSourceLink'];
                }
                return json;
              }
            }
            static fromJSON(json, helper, withDefaults) {
              if (typeof json === 'object' && !Array.isArray(json)) {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.DisplayOptions();
                if (json['showComplexTypesInTable'] != null) {
                  result['showComplexTypesInTable'] = $root.google.protobuf.BoolValue.fromJSON(json['showComplexTypesInTable'], helper);
                } else if (withDefaults !== false) {
                  delete result['showComplexTypesInTable'];
                } else {
                  delete result['showComplexTypesInTable'];
                }
                if (json['openAllExamplesOnStart'] != null) {
                  result['openAllExamplesOnStart'] = $root.google.protobuf.BoolValue.fromJSON(json['openAllExamplesOnStart'], helper);
                } else if (withDefaults !== false) {
                  delete result['openAllExamplesOnStart'];
                } else {
                  delete result['openAllExamplesOnStart'];
                }
                if (json['hideRestPlayground'] != null) {
                  result['hideRestPlayground'] = $root.google.protobuf.BoolValue.fromJSON(json['hideRestPlayground'], helper);
                } else if (withDefaults !== false) {
                  delete result['hideRestPlayground'];
                } else {
                  delete result['hideRestPlayground'];
                }
                if (json['showTokenBar'] != null) {
                  result['showTokenBar'] = $root.google.protobuf.BoolValue.fromJSON(json['showTokenBar'], helper);
                } else if (withDefaults !== false) {
                  delete result['showTokenBar'];
                } else {
                  delete result['showTokenBar'];
                }
                if (json['favicon'] != null) {
                  result['favicon'] = $root.google.protobuf.StringValue.fromJSON(json['favicon'], helper);
                } else if (withDefaults !== false) {
                  delete result['favicon'];
                } else {
                  delete result['favicon'];
                }
                if (json['showSourceLink'] != null) {
                  result['showSourceLink'] = $root.google.protobuf.BoolValue.fromJSON(json['showSourceLink'], helper);
                } else if (withDefaults !== false) {
                  delete result['showSourceLink'];
                } else {
                  delete result['showSourceLink'];
                }
                return result;
              } else
                return json;
            }
            static toGRPC(obj, helper) {
              if (obj == null) {
                return null;
              } else {
                const grpc = {};
                if (obj['showComplexTypesInTable'] != null) {
                  grpc['showComplexTypesInTable'] = $root.google.protobuf.BoolValue.toGRPC(obj['showComplexTypesInTable'], helper);
                }
                if (obj['openAllExamplesOnStart'] != null) {
                  grpc['openAllExamplesOnStart'] = $root.google.protobuf.BoolValue.toGRPC(obj['openAllExamplesOnStart'], helper);
                }
                if (obj['hideRestPlayground'] != null) {
                  grpc['hideRestPlayground'] = $root.google.protobuf.BoolValue.toGRPC(obj['hideRestPlayground'], helper);
                }
                if (obj['showTokenBar'] != null) {
                  grpc['showTokenBar'] = $root.google.protobuf.BoolValue.toGRPC(obj['showTokenBar'], helper);
                }
                if (obj['favicon'] != null) {
                  grpc['favicon'] = $root.google.protobuf.StringValue.toGRPC(obj['favicon'], helper);
                }
                if (obj['showSourceLink'] != null) {
                  grpc['showSourceLink'] = $root.google.protobuf.BoolValue.toGRPC(obj['showSourceLink'], helper);
                }
                return grpc;
              }
            }
            static fromGRPC(grpc, helper) {
              if (grpc == null) {
                return null;
              } else {
                const result = new $root.com.wixpress.wixdocs.ViewerConfig.DisplayOptions();
                if (grpc['showComplexTypesInTable'] != null) {
                  result['showComplexTypesInTable'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['showComplexTypesInTable'], helper);
                } else {
                  delete result['showComplexTypesInTable'];
                }
                if (grpc['openAllExamplesOnStart'] != null) {
                  result['openAllExamplesOnStart'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['openAllExamplesOnStart'], helper);
                } else {
                  delete result['openAllExamplesOnStart'];
                }
                if (grpc['hideRestPlayground'] != null) {
                  result['hideRestPlayground'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['hideRestPlayground'], helper);
                } else {
                  delete result['hideRestPlayground'];
                }
                if (grpc['showTokenBar'] != null) {
                  result['showTokenBar'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['showTokenBar'], helper);
                } else {
                  delete result['showTokenBar'];
                }
                if (grpc['favicon'] != null) {
                  result['favicon'] = $root.google.protobuf.StringValue.fromGRPC(grpc['favicon'], helper);
                } else {
                  delete result['favicon'];
                }
                if (grpc['showSourceLink'] != null) {
                  result['showSourceLink'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['showSourceLink'], helper);
                } else {
                  delete result['showSourceLink'];
                }
                return result;
              }
            }
          }
          __builtIn.Object.defineProperty(DisplayOptions.prototype, '__proto', {
            value: pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewerConfig.DisplayOptions');
            },
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(DisplayOptions.prototype, '__fqn__', {
            value: 'com.wixpress.wixdocs.ViewerConfig.DisplayOptions',
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(DisplayOptions.prototype, '__options__', {
            value: $root.__options,
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(DisplayOptions.prototype, '__root__', {
            value: $root,
            enumerable: false,
            configurable: false
          });
          return DisplayOptions;
        }());;
        __builtIn.Object.defineProperty(ViewerConfig.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewerConfig');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewerConfig.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.ViewerConfig',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewerConfig.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewerConfig.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return ViewerConfig;
      }());;
      _wixdocs.MenuConfig = (function () {
        class MenuConfig {
          constructor(props) {
            this.categories = props && props.categories;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['categories'] != null) {
                json['categories'] = obj['categories'].map(e => {
                  return $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['categories'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.MenuConfig();
              if (json['categories'] != null) {
                result['categories'] = Array.isArray(json['categories']) ? json['categories'].map(e => {
                  return $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.fromJSON(e, helper);
                }) : json['categories'];
              } else if (withDefaults !== false) {
                result['categories'] = [];
              } else {
                delete result['categories'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['categories'] != null) {
                grpc['categories'] = obj['categories'].map(e => {
                  return $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.toGRPC(e, helper);
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.MenuConfig();
              if (grpc['categories'] != null) {
                result['categories'] = grpc['categories'].map(e => {
                  return $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.fromGRPC(e, helper);
                });
              } else {
                result['categories'] = [];
              }
              return result;
            }
          }
        }
        MenuConfig.MenuConfigCategory = (function () {
          class MenuConfigCategory {
            constructor(props) {
              this.name = props && props.name;
              this.path = props && props.path;
              this.visible = props && props.visible;
              this.type = props && props.type;
              this.sortOrder = props && props.sortOrder;
              this.touched = props && props.touched;
              this.members = props && props.members;
            }
            static toJSON(obj, helper, withDefaults) {
              if (obj == null) {
                return null;
              } else {
                const json = {};
                if (obj['name'] != null) {
                  json['name'] = obj['name'];
                } else if (withDefaults) {
                  json['name'] = '';
                }
                if (obj['path'] != null) {
                  json['path'] = obj['path'];
                } else if (withDefaults) {
                  json['path'] = '';
                }
                if (obj['visible'] != null) {
                  json['visible'] = obj['visible'];
                } else if (withDefaults) {
                  json['visible'] = false;
                }
                if (obj['type'] != null) {
                  json['type'] = obj['type'];
                } else if (withDefaults) {
                  json['type'] = '';
                }
                if (obj['sortOrder'] != null) {
                  json['sortOrder'] = $root.google.protobuf.UInt32Value.toJSON(obj['sortOrder'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['sortOrder'];
                }
                if (obj['touched'] != null) {
                  json['touched'] = $root.google.protobuf.BoolValue.toJSON(obj['touched'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['touched'];
                }
                if (obj['members'] != null) {
                  json['members'] = obj['members'].map(e => {
                    return $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member.toJSON(e, helper, withDefaults);
                  });
                } else if (withDefaults) {
                  json['members'] = [];
                }
                return json;
              }
            }
            static fromJSON(json, helper, withDefaults) {
              if (typeof json === 'object' && !Array.isArray(json)) {
                const result = new $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory();
                if (json['name'] != null) {
                  result['name'] = json['name'];
                } else if (withDefaults !== false) {
                  result['name'] = '';
                } else {
                  delete result['name'];
                }
                if (json['path'] != null) {
                  result['path'] = json['path'];
                } else if (withDefaults !== false) {
                  result['path'] = '';
                } else {
                  delete result['path'];
                }
                if (json['visible'] != null) {
                  result['visible'] = json['visible'];
                } else if (withDefaults !== false) {
                  result['visible'] = false;
                } else {
                  delete result['visible'];
                }
                if (json['type'] != null) {
                  result['type'] = json['type'];
                } else if (withDefaults !== false) {
                  result['type'] = '';
                } else {
                  delete result['type'];
                }
                if (json['sortOrder'] != null) {
                  result['sortOrder'] = $root.google.protobuf.UInt32Value.fromJSON(json['sortOrder'], helper);
                } else if (withDefaults !== false) {
                  delete result['sortOrder'];
                } else {
                  delete result['sortOrder'];
                }
                if (json['touched'] != null) {
                  result['touched'] = $root.google.protobuf.BoolValue.fromJSON(json['touched'], helper);
                } else if (withDefaults !== false) {
                  delete result['touched'];
                } else {
                  delete result['touched'];
                }
                if (json['members'] != null) {
                  result['members'] = Array.isArray(json['members']) ? json['members'].map(e => {
                    return $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member.fromJSON(e, helper);
                  }) : json['members'];
                } else if (withDefaults !== false) {
                  result['members'] = [];
                } else {
                  delete result['members'];
                }
                return result;
              } else
                return json;
            }
            static toGRPC(obj, helper) {
              if (obj == null) {
                return null;
              } else {
                const grpc = {};
                if (obj['name'] != null) {
                  grpc['name'] = obj['name'];
                }
                if (obj['path'] != null) {
                  grpc['path'] = obj['path'];
                }
                if (obj['visible'] != null) {
                  grpc['visible'] = obj['visible'];
                }
                if (obj['type'] != null) {
                  grpc['type'] = obj['type'];
                }
                if (obj['sortOrder'] != null) {
                  grpc['sortOrder'] = $root.google.protobuf.UInt32Value.toGRPC(obj['sortOrder'], helper);
                }
                if (obj['touched'] != null) {
                  grpc['touched'] = $root.google.protobuf.BoolValue.toGRPC(obj['touched'], helper);
                }
                if (obj['members'] != null) {
                  grpc['members'] = obj['members'].map(e => {
                    return $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member.toGRPC(e, helper);
                  });
                }
                return grpc;
              }
            }
            static fromGRPC(grpc, helper) {
              if (grpc == null) {
                return null;
              } else {
                const result = new $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory();
                if (grpc['name'] != null) {
                  result['name'] = grpc['name'];
                } else {
                  result['name'] = '';
                }
                if (grpc['path'] != null) {
                  result['path'] = grpc['path'];
                } else {
                  result['path'] = '';
                }
                if (grpc['visible'] != null) {
                  result['visible'] = grpc['visible'];
                } else {
                  result['visible'] = false;
                }
                if (grpc['type'] != null) {
                  result['type'] = grpc['type'];
                } else {
                  result['type'] = '';
                }
                if (grpc['sortOrder'] != null) {
                  result['sortOrder'] = $root.google.protobuf.UInt32Value.fromGRPC(grpc['sortOrder'], helper);
                } else {
                  delete result['sortOrder'];
                }
                if (grpc['touched'] != null) {
                  result['touched'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['touched'], helper);
                } else {
                  delete result['touched'];
                }
                if (grpc['members'] != null) {
                  result['members'] = grpc['members'].map(e => {
                    return $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member.fromGRPC(e, helper);
                  });
                } else {
                  result['members'] = [];
                }
                return result;
              }
            }
          }
          MenuConfigCategory.Member = (function () {
            class Member {
              constructor(props) {
                this.name = props && props.name;
                this.path = props && props.path;
                this.visible = props && props.visible;
                this.type = props && props.type;
                this.sortOrder = props && props.sortOrder;
                this.movedFrom = props && props.movedFrom;
                this.touched = props && props.touched;
              }
              static toJSON(obj, helper, withDefaults) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};
                  if (obj['name'] != null) {
                    json['name'] = obj['name'];
                  } else if (withDefaults) {
                    json['name'] = '';
                  }
                  if (obj['path'] != null) {
                    json['path'] = obj['path'];
                  } else if (withDefaults) {
                    json['path'] = '';
                  }
                  if (obj['visible'] != null) {
                    json['visible'] = obj['visible'];
                  } else if (withDefaults) {
                    json['visible'] = false;
                  }
                  if (obj['type'] != null) {
                    json['type'] = obj['type'];
                  } else if (withDefaults) {
                    json['type'] = '';
                  }
                  if (obj['sortOrder'] != null) {
                    json['sortOrder'] = $root.google.protobuf.UInt32Value.toJSON(obj['sortOrder'], helper, withDefaults);
                  } else if (withDefaults) {
                    delete json['sortOrder'];
                  }
                  if (obj['movedFrom'] != null) {
                    json['movedFrom'] = $root.google.protobuf.StringValue.toJSON(obj['movedFrom'], helper, withDefaults);
                  } else if (withDefaults) {
                    delete json['movedFrom'];
                  }
                  if (obj['touched'] != null) {
                    json['touched'] = $root.google.protobuf.BoolValue.toJSON(obj['touched'], helper, withDefaults);
                  } else if (withDefaults) {
                    delete json['touched'];
                  }
                  return json;
                }
              }
              static fromJSON(json, helper, withDefaults) {
                if (typeof json === 'object' && !Array.isArray(json)) {
                  const result = new $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member();
                  if (json['name'] != null) {
                    result['name'] = json['name'];
                  } else if (withDefaults !== false) {
                    result['name'] = '';
                  } else {
                    delete result['name'];
                  }
                  if (json['path'] != null) {
                    result['path'] = json['path'];
                  } else if (withDefaults !== false) {
                    result['path'] = '';
                  } else {
                    delete result['path'];
                  }
                  if (json['visible'] != null) {
                    result['visible'] = json['visible'];
                  } else if (withDefaults !== false) {
                    result['visible'] = false;
                  } else {
                    delete result['visible'];
                  }
                  if (json['type'] != null) {
                    result['type'] = json['type'];
                  } else if (withDefaults !== false) {
                    result['type'] = '';
                  } else {
                    delete result['type'];
                  }
                  if (json['sortOrder'] != null) {
                    result['sortOrder'] = $root.google.protobuf.UInt32Value.fromJSON(json['sortOrder'], helper);
                  } else if (withDefaults !== false) {
                    delete result['sortOrder'];
                  } else {
                    delete result['sortOrder'];
                  }
                  if (json['movedFrom'] != null) {
                    result['movedFrom'] = $root.google.protobuf.StringValue.fromJSON(json['movedFrom'], helper);
                  } else if (withDefaults !== false) {
                    delete result['movedFrom'];
                  } else {
                    delete result['movedFrom'];
                  }
                  if (json['touched'] != null) {
                    result['touched'] = $root.google.protobuf.BoolValue.fromJSON(json['touched'], helper);
                  } else if (withDefaults !== false) {
                    delete result['touched'];
                  } else {
                    delete result['touched'];
                  }
                  return result;
                } else
                  return json;
              }
              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};
                  if (obj['name'] != null) {
                    grpc['name'] = obj['name'];
                  }
                  if (obj['path'] != null) {
                    grpc['path'] = obj['path'];
                  }
                  if (obj['visible'] != null) {
                    grpc['visible'] = obj['visible'];
                  }
                  if (obj['type'] != null) {
                    grpc['type'] = obj['type'];
                  }
                  if (obj['sortOrder'] != null) {
                    grpc['sortOrder'] = $root.google.protobuf.UInt32Value.toGRPC(obj['sortOrder'], helper);
                  }
                  if (obj['movedFrom'] != null) {
                    grpc['movedFrom'] = $root.google.protobuf.StringValue.toGRPC(obj['movedFrom'], helper);
                  }
                  if (obj['touched'] != null) {
                    grpc['touched'] = $root.google.protobuf.BoolValue.toGRPC(obj['touched'], helper);
                  }
                  return grpc;
                }
              }
              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member();
                  if (grpc['name'] != null) {
                    result['name'] = grpc['name'];
                  } else {
                    result['name'] = '';
                  }
                  if (grpc['path'] != null) {
                    result['path'] = grpc['path'];
                  } else {
                    result['path'] = '';
                  }
                  if (grpc['visible'] != null) {
                    result['visible'] = grpc['visible'];
                  } else {
                    result['visible'] = false;
                  }
                  if (grpc['type'] != null) {
                    result['type'] = grpc['type'];
                  } else {
                    result['type'] = '';
                  }
                  if (grpc['sortOrder'] != null) {
                    result['sortOrder'] = $root.google.protobuf.UInt32Value.fromGRPC(grpc['sortOrder'], helper);
                  } else {
                    delete result['sortOrder'];
                  }
                  if (grpc['movedFrom'] != null) {
                    result['movedFrom'] = $root.google.protobuf.StringValue.fromGRPC(grpc['movedFrom'], helper);
                  } else {
                    delete result['movedFrom'];
                  }
                  if (grpc['touched'] != null) {
                    result['touched'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['touched'], helper);
                  } else {
                    delete result['touched'];
                  }
                  return result;
                }
              }
            }
            __builtIn.Object.defineProperty(Member.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member');
              },
              enumerable: false,
              configurable: false
            });
            __builtIn.Object.defineProperty(Member.prototype, '__fqn__', {
              value: 'com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member',
              enumerable: false,
              configurable: false
            });
            __builtIn.Object.defineProperty(Member.prototype, '__options__', {
              value: $root.__options,
              enumerable: false,
              configurable: false
            });
            __builtIn.Object.defineProperty(Member.prototype, '__root__', {
              value: $root,
              enumerable: false,
              configurable: false
            });
            return Member;
          }());;
          MenuConfigCategory.Member = (function () {
            class Member {
              constructor(props) {
                this.name = props && props.name;
                this.path = props && props.path;
                this.visible = props && props.visible;
                this.type = props && props.type;
                this.sortOrder = props && props.sortOrder;
                this.movedFrom = props && props.movedFrom;
                this.touched = props && props.touched;
              }
              static toJSON(obj, helper, withDefaults) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};
                  if (obj['name'] != null) {
                    json['name'] = obj['name'];
                  } else if (withDefaults) {
                    json['name'] = '';
                  }
                  if (obj['path'] != null) {
                    json['path'] = obj['path'];
                  } else if (withDefaults) {
                    json['path'] = '';
                  }
                  if (obj['visible'] != null) {
                    json['visible'] = obj['visible'];
                  } else if (withDefaults) {
                    json['visible'] = false;
                  }
                  if (obj['type'] != null) {
                    json['type'] = obj['type'];
                  } else if (withDefaults) {
                    json['type'] = '';
                  }
                  if (obj['sortOrder'] != null) {
                    json['sortOrder'] = $root.google.protobuf.UInt32Value.toJSON(obj['sortOrder'], helper, withDefaults);
                  } else if (withDefaults) {
                    delete json['sortOrder'];
                  }
                  if (obj['movedFrom'] != null) {
                    json['movedFrom'] = $root.google.protobuf.StringValue.toJSON(obj['movedFrom'], helper, withDefaults);
                  } else if (withDefaults) {
                    delete json['movedFrom'];
                  }
                  if (obj['touched'] != null) {
                    json['touched'] = $root.google.protobuf.BoolValue.toJSON(obj['touched'], helper, withDefaults);
                  } else if (withDefaults) {
                    delete json['touched'];
                  }
                  return json;
                }
              }
              static fromJSON(json, helper, withDefaults) {
                if (typeof json === 'object' && !Array.isArray(json)) {
                  const result = new $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member();
                  if (json['name'] != null) {
                    result['name'] = json['name'];
                  } else if (withDefaults !== false) {
                    result['name'] = '';
                  } else {
                    delete result['name'];
                  }
                  if (json['path'] != null) {
                    result['path'] = json['path'];
                  } else if (withDefaults !== false) {
                    result['path'] = '';
                  } else {
                    delete result['path'];
                  }
                  if (json['visible'] != null) {
                    result['visible'] = json['visible'];
                  } else if (withDefaults !== false) {
                    result['visible'] = false;
                  } else {
                    delete result['visible'];
                  }
                  if (json['type'] != null) {
                    result['type'] = json['type'];
                  } else if (withDefaults !== false) {
                    result['type'] = '';
                  } else {
                    delete result['type'];
                  }
                  if (json['sortOrder'] != null) {
                    result['sortOrder'] = $root.google.protobuf.UInt32Value.fromJSON(json['sortOrder'], helper);
                  } else if (withDefaults !== false) {
                    delete result['sortOrder'];
                  } else {
                    delete result['sortOrder'];
                  }
                  if (json['movedFrom'] != null) {
                    result['movedFrom'] = $root.google.protobuf.StringValue.fromJSON(json['movedFrom'], helper);
                  } else if (withDefaults !== false) {
                    delete result['movedFrom'];
                  } else {
                    delete result['movedFrom'];
                  }
                  if (json['touched'] != null) {
                    result['touched'] = $root.google.protobuf.BoolValue.fromJSON(json['touched'], helper);
                  } else if (withDefaults !== false) {
                    delete result['touched'];
                  } else {
                    delete result['touched'];
                  }
                  return result;
                } else
                  return json;
              }
              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};
                  if (obj['name'] != null) {
                    grpc['name'] = obj['name'];
                  }
                  if (obj['path'] != null) {
                    grpc['path'] = obj['path'];
                  }
                  if (obj['visible'] != null) {
                    grpc['visible'] = obj['visible'];
                  }
                  if (obj['type'] != null) {
                    grpc['type'] = obj['type'];
                  }
                  if (obj['sortOrder'] != null) {
                    grpc['sortOrder'] = $root.google.protobuf.UInt32Value.toGRPC(obj['sortOrder'], helper);
                  }
                  if (obj['movedFrom'] != null) {
                    grpc['movedFrom'] = $root.google.protobuf.StringValue.toGRPC(obj['movedFrom'], helper);
                  }
                  if (obj['touched'] != null) {
                    grpc['touched'] = $root.google.protobuf.BoolValue.toGRPC(obj['touched'], helper);
                  }
                  return grpc;
                }
              }
              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member();
                  if (grpc['name'] != null) {
                    result['name'] = grpc['name'];
                  } else {
                    result['name'] = '';
                  }
                  if (grpc['path'] != null) {
                    result['path'] = grpc['path'];
                  } else {
                    result['path'] = '';
                  }
                  if (grpc['visible'] != null) {
                    result['visible'] = grpc['visible'];
                  } else {
                    result['visible'] = false;
                  }
                  if (grpc['type'] != null) {
                    result['type'] = grpc['type'];
                  } else {
                    result['type'] = '';
                  }
                  if (grpc['sortOrder'] != null) {
                    result['sortOrder'] = $root.google.protobuf.UInt32Value.fromGRPC(grpc['sortOrder'], helper);
                  } else {
                    delete result['sortOrder'];
                  }
                  if (grpc['movedFrom'] != null) {
                    result['movedFrom'] = $root.google.protobuf.StringValue.fromGRPC(grpc['movedFrom'], helper);
                  } else {
                    delete result['movedFrom'];
                  }
                  if (grpc['touched'] != null) {
                    result['touched'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['touched'], helper);
                  } else {
                    delete result['touched'];
                  }
                  return result;
                }
              }
            }
            __builtIn.Object.defineProperty(Member.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member');
              },
              enumerable: false,
              configurable: false
            });
            __builtIn.Object.defineProperty(Member.prototype, '__fqn__', {
              value: 'com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member',
              enumerable: false,
              configurable: false
            });
            __builtIn.Object.defineProperty(Member.prototype, '__options__', {
              value: $root.__options,
              enumerable: false,
              configurable: false
            });
            __builtIn.Object.defineProperty(Member.prototype, '__root__', {
              value: $root,
              enumerable: false,
              configurable: false
            });
            return Member;
          }());;
          __builtIn.Object.defineProperty(MenuConfigCategory.prototype, '__proto', {
            value: pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.wixdocs.MenuConfig.MenuConfigCategory');
            },
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(MenuConfigCategory.prototype, '__fqn__', {
            value: 'com.wixpress.wixdocs.MenuConfig.MenuConfigCategory',
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(MenuConfigCategory.prototype, '__options__', {
            value: $root.__options,
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(MenuConfigCategory.prototype, '__root__', {
            value: $root,
            enumerable: false,
            configurable: false
          });
          return MenuConfigCategory;
        }());;
        MenuConfig.MenuConfigCategory = (function () {
          class MenuConfigCategory {
            constructor(props) {
              this.name = props && props.name;
              this.path = props && props.path;
              this.visible = props && props.visible;
              this.type = props && props.type;
              this.sortOrder = props && props.sortOrder;
              this.touched = props && props.touched;
              this.members = props && props.members;
            }
            static toJSON(obj, helper, withDefaults) {
              if (obj == null) {
                return null;
              } else {
                const json = {};
                if (obj['name'] != null) {
                  json['name'] = obj['name'];
                } else if (withDefaults) {
                  json['name'] = '';
                }
                if (obj['path'] != null) {
                  json['path'] = obj['path'];
                } else if (withDefaults) {
                  json['path'] = '';
                }
                if (obj['visible'] != null) {
                  json['visible'] = obj['visible'];
                } else if (withDefaults) {
                  json['visible'] = false;
                }
                if (obj['type'] != null) {
                  json['type'] = obj['type'];
                } else if (withDefaults) {
                  json['type'] = '';
                }
                if (obj['sortOrder'] != null) {
                  json['sortOrder'] = $root.google.protobuf.UInt32Value.toJSON(obj['sortOrder'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['sortOrder'];
                }
                if (obj['touched'] != null) {
                  json['touched'] = $root.google.protobuf.BoolValue.toJSON(obj['touched'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['touched'];
                }
                if (obj['members'] != null) {
                  json['members'] = obj['members'].map(e => {
                    return $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member.toJSON(e, helper, withDefaults);
                  });
                } else if (withDefaults) {
                  json['members'] = [];
                }
                return json;
              }
            }
            static fromJSON(json, helper, withDefaults) {
              if (typeof json === 'object' && !Array.isArray(json)) {
                const result = new $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory();
                if (json['name'] != null) {
                  result['name'] = json['name'];
                } else if (withDefaults !== false) {
                  result['name'] = '';
                } else {
                  delete result['name'];
                }
                if (json['path'] != null) {
                  result['path'] = json['path'];
                } else if (withDefaults !== false) {
                  result['path'] = '';
                } else {
                  delete result['path'];
                }
                if (json['visible'] != null) {
                  result['visible'] = json['visible'];
                } else if (withDefaults !== false) {
                  result['visible'] = false;
                } else {
                  delete result['visible'];
                }
                if (json['type'] != null) {
                  result['type'] = json['type'];
                } else if (withDefaults !== false) {
                  result['type'] = '';
                } else {
                  delete result['type'];
                }
                if (json['sortOrder'] != null) {
                  result['sortOrder'] = $root.google.protobuf.UInt32Value.fromJSON(json['sortOrder'], helper);
                } else if (withDefaults !== false) {
                  delete result['sortOrder'];
                } else {
                  delete result['sortOrder'];
                }
                if (json['touched'] != null) {
                  result['touched'] = $root.google.protobuf.BoolValue.fromJSON(json['touched'], helper);
                } else if (withDefaults !== false) {
                  delete result['touched'];
                } else {
                  delete result['touched'];
                }
                if (json['members'] != null) {
                  result['members'] = Array.isArray(json['members']) ? json['members'].map(e => {
                    return $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member.fromJSON(e, helper);
                  }) : json['members'];
                } else if (withDefaults !== false) {
                  result['members'] = [];
                } else {
                  delete result['members'];
                }
                return result;
              } else
                return json;
            }
            static toGRPC(obj, helper) {
              if (obj == null) {
                return null;
              } else {
                const grpc = {};
                if (obj['name'] != null) {
                  grpc['name'] = obj['name'];
                }
                if (obj['path'] != null) {
                  grpc['path'] = obj['path'];
                }
                if (obj['visible'] != null) {
                  grpc['visible'] = obj['visible'];
                }
                if (obj['type'] != null) {
                  grpc['type'] = obj['type'];
                }
                if (obj['sortOrder'] != null) {
                  grpc['sortOrder'] = $root.google.protobuf.UInt32Value.toGRPC(obj['sortOrder'], helper);
                }
                if (obj['touched'] != null) {
                  grpc['touched'] = $root.google.protobuf.BoolValue.toGRPC(obj['touched'], helper);
                }
                if (obj['members'] != null) {
                  grpc['members'] = obj['members'].map(e => {
                    return $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member.toGRPC(e, helper);
                  });
                }
                return grpc;
              }
            }
            static fromGRPC(grpc, helper) {
              if (grpc == null) {
                return null;
              } else {
                const result = new $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory();
                if (grpc['name'] != null) {
                  result['name'] = grpc['name'];
                } else {
                  result['name'] = '';
                }
                if (grpc['path'] != null) {
                  result['path'] = grpc['path'];
                } else {
                  result['path'] = '';
                }
                if (grpc['visible'] != null) {
                  result['visible'] = grpc['visible'];
                } else {
                  result['visible'] = false;
                }
                if (grpc['type'] != null) {
                  result['type'] = grpc['type'];
                } else {
                  result['type'] = '';
                }
                if (grpc['sortOrder'] != null) {
                  result['sortOrder'] = $root.google.protobuf.UInt32Value.fromGRPC(grpc['sortOrder'], helper);
                } else {
                  delete result['sortOrder'];
                }
                if (grpc['touched'] != null) {
                  result['touched'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['touched'], helper);
                } else {
                  delete result['touched'];
                }
                if (grpc['members'] != null) {
                  result['members'] = grpc['members'].map(e => {
                    return $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member.fromGRPC(e, helper);
                  });
                } else {
                  result['members'] = [];
                }
                return result;
              }
            }
          }
          MenuConfigCategory.Member = (function () {
            class Member {
              constructor(props) {
                this.name = props && props.name;
                this.path = props && props.path;
                this.visible = props && props.visible;
                this.type = props && props.type;
                this.sortOrder = props && props.sortOrder;
                this.movedFrom = props && props.movedFrom;
                this.touched = props && props.touched;
              }
              static toJSON(obj, helper, withDefaults) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};
                  if (obj['name'] != null) {
                    json['name'] = obj['name'];
                  } else if (withDefaults) {
                    json['name'] = '';
                  }
                  if (obj['path'] != null) {
                    json['path'] = obj['path'];
                  } else if (withDefaults) {
                    json['path'] = '';
                  }
                  if (obj['visible'] != null) {
                    json['visible'] = obj['visible'];
                  } else if (withDefaults) {
                    json['visible'] = false;
                  }
                  if (obj['type'] != null) {
                    json['type'] = obj['type'];
                  } else if (withDefaults) {
                    json['type'] = '';
                  }
                  if (obj['sortOrder'] != null) {
                    json['sortOrder'] = $root.google.protobuf.UInt32Value.toJSON(obj['sortOrder'], helper, withDefaults);
                  } else if (withDefaults) {
                    delete json['sortOrder'];
                  }
                  if (obj['movedFrom'] != null) {
                    json['movedFrom'] = $root.google.protobuf.StringValue.toJSON(obj['movedFrom'], helper, withDefaults);
                  } else if (withDefaults) {
                    delete json['movedFrom'];
                  }
                  if (obj['touched'] != null) {
                    json['touched'] = $root.google.protobuf.BoolValue.toJSON(obj['touched'], helper, withDefaults);
                  } else if (withDefaults) {
                    delete json['touched'];
                  }
                  return json;
                }
              }
              static fromJSON(json, helper, withDefaults) {
                if (typeof json === 'object' && !Array.isArray(json)) {
                  const result = new $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member();
                  if (json['name'] != null) {
                    result['name'] = json['name'];
                  } else if (withDefaults !== false) {
                    result['name'] = '';
                  } else {
                    delete result['name'];
                  }
                  if (json['path'] != null) {
                    result['path'] = json['path'];
                  } else if (withDefaults !== false) {
                    result['path'] = '';
                  } else {
                    delete result['path'];
                  }
                  if (json['visible'] != null) {
                    result['visible'] = json['visible'];
                  } else if (withDefaults !== false) {
                    result['visible'] = false;
                  } else {
                    delete result['visible'];
                  }
                  if (json['type'] != null) {
                    result['type'] = json['type'];
                  } else if (withDefaults !== false) {
                    result['type'] = '';
                  } else {
                    delete result['type'];
                  }
                  if (json['sortOrder'] != null) {
                    result['sortOrder'] = $root.google.protobuf.UInt32Value.fromJSON(json['sortOrder'], helper);
                  } else if (withDefaults !== false) {
                    delete result['sortOrder'];
                  } else {
                    delete result['sortOrder'];
                  }
                  if (json['movedFrom'] != null) {
                    result['movedFrom'] = $root.google.protobuf.StringValue.fromJSON(json['movedFrom'], helper);
                  } else if (withDefaults !== false) {
                    delete result['movedFrom'];
                  } else {
                    delete result['movedFrom'];
                  }
                  if (json['touched'] != null) {
                    result['touched'] = $root.google.protobuf.BoolValue.fromJSON(json['touched'], helper);
                  } else if (withDefaults !== false) {
                    delete result['touched'];
                  } else {
                    delete result['touched'];
                  }
                  return result;
                } else
                  return json;
              }
              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};
                  if (obj['name'] != null) {
                    grpc['name'] = obj['name'];
                  }
                  if (obj['path'] != null) {
                    grpc['path'] = obj['path'];
                  }
                  if (obj['visible'] != null) {
                    grpc['visible'] = obj['visible'];
                  }
                  if (obj['type'] != null) {
                    grpc['type'] = obj['type'];
                  }
                  if (obj['sortOrder'] != null) {
                    grpc['sortOrder'] = $root.google.protobuf.UInt32Value.toGRPC(obj['sortOrder'], helper);
                  }
                  if (obj['movedFrom'] != null) {
                    grpc['movedFrom'] = $root.google.protobuf.StringValue.toGRPC(obj['movedFrom'], helper);
                  }
                  if (obj['touched'] != null) {
                    grpc['touched'] = $root.google.protobuf.BoolValue.toGRPC(obj['touched'], helper);
                  }
                  return grpc;
                }
              }
              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member();
                  if (grpc['name'] != null) {
                    result['name'] = grpc['name'];
                  } else {
                    result['name'] = '';
                  }
                  if (grpc['path'] != null) {
                    result['path'] = grpc['path'];
                  } else {
                    result['path'] = '';
                  }
                  if (grpc['visible'] != null) {
                    result['visible'] = grpc['visible'];
                  } else {
                    result['visible'] = false;
                  }
                  if (grpc['type'] != null) {
                    result['type'] = grpc['type'];
                  } else {
                    result['type'] = '';
                  }
                  if (grpc['sortOrder'] != null) {
                    result['sortOrder'] = $root.google.protobuf.UInt32Value.fromGRPC(grpc['sortOrder'], helper);
                  } else {
                    delete result['sortOrder'];
                  }
                  if (grpc['movedFrom'] != null) {
                    result['movedFrom'] = $root.google.protobuf.StringValue.fromGRPC(grpc['movedFrom'], helper);
                  } else {
                    delete result['movedFrom'];
                  }
                  if (grpc['touched'] != null) {
                    result['touched'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['touched'], helper);
                  } else {
                    delete result['touched'];
                  }
                  return result;
                }
              }
            }
            __builtIn.Object.defineProperty(Member.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member');
              },
              enumerable: false,
              configurable: false
            });
            __builtIn.Object.defineProperty(Member.prototype, '__fqn__', {
              value: 'com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member',
              enumerable: false,
              configurable: false
            });
            __builtIn.Object.defineProperty(Member.prototype, '__options__', {
              value: $root.__options,
              enumerable: false,
              configurable: false
            });
            __builtIn.Object.defineProperty(Member.prototype, '__root__', {
              value: $root,
              enumerable: false,
              configurable: false
            });
            return Member;
          }());;
          MenuConfigCategory.Member = (function () {
            class Member {
              constructor(props) {
                this.name = props && props.name;
                this.path = props && props.path;
                this.visible = props && props.visible;
                this.type = props && props.type;
                this.sortOrder = props && props.sortOrder;
                this.movedFrom = props && props.movedFrom;
                this.touched = props && props.touched;
              }
              static toJSON(obj, helper, withDefaults) {
                if (obj == null) {
                  return null;
                } else {
                  const json = {};
                  if (obj['name'] != null) {
                    json['name'] = obj['name'];
                  } else if (withDefaults) {
                    json['name'] = '';
                  }
                  if (obj['path'] != null) {
                    json['path'] = obj['path'];
                  } else if (withDefaults) {
                    json['path'] = '';
                  }
                  if (obj['visible'] != null) {
                    json['visible'] = obj['visible'];
                  } else if (withDefaults) {
                    json['visible'] = false;
                  }
                  if (obj['type'] != null) {
                    json['type'] = obj['type'];
                  } else if (withDefaults) {
                    json['type'] = '';
                  }
                  if (obj['sortOrder'] != null) {
                    json['sortOrder'] = $root.google.protobuf.UInt32Value.toJSON(obj['sortOrder'], helper, withDefaults);
                  } else if (withDefaults) {
                    delete json['sortOrder'];
                  }
                  if (obj['movedFrom'] != null) {
                    json['movedFrom'] = $root.google.protobuf.StringValue.toJSON(obj['movedFrom'], helper, withDefaults);
                  } else if (withDefaults) {
                    delete json['movedFrom'];
                  }
                  if (obj['touched'] != null) {
                    json['touched'] = $root.google.protobuf.BoolValue.toJSON(obj['touched'], helper, withDefaults);
                  } else if (withDefaults) {
                    delete json['touched'];
                  }
                  return json;
                }
              }
              static fromJSON(json, helper, withDefaults) {
                if (typeof json === 'object' && !Array.isArray(json)) {
                  const result = new $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member();
                  if (json['name'] != null) {
                    result['name'] = json['name'];
                  } else if (withDefaults !== false) {
                    result['name'] = '';
                  } else {
                    delete result['name'];
                  }
                  if (json['path'] != null) {
                    result['path'] = json['path'];
                  } else if (withDefaults !== false) {
                    result['path'] = '';
                  } else {
                    delete result['path'];
                  }
                  if (json['visible'] != null) {
                    result['visible'] = json['visible'];
                  } else if (withDefaults !== false) {
                    result['visible'] = false;
                  } else {
                    delete result['visible'];
                  }
                  if (json['type'] != null) {
                    result['type'] = json['type'];
                  } else if (withDefaults !== false) {
                    result['type'] = '';
                  } else {
                    delete result['type'];
                  }
                  if (json['sortOrder'] != null) {
                    result['sortOrder'] = $root.google.protobuf.UInt32Value.fromJSON(json['sortOrder'], helper);
                  } else if (withDefaults !== false) {
                    delete result['sortOrder'];
                  } else {
                    delete result['sortOrder'];
                  }
                  if (json['movedFrom'] != null) {
                    result['movedFrom'] = $root.google.protobuf.StringValue.fromJSON(json['movedFrom'], helper);
                  } else if (withDefaults !== false) {
                    delete result['movedFrom'];
                  } else {
                    delete result['movedFrom'];
                  }
                  if (json['touched'] != null) {
                    result['touched'] = $root.google.protobuf.BoolValue.fromJSON(json['touched'], helper);
                  } else if (withDefaults !== false) {
                    delete result['touched'];
                  } else {
                    delete result['touched'];
                  }
                  return result;
                } else
                  return json;
              }
              static toGRPC(obj, helper) {
                if (obj == null) {
                  return null;
                } else {
                  const grpc = {};
                  if (obj['name'] != null) {
                    grpc['name'] = obj['name'];
                  }
                  if (obj['path'] != null) {
                    grpc['path'] = obj['path'];
                  }
                  if (obj['visible'] != null) {
                    grpc['visible'] = obj['visible'];
                  }
                  if (obj['type'] != null) {
                    grpc['type'] = obj['type'];
                  }
                  if (obj['sortOrder'] != null) {
                    grpc['sortOrder'] = $root.google.protobuf.UInt32Value.toGRPC(obj['sortOrder'], helper);
                  }
                  if (obj['movedFrom'] != null) {
                    grpc['movedFrom'] = $root.google.protobuf.StringValue.toGRPC(obj['movedFrom'], helper);
                  }
                  if (obj['touched'] != null) {
                    grpc['touched'] = $root.google.protobuf.BoolValue.toGRPC(obj['touched'], helper);
                  }
                  return grpc;
                }
              }
              static fromGRPC(grpc, helper) {
                if (grpc == null) {
                  return null;
                } else {
                  const result = new $root.com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member();
                  if (grpc['name'] != null) {
                    result['name'] = grpc['name'];
                  } else {
                    result['name'] = '';
                  }
                  if (grpc['path'] != null) {
                    result['path'] = grpc['path'];
                  } else {
                    result['path'] = '';
                  }
                  if (grpc['visible'] != null) {
                    result['visible'] = grpc['visible'];
                  } else {
                    result['visible'] = false;
                  }
                  if (grpc['type'] != null) {
                    result['type'] = grpc['type'];
                  } else {
                    result['type'] = '';
                  }
                  if (grpc['sortOrder'] != null) {
                    result['sortOrder'] = $root.google.protobuf.UInt32Value.fromGRPC(grpc['sortOrder'], helper);
                  } else {
                    delete result['sortOrder'];
                  }
                  if (grpc['movedFrom'] != null) {
                    result['movedFrom'] = $root.google.protobuf.StringValue.fromGRPC(grpc['movedFrom'], helper);
                  } else {
                    delete result['movedFrom'];
                  }
                  if (grpc['touched'] != null) {
                    result['touched'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['touched'], helper);
                  } else {
                    delete result['touched'];
                  }
                  return result;
                }
              }
            }
            __builtIn.Object.defineProperty(Member.prototype, '__proto', {
              value: pbjs => {
                return $root.__lookup(pbjs)('com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member');
              },
              enumerable: false,
              configurable: false
            });
            __builtIn.Object.defineProperty(Member.prototype, '__fqn__', {
              value: 'com.wixpress.wixdocs.MenuConfig.MenuConfigCategory.Member',
              enumerable: false,
              configurable: false
            });
            __builtIn.Object.defineProperty(Member.prototype, '__options__', {
              value: $root.__options,
              enumerable: false,
              configurable: false
            });
            __builtIn.Object.defineProperty(Member.prototype, '__root__', {
              value: $root,
              enumerable: false,
              configurable: false
            });
            return Member;
          }());;
          __builtIn.Object.defineProperty(MenuConfigCategory.prototype, '__proto', {
            value: pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.wixdocs.MenuConfig.MenuConfigCategory');
            },
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(MenuConfigCategory.prototype, '__fqn__', {
            value: 'com.wixpress.wixdocs.MenuConfig.MenuConfigCategory',
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(MenuConfigCategory.prototype, '__options__', {
            value: $root.__options,
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(MenuConfigCategory.prototype, '__root__', {
            value: $root,
            enumerable: false,
            configurable: false
          });
          return MenuConfigCategory;
        }());;
        __builtIn.Object.defineProperty(MenuConfig.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.MenuConfig');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(MenuConfig.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.MenuConfig',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(MenuConfig.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(MenuConfig.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return MenuConfig;
      }());;
      _wixdocs.Viewer = (function () {
        class Viewer {
          constructor(props) {
            this.id = props && props.id;
            this.name = props && props.name;
            this.artifactId = props && props.artifactId;
            this.viewerConfig = props && props.viewerConfig;
            this.menuConfig = props && props.menuConfig;
            this.currentVersion = props && props.currentVersion;
            this.availableVersions = props && props.availableVersions;
            this.contentStatus = props && props.contentStatus;
            this.autoPublish = props && props.autoPublish;
            this.order = props && props.order;
            this.visibleSite = props && props.visibleSite;
            this.latestVersion = props && props.latestVersion;
            this.projectId = props && props.projectId;
            this.emailList = props && props.emailList;
            this.category = props && props.category;
            this.serviceJsonFormat = props && props.serviceJsonFormat;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              if (obj['name'] != null) {
                json['name'] = obj['name'];
              } else if (withDefaults) {
                json['name'] = '';
              }
              if (obj['artifactId'] != null) {
                json['artifactId'] = obj['artifactId'];
              } else if (withDefaults) {
                json['artifactId'] = '';
              }
              if (obj['viewerConfig'] != null) {
                json['viewerConfig'] = $root.com.wixpress.wixdocs.ViewerConfig.toJSON(obj['viewerConfig'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['viewerConfig'];
              }
              if (obj['menuConfig'] != null) {
                json['menuConfig'] = $root.com.wixpress.wixdocs.MenuConfig.toJSON(obj['menuConfig'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['menuConfig'];
              }
              if (obj['currentVersion'] != null) {
                json['currentVersion'] = obj['currentVersion'];
              } else if (withDefaults) {
                json['currentVersion'] = '';
              }
              if (obj['availableVersions'] != null) {
                json['availableVersions'] = obj['availableVersions'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['availableVersions'] = [];
              }
              if (obj['contentStatus'] != null) {
                json['contentStatus'] = $root.com.wixpress.wixdocs.Viewer.ContentStatus[obj['contentStatus']];
              } else if (withDefaults) {
                json['contentStatus'] = 'PUBLISHED';
              }
              if (obj['autoPublish'] != null) {
                json['autoPublish'] = obj['autoPublish'];
              } else if (withDefaults) {
                json['autoPublish'] = false;
              }
              if (obj['order'] != null) {
                json['order'] = obj['order'];
              } else if (withDefaults) {
                json['order'] = 0;
              }
              if (obj['visibleSite'] != null) {
                json['visibleSite'] = obj['visibleSite'];
              } else if (withDefaults) {
                json['visibleSite'] = false;
              }
              if (obj['latestVersion'] != null) {
                json['latestVersion'] = obj['latestVersion'];
              } else if (withDefaults) {
                json['latestVersion'] = '';
              }
              if (obj['projectId'] != null) {
                json['projectId'] = obj['projectId'];
              } else if (withDefaults) {
                json['projectId'] = '';
              }
              if (obj['emailList'] != null) {
                json['emailList'] = obj['emailList'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['emailList'] = [];
              }
              if (obj['category'] != null) {
                json['category'] = obj['category'];
              } else if (withDefaults) {
                json['category'] = '';
              }
              if (obj['serviceJsonFormat'] != null) {
                json['serviceJsonFormat'] = $root.com.wixpress.wixdocs.Viewer.ServiceJsonFormat[obj['serviceJsonFormat']];
              } else if (withDefaults) {
                json['serviceJsonFormat'] = 'NONE';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.Viewer();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              if (json['name'] != null) {
                result['name'] = json['name'];
              } else if (withDefaults !== false) {
                result['name'] = '';
              } else {
                delete result['name'];
              }
              if (json['artifactId'] != null) {
                result['artifactId'] = json['artifactId'];
              } else if (withDefaults !== false) {
                result['artifactId'] = '';
              } else {
                delete result['artifactId'];
              }
              if (json['viewerConfig'] != null) {
                result['viewerConfig'] = $root.com.wixpress.wixdocs.ViewerConfig.fromJSON(json['viewerConfig'], helper);
              } else if (withDefaults !== false) {
                delete result['viewerConfig'];
              } else {
                delete result['viewerConfig'];
              }
              if (json['menuConfig'] != null) {
                result['menuConfig'] = $root.com.wixpress.wixdocs.MenuConfig.fromJSON(json['menuConfig'], helper);
              } else if (withDefaults !== false) {
                delete result['menuConfig'];
              } else {
                delete result['menuConfig'];
              }
              if (json['currentVersion'] != null) {
                result['currentVersion'] = json['currentVersion'];
              } else if (withDefaults !== false) {
                result['currentVersion'] = '';
              } else {
                delete result['currentVersion'];
              }
              if (json['availableVersions'] != null) {
                result['availableVersions'] = Array.isArray(json['availableVersions']) ? json['availableVersions'].map(e => {
                  return e;
                }) : json['availableVersions'];
              } else if (withDefaults !== false) {
                result['availableVersions'] = [];
              } else {
                delete result['availableVersions'];
              }
              if (json['contentStatus'] != null) {
                result['contentStatus'] = typeof json['contentStatus'] === 'string' ? json['contentStatus'] : $root.com.wixpress.wixdocs.Viewer.ContentStatus[json['contentStatus']];
              } else if (withDefaults !== false) {
                result['contentStatus'] = 'PUBLISHED';
              } else {
                delete result['contentStatus'];
              }
              if (json['autoPublish'] != null) {
                result['autoPublish'] = json['autoPublish'];
              } else if (withDefaults !== false) {
                result['autoPublish'] = false;
              } else {
                delete result['autoPublish'];
              }
              if (json['order'] != null) {
                result['order'] = json['order'];
              } else if (withDefaults !== false) {
                result['order'] = 0;
              } else {
                delete result['order'];
              }
              if (json['visibleSite'] != null) {
                result['visibleSite'] = json['visibleSite'];
              } else if (withDefaults !== false) {
                result['visibleSite'] = false;
              } else {
                delete result['visibleSite'];
              }
              if (json['latestVersion'] != null) {
                result['latestVersion'] = json['latestVersion'];
              } else if (withDefaults !== false) {
                result['latestVersion'] = '';
              } else {
                delete result['latestVersion'];
              }
              if (json['projectId'] != null) {
                result['projectId'] = json['projectId'];
              } else if (withDefaults !== false) {
                result['projectId'] = '';
              } else {
                delete result['projectId'];
              }
              if (json['emailList'] != null) {
                result['emailList'] = Array.isArray(json['emailList']) ? json['emailList'].map(e => {
                  return e;
                }) : json['emailList'];
              } else if (withDefaults !== false) {
                result['emailList'] = [];
              } else {
                delete result['emailList'];
              }
              if (json['category'] != null) {
                result['category'] = json['category'];
              } else if (withDefaults !== false) {
                result['category'] = '';
              } else {
                delete result['category'];
              }
              if (json['serviceJsonFormat'] != null) {
                result['serviceJsonFormat'] = typeof json['serviceJsonFormat'] === 'string' ? json['serviceJsonFormat'] : $root.com.wixpress.wixdocs.Viewer.ServiceJsonFormat[json['serviceJsonFormat']];
              } else if (withDefaults !== false) {
                result['serviceJsonFormat'] = 'NONE';
              } else {
                delete result['serviceJsonFormat'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['name'] != null) {
                grpc['name'] = obj['name'];
              }
              if (obj['artifactId'] != null) {
                grpc['artifactId'] = obj['artifactId'];
              }
              if (obj['viewerConfig'] != null) {
                grpc['viewerConfig'] = $root.com.wixpress.wixdocs.ViewerConfig.toGRPC(obj['viewerConfig'], helper);
              }
              if (obj['menuConfig'] != null) {
                grpc['menuConfig'] = $root.com.wixpress.wixdocs.MenuConfig.toGRPC(obj['menuConfig'], helper);
              }
              if (obj['currentVersion'] != null) {
                grpc['currentVersion'] = obj['currentVersion'];
              }
              if (obj['availableVersions'] != null) {
                grpc['availableVersions'] = obj['availableVersions'].map(e => {
                  return e;
                });
              }
              if (obj['contentStatus'] != null) {
                grpc['contentStatus'] = obj['contentStatus'];
              }
              if (obj['autoPublish'] != null) {
                grpc['autoPublish'] = obj['autoPublish'];
              }
              if (obj['order'] != null) {
                grpc['order'] = obj['order'];
              }
              if (obj['visibleSite'] != null) {
                grpc['visibleSite'] = obj['visibleSite'];
              }
              if (obj['latestVersion'] != null) {
                grpc['latestVersion'] = obj['latestVersion'];
              }
              if (obj['projectId'] != null) {
                grpc['projectId'] = obj['projectId'];
              }
              if (obj['emailList'] != null) {
                grpc['emailList'] = obj['emailList'].map(e => {
                  return e;
                });
              }
              if (obj['category'] != null) {
                grpc['category'] = obj['category'];
              }
              if (obj['serviceJsonFormat'] != null) {
                grpc['serviceJsonFormat'] = obj['serviceJsonFormat'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.Viewer();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              if (grpc['name'] != null) {
                result['name'] = grpc['name'];
              } else {
                result['name'] = '';
              }
              if (grpc['artifactId'] != null) {
                result['artifactId'] = grpc['artifactId'];
              } else {
                result['artifactId'] = '';
              }
              if (grpc['viewerConfig'] != null) {
                result['viewerConfig'] = $root.com.wixpress.wixdocs.ViewerConfig.fromGRPC(grpc['viewerConfig'], helper);
              } else {
                delete result['viewerConfig'];
              }
              if (grpc['menuConfig'] != null) {
                result['menuConfig'] = $root.com.wixpress.wixdocs.MenuConfig.fromGRPC(grpc['menuConfig'], helper);
              } else {
                delete result['menuConfig'];
              }
              if (grpc['currentVersion'] != null) {
                result['currentVersion'] = grpc['currentVersion'];
              } else {
                result['currentVersion'] = '';
              }
              if (grpc['availableVersions'] != null) {
                result['availableVersions'] = grpc['availableVersions'].map(e => {
                  return e;
                });
              } else {
                result['availableVersions'] = [];
              }
              if (grpc['contentStatus'] != null) {
                result['contentStatus'] = grpc['contentStatus'];
              } else {
                result['contentStatus'] = 'PUBLISHED';
              }
              if (grpc['autoPublish'] != null) {
                result['autoPublish'] = grpc['autoPublish'];
              } else {
                result['autoPublish'] = false;
              }
              if (grpc['order'] != null) {
                result['order'] = grpc['order'];
              } else {
                result['order'] = 0;
              }
              if (grpc['visibleSite'] != null) {
                result['visibleSite'] = grpc['visibleSite'];
              } else {
                result['visibleSite'] = false;
              }
              if (grpc['latestVersion'] != null) {
                result['latestVersion'] = grpc['latestVersion'];
              } else {
                result['latestVersion'] = '';
              }
              if (grpc['projectId'] != null) {
                result['projectId'] = grpc['projectId'];
              } else {
                result['projectId'] = '';
              }
              if (grpc['emailList'] != null) {
                result['emailList'] = grpc['emailList'].map(e => {
                  return e;
                });
              } else {
                result['emailList'] = [];
              }
              if (grpc['category'] != null) {
                result['category'] = grpc['category'];
              } else {
                result['category'] = '';
              }
              if (grpc['serviceJsonFormat'] != null) {
                result['serviceJsonFormat'] = grpc['serviceJsonFormat'];
              } else {
                result['serviceJsonFormat'] = 'NONE';
              }
              return result;
            }
          }
        }
        Viewer.ContentStatus = {
          'PUBLISHED': 'PUBLISHED',
          0: 'PUBLISHED',
          'PENDING': 'PENDING',
          1: 'PENDING'
        };
        Viewer.ServiceJsonFormat = {
          'NONE': 'NONE',
          0: 'NONE',
          'PASCAL_CASE': 'PASCAL_CASE',
          1: 'PASCAL_CASE',
          'KABAB_CASE': 'KABAB_CASE',
          2: 'KABAB_CASE'
        };
        Viewer.ContentStatus = {
          'PUBLISHED': 'PUBLISHED',
          0: 'PUBLISHED',
          'PENDING': 'PENDING',
          1: 'PENDING'
        };
        Viewer.ServiceJsonFormat = {
          'NONE': 'NONE',
          0: 'NONE',
          'PASCAL_CASE': 'PASCAL_CASE',
          1: 'PASCAL_CASE',
          'KABAB_CASE': 'KABAB_CASE',
          2: 'KABAB_CASE'
        };
        __builtIn.Object.defineProperty(Viewer.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.Viewer');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Viewer.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.Viewer',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Viewer.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Viewer.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return Viewer;
      }());;
      _wixdocs.ViewerFilter = (function () {
        class ViewerFilter {
          constructor(props) {
            this.name = props && props.name;
            this.artifactId = props && props.artifactId;
            this.currentVersion = props && props.currentVersion;
            this.autoPublish = props && props.autoPublish;
            this.visibleSite = props && props.visibleSite;
            this.category = props && props.category;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['name'] != null) {
                json['name'] = $root.google.protobuf.StringValue.toJSON(obj['name'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['name'];
              }
              if (obj['artifactId'] != null) {
                json['artifactId'] = $root.google.protobuf.StringValue.toJSON(obj['artifactId'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['artifactId'];
              }
              if (obj['currentVersion'] != null) {
                json['currentVersion'] = $root.google.protobuf.StringValue.toJSON(obj['currentVersion'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['currentVersion'];
              }
              if (obj['autoPublish'] != null) {
                json['autoPublish'] = $root.google.protobuf.BoolValue.toJSON(obj['autoPublish'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['autoPublish'];
              }
              if (obj['visibleSite'] != null) {
                json['visibleSite'] = $root.google.protobuf.BoolValue.toJSON(obj['visibleSite'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['visibleSite'];
              }
              if (obj['category'] != null) {
                json['category'] = $root.google.protobuf.StringValue.toJSON(obj['category'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['category'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.ViewerFilter();
              if (json['name'] != null) {
                result['name'] = $root.google.protobuf.StringValue.fromJSON(json['name'], helper);
              } else if (withDefaults !== false) {
                delete result['name'];
              } else {
                delete result['name'];
              }
              if (json['artifactId'] != null) {
                result['artifactId'] = $root.google.protobuf.StringValue.fromJSON(json['artifactId'], helper);
              } else if (withDefaults !== false) {
                delete result['artifactId'];
              } else {
                delete result['artifactId'];
              }
              if (json['currentVersion'] != null) {
                result['currentVersion'] = $root.google.protobuf.StringValue.fromJSON(json['currentVersion'], helper);
              } else if (withDefaults !== false) {
                delete result['currentVersion'];
              } else {
                delete result['currentVersion'];
              }
              if (json['autoPublish'] != null) {
                result['autoPublish'] = $root.google.protobuf.BoolValue.fromJSON(json['autoPublish'], helper);
              } else if (withDefaults !== false) {
                delete result['autoPublish'];
              } else {
                delete result['autoPublish'];
              }
              if (json['visibleSite'] != null) {
                result['visibleSite'] = $root.google.protobuf.BoolValue.fromJSON(json['visibleSite'], helper);
              } else if (withDefaults !== false) {
                delete result['visibleSite'];
              } else {
                delete result['visibleSite'];
              }
              if (json['category'] != null) {
                result['category'] = $root.google.protobuf.StringValue.fromJSON(json['category'], helper);
              } else if (withDefaults !== false) {
                delete result['category'];
              } else {
                delete result['category'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['name'] != null) {
                grpc['name'] = $root.google.protobuf.StringValue.toGRPC(obj['name'], helper);
              }
              if (obj['artifactId'] != null) {
                grpc['artifactId'] = $root.google.protobuf.StringValue.toGRPC(obj['artifactId'], helper);
              }
              if (obj['currentVersion'] != null) {
                grpc['currentVersion'] = $root.google.protobuf.StringValue.toGRPC(obj['currentVersion'], helper);
              }
              if (obj['autoPublish'] != null) {
                grpc['autoPublish'] = $root.google.protobuf.BoolValue.toGRPC(obj['autoPublish'], helper);
              }
              if (obj['visibleSite'] != null) {
                grpc['visibleSite'] = $root.google.protobuf.BoolValue.toGRPC(obj['visibleSite'], helper);
              }
              if (obj['category'] != null) {
                grpc['category'] = $root.google.protobuf.StringValue.toGRPC(obj['category'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.ViewerFilter();
              if (grpc['name'] != null) {
                result['name'] = $root.google.protobuf.StringValue.fromGRPC(grpc['name'], helper);
              } else {
                delete result['name'];
              }
              if (grpc['artifactId'] != null) {
                result['artifactId'] = $root.google.protobuf.StringValue.fromGRPC(grpc['artifactId'], helper);
              } else {
                delete result['artifactId'];
              }
              if (grpc['currentVersion'] != null) {
                result['currentVersion'] = $root.google.protobuf.StringValue.fromGRPC(grpc['currentVersion'], helper);
              } else {
                delete result['currentVersion'];
              }
              if (grpc['autoPublish'] != null) {
                result['autoPublish'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['autoPublish'], helper);
              } else {
                delete result['autoPublish'];
              }
              if (grpc['visibleSite'] != null) {
                result['visibleSite'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['visibleSite'], helper);
              } else {
                delete result['visibleSite'];
              }
              if (grpc['category'] != null) {
                result['category'] = $root.google.protobuf.StringValue.fromGRPC(grpc['category'], helper);
              } else {
                delete result['category'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(ViewerFilter.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewerFilter');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewerFilter.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.ViewerFilter',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewerFilter.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewerFilter.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return ViewerFilter;
      }());;
      _wixdocs.ViewerUpdater = (function () {
        class ViewerUpdater {
          constructor(props) {
            this.name = props && props.name;
            this.artifactId = props && props.artifactId;
            this.currentVersion = props && props.currentVersion;
            this.autoPublish = props && props.autoPublish;
            this.visibleSite = props && props.visibleSite;
            this.category = props && props.category;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['name'] != null) {
                json['name'] = $root.google.protobuf.StringValue.toJSON(obj['name'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['name'];
              }
              if (obj['artifactId'] != null) {
                json['artifactId'] = $root.google.protobuf.StringValue.toJSON(obj['artifactId'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['artifactId'];
              }
              if (obj['currentVersion'] != null) {
                json['currentVersion'] = $root.google.protobuf.StringValue.toJSON(obj['currentVersion'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['currentVersion'];
              }
              if (obj['autoPublish'] != null) {
                json['autoPublish'] = $root.google.protobuf.BoolValue.toJSON(obj['autoPublish'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['autoPublish'];
              }
              if (obj['visibleSite'] != null) {
                json['visibleSite'] = $root.google.protobuf.BoolValue.toJSON(obj['visibleSite'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['visibleSite'];
              }
              if (obj['category'] != null) {
                json['category'] = $root.google.protobuf.StringValue.toJSON(obj['category'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['category'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.ViewerUpdater();
              if (json['name'] != null) {
                result['name'] = $root.google.protobuf.StringValue.fromJSON(json['name'], helper);
              } else if (withDefaults !== false) {
                delete result['name'];
              } else {
                delete result['name'];
              }
              if (json['artifactId'] != null) {
                result['artifactId'] = $root.google.protobuf.StringValue.fromJSON(json['artifactId'], helper);
              } else if (withDefaults !== false) {
                delete result['artifactId'];
              } else {
                delete result['artifactId'];
              }
              if (json['currentVersion'] != null) {
                result['currentVersion'] = $root.google.protobuf.StringValue.fromJSON(json['currentVersion'], helper);
              } else if (withDefaults !== false) {
                delete result['currentVersion'];
              } else {
                delete result['currentVersion'];
              }
              if (json['autoPublish'] != null) {
                result['autoPublish'] = $root.google.protobuf.BoolValue.fromJSON(json['autoPublish'], helper);
              } else if (withDefaults !== false) {
                delete result['autoPublish'];
              } else {
                delete result['autoPublish'];
              }
              if (json['visibleSite'] != null) {
                result['visibleSite'] = $root.google.protobuf.BoolValue.fromJSON(json['visibleSite'], helper);
              } else if (withDefaults !== false) {
                delete result['visibleSite'];
              } else {
                delete result['visibleSite'];
              }
              if (json['category'] != null) {
                result['category'] = $root.google.protobuf.StringValue.fromJSON(json['category'], helper);
              } else if (withDefaults !== false) {
                delete result['category'];
              } else {
                delete result['category'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['name'] != null) {
                grpc['name'] = $root.google.protobuf.StringValue.toGRPC(obj['name'], helper);
              }
              if (obj['artifactId'] != null) {
                grpc['artifactId'] = $root.google.protobuf.StringValue.toGRPC(obj['artifactId'], helper);
              }
              if (obj['currentVersion'] != null) {
                grpc['currentVersion'] = $root.google.protobuf.StringValue.toGRPC(obj['currentVersion'], helper);
              }
              if (obj['autoPublish'] != null) {
                grpc['autoPublish'] = $root.google.protobuf.BoolValue.toGRPC(obj['autoPublish'], helper);
              }
              if (obj['visibleSite'] != null) {
                grpc['visibleSite'] = $root.google.protobuf.BoolValue.toGRPC(obj['visibleSite'], helper);
              }
              if (obj['category'] != null) {
                grpc['category'] = $root.google.protobuf.StringValue.toGRPC(obj['category'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.ViewerUpdater();
              if (grpc['name'] != null) {
                result['name'] = $root.google.protobuf.StringValue.fromGRPC(grpc['name'], helper);
              } else {
                delete result['name'];
              }
              if (grpc['artifactId'] != null) {
                result['artifactId'] = $root.google.protobuf.StringValue.fromGRPC(grpc['artifactId'], helper);
              } else {
                delete result['artifactId'];
              }
              if (grpc['currentVersion'] != null) {
                result['currentVersion'] = $root.google.protobuf.StringValue.fromGRPC(grpc['currentVersion'], helper);
              } else {
                delete result['currentVersion'];
              }
              if (grpc['autoPublish'] != null) {
                result['autoPublish'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['autoPublish'], helper);
              } else {
                delete result['autoPublish'];
              }
              if (grpc['visibleSite'] != null) {
                result['visibleSite'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['visibleSite'], helper);
              } else {
                delete result['visibleSite'];
              }
              if (grpc['category'] != null) {
                result['category'] = $root.google.protobuf.StringValue.fromGRPC(grpc['category'], helper);
              } else {
                delete result['category'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(ViewerUpdater.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewerUpdater');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewerUpdater.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.ViewerUpdater',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewerUpdater.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewerUpdater.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return ViewerUpdater;
      }());;
      _wixdocs.Version = (function () {
        class Version {
          constructor(props) {
            this.id = props && props.id;
            this.viewerId = props && props.viewerId;
            this.publishedBy = props && props.publishedBy;
            this.version = props && props.version;
            this.releaseNote = props && props.releaseNote;
            this.branches = props && props.branches;
            this.publishedDate = props && props.publishedDate;
            this.buildInfo = props && props.buildInfo;
            this.updatedDate = props && props.updatedDate;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              if (obj['viewerId'] != null) {
                json['viewerId'] = obj['viewerId'];
              } else if (withDefaults) {
                json['viewerId'] = '';
              }
              if (obj['publishedBy'] != null) {
                json['publishedBy'] = obj['publishedBy'];
              } else if (withDefaults) {
                json['publishedBy'] = '';
              }
              if (obj['version'] != null) {
                json['version'] = obj['version'];
              } else if (withDefaults) {
                json['version'] = '';
              }
              if (obj['releaseNote'] != null) {
                json['releaseNote'] = obj['releaseNote'];
              } else if (withDefaults) {
                json['releaseNote'] = '';
              }
              if (obj['branches'] != null) {
                json['branches'] = obj['branches'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['branches'] = [];
              }
              if (obj['publishedDate'] != null) {
                json['publishedDate'] = $root.google.protobuf.Timestamp.toJSON(obj['publishedDate'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['publishedDate'];
              }
              if (obj['buildInfo'] != null) {
                json['buildInfo'] = $root.com.wixpress.wixdocs.Version.BuildInfo.toJSON(obj['buildInfo'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['buildInfo'];
              }
              if (obj['updatedDate'] != null) {
                json['updatedDate'] = $root.google.protobuf.Timestamp.toJSON(obj['updatedDate'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['updatedDate'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.Version();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              if (json['viewerId'] != null) {
                result['viewerId'] = json['viewerId'];
              } else if (withDefaults !== false) {
                result['viewerId'] = '';
              } else {
                delete result['viewerId'];
              }
              if (json['publishedBy'] != null) {
                result['publishedBy'] = json['publishedBy'];
              } else if (withDefaults !== false) {
                result['publishedBy'] = '';
              } else {
                delete result['publishedBy'];
              }
              if (json['version'] != null) {
                result['version'] = json['version'];
              } else if (withDefaults !== false) {
                result['version'] = '';
              } else {
                delete result['version'];
              }
              if (json['releaseNote'] != null) {
                result['releaseNote'] = json['releaseNote'];
              } else if (withDefaults !== false) {
                result['releaseNote'] = '';
              } else {
                delete result['releaseNote'];
              }
              if (json['branches'] != null) {
                result['branches'] = Array.isArray(json['branches']) ? json['branches'].map(e => {
                  return e;
                }) : json['branches'];
              } else if (withDefaults !== false) {
                result['branches'] = [];
              } else {
                delete result['branches'];
              }
              if (json['publishedDate'] != null) {
                result['publishedDate'] = $root.google.protobuf.Timestamp.fromJSON(json['publishedDate'], helper);
              } else if (withDefaults !== false) {
                delete result['publishedDate'];
              } else {
                delete result['publishedDate'];
              }
              if (json['buildInfo'] != null) {
                result['buildInfo'] = $root.com.wixpress.wixdocs.Version.BuildInfo.fromJSON(json['buildInfo'], helper);
              } else if (withDefaults !== false) {
                delete result['buildInfo'];
              } else {
                delete result['buildInfo'];
              }
              if (json['updatedDate'] != null) {
                result['updatedDate'] = $root.google.protobuf.Timestamp.fromJSON(json['updatedDate'], helper);
              } else if (withDefaults !== false) {
                delete result['updatedDate'];
              } else {
                delete result['updatedDate'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['viewerId'] != null) {
                grpc['viewerId'] = obj['viewerId'];
              }
              if (obj['publishedBy'] != null) {
                grpc['publishedBy'] = obj['publishedBy'];
              }
              if (obj['version'] != null) {
                grpc['version'] = obj['version'];
              }
              if (obj['releaseNote'] != null) {
                grpc['releaseNote'] = obj['releaseNote'];
              }
              if (obj['branches'] != null) {
                grpc['branches'] = obj['branches'].map(e => {
                  return e;
                });
              }
              if (obj['publishedDate'] != null) {
                grpc['publishedDate'] = $root.google.protobuf.Timestamp.toGRPC(obj['publishedDate'], helper);
              }
              if (obj['buildInfo'] != null) {
                grpc['buildInfo'] = $root.com.wixpress.wixdocs.Version.BuildInfo.toGRPC(obj['buildInfo'], helper);
              }
              if (obj['updatedDate'] != null) {
                grpc['updatedDate'] = $root.google.protobuf.Timestamp.toGRPC(obj['updatedDate'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.Version();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              if (grpc['viewerId'] != null) {
                result['viewerId'] = grpc['viewerId'];
              } else {
                result['viewerId'] = '';
              }
              if (grpc['publishedBy'] != null) {
                result['publishedBy'] = grpc['publishedBy'];
              } else {
                result['publishedBy'] = '';
              }
              if (grpc['version'] != null) {
                result['version'] = grpc['version'];
              } else {
                result['version'] = '';
              }
              if (grpc['releaseNote'] != null) {
                result['releaseNote'] = grpc['releaseNote'];
              } else {
                result['releaseNote'] = '';
              }
              if (grpc['branches'] != null) {
                result['branches'] = grpc['branches'].map(e => {
                  return e;
                });
              } else {
                result['branches'] = [];
              }
              if (grpc['publishedDate'] != null) {
                result['publishedDate'] = $root.google.protobuf.Timestamp.fromGRPC(grpc['publishedDate'], helper);
              } else {
                delete result['publishedDate'];
              }
              if (grpc['buildInfo'] != null) {
                result['buildInfo'] = $root.com.wixpress.wixdocs.Version.BuildInfo.fromGRPC(grpc['buildInfo'], helper);
              } else {
                delete result['buildInfo'];
              }
              if (grpc['updatedDate'] != null) {
                result['updatedDate'] = $root.google.protobuf.Timestamp.fromGRPC(grpc['updatedDate'], helper);
              } else {
                delete result['updatedDate'];
              }
              return result;
            }
          }
        }
        Version.BuildInfo = (function () {
          class BuildInfo {
            constructor(props) {
              this.status = props && props.status;
              this.errorMsg = props && props.errorMsg;
            }
            static toJSON(obj, helper, withDefaults) {
              if (obj == null) {
                return null;
              } else {
                const json = {};
                if (obj['status'] != null) {
                  json['status'] = $root.com.wixpress.wixdocs.Version.BuildInfo.Status[obj['status']];
                } else if (withDefaults) {
                  json['status'] = 'STARTED';
                }
                if (obj['errorMsg'] != null) {
                  json['errorMsg'] = $root.google.protobuf.StringValue.toJSON(obj['errorMsg'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['errorMsg'];
                }
                return json;
              }
            }
            static fromJSON(json, helper, withDefaults) {
              if (typeof json === 'object' && !Array.isArray(json)) {
                const result = new $root.com.wixpress.wixdocs.Version.BuildInfo();
                if (json['status'] != null) {
                  result['status'] = typeof json['status'] === 'string' ? json['status'] : $root.com.wixpress.wixdocs.Version.BuildInfo.Status[json['status']];
                } else if (withDefaults !== false) {
                  result['status'] = 'STARTED';
                } else {
                  delete result['status'];
                }
                if (json['errorMsg'] != null) {
                  result['errorMsg'] = $root.google.protobuf.StringValue.fromJSON(json['errorMsg'], helper);
                } else if (withDefaults !== false) {
                  delete result['errorMsg'];
                } else {
                  delete result['errorMsg'];
                }
                return result;
              } else
                return json;
            }
            static toGRPC(obj, helper) {
              if (obj == null) {
                return null;
              } else {
                const grpc = {};
                if (obj['status'] != null) {
                  grpc['status'] = obj['status'];
                }
                if (obj['errorMsg'] != null) {
                  grpc['errorMsg'] = $root.google.protobuf.StringValue.toGRPC(obj['errorMsg'], helper);
                }
                return grpc;
              }
            }
            static fromGRPC(grpc, helper) {
              if (grpc == null) {
                return null;
              } else {
                const result = new $root.com.wixpress.wixdocs.Version.BuildInfo();
                if (grpc['status'] != null) {
                  result['status'] = grpc['status'];
                } else {
                  result['status'] = 'STARTED';
                }
                if (grpc['errorMsg'] != null) {
                  result['errorMsg'] = $root.google.protobuf.StringValue.fromGRPC(grpc['errorMsg'], helper);
                } else {
                  delete result['errorMsg'];
                }
                return result;
              }
            }
          }
          BuildInfo.Status = {
            'STARTED': 'STARTED',
            0: 'STARTED',
            'COMPLETED': 'COMPLETED',
            1: 'COMPLETED',
            'FAILED': 'FAILED',
            2: 'FAILED'
          };
          BuildInfo.Status = {
            'STARTED': 'STARTED',
            0: 'STARTED',
            'COMPLETED': 'COMPLETED',
            1: 'COMPLETED',
            'FAILED': 'FAILED',
            2: 'FAILED'
          };
          __builtIn.Object.defineProperty(BuildInfo.prototype, '__proto', {
            value: pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.wixdocs.Version.BuildInfo');
            },
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(BuildInfo.prototype, '__fqn__', {
            value: 'com.wixpress.wixdocs.Version.BuildInfo',
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(BuildInfo.prototype, '__options__', {
            value: $root.__options,
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(BuildInfo.prototype, '__root__', {
            value: $root,
            enumerable: false,
            configurable: false
          });
          return BuildInfo;
        }());;
        Version.BumpType = {
          'patch': 'patch',
          0: 'patch',
          'minor': 'minor',
          1: 'minor',
          'major': 'major',
          2: 'major'
        };
        Version.BuildInfo = (function () {
          class BuildInfo {
            constructor(props) {
              this.status = props && props.status;
              this.errorMsg = props && props.errorMsg;
            }
            static toJSON(obj, helper, withDefaults) {
              if (obj == null) {
                return null;
              } else {
                const json = {};
                if (obj['status'] != null) {
                  json['status'] = $root.com.wixpress.wixdocs.Version.BuildInfo.Status[obj['status']];
                } else if (withDefaults) {
                  json['status'] = 'STARTED';
                }
                if (obj['errorMsg'] != null) {
                  json['errorMsg'] = $root.google.protobuf.StringValue.toJSON(obj['errorMsg'], helper, withDefaults);
                } else if (withDefaults) {
                  delete json['errorMsg'];
                }
                return json;
              }
            }
            static fromJSON(json, helper, withDefaults) {
              if (typeof json === 'object' && !Array.isArray(json)) {
                const result = new $root.com.wixpress.wixdocs.Version.BuildInfo();
                if (json['status'] != null) {
                  result['status'] = typeof json['status'] === 'string' ? json['status'] : $root.com.wixpress.wixdocs.Version.BuildInfo.Status[json['status']];
                } else if (withDefaults !== false) {
                  result['status'] = 'STARTED';
                } else {
                  delete result['status'];
                }
                if (json['errorMsg'] != null) {
                  result['errorMsg'] = $root.google.protobuf.StringValue.fromJSON(json['errorMsg'], helper);
                } else if (withDefaults !== false) {
                  delete result['errorMsg'];
                } else {
                  delete result['errorMsg'];
                }
                return result;
              } else
                return json;
            }
            static toGRPC(obj, helper) {
              if (obj == null) {
                return null;
              } else {
                const grpc = {};
                if (obj['status'] != null) {
                  grpc['status'] = obj['status'];
                }
                if (obj['errorMsg'] != null) {
                  grpc['errorMsg'] = $root.google.protobuf.StringValue.toGRPC(obj['errorMsg'], helper);
                }
                return grpc;
              }
            }
            static fromGRPC(grpc, helper) {
              if (grpc == null) {
                return null;
              } else {
                const result = new $root.com.wixpress.wixdocs.Version.BuildInfo();
                if (grpc['status'] != null) {
                  result['status'] = grpc['status'];
                } else {
                  result['status'] = 'STARTED';
                }
                if (grpc['errorMsg'] != null) {
                  result['errorMsg'] = $root.google.protobuf.StringValue.fromGRPC(grpc['errorMsg'], helper);
                } else {
                  delete result['errorMsg'];
                }
                return result;
              }
            }
          }
          BuildInfo.Status = {
            'STARTED': 'STARTED',
            0: 'STARTED',
            'COMPLETED': 'COMPLETED',
            1: 'COMPLETED',
            'FAILED': 'FAILED',
            2: 'FAILED'
          };
          BuildInfo.Status = {
            'STARTED': 'STARTED',
            0: 'STARTED',
            'COMPLETED': 'COMPLETED',
            1: 'COMPLETED',
            'FAILED': 'FAILED',
            2: 'FAILED'
          };
          __builtIn.Object.defineProperty(BuildInfo.prototype, '__proto', {
            value: pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.wixdocs.Version.BuildInfo');
            },
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(BuildInfo.prototype, '__fqn__', {
            value: 'com.wixpress.wixdocs.Version.BuildInfo',
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(BuildInfo.prototype, '__options__', {
            value: $root.__options,
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(BuildInfo.prototype, '__root__', {
            value: $root,
            enumerable: false,
            configurable: false
          });
          return BuildInfo;
        }());;
        Version.BumpType = {
          'patch': 'patch',
          0: 'patch',
          'minor': 'minor',
          1: 'minor',
          'major': 'major',
          2: 'major'
        };
        __builtIn.Object.defineProperty(Version.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.Version');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Version.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.Version',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Version.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Version.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return Version;
      }());;
      _wixdocs.Project = (function () {
        class Project {
          constructor(props) {
            this.id = props && props.id;
            this.name = props && props.name;
            this.viewerIds = props && props.viewerIds;
            this.domainSettings = props && props.domainSettings;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              if (obj['name'] != null) {
                json['name'] = obj['name'];
              } else if (withDefaults) {
                json['name'] = '';
              }
              if (obj['viewerIds'] != null) {
                json['viewerIds'] = obj['viewerIds'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['viewerIds'] = [];
              }
              if (obj['domainSettings'] != null) {
                json['domainSettings'] = $root.com.wixpress.wixdocs.DomainSettings.toJSON(obj['domainSettings'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['domainSettings'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.Project();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              if (json['name'] != null) {
                result['name'] = json['name'];
              } else if (withDefaults !== false) {
                result['name'] = '';
              } else {
                delete result['name'];
              }
              if (json['viewerIds'] != null) {
                result['viewerIds'] = Array.isArray(json['viewerIds']) ? json['viewerIds'].map(e => {
                  return e;
                }) : json['viewerIds'];
              } else if (withDefaults !== false) {
                result['viewerIds'] = [];
              } else {
                delete result['viewerIds'];
              }
              if (json['domainSettings'] != null) {
                result['domainSettings'] = $root.com.wixpress.wixdocs.DomainSettings.fromJSON(json['domainSettings'], helper);
              } else if (withDefaults !== false) {
                delete result['domainSettings'];
              } else {
                delete result['domainSettings'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['name'] != null) {
                grpc['name'] = obj['name'];
              }
              if (obj['viewerIds'] != null) {
                grpc['viewerIds'] = obj['viewerIds'].map(e => {
                  return e;
                });
              }
              if (obj['domainSettings'] != null) {
                grpc['domainSettings'] = $root.com.wixpress.wixdocs.DomainSettings.toGRPC(obj['domainSettings'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.Project();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              if (grpc['name'] != null) {
                result['name'] = grpc['name'];
              } else {
                result['name'] = '';
              }
              if (grpc['viewerIds'] != null) {
                result['viewerIds'] = grpc['viewerIds'].map(e => {
                  return e;
                });
              } else {
                result['viewerIds'] = [];
              }
              if (grpc['domainSettings'] != null) {
                result['domainSettings'] = $root.com.wixpress.wixdocs.DomainSettings.fromGRPC(grpc['domainSettings'], helper);
              } else {
                delete result['domainSettings'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(Project.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.Project');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Project.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.Project',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Project.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Project.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return Project;
      }());;
      _wixdocs.DomainSettings = (function () {
        class DomainSettings {
          constructor(props) {
            this.baseDomain = props && props.baseDomain;
            this.externalDomain = props && props.externalDomain;
            this.viewerId = props && props.viewerId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['baseDomain'] != null) {
                json['baseDomain'] = obj['baseDomain'];
              } else if (withDefaults) {
                json['baseDomain'] = '';
              }
              if (obj['externalDomain'] != null) {
                json['externalDomain'] = obj['externalDomain'];
              } else if (withDefaults) {
                json['externalDomain'] = '';
              }
              if (obj['viewerId'] != null) {
                json['viewerId'] = obj['viewerId'];
              } else if (withDefaults) {
                json['viewerId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.DomainSettings();
              if (json['baseDomain'] != null) {
                result['baseDomain'] = json['baseDomain'];
              } else if (withDefaults !== false) {
                result['baseDomain'] = '';
              } else {
                delete result['baseDomain'];
              }
              if (json['externalDomain'] != null) {
                result['externalDomain'] = json['externalDomain'];
              } else if (withDefaults !== false) {
                result['externalDomain'] = '';
              } else {
                delete result['externalDomain'];
              }
              if (json['viewerId'] != null) {
                result['viewerId'] = json['viewerId'];
              } else if (withDefaults !== false) {
                result['viewerId'] = '';
              } else {
                delete result['viewerId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['baseDomain'] != null) {
                grpc['baseDomain'] = obj['baseDomain'];
              }
              if (obj['externalDomain'] != null) {
                grpc['externalDomain'] = obj['externalDomain'];
              }
              if (obj['viewerId'] != null) {
                grpc['viewerId'] = obj['viewerId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.DomainSettings();
              if (grpc['baseDomain'] != null) {
                result['baseDomain'] = grpc['baseDomain'];
              } else {
                result['baseDomain'] = '';
              }
              if (grpc['externalDomain'] != null) {
                result['externalDomain'] = grpc['externalDomain'];
              } else {
                result['externalDomain'] = '';
              }
              if (grpc['viewerId'] != null) {
                result['viewerId'] = grpc['viewerId'];
              } else {
                result['viewerId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(DomainSettings.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.DomainSettings');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DomainSettings.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.DomainSettings',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DomainSettings.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DomainSettings.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return DomainSettings;
      }());;
      _wixdocs.ViewerConfigUpdated = (function () {
        class ViewerConfigUpdated {
          constructor(props) {
            this.config = props && props.config;
            this.viewerId = props && props.viewerId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['config'] != null) {
                json['config'] = $root.com.wixpress.wixdocs.ViewerConfig.toJSON(obj['config'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['config'];
              }
              if (obj['viewerId'] != null) {
                json['viewerId'] = obj['viewerId'];
              } else if (withDefaults) {
                json['viewerId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.ViewerConfigUpdated();
              if (json['config'] != null) {
                result['config'] = $root.com.wixpress.wixdocs.ViewerConfig.fromJSON(json['config'], helper);
              } else if (withDefaults !== false) {
                delete result['config'];
              } else {
                delete result['config'];
              }
              if (json['viewerId'] != null) {
                result['viewerId'] = json['viewerId'];
              } else if (withDefaults !== false) {
                result['viewerId'] = '';
              } else {
                delete result['viewerId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['config'] != null) {
                grpc['config'] = $root.com.wixpress.wixdocs.ViewerConfig.toGRPC(obj['config'], helper);
              }
              if (obj['viewerId'] != null) {
                grpc['viewerId'] = obj['viewerId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.ViewerConfigUpdated();
              if (grpc['config'] != null) {
                result['config'] = $root.com.wixpress.wixdocs.ViewerConfig.fromGRPC(grpc['config'], helper);
              } else {
                delete result['config'];
              }
              if (grpc['viewerId'] != null) {
                result['viewerId'] = grpc['viewerId'];
              } else {
                result['viewerId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(ViewerConfigUpdated.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewerConfigUpdated');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewerConfigUpdated.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.ViewerConfigUpdated',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewerConfigUpdated.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewerConfigUpdated.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return ViewerConfigUpdated;
      }());;
      _wixdocs.ViewerConfigPublished = (function () {
        class ViewerConfigPublished {
          constructor(props) {
            this.config = props && props.config;
            this.viewerId = props && props.viewerId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['config'] != null) {
                json['config'] = $root.com.wixpress.wixdocs.ViewerConfig.toJSON(obj['config'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['config'];
              }
              if (obj['viewerId'] != null) {
                json['viewerId'] = obj['viewerId'];
              } else if (withDefaults) {
                json['viewerId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.ViewerConfigPublished();
              if (json['config'] != null) {
                result['config'] = $root.com.wixpress.wixdocs.ViewerConfig.fromJSON(json['config'], helper);
              } else if (withDefaults !== false) {
                delete result['config'];
              } else {
                delete result['config'];
              }
              if (json['viewerId'] != null) {
                result['viewerId'] = json['viewerId'];
              } else if (withDefaults !== false) {
                result['viewerId'] = '';
              } else {
                delete result['viewerId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['config'] != null) {
                grpc['config'] = $root.com.wixpress.wixdocs.ViewerConfig.toGRPC(obj['config'], helper);
              }
              if (obj['viewerId'] != null) {
                grpc['viewerId'] = obj['viewerId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.ViewerConfigPublished();
              if (grpc['config'] != null) {
                result['config'] = $root.com.wixpress.wixdocs.ViewerConfig.fromGRPC(grpc['config'], helper);
              } else {
                delete result['config'];
              }
              if (grpc['viewerId'] != null) {
                result['viewerId'] = grpc['viewerId'];
              } else {
                result['viewerId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(ViewerConfigPublished.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewerConfigPublished');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewerConfigPublished.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.ViewerConfigPublished',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewerConfigPublished.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewerConfigPublished.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return ViewerConfigPublished;
      }());;
      _wixdocs.MenuConfigUpdated = (function () {
        class MenuConfigUpdated {
          constructor(props) {
            this.config = props && props.config;
            this.viewerId = props && props.viewerId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['config'] != null) {
                json['config'] = $root.com.wixpress.wixdocs.MenuConfig.toJSON(obj['config'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['config'];
              }
              if (obj['viewerId'] != null) {
                json['viewerId'] = obj['viewerId'];
              } else if (withDefaults) {
                json['viewerId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.MenuConfigUpdated();
              if (json['config'] != null) {
                result['config'] = $root.com.wixpress.wixdocs.MenuConfig.fromJSON(json['config'], helper);
              } else if (withDefaults !== false) {
                delete result['config'];
              } else {
                delete result['config'];
              }
              if (json['viewerId'] != null) {
                result['viewerId'] = json['viewerId'];
              } else if (withDefaults !== false) {
                result['viewerId'] = '';
              } else {
                delete result['viewerId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['config'] != null) {
                grpc['config'] = $root.com.wixpress.wixdocs.MenuConfig.toGRPC(obj['config'], helper);
              }
              if (obj['viewerId'] != null) {
                grpc['viewerId'] = obj['viewerId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.MenuConfigUpdated();
              if (grpc['config'] != null) {
                result['config'] = $root.com.wixpress.wixdocs.MenuConfig.fromGRPC(grpc['config'], helper);
              } else {
                delete result['config'];
              }
              if (grpc['viewerId'] != null) {
                result['viewerId'] = grpc['viewerId'];
              } else {
                result['viewerId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(MenuConfigUpdated.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.MenuConfigUpdated');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(MenuConfigUpdated.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.MenuConfigUpdated',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(MenuConfigUpdated.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(MenuConfigUpdated.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return MenuConfigUpdated;
      }());;
      _wixdocs.MenuConfigPublished = (function () {
        class MenuConfigPublished {
          constructor(props) {
            this.config = props && props.config;
            this.viewerId = props && props.viewerId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['config'] != null) {
                json['config'] = $root.com.wixpress.wixdocs.MenuConfig.toJSON(obj['config'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['config'];
              }
              if (obj['viewerId'] != null) {
                json['viewerId'] = obj['viewerId'];
              } else if (withDefaults) {
                json['viewerId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.MenuConfigPublished();
              if (json['config'] != null) {
                result['config'] = $root.com.wixpress.wixdocs.MenuConfig.fromJSON(json['config'], helper);
              } else if (withDefaults !== false) {
                delete result['config'];
              } else {
                delete result['config'];
              }
              if (json['viewerId'] != null) {
                result['viewerId'] = json['viewerId'];
              } else if (withDefaults !== false) {
                result['viewerId'] = '';
              } else {
                delete result['viewerId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['config'] != null) {
                grpc['config'] = $root.com.wixpress.wixdocs.MenuConfig.toGRPC(obj['config'], helper);
              }
              if (obj['viewerId'] != null) {
                grpc['viewerId'] = obj['viewerId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.MenuConfigPublished();
              if (grpc['config'] != null) {
                result['config'] = $root.com.wixpress.wixdocs.MenuConfig.fromGRPC(grpc['config'], helper);
              } else {
                delete result['config'];
              }
              if (grpc['viewerId'] != null) {
                result['viewerId'] = grpc['viewerId'];
              } else {
                result['viewerId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(MenuConfigPublished.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.MenuConfigPublished');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(MenuConfigPublished.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.MenuConfigPublished',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(MenuConfigPublished.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(MenuConfigPublished.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return MenuConfigPublished;
      }());;
      _wixdocs.ViewerVersionDataUploaded = (function () {
        class ViewerVersionDataUploaded {
          constructor(props) {
            this.currentVersion = props && props.currentVersion;
            this.viewerId = props && props.viewerId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['currentVersion'] != null) {
                json['currentVersion'] = obj['currentVersion'];
              } else if (withDefaults) {
                json['currentVersion'] = '';
              }
              if (obj['viewerId'] != null) {
                json['viewerId'] = obj['viewerId'];
              } else if (withDefaults) {
                json['viewerId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.ViewerVersionDataUploaded();
              if (json['currentVersion'] != null) {
                result['currentVersion'] = json['currentVersion'];
              } else if (withDefaults !== false) {
                result['currentVersion'] = '';
              } else {
                delete result['currentVersion'];
              }
              if (json['viewerId'] != null) {
                result['viewerId'] = json['viewerId'];
              } else if (withDefaults !== false) {
                result['viewerId'] = '';
              } else {
                delete result['viewerId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['currentVersion'] != null) {
                grpc['currentVersion'] = obj['currentVersion'];
              }
              if (obj['viewerId'] != null) {
                grpc['viewerId'] = obj['viewerId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.ViewerVersionDataUploaded();
              if (grpc['currentVersion'] != null) {
                result['currentVersion'] = grpc['currentVersion'];
              } else {
                result['currentVersion'] = '';
              }
              if (grpc['viewerId'] != null) {
                result['viewerId'] = grpc['viewerId'];
              } else {
                result['viewerId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(ViewerVersionDataUploaded.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewerVersionDataUploaded');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewerVersionDataUploaded.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.ViewerVersionDataUploaded',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewerVersionDataUploaded.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewerVersionDataUploaded.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return ViewerVersionDataUploaded;
      }());;
      _wixdocs.ProjectDomainSettingsUpdated = (function () {
        class ProjectDomainSettingsUpdated {
          constructor(props) {
            this.domainSettings = props && props.domainSettings;
            this.projectId = props && props.projectId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['domainSettings'] != null) {
                json['domainSettings'] = $root.com.wixpress.wixdocs.DomainSettings.toJSON(obj['domainSettings'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['domainSettings'];
              }
              if (obj['projectId'] != null) {
                json['projectId'] = obj['projectId'];
              } else if (withDefaults) {
                json['projectId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.ProjectDomainSettingsUpdated();
              if (json['domainSettings'] != null) {
                result['domainSettings'] = $root.com.wixpress.wixdocs.DomainSettings.fromJSON(json['domainSettings'], helper);
              } else if (withDefaults !== false) {
                delete result['domainSettings'];
              } else {
                delete result['domainSettings'];
              }
              if (json['projectId'] != null) {
                result['projectId'] = json['projectId'];
              } else if (withDefaults !== false) {
                result['projectId'] = '';
              } else {
                delete result['projectId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['domainSettings'] != null) {
                grpc['domainSettings'] = $root.com.wixpress.wixdocs.DomainSettings.toGRPC(obj['domainSettings'], helper);
              }
              if (obj['projectId'] != null) {
                grpc['projectId'] = obj['projectId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.ProjectDomainSettingsUpdated();
              if (grpc['domainSettings'] != null) {
                result['domainSettings'] = $root.com.wixpress.wixdocs.DomainSettings.fromGRPC(grpc['domainSettings'], helper);
              } else {
                delete result['domainSettings'];
              }
              if (grpc['projectId'] != null) {
                result['projectId'] = grpc['projectId'];
              } else {
                result['projectId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(ProjectDomainSettingsUpdated.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.ProjectDomainSettingsUpdated');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ProjectDomainSettingsUpdated.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.ProjectDomainSettingsUpdated',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ProjectDomainSettingsUpdated.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ProjectDomainSettingsUpdated.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return ProjectDomainSettingsUpdated;
      }());;
      _wixdocs.ProjectsService = (function () {
        class ProjectsService {
          listProjects(aspects, msg) {
            throw new TypeError('method listProjects is abstract');
          }
          createProject(aspects, msg) {
            throw new TypeError('method createProject is abstract');
          }
          getProject(aspects, msg) {
            throw new TypeError('method getProject is abstract');
          }
          deleteProject(aspects, msg) {
            throw new TypeError('method deleteProject is abstract');
          }
          updateProjectName(aspects, msg) {
            throw new TypeError('method updateProjectName is abstract');
          }
          updateViewersProjectId(aspects, msg) {
            throw new TypeError('method updateViewersProjectId is abstract');
          }
          updateProjectDomainSettings(aspects, msg) {
            throw new TypeError('method updateProjectDomainSettings is abstract');
          }
        }
        ProjectsService.prototype.listProjects._messageTypes = function () {
          return [
            $root.google.protobuf.Empty,
            $root.com.wixpress.wixdocs.ListProjectsResponse
          ];
        };
        ProjectsService.prototype.createProject._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.CreateProjectRequest,
            $root.com.wixpress.wixdocs.CreateProjectResponse
          ];
        };
        ProjectsService.prototype.getProject._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.GetProjectRequest,
            $root.com.wixpress.wixdocs.GetProjectResponse
          ];
        };
        ProjectsService.prototype.deleteProject._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.DeleteProjectRequest,
            $root.com.wixpress.wixdocs.DeleteProjectResponse
          ];
        };
        ProjectsService.prototype.updateProjectName._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.UpdateProjectNameRequest,
            $root.com.wixpress.wixdocs.UpdateProjectNameResponse
          ];
        };
        ProjectsService.prototype.updateViewersProjectId._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.UpdateViewersProjectIdRequest,
            $root.com.wixpress.wixdocs.UpdateViewersProjectIdResponse
          ];
        };
        ProjectsService.prototype.updateProjectDomainSettings._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.UpdateProjectDomainSettingsRequest,
            $root.com.wixpress.wixdocs.UpdateProjectDomainSettingsResponse
          ];
        };
        ProjectsService.prototype.listProjects.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ProjectsService.ListProjects');
        };
        ProjectsService.prototype.createProject.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ProjectsService.CreateProject');
        };
        ProjectsService.prototype.getProject.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ProjectsService.GetProject');
        };
        ProjectsService.prototype.deleteProject.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ProjectsService.DeleteProject');
        };
        ProjectsService.prototype.updateProjectName.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ProjectsService.UpdateProjectName');
        };
        ProjectsService.prototype.updateViewersProjectId.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ProjectsService.UpdateViewersProjectId');
        };
        ProjectsService.prototype.updateProjectDomainSettings.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ProjectsService.UpdateProjectDomainSettings');
        };
        __builtIn.Object.defineProperty(ProjectsService.prototype, '__isRpcService__', {
          value: true,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ProjectsService.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.ProjectsService',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ProjectsService.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.ProjectsService');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ProjectsService.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ProjectsService.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ProjectsService.prototype, '__filename', {
          value: __filename,
          enumerable: false,
          configurable: false
        });
        return ProjectsService;
      }());;
      _wixdocs.ListProjectsResponse = (function () {
        class ListProjectsResponse {
          constructor(props) {
            this.projects = props && props.projects;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['projects'] != null) {
                json['projects'] = obj['projects'].map(e => {
                  return $root.com.wixpress.wixdocs.Project.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['projects'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.ListProjectsResponse();
              if (json['projects'] != null) {
                result['projects'] = Array.isArray(json['projects']) ? json['projects'].map(e => {
                  return $root.com.wixpress.wixdocs.Project.fromJSON(e, helper);
                }) : json['projects'];
              } else if (withDefaults !== false) {
                result['projects'] = [];
              } else {
                delete result['projects'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['projects'] != null) {
                grpc['projects'] = obj['projects'].map(e => {
                  return $root.com.wixpress.wixdocs.Project.toGRPC(e, helper);
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.ListProjectsResponse();
              if (grpc['projects'] != null) {
                result['projects'] = grpc['projects'].map(e => {
                  return $root.com.wixpress.wixdocs.Project.fromGRPC(e, helper);
                });
              } else {
                result['projects'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(ListProjectsResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.ListProjectsResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ListProjectsResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.ListProjectsResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ListProjectsResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ListProjectsResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return ListProjectsResponse;
      }());;
      _wixdocs.CreateProjectRequest = (function () {
        class CreateProjectRequest {
          constructor(props) {
            this.name = props && props.name;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['name'] != null) {
                json['name'] = obj['name'];
              } else if (withDefaults) {
                json['name'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.CreateProjectRequest();
              if (json['name'] != null) {
                result['name'] = json['name'];
              } else if (withDefaults !== false) {
                result['name'] = '';
              } else {
                delete result['name'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['name'] != null) {
                grpc['name'] = obj['name'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.CreateProjectRequest();
              if (grpc['name'] != null) {
                result['name'] = grpc['name'];
              } else {
                result['name'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(CreateProjectRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.CreateProjectRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CreateProjectRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.CreateProjectRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CreateProjectRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CreateProjectRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return CreateProjectRequest;
      }());;
      _wixdocs.CreateProjectResponse = (function () {
        class CreateProjectResponse {
          constructor(props) {
            this.project = props && props.project;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['project'] != null) {
                json['project'] = $root.com.wixpress.wixdocs.Project.toJSON(obj['project'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['project'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.CreateProjectResponse();
              if (json['project'] != null) {
                result['project'] = $root.com.wixpress.wixdocs.Project.fromJSON(json['project'], helper);
              } else if (withDefaults !== false) {
                delete result['project'];
              } else {
                delete result['project'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['project'] != null) {
                grpc['project'] = $root.com.wixpress.wixdocs.Project.toGRPC(obj['project'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.CreateProjectResponse();
              if (grpc['project'] != null) {
                result['project'] = $root.com.wixpress.wixdocs.Project.fromGRPC(grpc['project'], helper);
              } else {
                delete result['project'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(CreateProjectResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.CreateProjectResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CreateProjectResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.CreateProjectResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CreateProjectResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CreateProjectResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return CreateProjectResponse;
      }());;
      _wixdocs.GetProjectRequest = (function () {
        class GetProjectRequest {
          constructor(props) {
            this.id = props && props.id;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.GetProjectRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.GetProjectRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(GetProjectRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.GetProjectRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetProjectRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.GetProjectRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetProjectRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetProjectRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return GetProjectRequest;
      }());;
      _wixdocs.GetProjectResponse = (function () {
        class GetProjectResponse {
          constructor(props) {
            this.project = props && props.project;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['project'] != null) {
                json['project'] = $root.com.wixpress.wixdocs.Project.toJSON(obj['project'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['project'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.GetProjectResponse();
              if (json['project'] != null) {
                result['project'] = $root.com.wixpress.wixdocs.Project.fromJSON(json['project'], helper);
              } else if (withDefaults !== false) {
                delete result['project'];
              } else {
                delete result['project'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['project'] != null) {
                grpc['project'] = $root.com.wixpress.wixdocs.Project.toGRPC(obj['project'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.GetProjectResponse();
              if (grpc['project'] != null) {
                result['project'] = $root.com.wixpress.wixdocs.Project.fromGRPC(grpc['project'], helper);
              } else {
                delete result['project'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(GetProjectResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.GetProjectResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetProjectResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.GetProjectResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetProjectResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetProjectResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return GetProjectResponse;
      }());;
      _wixdocs.DeleteProjectRequest = (function () {
        class DeleteProjectRequest {
          constructor(props) {
            this.id = props && props.id;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.DeleteProjectRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.DeleteProjectRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(DeleteProjectRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.DeleteProjectRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DeleteProjectRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.DeleteProjectRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DeleteProjectRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DeleteProjectRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return DeleteProjectRequest;
      }());;
      _wixdocs.DeleteProjectResponse = (function () {
        class DeleteProjectResponse {
          constructor(props) {
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.DeleteProjectResponse();
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.DeleteProjectResponse();
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(DeleteProjectResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.DeleteProjectResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DeleteProjectResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.DeleteProjectResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DeleteProjectResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DeleteProjectResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return DeleteProjectResponse;
      }());;
      _wixdocs.UpdateProjectNameRequest = (function () {
        class UpdateProjectNameRequest {
          constructor(props) {
            this.id = props && props.id;
            this.name = props && props.name;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              if (obj['name'] != null) {
                json['name'] = obj['name'];
              } else if (withDefaults) {
                json['name'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateProjectNameRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              if (json['name'] != null) {
                result['name'] = json['name'];
              } else if (withDefaults !== false) {
                result['name'] = '';
              } else {
                delete result['name'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['name'] != null) {
                grpc['name'] = obj['name'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateProjectNameRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              if (grpc['name'] != null) {
                result['name'] = grpc['name'];
              } else {
                result['name'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateProjectNameRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateProjectNameRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateProjectNameRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateProjectNameRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateProjectNameRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateProjectNameRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateProjectNameRequest;
      }());;
      _wixdocs.UpdateProjectNameResponse = (function () {
        class UpdateProjectNameResponse {
          constructor(props) {
            this.project = props && props.project;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['project'] != null) {
                json['project'] = $root.com.wixpress.wixdocs.Project.toJSON(obj['project'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['project'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateProjectNameResponse();
              if (json['project'] != null) {
                result['project'] = $root.com.wixpress.wixdocs.Project.fromJSON(json['project'], helper);
              } else if (withDefaults !== false) {
                delete result['project'];
              } else {
                delete result['project'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['project'] != null) {
                grpc['project'] = $root.com.wixpress.wixdocs.Project.toGRPC(obj['project'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateProjectNameResponse();
              if (grpc['project'] != null) {
                result['project'] = $root.com.wixpress.wixdocs.Project.fromGRPC(grpc['project'], helper);
              } else {
                delete result['project'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateProjectNameResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateProjectNameResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateProjectNameResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateProjectNameResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateProjectNameResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateProjectNameResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateProjectNameResponse;
      }());;
      _wixdocs.UpdateViewersProjectIdRequest = (function () {
        class UpdateViewersProjectIdRequest {
          constructor(props) {
            this.id = props && props.id;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateViewersProjectIdRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateViewersProjectIdRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateViewersProjectIdRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateViewersProjectIdRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewersProjectIdRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateViewersProjectIdRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewersProjectIdRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewersProjectIdRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateViewersProjectIdRequest;
      }());;
      _wixdocs.UpdateViewersProjectIdResponse = (function () {
        class UpdateViewersProjectIdResponse {
          constructor(props) {
            this.viewers = props && props.viewers;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['viewers'] != null) {
                json['viewers'] = obj['viewers'].map(e => {
                  return $root.com.wixpress.wixdocs.Viewer.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['viewers'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateViewersProjectIdResponse();
              if (json['viewers'] != null) {
                result['viewers'] = Array.isArray(json['viewers']) ? json['viewers'].map(e => {
                  return $root.com.wixpress.wixdocs.Viewer.fromJSON(e, helper);
                }) : json['viewers'];
              } else if (withDefaults !== false) {
                result['viewers'] = [];
              } else {
                delete result['viewers'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['viewers'] != null) {
                grpc['viewers'] = obj['viewers'].map(e => {
                  return $root.com.wixpress.wixdocs.Viewer.toGRPC(e, helper);
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateViewersProjectIdResponse();
              if (grpc['viewers'] != null) {
                result['viewers'] = grpc['viewers'].map(e => {
                  return $root.com.wixpress.wixdocs.Viewer.fromGRPC(e, helper);
                });
              } else {
                result['viewers'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateViewersProjectIdResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateViewersProjectIdResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewersProjectIdResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateViewersProjectIdResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewersProjectIdResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewersProjectIdResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateViewersProjectIdResponse;
      }());;
      _wixdocs.UpdateProjectDomainSettingsRequest = (function () {
        class UpdateProjectDomainSettingsRequest {
          constructor(props) {
            this.id = props && props.id;
            this.baseDomain = props && props.baseDomain;
            this.externalDomain = props && props.externalDomain;
            this.viewerId = props && props.viewerId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              if (obj['baseDomain'] != null) {
                json['baseDomain'] = obj['baseDomain'];
              } else if (withDefaults) {
                json['baseDomain'] = '';
              }
              if (obj['externalDomain'] != null) {
                json['externalDomain'] = obj['externalDomain'];
              } else if (withDefaults) {
                json['externalDomain'] = '';
              }
              if (obj['viewerId'] != null) {
                json['viewerId'] = obj['viewerId'];
              } else if (withDefaults) {
                json['viewerId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateProjectDomainSettingsRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              if (json['baseDomain'] != null) {
                result['baseDomain'] = json['baseDomain'];
              } else if (withDefaults !== false) {
                result['baseDomain'] = '';
              } else {
                delete result['baseDomain'];
              }
              if (json['externalDomain'] != null) {
                result['externalDomain'] = json['externalDomain'];
              } else if (withDefaults !== false) {
                result['externalDomain'] = '';
              } else {
                delete result['externalDomain'];
              }
              if (json['viewerId'] != null) {
                result['viewerId'] = json['viewerId'];
              } else if (withDefaults !== false) {
                result['viewerId'] = '';
              } else {
                delete result['viewerId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['baseDomain'] != null) {
                grpc['baseDomain'] = obj['baseDomain'];
              }
              if (obj['externalDomain'] != null) {
                grpc['externalDomain'] = obj['externalDomain'];
              }
              if (obj['viewerId'] != null) {
                grpc['viewerId'] = obj['viewerId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateProjectDomainSettingsRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              if (grpc['baseDomain'] != null) {
                result['baseDomain'] = grpc['baseDomain'];
              } else {
                result['baseDomain'] = '';
              }
              if (grpc['externalDomain'] != null) {
                result['externalDomain'] = grpc['externalDomain'];
              } else {
                result['externalDomain'] = '';
              }
              if (grpc['viewerId'] != null) {
                result['viewerId'] = grpc['viewerId'];
              } else {
                result['viewerId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateProjectDomainSettingsRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateProjectDomainSettingsRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateProjectDomainSettingsRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateProjectDomainSettingsRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateProjectDomainSettingsRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateProjectDomainSettingsRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateProjectDomainSettingsRequest;
      }());;
      _wixdocs.UpdateProjectDomainSettingsResponse = (function () {
        class UpdateProjectDomainSettingsResponse {
          constructor(props) {
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateProjectDomainSettingsResponse();
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateProjectDomainSettingsResponse();
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateProjectDomainSettingsResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateProjectDomainSettingsResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateProjectDomainSettingsResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateProjectDomainSettingsResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateProjectDomainSettingsResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateProjectDomainSettingsResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateProjectDomainSettingsResponse;
      }());;
      _wixdocs.SearchService = (function () {
        class SearchService {
          getDocs(aspects, msg) {
            throw new TypeError('method getDocs is abstract');
          }
          getFullSearchData(aspects, msg) {
            throw new TypeError('method getFullSearchData is abstract');
          }
        }
        SearchService.prototype.getDocs._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.GetDocsRequest,
            $root.com.wixpress.wixdocs.GetDocsResponse
          ];
        };
        SearchService.prototype.getFullSearchData._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.GetFullSearchDataRequest,
            $root.com.wixpress.wixdocs.GetFullSearchDataResponse
          ];
        };
        SearchService.prototype.getDocs.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.SearchService.GetDocs');
        };
        SearchService.prototype.getFullSearchData.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.SearchService.GetFullSearchData');
        };
        __builtIn.Object.defineProperty(SearchService.prototype, '__isRpcService__', {
          value: true,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(SearchService.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.SearchService',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(SearchService.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.SearchService');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(SearchService.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(SearchService.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(SearchService.prototype, '__filename', {
          value: __filename,
          enumerable: false,
          configurable: false
        });
        return SearchService;
      }());;
      _wixdocs.GetDocsRequest = (function () {
        class GetDocsRequest {
          constructor(props) {
            this.viewerId = props && props.viewerId;
            this.searchTerms = props && props.searchTerms;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['viewerId'] != null) {
                json['viewerId'] = obj['viewerId'];
              } else if (withDefaults) {
                json['viewerId'] = '';
              }
              if (obj['searchTerms'] != null) {
                json['searchTerms'] = obj['searchTerms'];
              } else if (withDefaults) {
                json['searchTerms'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.GetDocsRequest();
              if (json['viewerId'] != null) {
                result['viewerId'] = json['viewerId'];
              } else if (withDefaults !== false) {
                result['viewerId'] = '';
              } else {
                delete result['viewerId'];
              }
              if (json['searchTerms'] != null) {
                result['searchTerms'] = json['searchTerms'];
              } else if (withDefaults !== false) {
                result['searchTerms'] = '';
              } else {
                delete result['searchTerms'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['viewerId'] != null) {
                grpc['viewerId'] = obj['viewerId'];
              }
              if (obj['searchTerms'] != null) {
                grpc['searchTerms'] = obj['searchTerms'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.GetDocsRequest();
              if (grpc['viewerId'] != null) {
                result['viewerId'] = grpc['viewerId'];
              } else {
                result['viewerId'] = '';
              }
              if (grpc['searchTerms'] != null) {
                result['searchTerms'] = grpc['searchTerms'];
              } else {
                result['searchTerms'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(GetDocsRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.GetDocsRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetDocsRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.GetDocsRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetDocsRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetDocsRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return GetDocsRequest;
      }());;
      _wixdocs.WixDocsResults = (function () {
        class WixDocsResults {
          constructor(props) {
            this.type = props && props.type;
            this.name = props && props.name;
            this.description = props && props.description;
            this.summary = props && props.summary;
            this.siteName = props && props.siteName;
            this.link = props && props.link;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['type'] != null) {
                json['type'] = obj['type'];
              } else if (withDefaults) {
                json['type'] = '';
              }
              if (obj['name'] != null) {
                json['name'] = obj['name'];
              } else if (withDefaults) {
                json['name'] = '';
              }
              if (obj['description'] != null) {
                json['description'] = obj['description'];
              } else if (withDefaults) {
                json['description'] = '';
              }
              if (obj['summary'] != null) {
                json['summary'] = obj['summary'];
              } else if (withDefaults) {
                json['summary'] = '';
              }
              if (obj['siteName'] != null) {
                json['siteName'] = obj['siteName'];
              } else if (withDefaults) {
                json['siteName'] = '';
              }
              if (obj['link'] != null) {
                json['link'] = obj['link'];
              } else if (withDefaults) {
                json['link'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.WixDocsResults();
              if (json['type'] != null) {
                result['type'] = json['type'];
              } else if (withDefaults !== false) {
                result['type'] = '';
              } else {
                delete result['type'];
              }
              if (json['name'] != null) {
                result['name'] = json['name'];
              } else if (withDefaults !== false) {
                result['name'] = '';
              } else {
                delete result['name'];
              }
              if (json['description'] != null) {
                result['description'] = json['description'];
              } else if (withDefaults !== false) {
                result['description'] = '';
              } else {
                delete result['description'];
              }
              if (json['summary'] != null) {
                result['summary'] = json['summary'];
              } else if (withDefaults !== false) {
                result['summary'] = '';
              } else {
                delete result['summary'];
              }
              if (json['siteName'] != null) {
                result['siteName'] = json['siteName'];
              } else if (withDefaults !== false) {
                result['siteName'] = '';
              } else {
                delete result['siteName'];
              }
              if (json['link'] != null) {
                result['link'] = json['link'];
              } else if (withDefaults !== false) {
                result['link'] = '';
              } else {
                delete result['link'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['type'] != null) {
                grpc['type'] = obj['type'];
              }
              if (obj['name'] != null) {
                grpc['name'] = obj['name'];
              }
              if (obj['description'] != null) {
                grpc['description'] = obj['description'];
              }
              if (obj['summary'] != null) {
                grpc['summary'] = obj['summary'];
              }
              if (obj['siteName'] != null) {
                grpc['siteName'] = obj['siteName'];
              }
              if (obj['link'] != null) {
                grpc['link'] = obj['link'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.WixDocsResults();
              if (grpc['type'] != null) {
                result['type'] = grpc['type'];
              } else {
                result['type'] = '';
              }
              if (grpc['name'] != null) {
                result['name'] = grpc['name'];
              } else {
                result['name'] = '';
              }
              if (grpc['description'] != null) {
                result['description'] = grpc['description'];
              } else {
                result['description'] = '';
              }
              if (grpc['summary'] != null) {
                result['summary'] = grpc['summary'];
              } else {
                result['summary'] = '';
              }
              if (grpc['siteName'] != null) {
                result['siteName'] = grpc['siteName'];
              } else {
                result['siteName'] = '';
              }
              if (grpc['link'] != null) {
                result['link'] = grpc['link'];
              } else {
                result['link'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(WixDocsResults.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.WixDocsResults');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(WixDocsResults.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.WixDocsResults',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(WixDocsResults.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(WixDocsResults.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return WixDocsResults;
      }());;
      _wixdocs.GetDocsResponse = (function () {
        class GetDocsResponse {
          constructor(props) {
            this.results = props && props.results;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['results'] != null) {
                json['results'] = obj['results'].map(e => {
                  return $root.com.wixpress.wixdocs.WixDocsResults.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['results'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.GetDocsResponse();
              if (json['results'] != null) {
                result['results'] = Array.isArray(json['results']) ? json['results'].map(e => {
                  return $root.com.wixpress.wixdocs.WixDocsResults.fromJSON(e, helper);
                }) : json['results'];
              } else if (withDefaults !== false) {
                result['results'] = [];
              } else {
                delete result['results'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['results'] != null) {
                grpc['results'] = obj['results'].map(e => {
                  return $root.com.wixpress.wixdocs.WixDocsResults.toGRPC(e, helper);
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.GetDocsResponse();
              if (grpc['results'] != null) {
                result['results'] = grpc['results'].map(e => {
                  return $root.com.wixpress.wixdocs.WixDocsResults.fromGRPC(e, helper);
                });
              } else {
                result['results'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(GetDocsResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.GetDocsResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetDocsResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.GetDocsResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetDocsResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetDocsResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return GetDocsResponse;
      }());;
      _wixdocs.GetFullSearchDataRequest = (function () {
        class GetFullSearchDataRequest {
          constructor(props) {
            this.viewerId = props && props.viewerId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['viewerId'] != null) {
                json['viewerId'] = obj['viewerId'];
              } else if (withDefaults) {
                json['viewerId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.GetFullSearchDataRequest();
              if (json['viewerId'] != null) {
                result['viewerId'] = json['viewerId'];
              } else if (withDefaults !== false) {
                result['viewerId'] = '';
              } else {
                delete result['viewerId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['viewerId'] != null) {
                grpc['viewerId'] = obj['viewerId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.GetFullSearchDataRequest();
              if (grpc['viewerId'] != null) {
                result['viewerId'] = grpc['viewerId'];
              } else {
                result['viewerId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(GetFullSearchDataRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.GetFullSearchDataRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetFullSearchDataRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.GetFullSearchDataRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetFullSearchDataRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetFullSearchDataRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return GetFullSearchDataRequest;
      }());;
      _wixdocs.GetFullSearchDataResponse = (function () {
        class GetFullSearchDataResponse {
          constructor(props) {
            this.results = props && props.results;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['results'] != null) {
                json['results'] = obj['results'].map(e => {
                  return $root.com.wixpress.wixdocs.WixDocsResults.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['results'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.GetFullSearchDataResponse();
              if (json['results'] != null) {
                result['results'] = Array.isArray(json['results']) ? json['results'].map(e => {
                  return $root.com.wixpress.wixdocs.WixDocsResults.fromJSON(e, helper);
                }) : json['results'];
              } else if (withDefaults !== false) {
                result['results'] = [];
              } else {
                delete result['results'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['results'] != null) {
                grpc['results'] = obj['results'].map(e => {
                  return $root.com.wixpress.wixdocs.WixDocsResults.toGRPC(e, helper);
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.GetFullSearchDataResponse();
              if (grpc['results'] != null) {
                result['results'] = grpc['results'].map(e => {
                  return $root.com.wixpress.wixdocs.WixDocsResults.fromGRPC(e, helper);
                });
              } else {
                result['results'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(GetFullSearchDataResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.GetFullSearchDataResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetFullSearchDataResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.GetFullSearchDataResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetFullSearchDataResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetFullSearchDataResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return GetFullSearchDataResponse;
      }());;
      _wixdocs.StoreService = (function () {
        class StoreService {
          updateStoreContent(aspects, msg) {
            throw new TypeError('method updateStoreContent is abstract');
          }
          publishStoreContent(aspects, msg) {
            throw new TypeError('method publishStoreContent is abstract');
          }
        }
        StoreService.prototype.updateStoreContent._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.UpdateStoreContentRequest,
            $root.com.wixpress.wixdocs.UpdateStoreContentResponse
          ];
        };
        StoreService.prototype.publishStoreContent._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.PublishStoreContentRequest,
            $root.com.wixpress.wixdocs.PublishStoreContentResponse
          ];
        };
        StoreService.prototype.updateStoreContent.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.StoreService.UpdateStoreContent');
        };
        StoreService.prototype.publishStoreContent.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.StoreService.PublishStoreContent');
        };
        __builtIn.Object.defineProperty(StoreService.prototype, '__isRpcService__', {
          value: true,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(StoreService.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.StoreService',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(StoreService.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.StoreService');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(StoreService.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(StoreService.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(StoreService.prototype, '__filename', {
          value: __filename,
          enumerable: false,
          configurable: false
        });
        return StoreService;
      }());;
      _wixdocs.UpdateStoreContentRequest = (function () {
        class UpdateStoreContentRequest {
          constructor(props) {
            this.viewerId = props && props.viewerId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['viewerId'] != null) {
                json['viewerId'] = obj['viewerId'];
              } else if (withDefaults) {
                json['viewerId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateStoreContentRequest();
              if (json['viewerId'] != null) {
                result['viewerId'] = json['viewerId'];
              } else if (withDefaults !== false) {
                result['viewerId'] = '';
              } else {
                delete result['viewerId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['viewerId'] != null) {
                grpc['viewerId'] = obj['viewerId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateStoreContentRequest();
              if (grpc['viewerId'] != null) {
                result['viewerId'] = grpc['viewerId'];
              } else {
                result['viewerId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateStoreContentRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateStoreContentRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateStoreContentRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateStoreContentRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateStoreContentRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateStoreContentRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateStoreContentRequest;
      }());;
      _wixdocs.UpdateStoreContentResponse = (function () {
        class UpdateStoreContentResponse {
          constructor(props) {
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateStoreContentResponse();
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateStoreContentResponse();
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateStoreContentResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateStoreContentResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateStoreContentResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateStoreContentResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateStoreContentResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateStoreContentResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateStoreContentResponse;
      }());;
      _wixdocs.PublishStoreContentRequest = (function () {
        class PublishStoreContentRequest {
          constructor(props) {
            this.viewerId = props && props.viewerId;
            this.version = props && props.version;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['viewerId'] != null) {
                json['viewerId'] = obj['viewerId'];
              } else if (withDefaults) {
                json['viewerId'] = '';
              }
              if (obj['version'] != null) {
                json['version'] = obj['version'];
              } else if (withDefaults) {
                json['version'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.PublishStoreContentRequest();
              if (json['viewerId'] != null) {
                result['viewerId'] = json['viewerId'];
              } else if (withDefaults !== false) {
                result['viewerId'] = '';
              } else {
                delete result['viewerId'];
              }
              if (json['version'] != null) {
                result['version'] = json['version'];
              } else if (withDefaults !== false) {
                result['version'] = '';
              } else {
                delete result['version'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['viewerId'] != null) {
                grpc['viewerId'] = obj['viewerId'];
              }
              if (obj['version'] != null) {
                grpc['version'] = obj['version'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.PublishStoreContentRequest();
              if (grpc['viewerId'] != null) {
                result['viewerId'] = grpc['viewerId'];
              } else {
                result['viewerId'] = '';
              }
              if (grpc['version'] != null) {
                result['version'] = grpc['version'];
              } else {
                result['version'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(PublishStoreContentRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.PublishStoreContentRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PublishStoreContentRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.PublishStoreContentRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PublishStoreContentRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PublishStoreContentRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return PublishStoreContentRequest;
      }());;
      _wixdocs.PublishStoreContentResponse = (function () {
        class PublishStoreContentResponse {
          constructor(props) {
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.PublishStoreContentResponse();
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.PublishStoreContentResponse();
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(PublishStoreContentResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.PublishStoreContentResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PublishStoreContentResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.PublishStoreContentResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PublishStoreContentResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PublishStoreContentResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return PublishStoreContentResponse;
      }());;
      _wixdocs.ViewersService = (function () {
        class ViewersService {
          listViewersByProjectId(aspects, msg) {
            throw new TypeError('method listViewersByProjectId is abstract');
          }
          getViewersByProjectId(aspects, msg) {
            throw new TypeError('method getViewersByProjectId is abstract');
          }
          getViewer(aspects, msg) {
            throw new TypeError('method getViewer is abstract');
          }
          createViewer(aspects, msg) {
            throw new TypeError('method createViewer is abstract');
          }
          deleteViewer(aspects, msg) {
            throw new TypeError('method deleteViewer is abstract');
          }
          updateViewerName(aspects, msg) {
            throw new TypeError('method updateViewerName is abstract');
          }
          updateViewerArtifactId(aspects, msg) {
            throw new TypeError('method updateViewerArtifactId is abstract');
          }
          updateViewerConfig(aspects, msg) {
            throw new TypeError('method updateViewerConfig is abstract');
          }
          publishViewerConfig(aspects, msg) {
            throw new TypeError('method publishViewerConfig is abstract');
          }
          updateMenuConfig(aspects, msg) {
            throw new TypeError('method updateMenuConfig is abstract');
          }
          publishMenuConfig(aspects, msg) {
            throw new TypeError('method publishMenuConfig is abstract');
          }
          bumpVersion(aspects, msg) {
            throw new TypeError('method bumpVersion is abstract');
          }
          purgeVersions(aspects, msg) {
            throw new TypeError('method purgeVersions is abstract');
          }
          updateVersion(aspects, msg) {
            throw new TypeError('method updateVersion is abstract');
          }
          getVersions(aspects, msg) {
            throw new TypeError('method getVersions is abstract');
          }
          updateContentStatus(aspects, msg) {
            throw new TypeError('method updateContentStatus is abstract');
          }
          queryViewersByContent(aspects, msg) {
            throw new TypeError('method queryViewersByContent is abstract');
          }
          updateAutoPublish(aspects, msg) {
            throw new TypeError('method updateAutoPublish is abstract');
          }
          updateViewersOrder(aspects, msg) {
            throw new TypeError('method updateViewersOrder is abstract');
          }
          updateViewerVisibility(aspects, msg) {
            throw new TypeError('method updateViewerVisibility is abstract');
          }
          addToEmailList(aspects, msg) {
            throw new TypeError('method addToEmailList is abstract');
          }
          removeEmailsFromList(aspects, msg) {
            throw new TypeError('method removeEmailsFromList is abstract');
          }
          deployContent(aspects, msg) {
            throw new TypeError('method deployContent is abstract');
          }
          queryViewer(aspects, msg) {
            throw new TypeError('method queryViewer is abstract');
          }
          updateViewer(aspects, msg) {
            throw new TypeError('method updateViewer is abstract');
          }
          updateServiceJsonFormat(aspects, msg) {
            throw new TypeError('method updateServiceJsonFormat is abstract');
          }
        }
        ViewersService.prototype.listViewersByProjectId._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.ListViewersByProjectIdRequest,
            $root.com.wixpress.wixdocs.ListViewersByProjectIdResponse
          ];
        };
        ViewersService.prototype.getViewersByProjectId._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.GetViewersByProjectIdRequest,
            $root.com.wixpress.wixdocs.GetViewersByProjectIdResponse
          ];
        };
        ViewersService.prototype.getViewer._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.GetViewerRequest,
            $root.com.wixpress.wixdocs.GetViewerResponse
          ];
        };
        ViewersService.prototype.createViewer._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.CreateViewerRequest,
            $root.com.wixpress.wixdocs.CreateViewerResponse
          ];
        };
        ViewersService.prototype.deleteViewer._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.DeleteViewerRequest,
            $root.com.wixpress.wixdocs.DeleteViewerResponse
          ];
        };
        ViewersService.prototype.updateViewerName._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.UpdateViewerNameRequest,
            $root.com.wixpress.wixdocs.UpdateViewerNameResponse
          ];
        };
        ViewersService.prototype.updateViewerArtifactId._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.UpdateViewerArtifactIdRequest,
            $root.com.wixpress.wixdocs.UpdateViewerArtifactIdResponse
          ];
        };
        ViewersService.prototype.updateViewerConfig._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.UpdateViewerConfigRequest,
            $root.com.wixpress.wixdocs.UpdateViewerConfigResponse
          ];
        };
        ViewersService.prototype.publishViewerConfig._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.PublishViewerConfigRequest,
            $root.com.wixpress.wixdocs.PublishViewerConfigResponse
          ];
        };
        ViewersService.prototype.updateMenuConfig._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.UpdateMenuConfigRequest,
            $root.com.wixpress.wixdocs.UpdateMenuConfigResponse
          ];
        };
        ViewersService.prototype.publishMenuConfig._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.PublishMenuConfigRequest,
            $root.com.wixpress.wixdocs.PublishMenuConfigResponse
          ];
        };
        ViewersService.prototype.bumpVersion._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.BumpVersionRequest,
            $root.com.wixpress.wixdocs.BumpVersionResponse
          ];
        };
        ViewersService.prototype.purgeVersions._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.PurgeVersionsRequest,
            $root.com.wixpress.wixdocs.PurgeVersionsResponse
          ];
        };
        ViewersService.prototype.updateVersion._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.UpdateVersionRequest,
            $root.com.wixpress.wixdocs.UpdateVersionResponse
          ];
        };
        ViewersService.prototype.getVersions._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.GetVersionsRequest,
            $root.com.wixpress.wixdocs.GetVersionsResponse
          ];
        };
        ViewersService.prototype.updateContentStatus._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.UpdateContentStatusRequest,
            $root.com.wixpress.wixdocs.UpdateContentStatusResponse
          ];
        };
        ViewersService.prototype.queryViewersByContent._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.QueryViewersByContentRequest,
            $root.com.wixpress.wixdocs.QueryViewersByContentResponse
          ];
        };
        ViewersService.prototype.updateAutoPublish._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.UpdateAutoPublishRequest,
            $root.com.wixpress.wixdocs.UpdateAutoPublishResponse
          ];
        };
        ViewersService.prototype.updateViewersOrder._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.UpdateViewersOrderRequest,
            $root.com.wixpress.wixdocs.UpdateViewersOrderResponse
          ];
        };
        ViewersService.prototype.updateViewerVisibility._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.UpdateViewerVisibilityRequest,
            $root.com.wixpress.wixdocs.UpdateViewerVisibilityResponse
          ];
        };
        ViewersService.prototype.addToEmailList._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.AddToEmailListRequest,
            $root.com.wixpress.wixdocs.AddToEmailListResponse
          ];
        };
        ViewersService.prototype.removeEmailsFromList._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.RemoveEmailsFromListRequest,
            $root.com.wixpress.wixdocs.RemoveEmailsFromListResponse
          ];
        };
        ViewersService.prototype.deployContent._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.DeployContentRequest,
            $root.com.wixpress.wixdocs.DeployContentResponse
          ];
        };
        ViewersService.prototype.queryViewer._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.QueryViewerRequest,
            $root.com.wixpress.wixdocs.QueryViewerResponse
          ];
        };
        ViewersService.prototype.updateViewer._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.UpdateViewerRequest,
            $root.com.wixpress.wixdocs.UpdateViewerResponse
          ];
        };
        ViewersService.prototype.updateServiceJsonFormat._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.UpdateServiceJsonFormatRequest,
            $root.com.wixpress.wixdocs.UpdateServiceJsonFormatResponse
          ];
        };
        ViewersService.prototype.listViewersByProjectId.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.ListViewersByProjectId');
        };
        ViewersService.prototype.getViewersByProjectId.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.GetViewersByProjectId');
        };
        ViewersService.prototype.getViewer.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.GetViewer');
        };
        ViewersService.prototype.createViewer.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.CreateViewer');
        };
        ViewersService.prototype.deleteViewer.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.DeleteViewer');
        };
        ViewersService.prototype.updateViewerName.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.UpdateViewerName');
        };
        ViewersService.prototype.updateViewerArtifactId.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.UpdateViewerArtifactId');
        };
        ViewersService.prototype.updateViewerConfig.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.UpdateViewerConfig');
        };
        ViewersService.prototype.publishViewerConfig.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.PublishViewerConfig');
        };
        ViewersService.prototype.updateMenuConfig.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.UpdateMenuConfig');
        };
        ViewersService.prototype.publishMenuConfig.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.PublishMenuConfig');
        };
        ViewersService.prototype.bumpVersion.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.BumpVersion');
        };
        ViewersService.prototype.purgeVersions.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.PurgeVersions');
        };
        ViewersService.prototype.updateVersion.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.UpdateVersion');
        };
        ViewersService.prototype.getVersions.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.GetVersions');
        };
        ViewersService.prototype.updateContentStatus.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.UpdateContentStatus');
        };
        ViewersService.prototype.queryViewersByContent.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.QueryViewersByContent');
        };
        ViewersService.prototype.updateAutoPublish.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.UpdateAutoPublish');
        };
        ViewersService.prototype.updateViewersOrder.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.UpdateViewersOrder');
        };
        ViewersService.prototype.updateViewerVisibility.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.UpdateViewerVisibility');
        };
        ViewersService.prototype.addToEmailList.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.AddToEmailList');
        };
        ViewersService.prototype.removeEmailsFromList.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.RemoveEmailsFromList');
        };
        ViewersService.prototype.deployContent.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.DeployContent');
        };
        ViewersService.prototype.queryViewer.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.QueryViewer');
        };
        ViewersService.prototype.updateViewer.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.UpdateViewer');
        };
        ViewersService.prototype.updateServiceJsonFormat.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService.UpdateServiceJsonFormat');
        };
        __builtIn.Object.defineProperty(ViewersService.prototype, '__isRpcService__', {
          value: true,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewersService.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.ViewersService',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewersService.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.ViewersService');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewersService.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewersService.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ViewersService.prototype, '__filename', {
          value: __filename,
          enumerable: false,
          configurable: false
        });
        return ViewersService;
      }());;
      _wixdocs.ListViewersByProjectIdRequest = (function () {
        class ListViewersByProjectIdRequest {
          constructor(props) {
            this.projectId = props && props.projectId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['projectId'] != null) {
                json['projectId'] = obj['projectId'];
              } else if (withDefaults) {
                json['projectId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.ListViewersByProjectIdRequest();
              if (json['projectId'] != null) {
                result['projectId'] = json['projectId'];
              } else if (withDefaults !== false) {
                result['projectId'] = '';
              } else {
                delete result['projectId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['projectId'] != null) {
                grpc['projectId'] = obj['projectId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.ListViewersByProjectIdRequest();
              if (grpc['projectId'] != null) {
                result['projectId'] = grpc['projectId'];
              } else {
                result['projectId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(ListViewersByProjectIdRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.ListViewersByProjectIdRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ListViewersByProjectIdRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.ListViewersByProjectIdRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ListViewersByProjectIdRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ListViewersByProjectIdRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return ListViewersByProjectIdRequest;
      }());;
      _wixdocs.ListViewersByProjectIdResponse = (function () {
        class ListViewersByProjectIdResponse {
          constructor(props) {
            this.viewers = props && props.viewers;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['viewers'] != null) {
                json['viewers'] = obj['viewers'].map(e => {
                  return $root.com.wixpress.wixdocs.Viewer.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['viewers'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.ListViewersByProjectIdResponse();
              if (json['viewers'] != null) {
                result['viewers'] = Array.isArray(json['viewers']) ? json['viewers'].map(e => {
                  return $root.com.wixpress.wixdocs.Viewer.fromJSON(e, helper);
                }) : json['viewers'];
              } else if (withDefaults !== false) {
                result['viewers'] = [];
              } else {
                delete result['viewers'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['viewers'] != null) {
                grpc['viewers'] = obj['viewers'].map(e => {
                  return $root.com.wixpress.wixdocs.Viewer.toGRPC(e, helper);
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.ListViewersByProjectIdResponse();
              if (grpc['viewers'] != null) {
                result['viewers'] = grpc['viewers'].map(e => {
                  return $root.com.wixpress.wixdocs.Viewer.fromGRPC(e, helper);
                });
              } else {
                result['viewers'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(ListViewersByProjectIdResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.ListViewersByProjectIdResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ListViewersByProjectIdResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.ListViewersByProjectIdResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ListViewersByProjectIdResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ListViewersByProjectIdResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return ListViewersByProjectIdResponse;
      }());;
      _wixdocs.GetViewersByProjectIdRequest = (function () {
        class GetViewersByProjectIdRequest {
          constructor(props) {
            this.projectId = props && props.projectId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['projectId'] != null) {
                json['projectId'] = obj['projectId'];
              } else if (withDefaults) {
                json['projectId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.GetViewersByProjectIdRequest();
              if (json['projectId'] != null) {
                result['projectId'] = json['projectId'];
              } else if (withDefaults !== false) {
                result['projectId'] = '';
              } else {
                delete result['projectId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['projectId'] != null) {
                grpc['projectId'] = obj['projectId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.GetViewersByProjectIdRequest();
              if (grpc['projectId'] != null) {
                result['projectId'] = grpc['projectId'];
              } else {
                result['projectId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(GetViewersByProjectIdRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.GetViewersByProjectIdRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetViewersByProjectIdRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.GetViewersByProjectIdRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetViewersByProjectIdRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetViewersByProjectIdRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return GetViewersByProjectIdRequest;
      }());;
      _wixdocs.GetViewersByProjectIdResponse = (function () {
        class GetViewersByProjectIdResponse {
          constructor(props) {
            this.viewers = props && props.viewers;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['viewers'] != null) {
                json['viewers'] = obj['viewers'].map(e => {
                  return $root.com.wixpress.wixdocs.Viewer.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['viewers'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.GetViewersByProjectIdResponse();
              if (json['viewers'] != null) {
                result['viewers'] = Array.isArray(json['viewers']) ? json['viewers'].map(e => {
                  return $root.com.wixpress.wixdocs.Viewer.fromJSON(e, helper);
                }) : json['viewers'];
              } else if (withDefaults !== false) {
                result['viewers'] = [];
              } else {
                delete result['viewers'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['viewers'] != null) {
                grpc['viewers'] = obj['viewers'].map(e => {
                  return $root.com.wixpress.wixdocs.Viewer.toGRPC(e, helper);
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.GetViewersByProjectIdResponse();
              if (grpc['viewers'] != null) {
                result['viewers'] = grpc['viewers'].map(e => {
                  return $root.com.wixpress.wixdocs.Viewer.fromGRPC(e, helper);
                });
              } else {
                result['viewers'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(GetViewersByProjectIdResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.GetViewersByProjectIdResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetViewersByProjectIdResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.GetViewersByProjectIdResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetViewersByProjectIdResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetViewersByProjectIdResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return GetViewersByProjectIdResponse;
      }());;
      _wixdocs.GetViewerRequest = (function () {
        class GetViewerRequest {
          constructor(props) {
            this.id = props && props.id;
            this.projectId = props && props.projectId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              if (obj['projectId'] != null) {
                json['projectId'] = obj['projectId'];
              } else if (withDefaults) {
                json['projectId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.GetViewerRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              if (json['projectId'] != null) {
                result['projectId'] = json['projectId'];
              } else if (withDefaults !== false) {
                result['projectId'] = '';
              } else {
                delete result['projectId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['projectId'] != null) {
                grpc['projectId'] = obj['projectId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.GetViewerRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              if (grpc['projectId'] != null) {
                result['projectId'] = grpc['projectId'];
              } else {
                result['projectId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(GetViewerRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.GetViewerRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetViewerRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.GetViewerRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetViewerRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetViewerRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return GetViewerRequest;
      }());;
      _wixdocs.GetViewerResponse = (function () {
        class GetViewerResponse {
          constructor(props) {
            this.viewer = props && props.viewer;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['viewer'] != null) {
                json['viewer'] = $root.com.wixpress.wixdocs.Viewer.toJSON(obj['viewer'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['viewer'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.GetViewerResponse();
              if (json['viewer'] != null) {
                result['viewer'] = $root.com.wixpress.wixdocs.Viewer.fromJSON(json['viewer'], helper);
              } else if (withDefaults !== false) {
                delete result['viewer'];
              } else {
                delete result['viewer'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['viewer'] != null) {
                grpc['viewer'] = $root.com.wixpress.wixdocs.Viewer.toGRPC(obj['viewer'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.GetViewerResponse();
              if (grpc['viewer'] != null) {
                result['viewer'] = $root.com.wixpress.wixdocs.Viewer.fromGRPC(grpc['viewer'], helper);
              } else {
                delete result['viewer'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(GetViewerResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.GetViewerResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetViewerResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.GetViewerResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetViewerResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetViewerResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return GetViewerResponse;
      }());;
      _wixdocs.CreateViewerRequest = (function () {
        class CreateViewerRequest {
          constructor(props) {
            this.projectId = props && props.projectId;
            this.name = props && props.name;
            this.artifactId = props && props.artifactId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['projectId'] != null) {
                json['projectId'] = obj['projectId'];
              } else if (withDefaults) {
                json['projectId'] = '';
              }
              if (obj['name'] != null) {
                json['name'] = obj['name'];
              } else if (withDefaults) {
                json['name'] = '';
              }
              if (obj['artifactId'] != null) {
                json['artifactId'] = obj['artifactId'];
              } else if (withDefaults) {
                json['artifactId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.CreateViewerRequest();
              if (json['projectId'] != null) {
                result['projectId'] = json['projectId'];
              } else if (withDefaults !== false) {
                result['projectId'] = '';
              } else {
                delete result['projectId'];
              }
              if (json['name'] != null) {
                result['name'] = json['name'];
              } else if (withDefaults !== false) {
                result['name'] = '';
              } else {
                delete result['name'];
              }
              if (json['artifactId'] != null) {
                result['artifactId'] = json['artifactId'];
              } else if (withDefaults !== false) {
                result['artifactId'] = '';
              } else {
                delete result['artifactId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['projectId'] != null) {
                grpc['projectId'] = obj['projectId'];
              }
              if (obj['name'] != null) {
                grpc['name'] = obj['name'];
              }
              if (obj['artifactId'] != null) {
                grpc['artifactId'] = obj['artifactId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.CreateViewerRequest();
              if (grpc['projectId'] != null) {
                result['projectId'] = grpc['projectId'];
              } else {
                result['projectId'] = '';
              }
              if (grpc['name'] != null) {
                result['name'] = grpc['name'];
              } else {
                result['name'] = '';
              }
              if (grpc['artifactId'] != null) {
                result['artifactId'] = grpc['artifactId'];
              } else {
                result['artifactId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(CreateViewerRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.CreateViewerRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CreateViewerRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.CreateViewerRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CreateViewerRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CreateViewerRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return CreateViewerRequest;
      }());;
      _wixdocs.CreateViewerResponse = (function () {
        class CreateViewerResponse {
          constructor(props) {
            this.viewer = props && props.viewer;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['viewer'] != null) {
                json['viewer'] = $root.com.wixpress.wixdocs.Viewer.toJSON(obj['viewer'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['viewer'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.CreateViewerResponse();
              if (json['viewer'] != null) {
                result['viewer'] = $root.com.wixpress.wixdocs.Viewer.fromJSON(json['viewer'], helper);
              } else if (withDefaults !== false) {
                delete result['viewer'];
              } else {
                delete result['viewer'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['viewer'] != null) {
                grpc['viewer'] = $root.com.wixpress.wixdocs.Viewer.toGRPC(obj['viewer'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.CreateViewerResponse();
              if (grpc['viewer'] != null) {
                result['viewer'] = $root.com.wixpress.wixdocs.Viewer.fromGRPC(grpc['viewer'], helper);
              } else {
                delete result['viewer'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(CreateViewerResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.CreateViewerResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CreateViewerResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.CreateViewerResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CreateViewerResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CreateViewerResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return CreateViewerResponse;
      }());;
      _wixdocs.DeleteViewerRequest = (function () {
        class DeleteViewerRequest {
          constructor(props) {
            this.projectId = props && props.projectId;
            this.id = props && props.id;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['projectId'] != null) {
                json['projectId'] = obj['projectId'];
              } else if (withDefaults) {
                json['projectId'] = '';
              }
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.DeleteViewerRequest();
              if (json['projectId'] != null) {
                result['projectId'] = json['projectId'];
              } else if (withDefaults !== false) {
                result['projectId'] = '';
              } else {
                delete result['projectId'];
              }
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['projectId'] != null) {
                grpc['projectId'] = obj['projectId'];
              }
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.DeleteViewerRequest();
              if (grpc['projectId'] != null) {
                result['projectId'] = grpc['projectId'];
              } else {
                result['projectId'] = '';
              }
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(DeleteViewerRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.DeleteViewerRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DeleteViewerRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.DeleteViewerRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DeleteViewerRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DeleteViewerRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return DeleteViewerRequest;
      }());;
      _wixdocs.DeleteViewerResponse = (function () {
        class DeleteViewerResponse {
          constructor(props) {
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.DeleteViewerResponse();
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.DeleteViewerResponse();
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(DeleteViewerResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.DeleteViewerResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DeleteViewerResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.DeleteViewerResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DeleteViewerResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DeleteViewerResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return DeleteViewerResponse;
      }());;
      _wixdocs.UpdateViewerNameRequest = (function () {
        class UpdateViewerNameRequest {
          constructor(props) {
            this.id = props && props.id;
            this.name = props && props.name;
            this.projectId = props && props.projectId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              if (obj['name'] != null) {
                json['name'] = obj['name'];
              } else if (withDefaults) {
                json['name'] = '';
              }
              if (obj['projectId'] != null) {
                json['projectId'] = obj['projectId'];
              } else if (withDefaults) {
                json['projectId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateViewerNameRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              if (json['name'] != null) {
                result['name'] = json['name'];
              } else if (withDefaults !== false) {
                result['name'] = '';
              } else {
                delete result['name'];
              }
              if (json['projectId'] != null) {
                result['projectId'] = json['projectId'];
              } else if (withDefaults !== false) {
                result['projectId'] = '';
              } else {
                delete result['projectId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['name'] != null) {
                grpc['name'] = obj['name'];
              }
              if (obj['projectId'] != null) {
                grpc['projectId'] = obj['projectId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateViewerNameRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              if (grpc['name'] != null) {
                result['name'] = grpc['name'];
              } else {
                result['name'] = '';
              }
              if (grpc['projectId'] != null) {
                result['projectId'] = grpc['projectId'];
              } else {
                result['projectId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateViewerNameRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateViewerNameRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerNameRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateViewerNameRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerNameRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerNameRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateViewerNameRequest;
      }());;
      _wixdocs.UpdateViewerNameResponse = (function () {
        class UpdateViewerNameResponse {
          constructor(props) {
            this.viewer = props && props.viewer;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['viewer'] != null) {
                json['viewer'] = $root.com.wixpress.wixdocs.Viewer.toJSON(obj['viewer'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['viewer'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateViewerNameResponse();
              if (json['viewer'] != null) {
                result['viewer'] = $root.com.wixpress.wixdocs.Viewer.fromJSON(json['viewer'], helper);
              } else if (withDefaults !== false) {
                delete result['viewer'];
              } else {
                delete result['viewer'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['viewer'] != null) {
                grpc['viewer'] = $root.com.wixpress.wixdocs.Viewer.toGRPC(obj['viewer'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateViewerNameResponse();
              if (grpc['viewer'] != null) {
                result['viewer'] = $root.com.wixpress.wixdocs.Viewer.fromGRPC(grpc['viewer'], helper);
              } else {
                delete result['viewer'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateViewerNameResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateViewerNameResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerNameResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateViewerNameResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerNameResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerNameResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateViewerNameResponse;
      }());;
      _wixdocs.UpdateViewerArtifactIdRequest = (function () {
        class UpdateViewerArtifactIdRequest {
          constructor(props) {
            this.id = props && props.id;
            this.artifactId = props && props.artifactId;
            this.projectId = props && props.projectId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              if (obj['artifactId'] != null) {
                json['artifactId'] = obj['artifactId'];
              } else if (withDefaults) {
                json['artifactId'] = '';
              }
              if (obj['projectId'] != null) {
                json['projectId'] = obj['projectId'];
              } else if (withDefaults) {
                json['projectId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateViewerArtifactIdRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              if (json['artifactId'] != null) {
                result['artifactId'] = json['artifactId'];
              } else if (withDefaults !== false) {
                result['artifactId'] = '';
              } else {
                delete result['artifactId'];
              }
              if (json['projectId'] != null) {
                result['projectId'] = json['projectId'];
              } else if (withDefaults !== false) {
                result['projectId'] = '';
              } else {
                delete result['projectId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['artifactId'] != null) {
                grpc['artifactId'] = obj['artifactId'];
              }
              if (obj['projectId'] != null) {
                grpc['projectId'] = obj['projectId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateViewerArtifactIdRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              if (grpc['artifactId'] != null) {
                result['artifactId'] = grpc['artifactId'];
              } else {
                result['artifactId'] = '';
              }
              if (grpc['projectId'] != null) {
                result['projectId'] = grpc['projectId'];
              } else {
                result['projectId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateViewerArtifactIdRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateViewerArtifactIdRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerArtifactIdRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateViewerArtifactIdRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerArtifactIdRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerArtifactIdRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateViewerArtifactIdRequest;
      }());;
      _wixdocs.UpdateViewerArtifactIdResponse = (function () {
        class UpdateViewerArtifactIdResponse {
          constructor(props) {
            this.viewer = props && props.viewer;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['viewer'] != null) {
                json['viewer'] = $root.com.wixpress.wixdocs.Viewer.toJSON(obj['viewer'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['viewer'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateViewerArtifactIdResponse();
              if (json['viewer'] != null) {
                result['viewer'] = $root.com.wixpress.wixdocs.Viewer.fromJSON(json['viewer'], helper);
              } else if (withDefaults !== false) {
                delete result['viewer'];
              } else {
                delete result['viewer'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['viewer'] != null) {
                grpc['viewer'] = $root.com.wixpress.wixdocs.Viewer.toGRPC(obj['viewer'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateViewerArtifactIdResponse();
              if (grpc['viewer'] != null) {
                result['viewer'] = $root.com.wixpress.wixdocs.Viewer.fromGRPC(grpc['viewer'], helper);
              } else {
                delete result['viewer'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateViewerArtifactIdResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateViewerArtifactIdResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerArtifactIdResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateViewerArtifactIdResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerArtifactIdResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerArtifactIdResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateViewerArtifactIdResponse;
      }());;
      _wixdocs.UpdateViewerConfigRequest = (function () {
        class UpdateViewerConfigRequest {
          constructor(props) {
            this.id = props && props.id;
            this.config = props && props.config;
            this.shouldPublish = props && props.shouldPublish;
            this.projectId = props && props.projectId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              if (obj['config'] != null) {
                json['config'] = $root.com.wixpress.wixdocs.ViewerConfig.toJSON(obj['config'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['config'];
              }
              if (obj['shouldPublish'] != null) {
                json['shouldPublish'] = obj['shouldPublish'];
              } else if (withDefaults) {
                json['shouldPublish'] = false;
              }
              if (obj['projectId'] != null) {
                json['projectId'] = obj['projectId'];
              } else if (withDefaults) {
                json['projectId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateViewerConfigRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              if (json['config'] != null) {
                result['config'] = $root.com.wixpress.wixdocs.ViewerConfig.fromJSON(json['config'], helper);
              } else if (withDefaults !== false) {
                delete result['config'];
              } else {
                delete result['config'];
              }
              if (json['shouldPublish'] != null) {
                result['shouldPublish'] = json['shouldPublish'];
              } else if (withDefaults !== false) {
                result['shouldPublish'] = false;
              } else {
                delete result['shouldPublish'];
              }
              if (json['projectId'] != null) {
                result['projectId'] = json['projectId'];
              } else if (withDefaults !== false) {
                result['projectId'] = '';
              } else {
                delete result['projectId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['config'] != null) {
                grpc['config'] = $root.com.wixpress.wixdocs.ViewerConfig.toGRPC(obj['config'], helper);
              }
              if (obj['shouldPublish'] != null) {
                grpc['shouldPublish'] = obj['shouldPublish'];
              }
              if (obj['projectId'] != null) {
                grpc['projectId'] = obj['projectId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateViewerConfigRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              if (grpc['config'] != null) {
                result['config'] = $root.com.wixpress.wixdocs.ViewerConfig.fromGRPC(grpc['config'], helper);
              } else {
                delete result['config'];
              }
              if (grpc['shouldPublish'] != null) {
                result['shouldPublish'] = grpc['shouldPublish'];
              } else {
                result['shouldPublish'] = false;
              }
              if (grpc['projectId'] != null) {
                result['projectId'] = grpc['projectId'];
              } else {
                result['projectId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateViewerConfigRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateViewerConfigRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerConfigRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateViewerConfigRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerConfigRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerConfigRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateViewerConfigRequest;
      }());;
      _wixdocs.UpdateViewerConfigResponse = (function () {
        class UpdateViewerConfigResponse {
          constructor(props) {
            this.config = props && props.config;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['config'] != null) {
                json['config'] = $root.com.wixpress.wixdocs.ViewerConfig.toJSON(obj['config'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['config'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateViewerConfigResponse();
              if (json['config'] != null) {
                result['config'] = $root.com.wixpress.wixdocs.ViewerConfig.fromJSON(json['config'], helper);
              } else if (withDefaults !== false) {
                delete result['config'];
              } else {
                delete result['config'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['config'] != null) {
                grpc['config'] = $root.com.wixpress.wixdocs.ViewerConfig.toGRPC(obj['config'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateViewerConfigResponse();
              if (grpc['config'] != null) {
                result['config'] = $root.com.wixpress.wixdocs.ViewerConfig.fromGRPC(grpc['config'], helper);
              } else {
                delete result['config'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateViewerConfigResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateViewerConfigResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerConfigResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateViewerConfigResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerConfigResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerConfigResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateViewerConfigResponse;
      }());;
      _wixdocs.PublishViewerConfigRequest = (function () {
        class PublishViewerConfigRequest {
          constructor(props) {
            this.id = props && props.id;
            this.projectId = props && props.projectId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              if (obj['projectId'] != null) {
                json['projectId'] = obj['projectId'];
              } else if (withDefaults) {
                json['projectId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.PublishViewerConfigRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              if (json['projectId'] != null) {
                result['projectId'] = json['projectId'];
              } else if (withDefaults !== false) {
                result['projectId'] = '';
              } else {
                delete result['projectId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['projectId'] != null) {
                grpc['projectId'] = obj['projectId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.PublishViewerConfigRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              if (grpc['projectId'] != null) {
                result['projectId'] = grpc['projectId'];
              } else {
                result['projectId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(PublishViewerConfigRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.PublishViewerConfigRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PublishViewerConfigRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.PublishViewerConfigRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PublishViewerConfigRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PublishViewerConfigRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return PublishViewerConfigRequest;
      }());;
      _wixdocs.PublishViewerConfigResponse = (function () {
        class PublishViewerConfigResponse {
          constructor(props) {
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.PublishViewerConfigResponse();
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.PublishViewerConfigResponse();
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(PublishViewerConfigResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.PublishViewerConfigResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PublishViewerConfigResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.PublishViewerConfigResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PublishViewerConfigResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PublishViewerConfigResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return PublishViewerConfigResponse;
      }());;
      _wixdocs.UpdateMenuConfigRequest = (function () {
        class UpdateMenuConfigRequest {
          constructor(props) {
            this.id = props && props.id;
            this.config = props && props.config;
            this.shouldPublish = props && props.shouldPublish;
            this.projectId = props && props.projectId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              if (obj['config'] != null) {
                json['config'] = $root.com.wixpress.wixdocs.MenuConfig.toJSON(obj['config'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['config'];
              }
              if (obj['shouldPublish'] != null) {
                json['shouldPublish'] = obj['shouldPublish'];
              } else if (withDefaults) {
                json['shouldPublish'] = false;
              }
              if (obj['projectId'] != null) {
                json['projectId'] = obj['projectId'];
              } else if (withDefaults) {
                json['projectId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateMenuConfigRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              if (json['config'] != null) {
                result['config'] = $root.com.wixpress.wixdocs.MenuConfig.fromJSON(json['config'], helper);
              } else if (withDefaults !== false) {
                delete result['config'];
              } else {
                delete result['config'];
              }
              if (json['shouldPublish'] != null) {
                result['shouldPublish'] = json['shouldPublish'];
              } else if (withDefaults !== false) {
                result['shouldPublish'] = false;
              } else {
                delete result['shouldPublish'];
              }
              if (json['projectId'] != null) {
                result['projectId'] = json['projectId'];
              } else if (withDefaults !== false) {
                result['projectId'] = '';
              } else {
                delete result['projectId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['config'] != null) {
                grpc['config'] = $root.com.wixpress.wixdocs.MenuConfig.toGRPC(obj['config'], helper);
              }
              if (obj['shouldPublish'] != null) {
                grpc['shouldPublish'] = obj['shouldPublish'];
              }
              if (obj['projectId'] != null) {
                grpc['projectId'] = obj['projectId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateMenuConfigRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              if (grpc['config'] != null) {
                result['config'] = $root.com.wixpress.wixdocs.MenuConfig.fromGRPC(grpc['config'], helper);
              } else {
                delete result['config'];
              }
              if (grpc['shouldPublish'] != null) {
                result['shouldPublish'] = grpc['shouldPublish'];
              } else {
                result['shouldPublish'] = false;
              }
              if (grpc['projectId'] != null) {
                result['projectId'] = grpc['projectId'];
              } else {
                result['projectId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateMenuConfigRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateMenuConfigRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateMenuConfigRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateMenuConfigRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateMenuConfigRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateMenuConfigRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateMenuConfigRequest;
      }());;
      _wixdocs.UpdateMenuConfigResponse = (function () {
        class UpdateMenuConfigResponse {
          constructor(props) {
            this.config = props && props.config;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['config'] != null) {
                json['config'] = $root.com.wixpress.wixdocs.MenuConfig.toJSON(obj['config'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['config'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateMenuConfigResponse();
              if (json['config'] != null) {
                result['config'] = $root.com.wixpress.wixdocs.MenuConfig.fromJSON(json['config'], helper);
              } else if (withDefaults !== false) {
                delete result['config'];
              } else {
                delete result['config'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['config'] != null) {
                grpc['config'] = $root.com.wixpress.wixdocs.MenuConfig.toGRPC(obj['config'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateMenuConfigResponse();
              if (grpc['config'] != null) {
                result['config'] = $root.com.wixpress.wixdocs.MenuConfig.fromGRPC(grpc['config'], helper);
              } else {
                delete result['config'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateMenuConfigResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateMenuConfigResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateMenuConfigResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateMenuConfigResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateMenuConfigResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateMenuConfigResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateMenuConfigResponse;
      }());;
      _wixdocs.PublishMenuConfigRequest = (function () {
        class PublishMenuConfigRequest {
          constructor(props) {
            this.id = props && props.id;
            this.projectId = props && props.projectId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              if (obj['projectId'] != null) {
                json['projectId'] = obj['projectId'];
              } else if (withDefaults) {
                json['projectId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.PublishMenuConfigRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              if (json['projectId'] != null) {
                result['projectId'] = json['projectId'];
              } else if (withDefaults !== false) {
                result['projectId'] = '';
              } else {
                delete result['projectId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['projectId'] != null) {
                grpc['projectId'] = obj['projectId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.PublishMenuConfigRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              if (grpc['projectId'] != null) {
                result['projectId'] = grpc['projectId'];
              } else {
                result['projectId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(PublishMenuConfigRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.PublishMenuConfigRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PublishMenuConfigRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.PublishMenuConfigRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PublishMenuConfigRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PublishMenuConfigRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return PublishMenuConfigRequest;
      }());;
      _wixdocs.PublishMenuConfigResponse = (function () {
        class PublishMenuConfigResponse {
          constructor(props) {
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.PublishMenuConfigResponse();
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.PublishMenuConfigResponse();
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(PublishMenuConfigResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.PublishMenuConfigResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PublishMenuConfigResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.PublishMenuConfigResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PublishMenuConfigResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PublishMenuConfigResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return PublishMenuConfigResponse;
      }());;
      _wixdocs.BumpVersionRequest = (function () {
        class BumpVersionRequest {
          constructor(props) {
            this.id = props && props.id;
            this.projectId = props && props.projectId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              if (obj['projectId'] != null) {
                json['projectId'] = obj['projectId'];
              } else if (withDefaults) {
                json['projectId'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.BumpVersionRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              if (json['projectId'] != null) {
                result['projectId'] = json['projectId'];
              } else if (withDefaults !== false) {
                result['projectId'] = '';
              } else {
                delete result['projectId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['projectId'] != null) {
                grpc['projectId'] = obj['projectId'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.BumpVersionRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              if (grpc['projectId'] != null) {
                result['projectId'] = grpc['projectId'];
              } else {
                result['projectId'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(BumpVersionRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.BumpVersionRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(BumpVersionRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.BumpVersionRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(BumpVersionRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(BumpVersionRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return BumpVersionRequest;
      }());;
      _wixdocs.BumpVersionResponse = (function () {
        class BumpVersionResponse {
          constructor(props) {
            this.version = props && props.version;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['version'] != null) {
                json['version'] = obj['version'];
              } else if (withDefaults) {
                json['version'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.BumpVersionResponse();
              if (json['version'] != null) {
                result['version'] = json['version'];
              } else if (withDefaults !== false) {
                result['version'] = '';
              } else {
                delete result['version'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['version'] != null) {
                grpc['version'] = obj['version'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.BumpVersionResponse();
              if (grpc['version'] != null) {
                result['version'] = grpc['version'];
              } else {
                result['version'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(BumpVersionResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.BumpVersionResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(BumpVersionResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.BumpVersionResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(BumpVersionResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(BumpVersionResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return BumpVersionResponse;
      }());;
      _wixdocs.PurgeVersionsRequest = (function () {
        class PurgeVersionsRequest {
          constructor(props) {
            this.id = props && props.id;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.PurgeVersionsRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.PurgeVersionsRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(PurgeVersionsRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.PurgeVersionsRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PurgeVersionsRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.PurgeVersionsRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PurgeVersionsRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PurgeVersionsRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return PurgeVersionsRequest;
      }());;
      _wixdocs.PurgeVersionsResponse = (function () {
        class PurgeVersionsResponse {
          constructor(props) {
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.PurgeVersionsResponse();
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.PurgeVersionsResponse();
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(PurgeVersionsResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.PurgeVersionsResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PurgeVersionsResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.PurgeVersionsResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PurgeVersionsResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PurgeVersionsResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return PurgeVersionsResponse;
      }());;
      _wixdocs.UpdateVersionRequest = (function () {
        class UpdateVersionRequest {
          constructor(props) {
            this.id = props && props.id;
            this.projectId = props && props.projectId;
            this.viewerVersion = props && props.viewerVersion;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              if (obj['projectId'] != null) {
                json['projectId'] = obj['projectId'];
              } else if (withDefaults) {
                json['projectId'] = '';
              }
              if (obj['viewerVersion'] != null) {
                json['viewerVersion'] = obj['viewerVersion'];
              } else if (withDefaults) {
                json['viewerVersion'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateVersionRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              if (json['projectId'] != null) {
                result['projectId'] = json['projectId'];
              } else if (withDefaults !== false) {
                result['projectId'] = '';
              } else {
                delete result['projectId'];
              }
              if (json['viewerVersion'] != null) {
                result['viewerVersion'] = json['viewerVersion'];
              } else if (withDefaults !== false) {
                result['viewerVersion'] = '';
              } else {
                delete result['viewerVersion'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['projectId'] != null) {
                grpc['projectId'] = obj['projectId'];
              }
              if (obj['viewerVersion'] != null) {
                grpc['viewerVersion'] = obj['viewerVersion'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateVersionRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              if (grpc['projectId'] != null) {
                result['projectId'] = grpc['projectId'];
              } else {
                result['projectId'] = '';
              }
              if (grpc['viewerVersion'] != null) {
                result['viewerVersion'] = grpc['viewerVersion'];
              } else {
                result['viewerVersion'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateVersionRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateVersionRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateVersionRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateVersionRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateVersionRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateVersionRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateVersionRequest;
      }());;
      _wixdocs.UpdateVersionResponse = (function () {
        class UpdateVersionResponse {
          constructor(props) {
            this.version = props && props.version;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['version'] != null) {
                json['version'] = obj['version'];
              } else if (withDefaults) {
                json['version'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateVersionResponse();
              if (json['version'] != null) {
                result['version'] = json['version'];
              } else if (withDefaults !== false) {
                result['version'] = '';
              } else {
                delete result['version'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['version'] != null) {
                grpc['version'] = obj['version'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateVersionResponse();
              if (grpc['version'] != null) {
                result['version'] = grpc['version'];
              } else {
                result['version'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateVersionResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateVersionResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateVersionResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateVersionResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateVersionResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateVersionResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateVersionResponse;
      }());;
      _wixdocs.GetVersionsRequest = (function () {
        class GetVersionsRequest {
          constructor(props) {
            this.id = props && props.id;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.GetVersionsRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.GetVersionsRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(GetVersionsRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.GetVersionsRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetVersionsRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.GetVersionsRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetVersionsRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetVersionsRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return GetVersionsRequest;
      }());;
      _wixdocs.GetVersionsResponse = (function () {
        class GetVersionsResponse {
          constructor(props) {
            this.versions = props && props.versions;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['versions'] != null) {
                json['versions'] = obj['versions'].map(e => {
                  return $root.com.wixpress.wixdocs.Version.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['versions'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.GetVersionsResponse();
              if (json['versions'] != null) {
                result['versions'] = Array.isArray(json['versions']) ? json['versions'].map(e => {
                  return $root.com.wixpress.wixdocs.Version.fromJSON(e, helper);
                }) : json['versions'];
              } else if (withDefaults !== false) {
                result['versions'] = [];
              } else {
                delete result['versions'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['versions'] != null) {
                grpc['versions'] = obj['versions'].map(e => {
                  return $root.com.wixpress.wixdocs.Version.toGRPC(e, helper);
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.GetVersionsResponse();
              if (grpc['versions'] != null) {
                result['versions'] = grpc['versions'].map(e => {
                  return $root.com.wixpress.wixdocs.Version.fromGRPC(e, helper);
                });
              } else {
                result['versions'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(GetVersionsResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.GetVersionsResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetVersionsResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.GetVersionsResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetVersionsResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(GetVersionsResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return GetVersionsResponse;
      }());;
      _wixdocs.UpdateContentStatusRequest = (function () {
        class UpdateContentStatusRequest {
          constructor(props) {
            this.id = props && props.id;
            this.category = props && props.category;
            this.contentStatus = props && props.contentStatus;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                delete json['id'];
              }
              if (obj['category'] != null) {
                json['category'] = obj['category'];
              } else if (withDefaults) {
                delete json['category'];
              }
              if (obj['contentStatus'] != null) {
                json['contentStatus'] = $root.com.wixpress.wixdocs.Viewer.ContentStatus[obj['contentStatus']];
              } else if (withDefaults) {
                json['contentStatus'] = 'PUBLISHED';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateContentStatusRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                delete result['id'];
              } else {
                delete result['id'];
              }
              if (json['category'] != null) {
                result['category'] = json['category'];
              } else if (withDefaults !== false) {
                delete result['category'];
              } else {
                delete result['category'];
              }
              if (json['contentStatus'] != null) {
                result['contentStatus'] = typeof json['contentStatus'] === 'string' ? json['contentStatus'] : $root.com.wixpress.wixdocs.Viewer.ContentStatus[json['contentStatus']];
              } else if (withDefaults !== false) {
                result['contentStatus'] = 'PUBLISHED';
              } else {
                delete result['contentStatus'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['category'] != null) {
                grpc['category'] = obj['category'];
              }
              if (obj['contentStatus'] != null) {
                grpc['contentStatus'] = obj['contentStatus'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateContentStatusRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                delete result['id'];
              }
              if (grpc['category'] != null) {
                result['category'] = grpc['category'];
              } else {
                delete result['category'];
              }
              if (grpc['contentStatus'] != null) {
                result['contentStatus'] = grpc['contentStatus'];
              } else {
                result['contentStatus'] = 'PUBLISHED';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateContentStatusRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateContentStatusRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateContentStatusRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateContentStatusRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateContentStatusRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateContentStatusRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateContentStatusRequest;
      }());;
      _wixdocs.UpdateContentStatusResponse = (function () {
        class UpdateContentStatusResponse {
          constructor(props) {
            this.contentStatus = props && props.contentStatus;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['contentStatus'] != null) {
                json['contentStatus'] = $root.com.wixpress.wixdocs.Viewer.ContentStatus[obj['contentStatus']];
              } else if (withDefaults) {
                json['contentStatus'] = 'PUBLISHED';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateContentStatusResponse();
              if (json['contentStatus'] != null) {
                result['contentStatus'] = typeof json['contentStatus'] === 'string' ? json['contentStatus'] : $root.com.wixpress.wixdocs.Viewer.ContentStatus[json['contentStatus']];
              } else if (withDefaults !== false) {
                result['contentStatus'] = 'PUBLISHED';
              } else {
                delete result['contentStatus'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['contentStatus'] != null) {
                grpc['contentStatus'] = obj['contentStatus'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateContentStatusResponse();
              if (grpc['contentStatus'] != null) {
                result['contentStatus'] = grpc['contentStatus'];
              } else {
                result['contentStatus'] = 'PUBLISHED';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateContentStatusResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateContentStatusResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateContentStatusResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateContentStatusResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateContentStatusResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateContentStatusResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateContentStatusResponse;
      }());;
      _wixdocs.QueryViewersByContentRequest = (function () {
        class QueryViewersByContentRequest {
          constructor(props) {
            this.contentStatus = props && props.contentStatus;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['contentStatus'] != null) {
                json['contentStatus'] = $root.com.wixpress.wixdocs.Viewer.ContentStatus[obj['contentStatus']];
              } else if (withDefaults) {
                json['contentStatus'] = 'PUBLISHED';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.QueryViewersByContentRequest();
              if (json['contentStatus'] != null) {
                result['contentStatus'] = typeof json['contentStatus'] === 'string' ? json['contentStatus'] : $root.com.wixpress.wixdocs.Viewer.ContentStatus[json['contentStatus']];
              } else if (withDefaults !== false) {
                result['contentStatus'] = 'PUBLISHED';
              } else {
                delete result['contentStatus'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['contentStatus'] != null) {
                grpc['contentStatus'] = obj['contentStatus'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.QueryViewersByContentRequest();
              if (grpc['contentStatus'] != null) {
                result['contentStatus'] = grpc['contentStatus'];
              } else {
                result['contentStatus'] = 'PUBLISHED';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(QueryViewersByContentRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.QueryViewersByContentRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(QueryViewersByContentRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.QueryViewersByContentRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(QueryViewersByContentRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(QueryViewersByContentRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return QueryViewersByContentRequest;
      }());;
      _wixdocs.QueryViewersByContentResponse = (function () {
        class QueryViewersByContentResponse {
          constructor(props) {
            this.viewers = props && props.viewers;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['viewers'] != null) {
                json['viewers'] = obj['viewers'].map(e => {
                  return $root.com.wixpress.wixdocs.Viewer.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['viewers'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.QueryViewersByContentResponse();
              if (json['viewers'] != null) {
                result['viewers'] = Array.isArray(json['viewers']) ? json['viewers'].map(e => {
                  return $root.com.wixpress.wixdocs.Viewer.fromJSON(e, helper);
                }) : json['viewers'];
              } else if (withDefaults !== false) {
                result['viewers'] = [];
              } else {
                delete result['viewers'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['viewers'] != null) {
                grpc['viewers'] = obj['viewers'].map(e => {
                  return $root.com.wixpress.wixdocs.Viewer.toGRPC(e, helper);
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.QueryViewersByContentResponse();
              if (grpc['viewers'] != null) {
                result['viewers'] = grpc['viewers'].map(e => {
                  return $root.com.wixpress.wixdocs.Viewer.fromGRPC(e, helper);
                });
              } else {
                result['viewers'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(QueryViewersByContentResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.QueryViewersByContentResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(QueryViewersByContentResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.QueryViewersByContentResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(QueryViewersByContentResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(QueryViewersByContentResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return QueryViewersByContentResponse;
      }());;
      _wixdocs.UpdateAutoPublishRequest = (function () {
        class UpdateAutoPublishRequest {
          constructor(props) {
            this.id = props && props.id;
            this.autoPublish = props && props.autoPublish;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              if (obj['autoPublish'] != null) {
                json['autoPublish'] = obj['autoPublish'];
              } else if (withDefaults) {
                json['autoPublish'] = false;
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateAutoPublishRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              if (json['autoPublish'] != null) {
                result['autoPublish'] = json['autoPublish'];
              } else if (withDefaults !== false) {
                result['autoPublish'] = false;
              } else {
                delete result['autoPublish'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['autoPublish'] != null) {
                grpc['autoPublish'] = obj['autoPublish'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateAutoPublishRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              if (grpc['autoPublish'] != null) {
                result['autoPublish'] = grpc['autoPublish'];
              } else {
                result['autoPublish'] = false;
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateAutoPublishRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateAutoPublishRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateAutoPublishRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateAutoPublishRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateAutoPublishRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateAutoPublishRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateAutoPublishRequest;
      }());;
      _wixdocs.UpdateAutoPublishResponse = (function () {
        class UpdateAutoPublishResponse {
          constructor(props) {
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateAutoPublishResponse();
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateAutoPublishResponse();
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateAutoPublishResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateAutoPublishResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateAutoPublishResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateAutoPublishResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateAutoPublishResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateAutoPublishResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateAutoPublishResponse;
      }());;
      _wixdocs.UpdateViewersOrderRequest = (function () {
        class UpdateViewersOrderRequest {
          constructor(props) {
            this.viewersOrder = props && props.viewersOrder;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['viewersOrder'] != null) {
                json['viewersOrder'] = obj['viewersOrder'].map(e => {
                  return $root.com.wixpress.wixdocs.UpdateViewersOrderRequest.ViewerOrder.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['viewersOrder'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateViewersOrderRequest();
              if (json['viewersOrder'] != null) {
                result['viewersOrder'] = Array.isArray(json['viewersOrder']) ? json['viewersOrder'].map(e => {
                  return $root.com.wixpress.wixdocs.UpdateViewersOrderRequest.ViewerOrder.fromJSON(e, helper);
                }) : json['viewersOrder'];
              } else if (withDefaults !== false) {
                result['viewersOrder'] = [];
              } else {
                delete result['viewersOrder'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['viewersOrder'] != null) {
                grpc['viewersOrder'] = obj['viewersOrder'].map(e => {
                  return $root.com.wixpress.wixdocs.UpdateViewersOrderRequest.ViewerOrder.toGRPC(e, helper);
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateViewersOrderRequest();
              if (grpc['viewersOrder'] != null) {
                result['viewersOrder'] = grpc['viewersOrder'].map(e => {
                  return $root.com.wixpress.wixdocs.UpdateViewersOrderRequest.ViewerOrder.fromGRPC(e, helper);
                });
              } else {
                result['viewersOrder'] = [];
              }
              return result;
            }
          }
        }
        UpdateViewersOrderRequest.ViewerOrder = (function () {
          class ViewerOrder {
            constructor(props) {
              this.id = props && props.id;
              this.order = props && props.order;
            }
            static toJSON(obj, helper, withDefaults) {
              if (obj == null) {
                return null;
              } else {
                const json = {};
                if (obj['id'] != null) {
                  json['id'] = obj['id'];
                } else if (withDefaults) {
                  json['id'] = '';
                }
                if (obj['order'] != null) {
                  json['order'] = obj['order'];
                } else if (withDefaults) {
                  json['order'] = 0;
                }
                return json;
              }
            }
            static fromJSON(json, helper, withDefaults) {
              if (typeof json === 'object' && !Array.isArray(json)) {
                const result = new $root.com.wixpress.wixdocs.UpdateViewersOrderRequest.ViewerOrder();
                if (json['id'] != null) {
                  result['id'] = json['id'];
                } else if (withDefaults !== false) {
                  result['id'] = '';
                } else {
                  delete result['id'];
                }
                if (json['order'] != null) {
                  result['order'] = json['order'];
                } else if (withDefaults !== false) {
                  result['order'] = 0;
                } else {
                  delete result['order'];
                }
                return result;
              } else
                return json;
            }
            static toGRPC(obj, helper) {
              if (obj == null) {
                return null;
              } else {
                const grpc = {};
                if (obj['id'] != null) {
                  grpc['id'] = obj['id'];
                }
                if (obj['order'] != null) {
                  grpc['order'] = obj['order'];
                }
                return grpc;
              }
            }
            static fromGRPC(grpc, helper) {
              if (grpc == null) {
                return null;
              } else {
                const result = new $root.com.wixpress.wixdocs.UpdateViewersOrderRequest.ViewerOrder();
                if (grpc['id'] != null) {
                  result['id'] = grpc['id'];
                } else {
                  result['id'] = '';
                }
                if (grpc['order'] != null) {
                  result['order'] = grpc['order'];
                } else {
                  result['order'] = 0;
                }
                return result;
              }
            }
          }
          __builtIn.Object.defineProperty(ViewerOrder.prototype, '__proto', {
            value: pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateViewersOrderRequest.ViewerOrder');
            },
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(ViewerOrder.prototype, '__fqn__', {
            value: 'com.wixpress.wixdocs.UpdateViewersOrderRequest.ViewerOrder',
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(ViewerOrder.prototype, '__options__', {
            value: $root.__options,
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(ViewerOrder.prototype, '__root__', {
            value: $root,
            enumerable: false,
            configurable: false
          });
          return ViewerOrder;
        }());;
        UpdateViewersOrderRequest.ViewerOrder = (function () {
          class ViewerOrder {
            constructor(props) {
              this.id = props && props.id;
              this.order = props && props.order;
            }
            static toJSON(obj, helper, withDefaults) {
              if (obj == null) {
                return null;
              } else {
                const json = {};
                if (obj['id'] != null) {
                  json['id'] = obj['id'];
                } else if (withDefaults) {
                  json['id'] = '';
                }
                if (obj['order'] != null) {
                  json['order'] = obj['order'];
                } else if (withDefaults) {
                  json['order'] = 0;
                }
                return json;
              }
            }
            static fromJSON(json, helper, withDefaults) {
              if (typeof json === 'object' && !Array.isArray(json)) {
                const result = new $root.com.wixpress.wixdocs.UpdateViewersOrderRequest.ViewerOrder();
                if (json['id'] != null) {
                  result['id'] = json['id'];
                } else if (withDefaults !== false) {
                  result['id'] = '';
                } else {
                  delete result['id'];
                }
                if (json['order'] != null) {
                  result['order'] = json['order'];
                } else if (withDefaults !== false) {
                  result['order'] = 0;
                } else {
                  delete result['order'];
                }
                return result;
              } else
                return json;
            }
            static toGRPC(obj, helper) {
              if (obj == null) {
                return null;
              } else {
                const grpc = {};
                if (obj['id'] != null) {
                  grpc['id'] = obj['id'];
                }
                if (obj['order'] != null) {
                  grpc['order'] = obj['order'];
                }
                return grpc;
              }
            }
            static fromGRPC(grpc, helper) {
              if (grpc == null) {
                return null;
              } else {
                const result = new $root.com.wixpress.wixdocs.UpdateViewersOrderRequest.ViewerOrder();
                if (grpc['id'] != null) {
                  result['id'] = grpc['id'];
                } else {
                  result['id'] = '';
                }
                if (grpc['order'] != null) {
                  result['order'] = grpc['order'];
                } else {
                  result['order'] = 0;
                }
                return result;
              }
            }
          }
          __builtIn.Object.defineProperty(ViewerOrder.prototype, '__proto', {
            value: pbjs => {
              return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateViewersOrderRequest.ViewerOrder');
            },
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(ViewerOrder.prototype, '__fqn__', {
            value: 'com.wixpress.wixdocs.UpdateViewersOrderRequest.ViewerOrder',
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(ViewerOrder.prototype, '__options__', {
            value: $root.__options,
            enumerable: false,
            configurable: false
          });
          __builtIn.Object.defineProperty(ViewerOrder.prototype, '__root__', {
            value: $root,
            enumerable: false,
            configurable: false
          });
          return ViewerOrder;
        }());;
        __builtIn.Object.defineProperty(UpdateViewersOrderRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateViewersOrderRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewersOrderRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateViewersOrderRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewersOrderRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewersOrderRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateViewersOrderRequest;
      }());;
      _wixdocs.UpdateViewersOrderResponse = (function () {
        class UpdateViewersOrderResponse {
          constructor(props) {
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateViewersOrderResponse();
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateViewersOrderResponse();
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateViewersOrderResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateViewersOrderResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewersOrderResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateViewersOrderResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewersOrderResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewersOrderResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateViewersOrderResponse;
      }());;
      _wixdocs.UpdateViewerVisibilityRequest = (function () {
        class UpdateViewerVisibilityRequest {
          constructor(props) {
            this.id = props && props.id;
            this.visibility = props && props.visibility;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              if (obj['visibility'] != null) {
                json['visibility'] = obj['visibility'];
              } else if (withDefaults) {
                json['visibility'] = false;
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateViewerVisibilityRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              if (json['visibility'] != null) {
                result['visibility'] = json['visibility'];
              } else if (withDefaults !== false) {
                result['visibility'] = false;
              } else {
                delete result['visibility'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['visibility'] != null) {
                grpc['visibility'] = obj['visibility'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateViewerVisibilityRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              if (grpc['visibility'] != null) {
                result['visibility'] = grpc['visibility'];
              } else {
                result['visibility'] = false;
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateViewerVisibilityRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateViewerVisibilityRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerVisibilityRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateViewerVisibilityRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerVisibilityRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerVisibilityRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateViewerVisibilityRequest;
      }());;
      _wixdocs.UpdateViewerVisibilityResponse = (function () {
        class UpdateViewerVisibilityResponse {
          constructor(props) {
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateViewerVisibilityResponse();
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateViewerVisibilityResponse();
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateViewerVisibilityResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateViewerVisibilityResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerVisibilityResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateViewerVisibilityResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerVisibilityResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerVisibilityResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateViewerVisibilityResponse;
      }());;
      _wixdocs.AddToEmailListRequest = (function () {
        class AddToEmailListRequest {
          constructor(props) {
            this.id = props && props.id;
            this.emailList = props && props.emailList;
            this.shouldOverride = props && props.shouldOverride;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              if (obj['emailList'] != null) {
                json['emailList'] = obj['emailList'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['emailList'] = [];
              }
              if (obj['shouldOverride'] != null) {
                json['shouldOverride'] = obj['shouldOverride'];
              } else if (withDefaults) {
                json['shouldOverride'] = false;
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.AddToEmailListRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              if (json['emailList'] != null) {
                result['emailList'] = Array.isArray(json['emailList']) ? json['emailList'].map(e => {
                  return e;
                }) : json['emailList'];
              } else if (withDefaults !== false) {
                result['emailList'] = [];
              } else {
                delete result['emailList'];
              }
              if (json['shouldOverride'] != null) {
                result['shouldOverride'] = json['shouldOverride'];
              } else if (withDefaults !== false) {
                result['shouldOverride'] = false;
              } else {
                delete result['shouldOverride'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['emailList'] != null) {
                grpc['emailList'] = obj['emailList'].map(e => {
                  return e;
                });
              }
              if (obj['shouldOverride'] != null) {
                grpc['shouldOverride'] = obj['shouldOverride'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.AddToEmailListRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              if (grpc['emailList'] != null) {
                result['emailList'] = grpc['emailList'].map(e => {
                  return e;
                });
              } else {
                result['emailList'] = [];
              }
              if (grpc['shouldOverride'] != null) {
                result['shouldOverride'] = grpc['shouldOverride'];
              } else {
                result['shouldOverride'] = false;
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(AddToEmailListRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.AddToEmailListRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(AddToEmailListRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.AddToEmailListRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(AddToEmailListRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(AddToEmailListRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return AddToEmailListRequest;
      }());;
      _wixdocs.AddToEmailListResponse = (function () {
        class AddToEmailListResponse {
          constructor(props) {
            this.emailList = props && props.emailList;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['emailList'] != null) {
                json['emailList'] = obj['emailList'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['emailList'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.AddToEmailListResponse();
              if (json['emailList'] != null) {
                result['emailList'] = Array.isArray(json['emailList']) ? json['emailList'].map(e => {
                  return e;
                }) : json['emailList'];
              } else if (withDefaults !== false) {
                result['emailList'] = [];
              } else {
                delete result['emailList'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['emailList'] != null) {
                grpc['emailList'] = obj['emailList'].map(e => {
                  return e;
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.AddToEmailListResponse();
              if (grpc['emailList'] != null) {
                result['emailList'] = grpc['emailList'].map(e => {
                  return e;
                });
              } else {
                result['emailList'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(AddToEmailListResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.AddToEmailListResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(AddToEmailListResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.AddToEmailListResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(AddToEmailListResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(AddToEmailListResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return AddToEmailListResponse;
      }());;
      _wixdocs.RemoveEmailsFromListRequest = (function () {
        class RemoveEmailsFromListRequest {
          constructor(props) {
            this.id = props && props.id;
            this.emailList = props && props.emailList;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              if (obj['emailList'] != null) {
                json['emailList'] = obj['emailList'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['emailList'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.RemoveEmailsFromListRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              if (json['emailList'] != null) {
                result['emailList'] = Array.isArray(json['emailList']) ? json['emailList'].map(e => {
                  return e;
                }) : json['emailList'];
              } else if (withDefaults !== false) {
                result['emailList'] = [];
              } else {
                delete result['emailList'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['emailList'] != null) {
                grpc['emailList'] = obj['emailList'].map(e => {
                  return e;
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.RemoveEmailsFromListRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              if (grpc['emailList'] != null) {
                result['emailList'] = grpc['emailList'].map(e => {
                  return e;
                });
              } else {
                result['emailList'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(RemoveEmailsFromListRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.RemoveEmailsFromListRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(RemoveEmailsFromListRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.RemoveEmailsFromListRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(RemoveEmailsFromListRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(RemoveEmailsFromListRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return RemoveEmailsFromListRequest;
      }());;
      _wixdocs.RemoveEmailsFromListResponse = (function () {
        class RemoveEmailsFromListResponse {
          constructor(props) {
            this.emailList = props && props.emailList;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['emailList'] != null) {
                json['emailList'] = obj['emailList'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['emailList'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.RemoveEmailsFromListResponse();
              if (json['emailList'] != null) {
                result['emailList'] = Array.isArray(json['emailList']) ? json['emailList'].map(e => {
                  return e;
                }) : json['emailList'];
              } else if (withDefaults !== false) {
                result['emailList'] = [];
              } else {
                delete result['emailList'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['emailList'] != null) {
                grpc['emailList'] = obj['emailList'].map(e => {
                  return e;
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.RemoveEmailsFromListResponse();
              if (grpc['emailList'] != null) {
                result['emailList'] = grpc['emailList'].map(e => {
                  return e;
                });
              } else {
                result['emailList'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(RemoveEmailsFromListResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.RemoveEmailsFromListResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(RemoveEmailsFromListResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.RemoveEmailsFromListResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(RemoveEmailsFromListResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(RemoveEmailsFromListResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return RemoveEmailsFromListResponse;
      }());;
      _wixdocs.DeployContentRequest = (function () {
        class DeployContentRequest {
          constructor(props) {
            this.viewerId = props && props.viewerId;
            this.releaseNote = props && props.releaseNote;
            this.branch = props && props.branch;
            this.bumpType = props && props.bumpType;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['viewerId'] != null) {
                json['viewerId'] = obj['viewerId'];
              } else if (withDefaults) {
                json['viewerId'] = '';
              }
              if (obj['releaseNote'] != null) {
                json['releaseNote'] = obj['releaseNote'];
              } else if (withDefaults) {
                json['releaseNote'] = '';
              }
              if (obj['branch'] != null) {
                json['branch'] = $root.google.protobuf.StringValue.toJSON(obj['branch'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['branch'];
              }
              if (obj['bumpType'] != null) {
                json['bumpType'] = $root.com.wixpress.wixdocs.Version.BumpType[obj['bumpType']];
              } else if (withDefaults) {
                json['bumpType'] = 'patch';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.DeployContentRequest();
              if (json['viewerId'] != null) {
                result['viewerId'] = json['viewerId'];
              } else if (withDefaults !== false) {
                result['viewerId'] = '';
              } else {
                delete result['viewerId'];
              }
              if (json['releaseNote'] != null) {
                result['releaseNote'] = json['releaseNote'];
              } else if (withDefaults !== false) {
                result['releaseNote'] = '';
              } else {
                delete result['releaseNote'];
              }
              if (json['branch'] != null) {
                result['branch'] = $root.google.protobuf.StringValue.fromJSON(json['branch'], helper);
              } else if (withDefaults !== false) {
                delete result['branch'];
              } else {
                delete result['branch'];
              }
              if (json['bumpType'] != null) {
                result['bumpType'] = typeof json['bumpType'] === 'string' ? json['bumpType'] : $root.com.wixpress.wixdocs.Version.BumpType[json['bumpType']];
              } else if (withDefaults !== false) {
                result['bumpType'] = 'patch';
              } else {
                delete result['bumpType'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['viewerId'] != null) {
                grpc['viewerId'] = obj['viewerId'];
              }
              if (obj['releaseNote'] != null) {
                grpc['releaseNote'] = obj['releaseNote'];
              }
              if (obj['branch'] != null) {
                grpc['branch'] = $root.google.protobuf.StringValue.toGRPC(obj['branch'], helper);
              }
              if (obj['bumpType'] != null) {
                grpc['bumpType'] = obj['bumpType'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.DeployContentRequest();
              if (grpc['viewerId'] != null) {
                result['viewerId'] = grpc['viewerId'];
              } else {
                result['viewerId'] = '';
              }
              if (grpc['releaseNote'] != null) {
                result['releaseNote'] = grpc['releaseNote'];
              } else {
                result['releaseNote'] = '';
              }
              if (grpc['branch'] != null) {
                result['branch'] = $root.google.protobuf.StringValue.fromGRPC(grpc['branch'], helper);
              } else {
                delete result['branch'];
              }
              if (grpc['bumpType'] != null) {
                result['bumpType'] = grpc['bumpType'];
              } else {
                result['bumpType'] = 'patch';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(DeployContentRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.DeployContentRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DeployContentRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.DeployContentRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DeployContentRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DeployContentRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return DeployContentRequest;
      }());;
      _wixdocs.DeployContentResponse = (function () {
        class DeployContentResponse {
          constructor(props) {
            this.version = props && props.version;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['version'] != null) {
                json['version'] = $root.com.wixpress.wixdocs.Version.toJSON(obj['version'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['version'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.DeployContentResponse();
              if (json['version'] != null) {
                result['version'] = $root.com.wixpress.wixdocs.Version.fromJSON(json['version'], helper);
              } else if (withDefaults !== false) {
                delete result['version'];
              } else {
                delete result['version'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['version'] != null) {
                grpc['version'] = $root.com.wixpress.wixdocs.Version.toGRPC(obj['version'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.DeployContentResponse();
              if (grpc['version'] != null) {
                result['version'] = $root.com.wixpress.wixdocs.Version.fromGRPC(grpc['version'], helper);
              } else {
                delete result['version'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(DeployContentResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.DeployContentResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DeployContentResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.DeployContentResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DeployContentResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DeployContentResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return DeployContentResponse;
      }());;
      _wixdocs.QueryViewerRequest = (function () {
        class QueryViewerRequest {
          constructor(props) {
            this.viewerFilter = props && props.viewerFilter;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['viewerFilter'] != null) {
                json['viewerFilter'] = $root.com.wixpress.wixdocs.ViewerFilter.toJSON(obj['viewerFilter'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['viewerFilter'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.QueryViewerRequest();
              if (json['viewerFilter'] != null) {
                result['viewerFilter'] = $root.com.wixpress.wixdocs.ViewerFilter.fromJSON(json['viewerFilter'], helper);
              } else if (withDefaults !== false) {
                delete result['viewerFilter'];
              } else {
                delete result['viewerFilter'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['viewerFilter'] != null) {
                grpc['viewerFilter'] = $root.com.wixpress.wixdocs.ViewerFilter.toGRPC(obj['viewerFilter'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.QueryViewerRequest();
              if (grpc['viewerFilter'] != null) {
                result['viewerFilter'] = $root.com.wixpress.wixdocs.ViewerFilter.fromGRPC(grpc['viewerFilter'], helper);
              } else {
                delete result['viewerFilter'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(QueryViewerRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.QueryViewerRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(QueryViewerRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.QueryViewerRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(QueryViewerRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(QueryViewerRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return QueryViewerRequest;
      }());;
      _wixdocs.QueryViewerResponse = (function () {
        class QueryViewerResponse {
          constructor(props) {
            this.viewer = props && props.viewer;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['viewer'] != null) {
                json['viewer'] = $root.com.wixpress.wixdocs.Viewer.toJSON(obj['viewer'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['viewer'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.QueryViewerResponse();
              if (json['viewer'] != null) {
                result['viewer'] = $root.com.wixpress.wixdocs.Viewer.fromJSON(json['viewer'], helper);
              } else if (withDefaults !== false) {
                delete result['viewer'];
              } else {
                delete result['viewer'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['viewer'] != null) {
                grpc['viewer'] = $root.com.wixpress.wixdocs.Viewer.toGRPC(obj['viewer'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.QueryViewerResponse();
              if (grpc['viewer'] != null) {
                result['viewer'] = $root.com.wixpress.wixdocs.Viewer.fromGRPC(grpc['viewer'], helper);
              } else {
                delete result['viewer'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(QueryViewerResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.QueryViewerResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(QueryViewerResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.QueryViewerResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(QueryViewerResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(QueryViewerResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return QueryViewerResponse;
      }());;
      _wixdocs.UpdateViewerRequest = (function () {
        class UpdateViewerRequest {
          constructor(props) {
            this.id = props && props.id;
            this.viewerUpdater = props && props.viewerUpdater;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              if (obj['viewerUpdater'] != null) {
                json['viewerUpdater'] = $root.com.wixpress.wixdocs.ViewerUpdater.toJSON(obj['viewerUpdater'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['viewerUpdater'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateViewerRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              if (json['viewerUpdater'] != null) {
                result['viewerUpdater'] = $root.com.wixpress.wixdocs.ViewerUpdater.fromJSON(json['viewerUpdater'], helper);
              } else if (withDefaults !== false) {
                delete result['viewerUpdater'];
              } else {
                delete result['viewerUpdater'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['viewerUpdater'] != null) {
                grpc['viewerUpdater'] = $root.com.wixpress.wixdocs.ViewerUpdater.toGRPC(obj['viewerUpdater'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateViewerRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              if (grpc['viewerUpdater'] != null) {
                result['viewerUpdater'] = $root.com.wixpress.wixdocs.ViewerUpdater.fromGRPC(grpc['viewerUpdater'], helper);
              } else {
                delete result['viewerUpdater'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateViewerRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateViewerRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateViewerRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateViewerRequest;
      }());;
      _wixdocs.UpdateViewerResponse = (function () {
        class UpdateViewerResponse {
          constructor(props) {
            this.viewer = props && props.viewer;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['viewer'] != null) {
                json['viewer'] = $root.com.wixpress.wixdocs.Viewer.toJSON(obj['viewer'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['viewer'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateViewerResponse();
              if (json['viewer'] != null) {
                result['viewer'] = $root.com.wixpress.wixdocs.Viewer.fromJSON(json['viewer'], helper);
              } else if (withDefaults !== false) {
                delete result['viewer'];
              } else {
                delete result['viewer'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['viewer'] != null) {
                grpc['viewer'] = $root.com.wixpress.wixdocs.Viewer.toGRPC(obj['viewer'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateViewerResponse();
              if (grpc['viewer'] != null) {
                result['viewer'] = $root.com.wixpress.wixdocs.Viewer.fromGRPC(grpc['viewer'], helper);
              } else {
                delete result['viewer'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateViewerResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateViewerResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateViewerResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateViewerResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateViewerResponse;
      }());;
      _wixdocs.UpdateServiceJsonFormatRequest = (function () {
        class UpdateServiceJsonFormatRequest {
          constructor(props) {
            this.id = props && props.id;
            this.serviceJsonFormat = props && props.serviceJsonFormat;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = obj['id'];
              } else if (withDefaults) {
                json['id'] = '';
              }
              if (obj['serviceJsonFormat'] != null) {
                json['serviceJsonFormat'] = $root.com.wixpress.wixdocs.Viewer.ServiceJsonFormat[obj['serviceJsonFormat']];
              } else if (withDefaults) {
                json['serviceJsonFormat'] = 'NONE';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateServiceJsonFormatRequest();
              if (json['id'] != null) {
                result['id'] = json['id'];
              } else if (withDefaults !== false) {
                result['id'] = '';
              } else {
                delete result['id'];
              }
              if (json['serviceJsonFormat'] != null) {
                result['serviceJsonFormat'] = typeof json['serviceJsonFormat'] === 'string' ? json['serviceJsonFormat'] : $root.com.wixpress.wixdocs.Viewer.ServiceJsonFormat[json['serviceJsonFormat']];
              } else if (withDefaults !== false) {
                result['serviceJsonFormat'] = 'NONE';
              } else {
                delete result['serviceJsonFormat'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = obj['id'];
              }
              if (obj['serviceJsonFormat'] != null) {
                grpc['serviceJsonFormat'] = obj['serviceJsonFormat'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateServiceJsonFormatRequest();
              if (grpc['id'] != null) {
                result['id'] = grpc['id'];
              } else {
                result['id'] = '';
              }
              if (grpc['serviceJsonFormat'] != null) {
                result['serviceJsonFormat'] = grpc['serviceJsonFormat'];
              } else {
                result['serviceJsonFormat'] = 'NONE';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateServiceJsonFormatRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateServiceJsonFormatRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateServiceJsonFormatRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateServiceJsonFormatRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateServiceJsonFormatRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateServiceJsonFormatRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateServiceJsonFormatRequest;
      }());;
      _wixdocs.UpdateServiceJsonFormatResponse = (function () {
        class UpdateServiceJsonFormatResponse {
          constructor(props) {
            this.serviceJsonFormat = props && props.serviceJsonFormat;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['serviceJsonFormat'] != null) {
                json['serviceJsonFormat'] = $root.com.wixpress.wixdocs.Viewer.ServiceJsonFormat[obj['serviceJsonFormat']];
              } else if (withDefaults) {
                json['serviceJsonFormat'] = 'NONE';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UpdateServiceJsonFormatResponse();
              if (json['serviceJsonFormat'] != null) {
                result['serviceJsonFormat'] = typeof json['serviceJsonFormat'] === 'string' ? json['serviceJsonFormat'] : $root.com.wixpress.wixdocs.Viewer.ServiceJsonFormat[json['serviceJsonFormat']];
              } else if (withDefaults !== false) {
                result['serviceJsonFormat'] = 'NONE';
              } else {
                delete result['serviceJsonFormat'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['serviceJsonFormat'] != null) {
                grpc['serviceJsonFormat'] = obj['serviceJsonFormat'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UpdateServiceJsonFormatResponse();
              if (grpc['serviceJsonFormat'] != null) {
                result['serviceJsonFormat'] = grpc['serviceJsonFormat'];
              } else {
                result['serviceJsonFormat'] = 'NONE';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UpdateServiceJsonFormatResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UpdateServiceJsonFormatResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateServiceJsonFormatResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UpdateServiceJsonFormatResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateServiceJsonFormatResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UpdateServiceJsonFormatResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UpdateServiceJsonFormatResponse;
      }());;
      _wixdocs.Service = (function () {
        class Service {
          constructor(props) {
            this.name = props && props.name;
            this.memberOf = props && props.memberOf;
            this.mixes = props && props.mixes;
            this.labels = props && props.labels;
            this.location = props && props.location;
            this.docs = props && props.docs;
            this.properties = props && props.properties;
            this.operations = props && props.operations;
            this.clientEvents = props && props.clientEvents;
            this.callbacks = props && props.callbacks;
            this.messages = props && props.messages;
            this.relatedContent = props && props.relatedContent;
            this.FAQs = props && props.FAQs;
            this.tags = props && props.tags;
            this.relatedGuides = props && props.relatedGuides;
            this.events = props && props.events;
            this.extra = props && props.extra;
            this.clientId = props && props.clientId;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['name'] != null) {
                json['name'] = obj['name'];
              } else if (withDefaults) {
                json['name'] = '';
              }
              if (obj['memberOf'] != null) {
                json['memberOf'] = $root.google.protobuf.StringValue.toJSON(obj['memberOf'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['memberOf'];
              }
              if (obj['mixes'] != null) {
                json['mixes'] = obj['mixes'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['mixes'] = [];
              }
              if (obj['labels'] != null) {
                json['labels'] = obj['labels'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['labels'] = [];
              }
              if (obj['location'] != null) {
                json['location'] = $root.com.wixpress.wixdocs.CodeLocation.toJSON(obj['location'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['location'];
              }
              if (obj['docs'] != null) {
                json['docs'] = $root.com.wixpress.wixdocs.Docs.toJSON(obj['docs'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['docs'];
              }
              if (obj['properties'] != null) {
                json['properties'] = obj['properties'].map(e => {
                  return $root.com.wixpress.wixdocs.Property.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['properties'] = [];
              }
              if (obj['operations'] != null) {
                json['operations'] = obj['operations'].map(e => {
                  return $root.com.wixpress.wixdocs.Operation.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['operations'] = [];
              }
              if (obj['clientEvents'] != null) {
                json['clientEvents'] = obj['clientEvents'].map(e => {
                  return $root.com.wixpress.wixdocs.Operation.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['clientEvents'] = [];
              }
              if (obj['callbacks'] != null) {
                json['callbacks'] = obj['callbacks'].map(e => {
                  return $root.com.wixpress.wixdocs.Operation.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['callbacks'] = [];
              }
              if (obj['messages'] != null) {
                json['messages'] = obj['messages'].map(e => {
                  return $root.com.wixpress.wixdocs.Message.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['messages'] = [];
              }
              if (obj['relatedContent'] != null) {
                json['relatedContent'] = obj['relatedContent'].map(e => {
                  return $root.com.wixpress.wixdocs.RelatedContent.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['relatedContent'] = [];
              }
              if (obj['FAQs'] != null) {
                json['FAQs'] = obj['FAQs'].map(e => {
                  return $root.com.wixpress.wixdocs.FAQ.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['FAQs'] = [];
              }
              if (obj['tags'] != null) {
                json['tags'] = obj['tags'].map(e => {
                  return $root.com.wixpress.wixdocs.Tag.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['tags'] = [];
              }
              if (obj['relatedGuides'] != null) {
                json['relatedGuides'] = obj['relatedGuides'].map(e => {
                  return $root.com.wixpress.wixdocs.RelatedGuide.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['relatedGuides'] = [];
              }
              if (obj['events'] != null) {
                json['events'] = obj['events'].map(e => {
                  return $root.com.wixpress.wixdocs.Event.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['events'] = [];
              }
              if (obj['extra'] != null) {
                json['extra'] = $root.google.protobuf.Struct.toJSON(obj['extra'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['extra'];
              }
              if (obj['clientId'] != null) {
                json['clientId'] = $root.google.protobuf.StringValue.toJSON(obj['clientId'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['clientId'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.Service();
              if (json['name'] != null) {
                result['name'] = json['name'];
              } else if (withDefaults !== false) {
                result['name'] = '';
              } else {
                delete result['name'];
              }
              if (json['memberOf'] != null) {
                result['memberOf'] = $root.google.protobuf.StringValue.fromJSON(json['memberOf'], helper);
              } else if (withDefaults !== false) {
                delete result['memberOf'];
              } else {
                delete result['memberOf'];
              }
              if (json['mixes'] != null) {
                result['mixes'] = Array.isArray(json['mixes']) ? json['mixes'].map(e => {
                  return e;
                }) : json['mixes'];
              } else if (withDefaults !== false) {
                result['mixes'] = [];
              } else {
                delete result['mixes'];
              }
              if (json['labels'] != null) {
                result['labels'] = Array.isArray(json['labels']) ? json['labels'].map(e => {
                  return e;
                }) : json['labels'];
              } else if (withDefaults !== false) {
                result['labels'] = [];
              } else {
                delete result['labels'];
              }
              if (json['location'] != null) {
                result['location'] = $root.com.wixpress.wixdocs.CodeLocation.fromJSON(json['location'], helper);
              } else if (withDefaults !== false) {
                delete result['location'];
              } else {
                delete result['location'];
              }
              if (json['docs'] != null) {
                result['docs'] = $root.com.wixpress.wixdocs.Docs.fromJSON(json['docs'], helper);
              } else if (withDefaults !== false) {
                delete result['docs'];
              } else {
                delete result['docs'];
              }
              if (json['properties'] != null) {
                result['properties'] = Array.isArray(json['properties']) ? json['properties'].map(e => {
                  return $root.com.wixpress.wixdocs.Property.fromJSON(e, helper);
                }) : json['properties'];
              } else if (withDefaults !== false) {
                result['properties'] = [];
              } else {
                delete result['properties'];
              }
              if (json['operations'] != null) {
                result['operations'] = Array.isArray(json['operations']) ? json['operations'].map(e => {
                  return $root.com.wixpress.wixdocs.Operation.fromJSON(e, helper);
                }) : json['operations'];
              } else if (withDefaults !== false) {
                result['operations'] = [];
              } else {
                delete result['operations'];
              }
              if (json['clientEvents'] != null) {
                result['clientEvents'] = Array.isArray(json['clientEvents']) ? json['clientEvents'].map(e => {
                  return $root.com.wixpress.wixdocs.Operation.fromJSON(e, helper);
                }) : json['clientEvents'];
              } else if (withDefaults !== false) {
                result['clientEvents'] = [];
              } else {
                delete result['clientEvents'];
              }
              if (json['callbacks'] != null) {
                result['callbacks'] = Array.isArray(json['callbacks']) ? json['callbacks'].map(e => {
                  return $root.com.wixpress.wixdocs.Operation.fromJSON(e, helper);
                }) : json['callbacks'];
              } else if (withDefaults !== false) {
                result['callbacks'] = [];
              } else {
                delete result['callbacks'];
              }
              if (json['messages'] != null) {
                result['messages'] = Array.isArray(json['messages']) ? json['messages'].map(e => {
                  return $root.com.wixpress.wixdocs.Message.fromJSON(e, helper);
                }) : json['messages'];
              } else if (withDefaults !== false) {
                result['messages'] = [];
              } else {
                delete result['messages'];
              }
              if (json['relatedContent'] != null) {
                result['relatedContent'] = Array.isArray(json['relatedContent']) ? json['relatedContent'].map(e => {
                  return $root.com.wixpress.wixdocs.RelatedContent.fromJSON(e, helper);
                }) : json['relatedContent'];
              } else if (withDefaults !== false) {
                result['relatedContent'] = [];
              } else {
                delete result['relatedContent'];
              }
              if (json['FAQs'] != null) {
                result['FAQs'] = Array.isArray(json['FAQs']) ? json['FAQs'].map(e => {
                  return $root.com.wixpress.wixdocs.FAQ.fromJSON(e, helper);
                }) : json['FAQs'];
              } else if (withDefaults !== false) {
                result['FAQs'] = [];
              } else {
                delete result['FAQs'];
              }
              if (json['tags'] != null) {
                result['tags'] = Array.isArray(json['tags']) ? json['tags'].map(e => {
                  return $root.com.wixpress.wixdocs.Tag.fromJSON(e, helper);
                }) : json['tags'];
              } else if (withDefaults !== false) {
                result['tags'] = [];
              } else {
                delete result['tags'];
              }
              if (json['relatedGuides'] != null) {
                result['relatedGuides'] = Array.isArray(json['relatedGuides']) ? json['relatedGuides'].map(e => {
                  return $root.com.wixpress.wixdocs.RelatedGuide.fromJSON(e, helper);
                }) : json['relatedGuides'];
              } else if (withDefaults !== false) {
                result['relatedGuides'] = [];
              } else {
                delete result['relatedGuides'];
              }
              if (json['events'] != null) {
                result['events'] = Array.isArray(json['events']) ? json['events'].map(e => {
                  return $root.com.wixpress.wixdocs.Event.fromJSON(e, helper);
                }) : json['events'];
              } else if (withDefaults !== false) {
                result['events'] = [];
              } else {
                delete result['events'];
              }
              if (json['extra'] != null) {
                result['extra'] = $root.google.protobuf.Struct.fromJSON(json['extra'], helper);
              } else if (withDefaults !== false) {
                delete result['extra'];
              } else {
                delete result['extra'];
              }
              if (json['clientId'] != null) {
                result['clientId'] = $root.google.protobuf.StringValue.fromJSON(json['clientId'], helper);
              } else if (withDefaults !== false) {
                delete result['clientId'];
              } else {
                delete result['clientId'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['name'] != null) {
                grpc['name'] = obj['name'];
              }
              if (obj['memberOf'] != null) {
                grpc['memberOf'] = $root.google.protobuf.StringValue.toGRPC(obj['memberOf'], helper);
              }
              if (obj['mixes'] != null) {
                grpc['mixes'] = obj['mixes'].map(e => {
                  return e;
                });
              }
              if (obj['labels'] != null) {
                grpc['labels'] = obj['labels'].map(e => {
                  return e;
                });
              }
              if (obj['location'] != null) {
                grpc['location'] = $root.com.wixpress.wixdocs.CodeLocation.toGRPC(obj['location'], helper);
              }
              if (obj['docs'] != null) {
                grpc['docs'] = $root.com.wixpress.wixdocs.Docs.toGRPC(obj['docs'], helper);
              }
              if (obj['properties'] != null) {
                grpc['properties'] = obj['properties'].map(e => {
                  return $root.com.wixpress.wixdocs.Property.toGRPC(e, helper);
                });
              }
              if (obj['operations'] != null) {
                grpc['operations'] = obj['operations'].map(e => {
                  return $root.com.wixpress.wixdocs.Operation.toGRPC(e, helper);
                });
              }
              if (obj['clientEvents'] != null) {
                grpc['clientEvents'] = obj['clientEvents'].map(e => {
                  return $root.com.wixpress.wixdocs.Operation.toGRPC(e, helper);
                });
              }
              if (obj['callbacks'] != null) {
                grpc['callbacks'] = obj['callbacks'].map(e => {
                  return $root.com.wixpress.wixdocs.Operation.toGRPC(e, helper);
                });
              }
              if (obj['messages'] != null) {
                grpc['messages'] = obj['messages'].map(e => {
                  return $root.com.wixpress.wixdocs.Message.toGRPC(e, helper);
                });
              }
              if (obj['relatedContent'] != null) {
                grpc['relatedContent'] = obj['relatedContent'].map(e => {
                  return $root.com.wixpress.wixdocs.RelatedContent.toGRPC(e, helper);
                });
              }
              if (obj['FAQs'] != null) {
                grpc['FAQs'] = obj['FAQs'].map(e => {
                  return $root.com.wixpress.wixdocs.FAQ.toGRPC(e, helper);
                });
              }
              if (obj['tags'] != null) {
                grpc['tags'] = obj['tags'].map(e => {
                  return $root.com.wixpress.wixdocs.Tag.toGRPC(e, helper);
                });
              }
              if (obj['relatedGuides'] != null) {
                grpc['relatedGuides'] = obj['relatedGuides'].map(e => {
                  return $root.com.wixpress.wixdocs.RelatedGuide.toGRPC(e, helper);
                });
              }
              if (obj['events'] != null) {
                grpc['events'] = obj['events'].map(e => {
                  return $root.com.wixpress.wixdocs.Event.toGRPC(e, helper);
                });
              }
              if (obj['extra'] != null) {
                grpc['extra'] = $root.google.protobuf.Struct.toGRPC(obj['extra'], helper);
              }
              if (obj['clientId'] != null) {
                grpc['clientId'] = $root.google.protobuf.StringValue.toGRPC(obj['clientId'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.Service();
              if (grpc['name'] != null) {
                result['name'] = grpc['name'];
              } else {
                result['name'] = '';
              }
              if (grpc['memberOf'] != null) {
                result['memberOf'] = $root.google.protobuf.StringValue.fromGRPC(grpc['memberOf'], helper);
              } else {
                delete result['memberOf'];
              }
              if (grpc['mixes'] != null) {
                result['mixes'] = grpc['mixes'].map(e => {
                  return e;
                });
              } else {
                result['mixes'] = [];
              }
              if (grpc['labels'] != null) {
                result['labels'] = grpc['labels'].map(e => {
                  return e;
                });
              } else {
                result['labels'] = [];
              }
              if (grpc['location'] != null) {
                result['location'] = $root.com.wixpress.wixdocs.CodeLocation.fromGRPC(grpc['location'], helper);
              } else {
                delete result['location'];
              }
              if (grpc['docs'] != null) {
                result['docs'] = $root.com.wixpress.wixdocs.Docs.fromGRPC(grpc['docs'], helper);
              } else {
                delete result['docs'];
              }
              if (grpc['properties'] != null) {
                result['properties'] = grpc['properties'].map(e => {
                  return $root.com.wixpress.wixdocs.Property.fromGRPC(e, helper);
                });
              } else {
                result['properties'] = [];
              }
              if (grpc['operations'] != null) {
                result['operations'] = grpc['operations'].map(e => {
                  return $root.com.wixpress.wixdocs.Operation.fromGRPC(e, helper);
                });
              } else {
                result['operations'] = [];
              }
              if (grpc['clientEvents'] != null) {
                result['clientEvents'] = grpc['clientEvents'].map(e => {
                  return $root.com.wixpress.wixdocs.Operation.fromGRPC(e, helper);
                });
              } else {
                result['clientEvents'] = [];
              }
              if (grpc['callbacks'] != null) {
                result['callbacks'] = grpc['callbacks'].map(e => {
                  return $root.com.wixpress.wixdocs.Operation.fromGRPC(e, helper);
                });
              } else {
                result['callbacks'] = [];
              }
              if (grpc['messages'] != null) {
                result['messages'] = grpc['messages'].map(e => {
                  return $root.com.wixpress.wixdocs.Message.fromGRPC(e, helper);
                });
              } else {
                result['messages'] = [];
              }
              if (grpc['relatedContent'] != null) {
                result['relatedContent'] = grpc['relatedContent'].map(e => {
                  return $root.com.wixpress.wixdocs.RelatedContent.fromGRPC(e, helper);
                });
              } else {
                result['relatedContent'] = [];
              }
              if (grpc['FAQs'] != null) {
                result['FAQs'] = grpc['FAQs'].map(e => {
                  return $root.com.wixpress.wixdocs.FAQ.fromGRPC(e, helper);
                });
              } else {
                result['FAQs'] = [];
              }
              if (grpc['tags'] != null) {
                result['tags'] = grpc['tags'].map(e => {
                  return $root.com.wixpress.wixdocs.Tag.fromGRPC(e, helper);
                });
              } else {
                result['tags'] = [];
              }
              if (grpc['relatedGuides'] != null) {
                result['relatedGuides'] = grpc['relatedGuides'].map(e => {
                  return $root.com.wixpress.wixdocs.RelatedGuide.fromGRPC(e, helper);
                });
              } else {
                result['relatedGuides'] = [];
              }
              if (grpc['events'] != null) {
                result['events'] = grpc['events'].map(e => {
                  return $root.com.wixpress.wixdocs.Event.fromGRPC(e, helper);
                });
              } else {
                result['events'] = [];
              }
              if (grpc['extra'] != null) {
                result['extra'] = $root.google.protobuf.Struct.fromGRPC(grpc['extra'], helper);
              } else {
                delete result['extra'];
              }
              if (grpc['clientId'] != null) {
                result['clientId'] = $root.google.protobuf.StringValue.fromGRPC(grpc['clientId'], helper);
              } else {
                delete result['clientId'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(Service.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.Service');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Service.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.Service',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Service.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Service.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return Service;
      }());;
      _wixdocs.Extra = (function () {
        class Extra {
          constructor(props) {
            this.eventType = props && props.eventType;
            this.queryable = props && props.queryable;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['eventType'] != null) {
                json['eventType'] = $root.google.protobuf.StringValue.toJSON(obj['eventType'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['eventType'];
              }
              if (obj['queryable'] != null) {
                json['queryable'] = $root.google.protobuf.BoolValue.toJSON(obj['queryable'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['queryable'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.Extra();
              if (json['eventType'] != null) {
                result['eventType'] = $root.google.protobuf.StringValue.fromJSON(json['eventType'], helper);
              } else if (withDefaults !== false) {
                delete result['eventType'];
              } else {
                delete result['eventType'];
              }
              if (json['queryable'] != null) {
                result['queryable'] = $root.google.protobuf.BoolValue.fromJSON(json['queryable'], helper);
              } else if (withDefaults !== false) {
                delete result['queryable'];
              } else {
                delete result['queryable'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['eventType'] != null) {
                grpc['eventType'] = $root.google.protobuf.StringValue.toGRPC(obj['eventType'], helper);
              }
              if (obj['queryable'] != null) {
                grpc['queryable'] = $root.google.protobuf.BoolValue.toGRPC(obj['queryable'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.Extra();
              if (grpc['eventType'] != null) {
                result['eventType'] = $root.google.protobuf.StringValue.fromGRPC(grpc['eventType'], helper);
              } else {
                delete result['eventType'];
              }
              if (grpc['queryable'] != null) {
                result['queryable'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['queryable'], helper);
              } else {
                delete result['queryable'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(Extra.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.Extra');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Extra.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.Extra',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Extra.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Extra.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return Extra;
      }());;
      _wixdocs.CodeLocation = (function () {
        class CodeLocation {
          constructor(props) {
            this.filename = props && props.filename;
            this.lineno = props && props.lineno;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['filename'] != null) {
                json['filename'] = obj['filename'];
              } else if (withDefaults) {
                json['filename'] = '';
              }
              if (obj['lineno'] != null) {
                json['lineno'] = $root.google.protobuf.Int32Value.toJSON(obj['lineno'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['lineno'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.CodeLocation();
              if (json['filename'] != null) {
                result['filename'] = json['filename'];
              } else if (withDefaults !== false) {
                result['filename'] = '';
              } else {
                delete result['filename'];
              }
              if (json['lineno'] != null) {
                result['lineno'] = $root.google.protobuf.Int32Value.fromJSON(json['lineno'], helper);
              } else if (withDefaults !== false) {
                delete result['lineno'];
              } else {
                delete result['lineno'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['filename'] != null) {
                grpc['filename'] = obj['filename'];
              }
              if (obj['lineno'] != null) {
                grpc['lineno'] = $root.google.protobuf.Int32Value.toGRPC(obj['lineno'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.CodeLocation();
              if (grpc['filename'] != null) {
                result['filename'] = grpc['filename'];
              } else {
                result['filename'] = '';
              }
              if (grpc['lineno'] != null) {
                result['lineno'] = $root.google.protobuf.Int32Value.fromGRPC(grpc['lineno'], helper);
              } else {
                delete result['lineno'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(CodeLocation.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.CodeLocation');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CodeLocation.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.CodeLocation',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CodeLocation.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CodeLocation.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return CodeLocation;
      }());;
      _wixdocs.Docs = (function () {
        class Docs {
          constructor(props) {
            this.summary = props && props.summary;
            this.description = props && props.description;
            this.links = props && props.links;
            this.examples = props && props.examples;
            this.extra = props && props.extra;
            this.request = props && props.request;
            this.url = props && props.url;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['summary'] != null) {
                json['summary'] = obj['summary'];
              } else if (withDefaults) {
                json['summary'] = '';
              }
              if (obj['description'] != null) {
                json['description'] = obj['description'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['description'] = [];
              }
              if (obj['links'] != null) {
                json['links'] = obj['links'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['links'] = [];
              }
              if (obj['examples'] != null) {
                json['examples'] = obj['examples'].map(e => {
                  return $root.com.wixpress.wixdocs.Example.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['examples'] = [];
              }
              if (obj['extra'] != null) {
                json['extra'] = $root.com.wixpress.wixdocs.Extra.toJSON(obj['extra'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['extra'];
              }
              if (obj['request'] != null) {
                json['request'] = $root.com.wixpress.wixdocs.Docs.HTTP_VERB[obj['request']];
              } else if (withDefaults) {
                json['request'] = 'NA';
              }
              if (obj['url'] != null) {
                json['url'] = $root.google.protobuf.StringValue.toJSON(obj['url'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['url'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.Docs();
              if (json['summary'] != null) {
                result['summary'] = json['summary'];
              } else if (withDefaults !== false) {
                result['summary'] = '';
              } else {
                delete result['summary'];
              }
              if (json['description'] != null) {
                result['description'] = Array.isArray(json['description']) ? json['description'].map(e => {
                  return e;
                }) : json['description'];
              } else if (withDefaults !== false) {
                result['description'] = [];
              } else {
                delete result['description'];
              }
              if (json['links'] != null) {
                result['links'] = Array.isArray(json['links']) ? json['links'].map(e => {
                  return e;
                }) : json['links'];
              } else if (withDefaults !== false) {
                result['links'] = [];
              } else {
                delete result['links'];
              }
              if (json['examples'] != null) {
                result['examples'] = Array.isArray(json['examples']) ? json['examples'].map(e => {
                  return $root.com.wixpress.wixdocs.Example.fromJSON(e, helper);
                }) : json['examples'];
              } else if (withDefaults !== false) {
                result['examples'] = [];
              } else {
                delete result['examples'];
              }
              if (json['extra'] != null) {
                result['extra'] = $root.com.wixpress.wixdocs.Extra.fromJSON(json['extra'], helper);
              } else if (withDefaults !== false) {
                delete result['extra'];
              } else {
                delete result['extra'];
              }
              if (json['request'] != null) {
                result['request'] = typeof json['request'] === 'string' ? json['request'] : $root.com.wixpress.wixdocs.Docs.HTTP_VERB[json['request']];
              } else if (withDefaults !== false) {
                result['request'] = 'NA';
              } else {
                delete result['request'];
              }
              if (json['url'] != null) {
                result['url'] = $root.google.protobuf.StringValue.fromJSON(json['url'], helper);
              } else if (withDefaults !== false) {
                delete result['url'];
              } else {
                delete result['url'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['summary'] != null) {
                grpc['summary'] = obj['summary'];
              }
              if (obj['description'] != null) {
                grpc['description'] = obj['description'].map(e => {
                  return e;
                });
              }
              if (obj['links'] != null) {
                grpc['links'] = obj['links'].map(e => {
                  return e;
                });
              }
              if (obj['examples'] != null) {
                grpc['examples'] = obj['examples'].map(e => {
                  return $root.com.wixpress.wixdocs.Example.toGRPC(e, helper);
                });
              }
              if (obj['extra'] != null) {
                grpc['extra'] = $root.com.wixpress.wixdocs.Extra.toGRPC(obj['extra'], helper);
              }
              if (obj['request'] != null) {
                grpc['request'] = obj['request'];
              }
              if (obj['url'] != null) {
                grpc['url'] = $root.google.protobuf.StringValue.toGRPC(obj['url'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.Docs();
              if (grpc['summary'] != null) {
                result['summary'] = grpc['summary'];
              } else {
                result['summary'] = '';
              }
              if (grpc['description'] != null) {
                result['description'] = grpc['description'].map(e => {
                  return e;
                });
              } else {
                result['description'] = [];
              }
              if (grpc['links'] != null) {
                result['links'] = grpc['links'].map(e => {
                  return e;
                });
              } else {
                result['links'] = [];
              }
              if (grpc['examples'] != null) {
                result['examples'] = grpc['examples'].map(e => {
                  return $root.com.wixpress.wixdocs.Example.fromGRPC(e, helper);
                });
              } else {
                result['examples'] = [];
              }
              if (grpc['extra'] != null) {
                result['extra'] = $root.com.wixpress.wixdocs.Extra.fromGRPC(grpc['extra'], helper);
              } else {
                delete result['extra'];
              }
              if (grpc['request'] != null) {
                result['request'] = grpc['request'];
              } else {
                result['request'] = 'NA';
              }
              if (grpc['url'] != null) {
                result['url'] = $root.google.protobuf.StringValue.fromGRPC(grpc['url'], helper);
              } else {
                delete result['url'];
              }
              return result;
            }
          }
        }
        Docs.HTTP_VERB = {
          'NA': 'NA',
          0: 'NA',
          'GET': 'GET',
          1: 'GET',
          'POST': 'POST',
          2: 'POST',
          'PUT': 'PUT',
          3: 'PUT',
          'DELETE': 'DELETE',
          4: 'DELETE',
          'PATCH': 'PATCH',
          5: 'PATCH',
          'OPTIONS': 'OPTIONS',
          6: 'OPTIONS'
        };
        Docs.HTTP_VERB = {
          'NA': 'NA',
          0: 'NA',
          'GET': 'GET',
          1: 'GET',
          'POST': 'POST',
          2: 'POST',
          'PUT': 'PUT',
          3: 'PUT',
          'DELETE': 'DELETE',
          4: 'DELETE',
          'PATCH': 'PATCH',
          5: 'PATCH',
          'OPTIONS': 'OPTIONS',
          6: 'OPTIONS'
        };
        __builtIn.Object.defineProperty(Docs.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.Docs');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Docs.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.Docs',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Docs.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Docs.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return Docs;
      }());;
      _wixdocs.Property = (function () {
        class Property {
          constructor(props) {
            this.name = props && props.name;
            this.labels = props && props.labels;
            this.get = props && props.get;
            this.set = props && props.set;
            this.type = props && props.type;
            this.defaultValue = props && props.defaultValue;
            this.locations = props && props.locations;
            this.docs = props && props.docs;
            this.extra = props && props.extra;
            this.customLabels = props && props.customLabels;
            this.dynamicCustomLabels = props && props.dynamicCustomLabels;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['name'] != null) {
                json['name'] = obj['name'];
              } else if (withDefaults) {
                json['name'] = '';
              }
              if (obj['labels'] != null) {
                json['labels'] = obj['labels'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['labels'] = [];
              }
              if (obj['get'] != null) {
                json['get'] = $root.google.protobuf.BoolValue.toJSON(obj['get'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['get'];
              }
              if (obj['set'] != null) {
                json['set'] = $root.google.protobuf.BoolValue.toJSON(obj['set'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['set'];
              }
              if (obj['type'] != null) {
                json['type'] = obj['type'].map(e => {
                  return $root.com.wixpress.wixdocs.Type.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['type'] = [];
              }
              if (obj['defaultValue'] != null) {
                json['defaultValue'] = $root.google.protobuf.Value.toJSON(obj['defaultValue'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['defaultValue'];
              }
              if (obj['locations'] != null) {
                json['locations'] = obj['locations'].map(e => {
                  return $root.com.wixpress.wixdocs.CodeLocation.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['locations'] = [];
              }
              if (obj['docs'] != null) {
                json['docs'] = $root.com.wixpress.wixdocs.Docs.toJSON(obj['docs'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['docs'];
              }
              if (obj['extra'] != null) {
                json['extra'] = $root.com.wixpress.wixdocs.Extra.toJSON(obj['extra'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['extra'];
              }
              if (obj['customLabels'] != null) {
                json['customLabels'] = obj['customLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.CustomLabel.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['customLabels'] = [];
              }
              if (obj['dynamicCustomLabels'] != null) {
                json['dynamicCustomLabels'] = obj['dynamicCustomLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.DynamicCustomLabel.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['dynamicCustomLabels'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.Property();
              if (json['name'] != null) {
                result['name'] = json['name'];
              } else if (withDefaults !== false) {
                result['name'] = '';
              } else {
                delete result['name'];
              }
              if (json['labels'] != null) {
                result['labels'] = Array.isArray(json['labels']) ? json['labels'].map(e => {
                  return e;
                }) : json['labels'];
              } else if (withDefaults !== false) {
                result['labels'] = [];
              } else {
                delete result['labels'];
              }
              if (json['get'] != null) {
                result['get'] = $root.google.protobuf.BoolValue.fromJSON(json['get'], helper);
              } else if (withDefaults !== false) {
                delete result['get'];
              } else {
                delete result['get'];
              }
              if (json['set'] != null) {
                result['set'] = $root.google.protobuf.BoolValue.fromJSON(json['set'], helper);
              } else if (withDefaults !== false) {
                delete result['set'];
              } else {
                delete result['set'];
              }
              if (json['type'] != null) {
                result['type'] = Array.isArray(json['type']) ? json['type'].map(e => {
                  return $root.com.wixpress.wixdocs.Type.fromJSON(e, helper);
                }) : json['type'];
              } else if (withDefaults !== false) {
                result['type'] = [];
              } else {
                delete result['type'];
              }
              if (json['defaultValue'] != null) {
                result['defaultValue'] = $root.google.protobuf.Value.fromJSON(json['defaultValue'], helper);
              } else if (withDefaults !== false) {
                delete result['defaultValue'];
              } else {
                delete result['defaultValue'];
              }
              if (json['locations'] != null) {
                result['locations'] = Array.isArray(json['locations']) ? json['locations'].map(e => {
                  return $root.com.wixpress.wixdocs.CodeLocation.fromJSON(e, helper);
                }) : json['locations'];
              } else if (withDefaults !== false) {
                result['locations'] = [];
              } else {
                delete result['locations'];
              }
              if (json['docs'] != null) {
                result['docs'] = $root.com.wixpress.wixdocs.Docs.fromJSON(json['docs'], helper);
              } else if (withDefaults !== false) {
                delete result['docs'];
              } else {
                delete result['docs'];
              }
              if (json['extra'] != null) {
                result['extra'] = $root.com.wixpress.wixdocs.Extra.fromJSON(json['extra'], helper);
              } else if (withDefaults !== false) {
                delete result['extra'];
              } else {
                delete result['extra'];
              }
              if (json['customLabels'] != null) {
                result['customLabels'] = Array.isArray(json['customLabels']) ? json['customLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.CustomLabel.fromJSON(e, helper);
                }) : json['customLabels'];
              } else if (withDefaults !== false) {
                result['customLabels'] = [];
              } else {
                delete result['customLabels'];
              }
              if (json['dynamicCustomLabels'] != null) {
                result['dynamicCustomLabels'] = Array.isArray(json['dynamicCustomLabels']) ? json['dynamicCustomLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.DynamicCustomLabel.fromJSON(e, helper);
                }) : json['dynamicCustomLabels'];
              } else if (withDefaults !== false) {
                result['dynamicCustomLabels'] = [];
              } else {
                delete result['dynamicCustomLabels'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['name'] != null) {
                grpc['name'] = obj['name'];
              }
              if (obj['labels'] != null) {
                grpc['labels'] = obj['labels'].map(e => {
                  return e;
                });
              }
              if (obj['get'] != null) {
                grpc['get'] = $root.google.protobuf.BoolValue.toGRPC(obj['get'], helper);
              }
              if (obj['set'] != null) {
                grpc['set'] = $root.google.protobuf.BoolValue.toGRPC(obj['set'], helper);
              }
              if (obj['type'] != null) {
                grpc['type'] = obj['type'].map(e => {
                  return $root.com.wixpress.wixdocs.Type.toGRPC(e, helper);
                });
              }
              grpc['defaultValue'] = ($root.google.protobuf.Value.toGRPC(obj['defaultValue'], helper))
              if (obj['locations'] != null) {
                grpc['locations'] = obj['locations'].map(e => {
                  return $root.com.wixpress.wixdocs.CodeLocation.toGRPC(e, helper);
                });
              }
              if (obj['docs'] != null) {
                grpc['docs'] = $root.com.wixpress.wixdocs.Docs.toGRPC(obj['docs'], helper);
              }
              if (obj['extra'] != null) {
                grpc['extra'] = $root.com.wixpress.wixdocs.Extra.toGRPC(obj['extra'], helper);
              }
              if (obj['customLabels'] != null) {
                grpc['customLabels'] = obj['customLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.CustomLabel.toGRPC(e, helper);
                });
              }
              if (obj['dynamicCustomLabels'] != null) {
                grpc['dynamicCustomLabels'] = obj['dynamicCustomLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.DynamicCustomLabel.toGRPC(e, helper);
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.Property();
              if (grpc['name'] != null) {
                result['name'] = grpc['name'];
              } else {
                result['name'] = '';
              }
              if (grpc['labels'] != null) {
                result['labels'] = grpc['labels'].map(e => {
                  return e;
                });
              } else {
                result['labels'] = [];
              }
              if (grpc['get'] != null) {
                result['get'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['get'], helper);
              } else {
                delete result['get'];
              }
              if (grpc['set'] != null) {
                result['set'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['set'], helper);
              } else {
                delete result['set'];
              }
              if (grpc['type'] != null) {
                result['type'] = grpc['type'].map(e => {
                  return $root.com.wixpress.wixdocs.Type.fromGRPC(e, helper);
                });
              } else {
                result['type'] = [];
              }
              if (grpc['defaultValue'] != null) {
                result['defaultValue'] = $root.google.protobuf.Value.fromGRPC(grpc['defaultValue'], helper);
              } else {
                delete result['defaultValue'];
              }
              if (grpc['locations'] != null) {
                result['locations'] = grpc['locations'].map(e => {
                  return $root.com.wixpress.wixdocs.CodeLocation.fromGRPC(e, helper);
                });
              } else {
                result['locations'] = [];
              }
              if (grpc['docs'] != null) {
                result['docs'] = $root.com.wixpress.wixdocs.Docs.fromGRPC(grpc['docs'], helper);
              } else {
                delete result['docs'];
              }
              if (grpc['extra'] != null) {
                result['extra'] = $root.com.wixpress.wixdocs.Extra.fromGRPC(grpc['extra'], helper);
              } else {
                delete result['extra'];
              }
              if (grpc['customLabels'] != null) {
                result['customLabels'] = grpc['customLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.CustomLabel.fromGRPC(e, helper);
                });
              } else {
                result['customLabels'] = [];
              }
              if (grpc['dynamicCustomLabels'] != null) {
                result['dynamicCustomLabels'] = grpc['dynamicCustomLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.DynamicCustomLabel.fromGRPC(e, helper);
                });
              } else {
                result['dynamicCustomLabels'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(Property.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.Property');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Property.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.Property',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Property.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Property.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return Property;
      }());;
      _wixdocs.Example = (function () {
        class Example {
          constructor(props) {
            this.title = props && props.title;
            this.body = props && props.body;
            this.response = props && props.response;
            this.extra = props && props.extra;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['title'] != null) {
                json['title'] = obj['title'];
              } else if (withDefaults) {
                json['title'] = '';
              }
              if (obj['body'] != null) {
                json['body'] = obj['body'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['body'] = [];
              }
              if (obj['response'] != null) {
                json['response'] = obj['response'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['response'] = [];
              }
              if (obj['extra'] != null) {
                json['extra'] = $root.com.wixpress.wixdocs.Extra.toJSON(obj['extra'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['extra'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.Example();
              if (json['title'] != null) {
                result['title'] = json['title'];
              } else if (withDefaults !== false) {
                result['title'] = '';
              } else {
                delete result['title'];
              }
              if (json['body'] != null) {
                result['body'] = Array.isArray(json['body']) ? json['body'].map(e => {
                  return e;
                }) : json['body'];
              } else if (withDefaults !== false) {
                result['body'] = [];
              } else {
                delete result['body'];
              }
              if (json['response'] != null) {
                result['response'] = Array.isArray(json['response']) ? json['response'].map(e => {
                  return e;
                }) : json['response'];
              } else if (withDefaults !== false) {
                result['response'] = [];
              } else {
                delete result['response'];
              }
              if (json['extra'] != null) {
                result['extra'] = $root.com.wixpress.wixdocs.Extra.fromJSON(json['extra'], helper);
              } else if (withDefaults !== false) {
                delete result['extra'];
              } else {
                delete result['extra'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['title'] != null) {
                grpc['title'] = obj['title'];
              }
              if (obj['body'] != null) {
                grpc['body'] = obj['body'].map(e => {
                  return e;
                });
              }
              if (obj['response'] != null) {
                grpc['response'] = obj['response'].map(e => {
                  return e;
                });
              }
              if (obj['extra'] != null) {
                grpc['extra'] = $root.com.wixpress.wixdocs.Extra.toGRPC(obj['extra'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.Example();
              if (grpc['title'] != null) {
                result['title'] = grpc['title'];
              } else {
                result['title'] = '';
              }
              if (grpc['body'] != null) {
                result['body'] = grpc['body'].map(e => {
                  return e;
                });
              } else {
                result['body'] = [];
              }
              if (grpc['response'] != null) {
                result['response'] = grpc['response'].map(e => {
                  return e;
                });
              } else {
                result['response'] = [];
              }
              if (grpc['extra'] != null) {
                result['extra'] = $root.com.wixpress.wixdocs.Extra.fromGRPC(grpc['extra'], helper);
              } else {
                delete result['extra'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(Example.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.Example');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Example.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.Example',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Example.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Example.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return Example;
      }());;
      _wixdocs.Operation = (function () {
        class Operation {
          constructor(props) {
            this.name = props && props.name;
            this.labels = props && props.labels;
            this.nameParams = props && props.nameParams;
            this.params = props && props.params;
            this.ret = props && props.ret;
            this.locations = props && props.locations;
            this.docs = props && props.docs;
            this.tag = props && props.tag;
            this.methodName = props && props.methodName;
            this.serviceName = props && props.serviceName;
            this.permissions = props && props.permissions;
            this.extra = props && props.extra;
            this.customLabels = props && props.customLabels;
            this.dynamicCustomLabels = props && props.dynamicCustomLabels;
            this.requiredFields = props && props.requiredFields;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['name'] != null) {
                json['name'] = obj['name'];
              } else if (withDefaults) {
                json['name'] = '';
              }
              if (obj['labels'] != null) {
                json['labels'] = obj['labels'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['labels'] = [];
              }
              if (obj['nameParams'] != null) {
                json['nameParams'] = obj['nameParams'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['nameParams'] = [];
              }
              if (obj['params'] != null) {
                json['params'] = obj['params'].map(e => {
                  return $root.com.wixpress.wixdocs.Parameter.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['params'] = [];
              }
              if (obj['ret'] != null) {
                json['ret'] = $root.com.wixpress.wixdocs.ReturnValue.toJSON(obj['ret'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['ret'];
              }
              if (obj['locations'] != null) {
                json['locations'] = obj['locations'].map(e => {
                  return $root.com.wixpress.wixdocs.CodeLocation.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['locations'] = [];
              }
              if (obj['docs'] != null) {
                json['docs'] = $root.com.wixpress.wixdocs.Docs.toJSON(obj['docs'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['docs'];
              }
              if (obj['tag'] != null) {
                json['tag'] = $root.google.protobuf.StringValue.toJSON(obj['tag'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['tag'];
              }
              if (obj['methodName'] != null) {
                json['methodName'] = $root.google.protobuf.StringValue.toJSON(obj['methodName'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['methodName'];
              }
              if (obj['serviceName'] != null) {
                json['serviceName'] = $root.google.protobuf.StringValue.toJSON(obj['serviceName'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['serviceName'];
              }
              if (obj['permissions'] != null) {
                json['permissions'] = obj['permissions'].map(e => {
                  return $root.com.wixpress.wixdocs.Permission.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['permissions'] = [];
              }
              if (obj['extra'] != null) {
                json['extra'] = $root.com.wixpress.wixdocs.OperationsExtra.toJSON(obj['extra'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['extra'];
              }
              if (obj['customLabels'] != null) {
                json['customLabels'] = obj['customLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.CustomLabel.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['customLabels'] = [];
              }
              if (obj['dynamicCustomLabels'] != null) {
                json['dynamicCustomLabels'] = obj['dynamicCustomLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.DynamicCustomLabel.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['dynamicCustomLabels'] = [];
              }
              if (obj['requiredFields'] != null) {
                json['requiredFields'] = obj['requiredFields'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['requiredFields'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.Operation();
              if (json['name'] != null) {
                result['name'] = json['name'];
              } else if (withDefaults !== false) {
                result['name'] = '';
              } else {
                delete result['name'];
              }
              if (json['labels'] != null) {
                result['labels'] = Array.isArray(json['labels']) ? json['labels'].map(e => {
                  return e;
                }) : json['labels'];
              } else if (withDefaults !== false) {
                result['labels'] = [];
              } else {
                delete result['labels'];
              }
              if (json['nameParams'] != null) {
                result['nameParams'] = Array.isArray(json['nameParams']) ? json['nameParams'].map(e => {
                  return e;
                }) : json['nameParams'];
              } else if (withDefaults !== false) {
                result['nameParams'] = [];
              } else {
                delete result['nameParams'];
              }
              if (json['params'] != null) {
                result['params'] = Array.isArray(json['params']) ? json['params'].map(e => {
                  return $root.com.wixpress.wixdocs.Parameter.fromJSON(e, helper);
                }) : json['params'];
              } else if (withDefaults !== false) {
                result['params'] = [];
              } else {
                delete result['params'];
              }
              if (json['ret'] != null) {
                result['ret'] = $root.com.wixpress.wixdocs.ReturnValue.fromJSON(json['ret'], helper);
              } else if (withDefaults !== false) {
                delete result['ret'];
              } else {
                delete result['ret'];
              }
              if (json['locations'] != null) {
                result['locations'] = Array.isArray(json['locations']) ? json['locations'].map(e => {
                  return $root.com.wixpress.wixdocs.CodeLocation.fromJSON(e, helper);
                }) : json['locations'];
              } else if (withDefaults !== false) {
                result['locations'] = [];
              } else {
                delete result['locations'];
              }
              if (json['docs'] != null) {
                result['docs'] = $root.com.wixpress.wixdocs.Docs.fromJSON(json['docs'], helper);
              } else if (withDefaults !== false) {
                delete result['docs'];
              } else {
                delete result['docs'];
              }
              if (json['tag'] != null) {
                result['tag'] = $root.google.protobuf.StringValue.fromJSON(json['tag'], helper);
              } else if (withDefaults !== false) {
                delete result['tag'];
              } else {
                delete result['tag'];
              }
              if (json['methodName'] != null) {
                result['methodName'] = $root.google.protobuf.StringValue.fromJSON(json['methodName'], helper);
              } else if (withDefaults !== false) {
                delete result['methodName'];
              } else {
                delete result['methodName'];
              }
              if (json['serviceName'] != null) {
                result['serviceName'] = $root.google.protobuf.StringValue.fromJSON(json['serviceName'], helper);
              } else if (withDefaults !== false) {
                delete result['serviceName'];
              } else {
                delete result['serviceName'];
              }
              if (json['permissions'] != null) {
                result['permissions'] = Array.isArray(json['permissions']) ? json['permissions'].map(e => {
                  return $root.com.wixpress.wixdocs.Permission.fromJSON(e, helper);
                }) : json['permissions'];
              } else if (withDefaults !== false) {
                result['permissions'] = [];
              } else {
                delete result['permissions'];
              }
              if (json['extra'] != null) {
                result['extra'] = $root.com.wixpress.wixdocs.OperationsExtra.fromJSON(json['extra'], helper);
              } else if (withDefaults !== false) {
                delete result['extra'];
              } else {
                delete result['extra'];
              }
              if (json['customLabels'] != null) {
                result['customLabels'] = Array.isArray(json['customLabels']) ? json['customLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.CustomLabel.fromJSON(e, helper);
                }) : json['customLabels'];
              } else if (withDefaults !== false) {
                result['customLabels'] = [];
              } else {
                delete result['customLabels'];
              }
              if (json['dynamicCustomLabels'] != null) {
                result['dynamicCustomLabels'] = Array.isArray(json['dynamicCustomLabels']) ? json['dynamicCustomLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.DynamicCustomLabel.fromJSON(e, helper);
                }) : json['dynamicCustomLabels'];
              } else if (withDefaults !== false) {
                result['dynamicCustomLabels'] = [];
              } else {
                delete result['dynamicCustomLabels'];
              }
              if (json['requiredFields'] != null) {
                result['requiredFields'] = Array.isArray(json['requiredFields']) ? json['requiredFields'].map(e => {
                  return e;
                }) : json['requiredFields'];
              } else if (withDefaults !== false) {
                result['requiredFields'] = [];
              } else {
                delete result['requiredFields'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['name'] != null) {
                grpc['name'] = obj['name'];
              }
              if (obj['labels'] != null) {
                grpc['labels'] = obj['labels'].map(e => {
                  return e;
                });
              }
              if (obj['nameParams'] != null) {
                grpc['nameParams'] = obj['nameParams'].map(e => {
                  return e;
                });
              }
              if (obj['params'] != null) {
                grpc['params'] = obj['params'].map(e => {
                  return $root.com.wixpress.wixdocs.Parameter.toGRPC(e, helper);
                });
              }
              if (obj['ret'] != null) {
                grpc['ret'] = $root.com.wixpress.wixdocs.ReturnValue.toGRPC(obj['ret'], helper);
              }
              if (obj['locations'] != null) {
                grpc['locations'] = obj['locations'].map(e => {
                  return $root.com.wixpress.wixdocs.CodeLocation.toGRPC(e, helper);
                });
              }
              if (obj['docs'] != null) {
                grpc['docs'] = $root.com.wixpress.wixdocs.Docs.toGRPC(obj['docs'], helper);
              }
              if (obj['tag'] != null) {
                grpc['tag'] = $root.google.protobuf.StringValue.toGRPC(obj['tag'], helper);
              }
              if (obj['methodName'] != null) {
                grpc['methodName'] = $root.google.protobuf.StringValue.toGRPC(obj['methodName'], helper);
              }
              if (obj['serviceName'] != null) {
                grpc['serviceName'] = $root.google.protobuf.StringValue.toGRPC(obj['serviceName'], helper);
              }
              if (obj['permissions'] != null) {
                grpc['permissions'] = obj['permissions'].map(e => {
                  return $root.com.wixpress.wixdocs.Permission.toGRPC(e, helper);
                });
              }
              if (obj['extra'] != null) {
                grpc['extra'] = $root.com.wixpress.wixdocs.OperationsExtra.toGRPC(obj['extra'], helper);
              }
              if (obj['customLabels'] != null) {
                grpc['customLabels'] = obj['customLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.CustomLabel.toGRPC(e, helper);
                });
              }
              if (obj['dynamicCustomLabels'] != null) {
                grpc['dynamicCustomLabels'] = obj['dynamicCustomLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.DynamicCustomLabel.toGRPC(e, helper);
                });
              }
              if (obj['requiredFields'] != null) {
                grpc['requiredFields'] = obj['requiredFields'].map(e => {
                  return e;
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.Operation();
              if (grpc['name'] != null) {
                result['name'] = grpc['name'];
              } else {
                result['name'] = '';
              }
              if (grpc['labels'] != null) {
                result['labels'] = grpc['labels'].map(e => {
                  return e;
                });
              } else {
                result['labels'] = [];
              }
              if (grpc['nameParams'] != null) {
                result['nameParams'] = grpc['nameParams'].map(e => {
                  return e;
                });
              } else {
                result['nameParams'] = [];
              }
              if (grpc['params'] != null) {
                result['params'] = grpc['params'].map(e => {
                  return $root.com.wixpress.wixdocs.Parameter.fromGRPC(e, helper);
                });
              } else {
                result['params'] = [];
              }
              if (grpc['ret'] != null) {
                result['ret'] = $root.com.wixpress.wixdocs.ReturnValue.fromGRPC(grpc['ret'], helper);
              } else {
                delete result['ret'];
              }
              if (grpc['locations'] != null) {
                result['locations'] = grpc['locations'].map(e => {
                  return $root.com.wixpress.wixdocs.CodeLocation.fromGRPC(e, helper);
                });
              } else {
                result['locations'] = [];
              }
              if (grpc['docs'] != null) {
                result['docs'] = $root.com.wixpress.wixdocs.Docs.fromGRPC(grpc['docs'], helper);
              } else {
                delete result['docs'];
              }
              if (grpc['tag'] != null) {
                result['tag'] = $root.google.protobuf.StringValue.fromGRPC(grpc['tag'], helper);
              } else {
                delete result['tag'];
              }
              if (grpc['methodName'] != null) {
                result['methodName'] = $root.google.protobuf.StringValue.fromGRPC(grpc['methodName'], helper);
              } else {
                delete result['methodName'];
              }
              if (grpc['serviceName'] != null) {
                result['serviceName'] = $root.google.protobuf.StringValue.fromGRPC(grpc['serviceName'], helper);
              } else {
                delete result['serviceName'];
              }
              if (grpc['permissions'] != null) {
                result['permissions'] = grpc['permissions'].map(e => {
                  return $root.com.wixpress.wixdocs.Permission.fromGRPC(e, helper);
                });
              } else {
                result['permissions'] = [];
              }
              if (grpc['extra'] != null) {
                result['extra'] = $root.com.wixpress.wixdocs.OperationsExtra.fromGRPC(grpc['extra'], helper);
              } else {
                delete result['extra'];
              }
              if (grpc['customLabels'] != null) {
                result['customLabels'] = grpc['customLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.CustomLabel.fromGRPC(e, helper);
                });
              } else {
                result['customLabels'] = [];
              }
              if (grpc['dynamicCustomLabels'] != null) {
                result['dynamicCustomLabels'] = grpc['dynamicCustomLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.DynamicCustomLabel.fromGRPC(e, helper);
                });
              } else {
                result['dynamicCustomLabels'] = [];
              }
              if (grpc['requiredFields'] != null) {
                result['requiredFields'] = grpc['requiredFields'].map(e => {
                  return e;
                });
              } else {
                result['requiredFields'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(Operation.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.Operation');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Operation.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.Operation',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Operation.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Operation.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return Operation;
      }());;
      _wixdocs.Parameter = (function () {
        class Parameter {
          constructor(props) {
            this.name = props && props.name;
            this.type = props && props.type;
            this.doc = props && props.doc;
            this.spread = props && props.spread;
            this.optional = props && props.optional;
            this.in = props && props.in;
            this.required = props && props.required;
            this.readOnly = props && props.readOnly;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['name'] != null) {
                json['name'] = obj['name'];
              } else if (withDefaults) {
                json['name'] = '';
              }
              if (obj['type'] != null) {
                json['type'] = obj['type'].map(e => {
                  return $root.com.wixpress.wixdocs.Type.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['type'] = [];
              }
              if (obj['doc'] != null) {
                json['doc'] = obj['doc'];
              } else if (withDefaults) {
                json['doc'] = '';
              }
              if (obj['spread'] != null) {
                json['spread'] = $root.google.protobuf.BoolValue.toJSON(obj['spread'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['spread'];
              }
              if (obj['optional'] != null) {
                json['optional'] = $root.google.protobuf.BoolValue.toJSON(obj['optional'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['optional'];
              }
              if (obj['in'] != null) {
                json['in'] = $root.com.wixpress.wixdocs.Parameter.PARAM_URL_LOCATION[obj['in']];
              } else if (withDefaults) {
                json['in'] = 'NA';
              }
              if (obj['required'] != null) {
                json['required'] = $root.google.protobuf.BoolValue.toJSON(obj['required'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['required'];
              }
              if (obj['readOnly'] != null) {
                json['readOnly'] = $root.google.protobuf.BoolValue.toJSON(obj['readOnly'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['readOnly'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.Parameter();
              if (json['name'] != null) {
                result['name'] = json['name'];
              } else if (withDefaults !== false) {
                result['name'] = '';
              } else {
                delete result['name'];
              }
              if (json['type'] != null) {
                result['type'] = Array.isArray(json['type']) ? json['type'].map(e => {
                  return $root.com.wixpress.wixdocs.Type.fromJSON(e, helper);
                }) : json['type'];
              } else if (withDefaults !== false) {
                result['type'] = [];
              } else {
                delete result['type'];
              }
              if (json['doc'] != null) {
                result['doc'] = json['doc'];
              } else if (withDefaults !== false) {
                result['doc'] = '';
              } else {
                delete result['doc'];
              }
              if (json['spread'] != null) {
                result['spread'] = $root.google.protobuf.BoolValue.fromJSON(json['spread'], helper);
              } else if (withDefaults !== false) {
                delete result['spread'];
              } else {
                delete result['spread'];
              }
              if (json['optional'] != null) {
                result['optional'] = $root.google.protobuf.BoolValue.fromJSON(json['optional'], helper);
              } else if (withDefaults !== false) {
                delete result['optional'];
              } else {
                delete result['optional'];
              }
              if (json['in'] != null) {
                result['in'] = typeof json['in'] === 'string' ? json['in'] : $root.com.wixpress.wixdocs.Parameter.PARAM_URL_LOCATION[json['in']];
              } else if (withDefaults !== false) {
                result['in'] = 'NA';
              } else {
                delete result['in'];
              }
              if (json['required'] != null) {
                result['required'] = $root.google.protobuf.BoolValue.fromJSON(json['required'], helper);
              } else if (withDefaults !== false) {
                delete result['required'];
              } else {
                delete result['required'];
              }
              if (json['readOnly'] != null) {
                result['readOnly'] = $root.google.protobuf.BoolValue.fromJSON(json['readOnly'], helper);
              } else if (withDefaults !== false) {
                delete result['readOnly'];
              } else {
                delete result['readOnly'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['name'] != null) {
                grpc['name'] = obj['name'];
              }
              if (obj['type'] != null) {
                grpc['type'] = obj['type'].map(e => {
                  return $root.com.wixpress.wixdocs.Type.toGRPC(e, helper);
                });
              }
              if (obj['doc'] != null) {
                grpc['doc'] = obj['doc'];
              }
              if (obj['spread'] != null) {
                grpc['spread'] = $root.google.protobuf.BoolValue.toGRPC(obj['spread'], helper);
              }
              if (obj['optional'] != null) {
                grpc['optional'] = $root.google.protobuf.BoolValue.toGRPC(obj['optional'], helper);
              }
              if (obj['in'] != null) {
                grpc['in'] = obj['in'];
              }
              if (obj['required'] != null) {
                grpc['required'] = $root.google.protobuf.BoolValue.toGRPC(obj['required'], helper);
              }
              if (obj['readOnly'] != null) {
                grpc['readOnly'] = $root.google.protobuf.BoolValue.toGRPC(obj['readOnly'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.Parameter();
              if (grpc['name'] != null) {
                result['name'] = grpc['name'];
              } else {
                result['name'] = '';
              }
              if (grpc['type'] != null) {
                result['type'] = grpc['type'].map(e => {
                  return $root.com.wixpress.wixdocs.Type.fromGRPC(e, helper);
                });
              } else {
                result['type'] = [];
              }
              if (grpc['doc'] != null) {
                result['doc'] = grpc['doc'];
              } else {
                result['doc'] = '';
              }
              if (grpc['spread'] != null) {
                result['spread'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['spread'], helper);
              } else {
                delete result['spread'];
              }
              if (grpc['optional'] != null) {
                result['optional'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['optional'], helper);
              } else {
                delete result['optional'];
              }
              if (grpc['in'] != null) {
                result['in'] = grpc['in'];
              } else {
                result['in'] = 'NA';
              }
              if (grpc['required'] != null) {
                result['required'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['required'], helper);
              } else {
                delete result['required'];
              }
              if (grpc['readOnly'] != null) {
                result['readOnly'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['readOnly'], helper);
              } else {
                delete result['readOnly'];
              }
              return result;
            }
          }
        }
        Parameter.PARAM_URL_LOCATION = {
          'NA': 'NA',
          0: 'NA',
          'BODY': 'BODY',
          1: 'BODY',
          'PATH': 'PATH',
          2: 'PATH',
          'QUERY': 'QUERY',
          3: 'QUERY'
        };
        Parameter.PARAM_URL_LOCATION = {
          'NA': 'NA',
          0: 'NA',
          'BODY': 'BODY',
          1: 'BODY',
          'PATH': 'PATH',
          2: 'PATH',
          'QUERY': 'QUERY',
          3: 'QUERY'
        };
        __builtIn.Object.defineProperty(Parameter.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.Parameter');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Parameter.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.Parameter',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Parameter.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Parameter.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return Parameter;
      }());;
      _wixdocs.ReturnValue = (function () {
        class ReturnValue {
          constructor(props) {
            this.type = props && props.type;
            this.doc = props && props.doc;
            this.statusCode = props && props.statusCode;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['type'] != null) {
                json['type'] = obj['type'].map(e => {
                  return $root.com.wixpress.wixdocs.Type.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['type'] = [];
              }
              if (obj['doc'] != null) {
                json['doc'] = obj['doc'];
              } else if (withDefaults) {
                json['doc'] = '';
              }
              if (obj['statusCode'] != null) {
                json['statusCode'] = $root.google.protobuf.StringValue.toJSON(obj['statusCode'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['statusCode'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.ReturnValue();
              if (json['type'] != null) {
                result['type'] = Array.isArray(json['type']) ? json['type'].map(e => {
                  return $root.com.wixpress.wixdocs.Type.fromJSON(e, helper);
                }) : json['type'];
              } else if (withDefaults !== false) {
                result['type'] = [];
              } else {
                delete result['type'];
              }
              if (json['doc'] != null) {
                result['doc'] = json['doc'];
              } else if (withDefaults !== false) {
                result['doc'] = '';
              } else {
                delete result['doc'];
              }
              if (json['statusCode'] != null) {
                result['statusCode'] = $root.google.protobuf.StringValue.fromJSON(json['statusCode'], helper);
              } else if (withDefaults !== false) {
                delete result['statusCode'];
              } else {
                delete result['statusCode'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['type'] != null) {
                grpc['type'] = obj['type'].map(e => {
                  return $root.com.wixpress.wixdocs.Type.toGRPC(e, helper);
                });
              }
              if (obj['doc'] != null) {
                grpc['doc'] = obj['doc'];
              }
              if (obj['statusCode'] != null) {
                grpc['statusCode'] = $root.google.protobuf.StringValue.toGRPC(obj['statusCode'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.ReturnValue();
              if (grpc['type'] != null) {
                result['type'] = grpc['type'].map(e => {
                  return $root.com.wixpress.wixdocs.Type.fromGRPC(e, helper);
                });
              } else {
                result['type'] = [];
              }
              if (grpc['doc'] != null) {
                result['doc'] = grpc['doc'];
              } else {
                result['doc'] = '';
              }
              if (grpc['statusCode'] != null) {
                result['statusCode'] = $root.google.protobuf.StringValue.fromGRPC(grpc['statusCode'], helper);
              } else {
                delete result['statusCode'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(ReturnValue.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.ReturnValue');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ReturnValue.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.ReturnValue',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ReturnValue.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ReturnValue.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return ReturnValue;
      }());;
      _wixdocs.UnionType = (function () {
        class UnionType {
          constructor(props) {
            this.type = props && props.type;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['type'] != null) {
                json['type'] = obj['type'].map(e => {
                  return $root.com.wixpress.wixdocs.Type.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['type'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.UnionType();
              if (json['type'] != null) {
                result['type'] = Array.isArray(json['type']) ? json['type'].map(e => {
                  return $root.com.wixpress.wixdocs.Type.fromJSON(e, helper);
                }) : json['type'];
              } else if (withDefaults !== false) {
                result['type'] = [];
              } else {
                delete result['type'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['type'] != null) {
                grpc['type'] = obj['type'].map(e => {
                  return $root.com.wixpress.wixdocs.Type.toGRPC(e, helper);
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.UnionType();
              if (grpc['type'] != null) {
                result['type'] = grpc['type'].map(e => {
                  return $root.com.wixpress.wixdocs.Type.fromGRPC(e, helper);
                });
              } else {
                result['type'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(UnionType.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.UnionType');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UnionType.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.UnionType',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UnionType.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(UnionType.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return UnionType;
      }());;
      _wixdocs.ComplexType = (function () {
        class ComplexType {
          constructor(props) {
            this.nativeType = props && props.nativeType;
            this.referenceType = props && props.referenceType;
            this.typeParams = props && props.typeParams;
            this.displayName = props && props.displayName;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['nativeType'] != null) {
                json['nativeType'] = obj['nativeType'];
              } else if (withDefaults) {
                delete json['nativeType'];
              }
              if (obj['referenceType'] != null) {
                json['referenceType'] = obj['referenceType'];
              } else if (withDefaults) {
                delete json['referenceType'];
              }
              if (obj['typeParams'] != null) {
                json['typeParams'] = obj['typeParams'].map(e => {
                  return $root.com.wixpress.wixdocs.TypeParameter.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['typeParams'] = [];
              }
              if (obj['displayName'] != null) {
                json['displayName'] = $root.google.protobuf.StringValue.toJSON(obj['displayName'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['displayName'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.ComplexType();
              if (json['nativeType'] != null) {
                result['nativeType'] = json['nativeType'];
              } else if (withDefaults !== false) {
                delete result['nativeType'];
              } else {
                delete result['nativeType'];
              }
              if (json['referenceType'] != null) {
                result['referenceType'] = json['referenceType'];
              } else if (withDefaults !== false) {
                delete result['referenceType'];
              } else {
                delete result['referenceType'];
              }
              if (json['typeParams'] != null) {
                result['typeParams'] = Array.isArray(json['typeParams']) ? json['typeParams'].map(e => {
                  return $root.com.wixpress.wixdocs.TypeParameter.fromJSON(e, helper);
                }) : json['typeParams'];
              } else if (withDefaults !== false) {
                result['typeParams'] = [];
              } else {
                delete result['typeParams'];
              }
              if (json['displayName'] != null) {
                result['displayName'] = $root.google.protobuf.StringValue.fromJSON(json['displayName'], helper);
              } else if (withDefaults !== false) {
                delete result['displayName'];
              } else {
                delete result['displayName'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['nativeType'] != null) {
                grpc['nativeType'] = obj['nativeType'];
              }
              if (obj['referenceType'] != null) {
                grpc['referenceType'] = obj['referenceType'];
              }
              if (obj['typeParams'] != null) {
                grpc['typeParams'] = obj['typeParams'].map(e => {
                  return $root.com.wixpress.wixdocs.TypeParameter.toGRPC(e, helper);
                });
              }
              if (obj['displayName'] != null) {
                grpc['displayName'] = $root.google.protobuf.StringValue.toGRPC(obj['displayName'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.ComplexType();
              if (grpc['nativeType'] != null) {
                result['nativeType'] = grpc['nativeType'];
              } else {
                delete result['nativeType'];
              }
              if (grpc['referenceType'] != null) {
                result['referenceType'] = grpc['referenceType'];
              } else {
                delete result['referenceType'];
              }
              if (grpc['typeParams'] != null) {
                result['typeParams'] = grpc['typeParams'].map(e => {
                  return $root.com.wixpress.wixdocs.TypeParameter.fromGRPC(e, helper);
                });
              } else {
                result['typeParams'] = [];
              }
              if (grpc['displayName'] != null) {
                result['displayName'] = $root.google.protobuf.StringValue.fromGRPC(grpc['displayName'], helper);
              } else {
                delete result['displayName'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(ComplexType.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.ComplexType');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ComplexType.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.ComplexType',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ComplexType.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ComplexType.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return ComplexType;
      }());;
      _wixdocs.TypeParameter = (function () {
        class TypeParameter {
          constructor(props) {
            this.nativeType = props && props.nativeType;
            this.referenceType = props && props.referenceType;
            this.complexType = props && props.complexType;
            this.unionType = props && props.unionType;
            this.key = props && props.key;
            this.displayName = props && props.displayName;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['nativeType'] != null) {
                json['nativeType'] = obj['nativeType'];
              } else if (withDefaults) {
                delete json['nativeType'];
              }
              if (obj['referenceType'] != null) {
                json['referenceType'] = obj['referenceType'];
              } else if (withDefaults) {
                delete json['referenceType'];
              }
              if (obj['complexType'] != null) {
                json['complexType'] = $root.com.wixpress.wixdocs.ComplexType.toJSON(obj['complexType'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['complexType'];
              }
              if (obj['unionType'] != null) {
                json['unionType'] = $root.com.wixpress.wixdocs.UnionType.toJSON(obj['unionType'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['unionType'];
              }
              if (obj['key'] != null) {
                json['key'] = $root.google.protobuf.BoolValue.toJSON(obj['key'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['key'];
              }
              if (obj['displayName'] != null) {
                json['displayName'] = $root.google.protobuf.StringValue.toJSON(obj['displayName'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['displayName'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.TypeParameter();
              if (json['nativeType'] != null) {
                result['nativeType'] = json['nativeType'];
              } else if (withDefaults !== false) {
                delete result['nativeType'];
              } else {
                delete result['nativeType'];
              }
              if (json['referenceType'] != null) {
                result['referenceType'] = json['referenceType'];
              } else if (withDefaults !== false) {
                delete result['referenceType'];
              } else {
                delete result['referenceType'];
              }
              if (json['complexType'] != null) {
                result['complexType'] = $root.com.wixpress.wixdocs.ComplexType.fromJSON(json['complexType'], helper);
              } else if (withDefaults !== false) {
                delete result['complexType'];
              } else {
                delete result['complexType'];
              }
              if (json['unionType'] != null) {
                result['unionType'] = $root.com.wixpress.wixdocs.UnionType.fromJSON(json['unionType'], helper);
              } else if (withDefaults !== false) {
                delete result['unionType'];
              } else {
                delete result['unionType'];
              }
              if (json['key'] != null) {
                result['key'] = $root.google.protobuf.BoolValue.fromJSON(json['key'], helper);
              } else if (withDefaults !== false) {
                delete result['key'];
              } else {
                delete result['key'];
              }
              if (json['displayName'] != null) {
                result['displayName'] = $root.google.protobuf.StringValue.fromJSON(json['displayName'], helper);
              } else if (withDefaults !== false) {
                delete result['displayName'];
              } else {
                delete result['displayName'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['nativeType'] != null) {
                grpc['nativeType'] = obj['nativeType'];
              }
              if (obj['referenceType'] != null) {
                grpc['referenceType'] = obj['referenceType'];
              }
              if (obj['complexType'] != null) {
                grpc['complexType'] = $root.com.wixpress.wixdocs.ComplexType.toGRPC(obj['complexType'], helper);
              }
              if (obj['unionType'] != null) {
                grpc['unionType'] = $root.com.wixpress.wixdocs.UnionType.toGRPC(obj['unionType'], helper);
              }
              if (obj['key'] != null) {
                grpc['key'] = $root.google.protobuf.BoolValue.toGRPC(obj['key'], helper);
              }
              if (obj['displayName'] != null) {
                grpc['displayName'] = $root.google.protobuf.StringValue.toGRPC(obj['displayName'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.TypeParameter();
              if (grpc['nativeType'] != null) {
                result['nativeType'] = grpc['nativeType'];
              } else {
                delete result['nativeType'];
              }
              if (grpc['referenceType'] != null) {
                result['referenceType'] = grpc['referenceType'];
              } else {
                delete result['referenceType'];
              }
              if (grpc['complexType'] != null) {
                result['complexType'] = $root.com.wixpress.wixdocs.ComplexType.fromGRPC(grpc['complexType'], helper);
              } else {
                delete result['complexType'];
              }
              if (grpc['unionType'] != null) {
                result['unionType'] = $root.com.wixpress.wixdocs.UnionType.fromGRPC(grpc['unionType'], helper);
              } else {
                delete result['unionType'];
              }
              if (grpc['key'] != null) {
                result['key'] = $root.google.protobuf.BoolValue.fromGRPC(grpc['key'], helper);
              } else {
                delete result['key'];
              }
              if (grpc['displayName'] != null) {
                result['displayName'] = $root.google.protobuf.StringValue.fromGRPC(grpc['displayName'], helper);
              } else {
                delete result['displayName'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(TypeParameter.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.TypeParameter');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(TypeParameter.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.TypeParameter',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(TypeParameter.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(TypeParameter.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return TypeParameter;
      }());;
      _wixdocs.Type = (function () {
        class Type {
          constructor(props) {
            this.nativeType = props && props.nativeType;
            this.referenceType = props && props.referenceType;
            this.complexType = props && props.complexType;
            this.displayName = props && props.displayName;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['nativeType'] != null) {
                json['nativeType'] = obj['nativeType'];
              } else if (withDefaults) {
                delete json['nativeType'];
              }
              if (obj['referenceType'] != null) {
                json['referenceType'] = obj['referenceType'];
              } else if (withDefaults) {
                delete json['referenceType'];
              }
              if (obj['complexType'] != null) {
                json['complexType'] = $root.com.wixpress.wixdocs.ComplexType.toJSON(obj['complexType'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['complexType'];
              }
              if (obj['displayName'] != null) {
                json['displayName'] = $root.google.protobuf.StringValue.toJSON(obj['displayName'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['displayName'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.Type();
              if (json['nativeType'] != null) {
                result['nativeType'] = json['nativeType'];
              } else if (withDefaults !== false) {
                delete result['nativeType'];
              } else {
                delete result['nativeType'];
              }
              if (json['referenceType'] != null) {
                result['referenceType'] = json['referenceType'];
              } else if (withDefaults !== false) {
                delete result['referenceType'];
              } else {
                delete result['referenceType'];
              }
              if (json['complexType'] != null) {
                result['complexType'] = $root.com.wixpress.wixdocs.ComplexType.fromJSON(json['complexType'], helper);
              } else if (withDefaults !== false) {
                delete result['complexType'];
              } else {
                delete result['complexType'];
              }
              if (json['displayName'] != null) {
                result['displayName'] = $root.google.protobuf.StringValue.fromJSON(json['displayName'], helper);
              } else if (withDefaults !== false) {
                delete result['displayName'];
              } else {
                delete result['displayName'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['nativeType'] != null) {
                grpc['nativeType'] = obj['nativeType'];
              }
              if (obj['referenceType'] != null) {
                grpc['referenceType'] = obj['referenceType'];
              }
              if (obj['complexType'] != null) {
                grpc['complexType'] = $root.com.wixpress.wixdocs.ComplexType.toGRPC(obj['complexType'], helper);
              }
              if (obj['displayName'] != null) {
                grpc['displayName'] = $root.google.protobuf.StringValue.toGRPC(obj['displayName'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.Type();
              if (grpc['nativeType'] != null) {
                result['nativeType'] = grpc['nativeType'];
              } else {
                delete result['nativeType'];
              }
              if (grpc['referenceType'] != null) {
                result['referenceType'] = grpc['referenceType'];
              } else {
                delete result['referenceType'];
              }
              if (grpc['complexType'] != null) {
                result['complexType'] = $root.com.wixpress.wixdocs.ComplexType.fromGRPC(grpc['complexType'], helper);
              } else {
                delete result['complexType'];
              }
              if (grpc['displayName'] != null) {
                result['displayName'] = $root.google.protobuf.StringValue.fromGRPC(grpc['displayName'], helper);
              } else {
                delete result['displayName'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(Type.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.Type');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Type.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.Type',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Type.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Type.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return Type;
      }());;
      _wixdocs.CustomLabel = (function () {
        class CustomLabel {
          constructor(props) {
            this.id = props && props.id;
            this.values = props && props.values;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['id'] != null) {
                json['id'] = $root.google.protobuf.StringValue.toJSON(obj['id'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['id'];
              }
              if (obj['values'] != null) {
                json['values'] = obj['values'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['values'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.CustomLabel();
              if (json['id'] != null) {
                result['id'] = $root.google.protobuf.StringValue.fromJSON(json['id'], helper);
              } else if (withDefaults !== false) {
                delete result['id'];
              } else {
                delete result['id'];
              }
              if (json['values'] != null) {
                result['values'] = Array.isArray(json['values']) ? json['values'].map(e => {
                  return e;
                }) : json['values'];
              } else if (withDefaults !== false) {
                result['values'] = [];
              } else {
                delete result['values'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['id'] != null) {
                grpc['id'] = $root.google.protobuf.StringValue.toGRPC(obj['id'], helper);
              }
              if (obj['values'] != null) {
                grpc['values'] = obj['values'].map(e => {
                  return e;
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.CustomLabel();
              if (grpc['id'] != null) {
                result['id'] = $root.google.protobuf.StringValue.fromGRPC(grpc['id'], helper);
              } else {
                delete result['id'];
              }
              if (grpc['values'] != null) {
                result['values'] = grpc['values'].map(e => {
                  return e;
                });
              } else {
                result['values'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(CustomLabel.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.CustomLabel');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CustomLabel.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.CustomLabel',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CustomLabel.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CustomLabel.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return CustomLabel;
      }());;
      _wixdocs.DynamicCustomLabel = (function () {
        class DynamicCustomLabel {
          constructor(props) {
            this.color = props && props.color;
            this.name = props && props.name;
            this.description = props && props.description;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['color'] != null) {
                json['color'] = $root.google.protobuf.StringValue.toJSON(obj['color'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['color'];
              }
              if (obj['name'] != null) {
                json['name'] = $root.google.protobuf.StringValue.toJSON(obj['name'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['name'];
              }
              if (obj['description'] != null) {
                json['description'] = $root.google.protobuf.StringValue.toJSON(obj['description'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['description'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.DynamicCustomLabel();
              if (json['color'] != null) {
                result['color'] = $root.google.protobuf.StringValue.fromJSON(json['color'], helper);
              } else if (withDefaults !== false) {
                delete result['color'];
              } else {
                delete result['color'];
              }
              if (json['name'] != null) {
                result['name'] = $root.google.protobuf.StringValue.fromJSON(json['name'], helper);
              } else if (withDefaults !== false) {
                delete result['name'];
              } else {
                delete result['name'];
              }
              if (json['description'] != null) {
                result['description'] = $root.google.protobuf.StringValue.fromJSON(json['description'], helper);
              } else if (withDefaults !== false) {
                delete result['description'];
              } else {
                delete result['description'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['color'] != null) {
                grpc['color'] = $root.google.protobuf.StringValue.toGRPC(obj['color'], helper);
              }
              if (obj['name'] != null) {
                grpc['name'] = $root.google.protobuf.StringValue.toGRPC(obj['name'], helper);
              }
              if (obj['description'] != null) {
                grpc['description'] = $root.google.protobuf.StringValue.toGRPC(obj['description'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.DynamicCustomLabel();
              if (grpc['color'] != null) {
                result['color'] = $root.google.protobuf.StringValue.fromGRPC(grpc['color'], helper);
              } else {
                delete result['color'];
              }
              if (grpc['name'] != null) {
                result['name'] = $root.google.protobuf.StringValue.fromGRPC(grpc['name'], helper);
              } else {
                delete result['name'];
              }
              if (grpc['description'] != null) {
                result['description'] = $root.google.protobuf.StringValue.fromGRPC(grpc['description'], helper);
              } else {
                delete result['description'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(DynamicCustomLabel.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.DynamicCustomLabel');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DynamicCustomLabel.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.DynamicCustomLabel',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DynamicCustomLabel.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(DynamicCustomLabel.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return DynamicCustomLabel;
      }());;
      _wixdocs.Message = (function () {
        class Message {
          constructor(props) {
            this.name = props && props.name;
            this.locations = props && props.locations;
            this.docs = props && props.docs;
            this.members = props && props.members;
            this.labels = props && props.labels;
            this.extra = props && props.extra;
            this.enum = props && props.enum;
            this.customLabels = props && props.customLabels;
            this.dynamicCustomLabels = props && props.dynamicCustomLabels;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['name'] != null) {
                json['name'] = obj['name'];
              } else if (withDefaults) {
                json['name'] = '';
              }
              if (obj['locations'] != null) {
                json['locations'] = obj['locations'].map(e => {
                  return $root.com.wixpress.wixdocs.CodeLocation.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['locations'] = [];
              }
              if (obj['docs'] != null) {
                json['docs'] = $root.com.wixpress.wixdocs.Docs.toJSON(obj['docs'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['docs'];
              }
              if (obj['members'] != null) {
                json['members'] = obj['members'].map(e => {
                  return $root.com.wixpress.wixdocs.Parameter.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['members'] = [];
              }
              if (obj['labels'] != null) {
                json['labels'] = obj['labels'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['labels'] = [];
              }
              if (obj['extra'] != null) {
                json['extra'] = $root.com.wixpress.wixdocs.Extra.toJSON(obj['extra'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['extra'];
              }
              if (obj['enum'] != null) {
                json['enum'] = obj['enum'].map(e => {
                  return $root.google.protobuf.StringValue.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['enum'] = [];
              }
              if (obj['customLabels'] != null) {
                json['customLabels'] = obj['customLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.CustomLabel.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['customLabels'] = [];
              }
              if (obj['dynamicCustomLabels'] != null) {
                json['dynamicCustomLabels'] = obj['dynamicCustomLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.DynamicCustomLabel.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['dynamicCustomLabels'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.Message();
              if (json['name'] != null) {
                result['name'] = json['name'];
              } else if (withDefaults !== false) {
                result['name'] = '';
              } else {
                delete result['name'];
              }
              if (json['locations'] != null) {
                result['locations'] = Array.isArray(json['locations']) ? json['locations'].map(e => {
                  return $root.com.wixpress.wixdocs.CodeLocation.fromJSON(e, helper);
                }) : json['locations'];
              } else if (withDefaults !== false) {
                result['locations'] = [];
              } else {
                delete result['locations'];
              }
              if (json['docs'] != null) {
                result['docs'] = $root.com.wixpress.wixdocs.Docs.fromJSON(json['docs'], helper);
              } else if (withDefaults !== false) {
                delete result['docs'];
              } else {
                delete result['docs'];
              }
              if (json['members'] != null) {
                result['members'] = Array.isArray(json['members']) ? json['members'].map(e => {
                  return $root.com.wixpress.wixdocs.Parameter.fromJSON(e, helper);
                }) : json['members'];
              } else if (withDefaults !== false) {
                result['members'] = [];
              } else {
                delete result['members'];
              }
              if (json['labels'] != null) {
                result['labels'] = Array.isArray(json['labels']) ? json['labels'].map(e => {
                  return e;
                }) : json['labels'];
              } else if (withDefaults !== false) {
                result['labels'] = [];
              } else {
                delete result['labels'];
              }
              if (json['extra'] != null) {
                result['extra'] = $root.com.wixpress.wixdocs.Extra.fromJSON(json['extra'], helper);
              } else if (withDefaults !== false) {
                delete result['extra'];
              } else {
                delete result['extra'];
              }
              if (json['enum'] != null) {
                result['enum'] = Array.isArray(json['enum']) ? json['enum'].map(e => {
                  return $root.google.protobuf.StringValue.fromJSON(e, helper);
                }) : json['enum'];
              } else if (withDefaults !== false) {
                result['enum'] = [];
              } else {
                delete result['enum'];
              }
              if (json['customLabels'] != null) {
                result['customLabels'] = Array.isArray(json['customLabels']) ? json['customLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.CustomLabel.fromJSON(e, helper);
                }) : json['customLabels'];
              } else if (withDefaults !== false) {
                result['customLabels'] = [];
              } else {
                delete result['customLabels'];
              }
              if (json['dynamicCustomLabels'] != null) {
                result['dynamicCustomLabels'] = Array.isArray(json['dynamicCustomLabels']) ? json['dynamicCustomLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.DynamicCustomLabel.fromJSON(e, helper);
                }) : json['dynamicCustomLabels'];
              } else if (withDefaults !== false) {
                result['dynamicCustomLabels'] = [];
              } else {
                delete result['dynamicCustomLabels'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['name'] != null) {
                grpc['name'] = obj['name'];
              }
              if (obj['locations'] != null) {
                grpc['locations'] = obj['locations'].map(e => {
                  return $root.com.wixpress.wixdocs.CodeLocation.toGRPC(e, helper);
                });
              }
              if (obj['docs'] != null) {
                grpc['docs'] = $root.com.wixpress.wixdocs.Docs.toGRPC(obj['docs'], helper);
              }
              if (obj['members'] != null) {
                grpc['members'] = obj['members'].map(e => {
                  return $root.com.wixpress.wixdocs.Parameter.toGRPC(e, helper);
                });
              }
              if (obj['labels'] != null) {
                grpc['labels'] = obj['labels'].map(e => {
                  return e;
                });
              }
              if (obj['extra'] != null) {
                grpc['extra'] = $root.com.wixpress.wixdocs.Extra.toGRPC(obj['extra'], helper);
              }
              if (obj['enum'] != null) {
                grpc['enum'] = obj['enum'].map(e => {
                  return $root.google.protobuf.StringValue.toGRPC(e, helper);
                });
              }
              if (obj['customLabels'] != null) {
                grpc['customLabels'] = obj['customLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.CustomLabel.toGRPC(e, helper);
                });
              }
              if (obj['dynamicCustomLabels'] != null) {
                grpc['dynamicCustomLabels'] = obj['dynamicCustomLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.DynamicCustomLabel.toGRPC(e, helper);
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.Message();
              if (grpc['name'] != null) {
                result['name'] = grpc['name'];
              } else {
                result['name'] = '';
              }
              if (grpc['locations'] != null) {
                result['locations'] = grpc['locations'].map(e => {
                  return $root.com.wixpress.wixdocs.CodeLocation.fromGRPC(e, helper);
                });
              } else {
                result['locations'] = [];
              }
              if (grpc['docs'] != null) {
                result['docs'] = $root.com.wixpress.wixdocs.Docs.fromGRPC(grpc['docs'], helper);
              } else {
                delete result['docs'];
              }
              if (grpc['members'] != null) {
                result['members'] = grpc['members'].map(e => {
                  return $root.com.wixpress.wixdocs.Parameter.fromGRPC(e, helper);
                });
              } else {
                result['members'] = [];
              }
              if (grpc['labels'] != null) {
                result['labels'] = grpc['labels'].map(e => {
                  return e;
                });
              } else {
                result['labels'] = [];
              }
              if (grpc['extra'] != null) {
                result['extra'] = $root.com.wixpress.wixdocs.Extra.fromGRPC(grpc['extra'], helper);
              } else {
                delete result['extra'];
              }
              if (grpc['enum'] != null) {
                result['enum'] = grpc['enum'].map(e => {
                  return $root.google.protobuf.StringValue.fromGRPC(e, helper);
                });
              } else {
                result['enum'] = [];
              }
              if (grpc['customLabels'] != null) {
                result['customLabels'] = grpc['customLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.CustomLabel.fromGRPC(e, helper);
                });
              } else {
                result['customLabels'] = [];
              }
              if (grpc['dynamicCustomLabels'] != null) {
                result['dynamicCustomLabels'] = grpc['dynamicCustomLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.DynamicCustomLabel.fromGRPC(e, helper);
                });
              } else {
                result['dynamicCustomLabels'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(Message.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.Message');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Message.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.Message',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Message.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Message.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return Message;
      }());;
      _wixdocs.RelatedContent = (function () {
        class RelatedContent {
          constructor(props) {
            this.icon = props && props.icon;
            this.text = props && props.text;
            this.url = props && props.url;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['icon'] != null) {
                json['icon'] = obj['icon'];
              } else if (withDefaults) {
                json['icon'] = '';
              }
              if (obj['text'] != null) {
                json['text'] = obj['text'];
              } else if (withDefaults) {
                json['text'] = '';
              }
              if (obj['url'] != null) {
                json['url'] = obj['url'];
              } else if (withDefaults) {
                json['url'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.RelatedContent();
              if (json['icon'] != null) {
                result['icon'] = json['icon'];
              } else if (withDefaults !== false) {
                result['icon'] = '';
              } else {
                delete result['icon'];
              }
              if (json['text'] != null) {
                result['text'] = json['text'];
              } else if (withDefaults !== false) {
                result['text'] = '';
              } else {
                delete result['text'];
              }
              if (json['url'] != null) {
                result['url'] = json['url'];
              } else if (withDefaults !== false) {
                result['url'] = '';
              } else {
                delete result['url'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['icon'] != null) {
                grpc['icon'] = obj['icon'];
              }
              if (obj['text'] != null) {
                grpc['text'] = obj['text'];
              }
              if (obj['url'] != null) {
                grpc['url'] = obj['url'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.RelatedContent();
              if (grpc['icon'] != null) {
                result['icon'] = grpc['icon'];
              } else {
                result['icon'] = '';
              }
              if (grpc['text'] != null) {
                result['text'] = grpc['text'];
              } else {
                result['text'] = '';
              }
              if (grpc['url'] != null) {
                result['url'] = grpc['url'];
              } else {
                result['url'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(RelatedContent.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.RelatedContent');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(RelatedContent.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.RelatedContent',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(RelatedContent.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(RelatedContent.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return RelatedContent;
      }());;
      _wixdocs.RelatedGuide = (function () {
        class RelatedGuide {
          constructor(props) {
            this.path = props && props.path;
            this.name = props && props.name;
            this.tag = props && props.tag;
            this.src = props && props.src;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['path'] != null) {
                json['path'] = obj['path'];
              } else if (withDefaults) {
                json['path'] = '';
              }
              if (obj['name'] != null) {
                json['name'] = $root.google.protobuf.StringValue.toJSON(obj['name'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['name'];
              }
              if (obj['tag'] != null) {
                json['tag'] = $root.google.protobuf.StringValue.toJSON(obj['tag'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['tag'];
              }
              if (obj['src'] != null) {
                json['src'] = $root.google.protobuf.StringValue.toJSON(obj['src'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['src'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.RelatedGuide();
              if (json['path'] != null) {
                result['path'] = json['path'];
              } else if (withDefaults !== false) {
                result['path'] = '';
              } else {
                delete result['path'];
              }
              if (json['name'] != null) {
                result['name'] = $root.google.protobuf.StringValue.fromJSON(json['name'], helper);
              } else if (withDefaults !== false) {
                delete result['name'];
              } else {
                delete result['name'];
              }
              if (json['tag'] != null) {
                result['tag'] = $root.google.protobuf.StringValue.fromJSON(json['tag'], helper);
              } else if (withDefaults !== false) {
                delete result['tag'];
              } else {
                delete result['tag'];
              }
              if (json['src'] != null) {
                result['src'] = $root.google.protobuf.StringValue.fromJSON(json['src'], helper);
              } else if (withDefaults !== false) {
                delete result['src'];
              } else {
                delete result['src'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['path'] != null) {
                grpc['path'] = obj['path'];
              }
              if (obj['name'] != null) {
                grpc['name'] = $root.google.protobuf.StringValue.toGRPC(obj['name'], helper);
              }
              if (obj['tag'] != null) {
                grpc['tag'] = $root.google.protobuf.StringValue.toGRPC(obj['tag'], helper);
              }
              if (obj['src'] != null) {
                grpc['src'] = $root.google.protobuf.StringValue.toGRPC(obj['src'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.RelatedGuide();
              if (grpc['path'] != null) {
                result['path'] = grpc['path'];
              } else {
                result['path'] = '';
              }
              if (grpc['name'] != null) {
                result['name'] = $root.google.protobuf.StringValue.fromGRPC(grpc['name'], helper);
              } else {
                delete result['name'];
              }
              if (grpc['tag'] != null) {
                result['tag'] = $root.google.protobuf.StringValue.fromGRPC(grpc['tag'], helper);
              } else {
                delete result['tag'];
              }
              if (grpc['src'] != null) {
                result['src'] = $root.google.protobuf.StringValue.fromGRPC(grpc['src'], helper);
              } else {
                delete result['src'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(RelatedGuide.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.RelatedGuide');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(RelatedGuide.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.RelatedGuide',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(RelatedGuide.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(RelatedGuide.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return RelatedGuide;
      }());;
      _wixdocs.FAQ = (function () {
        class FAQ {
          constructor(props) {
            this.title = props && props.title;
            this.markdown = props && props.markdown;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['title'] != null) {
                json['title'] = obj['title'];
              } else if (withDefaults) {
                json['title'] = '';
              }
              if (obj['markdown'] != null) {
                json['markdown'] = obj['markdown'];
              } else if (withDefaults) {
                json['markdown'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.FAQ();
              if (json['title'] != null) {
                result['title'] = json['title'];
              } else if (withDefaults !== false) {
                result['title'] = '';
              } else {
                delete result['title'];
              }
              if (json['markdown'] != null) {
                result['markdown'] = json['markdown'];
              } else if (withDefaults !== false) {
                result['markdown'] = '';
              } else {
                delete result['markdown'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['title'] != null) {
                grpc['title'] = obj['title'];
              }
              if (obj['markdown'] != null) {
                grpc['markdown'] = obj['markdown'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.FAQ();
              if (grpc['title'] != null) {
                result['title'] = grpc['title'];
              } else {
                result['title'] = '';
              }
              if (grpc['markdown'] != null) {
                result['markdown'] = grpc['markdown'];
              } else {
                result['markdown'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(FAQ.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.FAQ');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(FAQ.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.FAQ',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(FAQ.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(FAQ.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return FAQ;
      }());;
      _wixdocs.Tag = (function () {
        class Tag {
          constructor(props) {
            this.name = props && props.name;
            this.entity = props && props.entity;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['name'] != null) {
                json['name'] = obj['name'];
              } else if (withDefaults) {
                json['name'] = '';
              }
              if (obj['entity'] != null) {
                json['entity'] = obj['entity'];
              } else if (withDefaults) {
                json['entity'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.Tag();
              if (json['name'] != null) {
                result['name'] = json['name'];
              } else if (withDefaults !== false) {
                result['name'] = '';
              } else {
                delete result['name'];
              }
              if (json['entity'] != null) {
                result['entity'] = json['entity'];
              } else if (withDefaults !== false) {
                result['entity'] = '';
              } else {
                delete result['entity'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['name'] != null) {
                grpc['name'] = obj['name'];
              }
              if (obj['entity'] != null) {
                grpc['entity'] = obj['entity'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.Tag();
              if (grpc['name'] != null) {
                result['name'] = grpc['name'];
              } else {
                result['name'] = '';
              }
              if (grpc['entity'] != null) {
                result['entity'] = grpc['entity'];
              } else {
                result['entity'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(Tag.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.Tag');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Tag.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.Tag',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Tag.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Tag.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return Tag;
      }());;
      _wixdocs.OperationsExtra = (function () {
        class OperationsExtra {
          constructor(props) {
            this.hasRest = props && props.hasRest;
            this.rpcRequestName = props && props.rpcRequestName;
            this.rpcResponseName = props && props.rpcResponseName;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['hasRest'] != null) {
                json['hasRest'] = obj['hasRest'];
              } else if (withDefaults) {
                json['hasRest'] = false;
              }
              if (obj['rpcRequestName'] != null) {
                json['rpcRequestName'] = obj['rpcRequestName'];
              } else if (withDefaults) {
                json['rpcRequestName'] = '';
              }
              if (obj['rpcResponseName'] != null) {
                json['rpcResponseName'] = obj['rpcResponseName'];
              } else if (withDefaults) {
                json['rpcResponseName'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.OperationsExtra();
              if (json['hasRest'] != null) {
                result['hasRest'] = json['hasRest'];
              } else if (withDefaults !== false) {
                result['hasRest'] = false;
              } else {
                delete result['hasRest'];
              }
              if (json['rpcRequestName'] != null) {
                result['rpcRequestName'] = json['rpcRequestName'];
              } else if (withDefaults !== false) {
                result['rpcRequestName'] = '';
              } else {
                delete result['rpcRequestName'];
              }
              if (json['rpcResponseName'] != null) {
                result['rpcResponseName'] = json['rpcResponseName'];
              } else if (withDefaults !== false) {
                result['rpcResponseName'] = '';
              } else {
                delete result['rpcResponseName'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['hasRest'] != null) {
                grpc['hasRest'] = obj['hasRest'];
              }
              if (obj['rpcRequestName'] != null) {
                grpc['rpcRequestName'] = obj['rpcRequestName'];
              }
              if (obj['rpcResponseName'] != null) {
                grpc['rpcResponseName'] = obj['rpcResponseName'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.OperationsExtra();
              if (grpc['hasRest'] != null) {
                result['hasRest'] = grpc['hasRest'];
              } else {
                result['hasRest'] = false;
              }
              if (grpc['rpcRequestName'] != null) {
                result['rpcRequestName'] = grpc['rpcRequestName'];
              } else {
                result['rpcRequestName'] = '';
              }
              if (grpc['rpcResponseName'] != null) {
                result['rpcResponseName'] = grpc['rpcResponseName'];
              } else {
                result['rpcResponseName'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(OperationsExtra.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.OperationsExtra');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(OperationsExtra.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.OperationsExtra',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(OperationsExtra.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(OperationsExtra.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return OperationsExtra;
      }());;
      _wixdocs.Permission = (function () {
        class Permission {
          constructor(props) {
            this.name = props && props.name;
            this.description = props && props.description;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['name'] != null) {
                json['name'] = obj['name'];
              } else if (withDefaults) {
                json['name'] = '';
              }
              if (obj['description'] != null) {
                json['description'] = obj['description'];
              } else if (withDefaults) {
                json['description'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.Permission();
              if (json['name'] != null) {
                result['name'] = json['name'];
              } else if (withDefaults !== false) {
                result['name'] = '';
              } else {
                delete result['name'];
              }
              if (json['description'] != null) {
                result['description'] = json['description'];
              } else if (withDefaults !== false) {
                result['description'] = '';
              } else {
                delete result['description'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['name'] != null) {
                grpc['name'] = obj['name'];
              }
              if (obj['description'] != null) {
                grpc['description'] = obj['description'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.Permission();
              if (grpc['name'] != null) {
                result['name'] = grpc['name'];
              } else {
                result['name'] = '';
              }
              if (grpc['description'] != null) {
                result['description'] = grpc['description'];
              } else {
                result['description'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(Permission.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.Permission');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Permission.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.Permission',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Permission.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Permission.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return Permission;
      }());;
      _wixdocs.Event = (function () {
        class Event {
          constructor(props) {
            this.type = props && props.type;
            this.name = props && props.name;
            this.docs = props && props.docs;
            this.topic = props && props.topic;
            this.tag = props && props.tag;
            this.permissions = props && props.permissions;
            this.customLabels = props && props.customLabels;
            this.dynamicCustomLabels = props && props.dynamicCustomLabels;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['type'] != null) {
                json['type'] = obj['type'];
              } else if (withDefaults) {
                json['type'] = '';
              }
              if (obj['name'] != null) {
                json['name'] = obj['name'];
              } else if (withDefaults) {
                json['name'] = '';
              }
              if (obj['docs'] != null) {
                json['docs'] = $root.com.wixpress.wixdocs.Docs.toJSON(obj['docs'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['docs'];
              }
              if (obj['topic'] != null) {
                json['topic'] = obj['topic'];
              } else if (withDefaults) {
                json['topic'] = '';
              }
              if (obj['tag'] != null) {
                json['tag'] = obj['tag'];
              } else if (withDefaults) {
                json['tag'] = '';
              }
              if (obj['permissions'] != null) {
                json['permissions'] = obj['permissions'].map(e => {
                  return $root.com.wixpress.wixdocs.Permission.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['permissions'] = [];
              }
              if (obj['customLabels'] != null) {
                json['customLabels'] = obj['customLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.CustomLabel.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['customLabels'] = [];
              }
              if (obj['dynamicCustomLabels'] != null) {
                json['dynamicCustomLabels'] = obj['dynamicCustomLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.DynamicCustomLabel.toJSON(e, helper, withDefaults);
                });
              } else if (withDefaults) {
                json['dynamicCustomLabels'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.Event();
              if (json['type'] != null) {
                result['type'] = json['type'];
              } else if (withDefaults !== false) {
                result['type'] = '';
              } else {
                delete result['type'];
              }
              if (json['name'] != null) {
                result['name'] = json['name'];
              } else if (withDefaults !== false) {
                result['name'] = '';
              } else {
                delete result['name'];
              }
              if (json['docs'] != null) {
                result['docs'] = $root.com.wixpress.wixdocs.Docs.fromJSON(json['docs'], helper);
              } else if (withDefaults !== false) {
                delete result['docs'];
              } else {
                delete result['docs'];
              }
              if (json['topic'] != null) {
                result['topic'] = json['topic'];
              } else if (withDefaults !== false) {
                result['topic'] = '';
              } else {
                delete result['topic'];
              }
              if (json['tag'] != null) {
                result['tag'] = json['tag'];
              } else if (withDefaults !== false) {
                result['tag'] = '';
              } else {
                delete result['tag'];
              }
              if (json['permissions'] != null) {
                result['permissions'] = Array.isArray(json['permissions']) ? json['permissions'].map(e => {
                  return $root.com.wixpress.wixdocs.Permission.fromJSON(e, helper);
                }) : json['permissions'];
              } else if (withDefaults !== false) {
                result['permissions'] = [];
              } else {
                delete result['permissions'];
              }
              if (json['customLabels'] != null) {
                result['customLabels'] = Array.isArray(json['customLabels']) ? json['customLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.CustomLabel.fromJSON(e, helper);
                }) : json['customLabels'];
              } else if (withDefaults !== false) {
                result['customLabels'] = [];
              } else {
                delete result['customLabels'];
              }
              if (json['dynamicCustomLabels'] != null) {
                result['dynamicCustomLabels'] = Array.isArray(json['dynamicCustomLabels']) ? json['dynamicCustomLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.DynamicCustomLabel.fromJSON(e, helper);
                }) : json['dynamicCustomLabels'];
              } else if (withDefaults !== false) {
                result['dynamicCustomLabels'] = [];
              } else {
                delete result['dynamicCustomLabels'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['type'] != null) {
                grpc['type'] = obj['type'];
              }
              if (obj['name'] != null) {
                grpc['name'] = obj['name'];
              }
              if (obj['docs'] != null) {
                grpc['docs'] = $root.com.wixpress.wixdocs.Docs.toGRPC(obj['docs'], helper);
              }
              if (obj['topic'] != null) {
                grpc['topic'] = obj['topic'];
              }
              if (obj['tag'] != null) {
                grpc['tag'] = obj['tag'];
              }
              if (obj['permissions'] != null) {
                grpc['permissions'] = obj['permissions'].map(e => {
                  return $root.com.wixpress.wixdocs.Permission.toGRPC(e, helper);
                });
              }
              if (obj['customLabels'] != null) {
                grpc['customLabels'] = obj['customLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.CustomLabel.toGRPC(e, helper);
                });
              }
              if (obj['dynamicCustomLabels'] != null) {
                grpc['dynamicCustomLabels'] = obj['dynamicCustomLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.DynamicCustomLabel.toGRPC(e, helper);
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.Event();
              if (grpc['type'] != null) {
                result['type'] = grpc['type'];
              } else {
                result['type'] = '';
              }
              if (grpc['name'] != null) {
                result['name'] = grpc['name'];
              } else {
                result['name'] = '';
              }
              if (grpc['docs'] != null) {
                result['docs'] = $root.com.wixpress.wixdocs.Docs.fromGRPC(grpc['docs'], helper);
              } else {
                delete result['docs'];
              }
              if (grpc['topic'] != null) {
                result['topic'] = grpc['topic'];
              } else {
                result['topic'] = '';
              }
              if (grpc['tag'] != null) {
                result['tag'] = grpc['tag'];
              } else {
                result['tag'] = '';
              }
              if (grpc['permissions'] != null) {
                result['permissions'] = grpc['permissions'].map(e => {
                  return $root.com.wixpress.wixdocs.Permission.fromGRPC(e, helper);
                });
              } else {
                result['permissions'] = [];
              }
              if (grpc['customLabels'] != null) {
                result['customLabels'] = grpc['customLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.CustomLabel.fromGRPC(e, helper);
                });
              } else {
                result['customLabels'] = [];
              }
              if (grpc['dynamicCustomLabels'] != null) {
                result['dynamicCustomLabels'] = grpc['dynamicCustomLabels'].map(e => {
                  return $root.com.wixpress.wixdocs.DynamicCustomLabel.fromGRPC(e, helper);
                });
              } else {
                result['dynamicCustomLabels'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(Event.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.Event');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Event.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.Event',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Event.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Event.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return Event;
      }());;
      _wixdocs.Entity = (function () {
        class Entity {
          constructor(props) {
            this.name = props && props.name;
            this.type = props && props.type;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['name'] != null) {
                json['name'] = obj['name'];
              } else if (withDefaults) {
                json['name'] = '';
              }
              if (obj['type'] != null) {
                json['type'] = obj['type'];
              } else if (withDefaults) {
                json['type'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.Entity();
              if (json['name'] != null) {
                result['name'] = json['name'];
              } else if (withDefaults !== false) {
                result['name'] = '';
              } else {
                delete result['name'];
              }
              if (json['type'] != null) {
                result['type'] = json['type'];
              } else if (withDefaults !== false) {
                result['type'] = '';
              } else {
                delete result['type'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['name'] != null) {
                grpc['name'] = obj['name'];
              }
              if (obj['type'] != null) {
                grpc['type'] = obj['type'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.Entity();
              if (grpc['name'] != null) {
                result['name'] = grpc['name'];
              } else {
                result['name'] = '';
              }
              if (grpc['type'] != null) {
                result['type'] = grpc['type'];
              } else {
                result['type'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(Entity.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.Entity');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Entity.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.Entity',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Entity.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Entity.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return Entity;
      }());;
      _wixdocs.WixDocsService = (function () {
        class WixDocsService {
          createDocs(aspects, msg) {
            throw new TypeError('method createDocs is abstract');
          }
          partialUpdateDocs(aspects, msg) {
            throw new TypeError('method partialUpdateDocs is abstract');
          }
          jsonPreview(aspects, msg) {
            throw new TypeError('method jsonPreview is abstract');
          }
        }
        WixDocsService.prototype.createDocs._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.CreateDocsRequest,
            $root.com.wixpress.wixdocs.CreateDocsResponse
          ];
        };
        WixDocsService.prototype.partialUpdateDocs._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.PartialUpdateDocsRequest,
            $root.com.wixpress.wixdocs.PartialUpdateDocsResponse
          ];
        };
        WixDocsService.prototype.jsonPreview._messageTypes = function () {
          return [
            $root.com.wixpress.wixdocs.JsonPreviewRequest,
            $root.com.wixpress.wixdocs.JsonPreviewResponse
          ];
        };
        WixDocsService.prototype.createDocs.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.WixDocsService.CreateDocs');
        };
        WixDocsService.prototype.partialUpdateDocs.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.WixDocsService.PartialUpdateDocs');
        };
        WixDocsService.prototype.jsonPreview.__proto = pbjs => {
          return $root.__lookup(pbjs)('com.wixpress.wixdocs.WixDocsService.JsonPreview');
        };
        __builtIn.Object.defineProperty(WixDocsService.prototype, '__isRpcService__', {
          value: true,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(WixDocsService.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.WixDocsService',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(WixDocsService.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.WixDocsService');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(WixDocsService.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(WixDocsService.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(WixDocsService.prototype, '__filename', {
          value: __filename,
          enumerable: false,
          configurable: false
        });
        return WixDocsService;
      }());;
      _wixdocs.CreateDocsRequest = (function () {
        class CreateDocsRequest {
          constructor(props) {
            this.service = props && props.service;
            this.wixDocsPortal = props && props.wixDocsPortal;
            this.branchName = props && props.branchName;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['service'] != null) {
                json['service'] = $root.com.wixpress.wixdocs.Service.toJSON(obj['service'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['service'];
              }
              if (obj['wixDocsPortal'] != null) {
                json['wixDocsPortal'] = obj['wixDocsPortal'];
              } else if (withDefaults) {
                json['wixDocsPortal'] = '';
              }
              if (obj['branchName'] != null) {
                json['branchName'] = obj['branchName'];
              } else if (withDefaults) {
                json['branchName'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.CreateDocsRequest();
              if (json['service'] != null) {
                result['service'] = $root.com.wixpress.wixdocs.Service.fromJSON(json['service'], helper);
              } else if (withDefaults !== false) {
                delete result['service'];
              } else {
                delete result['service'];
              }
              if (json['wixDocsPortal'] != null) {
                result['wixDocsPortal'] = json['wixDocsPortal'];
              } else if (withDefaults !== false) {
                result['wixDocsPortal'] = '';
              } else {
                delete result['wixDocsPortal'];
              }
              if (json['branchName'] != null) {
                result['branchName'] = json['branchName'];
              } else if (withDefaults !== false) {
                result['branchName'] = '';
              } else {
                delete result['branchName'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['service'] != null) {
                grpc['service'] = $root.com.wixpress.wixdocs.Service.toGRPC(obj['service'], helper);
              }
              if (obj['wixDocsPortal'] != null) {
                grpc['wixDocsPortal'] = obj['wixDocsPortal'];
              }
              if (obj['branchName'] != null) {
                grpc['branchName'] = obj['branchName'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.CreateDocsRequest();
              if (grpc['service'] != null) {
                result['service'] = $root.com.wixpress.wixdocs.Service.fromGRPC(grpc['service'], helper);
              } else {
                delete result['service'];
              }
              if (grpc['wixDocsPortal'] != null) {
                result['wixDocsPortal'] = grpc['wixDocsPortal'];
              } else {
                result['wixDocsPortal'] = '';
              }
              if (grpc['branchName'] != null) {
                result['branchName'] = grpc['branchName'];
              } else {
                result['branchName'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(CreateDocsRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.CreateDocsRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CreateDocsRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.CreateDocsRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CreateDocsRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CreateDocsRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return CreateDocsRequest;
      }());;
      _wixdocs.CreateDocsResponse = (function () {
        class CreateDocsResponse {
          constructor(props) {
            this.previewUrl = props && props.previewUrl;
            this.service = props && props.service;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['previewUrl'] != null) {
                json['previewUrl'] = obj['previewUrl'];
              } else if (withDefaults) {
                json['previewUrl'] = '';
              }
              if (obj['service'] != null) {
                json['service'] = $root.com.wixpress.wixdocs.Service.toJSON(obj['service'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['service'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.CreateDocsResponse();
              if (json['previewUrl'] != null) {
                result['previewUrl'] = json['previewUrl'];
              } else if (withDefaults !== false) {
                result['previewUrl'] = '';
              } else {
                delete result['previewUrl'];
              }
              if (json['service'] != null) {
                result['service'] = $root.com.wixpress.wixdocs.Service.fromJSON(json['service'], helper);
              } else if (withDefaults !== false) {
                delete result['service'];
              } else {
                delete result['service'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['previewUrl'] != null) {
                grpc['previewUrl'] = obj['previewUrl'];
              }
              if (obj['service'] != null) {
                grpc['service'] = $root.com.wixpress.wixdocs.Service.toGRPC(obj['service'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.CreateDocsResponse();
              if (grpc['previewUrl'] != null) {
                result['previewUrl'] = grpc['previewUrl'];
              } else {
                result['previewUrl'] = '';
              }
              if (grpc['service'] != null) {
                result['service'] = $root.com.wixpress.wixdocs.Service.fromGRPC(grpc['service'], helper);
              } else {
                delete result['service'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(CreateDocsResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.CreateDocsResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CreateDocsResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.CreateDocsResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CreateDocsResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(CreateDocsResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return CreateDocsResponse;
      }());;
      _wixdocs.PartialUpdateDocsRequest = (function () {
        class PartialUpdateDocsRequest {
          constructor(props) {
            this.service = props && props.service;
            this.wixDocsPortal = props && props.wixDocsPortal;
            this.branchName = props && props.branchName;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['service'] != null) {
                json['service'] = $root.com.wixpress.wixdocs.Service.toJSON(obj['service'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['service'];
              }
              if (obj['wixDocsPortal'] != null) {
                json['wixDocsPortal'] = obj['wixDocsPortal'];
              } else if (withDefaults) {
                json['wixDocsPortal'] = '';
              }
              if (obj['branchName'] != null) {
                json['branchName'] = obj['branchName'];
              } else if (withDefaults) {
                json['branchName'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.PartialUpdateDocsRequest();
              if (json['service'] != null) {
                result['service'] = $root.com.wixpress.wixdocs.Service.fromJSON(json['service'], helper);
              } else if (withDefaults !== false) {
                delete result['service'];
              } else {
                delete result['service'];
              }
              if (json['wixDocsPortal'] != null) {
                result['wixDocsPortal'] = json['wixDocsPortal'];
              } else if (withDefaults !== false) {
                result['wixDocsPortal'] = '';
              } else {
                delete result['wixDocsPortal'];
              }
              if (json['branchName'] != null) {
                result['branchName'] = json['branchName'];
              } else if (withDefaults !== false) {
                result['branchName'] = '';
              } else {
                delete result['branchName'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['service'] != null) {
                grpc['service'] = $root.com.wixpress.wixdocs.Service.toGRPC(obj['service'], helper);
              }
              if (obj['wixDocsPortal'] != null) {
                grpc['wixDocsPortal'] = obj['wixDocsPortal'];
              }
              if (obj['branchName'] != null) {
                grpc['branchName'] = obj['branchName'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.PartialUpdateDocsRequest();
              if (grpc['service'] != null) {
                result['service'] = $root.com.wixpress.wixdocs.Service.fromGRPC(grpc['service'], helper);
              } else {
                delete result['service'];
              }
              if (grpc['wixDocsPortal'] != null) {
                result['wixDocsPortal'] = grpc['wixDocsPortal'];
              } else {
                result['wixDocsPortal'] = '';
              }
              if (grpc['branchName'] != null) {
                result['branchName'] = grpc['branchName'];
              } else {
                result['branchName'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(PartialUpdateDocsRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.PartialUpdateDocsRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PartialUpdateDocsRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.PartialUpdateDocsRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PartialUpdateDocsRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PartialUpdateDocsRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return PartialUpdateDocsRequest;
      }());;
      _wixdocs.PartialUpdateDocsResponse = (function () {
        class PartialUpdateDocsResponse {
          constructor(props) {
            this.previewUrl = props && props.previewUrl;
            this.service = props && props.service;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['previewUrl'] != null) {
                json['previewUrl'] = obj['previewUrl'];
              } else if (withDefaults) {
                json['previewUrl'] = '';
              }
              if (obj['service'] != null) {
                json['service'] = $root.com.wixpress.wixdocs.Service.toJSON(obj['service'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['service'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.PartialUpdateDocsResponse();
              if (json['previewUrl'] != null) {
                result['previewUrl'] = json['previewUrl'];
              } else if (withDefaults !== false) {
                result['previewUrl'] = '';
              } else {
                delete result['previewUrl'];
              }
              if (json['service'] != null) {
                result['service'] = $root.com.wixpress.wixdocs.Service.fromJSON(json['service'], helper);
              } else if (withDefaults !== false) {
                delete result['service'];
              } else {
                delete result['service'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['previewUrl'] != null) {
                grpc['previewUrl'] = obj['previewUrl'];
              }
              if (obj['service'] != null) {
                grpc['service'] = $root.com.wixpress.wixdocs.Service.toGRPC(obj['service'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.PartialUpdateDocsResponse();
              if (grpc['previewUrl'] != null) {
                result['previewUrl'] = grpc['previewUrl'];
              } else {
                result['previewUrl'] = '';
              }
              if (grpc['service'] != null) {
                result['service'] = $root.com.wixpress.wixdocs.Service.fromGRPC(grpc['service'], helper);
              } else {
                delete result['service'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(PartialUpdateDocsResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.PartialUpdateDocsResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PartialUpdateDocsResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.PartialUpdateDocsResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PartialUpdateDocsResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(PartialUpdateDocsResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return PartialUpdateDocsResponse;
      }());;
      _wixdocs.JsonPreviewRequest = (function () {
        class JsonPreviewRequest {
          constructor(props) {
            this.jsonAsString = props && props.jsonAsString;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['jsonAsString'] != null) {
                json['jsonAsString'] = obj['jsonAsString'];
              } else if (withDefaults) {
                json['jsonAsString'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.JsonPreviewRequest();
              if (json['jsonAsString'] != null) {
                result['jsonAsString'] = json['jsonAsString'];
              } else if (withDefaults !== false) {
                result['jsonAsString'] = '';
              } else {
                delete result['jsonAsString'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['jsonAsString'] != null) {
                grpc['jsonAsString'] = obj['jsonAsString'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.JsonPreviewRequest();
              if (grpc['jsonAsString'] != null) {
                result['jsonAsString'] = grpc['jsonAsString'];
              } else {
                result['jsonAsString'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(JsonPreviewRequest.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.JsonPreviewRequest');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(JsonPreviewRequest.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.JsonPreviewRequest',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(JsonPreviewRequest.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(JsonPreviewRequest.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return JsonPreviewRequest;
      }());;
      _wixdocs.JsonPreviewResponse = (function () {
        class JsonPreviewResponse {
          constructor(props) {
            this.previewUrl = props && props.previewUrl;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['previewUrl'] != null) {
                json['previewUrl'] = obj['previewUrl'];
              } else if (withDefaults) {
                json['previewUrl'] = '';
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.com.wixpress.wixdocs.JsonPreviewResponse();
              if (json['previewUrl'] != null) {
                result['previewUrl'] = json['previewUrl'];
              } else if (withDefaults !== false) {
                result['previewUrl'] = '';
              } else {
                delete result['previewUrl'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['previewUrl'] != null) {
                grpc['previewUrl'] = obj['previewUrl'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.com.wixpress.wixdocs.JsonPreviewResponse();
              if (grpc['previewUrl'] != null) {
                result['previewUrl'] = grpc['previewUrl'];
              } else {
                result['previewUrl'] = '';
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(JsonPreviewResponse.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('com.wixpress.wixdocs.JsonPreviewResponse');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(JsonPreviewResponse.prototype, '__fqn__', {
          value: 'com.wixpress.wixdocs.JsonPreviewResponse',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(JsonPreviewResponse.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(JsonPreviewResponse.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return JsonPreviewResponse;
      }());;
      return _wixdocs;
    }());;
    return _wixpress;
  }());;
  return _com;
}());;
$root.google = (function () {
  const _google = {};
  _google.protobuf = (function () {
    const _protobuf = {};
    _protobuf.DoubleValue = (function () {
      class DoubleValue {
        constructor(props) {
          this.value = props && props.value;
        }
        static toJSON(obj, helper) {
          return obj == null ? obj : isNaN(obj) ? 'NaN' : isFinite(obj) ? obj : obj.toString();
        }
        static fromJSON(json, helper) {
          return json === 'NaN' ? NaN : json === 'Infinity' ? Infinity : json === '-Infinity' ? -Infinity : json;
        }
        static toGRPC(obj, helper) {
          return obj == null ? obj : { 'value': obj };
        }
        static fromGRPC(grpc, helper) {
          return grpc && grpc.value;
        }
      }
      __builtIn.Object.defineProperty(DoubleValue.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.DoubleValue');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(DoubleValue.prototype, '__fqn__', {
        value: 'google.protobuf.DoubleValue',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(DoubleValue.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(DoubleValue.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return DoubleValue;
    }());;
    _protobuf.FloatValue = (function () {
      class FloatValue {
        constructor(props) {
          this.value = props && props.value;
        }
        static toJSON(obj, helper) {
          return obj == null ? obj : isNaN(obj) ? 'NaN' : isFinite(obj) ? obj : obj.toString();
        }
        static fromJSON(json, helper) {
          return json === 'NaN' ? NaN : json === 'Infinity' ? Infinity : json === '-Infinity' ? -Infinity : json;
        }
        static toGRPC(obj, helper) {
          return obj == null ? obj : { 'value': obj };
        }
        static fromGRPC(grpc, helper) {
          return grpc && grpc.value;
        }
      }
      __builtIn.Object.defineProperty(FloatValue.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.FloatValue');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FloatValue.prototype, '__fqn__', {
        value: 'google.protobuf.FloatValue',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FloatValue.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FloatValue.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return FloatValue;
    }());;
    _protobuf.Int64Value = (function () {
      class Int64Value {
        constructor(props) {
          this.value = props && props.value;
        }
        static toJSON(obj, helper) {
          return obj == null ? obj : obj.toString();
        }
        static fromJSON(json, helper) {
          return json == null ? json : typeof json === 'number' || typeof json === 'string' && /^[-+]?\d+$/.test(json) ? Long.fromValue(json) : json;
        }
        static toGRPC(obj, helper) {
          return obj == null ? obj : { 'value': obj.toString() };
        }
        static fromGRPC(grpc, helper) {
          return grpc && (typeof grpc.value === 'number' || typeof grpc.value === 'string' && /^[-+]?\d+$/.test(grpc.value) ? Long.fromValue(grpc.value) : grpc.value);
        }
      }
      __builtIn.Object.defineProperty(Int64Value.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.Int64Value');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Int64Value.prototype, '__fqn__', {
        value: 'google.protobuf.Int64Value',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Int64Value.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Int64Value.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Int64Value;
    }());;
    _protobuf.UInt64Value = (function () {
      class UInt64Value {
        constructor(props) {
          this.value = props && props.value;
        }
        static toJSON(obj, helper) {
          return obj == null ? obj : obj.toString();
        }
        static fromJSON(json, helper) {
          return json == null ? json : typeof json === 'number' || typeof json === 'string' && /^[-+]?\d+$/.test(json) ? Long.fromValue(json, 'true') : json;
        }
        static toGRPC(obj, helper) {
          return obj == null ? obj : { 'value': obj.toString() };
        }
        static fromGRPC(grpc, helper) {
          return grpc && (typeof grpc.value === 'number' || typeof grpc.value === 'string' && /^[-+]?\d+$/.test(grpc.value) ? Long.fromValue(grpc.value, 'true') : grpc.value);
        }
      }
      __builtIn.Object.defineProperty(UInt64Value.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.UInt64Value');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(UInt64Value.prototype, '__fqn__', {
        value: 'google.protobuf.UInt64Value',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(UInt64Value.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(UInt64Value.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return UInt64Value;
    }());;
    _protobuf.Int32Value = (function () {
      class Int32Value {
        constructor(props) {
          this.value = props && props.value;
        }
        static toJSON(obj, helper) {
          return obj;
        }
        static fromJSON(json, helper) {
          return json;
        }
        static toGRPC(obj, helper) {
          return obj == null ? obj : { 'value': obj };
        }
        static fromGRPC(grpc, helper) {
          return grpc && grpc.value;
        }
      }
      __builtIn.Object.defineProperty(Int32Value.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.Int32Value');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Int32Value.prototype, '__fqn__', {
        value: 'google.protobuf.Int32Value',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Int32Value.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Int32Value.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Int32Value;
    }());;
    _protobuf.UInt32Value = (function () {
      class UInt32Value {
        constructor(props) {
          this.value = props && props.value;
        }
        static toJSON(obj, helper) {
          return obj;
        }
        static fromJSON(json, helper) {
          return json;
        }
        static toGRPC(obj, helper) {
          return obj == null ? obj : { 'value': obj };
        }
        static fromGRPC(grpc, helper) {
          return grpc && grpc.value;
        }
      }
      __builtIn.Object.defineProperty(UInt32Value.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.UInt32Value');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(UInt32Value.prototype, '__fqn__', {
        value: 'google.protobuf.UInt32Value',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(UInt32Value.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(UInt32Value.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return UInt32Value;
    }());;
    _protobuf.BoolValue = (function () {
      class BoolValue {
        constructor(props) {
          this.value = props && props.value;
        }
        static toJSON(obj, helper) {
          return obj;
        }
        static fromJSON(json, helper) {
          return json;
        }
        static toGRPC(obj, helper) {
          return obj == null ? obj : { 'value': obj };
        }
        static fromGRPC(grpc, helper) {
          return grpc && grpc.value;
        }
      }
      __builtIn.Object.defineProperty(BoolValue.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.BoolValue');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BoolValue.prototype, '__fqn__', {
        value: 'google.protobuf.BoolValue',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BoolValue.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BoolValue.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return BoolValue;
    }());;
    _protobuf.StringValue = (function () {
      class StringValue {
        constructor(props) {
          this.value = props && props.value;
        }
        static toJSON(obj, helper) {
          return obj;
        }
        static fromJSON(json, helper) {
          return json;
        }
        static toGRPC(obj, helper) {
          return obj == null ? obj : { 'value': obj };
        }
        static fromGRPC(grpc, helper) {
          return grpc && grpc.value;
        }
      }
      __builtIn.Object.defineProperty(StringValue.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.StringValue');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(StringValue.prototype, '__fqn__', {
        value: 'google.protobuf.StringValue',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(StringValue.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(StringValue.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return StringValue;
    }());;
    _protobuf.BytesValue = (function () {
      class BytesValue {
        constructor(props) {
          this.value = props && props.value;
        }
        static toJSON(obj, helper) {
          return obj && obj.toString('base64');
        }
        static fromJSON(json, helper) {
          return json && function tryParseBytes(val) {
            try {
              return __builtIn.Buffer.from(val, 'base64');
            } catch (e) {
              return val;
            } finally {
            }
          }(json);
        }
        static toGRPC(obj, helper) {
          return obj == null ? obj : { 'value': obj };
        }
        static fromGRPC(grpc, helper) {
          return grpc && grpc.value;
        }
      }
      __builtIn.Object.defineProperty(BytesValue.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.BytesValue');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BytesValue.prototype, '__fqn__', {
        value: 'google.protobuf.BytesValue',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BytesValue.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(BytesValue.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return BytesValue;
    }());;
    _protobuf.FileDescriptorSet = (function () {
      class FileDescriptorSet {
        constructor(props) {
          this.file = props && props.file;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['file'] != null) {
              json['file'] = obj['file'].map(e => {
                return $root.google.protobuf.FileDescriptorProto.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['file'] = [];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.FileDescriptorSet();
            if (json['file'] != null) {
              result['file'] = Array.isArray(json['file']) ? json['file'].map(e => {
                return $root.google.protobuf.FileDescriptorProto.fromJSON(e, helper);
              }) : json['file'];
            } else if (withDefaults !== false) {
              result['file'] = [];
            } else {
              delete result['file'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['file'] != null) {
              grpc['file'] = obj['file'].map(e => {
                return $root.google.protobuf.FileDescriptorProto.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.FileDescriptorSet();
            if (grpc['file'] != null) {
              result['file'] = grpc['file'].map(e => {
                return $root.google.protobuf.FileDescriptorProto.fromGRPC(e, helper);
              });
            } else {
              result['file'] = [];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(FileDescriptorSet.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.FileDescriptorSet');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FileDescriptorSet.prototype, '__fqn__', {
        value: 'google.protobuf.FileDescriptorSet',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FileDescriptorSet.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FileDescriptorSet.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return FileDescriptorSet;
    }());;
    _protobuf.FileDescriptorProto = (function () {
      class FileDescriptorProto {
        constructor(props) {
          this.name = props && props.name;
          this.package = props && props.package;
          this.dependency = props && props.dependency;
          this.publicDependency = props && props.publicDependency;
          this.weakDependency = props && props.weakDependency;
          this.messageType = props && props.messageType;
          this.enumType = props && props.enumType;
          this.service = props && props.service;
          this.extension = props && props.extension;
          this.options = props && props.options;
          this.sourceCodeInfo = props && props.sourceCodeInfo;
          this.syntax = props && props.syntax;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['name'] != null) {
              json['name'] = obj['name'];
            } else if (withDefaults) {
              json['name'] = '';
            }
            if (obj['package'] != null) {
              json['package'] = obj['package'];
            } else if (withDefaults) {
              json['package'] = '';
            }
            if (obj['dependency'] != null) {
              json['dependency'] = obj['dependency'].map(e => {
                return e;
              });
            } else if (withDefaults) {
              json['dependency'] = [];
            }
            if (obj['publicDependency'] != null) {
              json['publicDependency'] = obj['publicDependency'].map(e => {
                return e;
              });
            } else if (withDefaults) {
              json['publicDependency'] = [];
            }
            if (obj['weakDependency'] != null) {
              json['weakDependency'] = obj['weakDependency'].map(e => {
                return e;
              });
            } else if (withDefaults) {
              json['weakDependency'] = [];
            }
            if (obj['messageType'] != null) {
              json['messageType'] = obj['messageType'].map(e => {
                return $root.google.protobuf.DescriptorProto.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['messageType'] = [];
            }
            if (obj['enumType'] != null) {
              json['enumType'] = obj['enumType'].map(e => {
                return $root.google.protobuf.EnumDescriptorProto.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['enumType'] = [];
            }
            if (obj['service'] != null) {
              json['service'] = obj['service'].map(e => {
                return $root.google.protobuf.ServiceDescriptorProto.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['service'] = [];
            }
            if (obj['extension'] != null) {
              json['extension'] = obj['extension'].map(e => {
                return $root.google.protobuf.FieldDescriptorProto.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['extension'] = [];
            }
            if (obj['options'] != null) {
              json['options'] = $root.google.protobuf.FileOptions.toJSON(obj['options'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['options'];
            }
            if (obj['sourceCodeInfo'] != null) {
              json['sourceCodeInfo'] = $root.google.protobuf.SourceCodeInfo.toJSON(obj['sourceCodeInfo'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['sourceCodeInfo'];
            }
            if (obj['syntax'] != null) {
              json['syntax'] = obj['syntax'];
            } else if (withDefaults) {
              json['syntax'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.FileDescriptorProto();
            if (json['name'] != null) {
              result['name'] = json['name'];
            } else if (withDefaults !== false) {
              result['name'] = '';
            } else {
              delete result['name'];
            }
            if (json['package'] != null) {
              result['package'] = json['package'];
            } else if (withDefaults !== false) {
              result['package'] = '';
            } else {
              delete result['package'];
            }
            if (json['dependency'] != null) {
              result['dependency'] = Array.isArray(json['dependency']) ? json['dependency'].map(e => {
                return e;
              }) : json['dependency'];
            } else if (withDefaults !== false) {
              result['dependency'] = [];
            } else {
              delete result['dependency'];
            }
            if (json['publicDependency'] != null) {
              result['publicDependency'] = Array.isArray(json['publicDependency']) ? json['publicDependency'].map(e => {
                return e;
              }) : json['publicDependency'];
            } else if (withDefaults !== false) {
              result['publicDependency'] = [];
            } else {
              delete result['publicDependency'];
            }
            if (json['weakDependency'] != null) {
              result['weakDependency'] = Array.isArray(json['weakDependency']) ? json['weakDependency'].map(e => {
                return e;
              }) : json['weakDependency'];
            } else if (withDefaults !== false) {
              result['weakDependency'] = [];
            } else {
              delete result['weakDependency'];
            }
            if (json['messageType'] != null) {
              result['messageType'] = Array.isArray(json['messageType']) ? json['messageType'].map(e => {
                return $root.google.protobuf.DescriptorProto.fromJSON(e, helper);
              }) : json['messageType'];
            } else if (withDefaults !== false) {
              result['messageType'] = [];
            } else {
              delete result['messageType'];
            }
            if (json['enumType'] != null) {
              result['enumType'] = Array.isArray(json['enumType']) ? json['enumType'].map(e => {
                return $root.google.protobuf.EnumDescriptorProto.fromJSON(e, helper);
              }) : json['enumType'];
            } else if (withDefaults !== false) {
              result['enumType'] = [];
            } else {
              delete result['enumType'];
            }
            if (json['service'] != null) {
              result['service'] = Array.isArray(json['service']) ? json['service'].map(e => {
                return $root.google.protobuf.ServiceDescriptorProto.fromJSON(e, helper);
              }) : json['service'];
            } else if (withDefaults !== false) {
              result['service'] = [];
            } else {
              delete result['service'];
            }
            if (json['extension'] != null) {
              result['extension'] = Array.isArray(json['extension']) ? json['extension'].map(e => {
                return $root.google.protobuf.FieldDescriptorProto.fromJSON(e, helper);
              }) : json['extension'];
            } else if (withDefaults !== false) {
              result['extension'] = [];
            } else {
              delete result['extension'];
            }
            if (json['options'] != null) {
              result['options'] = $root.google.protobuf.FileOptions.fromJSON(json['options'], helper);
            } else if (withDefaults !== false) {
              delete result['options'];
            } else {
              delete result['options'];
            }
            if (json['sourceCodeInfo'] != null) {
              result['sourceCodeInfo'] = $root.google.protobuf.SourceCodeInfo.fromJSON(json['sourceCodeInfo'], helper);
            } else if (withDefaults !== false) {
              delete result['sourceCodeInfo'];
            } else {
              delete result['sourceCodeInfo'];
            }
            if (json['syntax'] != null) {
              result['syntax'] = json['syntax'];
            } else if (withDefaults !== false) {
              result['syntax'] = '';
            } else {
              delete result['syntax'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['name'] != null) {
              grpc['name'] = obj['name'];
            }
            if (obj['package'] != null) {
              grpc['package'] = obj['package'];
            }
            if (obj['dependency'] != null) {
              grpc['dependency'] = obj['dependency'].map(e => {
                return e;
              });
            }
            if (obj['publicDependency'] != null) {
              grpc['publicDependency'] = obj['publicDependency'].map(e => {
                return e;
              });
            }
            if (obj['weakDependency'] != null) {
              grpc['weakDependency'] = obj['weakDependency'].map(e => {
                return e;
              });
            }
            if (obj['messageType'] != null) {
              grpc['messageType'] = obj['messageType'].map(e => {
                return $root.google.protobuf.DescriptorProto.toGRPC(e, helper);
              });
            }
            if (obj['enumType'] != null) {
              grpc['enumType'] = obj['enumType'].map(e => {
                return $root.google.protobuf.EnumDescriptorProto.toGRPC(e, helper);
              });
            }
            if (obj['service'] != null) {
              grpc['service'] = obj['service'].map(e => {
                return $root.google.protobuf.ServiceDescriptorProto.toGRPC(e, helper);
              });
            }
            if (obj['extension'] != null) {
              grpc['extension'] = obj['extension'].map(e => {
                return $root.google.protobuf.FieldDescriptorProto.toGRPC(e, helper);
              });
            }
            if (obj['options'] != null) {
              grpc['options'] = $root.google.protobuf.FileOptions.toGRPC(obj['options'], helper);
            }
            if (obj['sourceCodeInfo'] != null) {
              grpc['sourceCodeInfo'] = $root.google.protobuf.SourceCodeInfo.toGRPC(obj['sourceCodeInfo'], helper);
            }
            if (obj['syntax'] != null) {
              grpc['syntax'] = obj['syntax'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.FileDescriptorProto();
            if (grpc['name'] != null) {
              result['name'] = grpc['name'];
            } else {
              result['name'] = '';
            }
            if (grpc['package'] != null) {
              result['package'] = grpc['package'];
            } else {
              result['package'] = '';
            }
            if (grpc['dependency'] != null) {
              result['dependency'] = grpc['dependency'].map(e => {
                return e;
              });
            } else {
              result['dependency'] = [];
            }
            if (grpc['publicDependency'] != null) {
              result['publicDependency'] = grpc['publicDependency'].map(e => {
                return e;
              });
            } else {
              result['publicDependency'] = [];
            }
            if (grpc['weakDependency'] != null) {
              result['weakDependency'] = grpc['weakDependency'].map(e => {
                return e;
              });
            } else {
              result['weakDependency'] = [];
            }
            if (grpc['messageType'] != null) {
              result['messageType'] = grpc['messageType'].map(e => {
                return $root.google.protobuf.DescriptorProto.fromGRPC(e, helper);
              });
            } else {
              result['messageType'] = [];
            }
            if (grpc['enumType'] != null) {
              result['enumType'] = grpc['enumType'].map(e => {
                return $root.google.protobuf.EnumDescriptorProto.fromGRPC(e, helper);
              });
            } else {
              result['enumType'] = [];
            }
            if (grpc['service'] != null) {
              result['service'] = grpc['service'].map(e => {
                return $root.google.protobuf.ServiceDescriptorProto.fromGRPC(e, helper);
              });
            } else {
              result['service'] = [];
            }
            if (grpc['extension'] != null) {
              result['extension'] = grpc['extension'].map(e => {
                return $root.google.protobuf.FieldDescriptorProto.fromGRPC(e, helper);
              });
            } else {
              result['extension'] = [];
            }
            if (grpc['options'] != null) {
              result['options'] = $root.google.protobuf.FileOptions.fromGRPC(grpc['options'], helper);
            } else {
              delete result['options'];
            }
            if (grpc['sourceCodeInfo'] != null) {
              result['sourceCodeInfo'] = $root.google.protobuf.SourceCodeInfo.fromGRPC(grpc['sourceCodeInfo'], helper);
            } else {
              delete result['sourceCodeInfo'];
            }
            if (grpc['syntax'] != null) {
              result['syntax'] = grpc['syntax'];
            } else {
              result['syntax'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(FileDescriptorProto.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.FileDescriptorProto');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FileDescriptorProto.prototype, '__fqn__', {
        value: 'google.protobuf.FileDescriptorProto',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FileDescriptorProto.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FileDescriptorProto.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return FileDescriptorProto;
    }());;
    _protobuf.DescriptorProto = (function () {
      class DescriptorProto {
        constructor(props) {
          this.name = props && props.name;
          this.field = props && props.field;
          this.extension = props && props.extension;
          this.nestedType = props && props.nestedType;
          this.enumType = props && props.enumType;
          this.extensionRange = props && props.extensionRange;
          this.oneofDecl = props && props.oneofDecl;
          this.options = props && props.options;
          this.reservedRange = props && props.reservedRange;
          this.reservedName = props && props.reservedName;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['name'] != null) {
              json['name'] = obj['name'];
            } else if (withDefaults) {
              json['name'] = '';
            }
            if (obj['field'] != null) {
              json['field'] = obj['field'].map(e => {
                return $root.google.protobuf.FieldDescriptorProto.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['field'] = [];
            }
            if (obj['extension'] != null) {
              json['extension'] = obj['extension'].map(e => {
                return $root.google.protobuf.FieldDescriptorProto.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['extension'] = [];
            }
            if (obj['nestedType'] != null) {
              json['nestedType'] = obj['nestedType'].map(e => {
                return $root.google.protobuf.DescriptorProto.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['nestedType'] = [];
            }
            if (obj['enumType'] != null) {
              json['enumType'] = obj['enumType'].map(e => {
                return $root.google.protobuf.EnumDescriptorProto.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['enumType'] = [];
            }
            if (obj['extensionRange'] != null) {
              json['extensionRange'] = obj['extensionRange'].map(e => {
                return $root.google.protobuf.DescriptorProto.ExtensionRange.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['extensionRange'] = [];
            }
            if (obj['oneofDecl'] != null) {
              json['oneofDecl'] = obj['oneofDecl'].map(e => {
                return $root.google.protobuf.OneofDescriptorProto.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['oneofDecl'] = [];
            }
            if (obj['options'] != null) {
              json['options'] = $root.google.protobuf.MessageOptions.toJSON(obj['options'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['options'];
            }
            if (obj['reservedRange'] != null) {
              json['reservedRange'] = obj['reservedRange'].map(e => {
                return $root.google.protobuf.DescriptorProto.ReservedRange.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['reservedRange'] = [];
            }
            if (obj['reservedName'] != null) {
              json['reservedName'] = obj['reservedName'].map(e => {
                return e;
              });
            } else if (withDefaults) {
              json['reservedName'] = [];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.DescriptorProto();
            if (json['name'] != null) {
              result['name'] = json['name'];
            } else if (withDefaults !== false) {
              result['name'] = '';
            } else {
              delete result['name'];
            }
            if (json['field'] != null) {
              result['field'] = Array.isArray(json['field']) ? json['field'].map(e => {
                return $root.google.protobuf.FieldDescriptorProto.fromJSON(e, helper);
              }) : json['field'];
            } else if (withDefaults !== false) {
              result['field'] = [];
            } else {
              delete result['field'];
            }
            if (json['extension'] != null) {
              result['extension'] = Array.isArray(json['extension']) ? json['extension'].map(e => {
                return $root.google.protobuf.FieldDescriptorProto.fromJSON(e, helper);
              }) : json['extension'];
            } else if (withDefaults !== false) {
              result['extension'] = [];
            } else {
              delete result['extension'];
            }
            if (json['nestedType'] != null) {
              result['nestedType'] = Array.isArray(json['nestedType']) ? json['nestedType'].map(e => {
                return $root.google.protobuf.DescriptorProto.fromJSON(e, helper);
              }) : json['nestedType'];
            } else if (withDefaults !== false) {
              result['nestedType'] = [];
            } else {
              delete result['nestedType'];
            }
            if (json['enumType'] != null) {
              result['enumType'] = Array.isArray(json['enumType']) ? json['enumType'].map(e => {
                return $root.google.protobuf.EnumDescriptorProto.fromJSON(e, helper);
              }) : json['enumType'];
            } else if (withDefaults !== false) {
              result['enumType'] = [];
            } else {
              delete result['enumType'];
            }
            if (json['extensionRange'] != null) {
              result['extensionRange'] = Array.isArray(json['extensionRange']) ? json['extensionRange'].map(e => {
                return $root.google.protobuf.DescriptorProto.ExtensionRange.fromJSON(e, helper);
              }) : json['extensionRange'];
            } else if (withDefaults !== false) {
              result['extensionRange'] = [];
            } else {
              delete result['extensionRange'];
            }
            if (json['oneofDecl'] != null) {
              result['oneofDecl'] = Array.isArray(json['oneofDecl']) ? json['oneofDecl'].map(e => {
                return $root.google.protobuf.OneofDescriptorProto.fromJSON(e, helper);
              }) : json['oneofDecl'];
            } else if (withDefaults !== false) {
              result['oneofDecl'] = [];
            } else {
              delete result['oneofDecl'];
            }
            if (json['options'] != null) {
              result['options'] = $root.google.protobuf.MessageOptions.fromJSON(json['options'], helper);
            } else if (withDefaults !== false) {
              delete result['options'];
            } else {
              delete result['options'];
            }
            if (json['reservedRange'] != null) {
              result['reservedRange'] = Array.isArray(json['reservedRange']) ? json['reservedRange'].map(e => {
                return $root.google.protobuf.DescriptorProto.ReservedRange.fromJSON(e, helper);
              }) : json['reservedRange'];
            } else if (withDefaults !== false) {
              result['reservedRange'] = [];
            } else {
              delete result['reservedRange'];
            }
            if (json['reservedName'] != null) {
              result['reservedName'] = Array.isArray(json['reservedName']) ? json['reservedName'].map(e => {
                return e;
              }) : json['reservedName'];
            } else if (withDefaults !== false) {
              result['reservedName'] = [];
            } else {
              delete result['reservedName'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['name'] != null) {
              grpc['name'] = obj['name'];
            }
            if (obj['field'] != null) {
              grpc['field'] = obj['field'].map(e => {
                return $root.google.protobuf.FieldDescriptorProto.toGRPC(e, helper);
              });
            }
            if (obj['extension'] != null) {
              grpc['extension'] = obj['extension'].map(e => {
                return $root.google.protobuf.FieldDescriptorProto.toGRPC(e, helper);
              });
            }
            if (obj['nestedType'] != null) {
              grpc['nestedType'] = obj['nestedType'].map(e => {
                return $root.google.protobuf.DescriptorProto.toGRPC(e, helper);
              });
            }
            if (obj['enumType'] != null) {
              grpc['enumType'] = obj['enumType'].map(e => {
                return $root.google.protobuf.EnumDescriptorProto.toGRPC(e, helper);
              });
            }
            if (obj['extensionRange'] != null) {
              grpc['extensionRange'] = obj['extensionRange'].map(e => {
                return $root.google.protobuf.DescriptorProto.ExtensionRange.toGRPC(e, helper);
              });
            }
            if (obj['oneofDecl'] != null) {
              grpc['oneofDecl'] = obj['oneofDecl'].map(e => {
                return $root.google.protobuf.OneofDescriptorProto.toGRPC(e, helper);
              });
            }
            if (obj['options'] != null) {
              grpc['options'] = $root.google.protobuf.MessageOptions.toGRPC(obj['options'], helper);
            }
            if (obj['reservedRange'] != null) {
              grpc['reservedRange'] = obj['reservedRange'].map(e => {
                return $root.google.protobuf.DescriptorProto.ReservedRange.toGRPC(e, helper);
              });
            }
            if (obj['reservedName'] != null) {
              grpc['reservedName'] = obj['reservedName'].map(e => {
                return e;
              });
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.DescriptorProto();
            if (grpc['name'] != null) {
              result['name'] = grpc['name'];
            } else {
              result['name'] = '';
            }
            if (grpc['field'] != null) {
              result['field'] = grpc['field'].map(e => {
                return $root.google.protobuf.FieldDescriptorProto.fromGRPC(e, helper);
              });
            } else {
              result['field'] = [];
            }
            if (grpc['extension'] != null) {
              result['extension'] = grpc['extension'].map(e => {
                return $root.google.protobuf.FieldDescriptorProto.fromGRPC(e, helper);
              });
            } else {
              result['extension'] = [];
            }
            if (grpc['nestedType'] != null) {
              result['nestedType'] = grpc['nestedType'].map(e => {
                return $root.google.protobuf.DescriptorProto.fromGRPC(e, helper);
              });
            } else {
              result['nestedType'] = [];
            }
            if (grpc['enumType'] != null) {
              result['enumType'] = grpc['enumType'].map(e => {
                return $root.google.protobuf.EnumDescriptorProto.fromGRPC(e, helper);
              });
            } else {
              result['enumType'] = [];
            }
            if (grpc['extensionRange'] != null) {
              result['extensionRange'] = grpc['extensionRange'].map(e => {
                return $root.google.protobuf.DescriptorProto.ExtensionRange.fromGRPC(e, helper);
              });
            } else {
              result['extensionRange'] = [];
            }
            if (grpc['oneofDecl'] != null) {
              result['oneofDecl'] = grpc['oneofDecl'].map(e => {
                return $root.google.protobuf.OneofDescriptorProto.fromGRPC(e, helper);
              });
            } else {
              result['oneofDecl'] = [];
            }
            if (grpc['options'] != null) {
              result['options'] = $root.google.protobuf.MessageOptions.fromGRPC(grpc['options'], helper);
            } else {
              delete result['options'];
            }
            if (grpc['reservedRange'] != null) {
              result['reservedRange'] = grpc['reservedRange'].map(e => {
                return $root.google.protobuf.DescriptorProto.ReservedRange.fromGRPC(e, helper);
              });
            } else {
              result['reservedRange'] = [];
            }
            if (grpc['reservedName'] != null) {
              result['reservedName'] = grpc['reservedName'].map(e => {
                return e;
              });
            } else {
              result['reservedName'] = [];
            }
            return result;
          }
        }
      }
      DescriptorProto.ExtensionRange = (function () {
        class ExtensionRange {
          constructor(props) {
            this.start = props && props.start;
            this.end = props && props.end;
            this.options = props && props.options;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['start'] != null) {
                json['start'] = obj['start'];
              } else if (withDefaults) {
                json['start'] = 0;
              }
              if (obj['end'] != null) {
                json['end'] = obj['end'];
              } else if (withDefaults) {
                json['end'] = 0;
              }
              if (obj['options'] != null) {
                json['options'] = $root.google.protobuf.ExtensionRangeOptions.toJSON(obj['options'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['options'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.google.protobuf.DescriptorProto.ExtensionRange();
              if (json['start'] != null) {
                result['start'] = json['start'];
              } else if (withDefaults !== false) {
                result['start'] = 0;
              } else {
                delete result['start'];
              }
              if (json['end'] != null) {
                result['end'] = json['end'];
              } else if (withDefaults !== false) {
                result['end'] = 0;
              } else {
                delete result['end'];
              }
              if (json['options'] != null) {
                result['options'] = $root.google.protobuf.ExtensionRangeOptions.fromJSON(json['options'], helper);
              } else if (withDefaults !== false) {
                delete result['options'];
              } else {
                delete result['options'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['start'] != null) {
                grpc['start'] = obj['start'];
              }
              if (obj['end'] != null) {
                grpc['end'] = obj['end'];
              }
              if (obj['options'] != null) {
                grpc['options'] = $root.google.protobuf.ExtensionRangeOptions.toGRPC(obj['options'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.google.protobuf.DescriptorProto.ExtensionRange();
              if (grpc['start'] != null) {
                result['start'] = grpc['start'];
              } else {
                result['start'] = 0;
              }
              if (grpc['end'] != null) {
                result['end'] = grpc['end'];
              } else {
                result['end'] = 0;
              }
              if (grpc['options'] != null) {
                result['options'] = $root.google.protobuf.ExtensionRangeOptions.fromGRPC(grpc['options'], helper);
              } else {
                delete result['options'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(ExtensionRange.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('google.protobuf.DescriptorProto.ExtensionRange');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ExtensionRange.prototype, '__fqn__', {
          value: 'google.protobuf.DescriptorProto.ExtensionRange',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ExtensionRange.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ExtensionRange.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return ExtensionRange;
      }());;
      DescriptorProto.ReservedRange = (function () {
        class ReservedRange {
          constructor(props) {
            this.start = props && props.start;
            this.end = props && props.end;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['start'] != null) {
                json['start'] = obj['start'];
              } else if (withDefaults) {
                json['start'] = 0;
              }
              if (obj['end'] != null) {
                json['end'] = obj['end'];
              } else if (withDefaults) {
                json['end'] = 0;
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.google.protobuf.DescriptorProto.ReservedRange();
              if (json['start'] != null) {
                result['start'] = json['start'];
              } else if (withDefaults !== false) {
                result['start'] = 0;
              } else {
                delete result['start'];
              }
              if (json['end'] != null) {
                result['end'] = json['end'];
              } else if (withDefaults !== false) {
                result['end'] = 0;
              } else {
                delete result['end'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['start'] != null) {
                grpc['start'] = obj['start'];
              }
              if (obj['end'] != null) {
                grpc['end'] = obj['end'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.google.protobuf.DescriptorProto.ReservedRange();
              if (grpc['start'] != null) {
                result['start'] = grpc['start'];
              } else {
                result['start'] = 0;
              }
              if (grpc['end'] != null) {
                result['end'] = grpc['end'];
              } else {
                result['end'] = 0;
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(ReservedRange.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('google.protobuf.DescriptorProto.ReservedRange');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ReservedRange.prototype, '__fqn__', {
          value: 'google.protobuf.DescriptorProto.ReservedRange',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ReservedRange.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ReservedRange.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return ReservedRange;
      }());;
      DescriptorProto.ExtensionRange = (function () {
        class ExtensionRange {
          constructor(props) {
            this.start = props && props.start;
            this.end = props && props.end;
            this.options = props && props.options;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['start'] != null) {
                json['start'] = obj['start'];
              } else if (withDefaults) {
                json['start'] = 0;
              }
              if (obj['end'] != null) {
                json['end'] = obj['end'];
              } else if (withDefaults) {
                json['end'] = 0;
              }
              if (obj['options'] != null) {
                json['options'] = $root.google.protobuf.ExtensionRangeOptions.toJSON(obj['options'], helper, withDefaults);
              } else if (withDefaults) {
                delete json['options'];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.google.protobuf.DescriptorProto.ExtensionRange();
              if (json['start'] != null) {
                result['start'] = json['start'];
              } else if (withDefaults !== false) {
                result['start'] = 0;
              } else {
                delete result['start'];
              }
              if (json['end'] != null) {
                result['end'] = json['end'];
              } else if (withDefaults !== false) {
                result['end'] = 0;
              } else {
                delete result['end'];
              }
              if (json['options'] != null) {
                result['options'] = $root.google.protobuf.ExtensionRangeOptions.fromJSON(json['options'], helper);
              } else if (withDefaults !== false) {
                delete result['options'];
              } else {
                delete result['options'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['start'] != null) {
                grpc['start'] = obj['start'];
              }
              if (obj['end'] != null) {
                grpc['end'] = obj['end'];
              }
              if (obj['options'] != null) {
                grpc['options'] = $root.google.protobuf.ExtensionRangeOptions.toGRPC(obj['options'], helper);
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.google.protobuf.DescriptorProto.ExtensionRange();
              if (grpc['start'] != null) {
                result['start'] = grpc['start'];
              } else {
                result['start'] = 0;
              }
              if (grpc['end'] != null) {
                result['end'] = grpc['end'];
              } else {
                result['end'] = 0;
              }
              if (grpc['options'] != null) {
                result['options'] = $root.google.protobuf.ExtensionRangeOptions.fromGRPC(grpc['options'], helper);
              } else {
                delete result['options'];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(ExtensionRange.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('google.protobuf.DescriptorProto.ExtensionRange');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ExtensionRange.prototype, '__fqn__', {
          value: 'google.protobuf.DescriptorProto.ExtensionRange',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ExtensionRange.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ExtensionRange.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return ExtensionRange;
      }());;
      DescriptorProto.ReservedRange = (function () {
        class ReservedRange {
          constructor(props) {
            this.start = props && props.start;
            this.end = props && props.end;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['start'] != null) {
                json['start'] = obj['start'];
              } else if (withDefaults) {
                json['start'] = 0;
              }
              if (obj['end'] != null) {
                json['end'] = obj['end'];
              } else if (withDefaults) {
                json['end'] = 0;
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.google.protobuf.DescriptorProto.ReservedRange();
              if (json['start'] != null) {
                result['start'] = json['start'];
              } else if (withDefaults !== false) {
                result['start'] = 0;
              } else {
                delete result['start'];
              }
              if (json['end'] != null) {
                result['end'] = json['end'];
              } else if (withDefaults !== false) {
                result['end'] = 0;
              } else {
                delete result['end'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['start'] != null) {
                grpc['start'] = obj['start'];
              }
              if (obj['end'] != null) {
                grpc['end'] = obj['end'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.google.protobuf.DescriptorProto.ReservedRange();
              if (grpc['start'] != null) {
                result['start'] = grpc['start'];
              } else {
                result['start'] = 0;
              }
              if (grpc['end'] != null) {
                result['end'] = grpc['end'];
              } else {
                result['end'] = 0;
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(ReservedRange.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('google.protobuf.DescriptorProto.ReservedRange');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ReservedRange.prototype, '__fqn__', {
          value: 'google.protobuf.DescriptorProto.ReservedRange',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ReservedRange.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(ReservedRange.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return ReservedRange;
      }());;
      __builtIn.Object.defineProperty(DescriptorProto.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.DescriptorProto');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(DescriptorProto.prototype, '__fqn__', {
        value: 'google.protobuf.DescriptorProto',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(DescriptorProto.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(DescriptorProto.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return DescriptorProto;
    }());;
    _protobuf.ExtensionRangeOptions = (function () {
      class ExtensionRangeOptions {
        constructor(props) {
          this.uninterpretedOption = props && props.uninterpretedOption;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['uninterpretedOption'] != null) {
              json['uninterpretedOption'] = obj['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['uninterpretedOption'] = [];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.ExtensionRangeOptions();
            if (json['uninterpretedOption'] != null) {
              result['uninterpretedOption'] = Array.isArray(json['uninterpretedOption']) ? json['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.fromJSON(e, helper);
              }) : json['uninterpretedOption'];
            } else if (withDefaults !== false) {
              result['uninterpretedOption'] = [];
            } else {
              delete result['uninterpretedOption'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['uninterpretedOption'] != null) {
              grpc['uninterpretedOption'] = obj['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.ExtensionRangeOptions();
            if (grpc['uninterpretedOption'] != null) {
              result['uninterpretedOption'] = grpc['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.fromGRPC(e, helper);
              });
            } else {
              result['uninterpretedOption'] = [];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(ExtensionRangeOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.ExtensionRangeOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ExtensionRangeOptions.prototype, '__fqn__', {
        value: 'google.protobuf.ExtensionRangeOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ExtensionRangeOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ExtensionRangeOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return ExtensionRangeOptions;
    }());;
    _protobuf.FieldDescriptorProto = (function () {
      class FieldDescriptorProto {
        constructor(props) {
          this.name = props && props.name;
          this.number = props && props.number;
          this.label = props && props.label;
          this.type = props && props.type;
          this.typeName = props && props.typeName;
          this.extendee = props && props.extendee;
          this.defaultValue = props && props.defaultValue;
          this.oneofIndex = props && props.oneofIndex;
          this.jsonName = props && props.jsonName;
          this.options = props && props.options;
          this.proto3Optional = props && props.proto3Optional;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['name'] != null) {
              json['name'] = obj['name'];
            } else if (withDefaults) {
              json['name'] = '';
            }
            if (obj['number'] != null) {
              json['number'] = obj['number'];
            } else if (withDefaults) {
              json['number'] = 0;
            }
            if (obj['label'] != null) {
              json['label'] = $root.google.protobuf.FieldDescriptorProto.Label[obj['label']];
            } else if (withDefaults) {
              json['label'] = 'LABEL_OPTIONAL';
            }
            if (obj['type'] != null) {
              json['type'] = $root.google.protobuf.FieldDescriptorProto.Type[obj['type']];
            } else if (withDefaults) {
              json['type'] = 'TYPE_DOUBLE';
            }
            if (obj['typeName'] != null) {
              json['typeName'] = obj['typeName'];
            } else if (withDefaults) {
              json['typeName'] = '';
            }
            if (obj['extendee'] != null) {
              json['extendee'] = obj['extendee'];
            } else if (withDefaults) {
              json['extendee'] = '';
            }
            if (obj['defaultValue'] != null) {
              json['defaultValue'] = obj['defaultValue'];
            } else if (withDefaults) {
              json['defaultValue'] = '';
            }
            if (obj['oneofIndex'] != null) {
              json['oneofIndex'] = obj['oneofIndex'];
            } else if (withDefaults) {
              json['oneofIndex'] = 0;
            }
            if (obj['jsonName'] != null) {
              json['jsonName'] = obj['jsonName'];
            } else if (withDefaults) {
              json['jsonName'] = '';
            }
            if (obj['options'] != null) {
              json['options'] = $root.google.protobuf.FieldOptions.toJSON(obj['options'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['options'];
            }
            if (obj['proto3Optional'] != null) {
              json['proto3Optional'] = obj['proto3Optional'];
            } else if (withDefaults) {
              json['proto3Optional'] = false;
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.FieldDescriptorProto();
            if (json['name'] != null) {
              result['name'] = json['name'];
            } else if (withDefaults !== false) {
              result['name'] = '';
            } else {
              delete result['name'];
            }
            if (json['number'] != null) {
              result['number'] = json['number'];
            } else if (withDefaults !== false) {
              result['number'] = 0;
            } else {
              delete result['number'];
            }
            if (json['label'] != null) {
              result['label'] = typeof json['label'] === 'string' ? json['label'] : $root.google.protobuf.FieldDescriptorProto.Label[json['label']];
            } else if (withDefaults !== false) {
              result['label'] = 'LABEL_OPTIONAL';
            } else {
              delete result['label'];
            }
            if (json['type'] != null) {
              result['type'] = typeof json['type'] === 'string' ? json['type'] : $root.google.protobuf.FieldDescriptorProto.Type[json['type']];
            } else if (withDefaults !== false) {
              result['type'] = 'TYPE_DOUBLE';
            } else {
              delete result['type'];
            }
            if (json['typeName'] != null) {
              result['typeName'] = json['typeName'];
            } else if (withDefaults !== false) {
              result['typeName'] = '';
            } else {
              delete result['typeName'];
            }
            if (json['extendee'] != null) {
              result['extendee'] = json['extendee'];
            } else if (withDefaults !== false) {
              result['extendee'] = '';
            } else {
              delete result['extendee'];
            }
            if (json['defaultValue'] != null) {
              result['defaultValue'] = json['defaultValue'];
            } else if (withDefaults !== false) {
              result['defaultValue'] = '';
            } else {
              delete result['defaultValue'];
            }
            if (json['oneofIndex'] != null) {
              result['oneofIndex'] = json['oneofIndex'];
            } else if (withDefaults !== false) {
              result['oneofIndex'] = 0;
            } else {
              delete result['oneofIndex'];
            }
            if (json['jsonName'] != null) {
              result['jsonName'] = json['jsonName'];
            } else if (withDefaults !== false) {
              result['jsonName'] = '';
            } else {
              delete result['jsonName'];
            }
            if (json['options'] != null) {
              result['options'] = $root.google.protobuf.FieldOptions.fromJSON(json['options'], helper);
            } else if (withDefaults !== false) {
              delete result['options'];
            } else {
              delete result['options'];
            }
            if (json['proto3Optional'] != null) {
              result['proto3Optional'] = json['proto3Optional'];
            } else if (withDefaults !== false) {
              result['proto3Optional'] = false;
            } else {
              delete result['proto3Optional'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['name'] != null) {
              grpc['name'] = obj['name'];
            }
            if (obj['number'] != null) {
              grpc['number'] = obj['number'];
            }
            if (obj['label'] != null) {
              grpc['label'] = obj['label'];
            }
            if (obj['type'] != null) {
              grpc['type'] = obj['type'];
            }
            if (obj['typeName'] != null) {
              grpc['typeName'] = obj['typeName'];
            }
            if (obj['extendee'] != null) {
              grpc['extendee'] = obj['extendee'];
            }
            if (obj['defaultValue'] != null) {
              grpc['defaultValue'] = obj['defaultValue'];
            }
            if (obj['oneofIndex'] != null) {
              grpc['oneofIndex'] = obj['oneofIndex'];
            }
            if (obj['jsonName'] != null) {
              grpc['jsonName'] = obj['jsonName'];
            }
            if (obj['options'] != null) {
              grpc['options'] = $root.google.protobuf.FieldOptions.toGRPC(obj['options'], helper);
            }
            if (obj['proto3Optional'] != null) {
              grpc['proto3Optional'] = obj['proto3Optional'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.FieldDescriptorProto();
            if (grpc['name'] != null) {
              result['name'] = grpc['name'];
            } else {
              result['name'] = '';
            }
            if (grpc['number'] != null) {
              result['number'] = grpc['number'];
            } else {
              result['number'] = 0;
            }
            if (grpc['label'] != null) {
              result['label'] = grpc['label'];
            } else {
              result['label'] = 'LABEL_OPTIONAL';
            }
            if (grpc['type'] != null) {
              result['type'] = grpc['type'];
            } else {
              result['type'] = 'TYPE_DOUBLE';
            }
            if (grpc['typeName'] != null) {
              result['typeName'] = grpc['typeName'];
            } else {
              result['typeName'] = '';
            }
            if (grpc['extendee'] != null) {
              result['extendee'] = grpc['extendee'];
            } else {
              result['extendee'] = '';
            }
            if (grpc['defaultValue'] != null) {
              result['defaultValue'] = grpc['defaultValue'];
            } else {
              result['defaultValue'] = '';
            }
            if (grpc['oneofIndex'] != null) {
              result['oneofIndex'] = grpc['oneofIndex'];
            } else {
              result['oneofIndex'] = 0;
            }
            if (grpc['jsonName'] != null) {
              result['jsonName'] = grpc['jsonName'];
            } else {
              result['jsonName'] = '';
            }
            if (grpc['options'] != null) {
              result['options'] = $root.google.protobuf.FieldOptions.fromGRPC(grpc['options'], helper);
            } else {
              delete result['options'];
            }
            if (grpc['proto3Optional'] != null) {
              result['proto3Optional'] = grpc['proto3Optional'];
            } else {
              result['proto3Optional'] = false;
            }
            return result;
          }
        }
      }
      FieldDescriptorProto.Type = {
        'TYPE_DOUBLE': 'TYPE_DOUBLE',
        1: 'TYPE_DOUBLE',
        'TYPE_FLOAT': 'TYPE_FLOAT',
        2: 'TYPE_FLOAT',
        'TYPE_INT64': 'TYPE_INT64',
        3: 'TYPE_INT64',
        'TYPE_UINT64': 'TYPE_UINT64',
        4: 'TYPE_UINT64',
        'TYPE_INT32': 'TYPE_INT32',
        5: 'TYPE_INT32',
        'TYPE_FIXED64': 'TYPE_FIXED64',
        6: 'TYPE_FIXED64',
        'TYPE_FIXED32': 'TYPE_FIXED32',
        7: 'TYPE_FIXED32',
        'TYPE_BOOL': 'TYPE_BOOL',
        8: 'TYPE_BOOL',
        'TYPE_STRING': 'TYPE_STRING',
        9: 'TYPE_STRING',
        'TYPE_GROUP': 'TYPE_GROUP',
        10: 'TYPE_GROUP',
        'TYPE_MESSAGE': 'TYPE_MESSAGE',
        11: 'TYPE_MESSAGE',
        'TYPE_BYTES': 'TYPE_BYTES',
        12: 'TYPE_BYTES',
        'TYPE_UINT32': 'TYPE_UINT32',
        13: 'TYPE_UINT32',
        'TYPE_ENUM': 'TYPE_ENUM',
        14: 'TYPE_ENUM',
        'TYPE_SFIXED32': 'TYPE_SFIXED32',
        15: 'TYPE_SFIXED32',
        'TYPE_SFIXED64': 'TYPE_SFIXED64',
        16: 'TYPE_SFIXED64',
        'TYPE_SINT32': 'TYPE_SINT32',
        17: 'TYPE_SINT32',
        'TYPE_SINT64': 'TYPE_SINT64',
        18: 'TYPE_SINT64'
      };
      FieldDescriptorProto.Label = {
        'LABEL_OPTIONAL': 'LABEL_OPTIONAL',
        1: 'LABEL_OPTIONAL',
        'LABEL_REQUIRED': 'LABEL_REQUIRED',
        2: 'LABEL_REQUIRED',
        'LABEL_REPEATED': 'LABEL_REPEATED',
        3: 'LABEL_REPEATED'
      };
      FieldDescriptorProto.Type = {
        'TYPE_DOUBLE': 'TYPE_DOUBLE',
        1: 'TYPE_DOUBLE',
        'TYPE_FLOAT': 'TYPE_FLOAT',
        2: 'TYPE_FLOAT',
        'TYPE_INT64': 'TYPE_INT64',
        3: 'TYPE_INT64',
        'TYPE_UINT64': 'TYPE_UINT64',
        4: 'TYPE_UINT64',
        'TYPE_INT32': 'TYPE_INT32',
        5: 'TYPE_INT32',
        'TYPE_FIXED64': 'TYPE_FIXED64',
        6: 'TYPE_FIXED64',
        'TYPE_FIXED32': 'TYPE_FIXED32',
        7: 'TYPE_FIXED32',
        'TYPE_BOOL': 'TYPE_BOOL',
        8: 'TYPE_BOOL',
        'TYPE_STRING': 'TYPE_STRING',
        9: 'TYPE_STRING',
        'TYPE_GROUP': 'TYPE_GROUP',
        10: 'TYPE_GROUP',
        'TYPE_MESSAGE': 'TYPE_MESSAGE',
        11: 'TYPE_MESSAGE',
        'TYPE_BYTES': 'TYPE_BYTES',
        12: 'TYPE_BYTES',
        'TYPE_UINT32': 'TYPE_UINT32',
        13: 'TYPE_UINT32',
        'TYPE_ENUM': 'TYPE_ENUM',
        14: 'TYPE_ENUM',
        'TYPE_SFIXED32': 'TYPE_SFIXED32',
        15: 'TYPE_SFIXED32',
        'TYPE_SFIXED64': 'TYPE_SFIXED64',
        16: 'TYPE_SFIXED64',
        'TYPE_SINT32': 'TYPE_SINT32',
        17: 'TYPE_SINT32',
        'TYPE_SINT64': 'TYPE_SINT64',
        18: 'TYPE_SINT64'
      };
      FieldDescriptorProto.Label = {
        'LABEL_OPTIONAL': 'LABEL_OPTIONAL',
        1: 'LABEL_OPTIONAL',
        'LABEL_REQUIRED': 'LABEL_REQUIRED',
        2: 'LABEL_REQUIRED',
        'LABEL_REPEATED': 'LABEL_REPEATED',
        3: 'LABEL_REPEATED'
      };
      __builtIn.Object.defineProperty(FieldDescriptorProto.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.FieldDescriptorProto');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FieldDescriptorProto.prototype, '__fqn__', {
        value: 'google.protobuf.FieldDescriptorProto',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FieldDescriptorProto.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FieldDescriptorProto.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return FieldDescriptorProto;
    }());;
    _protobuf.OneofDescriptorProto = (function () {
      class OneofDescriptorProto {
        constructor(props) {
          this.name = props && props.name;
          this.options = props && props.options;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['name'] != null) {
              json['name'] = obj['name'];
            } else if (withDefaults) {
              json['name'] = '';
            }
            if (obj['options'] != null) {
              json['options'] = $root.google.protobuf.OneofOptions.toJSON(obj['options'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['options'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.OneofDescriptorProto();
            if (json['name'] != null) {
              result['name'] = json['name'];
            } else if (withDefaults !== false) {
              result['name'] = '';
            } else {
              delete result['name'];
            }
            if (json['options'] != null) {
              result['options'] = $root.google.protobuf.OneofOptions.fromJSON(json['options'], helper);
            } else if (withDefaults !== false) {
              delete result['options'];
            } else {
              delete result['options'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['name'] != null) {
              grpc['name'] = obj['name'];
            }
            if (obj['options'] != null) {
              grpc['options'] = $root.google.protobuf.OneofOptions.toGRPC(obj['options'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.OneofDescriptorProto();
            if (grpc['name'] != null) {
              result['name'] = grpc['name'];
            } else {
              result['name'] = '';
            }
            if (grpc['options'] != null) {
              result['options'] = $root.google.protobuf.OneofOptions.fromGRPC(grpc['options'], helper);
            } else {
              delete result['options'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(OneofDescriptorProto.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.OneofDescriptorProto');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(OneofDescriptorProto.prototype, '__fqn__', {
        value: 'google.protobuf.OneofDescriptorProto',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(OneofDescriptorProto.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(OneofDescriptorProto.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return OneofDescriptorProto;
    }());;
    _protobuf.EnumDescriptorProto = (function () {
      class EnumDescriptorProto {
        constructor(props) {
          this.name = props && props.name;
          this.value = props && props.value;
          this.options = props && props.options;
          this.reservedRange = props && props.reservedRange;
          this.reservedName = props && props.reservedName;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['name'] != null) {
              json['name'] = obj['name'];
            } else if (withDefaults) {
              json['name'] = '';
            }
            if (obj['value'] != null) {
              json['value'] = obj['value'].map(e => {
                return $root.google.protobuf.EnumValueDescriptorProto.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['value'] = [];
            }
            if (obj['options'] != null) {
              json['options'] = $root.google.protobuf.EnumOptions.toJSON(obj['options'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['options'];
            }
            if (obj['reservedRange'] != null) {
              json['reservedRange'] = obj['reservedRange'].map(e => {
                return $root.google.protobuf.EnumDescriptorProto.EnumReservedRange.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['reservedRange'] = [];
            }
            if (obj['reservedName'] != null) {
              json['reservedName'] = obj['reservedName'].map(e => {
                return e;
              });
            } else if (withDefaults) {
              json['reservedName'] = [];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.EnumDescriptorProto();
            if (json['name'] != null) {
              result['name'] = json['name'];
            } else if (withDefaults !== false) {
              result['name'] = '';
            } else {
              delete result['name'];
            }
            if (json['value'] != null) {
              result['value'] = Array.isArray(json['value']) ? json['value'].map(e => {
                return $root.google.protobuf.EnumValueDescriptorProto.fromJSON(e, helper);
              }) : json['value'];
            } else if (withDefaults !== false) {
              result['value'] = [];
            } else {
              delete result['value'];
            }
            if (json['options'] != null) {
              result['options'] = $root.google.protobuf.EnumOptions.fromJSON(json['options'], helper);
            } else if (withDefaults !== false) {
              delete result['options'];
            } else {
              delete result['options'];
            }
            if (json['reservedRange'] != null) {
              result['reservedRange'] = Array.isArray(json['reservedRange']) ? json['reservedRange'].map(e => {
                return $root.google.protobuf.EnumDescriptorProto.EnumReservedRange.fromJSON(e, helper);
              }) : json['reservedRange'];
            } else if (withDefaults !== false) {
              result['reservedRange'] = [];
            } else {
              delete result['reservedRange'];
            }
            if (json['reservedName'] != null) {
              result['reservedName'] = Array.isArray(json['reservedName']) ? json['reservedName'].map(e => {
                return e;
              }) : json['reservedName'];
            } else if (withDefaults !== false) {
              result['reservedName'] = [];
            } else {
              delete result['reservedName'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['name'] != null) {
              grpc['name'] = obj['name'];
            }
            if (obj['value'] != null) {
              grpc['value'] = obj['value'].map(e => {
                return $root.google.protobuf.EnumValueDescriptorProto.toGRPC(e, helper);
              });
            }
            if (obj['options'] != null) {
              grpc['options'] = $root.google.protobuf.EnumOptions.toGRPC(obj['options'], helper);
            }
            if (obj['reservedRange'] != null) {
              grpc['reservedRange'] = obj['reservedRange'].map(e => {
                return $root.google.protobuf.EnumDescriptorProto.EnumReservedRange.toGRPC(e, helper);
              });
            }
            if (obj['reservedName'] != null) {
              grpc['reservedName'] = obj['reservedName'].map(e => {
                return e;
              });
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.EnumDescriptorProto();
            if (grpc['name'] != null) {
              result['name'] = grpc['name'];
            } else {
              result['name'] = '';
            }
            if (grpc['value'] != null) {
              result['value'] = grpc['value'].map(e => {
                return $root.google.protobuf.EnumValueDescriptorProto.fromGRPC(e, helper);
              });
            } else {
              result['value'] = [];
            }
            if (grpc['options'] != null) {
              result['options'] = $root.google.protobuf.EnumOptions.fromGRPC(grpc['options'], helper);
            } else {
              delete result['options'];
            }
            if (grpc['reservedRange'] != null) {
              result['reservedRange'] = grpc['reservedRange'].map(e => {
                return $root.google.protobuf.EnumDescriptorProto.EnumReservedRange.fromGRPC(e, helper);
              });
            } else {
              result['reservedRange'] = [];
            }
            if (grpc['reservedName'] != null) {
              result['reservedName'] = grpc['reservedName'].map(e => {
                return e;
              });
            } else {
              result['reservedName'] = [];
            }
            return result;
          }
        }
      }
      EnumDescriptorProto.EnumReservedRange = (function () {
        class EnumReservedRange {
          constructor(props) {
            this.start = props && props.start;
            this.end = props && props.end;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['start'] != null) {
                json['start'] = obj['start'];
              } else if (withDefaults) {
                json['start'] = 0;
              }
              if (obj['end'] != null) {
                json['end'] = obj['end'];
              } else if (withDefaults) {
                json['end'] = 0;
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.google.protobuf.EnumDescriptorProto.EnumReservedRange();
              if (json['start'] != null) {
                result['start'] = json['start'];
              } else if (withDefaults !== false) {
                result['start'] = 0;
              } else {
                delete result['start'];
              }
              if (json['end'] != null) {
                result['end'] = json['end'];
              } else if (withDefaults !== false) {
                result['end'] = 0;
              } else {
                delete result['end'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['start'] != null) {
                grpc['start'] = obj['start'];
              }
              if (obj['end'] != null) {
                grpc['end'] = obj['end'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.google.protobuf.EnumDescriptorProto.EnumReservedRange();
              if (grpc['start'] != null) {
                result['start'] = grpc['start'];
              } else {
                result['start'] = 0;
              }
              if (grpc['end'] != null) {
                result['end'] = grpc['end'];
              } else {
                result['end'] = 0;
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(EnumReservedRange.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('google.protobuf.EnumDescriptorProto.EnumReservedRange');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(EnumReservedRange.prototype, '__fqn__', {
          value: 'google.protobuf.EnumDescriptorProto.EnumReservedRange',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(EnumReservedRange.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(EnumReservedRange.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return EnumReservedRange;
      }());;
      EnumDescriptorProto.EnumReservedRange = (function () {
        class EnumReservedRange {
          constructor(props) {
            this.start = props && props.start;
            this.end = props && props.end;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['start'] != null) {
                json['start'] = obj['start'];
              } else if (withDefaults) {
                json['start'] = 0;
              }
              if (obj['end'] != null) {
                json['end'] = obj['end'];
              } else if (withDefaults) {
                json['end'] = 0;
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.google.protobuf.EnumDescriptorProto.EnumReservedRange();
              if (json['start'] != null) {
                result['start'] = json['start'];
              } else if (withDefaults !== false) {
                result['start'] = 0;
              } else {
                delete result['start'];
              }
              if (json['end'] != null) {
                result['end'] = json['end'];
              } else if (withDefaults !== false) {
                result['end'] = 0;
              } else {
                delete result['end'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['start'] != null) {
                grpc['start'] = obj['start'];
              }
              if (obj['end'] != null) {
                grpc['end'] = obj['end'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.google.protobuf.EnumDescriptorProto.EnumReservedRange();
              if (grpc['start'] != null) {
                result['start'] = grpc['start'];
              } else {
                result['start'] = 0;
              }
              if (grpc['end'] != null) {
                result['end'] = grpc['end'];
              } else {
                result['end'] = 0;
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(EnumReservedRange.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('google.protobuf.EnumDescriptorProto.EnumReservedRange');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(EnumReservedRange.prototype, '__fqn__', {
          value: 'google.protobuf.EnumDescriptorProto.EnumReservedRange',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(EnumReservedRange.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(EnumReservedRange.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return EnumReservedRange;
      }());;
      __builtIn.Object.defineProperty(EnumDescriptorProto.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.EnumDescriptorProto');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(EnumDescriptorProto.prototype, '__fqn__', {
        value: 'google.protobuf.EnumDescriptorProto',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(EnumDescriptorProto.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(EnumDescriptorProto.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return EnumDescriptorProto;
    }());;
    _protobuf.EnumValueDescriptorProto = (function () {
      class EnumValueDescriptorProto {
        constructor(props) {
          this.name = props && props.name;
          this.number = props && props.number;
          this.options = props && props.options;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['name'] != null) {
              json['name'] = obj['name'];
            } else if (withDefaults) {
              json['name'] = '';
            }
            if (obj['number'] != null) {
              json['number'] = obj['number'];
            } else if (withDefaults) {
              json['number'] = 0;
            }
            if (obj['options'] != null) {
              json['options'] = $root.google.protobuf.EnumValueOptions.toJSON(obj['options'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['options'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.EnumValueDescriptorProto();
            if (json['name'] != null) {
              result['name'] = json['name'];
            } else if (withDefaults !== false) {
              result['name'] = '';
            } else {
              delete result['name'];
            }
            if (json['number'] != null) {
              result['number'] = json['number'];
            } else if (withDefaults !== false) {
              result['number'] = 0;
            } else {
              delete result['number'];
            }
            if (json['options'] != null) {
              result['options'] = $root.google.protobuf.EnumValueOptions.fromJSON(json['options'], helper);
            } else if (withDefaults !== false) {
              delete result['options'];
            } else {
              delete result['options'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['name'] != null) {
              grpc['name'] = obj['name'];
            }
            if (obj['number'] != null) {
              grpc['number'] = obj['number'];
            }
            if (obj['options'] != null) {
              grpc['options'] = $root.google.protobuf.EnumValueOptions.toGRPC(obj['options'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.EnumValueDescriptorProto();
            if (grpc['name'] != null) {
              result['name'] = grpc['name'];
            } else {
              result['name'] = '';
            }
            if (grpc['number'] != null) {
              result['number'] = grpc['number'];
            } else {
              result['number'] = 0;
            }
            if (grpc['options'] != null) {
              result['options'] = $root.google.protobuf.EnumValueOptions.fromGRPC(grpc['options'], helper);
            } else {
              delete result['options'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(EnumValueDescriptorProto.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.EnumValueDescriptorProto');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(EnumValueDescriptorProto.prototype, '__fqn__', {
        value: 'google.protobuf.EnumValueDescriptorProto',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(EnumValueDescriptorProto.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(EnumValueDescriptorProto.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return EnumValueDescriptorProto;
    }());;
    _protobuf.ServiceDescriptorProto = (function () {
      class ServiceDescriptorProto {
        constructor(props) {
          this.name = props && props.name;
          this.method = props && props.method;
          this.options = props && props.options;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['name'] != null) {
              json['name'] = obj['name'];
            } else if (withDefaults) {
              json['name'] = '';
            }
            if (obj['method'] != null) {
              json['method'] = obj['method'].map(e => {
                return $root.google.protobuf.MethodDescriptorProto.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['method'] = [];
            }
            if (obj['options'] != null) {
              json['options'] = $root.google.protobuf.ServiceOptions.toJSON(obj['options'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['options'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.ServiceDescriptorProto();
            if (json['name'] != null) {
              result['name'] = json['name'];
            } else if (withDefaults !== false) {
              result['name'] = '';
            } else {
              delete result['name'];
            }
            if (json['method'] != null) {
              result['method'] = Array.isArray(json['method']) ? json['method'].map(e => {
                return $root.google.protobuf.MethodDescriptorProto.fromJSON(e, helper);
              }) : json['method'];
            } else if (withDefaults !== false) {
              result['method'] = [];
            } else {
              delete result['method'];
            }
            if (json['options'] != null) {
              result['options'] = $root.google.protobuf.ServiceOptions.fromJSON(json['options'], helper);
            } else if (withDefaults !== false) {
              delete result['options'];
            } else {
              delete result['options'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['name'] != null) {
              grpc['name'] = obj['name'];
            }
            if (obj['method'] != null) {
              grpc['method'] = obj['method'].map(e => {
                return $root.google.protobuf.MethodDescriptorProto.toGRPC(e, helper);
              });
            }
            if (obj['options'] != null) {
              grpc['options'] = $root.google.protobuf.ServiceOptions.toGRPC(obj['options'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.ServiceDescriptorProto();
            if (grpc['name'] != null) {
              result['name'] = grpc['name'];
            } else {
              result['name'] = '';
            }
            if (grpc['method'] != null) {
              result['method'] = grpc['method'].map(e => {
                return $root.google.protobuf.MethodDescriptorProto.fromGRPC(e, helper);
              });
            } else {
              result['method'] = [];
            }
            if (grpc['options'] != null) {
              result['options'] = $root.google.protobuf.ServiceOptions.fromGRPC(grpc['options'], helper);
            } else {
              delete result['options'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(ServiceDescriptorProto.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.ServiceDescriptorProto');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ServiceDescriptorProto.prototype, '__fqn__', {
        value: 'google.protobuf.ServiceDescriptorProto',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ServiceDescriptorProto.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ServiceDescriptorProto.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return ServiceDescriptorProto;
    }());;
    _protobuf.MethodDescriptorProto = (function () {
      class MethodDescriptorProto {
        constructor(props) {
          this.name = props && props.name;
          this.inputType = props && props.inputType;
          this.outputType = props && props.outputType;
          this.options = props && props.options;
          this.clientStreaming = props && props.clientStreaming;
          this.serverStreaming = props && props.serverStreaming;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['name'] != null) {
              json['name'] = obj['name'];
            } else if (withDefaults) {
              json['name'] = '';
            }
            if (obj['inputType'] != null) {
              json['inputType'] = obj['inputType'];
            } else if (withDefaults) {
              json['inputType'] = '';
            }
            if (obj['outputType'] != null) {
              json['outputType'] = obj['outputType'];
            } else if (withDefaults) {
              json['outputType'] = '';
            }
            if (obj['options'] != null) {
              json['options'] = $root.google.protobuf.MethodOptions.toJSON(obj['options'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['options'];
            }
            if (obj['clientStreaming'] != null) {
              json['clientStreaming'] = obj['clientStreaming'];
            } else if (withDefaults) {
              json['clientStreaming'] = false;
            }
            if (obj['serverStreaming'] != null) {
              json['serverStreaming'] = obj['serverStreaming'];
            } else if (withDefaults) {
              json['serverStreaming'] = false;
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.MethodDescriptorProto();
            if (json['name'] != null) {
              result['name'] = json['name'];
            } else if (withDefaults !== false) {
              result['name'] = '';
            } else {
              delete result['name'];
            }
            if (json['inputType'] != null) {
              result['inputType'] = json['inputType'];
            } else if (withDefaults !== false) {
              result['inputType'] = '';
            } else {
              delete result['inputType'];
            }
            if (json['outputType'] != null) {
              result['outputType'] = json['outputType'];
            } else if (withDefaults !== false) {
              result['outputType'] = '';
            } else {
              delete result['outputType'];
            }
            if (json['options'] != null) {
              result['options'] = $root.google.protobuf.MethodOptions.fromJSON(json['options'], helper);
            } else if (withDefaults !== false) {
              delete result['options'];
            } else {
              delete result['options'];
            }
            if (json['clientStreaming'] != null) {
              result['clientStreaming'] = json['clientStreaming'];
            } else if (withDefaults !== false) {
              result['clientStreaming'] = false;
            } else {
              delete result['clientStreaming'];
            }
            if (json['serverStreaming'] != null) {
              result['serverStreaming'] = json['serverStreaming'];
            } else if (withDefaults !== false) {
              result['serverStreaming'] = false;
            } else {
              delete result['serverStreaming'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['name'] != null) {
              grpc['name'] = obj['name'];
            }
            if (obj['inputType'] != null) {
              grpc['inputType'] = obj['inputType'];
            }
            if (obj['outputType'] != null) {
              grpc['outputType'] = obj['outputType'];
            }
            if (obj['options'] != null) {
              grpc['options'] = $root.google.protobuf.MethodOptions.toGRPC(obj['options'], helper);
            }
            if (obj['clientStreaming'] != null) {
              grpc['clientStreaming'] = obj['clientStreaming'];
            }
            if (obj['serverStreaming'] != null) {
              grpc['serverStreaming'] = obj['serverStreaming'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.MethodDescriptorProto();
            if (grpc['name'] != null) {
              result['name'] = grpc['name'];
            } else {
              result['name'] = '';
            }
            if (grpc['inputType'] != null) {
              result['inputType'] = grpc['inputType'];
            } else {
              result['inputType'] = '';
            }
            if (grpc['outputType'] != null) {
              result['outputType'] = grpc['outputType'];
            } else {
              result['outputType'] = '';
            }
            if (grpc['options'] != null) {
              result['options'] = $root.google.protobuf.MethodOptions.fromGRPC(grpc['options'], helper);
            } else {
              delete result['options'];
            }
            if (grpc['clientStreaming'] != null) {
              result['clientStreaming'] = grpc['clientStreaming'];
            } else {
              result['clientStreaming'] = false;
            }
            if (grpc['serverStreaming'] != null) {
              result['serverStreaming'] = grpc['serverStreaming'];
            } else {
              result['serverStreaming'] = false;
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(MethodDescriptorProto.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.MethodDescriptorProto');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(MethodDescriptorProto.prototype, '__fqn__', {
        value: 'google.protobuf.MethodDescriptorProto',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(MethodDescriptorProto.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(MethodDescriptorProto.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return MethodDescriptorProto;
    }());;
    _protobuf.FileOptions = (function () {
      class FileOptions {
        constructor(props) {
          this.javaPackage = props && props.javaPackage;
          this.javaOuterClassname = props && props.javaOuterClassname;
          this.javaMultipleFiles = props && props.javaMultipleFiles;
          this.javaGenerateEqualsAndHash = props && props.javaGenerateEqualsAndHash;
          this.javaStringCheckUtf8 = props && props.javaStringCheckUtf8;
          this.optimizeFor = props && props.optimizeFor;
          this.goPackage = props && props.goPackage;
          this.ccGenericServices = props && props.ccGenericServices;
          this.javaGenericServices = props && props.javaGenericServices;
          this.pyGenericServices = props && props.pyGenericServices;
          this.phpGenericServices = props && props.phpGenericServices;
          this.deprecated = props && props.deprecated;
          this.ccEnableArenas = props && props.ccEnableArenas;
          this.objcClassPrefix = props && props.objcClassPrefix;
          this.csharpNamespace = props && props.csharpNamespace;
          this.swiftPrefix = props && props.swiftPrefix;
          this.phpClassPrefix = props && props.phpClassPrefix;
          this.phpNamespace = props && props.phpNamespace;
          this.phpMetadataNamespace = props && props.phpMetadataNamespace;
          this.rubyPackage = props && props.rubyPackage;
          this.uninterpretedOption = props && props.uninterpretedOption;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['javaPackage'] != null) {
              json['javaPackage'] = obj['javaPackage'];
            } else if (withDefaults) {
              json['javaPackage'] = '';
            }
            if (obj['javaOuterClassname'] != null) {
              json['javaOuterClassname'] = obj['javaOuterClassname'];
            } else if (withDefaults) {
              json['javaOuterClassname'] = '';
            }
            if (obj['javaMultipleFiles'] != null) {
              json['javaMultipleFiles'] = obj['javaMultipleFiles'];
            } else if (withDefaults) {
              json['javaMultipleFiles'] = false;
            }
            if (obj['javaGenerateEqualsAndHash'] != null) {
              json['javaGenerateEqualsAndHash'] = obj['javaGenerateEqualsAndHash'];
            } else if (withDefaults) {
              json['javaGenerateEqualsAndHash'] = false;
            }
            if (obj['javaStringCheckUtf8'] != null) {
              json['javaStringCheckUtf8'] = obj['javaStringCheckUtf8'];
            } else if (withDefaults) {
              json['javaStringCheckUtf8'] = false;
            }
            if (obj['optimizeFor'] != null) {
              json['optimizeFor'] = $root.google.protobuf.FileOptions.OptimizeMode[obj['optimizeFor']];
            } else if (withDefaults) {
              json['optimizeFor'] = 'SPEED';
            }
            if (obj['goPackage'] != null) {
              json['goPackage'] = obj['goPackage'];
            } else if (withDefaults) {
              json['goPackage'] = '';
            }
            if (obj['ccGenericServices'] != null) {
              json['ccGenericServices'] = obj['ccGenericServices'];
            } else if (withDefaults) {
              json['ccGenericServices'] = false;
            }
            if (obj['javaGenericServices'] != null) {
              json['javaGenericServices'] = obj['javaGenericServices'];
            } else if (withDefaults) {
              json['javaGenericServices'] = false;
            }
            if (obj['pyGenericServices'] != null) {
              json['pyGenericServices'] = obj['pyGenericServices'];
            } else if (withDefaults) {
              json['pyGenericServices'] = false;
            }
            if (obj['phpGenericServices'] != null) {
              json['phpGenericServices'] = obj['phpGenericServices'];
            } else if (withDefaults) {
              json['phpGenericServices'] = false;
            }
            if (obj['deprecated'] != null) {
              json['deprecated'] = obj['deprecated'];
            } else if (withDefaults) {
              json['deprecated'] = false;
            }
            if (obj['ccEnableArenas'] != null) {
              json['ccEnableArenas'] = obj['ccEnableArenas'];
            } else if (withDefaults) {
              json['ccEnableArenas'] = false;
            }
            if (obj['objcClassPrefix'] != null) {
              json['objcClassPrefix'] = obj['objcClassPrefix'];
            } else if (withDefaults) {
              json['objcClassPrefix'] = '';
            }
            if (obj['csharpNamespace'] != null) {
              json['csharpNamespace'] = obj['csharpNamespace'];
            } else if (withDefaults) {
              json['csharpNamespace'] = '';
            }
            if (obj['swiftPrefix'] != null) {
              json['swiftPrefix'] = obj['swiftPrefix'];
            } else if (withDefaults) {
              json['swiftPrefix'] = '';
            }
            if (obj['phpClassPrefix'] != null) {
              json['phpClassPrefix'] = obj['phpClassPrefix'];
            } else if (withDefaults) {
              json['phpClassPrefix'] = '';
            }
            if (obj['phpNamespace'] != null) {
              json['phpNamespace'] = obj['phpNamespace'];
            } else if (withDefaults) {
              json['phpNamespace'] = '';
            }
            if (obj['phpMetadataNamespace'] != null) {
              json['phpMetadataNamespace'] = obj['phpMetadataNamespace'];
            } else if (withDefaults) {
              json['phpMetadataNamespace'] = '';
            }
            if (obj['rubyPackage'] != null) {
              json['rubyPackage'] = obj['rubyPackage'];
            } else if (withDefaults) {
              json['rubyPackage'] = '';
            }
            if (obj['uninterpretedOption'] != null) {
              json['uninterpretedOption'] = obj['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['uninterpretedOption'] = [];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.FileOptions();
            if (json['javaPackage'] != null) {
              result['javaPackage'] = json['javaPackage'];
            } else if (withDefaults !== false) {
              result['javaPackage'] = '';
            } else {
              delete result['javaPackage'];
            }
            if (json['javaOuterClassname'] != null) {
              result['javaOuterClassname'] = json['javaOuterClassname'];
            } else if (withDefaults !== false) {
              result['javaOuterClassname'] = '';
            } else {
              delete result['javaOuterClassname'];
            }
            if (json['javaMultipleFiles'] != null) {
              result['javaMultipleFiles'] = json['javaMultipleFiles'];
            } else if (withDefaults !== false) {
              result['javaMultipleFiles'] = false;
            } else {
              delete result['javaMultipleFiles'];
            }
            if (json['javaGenerateEqualsAndHash'] != null) {
              result['javaGenerateEqualsAndHash'] = json['javaGenerateEqualsAndHash'];
            } else if (withDefaults !== false) {
              result['javaGenerateEqualsAndHash'] = false;
            } else {
              delete result['javaGenerateEqualsAndHash'];
            }
            if (json['javaStringCheckUtf8'] != null) {
              result['javaStringCheckUtf8'] = json['javaStringCheckUtf8'];
            } else if (withDefaults !== false) {
              result['javaStringCheckUtf8'] = false;
            } else {
              delete result['javaStringCheckUtf8'];
            }
            if (json['optimizeFor'] != null) {
              result['optimizeFor'] = typeof json['optimizeFor'] === 'string' ? json['optimizeFor'] : $root.google.protobuf.FileOptions.OptimizeMode[json['optimizeFor']];
            } else if (withDefaults !== false) {
              result['optimizeFor'] = 'SPEED';
            } else {
              delete result['optimizeFor'];
            }
            if (json['goPackage'] != null) {
              result['goPackage'] = json['goPackage'];
            } else if (withDefaults !== false) {
              result['goPackage'] = '';
            } else {
              delete result['goPackage'];
            }
            if (json['ccGenericServices'] != null) {
              result['ccGenericServices'] = json['ccGenericServices'];
            } else if (withDefaults !== false) {
              result['ccGenericServices'] = false;
            } else {
              delete result['ccGenericServices'];
            }
            if (json['javaGenericServices'] != null) {
              result['javaGenericServices'] = json['javaGenericServices'];
            } else if (withDefaults !== false) {
              result['javaGenericServices'] = false;
            } else {
              delete result['javaGenericServices'];
            }
            if (json['pyGenericServices'] != null) {
              result['pyGenericServices'] = json['pyGenericServices'];
            } else if (withDefaults !== false) {
              result['pyGenericServices'] = false;
            } else {
              delete result['pyGenericServices'];
            }
            if (json['phpGenericServices'] != null) {
              result['phpGenericServices'] = json['phpGenericServices'];
            } else if (withDefaults !== false) {
              result['phpGenericServices'] = false;
            } else {
              delete result['phpGenericServices'];
            }
            if (json['deprecated'] != null) {
              result['deprecated'] = json['deprecated'];
            } else if (withDefaults !== false) {
              result['deprecated'] = false;
            } else {
              delete result['deprecated'];
            }
            if (json['ccEnableArenas'] != null) {
              result['ccEnableArenas'] = json['ccEnableArenas'];
            } else if (withDefaults !== false) {
              result['ccEnableArenas'] = false;
            } else {
              delete result['ccEnableArenas'];
            }
            if (json['objcClassPrefix'] != null) {
              result['objcClassPrefix'] = json['objcClassPrefix'];
            } else if (withDefaults !== false) {
              result['objcClassPrefix'] = '';
            } else {
              delete result['objcClassPrefix'];
            }
            if (json['csharpNamespace'] != null) {
              result['csharpNamespace'] = json['csharpNamespace'];
            } else if (withDefaults !== false) {
              result['csharpNamespace'] = '';
            } else {
              delete result['csharpNamespace'];
            }
            if (json['swiftPrefix'] != null) {
              result['swiftPrefix'] = json['swiftPrefix'];
            } else if (withDefaults !== false) {
              result['swiftPrefix'] = '';
            } else {
              delete result['swiftPrefix'];
            }
            if (json['phpClassPrefix'] != null) {
              result['phpClassPrefix'] = json['phpClassPrefix'];
            } else if (withDefaults !== false) {
              result['phpClassPrefix'] = '';
            } else {
              delete result['phpClassPrefix'];
            }
            if (json['phpNamespace'] != null) {
              result['phpNamespace'] = json['phpNamespace'];
            } else if (withDefaults !== false) {
              result['phpNamespace'] = '';
            } else {
              delete result['phpNamespace'];
            }
            if (json['phpMetadataNamespace'] != null) {
              result['phpMetadataNamespace'] = json['phpMetadataNamespace'];
            } else if (withDefaults !== false) {
              result['phpMetadataNamespace'] = '';
            } else {
              delete result['phpMetadataNamespace'];
            }
            if (json['rubyPackage'] != null) {
              result['rubyPackage'] = json['rubyPackage'];
            } else if (withDefaults !== false) {
              result['rubyPackage'] = '';
            } else {
              delete result['rubyPackage'];
            }
            if (json['uninterpretedOption'] != null) {
              result['uninterpretedOption'] = Array.isArray(json['uninterpretedOption']) ? json['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.fromJSON(e, helper);
              }) : json['uninterpretedOption'];
            } else if (withDefaults !== false) {
              result['uninterpretedOption'] = [];
            } else {
              delete result['uninterpretedOption'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['javaPackage'] != null) {
              grpc['javaPackage'] = obj['javaPackage'];
            }
            if (obj['javaOuterClassname'] != null) {
              grpc['javaOuterClassname'] = obj['javaOuterClassname'];
            }
            if (obj['javaMultipleFiles'] != null) {
              grpc['javaMultipleFiles'] = obj['javaMultipleFiles'];
            }
            if (obj['javaGenerateEqualsAndHash'] != null) {
              grpc['javaGenerateEqualsAndHash'] = obj['javaGenerateEqualsAndHash'];
            }
            if (obj['javaStringCheckUtf8'] != null) {
              grpc['javaStringCheckUtf8'] = obj['javaStringCheckUtf8'];
            }
            if (obj['optimizeFor'] != null) {
              grpc['optimizeFor'] = obj['optimizeFor'];
            }
            if (obj['goPackage'] != null) {
              grpc['goPackage'] = obj['goPackage'];
            }
            if (obj['ccGenericServices'] != null) {
              grpc['ccGenericServices'] = obj['ccGenericServices'];
            }
            if (obj['javaGenericServices'] != null) {
              grpc['javaGenericServices'] = obj['javaGenericServices'];
            }
            if (obj['pyGenericServices'] != null) {
              grpc['pyGenericServices'] = obj['pyGenericServices'];
            }
            if (obj['phpGenericServices'] != null) {
              grpc['phpGenericServices'] = obj['phpGenericServices'];
            }
            if (obj['deprecated'] != null) {
              grpc['deprecated'] = obj['deprecated'];
            }
            if (obj['ccEnableArenas'] != null) {
              grpc['ccEnableArenas'] = obj['ccEnableArenas'];
            }
            if (obj['objcClassPrefix'] != null) {
              grpc['objcClassPrefix'] = obj['objcClassPrefix'];
            }
            if (obj['csharpNamespace'] != null) {
              grpc['csharpNamespace'] = obj['csharpNamespace'];
            }
            if (obj['swiftPrefix'] != null) {
              grpc['swiftPrefix'] = obj['swiftPrefix'];
            }
            if (obj['phpClassPrefix'] != null) {
              grpc['phpClassPrefix'] = obj['phpClassPrefix'];
            }
            if (obj['phpNamespace'] != null) {
              grpc['phpNamespace'] = obj['phpNamespace'];
            }
            if (obj['phpMetadataNamespace'] != null) {
              grpc['phpMetadataNamespace'] = obj['phpMetadataNamespace'];
            }
            if (obj['rubyPackage'] != null) {
              grpc['rubyPackage'] = obj['rubyPackage'];
            }
            if (obj['uninterpretedOption'] != null) {
              grpc['uninterpretedOption'] = obj['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.FileOptions();
            if (grpc['javaPackage'] != null) {
              result['javaPackage'] = grpc['javaPackage'];
            } else {
              result['javaPackage'] = '';
            }
            if (grpc['javaOuterClassname'] != null) {
              result['javaOuterClassname'] = grpc['javaOuterClassname'];
            } else {
              result['javaOuterClassname'] = '';
            }
            if (grpc['javaMultipleFiles'] != null) {
              result['javaMultipleFiles'] = grpc['javaMultipleFiles'];
            } else {
              result['javaMultipleFiles'] = false;
            }
            if (grpc['javaGenerateEqualsAndHash'] != null) {
              result['javaGenerateEqualsAndHash'] = grpc['javaGenerateEqualsAndHash'];
            } else {
              result['javaGenerateEqualsAndHash'] = false;
            }
            if (grpc['javaStringCheckUtf8'] != null) {
              result['javaStringCheckUtf8'] = grpc['javaStringCheckUtf8'];
            } else {
              result['javaStringCheckUtf8'] = false;
            }
            if (grpc['optimizeFor'] != null) {
              result['optimizeFor'] = grpc['optimizeFor'];
            } else {
              result['optimizeFor'] = 'SPEED';
            }
            if (grpc['goPackage'] != null) {
              result['goPackage'] = grpc['goPackage'];
            } else {
              result['goPackage'] = '';
            }
            if (grpc['ccGenericServices'] != null) {
              result['ccGenericServices'] = grpc['ccGenericServices'];
            } else {
              result['ccGenericServices'] = false;
            }
            if (grpc['javaGenericServices'] != null) {
              result['javaGenericServices'] = grpc['javaGenericServices'];
            } else {
              result['javaGenericServices'] = false;
            }
            if (grpc['pyGenericServices'] != null) {
              result['pyGenericServices'] = grpc['pyGenericServices'];
            } else {
              result['pyGenericServices'] = false;
            }
            if (grpc['phpGenericServices'] != null) {
              result['phpGenericServices'] = grpc['phpGenericServices'];
            } else {
              result['phpGenericServices'] = false;
            }
            if (grpc['deprecated'] != null) {
              result['deprecated'] = grpc['deprecated'];
            } else {
              result['deprecated'] = false;
            }
            if (grpc['ccEnableArenas'] != null) {
              result['ccEnableArenas'] = grpc['ccEnableArenas'];
            } else {
              result['ccEnableArenas'] = false;
            }
            if (grpc['objcClassPrefix'] != null) {
              result['objcClassPrefix'] = grpc['objcClassPrefix'];
            } else {
              result['objcClassPrefix'] = '';
            }
            if (grpc['csharpNamespace'] != null) {
              result['csharpNamespace'] = grpc['csharpNamespace'];
            } else {
              result['csharpNamespace'] = '';
            }
            if (grpc['swiftPrefix'] != null) {
              result['swiftPrefix'] = grpc['swiftPrefix'];
            } else {
              result['swiftPrefix'] = '';
            }
            if (grpc['phpClassPrefix'] != null) {
              result['phpClassPrefix'] = grpc['phpClassPrefix'];
            } else {
              result['phpClassPrefix'] = '';
            }
            if (grpc['phpNamespace'] != null) {
              result['phpNamespace'] = grpc['phpNamespace'];
            } else {
              result['phpNamespace'] = '';
            }
            if (grpc['phpMetadataNamespace'] != null) {
              result['phpMetadataNamespace'] = grpc['phpMetadataNamespace'];
            } else {
              result['phpMetadataNamespace'] = '';
            }
            if (grpc['rubyPackage'] != null) {
              result['rubyPackage'] = grpc['rubyPackage'];
            } else {
              result['rubyPackage'] = '';
            }
            if (grpc['uninterpretedOption'] != null) {
              result['uninterpretedOption'] = grpc['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.fromGRPC(e, helper);
              });
            } else {
              result['uninterpretedOption'] = [];
            }
            return result;
          }
        }
      }
      FileOptions.OptimizeMode = {
        'SPEED': 'SPEED',
        1: 'SPEED',
        'CODE_SIZE': 'CODE_SIZE',
        2: 'CODE_SIZE',
        'LITE_RUNTIME': 'LITE_RUNTIME',
        3: 'LITE_RUNTIME'
      };
      FileOptions.OptimizeMode = {
        'SPEED': 'SPEED',
        1: 'SPEED',
        'CODE_SIZE': 'CODE_SIZE',
        2: 'CODE_SIZE',
        'LITE_RUNTIME': 'LITE_RUNTIME',
        3: 'LITE_RUNTIME'
      };
      __builtIn.Object.defineProperty(FileOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.FileOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FileOptions.prototype, '__fqn__', {
        value: 'google.protobuf.FileOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FileOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FileOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return FileOptions;
    }());;
    _protobuf.MessageOptions = (function () {
      class MessageOptions {
        constructor(props) {
          this.messageSetWireFormat = props && props.messageSetWireFormat;
          this.noStandardDescriptorAccessor = props && props.noStandardDescriptorAccessor;
          this.deprecated = props && props.deprecated;
          this.mapEntry = props && props.mapEntry;
          this.uninterpretedOption = props && props.uninterpretedOption;
          this['wix.api.decompositeOf'] = props && props['wix.api.decompositeOf'];
          this['wix.api.decompositionMinimumFields'] = props && props['wix.api.decompositionMinimumFields'];
          this['wix.api.unwrapArrayValue'] = props && props['wix.api.unwrapArrayValue'];
          this['wix.api.messageDeprecated'] = props && props['wix.api.messageDeprecated'];
          this['wix.api.unique'] = props && props['wix.api.unique'];
          this['wix.api.entity'] = props && props['wix.api.entity'];
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['messageSetWireFormat'] != null) {
              json['messageSetWireFormat'] = obj['messageSetWireFormat'];
            } else if (withDefaults) {
              json['messageSetWireFormat'] = false;
            }
            if (obj['noStandardDescriptorAccessor'] != null) {
              json['noStandardDescriptorAccessor'] = obj['noStandardDescriptorAccessor'];
            } else if (withDefaults) {
              json['noStandardDescriptorAccessor'] = false;
            }
            if (obj['deprecated'] != null) {
              json['deprecated'] = obj['deprecated'];
            } else if (withDefaults) {
              json['deprecated'] = false;
            }
            if (obj['mapEntry'] != null) {
              json['mapEntry'] = obj['mapEntry'];
            } else if (withDefaults) {
              json['mapEntry'] = false;
            }
            if (obj['uninterpretedOption'] != null) {
              json['uninterpretedOption'] = obj['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['uninterpretedOption'] = [];
            }
            if (obj['wix.api.decompositeOf'] != null) {
              json['wix.api.decompositeOf'] = obj['wix.api.decompositeOf'];
            } else if (withDefaults) {
              json['wix.api.decompositeOf'] = '';
            }
            if (obj['wix.api.decompositionMinimumFields'] != null) {
              json['wix.api.decompositionMinimumFields'] = obj['wix.api.decompositionMinimumFields'].map(e => {
                return $root.wix.api.FieldSet.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['wix.api.decompositionMinimumFields'] = [];
            }
            if (obj['wix.api.unwrapArrayValue'] != null) {
              json['wix.api.unwrapArrayValue'] = obj['wix.api.unwrapArrayValue'];
            } else if (withDefaults) {
              json['wix.api.unwrapArrayValue'] = false;
            }
            if (obj['wix.api.messageDeprecated'] != null) {
              json['wix.api.messageDeprecated'] = $root.wix.api.Deprecated.toJSON(obj['wix.api.messageDeprecated'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['wix.api.messageDeprecated'];
            }
            if (obj['wix.api.unique'] != null) {
              json['wix.api.unique'] = obj['wix.api.unique'].map(e => {
                return $root.wix.api.Unique.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['wix.api.unique'] = [];
            }
            if (obj['wix.api.entity'] != null) {
              json['wix.api.entity'] = $root.wix.api.Entity.toJSON(obj['wix.api.entity'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['wix.api.entity'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.MessageOptions();
            if (json['messageSetWireFormat'] != null) {
              result['messageSetWireFormat'] = json['messageSetWireFormat'];
            } else if (withDefaults !== false) {
              result['messageSetWireFormat'] = false;
            } else {
              delete result['messageSetWireFormat'];
            }
            if (json['noStandardDescriptorAccessor'] != null) {
              result['noStandardDescriptorAccessor'] = json['noStandardDescriptorAccessor'];
            } else if (withDefaults !== false) {
              result['noStandardDescriptorAccessor'] = false;
            } else {
              delete result['noStandardDescriptorAccessor'];
            }
            if (json['deprecated'] != null) {
              result['deprecated'] = json['deprecated'];
            } else if (withDefaults !== false) {
              result['deprecated'] = false;
            } else {
              delete result['deprecated'];
            }
            if (json['mapEntry'] != null) {
              result['mapEntry'] = json['mapEntry'];
            } else if (withDefaults !== false) {
              result['mapEntry'] = false;
            } else {
              delete result['mapEntry'];
            }
            if (json['uninterpretedOption'] != null) {
              result['uninterpretedOption'] = Array.isArray(json['uninterpretedOption']) ? json['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.fromJSON(e, helper);
              }) : json['uninterpretedOption'];
            } else if (withDefaults !== false) {
              result['uninterpretedOption'] = [];
            } else {
              delete result['uninterpretedOption'];
            }
            if (json['wix.api.decompositeOf'] != null) {
              result['wix.api.decompositeOf'] = json['wix.api.decompositeOf'];
            } else if (withDefaults !== false) {
              result['wix.api.decompositeOf'] = '';
            } else {
              delete result['wix.api.decompositeOf'];
            }
            if (json['wix.api.decompositionMinimumFields'] != null) {
              result['wix.api.decompositionMinimumFields'] = Array.isArray(json['wix.api.decompositionMinimumFields']) ? json['wix.api.decompositionMinimumFields'].map(e => {
                return $root.wix.api.FieldSet.fromJSON(e, helper);
              }) : json['wix.api.decompositionMinimumFields'];
            } else if (withDefaults !== false) {
              result['wix.api.decompositionMinimumFields'] = [];
            } else {
              delete result['wix.api.decompositionMinimumFields'];
            }
            if (json['wix.api.unwrapArrayValue'] != null) {
              result['wix.api.unwrapArrayValue'] = json['wix.api.unwrapArrayValue'];
            } else if (withDefaults !== false) {
              result['wix.api.unwrapArrayValue'] = false;
            } else {
              delete result['wix.api.unwrapArrayValue'];
            }
            if (json['wix.api.messageDeprecated'] != null) {
              result['wix.api.messageDeprecated'] = $root.wix.api.Deprecated.fromJSON(json['wix.api.messageDeprecated'], helper);
            } else if (withDefaults !== false) {
              delete result['wix.api.messageDeprecated'];
            } else {
              delete result['wix.api.messageDeprecated'];
            }
            if (json['wix.api.unique'] != null) {
              result['wix.api.unique'] = Array.isArray(json['wix.api.unique']) ? json['wix.api.unique'].map(e => {
                return $root.wix.api.Unique.fromJSON(e, helper);
              }) : json['wix.api.unique'];
            } else if (withDefaults !== false) {
              result['wix.api.unique'] = [];
            } else {
              delete result['wix.api.unique'];
            }
            if (json['wix.api.entity'] != null) {
              result['wix.api.entity'] = $root.wix.api.Entity.fromJSON(json['wix.api.entity'], helper);
            } else if (withDefaults !== false) {
              delete result['wix.api.entity'];
            } else {
              delete result['wix.api.entity'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['messageSetWireFormat'] != null) {
              grpc['messageSetWireFormat'] = obj['messageSetWireFormat'];
            }
            if (obj['noStandardDescriptorAccessor'] != null) {
              grpc['noStandardDescriptorAccessor'] = obj['noStandardDescriptorAccessor'];
            }
            if (obj['deprecated'] != null) {
              grpc['deprecated'] = obj['deprecated'];
            }
            if (obj['mapEntry'] != null) {
              grpc['mapEntry'] = obj['mapEntry'];
            }
            if (obj['uninterpretedOption'] != null) {
              grpc['uninterpretedOption'] = obj['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.toGRPC(e, helper);
              });
            }
            if (obj['wix.api.decompositeOf'] != null) {
              grpc['wix.api.decompositeOf'] = obj['wix.api.decompositeOf'];
            }
            if (obj['wix.api.decompositionMinimumFields'] != null) {
              grpc['wix.api.decompositionMinimumFields'] = obj['wix.api.decompositionMinimumFields'].map(e => {
                return $root.wix.api.FieldSet.toGRPC(e, helper);
              });
            }
            if (obj['wix.api.unwrapArrayValue'] != null) {
              grpc['wix.api.unwrapArrayValue'] = obj['wix.api.unwrapArrayValue'];
            }
            if (obj['wix.api.messageDeprecated'] != null) {
              grpc['wix.api.messageDeprecated'] = $root.wix.api.Deprecated.toGRPC(obj['wix.api.messageDeprecated'], helper);
            }
            if (obj['wix.api.unique'] != null) {
              grpc['wix.api.unique'] = obj['wix.api.unique'].map(e => {
                return $root.wix.api.Unique.toGRPC(e, helper);
              });
            }
            if (obj['wix.api.entity'] != null) {
              grpc['wix.api.entity'] = $root.wix.api.Entity.toGRPC(obj['wix.api.entity'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.MessageOptions();
            if (grpc['messageSetWireFormat'] != null) {
              result['messageSetWireFormat'] = grpc['messageSetWireFormat'];
            } else {
              result['messageSetWireFormat'] = false;
            }
            if (grpc['noStandardDescriptorAccessor'] != null) {
              result['noStandardDescriptorAccessor'] = grpc['noStandardDescriptorAccessor'];
            } else {
              result['noStandardDescriptorAccessor'] = false;
            }
            if (grpc['deprecated'] != null) {
              result['deprecated'] = grpc['deprecated'];
            } else {
              result['deprecated'] = false;
            }
            if (grpc['mapEntry'] != null) {
              result['mapEntry'] = grpc['mapEntry'];
            } else {
              result['mapEntry'] = false;
            }
            if (grpc['uninterpretedOption'] != null) {
              result['uninterpretedOption'] = grpc['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.fromGRPC(e, helper);
              });
            } else {
              result['uninterpretedOption'] = [];
            }
            if (grpc['wix.api.decompositeOf'] != null) {
              result['wix.api.decompositeOf'] = grpc['wix.api.decompositeOf'];
            } else {
              result['wix.api.decompositeOf'] = '';
            }
            if (grpc['wix.api.decompositionMinimumFields'] != null) {
              result['wix.api.decompositionMinimumFields'] = grpc['wix.api.decompositionMinimumFields'].map(e => {
                return $root.wix.api.FieldSet.fromGRPC(e, helper);
              });
            } else {
              result['wix.api.decompositionMinimumFields'] = [];
            }
            if (grpc['wix.api.unwrapArrayValue'] != null) {
              result['wix.api.unwrapArrayValue'] = grpc['wix.api.unwrapArrayValue'];
            } else {
              result['wix.api.unwrapArrayValue'] = false;
            }
            if (grpc['wix.api.messageDeprecated'] != null) {
              result['wix.api.messageDeprecated'] = $root.wix.api.Deprecated.fromGRPC(grpc['wix.api.messageDeprecated'], helper);
            } else {
              delete result['wix.api.messageDeprecated'];
            }
            if (grpc['wix.api.unique'] != null) {
              result['wix.api.unique'] = grpc['wix.api.unique'].map(e => {
                return $root.wix.api.Unique.fromGRPC(e, helper);
              });
            } else {
              result['wix.api.unique'] = [];
            }
            if (grpc['wix.api.entity'] != null) {
              result['wix.api.entity'] = $root.wix.api.Entity.fromGRPC(grpc['wix.api.entity'], helper);
            } else {
              delete result['wix.api.entity'];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(MessageOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.MessageOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(MessageOptions.prototype, '__fqn__', {
        value: 'google.protobuf.MessageOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(MessageOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(MessageOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return MessageOptions;
    }());;
    _protobuf.FieldOptions = (function () {
      class FieldOptions {
        constructor(props) {
          this.ctype = props && props.ctype;
          this.packed = props && props.packed;
          this.jstype = props && props.jstype;
          this.lazy = props && props.lazy;
          this.deprecated = props && props.deprecated;
          this.weak = props && props.weak;
          this.uninterpretedOption = props && props.uninterpretedOption;
          this['wix.api.fieldExposure'] = props && props['wix.api.fieldExposure'];
          this['wix.api.fieldMaturity'] = props && props['wix.api.fieldMaturity'];
          this['wix.api.pii'] = props && props['wix.api.pii'];
          this['wix.api.referencedEntity'] = props && props['wix.api.referencedEntity'];
          this['wix.api.fieldDeprecated'] = props && props['wix.api.fieldDeprecated'];
          this['wix.api.translatable'] = props && props['wix.api.translatable'];
          this['wix.api.max'] = props && props['wix.api.max'];
          this['wix.api.min'] = props && props['wix.api.min'];
          this['wix.api.maxLength'] = props && props['wix.api.maxLength'];
          this['wix.api.minLength'] = props && props['wix.api.minLength'];
          this['wix.api.maxSize'] = props && props['wix.api.maxSize'];
          this['wix.api.minSize'] = props && props['wix.api.minSize'];
          this['wix.api.format'] = props && props['wix.api.format'];
          this['wix.api.readOnly'] = props && props['wix.api.readOnly'];
          this['wix.api.immutable'] = props && props['wix.api.immutable'];
          this['wix.api.decimalValue'] = props && props['wix.api.decimalValue'];
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['ctype'] != null) {
              json['ctype'] = $root.google.protobuf.FieldOptions.CType[obj['ctype']];
            } else if (withDefaults) {
              json['ctype'] = 'STRING';
            }
            if (obj['packed'] != null) {
              json['packed'] = obj['packed'];
            } else if (withDefaults) {
              json['packed'] = false;
            }
            if (obj['jstype'] != null) {
              json['jstype'] = $root.google.protobuf.FieldOptions.JSType[obj['jstype']];
            } else if (withDefaults) {
              json['jstype'] = 'JS_NORMAL';
            }
            if (obj['lazy'] != null) {
              json['lazy'] = obj['lazy'];
            } else if (withDefaults) {
              json['lazy'] = false;
            }
            if (obj['deprecated'] != null) {
              json['deprecated'] = obj['deprecated'];
            } else if (withDefaults) {
              json['deprecated'] = false;
            }
            if (obj['weak'] != null) {
              json['weak'] = obj['weak'];
            } else if (withDefaults) {
              json['weak'] = false;
            }
            if (obj['uninterpretedOption'] != null) {
              json['uninterpretedOption'] = obj['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['uninterpretedOption'] = [];
            }
            if (obj['wix.api.fieldExposure'] != null) {
              json['wix.api.fieldExposure'] = $root.wix.api.Exposure[obj['wix.api.fieldExposure']];
            } else if (withDefaults) {
              json['wix.api.fieldExposure'] = 'PRIVATE';
            }
            if (obj['wix.api.fieldMaturity'] != null) {
              json['wix.api.fieldMaturity'] = $root.wix.api.Maturity[obj['wix.api.fieldMaturity']];
            } else if (withDefaults) {
              json['wix.api.fieldMaturity'] = 'ALPHA';
            }
            if (obj['wix.api.pii'] != null) {
              json['wix.api.pii'] = obj['wix.api.pii'];
            } else if (withDefaults) {
              json['wix.api.pii'] = false;
            }
            if (obj['wix.api.referencedEntity'] != null) {
              json['wix.api.referencedEntity'] = obj['wix.api.referencedEntity'];
            } else if (withDefaults) {
              json['wix.api.referencedEntity'] = '';
            }
            if (obj['wix.api.fieldDeprecated'] != null) {
              json['wix.api.fieldDeprecated'] = $root.wix.api.Deprecated.toJSON(obj['wix.api.fieldDeprecated'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['wix.api.fieldDeprecated'];
            }
            if (obj['wix.api.translatable'] != null) {
              json['wix.api.translatable'] = $root.wix.api.Translatable.toJSON(obj['wix.api.translatable'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['wix.api.translatable'];
            }
            if (obj['wix.api.max'] != null) {
              json['wix.api.max'] = obj['wix.api.max'] == null ? obj['wix.api.max'] : isNaN(obj['wix.api.max']) ? 'NaN' : isFinite(obj['wix.api.max']) ? obj['wix.api.max'] : obj['wix.api.max'].toString();
            } else if (withDefaults) {
              json['wix.api.max'] = 0;
            }
            if (obj['wix.api.min'] != null) {
              json['wix.api.min'] = obj['wix.api.min'] == null ? obj['wix.api.min'] : isNaN(obj['wix.api.min']) ? 'NaN' : isFinite(obj['wix.api.min']) ? obj['wix.api.min'] : obj['wix.api.min'].toString();
            } else if (withDefaults) {
              json['wix.api.min'] = 0;
            }
            if (obj['wix.api.maxLength'] != null) {
              json['wix.api.maxLength'] = obj['wix.api.maxLength'];
            } else if (withDefaults) {
              json['wix.api.maxLength'] = 0;
            }
            if (obj['wix.api.minLength'] != null) {
              json['wix.api.minLength'] = obj['wix.api.minLength'];
            } else if (withDefaults) {
              json['wix.api.minLength'] = 0;
            }
            if (obj['wix.api.maxSize'] != null) {
              json['wix.api.maxSize'] = obj['wix.api.maxSize'];
            } else if (withDefaults) {
              json['wix.api.maxSize'] = 0;
            }
            if (obj['wix.api.minSize'] != null) {
              json['wix.api.minSize'] = obj['wix.api.minSize'];
            } else if (withDefaults) {
              json['wix.api.minSize'] = 0;
            }
            if (obj['wix.api.format'] != null) {
              json['wix.api.format'] = $root.wix.api.Format[obj['wix.api.format']];
            } else if (withDefaults) {
              json['wix.api.format'] = 'EMAIL';
            }
            if (obj['wix.api.readOnly'] != null) {
              json['wix.api.readOnly'] = obj['wix.api.readOnly'];
            } else if (withDefaults) {
              json['wix.api.readOnly'] = false;
            }
            if (obj['wix.api.immutable'] != null) {
              json['wix.api.immutable'] = obj['wix.api.immutable'];
            } else if (withDefaults) {
              json['wix.api.immutable'] = false;
            }
            if (obj['wix.api.decimalValue'] != null) {
              json['wix.api.decimalValue'] = $root.wix.api.DecimalValueOptions.toJSON(obj['wix.api.decimalValue'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['wix.api.decimalValue'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.FieldOptions();
            if (json['ctype'] != null) {
              result['ctype'] = typeof json['ctype'] === 'string' ? json['ctype'] : $root.google.protobuf.FieldOptions.CType[json['ctype']];
            } else if (withDefaults !== false) {
              result['ctype'] = 'STRING';
            } else {
              delete result['ctype'];
            }
            if (json['packed'] != null) {
              result['packed'] = json['packed'];
            } else if (withDefaults !== false) {
              result['packed'] = false;
            } else {
              delete result['packed'];
            }
            if (json['jstype'] != null) {
              result['jstype'] = typeof json['jstype'] === 'string' ? json['jstype'] : $root.google.protobuf.FieldOptions.JSType[json['jstype']];
            } else if (withDefaults !== false) {
              result['jstype'] = 'JS_NORMAL';
            } else {
              delete result['jstype'];
            }
            if (json['lazy'] != null) {
              result['lazy'] = json['lazy'];
            } else if (withDefaults !== false) {
              result['lazy'] = false;
            } else {
              delete result['lazy'];
            }
            if (json['deprecated'] != null) {
              result['deprecated'] = json['deprecated'];
            } else if (withDefaults !== false) {
              result['deprecated'] = false;
            } else {
              delete result['deprecated'];
            }
            if (json['weak'] != null) {
              result['weak'] = json['weak'];
            } else if (withDefaults !== false) {
              result['weak'] = false;
            } else {
              delete result['weak'];
            }
            if (json['uninterpretedOption'] != null) {
              result['uninterpretedOption'] = Array.isArray(json['uninterpretedOption']) ? json['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.fromJSON(e, helper);
              }) : json['uninterpretedOption'];
            } else if (withDefaults !== false) {
              result['uninterpretedOption'] = [];
            } else {
              delete result['uninterpretedOption'];
            }
            if (json['wix.api.fieldExposure'] != null) {
              result['wix.api.fieldExposure'] = typeof json['wix.api.fieldExposure'] === 'string' ? json['wix.api.fieldExposure'] : $root.wix.api.Exposure[json['wix.api.fieldExposure']];
            } else if (withDefaults !== false) {
              result['wix.api.fieldExposure'] = 'PRIVATE';
            } else {
              delete result['wix.api.fieldExposure'];
            }
            if (json['wix.api.fieldMaturity'] != null) {
              result['wix.api.fieldMaturity'] = typeof json['wix.api.fieldMaturity'] === 'string' ? json['wix.api.fieldMaturity'] : $root.wix.api.Maturity[json['wix.api.fieldMaturity']];
            } else if (withDefaults !== false) {
              result['wix.api.fieldMaturity'] = 'ALPHA';
            } else {
              delete result['wix.api.fieldMaturity'];
            }
            if (json['wix.api.pii'] != null) {
              result['wix.api.pii'] = json['wix.api.pii'];
            } else if (withDefaults !== false) {
              result['wix.api.pii'] = false;
            } else {
              delete result['wix.api.pii'];
            }
            if (json['wix.api.referencedEntity'] != null) {
              result['wix.api.referencedEntity'] = json['wix.api.referencedEntity'];
            } else if (withDefaults !== false) {
              result['wix.api.referencedEntity'] = '';
            } else {
              delete result['wix.api.referencedEntity'];
            }
            if (json['wix.api.fieldDeprecated'] != null) {
              result['wix.api.fieldDeprecated'] = $root.wix.api.Deprecated.fromJSON(json['wix.api.fieldDeprecated'], helper);
            } else if (withDefaults !== false) {
              delete result['wix.api.fieldDeprecated'];
            } else {
              delete result['wix.api.fieldDeprecated'];
            }
            if (json['wix.api.translatable'] != null) {
              result['wix.api.translatable'] = $root.wix.api.Translatable.fromJSON(json['wix.api.translatable'], helper);
            } else if (withDefaults !== false) {
              delete result['wix.api.translatable'];
            } else {
              delete result['wix.api.translatable'];
            }
            if (json['wix.api.max'] != null) {
              result['wix.api.max'] = json['wix.api.max'] === 'NaN' ? NaN : json['wix.api.max'] === 'Infinity' ? Infinity : json['wix.api.max'] === '-Infinity' ? -Infinity : json['wix.api.max'];
            } else if (withDefaults !== false) {
              result['wix.api.max'] = 0;
            } else {
              delete result['wix.api.max'];
            }
            if (json['wix.api.min'] != null) {
              result['wix.api.min'] = json['wix.api.min'] === 'NaN' ? NaN : json['wix.api.min'] === 'Infinity' ? Infinity : json['wix.api.min'] === '-Infinity' ? -Infinity : json['wix.api.min'];
            } else if (withDefaults !== false) {
              result['wix.api.min'] = 0;
            } else {
              delete result['wix.api.min'];
            }
            if (json['wix.api.maxLength'] != null) {
              result['wix.api.maxLength'] = json['wix.api.maxLength'];
            } else if (withDefaults !== false) {
              result['wix.api.maxLength'] = 0;
            } else {
              delete result['wix.api.maxLength'];
            }
            if (json['wix.api.minLength'] != null) {
              result['wix.api.minLength'] = json['wix.api.minLength'];
            } else if (withDefaults !== false) {
              result['wix.api.minLength'] = 0;
            } else {
              delete result['wix.api.minLength'];
            }
            if (json['wix.api.maxSize'] != null) {
              result['wix.api.maxSize'] = json['wix.api.maxSize'];
            } else if (withDefaults !== false) {
              result['wix.api.maxSize'] = 0;
            } else {
              delete result['wix.api.maxSize'];
            }
            if (json['wix.api.minSize'] != null) {
              result['wix.api.minSize'] = json['wix.api.minSize'];
            } else if (withDefaults !== false) {
              result['wix.api.minSize'] = 0;
            } else {
              delete result['wix.api.minSize'];
            }
            if (json['wix.api.format'] != null) {
              result['wix.api.format'] = typeof json['wix.api.format'] === 'string' ? json['wix.api.format'] : $root.wix.api.Format[json['wix.api.format']];
            } else if (withDefaults !== false) {
              result['wix.api.format'] = 'EMAIL';
            } else {
              delete result['wix.api.format'];
            }
            if (json['wix.api.readOnly'] != null) {
              result['wix.api.readOnly'] = json['wix.api.readOnly'];
            } else if (withDefaults !== false) {
              result['wix.api.readOnly'] = false;
            } else {
              delete result['wix.api.readOnly'];
            }
            if (json['wix.api.immutable'] != null) {
              result['wix.api.immutable'] = json['wix.api.immutable'];
            } else if (withDefaults !== false) {
              result['wix.api.immutable'] = false;
            } else {
              delete result['wix.api.immutable'];
            }
            if (json['wix.api.decimalValue'] != null) {
              result['wix.api.decimalValue'] = $root.wix.api.DecimalValueOptions.fromJSON(json['wix.api.decimalValue'], helper);
            } else if (withDefaults !== false) {
              delete result['wix.api.decimalValue'];
            } else {
              delete result['wix.api.decimalValue'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['ctype'] != null) {
              grpc['ctype'] = obj['ctype'];
            }
            if (obj['packed'] != null) {
              grpc['packed'] = obj['packed'];
            }
            if (obj['jstype'] != null) {
              grpc['jstype'] = obj['jstype'];
            }
            if (obj['lazy'] != null) {
              grpc['lazy'] = obj['lazy'];
            }
            if (obj['deprecated'] != null) {
              grpc['deprecated'] = obj['deprecated'];
            }
            if (obj['weak'] != null) {
              grpc['weak'] = obj['weak'];
            }
            if (obj['uninterpretedOption'] != null) {
              grpc['uninterpretedOption'] = obj['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.toGRPC(e, helper);
              });
            }
            if (obj['wix.api.fieldExposure'] != null) {
              grpc['wix.api.fieldExposure'] = obj['wix.api.fieldExposure'];
            }
            if (obj['wix.api.fieldMaturity'] != null) {
              grpc['wix.api.fieldMaturity'] = obj['wix.api.fieldMaturity'];
            }
            if (obj['wix.api.pii'] != null) {
              grpc['wix.api.pii'] = obj['wix.api.pii'];
            }
            if (obj['wix.api.referencedEntity'] != null) {
              grpc['wix.api.referencedEntity'] = obj['wix.api.referencedEntity'];
            }
            if (obj['wix.api.fieldDeprecated'] != null) {
              grpc['wix.api.fieldDeprecated'] = $root.wix.api.Deprecated.toGRPC(obj['wix.api.fieldDeprecated'], helper);
            }
            if (obj['wix.api.translatable'] != null) {
              grpc['wix.api.translatable'] = $root.wix.api.Translatable.toGRPC(obj['wix.api.translatable'], helper);
            }
            if (obj['wix.api.max'] != null) {
              grpc['wix.api.max'] = obj['wix.api.max'];
            }
            if (obj['wix.api.min'] != null) {
              grpc['wix.api.min'] = obj['wix.api.min'];
            }
            if (obj['wix.api.maxLength'] != null) {
              grpc['wix.api.maxLength'] = obj['wix.api.maxLength'];
            }
            if (obj['wix.api.minLength'] != null) {
              grpc['wix.api.minLength'] = obj['wix.api.minLength'];
            }
            if (obj['wix.api.maxSize'] != null) {
              grpc['wix.api.maxSize'] = obj['wix.api.maxSize'];
            }
            if (obj['wix.api.minSize'] != null) {
              grpc['wix.api.minSize'] = obj['wix.api.minSize'];
            }
            if (obj['wix.api.format'] != null) {
              grpc['wix.api.format'] = obj['wix.api.format'];
            }
            if (obj['wix.api.readOnly'] != null) {
              grpc['wix.api.readOnly'] = obj['wix.api.readOnly'];
            }
            if (obj['wix.api.immutable'] != null) {
              grpc['wix.api.immutable'] = obj['wix.api.immutable'];
            }
            if (obj['wix.api.decimalValue'] != null) {
              grpc['wix.api.decimalValue'] = $root.wix.api.DecimalValueOptions.toGRPC(obj['wix.api.decimalValue'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.FieldOptions();
            if (grpc['ctype'] != null) {
              result['ctype'] = grpc['ctype'];
            } else {
              result['ctype'] = 'STRING';
            }
            if (grpc['packed'] != null) {
              result['packed'] = grpc['packed'];
            } else {
              result['packed'] = false;
            }
            if (grpc['jstype'] != null) {
              result['jstype'] = grpc['jstype'];
            } else {
              result['jstype'] = 'JS_NORMAL';
            }
            if (grpc['lazy'] != null) {
              result['lazy'] = grpc['lazy'];
            } else {
              result['lazy'] = false;
            }
            if (grpc['deprecated'] != null) {
              result['deprecated'] = grpc['deprecated'];
            } else {
              result['deprecated'] = false;
            }
            if (grpc['weak'] != null) {
              result['weak'] = grpc['weak'];
            } else {
              result['weak'] = false;
            }
            if (grpc['uninterpretedOption'] != null) {
              result['uninterpretedOption'] = grpc['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.fromGRPC(e, helper);
              });
            } else {
              result['uninterpretedOption'] = [];
            }
            if (grpc['wix.api.fieldExposure'] != null) {
              result['wix.api.fieldExposure'] = grpc['wix.api.fieldExposure'];
            } else {
              result['wix.api.fieldExposure'] = 'PRIVATE';
            }
            if (grpc['wix.api.fieldMaturity'] != null) {
              result['wix.api.fieldMaturity'] = grpc['wix.api.fieldMaturity'];
            } else {
              result['wix.api.fieldMaturity'] = 'ALPHA';
            }
            if (grpc['wix.api.pii'] != null) {
              result['wix.api.pii'] = grpc['wix.api.pii'];
            } else {
              result['wix.api.pii'] = false;
            }
            if (grpc['wix.api.referencedEntity'] != null) {
              result['wix.api.referencedEntity'] = grpc['wix.api.referencedEntity'];
            } else {
              result['wix.api.referencedEntity'] = '';
            }
            if (grpc['wix.api.fieldDeprecated'] != null) {
              result['wix.api.fieldDeprecated'] = $root.wix.api.Deprecated.fromGRPC(grpc['wix.api.fieldDeprecated'], helper);
            } else {
              delete result['wix.api.fieldDeprecated'];
            }
            if (grpc['wix.api.translatable'] != null) {
              result['wix.api.translatable'] = $root.wix.api.Translatable.fromGRPC(grpc['wix.api.translatable'], helper);
            } else {
              delete result['wix.api.translatable'];
            }
            if (grpc['wix.api.max'] != null) {
              result['wix.api.max'] = grpc['wix.api.max'];
            } else {
              result['wix.api.max'] = 0;
            }
            if (grpc['wix.api.min'] != null) {
              result['wix.api.min'] = grpc['wix.api.min'];
            } else {
              result['wix.api.min'] = 0;
            }
            if (grpc['wix.api.maxLength'] != null) {
              result['wix.api.maxLength'] = grpc['wix.api.maxLength'];
            } else {
              result['wix.api.maxLength'] = 0;
            }
            if (grpc['wix.api.minLength'] != null) {
              result['wix.api.minLength'] = grpc['wix.api.minLength'];
            } else {
              result['wix.api.minLength'] = 0;
            }
            if (grpc['wix.api.maxSize'] != null) {
              result['wix.api.maxSize'] = grpc['wix.api.maxSize'];
            } else {
              result['wix.api.maxSize'] = 0;
            }
            if (grpc['wix.api.minSize'] != null) {
              result['wix.api.minSize'] = grpc['wix.api.minSize'];
            } else {
              result['wix.api.minSize'] = 0;
            }
            if (grpc['wix.api.format'] != null) {
              result['wix.api.format'] = grpc['wix.api.format'];
            } else {
              result['wix.api.format'] = 'EMAIL';
            }
            if (grpc['wix.api.readOnly'] != null) {
              result['wix.api.readOnly'] = grpc['wix.api.readOnly'];
            } else {
              result['wix.api.readOnly'] = false;
            }
            if (grpc['wix.api.immutable'] != null) {
              result['wix.api.immutable'] = grpc['wix.api.immutable'];
            } else {
              result['wix.api.immutable'] = false;
            }
            if (grpc['wix.api.decimalValue'] != null) {
              result['wix.api.decimalValue'] = $root.wix.api.DecimalValueOptions.fromGRPC(grpc['wix.api.decimalValue'], helper);
            } else {
              delete result['wix.api.decimalValue'];
            }
            return result;
          }
        }
      }
      FieldOptions.CType = {
        'STRING': 'STRING',
        0: 'STRING',
        'CORD': 'CORD',
        1: 'CORD',
        'STRING_PIECE': 'STRING_PIECE',
        2: 'STRING_PIECE'
      };
      FieldOptions.JSType = {
        'JS_NORMAL': 'JS_NORMAL',
        0: 'JS_NORMAL',
        'JS_STRING': 'JS_STRING',
        1: 'JS_STRING',
        'JS_NUMBER': 'JS_NUMBER',
        2: 'JS_NUMBER'
      };
      FieldOptions.CType = {
        'STRING': 'STRING',
        0: 'STRING',
        'CORD': 'CORD',
        1: 'CORD',
        'STRING_PIECE': 'STRING_PIECE',
        2: 'STRING_PIECE'
      };
      FieldOptions.JSType = {
        'JS_NORMAL': 'JS_NORMAL',
        0: 'JS_NORMAL',
        'JS_STRING': 'JS_STRING',
        1: 'JS_STRING',
        'JS_NUMBER': 'JS_NUMBER',
        2: 'JS_NUMBER'
      };
      __builtIn.Object.defineProperty(FieldOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.FieldOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FieldOptions.prototype, '__fqn__', {
        value: 'google.protobuf.FieldOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FieldOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(FieldOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return FieldOptions;
    }());;
    _protobuf.OneofOptions = (function () {
      class OneofOptions {
        constructor(props) {
          this.uninterpretedOption = props && props.uninterpretedOption;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['uninterpretedOption'] != null) {
              json['uninterpretedOption'] = obj['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['uninterpretedOption'] = [];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.OneofOptions();
            if (json['uninterpretedOption'] != null) {
              result['uninterpretedOption'] = Array.isArray(json['uninterpretedOption']) ? json['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.fromJSON(e, helper);
              }) : json['uninterpretedOption'];
            } else if (withDefaults !== false) {
              result['uninterpretedOption'] = [];
            } else {
              delete result['uninterpretedOption'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['uninterpretedOption'] != null) {
              grpc['uninterpretedOption'] = obj['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.OneofOptions();
            if (grpc['uninterpretedOption'] != null) {
              result['uninterpretedOption'] = grpc['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.fromGRPC(e, helper);
              });
            } else {
              result['uninterpretedOption'] = [];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(OneofOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.OneofOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(OneofOptions.prototype, '__fqn__', {
        value: 'google.protobuf.OneofOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(OneofOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(OneofOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return OneofOptions;
    }());;
    _protobuf.EnumOptions = (function () {
      class EnumOptions {
        constructor(props) {
          this.allowAlias = props && props.allowAlias;
          this.deprecated = props && props.deprecated;
          this.uninterpretedOption = props && props.uninterpretedOption;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['allowAlias'] != null) {
              json['allowAlias'] = obj['allowAlias'];
            } else if (withDefaults) {
              json['allowAlias'] = false;
            }
            if (obj['deprecated'] != null) {
              json['deprecated'] = obj['deprecated'];
            } else if (withDefaults) {
              json['deprecated'] = false;
            }
            if (obj['uninterpretedOption'] != null) {
              json['uninterpretedOption'] = obj['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['uninterpretedOption'] = [];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.EnumOptions();
            if (json['allowAlias'] != null) {
              result['allowAlias'] = json['allowAlias'];
            } else if (withDefaults !== false) {
              result['allowAlias'] = false;
            } else {
              delete result['allowAlias'];
            }
            if (json['deprecated'] != null) {
              result['deprecated'] = json['deprecated'];
            } else if (withDefaults !== false) {
              result['deprecated'] = false;
            } else {
              delete result['deprecated'];
            }
            if (json['uninterpretedOption'] != null) {
              result['uninterpretedOption'] = Array.isArray(json['uninterpretedOption']) ? json['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.fromJSON(e, helper);
              }) : json['uninterpretedOption'];
            } else if (withDefaults !== false) {
              result['uninterpretedOption'] = [];
            } else {
              delete result['uninterpretedOption'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['allowAlias'] != null) {
              grpc['allowAlias'] = obj['allowAlias'];
            }
            if (obj['deprecated'] != null) {
              grpc['deprecated'] = obj['deprecated'];
            }
            if (obj['uninterpretedOption'] != null) {
              grpc['uninterpretedOption'] = obj['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.EnumOptions();
            if (grpc['allowAlias'] != null) {
              result['allowAlias'] = grpc['allowAlias'];
            } else {
              result['allowAlias'] = false;
            }
            if (grpc['deprecated'] != null) {
              result['deprecated'] = grpc['deprecated'];
            } else {
              result['deprecated'] = false;
            }
            if (grpc['uninterpretedOption'] != null) {
              result['uninterpretedOption'] = grpc['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.fromGRPC(e, helper);
              });
            } else {
              result['uninterpretedOption'] = [];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(EnumOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.EnumOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(EnumOptions.prototype, '__fqn__', {
        value: 'google.protobuf.EnumOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(EnumOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(EnumOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return EnumOptions;
    }());;
    _protobuf.EnumValueOptions = (function () {
      class EnumValueOptions {
        constructor(props) {
          this.deprecated = props && props.deprecated;
          this.uninterpretedOption = props && props.uninterpretedOption;
          this['wix.api.enumMaturity'] = props && props['wix.api.enumMaturity'];
          this['wix.api.enumExposure'] = props && props['wix.api.enumExposure'];
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['deprecated'] != null) {
              json['deprecated'] = obj['deprecated'];
            } else if (withDefaults) {
              json['deprecated'] = false;
            }
            if (obj['uninterpretedOption'] != null) {
              json['uninterpretedOption'] = obj['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['uninterpretedOption'] = [];
            }
            if (obj['wix.api.enumMaturity'] != null) {
              json['wix.api.enumMaturity'] = $root.wix.api.Maturity[obj['wix.api.enumMaturity']];
            } else if (withDefaults) {
              json['wix.api.enumMaturity'] = 'ALPHA';
            }
            if (obj['wix.api.enumExposure'] != null) {
              json['wix.api.enumExposure'] = $root.wix.api.Exposure[obj['wix.api.enumExposure']];
            } else if (withDefaults) {
              json['wix.api.enumExposure'] = 'PRIVATE';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.EnumValueOptions();
            if (json['deprecated'] != null) {
              result['deprecated'] = json['deprecated'];
            } else if (withDefaults !== false) {
              result['deprecated'] = false;
            } else {
              delete result['deprecated'];
            }
            if (json['uninterpretedOption'] != null) {
              result['uninterpretedOption'] = Array.isArray(json['uninterpretedOption']) ? json['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.fromJSON(e, helper);
              }) : json['uninterpretedOption'];
            } else if (withDefaults !== false) {
              result['uninterpretedOption'] = [];
            } else {
              delete result['uninterpretedOption'];
            }
            if (json['wix.api.enumMaturity'] != null) {
              result['wix.api.enumMaturity'] = typeof json['wix.api.enumMaturity'] === 'string' ? json['wix.api.enumMaturity'] : $root.wix.api.Maturity[json['wix.api.enumMaturity']];
            } else if (withDefaults !== false) {
              result['wix.api.enumMaturity'] = 'ALPHA';
            } else {
              delete result['wix.api.enumMaturity'];
            }
            if (json['wix.api.enumExposure'] != null) {
              result['wix.api.enumExposure'] = typeof json['wix.api.enumExposure'] === 'string' ? json['wix.api.enumExposure'] : $root.wix.api.Exposure[json['wix.api.enumExposure']];
            } else if (withDefaults !== false) {
              result['wix.api.enumExposure'] = 'PRIVATE';
            } else {
              delete result['wix.api.enumExposure'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['deprecated'] != null) {
              grpc['deprecated'] = obj['deprecated'];
            }
            if (obj['uninterpretedOption'] != null) {
              grpc['uninterpretedOption'] = obj['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.toGRPC(e, helper);
              });
            }
            if (obj['wix.api.enumMaturity'] != null) {
              grpc['wix.api.enumMaturity'] = obj['wix.api.enumMaturity'];
            }
            if (obj['wix.api.enumExposure'] != null) {
              grpc['wix.api.enumExposure'] = obj['wix.api.enumExposure'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.EnumValueOptions();
            if (grpc['deprecated'] != null) {
              result['deprecated'] = grpc['deprecated'];
            } else {
              result['deprecated'] = false;
            }
            if (grpc['uninterpretedOption'] != null) {
              result['uninterpretedOption'] = grpc['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.fromGRPC(e, helper);
              });
            } else {
              result['uninterpretedOption'] = [];
            }
            if (grpc['wix.api.enumMaturity'] != null) {
              result['wix.api.enumMaturity'] = grpc['wix.api.enumMaturity'];
            } else {
              result['wix.api.enumMaturity'] = 'ALPHA';
            }
            if (grpc['wix.api.enumExposure'] != null) {
              result['wix.api.enumExposure'] = grpc['wix.api.enumExposure'];
            } else {
              result['wix.api.enumExposure'] = 'PRIVATE';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(EnumValueOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.EnumValueOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(EnumValueOptions.prototype, '__fqn__', {
        value: 'google.protobuf.EnumValueOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(EnumValueOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(EnumValueOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return EnumValueOptions;
    }());;
    _protobuf.ServiceOptions = (function () {
      class ServiceOptions {
        constructor(props) {
          this.deprecated = props && props.deprecated;
          this.uninterpretedOption = props && props.uninterpretedOption;
          this['wix.api.serviceMaturity'] = props && props['wix.api.serviceMaturity'];
          this['wix.api.serviceExposure'] = props && props['wix.api.serviceExposure'];
          this['wix.api.serviceDeprecated'] = props && props['wix.api.serviceDeprecated'];
          this['wix.api.appendixFiles'] = props && props['wix.api.appendixFiles'];
          this['wix.api.serviceEntity'] = props && props['wix.api.serviceEntity'];
          this['wix.api.event'] = props && props['wix.api.event'];
          this['wix.api.eventDeprecated'] = props && props['wix.api.eventDeprecated'];
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['deprecated'] != null) {
              json['deprecated'] = obj['deprecated'];
            } else if (withDefaults) {
              json['deprecated'] = false;
            }
            if (obj['uninterpretedOption'] != null) {
              json['uninterpretedOption'] = obj['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['uninterpretedOption'] = [];
            }
            if (obj['wix.api.serviceMaturity'] != null) {
              json['wix.api.serviceMaturity'] = $root.wix.api.Maturity[obj['wix.api.serviceMaturity']];
            } else if (withDefaults) {
              json['wix.api.serviceMaturity'] = 'ALPHA';
            }
            if (obj['wix.api.serviceExposure'] != null) {
              json['wix.api.serviceExposure'] = $root.wix.api.Exposure[obj['wix.api.serviceExposure']];
            } else if (withDefaults) {
              json['wix.api.serviceExposure'] = 'PRIVATE';
            }
            if (obj['wix.api.serviceDeprecated'] != null) {
              json['wix.api.serviceDeprecated'] = $root.wix.api.Deprecated.toJSON(obj['wix.api.serviceDeprecated'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['wix.api.serviceDeprecated'];
            }
            if (obj['wix.api.appendixFiles'] != null) {
              json['wix.api.appendixFiles'] = obj['wix.api.appendixFiles'].map(e => {
                return $root.wix.api.ServiceAppendix.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['wix.api.appendixFiles'] = [];
            }
            if (obj['wix.api.serviceEntity'] != null) {
              json['wix.api.serviceEntity'] = $root.wix.api.ServiceEntity.toJSON(obj['wix.api.serviceEntity'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['wix.api.serviceEntity'];
            }
            if (obj['wix.api.event'] != null) {
              json['wix.api.event'] = obj['wix.api.event'].map(e => {
                return $root.wix.api.Callback.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['wix.api.event'] = [];
            }
            if (obj['wix.api.eventDeprecated'] != null) {
              json['wix.api.eventDeprecated'] = obj['wix.api.eventDeprecated'].map(e => {
                return $root.wix.api.CallbackDeprecation.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['wix.api.eventDeprecated'] = [];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.ServiceOptions();
            if (json['deprecated'] != null) {
              result['deprecated'] = json['deprecated'];
            } else if (withDefaults !== false) {
              result['deprecated'] = false;
            } else {
              delete result['deprecated'];
            }
            if (json['uninterpretedOption'] != null) {
              result['uninterpretedOption'] = Array.isArray(json['uninterpretedOption']) ? json['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.fromJSON(e, helper);
              }) : json['uninterpretedOption'];
            } else if (withDefaults !== false) {
              result['uninterpretedOption'] = [];
            } else {
              delete result['uninterpretedOption'];
            }
            if (json['wix.api.serviceMaturity'] != null) {
              result['wix.api.serviceMaturity'] = typeof json['wix.api.serviceMaturity'] === 'string' ? json['wix.api.serviceMaturity'] : $root.wix.api.Maturity[json['wix.api.serviceMaturity']];
            } else if (withDefaults !== false) {
              result['wix.api.serviceMaturity'] = 'ALPHA';
            } else {
              delete result['wix.api.serviceMaturity'];
            }
            if (json['wix.api.serviceExposure'] != null) {
              result['wix.api.serviceExposure'] = typeof json['wix.api.serviceExposure'] === 'string' ? json['wix.api.serviceExposure'] : $root.wix.api.Exposure[json['wix.api.serviceExposure']];
            } else if (withDefaults !== false) {
              result['wix.api.serviceExposure'] = 'PRIVATE';
            } else {
              delete result['wix.api.serviceExposure'];
            }
            if (json['wix.api.serviceDeprecated'] != null) {
              result['wix.api.serviceDeprecated'] = $root.wix.api.Deprecated.fromJSON(json['wix.api.serviceDeprecated'], helper);
            } else if (withDefaults !== false) {
              delete result['wix.api.serviceDeprecated'];
            } else {
              delete result['wix.api.serviceDeprecated'];
            }
            if (json['wix.api.appendixFiles'] != null) {
              result['wix.api.appendixFiles'] = Array.isArray(json['wix.api.appendixFiles']) ? json['wix.api.appendixFiles'].map(e => {
                return $root.wix.api.ServiceAppendix.fromJSON(e, helper);
              }) : json['wix.api.appendixFiles'];
            } else if (withDefaults !== false) {
              result['wix.api.appendixFiles'] = [];
            } else {
              delete result['wix.api.appendixFiles'];
            }
            if (json['wix.api.serviceEntity'] != null) {
              result['wix.api.serviceEntity'] = $root.wix.api.ServiceEntity.fromJSON(json['wix.api.serviceEntity'], helper);
            } else if (withDefaults !== false) {
              delete result['wix.api.serviceEntity'];
            } else {
              delete result['wix.api.serviceEntity'];
            }
            if (json['wix.api.event'] != null) {
              result['wix.api.event'] = Array.isArray(json['wix.api.event']) ? json['wix.api.event'].map(e => {
                return $root.wix.api.Callback.fromJSON(e, helper);
              }) : json['wix.api.event'];
            } else if (withDefaults !== false) {
              result['wix.api.event'] = [];
            } else {
              delete result['wix.api.event'];
            }
            if (json['wix.api.eventDeprecated'] != null) {
              result['wix.api.eventDeprecated'] = Array.isArray(json['wix.api.eventDeprecated']) ? json['wix.api.eventDeprecated'].map(e => {
                return $root.wix.api.CallbackDeprecation.fromJSON(e, helper);
              }) : json['wix.api.eventDeprecated'];
            } else if (withDefaults !== false) {
              result['wix.api.eventDeprecated'] = [];
            } else {
              delete result['wix.api.eventDeprecated'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['deprecated'] != null) {
              grpc['deprecated'] = obj['deprecated'];
            }
            if (obj['uninterpretedOption'] != null) {
              grpc['uninterpretedOption'] = obj['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.toGRPC(e, helper);
              });
            }
            if (obj['wix.api.serviceMaturity'] != null) {
              grpc['wix.api.serviceMaturity'] = obj['wix.api.serviceMaturity'];
            }
            if (obj['wix.api.serviceExposure'] != null) {
              grpc['wix.api.serviceExposure'] = obj['wix.api.serviceExposure'];
            }
            if (obj['wix.api.serviceDeprecated'] != null) {
              grpc['wix.api.serviceDeprecated'] = $root.wix.api.Deprecated.toGRPC(obj['wix.api.serviceDeprecated'], helper);
            }
            if (obj['wix.api.appendixFiles'] != null) {
              grpc['wix.api.appendixFiles'] = obj['wix.api.appendixFiles'].map(e => {
                return $root.wix.api.ServiceAppendix.toGRPC(e, helper);
              });
            }
            if (obj['wix.api.serviceEntity'] != null) {
              grpc['wix.api.serviceEntity'] = $root.wix.api.ServiceEntity.toGRPC(obj['wix.api.serviceEntity'], helper);
            }
            if (obj['wix.api.event'] != null) {
              grpc['wix.api.event'] = obj['wix.api.event'].map(e => {
                return $root.wix.api.Callback.toGRPC(e, helper);
              });
            }
            if (obj['wix.api.eventDeprecated'] != null) {
              grpc['wix.api.eventDeprecated'] = obj['wix.api.eventDeprecated'].map(e => {
                return $root.wix.api.CallbackDeprecation.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.ServiceOptions();
            if (grpc['deprecated'] != null) {
              result['deprecated'] = grpc['deprecated'];
            } else {
              result['deprecated'] = false;
            }
            if (grpc['uninterpretedOption'] != null) {
              result['uninterpretedOption'] = grpc['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.fromGRPC(e, helper);
              });
            } else {
              result['uninterpretedOption'] = [];
            }
            if (grpc['wix.api.serviceMaturity'] != null) {
              result['wix.api.serviceMaturity'] = grpc['wix.api.serviceMaturity'];
            } else {
              result['wix.api.serviceMaturity'] = 'ALPHA';
            }
            if (grpc['wix.api.serviceExposure'] != null) {
              result['wix.api.serviceExposure'] = grpc['wix.api.serviceExposure'];
            } else {
              result['wix.api.serviceExposure'] = 'PRIVATE';
            }
            if (grpc['wix.api.serviceDeprecated'] != null) {
              result['wix.api.serviceDeprecated'] = $root.wix.api.Deprecated.fromGRPC(grpc['wix.api.serviceDeprecated'], helper);
            } else {
              delete result['wix.api.serviceDeprecated'];
            }
            if (grpc['wix.api.appendixFiles'] != null) {
              result['wix.api.appendixFiles'] = grpc['wix.api.appendixFiles'].map(e => {
                return $root.wix.api.ServiceAppendix.fromGRPC(e, helper);
              });
            } else {
              result['wix.api.appendixFiles'] = [];
            }
            if (grpc['wix.api.serviceEntity'] != null) {
              result['wix.api.serviceEntity'] = $root.wix.api.ServiceEntity.fromGRPC(grpc['wix.api.serviceEntity'], helper);
            } else {
              delete result['wix.api.serviceEntity'];
            }
            if (grpc['wix.api.event'] != null) {
              result['wix.api.event'] = grpc['wix.api.event'].map(e => {
                return $root.wix.api.Callback.fromGRPC(e, helper);
              });
            } else {
              result['wix.api.event'] = [];
            }
            if (grpc['wix.api.eventDeprecated'] != null) {
              result['wix.api.eventDeprecated'] = grpc['wix.api.eventDeprecated'].map(e => {
                return $root.wix.api.CallbackDeprecation.fromGRPC(e, helper);
              });
            } else {
              result['wix.api.eventDeprecated'] = [];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(ServiceOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.ServiceOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ServiceOptions.prototype, '__fqn__', {
        value: 'google.protobuf.ServiceOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ServiceOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ServiceOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return ServiceOptions;
    }());;
    _protobuf.MethodOptions = (function () {
      class MethodOptions {
        constructor(props) {
          this.deprecated = props && props.deprecated;
          this.idempotencyLevel = props && props.idempotencyLevel;
          this.uninterpretedOption = props && props.uninterpretedOption;
          this['wix.api.exposure'] = props && props['wix.api.exposure'];
          this['wix.api.maturity'] = props && props['wix.api.maturity'];
          this['wix.api.cacheable'] = props && props['wix.api.cacheable'];
          this['wix.api.deprecated'] = props && props['wix.api.deprecated'];
          this['wix.api.crud'] = props && props['wix.api.crud'];
          this['wix.api.required'] = props && props['wix.api.required'];
          this['wix.api.callback'] = props && props['wix.api.callback'];
          this['google.api.http'] = props && props['google.api.http'];
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['deprecated'] != null) {
              json['deprecated'] = obj['deprecated'];
            } else if (withDefaults) {
              json['deprecated'] = false;
            }
            if (obj['idempotencyLevel'] != null) {
              json['idempotencyLevel'] = $root.google.protobuf.MethodOptions.IdempotencyLevel[obj['idempotencyLevel']];
            } else if (withDefaults) {
              json['idempotencyLevel'] = 'IDEMPOTENCY_UNKNOWN';
            }
            if (obj['uninterpretedOption'] != null) {
              json['uninterpretedOption'] = obj['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['uninterpretedOption'] = [];
            }
            if (obj['wix.api.exposure'] != null) {
              json['wix.api.exposure'] = $root.wix.api.Exposure[obj['wix.api.exposure']];
            } else if (withDefaults) {
              json['wix.api.exposure'] = 'PRIVATE';
            }
            if (obj['wix.api.maturity'] != null) {
              json['wix.api.maturity'] = $root.wix.api.Maturity[obj['wix.api.maturity']];
            } else if (withDefaults) {
              json['wix.api.maturity'] = 'ALPHA';
            }
            if (obj['wix.api.cacheable'] != null) {
              json['wix.api.cacheable'] = $root.wix.api.CacheSettings.toJSON(obj['wix.api.cacheable'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['wix.api.cacheable'];
            }
            if (obj['wix.api.deprecated'] != null) {
              json['wix.api.deprecated'] = $root.wix.api.Deprecated.toJSON(obj['wix.api.deprecated'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['wix.api.deprecated'];
            }
            if (obj['wix.api.crud'] != null) {
              json['wix.api.crud'] = $root.wix.api.Crud.toJSON(obj['wix.api.crud'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['wix.api.crud'];
            }
            if (obj['wix.api.required'] != null) {
              json['wix.api.required'] = obj['wix.api.required'].map(e => {
                return e;
              });
            } else if (withDefaults) {
              json['wix.api.required'] = [];
            }
            if (obj['wix.api.callback'] != null) {
              json['wix.api.callback'] = obj['wix.api.callback'].map(e => {
                return $root.wix.api.Callback.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['wix.api.callback'] = [];
            }
            if (obj['google.api.http'] != null) {
              json['google.api.http'] = $root.google.api.HttpRule.toJSON(obj['google.api.http'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['google.api.http'];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.MethodOptions();
            if (json['deprecated'] != null) {
              result['deprecated'] = json['deprecated'];
            } else if (withDefaults !== false) {
              result['deprecated'] = false;
            } else {
              delete result['deprecated'];
            }
            if (json['idempotencyLevel'] != null) {
              result['idempotencyLevel'] = typeof json['idempotencyLevel'] === 'string' ? json['idempotencyLevel'] : $root.google.protobuf.MethodOptions.IdempotencyLevel[json['idempotencyLevel']];
            } else if (withDefaults !== false) {
              result['idempotencyLevel'] = 'IDEMPOTENCY_UNKNOWN';
            } else {
              delete result['idempotencyLevel'];
            }
            if (json['uninterpretedOption'] != null) {
              result['uninterpretedOption'] = Array.isArray(json['uninterpretedOption']) ? json['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.fromJSON(e, helper);
              }) : json['uninterpretedOption'];
            } else if (withDefaults !== false) {
              result['uninterpretedOption'] = [];
            } else {
              delete result['uninterpretedOption'];
            }
            if (json['wix.api.exposure'] != null) {
              result['wix.api.exposure'] = typeof json['wix.api.exposure'] === 'string' ? json['wix.api.exposure'] : $root.wix.api.Exposure[json['wix.api.exposure']];
            } else if (withDefaults !== false) {
              result['wix.api.exposure'] = 'PRIVATE';
            } else {
              delete result['wix.api.exposure'];
            }
            if (json['wix.api.maturity'] != null) {
              result['wix.api.maturity'] = typeof json['wix.api.maturity'] === 'string' ? json['wix.api.maturity'] : $root.wix.api.Maturity[json['wix.api.maturity']];
            } else if (withDefaults !== false) {
              result['wix.api.maturity'] = 'ALPHA';
            } else {
              delete result['wix.api.maturity'];
            }
            if (json['wix.api.cacheable'] != null) {
              result['wix.api.cacheable'] = $root.wix.api.CacheSettings.fromJSON(json['wix.api.cacheable'], helper);
            } else if (withDefaults !== false) {
              delete result['wix.api.cacheable'];
            } else {
              delete result['wix.api.cacheable'];
            }
            if (json['wix.api.deprecated'] != null) {
              result['wix.api.deprecated'] = $root.wix.api.Deprecated.fromJSON(json['wix.api.deprecated'], helper);
            } else if (withDefaults !== false) {
              delete result['wix.api.deprecated'];
            } else {
              delete result['wix.api.deprecated'];
            }
            if (json['wix.api.crud'] != null) {
              result['wix.api.crud'] = $root.wix.api.Crud.fromJSON(json['wix.api.crud'], helper);
            } else if (withDefaults !== false) {
              delete result['wix.api.crud'];
            } else {
              delete result['wix.api.crud'];
            }
            if (json['wix.api.required'] != null) {
              result['wix.api.required'] = Array.isArray(json['wix.api.required']) ? json['wix.api.required'].map(e => {
                return e;
              }) : json['wix.api.required'];
            } else if (withDefaults !== false) {
              result['wix.api.required'] = [];
            } else {
              delete result['wix.api.required'];
            }
            if (json['wix.api.callback'] != null) {
              result['wix.api.callback'] = Array.isArray(json['wix.api.callback']) ? json['wix.api.callback'].map(e => {
                return $root.wix.api.Callback.fromJSON(e, helper);
              }) : json['wix.api.callback'];
            } else if (withDefaults !== false) {
              result['wix.api.callback'] = [];
            } else {
              delete result['wix.api.callback'];
            }
            if (json['google.api.http'] != null) {
              result['google.api.http'] = $root.google.api.HttpRule.fromJSON(json['google.api.http'], helper);
            } else if (withDefaults !== false) {
              delete result['google.api.http'];
            } else {
              delete result['google.api.http'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['deprecated'] != null) {
              grpc['deprecated'] = obj['deprecated'];
            }
            if (obj['idempotencyLevel'] != null) {
              grpc['idempotencyLevel'] = obj['idempotencyLevel'];
            }
            if (obj['uninterpretedOption'] != null) {
              grpc['uninterpretedOption'] = obj['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.toGRPC(e, helper);
              });
            }
            if (obj['wix.api.exposure'] != null) {
              grpc['wix.api.exposure'] = obj['wix.api.exposure'];
            }
            if (obj['wix.api.maturity'] != null) {
              grpc['wix.api.maturity'] = obj['wix.api.maturity'];
            }
            if (obj['wix.api.cacheable'] != null) {
              grpc['wix.api.cacheable'] = $root.wix.api.CacheSettings.toGRPC(obj['wix.api.cacheable'], helper);
            }
            if (obj['wix.api.deprecated'] != null) {
              grpc['wix.api.deprecated'] = $root.wix.api.Deprecated.toGRPC(obj['wix.api.deprecated'], helper);
            }
            if (obj['wix.api.crud'] != null) {
              grpc['wix.api.crud'] = $root.wix.api.Crud.toGRPC(obj['wix.api.crud'], helper);
            }
            if (obj['wix.api.required'] != null) {
              grpc['wix.api.required'] = obj['wix.api.required'].map(e => {
                return e;
              });
            }
            if (obj['wix.api.callback'] != null) {
              grpc['wix.api.callback'] = obj['wix.api.callback'].map(e => {
                return $root.wix.api.Callback.toGRPC(e, helper);
              });
            }
            if (obj['google.api.http'] != null) {
              grpc['google.api.http'] = $root.google.api.HttpRule.toGRPC(obj['google.api.http'], helper);
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.MethodOptions();
            if (grpc['deprecated'] != null) {
              result['deprecated'] = grpc['deprecated'];
            } else {
              result['deprecated'] = false;
            }
            if (grpc['idempotencyLevel'] != null) {
              result['idempotencyLevel'] = grpc['idempotencyLevel'];
            } else {
              result['idempotencyLevel'] = 'IDEMPOTENCY_UNKNOWN';
            }
            if (grpc['uninterpretedOption'] != null) {
              result['uninterpretedOption'] = grpc['uninterpretedOption'].map(e => {
                return $root.google.protobuf.UninterpretedOption.fromGRPC(e, helper);
              });
            } else {
              result['uninterpretedOption'] = [];
            }
            if (grpc['wix.api.exposure'] != null) {
              result['wix.api.exposure'] = grpc['wix.api.exposure'];
            } else {
              result['wix.api.exposure'] = 'PRIVATE';
            }
            if (grpc['wix.api.maturity'] != null) {
              result['wix.api.maturity'] = grpc['wix.api.maturity'];
            } else {
              result['wix.api.maturity'] = 'ALPHA';
            }
            if (grpc['wix.api.cacheable'] != null) {
              result['wix.api.cacheable'] = $root.wix.api.CacheSettings.fromGRPC(grpc['wix.api.cacheable'], helper);
            } else {
              delete result['wix.api.cacheable'];
            }
            if (grpc['wix.api.deprecated'] != null) {
              result['wix.api.deprecated'] = $root.wix.api.Deprecated.fromGRPC(grpc['wix.api.deprecated'], helper);
            } else {
              delete result['wix.api.deprecated'];
            }
            if (grpc['wix.api.crud'] != null) {
              result['wix.api.crud'] = $root.wix.api.Crud.fromGRPC(grpc['wix.api.crud'], helper);
            } else {
              delete result['wix.api.crud'];
            }
            if (grpc['wix.api.required'] != null) {
              result['wix.api.required'] = grpc['wix.api.required'].map(e => {
                return e;
              });
            } else {
              result['wix.api.required'] = [];
            }
            if (grpc['wix.api.callback'] != null) {
              result['wix.api.callback'] = grpc['wix.api.callback'].map(e => {
                return $root.wix.api.Callback.fromGRPC(e, helper);
              });
            } else {
              result['wix.api.callback'] = [];
            }
            if (grpc['google.api.http'] != null) {
              result['google.api.http'] = $root.google.api.HttpRule.fromGRPC(grpc['google.api.http'], helper);
            } else {
              delete result['google.api.http'];
            }
            return result;
          }
        }
      }
      MethodOptions.IdempotencyLevel = {
        'IDEMPOTENCY_UNKNOWN': 'IDEMPOTENCY_UNKNOWN',
        0: 'IDEMPOTENCY_UNKNOWN',
        'NO_SIDE_EFFECTS': 'NO_SIDE_EFFECTS',
        1: 'NO_SIDE_EFFECTS',
        'IDEMPOTENT': 'IDEMPOTENT',
        2: 'IDEMPOTENT'
      };
      MethodOptions.IdempotencyLevel = {
        'IDEMPOTENCY_UNKNOWN': 'IDEMPOTENCY_UNKNOWN',
        0: 'IDEMPOTENCY_UNKNOWN',
        'NO_SIDE_EFFECTS': 'NO_SIDE_EFFECTS',
        1: 'NO_SIDE_EFFECTS',
        'IDEMPOTENT': 'IDEMPOTENT',
        2: 'IDEMPOTENT'
      };
      __builtIn.Object.defineProperty(MethodOptions.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.MethodOptions');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(MethodOptions.prototype, '__fqn__', {
        value: 'google.protobuf.MethodOptions',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(MethodOptions.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(MethodOptions.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return MethodOptions;
    }());;
    _protobuf.UninterpretedOption = (function () {
      class UninterpretedOption {
        constructor(props) {
          this.name = props && props.name;
          this.identifierValue = props && props.identifierValue;
          this.positiveIntValue = props && props.positiveIntValue;
          this.negativeIntValue = props && props.negativeIntValue;
          this.doubleValue = props && props.doubleValue;
          this.stringValue = props && props.stringValue;
          this.aggregateValue = props && props.aggregateValue;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['name'] != null) {
              json['name'] = obj['name'].map(e => {
                return $root.google.protobuf.UninterpretedOption.NamePart.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['name'] = [];
            }
            if (obj['identifierValue'] != null) {
              json['identifierValue'] = obj['identifierValue'];
            } else if (withDefaults) {
              json['identifierValue'] = '';
            }
            if (obj['positiveIntValue'] != null) {
              json['positiveIntValue'] = obj['positiveIntValue'].toString();
            } else if (withDefaults) {
              json['positiveIntValue'] = Long.ZERO;
            }
            if (obj['negativeIntValue'] != null) {
              json['negativeIntValue'] = obj['negativeIntValue'].toString();
            } else if (withDefaults) {
              json['negativeIntValue'] = Long.ZERO;
            }
            if (obj['doubleValue'] != null) {
              json['doubleValue'] = obj['doubleValue'] == null ? obj['doubleValue'] : isNaN(obj['doubleValue']) ? 'NaN' : isFinite(obj['doubleValue']) ? obj['doubleValue'] : obj['doubleValue'].toString();
            } else if (withDefaults) {
              json['doubleValue'] = 0;
            }
            if (obj['stringValue'] != null) {
              json['stringValue'] = obj['stringValue'].toString('base64');
            } else if (withDefaults) {
              json['stringValue'] = '';
            }
            if (obj['aggregateValue'] != null) {
              json['aggregateValue'] = obj['aggregateValue'];
            } else if (withDefaults) {
              json['aggregateValue'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.UninterpretedOption();
            if (json['name'] != null) {
              result['name'] = Array.isArray(json['name']) ? json['name'].map(e => {
                return $root.google.protobuf.UninterpretedOption.NamePart.fromJSON(e, helper);
              }) : json['name'];
            } else if (withDefaults !== false) {
              result['name'] = [];
            } else {
              delete result['name'];
            }
            if (json['identifierValue'] != null) {
              result['identifierValue'] = json['identifierValue'];
            } else if (withDefaults !== false) {
              result['identifierValue'] = '';
            } else {
              delete result['identifierValue'];
            }
            if (json['positiveIntValue'] != null) {
              result['positiveIntValue'] = typeof json['positiveIntValue'] === 'number' || typeof json['positiveIntValue'] === 'string' && /^[-+]?\d+$/.test(json['positiveIntValue']) ? Long.fromValue(json['positiveIntValue'], 'true') : json['positiveIntValue'];
            } else if (withDefaults !== false) {
              result['positiveIntValue'] = Long.ZERO;
            } else {
              delete result['positiveIntValue'];
            }
            if (json['negativeIntValue'] != null) {
              result['negativeIntValue'] = typeof json['negativeIntValue'] === 'number' || typeof json['negativeIntValue'] === 'string' && /^[-+]?\d+$/.test(json['negativeIntValue']) ? Long.fromValue(json['negativeIntValue']) : json['negativeIntValue'];
            } else if (withDefaults !== false) {
              result['negativeIntValue'] = Long.ZERO;
            } else {
              delete result['negativeIntValue'];
            }
            if (json['doubleValue'] != null) {
              result['doubleValue'] = json['doubleValue'] === 'NaN' ? NaN : json['doubleValue'] === 'Infinity' ? Infinity : json['doubleValue'] === '-Infinity' ? -Infinity : json['doubleValue'];
            } else if (withDefaults !== false) {
              result['doubleValue'] = 0;
            } else {
              delete result['doubleValue'];
            }
            if (json['stringValue'] != null) {
              result['stringValue'] = function tryParseBytes(val) {
                try {
                  return __builtIn.Buffer.from(val, 'base64');
                } catch (e) {
                  return val;
                } finally {
                }
              }(json['stringValue']);
            } else if (withDefaults !== false) {
              result['stringValue'] = '';
            } else {
              delete result['stringValue'];
            }
            if (json['aggregateValue'] != null) {
              result['aggregateValue'] = json['aggregateValue'];
            } else if (withDefaults !== false) {
              result['aggregateValue'] = '';
            } else {
              delete result['aggregateValue'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['name'] != null) {
              grpc['name'] = obj['name'].map(e => {
                return $root.google.protobuf.UninterpretedOption.NamePart.toGRPC(e, helper);
              });
            }
            if (obj['identifierValue'] != null) {
              grpc['identifierValue'] = obj['identifierValue'];
            }
            if (obj['positiveIntValue'] != null) {
              grpc['positiveIntValue'] = obj['positiveIntValue'].toString();
            }
            if (obj['negativeIntValue'] != null) {
              grpc['negativeIntValue'] = obj['negativeIntValue'].toString();
            }
            if (obj['doubleValue'] != null) {
              grpc['doubleValue'] = obj['doubleValue'];
            }
            if (obj['stringValue'] != null) {
              grpc['stringValue'] = obj['stringValue'];
            }
            if (obj['aggregateValue'] != null) {
              grpc['aggregateValue'] = obj['aggregateValue'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.UninterpretedOption();
            if (grpc['name'] != null) {
              result['name'] = grpc['name'].map(e => {
                return $root.google.protobuf.UninterpretedOption.NamePart.fromGRPC(e, helper);
              });
            } else {
              result['name'] = [];
            }
            if (grpc['identifierValue'] != null) {
              result['identifierValue'] = grpc['identifierValue'];
            } else {
              result['identifierValue'] = '';
            }
            if (grpc['positiveIntValue'] != null) {
              result['positiveIntValue'] = typeof grpc['positiveIntValue'] === 'number' || typeof grpc['positiveIntValue'] === 'string' && /^[-+]?\d+$/.test(grpc['positiveIntValue']) ? Long.fromValue(grpc['positiveIntValue'], 'true') : grpc['positiveIntValue'];
            } else {
              result['positiveIntValue'] = Long.ZERO;
            }
            if (grpc['negativeIntValue'] != null) {
              result['negativeIntValue'] = typeof grpc['negativeIntValue'] === 'number' || typeof grpc['negativeIntValue'] === 'string' && /^[-+]?\d+$/.test(grpc['negativeIntValue']) ? Long.fromValue(grpc['negativeIntValue']) : grpc['negativeIntValue'];
            } else {
              result['negativeIntValue'] = Long.ZERO;
            }
            if (grpc['doubleValue'] != null) {
              result['doubleValue'] = grpc['doubleValue'];
            } else {
              result['doubleValue'] = 0;
            }
            if (grpc['stringValue'] != null) {
              result['stringValue'] = grpc['stringValue'];
            } else {
              result['stringValue'] = '';
            }
            if (grpc['aggregateValue'] != null) {
              result['aggregateValue'] = grpc['aggregateValue'];
            } else {
              result['aggregateValue'] = '';
            }
            return result;
          }
        }
      }
      UninterpretedOption.NamePart = (function () {
        class NamePart {
          constructor(props) {
            this.namePart = props && props.namePart;
            this.isExtension = props && props.isExtension;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['namePart'] != null) {
                json['namePart'] = obj['namePart'];
              } else if (withDefaults) {
                json['namePart'] = '';
              }
              if (obj['isExtension'] != null) {
                json['isExtension'] = obj['isExtension'];
              } else if (withDefaults) {
                json['isExtension'] = false;
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.google.protobuf.UninterpretedOption.NamePart();
              if (json['namePart'] != null) {
                result['namePart'] = json['namePart'];
              } else if (withDefaults !== false) {
                result['namePart'] = '';
              } else {
                delete result['namePart'];
              }
              if (json['isExtension'] != null) {
                result['isExtension'] = json['isExtension'];
              } else if (withDefaults !== false) {
                result['isExtension'] = false;
              } else {
                delete result['isExtension'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['namePart'] != null) {
                grpc['namePart'] = obj['namePart'];
              }
              if (obj['isExtension'] != null) {
                grpc['isExtension'] = obj['isExtension'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.google.protobuf.UninterpretedOption.NamePart();
              if (grpc['namePart'] != null) {
                result['namePart'] = grpc['namePart'];
              } else {
                result['namePart'] = '';
              }
              if (grpc['isExtension'] != null) {
                result['isExtension'] = grpc['isExtension'];
              } else {
                result['isExtension'] = false;
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(NamePart.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('google.protobuf.UninterpretedOption.NamePart');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(NamePart.prototype, '__fqn__', {
          value: 'google.protobuf.UninterpretedOption.NamePart',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(NamePart.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(NamePart.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return NamePart;
      }());;
      UninterpretedOption.NamePart = (function () {
        class NamePart {
          constructor(props) {
            this.namePart = props && props.namePart;
            this.isExtension = props && props.isExtension;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['namePart'] != null) {
                json['namePart'] = obj['namePart'];
              } else if (withDefaults) {
                json['namePart'] = '';
              }
              if (obj['isExtension'] != null) {
                json['isExtension'] = obj['isExtension'];
              } else if (withDefaults) {
                json['isExtension'] = false;
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.google.protobuf.UninterpretedOption.NamePart();
              if (json['namePart'] != null) {
                result['namePart'] = json['namePart'];
              } else if (withDefaults !== false) {
                result['namePart'] = '';
              } else {
                delete result['namePart'];
              }
              if (json['isExtension'] != null) {
                result['isExtension'] = json['isExtension'];
              } else if (withDefaults !== false) {
                result['isExtension'] = false;
              } else {
                delete result['isExtension'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['namePart'] != null) {
                grpc['namePart'] = obj['namePart'];
              }
              if (obj['isExtension'] != null) {
                grpc['isExtension'] = obj['isExtension'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.google.protobuf.UninterpretedOption.NamePart();
              if (grpc['namePart'] != null) {
                result['namePart'] = grpc['namePart'];
              } else {
                result['namePart'] = '';
              }
              if (grpc['isExtension'] != null) {
                result['isExtension'] = grpc['isExtension'];
              } else {
                result['isExtension'] = false;
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(NamePart.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('google.protobuf.UninterpretedOption.NamePart');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(NamePart.prototype, '__fqn__', {
          value: 'google.protobuf.UninterpretedOption.NamePart',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(NamePart.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(NamePart.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return NamePart;
      }());;
      __builtIn.Object.defineProperty(UninterpretedOption.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.UninterpretedOption');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(UninterpretedOption.prototype, '__fqn__', {
        value: 'google.protobuf.UninterpretedOption',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(UninterpretedOption.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(UninterpretedOption.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return UninterpretedOption;
    }());;
    _protobuf.SourceCodeInfo = (function () {
      class SourceCodeInfo {
        constructor(props) {
          this.location = props && props.location;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['location'] != null) {
              json['location'] = obj['location'].map(e => {
                return $root.google.protobuf.SourceCodeInfo.Location.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['location'] = [];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.SourceCodeInfo();
            if (json['location'] != null) {
              result['location'] = Array.isArray(json['location']) ? json['location'].map(e => {
                return $root.google.protobuf.SourceCodeInfo.Location.fromJSON(e, helper);
              }) : json['location'];
            } else if (withDefaults !== false) {
              result['location'] = [];
            } else {
              delete result['location'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['location'] != null) {
              grpc['location'] = obj['location'].map(e => {
                return $root.google.protobuf.SourceCodeInfo.Location.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.SourceCodeInfo();
            if (grpc['location'] != null) {
              result['location'] = grpc['location'].map(e => {
                return $root.google.protobuf.SourceCodeInfo.Location.fromGRPC(e, helper);
              });
            } else {
              result['location'] = [];
            }
            return result;
          }
        }
      }
      SourceCodeInfo.Location = (function () {
        class Location {
          constructor(props) {
            this.path = props && props.path;
            this.span = props && props.span;
            this.leadingComments = props && props.leadingComments;
            this.trailingComments = props && props.trailingComments;
            this.leadingDetachedComments = props && props.leadingDetachedComments;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['path'] != null) {
                json['path'] = obj['path'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['path'] = [];
              }
              if (obj['span'] != null) {
                json['span'] = obj['span'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['span'] = [];
              }
              if (obj['leadingComments'] != null) {
                json['leadingComments'] = obj['leadingComments'];
              } else if (withDefaults) {
                json['leadingComments'] = '';
              }
              if (obj['trailingComments'] != null) {
                json['trailingComments'] = obj['trailingComments'];
              } else if (withDefaults) {
                json['trailingComments'] = '';
              }
              if (obj['leadingDetachedComments'] != null) {
                json['leadingDetachedComments'] = obj['leadingDetachedComments'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['leadingDetachedComments'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.google.protobuf.SourceCodeInfo.Location();
              if (json['path'] != null) {
                result['path'] = Array.isArray(json['path']) ? json['path'].map(e => {
                  return e;
                }) : json['path'];
              } else if (withDefaults !== false) {
                result['path'] = [];
              } else {
                delete result['path'];
              }
              if (json['span'] != null) {
                result['span'] = Array.isArray(json['span']) ? json['span'].map(e => {
                  return e;
                }) : json['span'];
              } else if (withDefaults !== false) {
                result['span'] = [];
              } else {
                delete result['span'];
              }
              if (json['leadingComments'] != null) {
                result['leadingComments'] = json['leadingComments'];
              } else if (withDefaults !== false) {
                result['leadingComments'] = '';
              } else {
                delete result['leadingComments'];
              }
              if (json['trailingComments'] != null) {
                result['trailingComments'] = json['trailingComments'];
              } else if (withDefaults !== false) {
                result['trailingComments'] = '';
              } else {
                delete result['trailingComments'];
              }
              if (json['leadingDetachedComments'] != null) {
                result['leadingDetachedComments'] = Array.isArray(json['leadingDetachedComments']) ? json['leadingDetachedComments'].map(e => {
                  return e;
                }) : json['leadingDetachedComments'];
              } else if (withDefaults !== false) {
                result['leadingDetachedComments'] = [];
              } else {
                delete result['leadingDetachedComments'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['path'] != null) {
                grpc['path'] = obj['path'].map(e => {
                  return e;
                });
              }
              if (obj['span'] != null) {
                grpc['span'] = obj['span'].map(e => {
                  return e;
                });
              }
              if (obj['leadingComments'] != null) {
                grpc['leadingComments'] = obj['leadingComments'];
              }
              if (obj['trailingComments'] != null) {
                grpc['trailingComments'] = obj['trailingComments'];
              }
              if (obj['leadingDetachedComments'] != null) {
                grpc['leadingDetachedComments'] = obj['leadingDetachedComments'].map(e => {
                  return e;
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.google.protobuf.SourceCodeInfo.Location();
              if (grpc['path'] != null) {
                result['path'] = grpc['path'].map(e => {
                  return e;
                });
              } else {
                result['path'] = [];
              }
              if (grpc['span'] != null) {
                result['span'] = grpc['span'].map(e => {
                  return e;
                });
              } else {
                result['span'] = [];
              }
              if (grpc['leadingComments'] != null) {
                result['leadingComments'] = grpc['leadingComments'];
              } else {
                result['leadingComments'] = '';
              }
              if (grpc['trailingComments'] != null) {
                result['trailingComments'] = grpc['trailingComments'];
              } else {
                result['trailingComments'] = '';
              }
              if (grpc['leadingDetachedComments'] != null) {
                result['leadingDetachedComments'] = grpc['leadingDetachedComments'].map(e => {
                  return e;
                });
              } else {
                result['leadingDetachedComments'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(Location.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('google.protobuf.SourceCodeInfo.Location');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Location.prototype, '__fqn__', {
          value: 'google.protobuf.SourceCodeInfo.Location',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Location.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Location.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return Location;
      }());;
      SourceCodeInfo.Location = (function () {
        class Location {
          constructor(props) {
            this.path = props && props.path;
            this.span = props && props.span;
            this.leadingComments = props && props.leadingComments;
            this.trailingComments = props && props.trailingComments;
            this.leadingDetachedComments = props && props.leadingDetachedComments;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['path'] != null) {
                json['path'] = obj['path'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['path'] = [];
              }
              if (obj['span'] != null) {
                json['span'] = obj['span'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['span'] = [];
              }
              if (obj['leadingComments'] != null) {
                json['leadingComments'] = obj['leadingComments'];
              } else if (withDefaults) {
                json['leadingComments'] = '';
              }
              if (obj['trailingComments'] != null) {
                json['trailingComments'] = obj['trailingComments'];
              } else if (withDefaults) {
                json['trailingComments'] = '';
              }
              if (obj['leadingDetachedComments'] != null) {
                json['leadingDetachedComments'] = obj['leadingDetachedComments'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['leadingDetachedComments'] = [];
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.google.protobuf.SourceCodeInfo.Location();
              if (json['path'] != null) {
                result['path'] = Array.isArray(json['path']) ? json['path'].map(e => {
                  return e;
                }) : json['path'];
              } else if (withDefaults !== false) {
                result['path'] = [];
              } else {
                delete result['path'];
              }
              if (json['span'] != null) {
                result['span'] = Array.isArray(json['span']) ? json['span'].map(e => {
                  return e;
                }) : json['span'];
              } else if (withDefaults !== false) {
                result['span'] = [];
              } else {
                delete result['span'];
              }
              if (json['leadingComments'] != null) {
                result['leadingComments'] = json['leadingComments'];
              } else if (withDefaults !== false) {
                result['leadingComments'] = '';
              } else {
                delete result['leadingComments'];
              }
              if (json['trailingComments'] != null) {
                result['trailingComments'] = json['trailingComments'];
              } else if (withDefaults !== false) {
                result['trailingComments'] = '';
              } else {
                delete result['trailingComments'];
              }
              if (json['leadingDetachedComments'] != null) {
                result['leadingDetachedComments'] = Array.isArray(json['leadingDetachedComments']) ? json['leadingDetachedComments'].map(e => {
                  return e;
                }) : json['leadingDetachedComments'];
              } else if (withDefaults !== false) {
                result['leadingDetachedComments'] = [];
              } else {
                delete result['leadingDetachedComments'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['path'] != null) {
                grpc['path'] = obj['path'].map(e => {
                  return e;
                });
              }
              if (obj['span'] != null) {
                grpc['span'] = obj['span'].map(e => {
                  return e;
                });
              }
              if (obj['leadingComments'] != null) {
                grpc['leadingComments'] = obj['leadingComments'];
              }
              if (obj['trailingComments'] != null) {
                grpc['trailingComments'] = obj['trailingComments'];
              }
              if (obj['leadingDetachedComments'] != null) {
                grpc['leadingDetachedComments'] = obj['leadingDetachedComments'].map(e => {
                  return e;
                });
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.google.protobuf.SourceCodeInfo.Location();
              if (grpc['path'] != null) {
                result['path'] = grpc['path'].map(e => {
                  return e;
                });
              } else {
                result['path'] = [];
              }
              if (grpc['span'] != null) {
                result['span'] = grpc['span'].map(e => {
                  return e;
                });
              } else {
                result['span'] = [];
              }
              if (grpc['leadingComments'] != null) {
                result['leadingComments'] = grpc['leadingComments'];
              } else {
                result['leadingComments'] = '';
              }
              if (grpc['trailingComments'] != null) {
                result['trailingComments'] = grpc['trailingComments'];
              } else {
                result['trailingComments'] = '';
              }
              if (grpc['leadingDetachedComments'] != null) {
                result['leadingDetachedComments'] = grpc['leadingDetachedComments'].map(e => {
                  return e;
                });
              } else {
                result['leadingDetachedComments'] = [];
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(Location.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('google.protobuf.SourceCodeInfo.Location');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Location.prototype, '__fqn__', {
          value: 'google.protobuf.SourceCodeInfo.Location',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Location.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Location.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return Location;
      }());;
      __builtIn.Object.defineProperty(SourceCodeInfo.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.SourceCodeInfo');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(SourceCodeInfo.prototype, '__fqn__', {
        value: 'google.protobuf.SourceCodeInfo',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(SourceCodeInfo.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(SourceCodeInfo.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return SourceCodeInfo;
    }());;
    _protobuf.GeneratedCodeInfo = (function () {
      class GeneratedCodeInfo {
        constructor(props) {
          this.annotation = props && props.annotation;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['annotation'] != null) {
              json['annotation'] = obj['annotation'].map(e => {
                return $root.google.protobuf.GeneratedCodeInfo.Annotation.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['annotation'] = [];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.GeneratedCodeInfo();
            if (json['annotation'] != null) {
              result['annotation'] = Array.isArray(json['annotation']) ? json['annotation'].map(e => {
                return $root.google.protobuf.GeneratedCodeInfo.Annotation.fromJSON(e, helper);
              }) : json['annotation'];
            } else if (withDefaults !== false) {
              result['annotation'] = [];
            } else {
              delete result['annotation'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['annotation'] != null) {
              grpc['annotation'] = obj['annotation'].map(e => {
                return $root.google.protobuf.GeneratedCodeInfo.Annotation.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.GeneratedCodeInfo();
            if (grpc['annotation'] != null) {
              result['annotation'] = grpc['annotation'].map(e => {
                return $root.google.protobuf.GeneratedCodeInfo.Annotation.fromGRPC(e, helper);
              });
            } else {
              result['annotation'] = [];
            }
            return result;
          }
        }
      }
      GeneratedCodeInfo.Annotation = (function () {
        class Annotation {
          constructor(props) {
            this.path = props && props.path;
            this.sourceFile = props && props.sourceFile;
            this.begin = props && props.begin;
            this.end = props && props.end;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['path'] != null) {
                json['path'] = obj['path'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['path'] = [];
              }
              if (obj['sourceFile'] != null) {
                json['sourceFile'] = obj['sourceFile'];
              } else if (withDefaults) {
                json['sourceFile'] = '';
              }
              if (obj['begin'] != null) {
                json['begin'] = obj['begin'];
              } else if (withDefaults) {
                json['begin'] = 0;
              }
              if (obj['end'] != null) {
                json['end'] = obj['end'];
              } else if (withDefaults) {
                json['end'] = 0;
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.google.protobuf.GeneratedCodeInfo.Annotation();
              if (json['path'] != null) {
                result['path'] = Array.isArray(json['path']) ? json['path'].map(e => {
                  return e;
                }) : json['path'];
              } else if (withDefaults !== false) {
                result['path'] = [];
              } else {
                delete result['path'];
              }
              if (json['sourceFile'] != null) {
                result['sourceFile'] = json['sourceFile'];
              } else if (withDefaults !== false) {
                result['sourceFile'] = '';
              } else {
                delete result['sourceFile'];
              }
              if (json['begin'] != null) {
                result['begin'] = json['begin'];
              } else if (withDefaults !== false) {
                result['begin'] = 0;
              } else {
                delete result['begin'];
              }
              if (json['end'] != null) {
                result['end'] = json['end'];
              } else if (withDefaults !== false) {
                result['end'] = 0;
              } else {
                delete result['end'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['path'] != null) {
                grpc['path'] = obj['path'].map(e => {
                  return e;
                });
              }
              if (obj['sourceFile'] != null) {
                grpc['sourceFile'] = obj['sourceFile'];
              }
              if (obj['begin'] != null) {
                grpc['begin'] = obj['begin'];
              }
              if (obj['end'] != null) {
                grpc['end'] = obj['end'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.google.protobuf.GeneratedCodeInfo.Annotation();
              if (grpc['path'] != null) {
                result['path'] = grpc['path'].map(e => {
                  return e;
                });
              } else {
                result['path'] = [];
              }
              if (grpc['sourceFile'] != null) {
                result['sourceFile'] = grpc['sourceFile'];
              } else {
                result['sourceFile'] = '';
              }
              if (grpc['begin'] != null) {
                result['begin'] = grpc['begin'];
              } else {
                result['begin'] = 0;
              }
              if (grpc['end'] != null) {
                result['end'] = grpc['end'];
              } else {
                result['end'] = 0;
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(Annotation.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('google.protobuf.GeneratedCodeInfo.Annotation');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Annotation.prototype, '__fqn__', {
          value: 'google.protobuf.GeneratedCodeInfo.Annotation',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Annotation.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Annotation.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return Annotation;
      }());;
      GeneratedCodeInfo.Annotation = (function () {
        class Annotation {
          constructor(props) {
            this.path = props && props.path;
            this.sourceFile = props && props.sourceFile;
            this.begin = props && props.begin;
            this.end = props && props.end;
          }
          static toJSON(obj, helper, withDefaults) {
            if (obj == null) {
              return null;
            } else {
              const json = {};
              if (obj['path'] != null) {
                json['path'] = obj['path'].map(e => {
                  return e;
                });
              } else if (withDefaults) {
                json['path'] = [];
              }
              if (obj['sourceFile'] != null) {
                json['sourceFile'] = obj['sourceFile'];
              } else if (withDefaults) {
                json['sourceFile'] = '';
              }
              if (obj['begin'] != null) {
                json['begin'] = obj['begin'];
              } else if (withDefaults) {
                json['begin'] = 0;
              }
              if (obj['end'] != null) {
                json['end'] = obj['end'];
              } else if (withDefaults) {
                json['end'] = 0;
              }
              return json;
            }
          }
          static fromJSON(json, helper, withDefaults) {
            if (typeof json === 'object' && !Array.isArray(json)) {
              const result = new $root.google.protobuf.GeneratedCodeInfo.Annotation();
              if (json['path'] != null) {
                result['path'] = Array.isArray(json['path']) ? json['path'].map(e => {
                  return e;
                }) : json['path'];
              } else if (withDefaults !== false) {
                result['path'] = [];
              } else {
                delete result['path'];
              }
              if (json['sourceFile'] != null) {
                result['sourceFile'] = json['sourceFile'];
              } else if (withDefaults !== false) {
                result['sourceFile'] = '';
              } else {
                delete result['sourceFile'];
              }
              if (json['begin'] != null) {
                result['begin'] = json['begin'];
              } else if (withDefaults !== false) {
                result['begin'] = 0;
              } else {
                delete result['begin'];
              }
              if (json['end'] != null) {
                result['end'] = json['end'];
              } else if (withDefaults !== false) {
                result['end'] = 0;
              } else {
                delete result['end'];
              }
              return result;
            } else
              return json;
          }
          static toGRPC(obj, helper) {
            if (obj == null) {
              return null;
            } else {
              const grpc = {};
              if (obj['path'] != null) {
                grpc['path'] = obj['path'].map(e => {
                  return e;
                });
              }
              if (obj['sourceFile'] != null) {
                grpc['sourceFile'] = obj['sourceFile'];
              }
              if (obj['begin'] != null) {
                grpc['begin'] = obj['begin'];
              }
              if (obj['end'] != null) {
                grpc['end'] = obj['end'];
              }
              return grpc;
            }
          }
          static fromGRPC(grpc, helper) {
            if (grpc == null) {
              return null;
            } else {
              const result = new $root.google.protobuf.GeneratedCodeInfo.Annotation();
              if (grpc['path'] != null) {
                result['path'] = grpc['path'].map(e => {
                  return e;
                });
              } else {
                result['path'] = [];
              }
              if (grpc['sourceFile'] != null) {
                result['sourceFile'] = grpc['sourceFile'];
              } else {
                result['sourceFile'] = '';
              }
              if (grpc['begin'] != null) {
                result['begin'] = grpc['begin'];
              } else {
                result['begin'] = 0;
              }
              if (grpc['end'] != null) {
                result['end'] = grpc['end'];
              } else {
                result['end'] = 0;
              }
              return result;
            }
          }
        }
        __builtIn.Object.defineProperty(Annotation.prototype, '__proto', {
          value: pbjs => {
            return $root.__lookup(pbjs)('google.protobuf.GeneratedCodeInfo.Annotation');
          },
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Annotation.prototype, '__fqn__', {
          value: 'google.protobuf.GeneratedCodeInfo.Annotation',
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Annotation.prototype, '__options__', {
          value: $root.__options,
          enumerable: false,
          configurable: false
        });
        __builtIn.Object.defineProperty(Annotation.prototype, '__root__', {
          value: $root,
          enumerable: false,
          configurable: false
        });
        return Annotation;
      }());;
      __builtIn.Object.defineProperty(GeneratedCodeInfo.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.GeneratedCodeInfo');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(GeneratedCodeInfo.prototype, '__fqn__', {
        value: 'google.protobuf.GeneratedCodeInfo',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(GeneratedCodeInfo.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(GeneratedCodeInfo.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return GeneratedCodeInfo;
    }());;
    _protobuf.Struct = (function () {
      class Struct {
        constructor(props) {
          this.fields = props && props.fields;
        }
        static toJSON(obj, helper) {
          return obj;
        }
        static fromJSON(json, helper) {
          return json;
        }
        static toGRPC(obj, helper) {
          return helper.grpc.structToGRPC(obj);
        }
        static fromGRPC(grpc, helper) {
          return helper.grpc.structFromGRPC(grpc);
        }
      }
      __builtIn.Object.defineProperty(Struct.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.Struct');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Struct.prototype, '__fqn__', {
        value: 'google.protobuf.Struct',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Struct.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Struct.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Struct;
    }());;
    _protobuf.Value = (function () {
      class Value {
        constructor(props) {
          this.nullValue = props && props.nullValue;
          this.numberValue = props && props.numberValue;
          this.stringValue = props && props.stringValue;
          this.boolValue = props && props.boolValue;
          this.structValue = props && props.structValue;
          this.listValue = props && props.listValue;
        }
        static toJSON(obj, helper) {
          return obj;
        }
        static fromJSON(json, helper) {
          return json;
        }
        static toGRPC(obj, helper) {
          return helper.grpc.valueToGRPC(obj);
        }
        static fromGRPC(grpc, helper) {
          return helper.grpc.valueFromGRPC(grpc);
        }
      }
      __builtIn.Object.defineProperty(Value.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.Value');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Value.prototype, '__fqn__', {
        value: 'google.protobuf.Value',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Value.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Value.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Value;
    }());;
    _protobuf.ListValue = (function () {
      class ListValue {
        constructor(props) {
          this.values = props && props.values;
        }
        static toJSON(obj, helper) {
          return obj;
        }
        static fromJSON(json, helper) {
          return json;
        }
        static toGRPC(obj, helper) {
          return helper.grpc.listValueToGRPC(obj);
        }
        static fromGRPC(grpc, helper) {
          return helper.grpc.listValueFromGRPC(grpc);
        }
      }
      __builtIn.Object.defineProperty(ListValue.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.ListValue');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ListValue.prototype, '__fqn__', {
        value: 'google.protobuf.ListValue',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ListValue.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(ListValue.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return ListValue;
    }());;
    _protobuf.Timestamp = (function () {
      class Timestamp {
        constructor(props) {
          this.seconds = props && props.seconds;
          this.nanos = props && props.nanos;
        }
        static toJSON(obj, helper) {
          return obj && obj.toISOString();
        }
        static fromJSON(json, helper) {
          return typeof json === 'string' && !isNaN(new Date(json)) ? new Date(json) : json;
        }
        static toGRPC(obj, helper) {
          return helper.grpc.timestampToGRPC(obj);
        }
        static fromGRPC(grpc, helper) {
          return helper.grpc.timestampFromGRPC(grpc);
        }
      }
      __builtIn.Object.defineProperty(Timestamp.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.Timestamp');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Timestamp.prototype, '__fqn__', {
        value: 'google.protobuf.Timestamp',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Timestamp.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Timestamp.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Timestamp;
    }());;
    _protobuf.Empty = (function () {
      class Empty {
        constructor(props) {
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.protobuf.Empty();
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.protobuf.Empty();
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(Empty.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.protobuf.Empty');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Empty.prototype, '__fqn__', {
        value: 'google.protobuf.Empty',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Empty.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Empty.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Empty;
    }());;
    return _protobuf;
  }());;
  _google.api = (function () {
    const _api = {};
    _api.Http = (function () {
      class Http {
        constructor(props) {
          this.rules = props && props.rules;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['rules'] != null) {
              json['rules'] = obj['rules'].map(e => {
                return $root.google.api.HttpRule.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['rules'] = [];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.api.Http();
            if (json['rules'] != null) {
              result['rules'] = Array.isArray(json['rules']) ? json['rules'].map(e => {
                return $root.google.api.HttpRule.fromJSON(e, helper);
              }) : json['rules'];
            } else if (withDefaults !== false) {
              result['rules'] = [];
            } else {
              delete result['rules'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['rules'] != null) {
              grpc['rules'] = obj['rules'].map(e => {
                return $root.google.api.HttpRule.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.api.Http();
            if (grpc['rules'] != null) {
              result['rules'] = grpc['rules'].map(e => {
                return $root.google.api.HttpRule.fromGRPC(e, helper);
              });
            } else {
              result['rules'] = [];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(Http.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.api.Http');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Http.prototype, '__fqn__', {
        value: 'google.api.Http',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Http.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(Http.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return Http;
    }());;
    _api.HttpRule = (function () {
      class HttpRule {
        constructor(props) {
          this.selector = props && props.selector;
          this.get = props && props.get;
          this.put = props && props.put;
          this.post = props && props.post;
          this.delete = props && props.delete;
          this.patch = props && props.patch;
          this.custom = props && props.custom;
          this.body = props && props.body;
          this.additionalBindings = props && props.additionalBindings;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['selector'] != null) {
              json['selector'] = obj['selector'];
            } else if (withDefaults) {
              json['selector'] = '';
            }
            if (obj['get'] != null) {
              json['get'] = obj['get'];
            } else if (withDefaults) {
              delete json['get'];
            }
            if (obj['put'] != null) {
              json['put'] = obj['put'];
            } else if (withDefaults) {
              delete json['put'];
            }
            if (obj['post'] != null) {
              json['post'] = obj['post'];
            } else if (withDefaults) {
              delete json['post'];
            }
            if (obj['delete'] != null) {
              json['delete'] = obj['delete'];
            } else if (withDefaults) {
              delete json['delete'];
            }
            if (obj['patch'] != null) {
              json['patch'] = obj['patch'];
            } else if (withDefaults) {
              delete json['patch'];
            }
            if (obj['custom'] != null) {
              json['custom'] = $root.google.api.CustomHttpPattern.toJSON(obj['custom'], helper, withDefaults);
            } else if (withDefaults) {
              delete json['custom'];
            }
            if (obj['body'] != null) {
              json['body'] = obj['body'];
            } else if (withDefaults) {
              json['body'] = '';
            }
            if (obj['additionalBindings'] != null) {
              json['additionalBindings'] = obj['additionalBindings'].map(e => {
                return $root.google.api.HttpRule.toJSON(e, helper, withDefaults);
              });
            } else if (withDefaults) {
              json['additionalBindings'] = [];
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.api.HttpRule();
            if (json['selector'] != null) {
              result['selector'] = json['selector'];
            } else if (withDefaults !== false) {
              result['selector'] = '';
            } else {
              delete result['selector'];
            }
            if (json['get'] != null) {
              result['get'] = json['get'];
            } else if (withDefaults !== false) {
              delete result['get'];
            } else {
              delete result['get'];
            }
            if (json['put'] != null) {
              result['put'] = json['put'];
            } else if (withDefaults !== false) {
              delete result['put'];
            } else {
              delete result['put'];
            }
            if (json['post'] != null) {
              result['post'] = json['post'];
            } else if (withDefaults !== false) {
              delete result['post'];
            } else {
              delete result['post'];
            }
            if (json['delete'] != null) {
              result['delete'] = json['delete'];
            } else if (withDefaults !== false) {
              delete result['delete'];
            } else {
              delete result['delete'];
            }
            if (json['patch'] != null) {
              result['patch'] = json['patch'];
            } else if (withDefaults !== false) {
              delete result['patch'];
            } else {
              delete result['patch'];
            }
            if (json['custom'] != null) {
              result['custom'] = $root.google.api.CustomHttpPattern.fromJSON(json['custom'], helper);
            } else if (withDefaults !== false) {
              delete result['custom'];
            } else {
              delete result['custom'];
            }
            if (json['body'] != null) {
              result['body'] = json['body'];
            } else if (withDefaults !== false) {
              result['body'] = '';
            } else {
              delete result['body'];
            }
            if (json['additionalBindings'] != null) {
              result['additionalBindings'] = Array.isArray(json['additionalBindings']) ? json['additionalBindings'].map(e => {
                return $root.google.api.HttpRule.fromJSON(e, helper);
              }) : json['additionalBindings'];
            } else if (withDefaults !== false) {
              result['additionalBindings'] = [];
            } else {
              delete result['additionalBindings'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['selector'] != null) {
              grpc['selector'] = obj['selector'];
            }
            if (obj['get'] != null) {
              grpc['get'] = obj['get'];
            }
            if (obj['put'] != null) {
              grpc['put'] = obj['put'];
            }
            if (obj['post'] != null) {
              grpc['post'] = obj['post'];
            }
            if (obj['delete'] != null) {
              grpc['delete'] = obj['delete'];
            }
            if (obj['patch'] != null) {
              grpc['patch'] = obj['patch'];
            }
            if (obj['custom'] != null) {
              grpc['custom'] = $root.google.api.CustomHttpPattern.toGRPC(obj['custom'], helper);
            }
            if (obj['body'] != null) {
              grpc['body'] = obj['body'];
            }
            if (obj['additionalBindings'] != null) {
              grpc['additionalBindings'] = obj['additionalBindings'].map(e => {
                return $root.google.api.HttpRule.toGRPC(e, helper);
              });
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.api.HttpRule();
            if (grpc['selector'] != null) {
              result['selector'] = grpc['selector'];
            } else {
              result['selector'] = '';
            }
            if (grpc['get'] != null) {
              result['get'] = grpc['get'];
            } else {
              delete result['get'];
            }
            if (grpc['put'] != null) {
              result['put'] = grpc['put'];
            } else {
              delete result['put'];
            }
            if (grpc['post'] != null) {
              result['post'] = grpc['post'];
            } else {
              delete result['post'];
            }
            if (grpc['delete'] != null) {
              result['delete'] = grpc['delete'];
            } else {
              delete result['delete'];
            }
            if (grpc['patch'] != null) {
              result['patch'] = grpc['patch'];
            } else {
              delete result['patch'];
            }
            if (grpc['custom'] != null) {
              result['custom'] = $root.google.api.CustomHttpPattern.fromGRPC(grpc['custom'], helper);
            } else {
              delete result['custom'];
            }
            if (grpc['body'] != null) {
              result['body'] = grpc['body'];
            } else {
              result['body'] = '';
            }
            if (grpc['additionalBindings'] != null) {
              result['additionalBindings'] = grpc['additionalBindings'].map(e => {
                return $root.google.api.HttpRule.fromGRPC(e, helper);
              });
            } else {
              result['additionalBindings'] = [];
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(HttpRule.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.api.HttpRule');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(HttpRule.prototype, '__fqn__', {
        value: 'google.api.HttpRule',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(HttpRule.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(HttpRule.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return HttpRule;
    }());;
    _api.CustomHttpPattern = (function () {
      class CustomHttpPattern {
        constructor(props) {
          this.kind = props && props.kind;
          this.path = props && props.path;
        }
        static toJSON(obj, helper, withDefaults) {
          if (obj == null) {
            return null;
          } else {
            const json = {};
            if (obj['kind'] != null) {
              json['kind'] = obj['kind'];
            } else if (withDefaults) {
              json['kind'] = '';
            }
            if (obj['path'] != null) {
              json['path'] = obj['path'];
            } else if (withDefaults) {
              json['path'] = '';
            }
            return json;
          }
        }
        static fromJSON(json, helper, withDefaults) {
          if (typeof json === 'object' && !Array.isArray(json)) {
            const result = new $root.google.api.CustomHttpPattern();
            if (json['kind'] != null) {
              result['kind'] = json['kind'];
            } else if (withDefaults !== false) {
              result['kind'] = '';
            } else {
              delete result['kind'];
            }
            if (json['path'] != null) {
              result['path'] = json['path'];
            } else if (withDefaults !== false) {
              result['path'] = '';
            } else {
              delete result['path'];
            }
            return result;
          } else
            return json;
        }
        static toGRPC(obj, helper) {
          if (obj == null) {
            return null;
          } else {
            const grpc = {};
            if (obj['kind'] != null) {
              grpc['kind'] = obj['kind'];
            }
            if (obj['path'] != null) {
              grpc['path'] = obj['path'];
            }
            return grpc;
          }
        }
        static fromGRPC(grpc, helper) {
          if (grpc == null) {
            return null;
          } else {
            const result = new $root.google.api.CustomHttpPattern();
            if (grpc['kind'] != null) {
              result['kind'] = grpc['kind'];
            } else {
              result['kind'] = '';
            }
            if (grpc['path'] != null) {
              result['path'] = grpc['path'];
            } else {
              result['path'] = '';
            }
            return result;
          }
        }
      }
      __builtIn.Object.defineProperty(CustomHttpPattern.prototype, '__proto', {
        value: pbjs => {
          return $root.__lookup(pbjs)('google.api.CustomHttpPattern');
        },
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(CustomHttpPattern.prototype, '__fqn__', {
        value: 'google.api.CustomHttpPattern',
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(CustomHttpPattern.prototype, '__options__', {
        value: $root.__options,
        enumerable: false,
        configurable: false
      });
      __builtIn.Object.defineProperty(CustomHttpPattern.prototype, '__root__', {
        value: $root,
        enumerable: false,
        configurable: false
      });
      return CustomHttpPattern;
    }());;
    return _api;
  }());;
  return _google;
}());;
module.exports = $root;